const cityData = {
    "succ": true,
    "msg": "执行成功 ",
    "code": 0,
    "data": [
        {
            "province_id": 14,
            "name": "安徽省",
            "whole_name": "安徽省",
            "simple_py": "AHS",
            "per_pin_yin": "A",
            "per_pin_yin2": "A",
            "city_code": "",
            "area_code": "340000",
            "longitude": "117.283042",
            "latitude": "31.86119",
            "children": [
                {
                    "city_id": 19880,
                    "province_id": 14,
                    "name": "安庆市",
                    "whole_name": "安庆市，安徽省",
                    "simple_py": "AQS",
                    "per_pin_yin": "A",
                    "per_pin_yin2": "A",
                    "city_code": "0556",
                    "area_code": "340800",
                    "longitude": "117.043551",
                    "latitude": "30.50883",
                    "children": [
                        {
                            "area_id": 20620,
                            "city_id": 19880,
                            "province_id": 14,
                            "name": "大观区",
                            "whole_name": "大观区，安庆市，安徽省",
                            "simple_py": "DGQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0556",
                            "area_code": "340803",
                            "longitude": "117.034512",
                            "latitude": "30.505632"
                        },
                        {
                            "area_id": 20621,
                            "city_id": 19880,
                            "province_id": 14,
                            "name": "怀宁县",
                            "whole_name": "怀宁县，安庆市，安徽省",
                            "simple_py": "HNX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0556",
                            "area_code": "340822",
                            "longitude": "116.828664",
                            "latitude": "30.734994"
                        },
                        {
                            "area_id": 20612,
                            "city_id": 19880,
                            "province_id": 14,
                            "name": "潜山县",
                            "whole_name": "潜山县，安庆市，安徽省",
                            "simple_py": "QSX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0556",
                            "area_code": "340824",
                            "longitude": "116.573666",
                            "latitude": "30.638222"
                        },
                        {
                            "area_id": 20618,
                            "city_id": 19880,
                            "province_id": 14,
                            "name": "宿松县",
                            "whole_name": "宿松县，安庆市，安徽省",
                            "simple_py": "SSX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0556",
                            "area_code": "340826",
                            "longitude": "116.120204",
                            "latitude": "30.158327"
                        },
                        {
                            "area_id": 20614,
                            "city_id": 19880,
                            "province_id": 14,
                            "name": "桐城市",
                            "whole_name": "桐城市，安庆市，安徽省",
                            "simple_py": "TCS",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0556",
                            "area_code": "340881",
                            "longitude": "116.959656",
                            "latitude": "31.050576"
                        },
                        {
                            "area_id": 20615,
                            "city_id": 19880,
                            "province_id": 14,
                            "name": "太湖县",
                            "whole_name": "太湖县，安庆市，安徽省",
                            "simple_py": "THX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0556",
                            "area_code": "340825",
                            "longitude": "116.305225",
                            "latitude": "30.451869"
                        },
                        {
                            "area_id": 20619,
                            "city_id": 19880,
                            "province_id": 14,
                            "name": "望江县",
                            "whole_name": "望江县，安庆市，安徽省",
                            "simple_py": "WJX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0556",
                            "area_code": "340827",
                            "longitude": "116.690927",
                            "latitude": "30.12491"
                        },
                        {
                            "area_id": 20613,
                            "city_id": 19880,
                            "province_id": 14,
                            "name": "岳西县",
                            "whole_name": "岳西县，安庆市，安徽省",
                            "simple_py": "YXX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0556",
                            "area_code": "340828",
                            "longitude": "116.360482",
                            "latitude": "30.848502"
                        },
                        {
                            "area_id": 20616,
                            "city_id": 19880,
                            "province_id": 14,
                            "name": "迎江区",
                            "whole_name": "迎江区，安庆市，安徽省",
                            "simple_py": "YJQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0556",
                            "area_code": "340802",
                            "longitude": "117.044965",
                            "latitude": "30.506375"
                        },
                        {
                            "area_id": 20617,
                            "city_id": 19880,
                            "province_id": 14,
                            "name": "宜秀区",
                            "whole_name": "宜秀区，安庆市，安徽省",
                            "simple_py": "YXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0556",
                            "area_code": "340811",
                            "longitude": "117.070003",
                            "latitude": "30.541323"
                        }
                    ]
                },
                {
                    "city_id": 19875,
                    "province_id": 14,
                    "name": "蚌埠市",
                    "whole_name": "蚌埠市，安徽省",
                    "simple_py": "BBS",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "0552",
                    "area_code": "340300",
                    "longitude": "117.363228",
                    "latitude": "32.939667",
                    "children": [
                        {
                            "area_id": 20163,
                            "city_id": 19875,
                            "province_id": 14,
                            "name": "蚌山区",
                            "whole_name": "蚌山区，蚌埠市，安徽省",
                            "simple_py": "BSQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0552",
                            "area_code": "340303",
                            "longitude": "117.355789",
                            "latitude": "32.938066"
                        },
                        {
                            "area_id": 20158,
                            "city_id": 19875,
                            "province_id": 14,
                            "name": "固镇县",
                            "whole_name": "固镇县，蚌埠市，安徽省",
                            "simple_py": "GZX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0552",
                            "area_code": "340323",
                            "longitude": "117.315962",
                            "latitude": "33.318679"
                        },
                        {
                            "area_id": 20157,
                            "city_id": 19875,
                            "province_id": 14,
                            "name": "淮上区",
                            "whole_name": "淮上区，蚌埠市，安徽省",
                            "simple_py": "HSQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0552",
                            "area_code": "340311",
                            "longitude": "117.34709",
                            "latitude": "32.963147"
                        },
                        {
                            "area_id": 20161,
                            "city_id": 19875,
                            "province_id": 14,
                            "name": "怀远县",
                            "whole_name": "怀远县，蚌埠市，安徽省",
                            "simple_py": "HYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0552",
                            "area_code": "340321",
                            "longitude": "117.200171",
                            "latitude": "32.956934"
                        },
                        {
                            "area_id": 20159,
                            "city_id": 19875,
                            "province_id": 14,
                            "name": "龙子湖区",
                            "whole_name": "龙子湖区，蚌埠市，安徽省",
                            "simple_py": "LZHQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0552",
                            "area_code": "340302",
                            "longitude": "117.382312",
                            "latitude": "32.950452"
                        },
                        {
                            "area_id": 20160,
                            "city_id": 19875,
                            "province_id": 14,
                            "name": "五河县",
                            "whole_name": "五河县，蚌埠市，安徽省",
                            "simple_py": "WHX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0552",
                            "area_code": "340322",
                            "longitude": "117.888809",
                            "latitude": "33.146202"
                        },
                        {
                            "area_id": 20162,
                            "city_id": 19875,
                            "province_id": 14,
                            "name": "禹会区",
                            "whole_name": "禹会区，蚌埠市，安徽省",
                            "simple_py": "YHQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0552",
                            "area_code": "340304",
                            "longitude": "117.35259",
                            "latitude": "32.931933"
                        }
                    ]
                },
                {
                    "city_id": 19878,
                    "province_id": 14,
                    "name": "亳州市",
                    "whole_name": "亳州市，安徽省",
                    "simple_py": "BZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "B",
                    "city_code": "0558",
                    "area_code": "341600",
                    "longitude": "115.782939",
                    "latitude": "33.869338",
                    "children": [
                        {
                            "area_id": 20382,
                            "city_id": 19878,
                            "province_id": 14,
                            "name": "利辛县",
                            "whole_name": "利辛县，亳州市，安徽省",
                            "simple_py": "LXX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0558",
                            "area_code": "341623",
                            "longitude": "116.207782",
                            "latitude": "33.143503"
                        },
                        {
                            "area_id": 20381,
                            "city_id": 19878,
                            "province_id": 14,
                            "name": "蒙城县",
                            "whole_name": "蒙城县，亳州市，安徽省",
                            "simple_py": "MCX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0558",
                            "area_code": "341622",
                            "longitude": "116.560337",
                            "latitude": "33.260814"
                        },
                        {
                            "area_id": 20380,
                            "city_id": 19878,
                            "province_id": 14,
                            "name": "谯城区",
                            "whole_name": "谯城区，亳州市，安徽省",
                            "simple_py": "QCQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0558",
                            "area_code": "341602",
                            "longitude": "115.781214",
                            "latitude": "33.869284"
                        },
                        {
                            "area_id": 20379,
                            "city_id": 19878,
                            "province_id": 14,
                            "name": "涡阳县",
                            "whole_name": "涡阳县，亳州市，安徽省",
                            "simple_py": "WYX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0558",
                            "area_code": "341621",
                            "longitude": "116.211551",
                            "latitude": "33.502831"
                        }
                    ]
                },
                {
                    "city_id": 19877,
                    "province_id": 14,
                    "name": "池州市",
                    "whole_name": "池州市，安徽省",
                    "simple_py": "CZS",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0566",
                    "area_code": "341700",
                    "longitude": "117.489157",
                    "latitude": "30.656037",
                    "children": [
                        {
                            "area_id": 20312,
                            "city_id": 19877,
                            "province_id": 14,
                            "name": "东至县",
                            "whole_name": "东至县，池州市，安徽省",
                            "simple_py": "DZX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0566",
                            "area_code": "341721",
                            "longitude": "117.021476",
                            "latitude": "30.096568"
                        },
                        {
                            "area_id": 20313,
                            "city_id": 19877,
                            "province_id": 14,
                            "name": "贵池区",
                            "whole_name": "贵池区，池州市，安徽省",
                            "simple_py": "GCQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0566",
                            "area_code": "341702",
                            "longitude": "117.488342",
                            "latitude": "30.657378"
                        },
                        {
                            "area_id": 20311,
                            "city_id": 19877,
                            "province_id": 14,
                            "name": "青阳县",
                            "whole_name": "青阳县，池州市，安徽省",
                            "simple_py": "QYX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0566",
                            "area_code": "341723",
                            "longitude": "117.857395",
                            "latitude": "30.63818"
                        },
                        {
                            "area_id": 20314,
                            "city_id": 19877,
                            "province_id": 14,
                            "name": "石台县",
                            "whole_name": "石台县，池州市，安徽省",
                            "simple_py": "STX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0566",
                            "area_code": "341722",
                            "longitude": "117.482907",
                            "latitude": "30.210324"
                        }
                    ]
                },
                {
                    "city_id": 19879,
                    "province_id": 14,
                    "name": "滁州市",
                    "whole_name": "滁州市，安徽省",
                    "simple_py": "CZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "C",
                    "city_code": "0550",
                    "area_code": "341100",
                    "longitude": "118.316264",
                    "latitude": "32.303627",
                    "children": [
                        {
                            "area_id": 20487,
                            "city_id": 19879,
                            "province_id": 14,
                            "name": "定远县",
                            "whole_name": "定远县，滁州市，安徽省",
                            "simple_py": "DYX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0550",
                            "area_code": "341125",
                            "longitude": "117.683713",
                            "latitude": "32.527105"
                        },
                        {
                            "area_id": 20486,
                            "city_id": 19879,
                            "province_id": 14,
                            "name": "凤阳县",
                            "whole_name": "凤阳县，滁州市，安徽省",
                            "simple_py": "FYX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0550",
                            "area_code": "341126",
                            "longitude": "117.562461",
                            "latitude": "32.867146"
                        },
                        {
                            "area_id": 20488,
                            "city_id": 19879,
                            "province_id": 14,
                            "name": "来安县",
                            "whole_name": "来安县，滁州市，安徽省",
                            "simple_py": "LAX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0550",
                            "area_code": "341122",
                            "longitude": "118.433293",
                            "latitude": "32.450231"
                        },
                        {
                            "area_id": 20490,
                            "city_id": 19879,
                            "province_id": 14,
                            "name": "琅琊区",
                            "whole_name": "琅琊区，滁州市，安徽省",
                            "simple_py": "LYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0550",
                            "area_code": "341102",
                            "longitude": "118.316475",
                            "latitude": "32.303797"
                        },
                        {
                            "area_id": 20483,
                            "city_id": 19879,
                            "province_id": 14,
                            "name": "明光市",
                            "whole_name": "明光市，滁州市，安徽省",
                            "simple_py": "MGS",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0550",
                            "area_code": "341182",
                            "longitude": "117.998048",
                            "latitude": "32.781206"
                        },
                        {
                            "area_id": 20489,
                            "city_id": 19879,
                            "province_id": 14,
                            "name": "南谯区",
                            "whole_name": "南谯区，滁州市，安徽省",
                            "simple_py": "NQQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0550",
                            "area_code": "341103",
                            "longitude": "118.296955",
                            "latitude": "32.329841"
                        },
                        {
                            "area_id": 20485,
                            "city_id": 19879,
                            "province_id": 14,
                            "name": "全椒县",
                            "whole_name": "全椒县，滁州市，安徽省",
                            "simple_py": "QJX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0550",
                            "area_code": "341124",
                            "longitude": "118.268576",
                            "latitude": "32.09385"
                        },
                        {
                            "area_id": 20484,
                            "city_id": 19879,
                            "province_id": 14,
                            "name": "天长市",
                            "whole_name": "天长市，滁州市，安徽省",
                            "simple_py": "TCS",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0550",
                            "area_code": "341181",
                            "longitude": "119.011212",
                            "latitude": "32.6815"
                        }
                    ]
                },
                {
                    "city_id": 19872,
                    "province_id": 14,
                    "name": "阜阳市",
                    "whole_name": "阜阳市，安徽省",
                    "simple_py": "FYS",
                    "per_pin_yin": "F",
                    "per_pin_yin2": "F",
                    "city_code": "0558",
                    "area_code": "341200",
                    "longitude": "115.819729",
                    "latitude": "32.896969",
                    "children": [
                        {
                            "area_id": 19893,
                            "city_id": 19872,
                            "province_id": 14,
                            "name": "阜南县",
                            "whole_name": "阜南县，阜阳市，安徽省",
                            "simple_py": "FNX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0558",
                            "area_code": "341225",
                            "longitude": "115.590534",
                            "latitude": "32.638102"
                        },
                        {
                            "area_id": 19895,
                            "city_id": 19872,
                            "province_id": 14,
                            "name": "界首市",
                            "whole_name": "界首市，阜阳市，安徽省",
                            "simple_py": "JSS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0558",
                            "area_code": "341282",
                            "longitude": "115.362117",
                            "latitude": "33.26153"
                        },
                        {
                            "area_id": 19889,
                            "city_id": 19872,
                            "province_id": 14,
                            "name": "临泉县",
                            "whole_name": "临泉县，阜阳市，安徽省",
                            "simple_py": "LQX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0558",
                            "area_code": "341221",
                            "longitude": "115.261688",
                            "latitude": "33.062698"
                        },
                        {
                            "area_id": 19888,
                            "city_id": 19872,
                            "province_id": 14,
                            "name": "太和县",
                            "whole_name": "太和县，阜阳市，安徽省",
                            "simple_py": "THX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0558",
                            "area_code": "341222",
                            "longitude": "115.627243",
                            "latitude": "33.16229"
                        },
                        {
                            "area_id": 19890,
                            "city_id": 19872,
                            "province_id": 14,
                            "name": "颍泉区",
                            "whole_name": "颍泉区，阜阳市，安徽省",
                            "simple_py": "YQQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0558",
                            "area_code": "341204",
                            "longitude": "115.804525",
                            "latitude": "32.924797"
                        },
                        {
                            "area_id": 19891,
                            "city_id": 19872,
                            "province_id": 14,
                            "name": "颍东区",
                            "whole_name": "颍东区，阜阳市，安徽省",
                            "simple_py": "YDQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0558",
                            "area_code": "341203",
                            "longitude": "115.858747",
                            "latitude": "32.908861"
                        },
                        {
                            "area_id": 19892,
                            "city_id": 19872,
                            "province_id": 14,
                            "name": "颍州区",
                            "whole_name": "颍州区，阜阳市，安徽省",
                            "simple_py": "YZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0558",
                            "area_code": "341202",
                            "longitude": "115.813914",
                            "latitude": "32.891238"
                        },
                        {
                            "area_id": 19894,
                            "city_id": 19872,
                            "province_id": 14,
                            "name": "颍上县",
                            "whole_name": "颍上县，阜阳市，安徽省",
                            "simple_py": "YSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0558",
                            "area_code": "341226",
                            "longitude": "116.259122",
                            "latitude": "32.637065"
                        }
                    ]
                },
                {
                    "city_id": 19873,
                    "province_id": 14,
                    "name": "淮北市",
                    "whole_name": "淮北市，安徽省",
                    "simple_py": "HBS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0561",
                    "area_code": "340600",
                    "longitude": "116.794664",
                    "latitude": "33.971707",
                    "children": [
                        {
                            "area_id": 20069,
                            "city_id": 19873,
                            "province_id": 14,
                            "name": "杜集区",
                            "whole_name": "杜集区，淮北市，安徽省",
                            "simple_py": "DJQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0561",
                            "area_code": "340602",
                            "longitude": "116.833925",
                            "latitude": "33.991218"
                        },
                        {
                            "area_id": 20072,
                            "city_id": 19873,
                            "province_id": 14,
                            "name": "烈山区",
                            "whole_name": "烈山区，淮北市，安徽省",
                            "simple_py": "LSQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0561",
                            "area_code": "340604",
                            "longitude": "116.809465",
                            "latitude": "33.889529"
                        },
                        {
                            "area_id": 20071,
                            "city_id": 19873,
                            "province_id": 14,
                            "name": "濉溪县",
                            "whole_name": "濉溪县，淮北市，安徽省",
                            "simple_py": "SXX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0561",
                            "area_code": "340621",
                            "longitude": "116.767435",
                            "latitude": "33.916407"
                        },
                        {
                            "area_id": 20070,
                            "city_id": 19873,
                            "province_id": 14,
                            "name": "相山区",
                            "whole_name": "相山区，淮北市，安徽省",
                            "simple_py": "XSQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0561",
                            "area_code": "340603",
                            "longitude": "116.790775",
                            "latitude": "33.970916"
                        }
                    ]
                },
                {
                    "city_id": 19881,
                    "province_id": 14,
                    "name": "黄山市",
                    "whole_name": "黄山市，安徽省",
                    "simple_py": "HSS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0559",
                    "area_code": "341000",
                    "longitude": "118.317325",
                    "latitude": "29.709239",
                    "children": [
                        {
                            "area_id": 20782,
                            "city_id": 19881,
                            "province_id": 14,
                            "name": "黄山区",
                            "whole_name": "黄山区，黄山市，安徽省",
                            "simple_py": "HSQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0559",
                            "area_code": "341003",
                            "longitude": "118.136639",
                            "latitude": "30.294517"
                        },
                        {
                            "area_id": 20787,
                            "city_id": 19881,
                            "province_id": 14,
                            "name": "徽州区",
                            "whole_name": "徽州区，黄山市，安徽省",
                            "simple_py": "HZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0559",
                            "area_code": "341004",
                            "longitude": "118.339743",
                            "latitude": "29.825201"
                        },
                        {
                            "area_id": 20786,
                            "city_id": 19881,
                            "province_id": 14,
                            "name": "祁门县",
                            "whole_name": "祁门县，黄山市，安徽省",
                            "simple_py": "QMX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0559",
                            "area_code": "341024",
                            "longitude": "117.717237",
                            "latitude": "29.853472"
                        },
                        {
                            "area_id": 20788,
                            "city_id": 19881,
                            "province_id": 14,
                            "name": "歙县",
                            "whole_name": "歙县，黄山市，安徽省",
                            "simple_py": "SX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0559",
                            "area_code": "341021",
                            "longitude": "118.428025",
                            "latitude": "29.867748"
                        },
                        {
                            "area_id": 20785,
                            "city_id": 19881,
                            "province_id": 14,
                            "name": "屯溪区",
                            "whole_name": "屯溪区，黄山市，安徽省",
                            "simple_py": "TXQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0559",
                            "area_code": "341002",
                            "longitude": "118.317354",
                            "latitude": "29.709186"
                        },
                        {
                            "area_id": 20784,
                            "city_id": 19881,
                            "province_id": 14,
                            "name": "休宁县",
                            "whole_name": "休宁县，黄山市，安徽省",
                            "simple_py": "XNX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0559",
                            "area_code": "341022",
                            "longitude": "118.188531",
                            "latitude": "29.788878"
                        },
                        {
                            "area_id": 20783,
                            "city_id": 19881,
                            "province_id": 14,
                            "name": "黟县",
                            "whole_name": "黟县，黄山市，安徽省",
                            "simple_py": "YX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0559",
                            "area_code": "341023",
                            "longitude": "117.942911",
                            "latitude": "29.923812"
                        }
                    ]
                },
                {
                    "city_id": 19885,
                    "province_id": 14,
                    "name": "淮南市",
                    "whole_name": "淮南市，安徽省",
                    "simple_py": "HNS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0554",
                    "area_code": "340400",
                    "longitude": "117.018329",
                    "latitude": "32.647574",
                    "children": [
                        {
                            "area_id": 21248,
                            "city_id": 19885,
                            "province_id": 14,
                            "name": "八公山区",
                            "whole_name": "八公山区，淮南市，安徽省",
                            "simple_py": "BGSQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0554",
                            "area_code": "340405",
                            "longitude": "116.841111",
                            "latitude": "32.628229"
                        },
                        {
                            "area_id": 21252,
                            "city_id": 19885,
                            "province_id": 14,
                            "name": "大通区",
                            "whole_name": "大通区，淮南市，安徽省",
                            "simple_py": "DTQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0554",
                            "area_code": "340402",
                            "longitude": "117.052927",
                            "latitude": "32.632066"
                        },
                        {
                            "area_id": 21251,
                            "city_id": 19885,
                            "province_id": 14,
                            "name": "凤台县",
                            "whole_name": "凤台县，淮南市，安徽省",
                            "simple_py": "FTX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0554",
                            "area_code": "340421",
                            "longitude": "116.722769",
                            "latitude": "32.705382"
                        },
                        {
                            "area_id": 21249,
                            "city_id": 19885,
                            "province_id": 14,
                            "name": "潘集区",
                            "whole_name": "潘集区，淮南市，安徽省",
                            "simple_py": "PJQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0554",
                            "area_code": "340406",
                            "longitude": "116.816879",
                            "latitude": "32.782117"
                        },
                        {
                            "area_id": 21254,
                            "city_id": 19885,
                            "province_id": 14,
                            "name": "寿县",
                            "whole_name": "寿县，淮南市，安徽省",
                            "simple_py": "SX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0554",
                            "area_code": "340422",
                            "longitude": "116.785349",
                            "latitude": "32.577304"
                        },
                        {
                            "area_id": 21253,
                            "city_id": 19885,
                            "province_id": 14,
                            "name": "田家庵区",
                            "whole_name": "田家庵区，淮南市，安徽省",
                            "simple_py": "TJAQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0554",
                            "area_code": "340403",
                            "longitude": "117.018318",
                            "latitude": "32.644342"
                        },
                        {
                            "area_id": 21250,
                            "city_id": 19885,
                            "province_id": 14,
                            "name": "谢家集区",
                            "whole_name": "谢家集区，淮南市，安徽省",
                            "simple_py": "XJJQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0554",
                            "area_code": "340404",
                            "longitude": "116.865354",
                            "latitude": "32.598289"
                        }
                    ]
                },
                {
                    "city_id": 19886,
                    "province_id": 14,
                    "name": "合肥市",
                    "whole_name": "合肥市，安徽省",
                    "simple_py": "HFS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0551",
                    "area_code": "340100",
                    "longitude": "117.283042",
                    "latitude": "31.86119",
                    "children": [
                        {
                            "area_id": 21357,
                            "city_id": 19886,
                            "province_id": 14,
                            "name": "包河区",
                            "whole_name": "包河区，合肥市，安徽省",
                            "simple_py": "BHQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0551",
                            "area_code": "340111",
                            "longitude": "117.285751",
                            "latitude": "31.82956"
                        },
                        {
                            "area_id": 21354,
                            "city_id": 19886,
                            "province_id": 14,
                            "name": "长丰县",
                            "whole_name": "长丰县，合肥市，安徽省",
                            "simple_py": "CFX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0551",
                            "area_code": "340121",
                            "longitude": "117.164699",
                            "latitude": "32.478548"
                        },
                        {
                            "area_id": 21358,
                            "city_id": 19886,
                            "province_id": 14,
                            "name": "巢湖市",
                            "whole_name": "巢湖市，合肥市，安徽省",
                            "simple_py": "CHS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0565",
                            "area_code": "340181",
                            "longitude": "117.874155",
                            "latitude": "31.600518"
                        },
                        {
                            "area_id": 21351,
                            "city_id": 19886,
                            "province_id": 14,
                            "name": "肥东县",
                            "whole_name": "肥东县，合肥市，安徽省",
                            "simple_py": "FDX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0551",
                            "area_code": "340122",
                            "longitude": "117.463222",
                            "latitude": "31.883992"
                        },
                        {
                            "area_id": 21355,
                            "city_id": 19886,
                            "province_id": 14,
                            "name": "肥西县",
                            "whole_name": "肥西县，合肥市，安徽省",
                            "simple_py": "FXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0551",
                            "area_code": "340123",
                            "longitude": "117.166118",
                            "latitude": "31.719646"
                        },
                        {
                            "area_id": 21350,
                            "city_id": 19886,
                            "province_id": 14,
                            "name": "庐阳区",
                            "whole_name": "庐阳区，合肥市，安徽省",
                            "simple_py": "LYQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0551",
                            "area_code": "340103",
                            "longitude": "117.283776",
                            "latitude": "31.869011"
                        },
                        {
                            "area_id": 21352,
                            "city_id": 19886,
                            "province_id": 14,
                            "name": "庐江县",
                            "whole_name": "庐江县，合肥市，安徽省",
                            "simple_py": "LJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0551",
                            "area_code": "340124",
                            "longitude": "117.289844",
                            "latitude": "31.251488"
                        },
                        {
                            "area_id": 21356,
                            "city_id": 19886,
                            "province_id": 14,
                            "name": "蜀山区",
                            "whole_name": "蜀山区，合肥市，安徽省",
                            "simple_py": "SSQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0551",
                            "area_code": "340104",
                            "longitude": "117.262072",
                            "latitude": "31.855868"
                        },
                        {
                            "area_id": 21353,
                            "city_id": 19886,
                            "province_id": 14,
                            "name": "瑶海区",
                            "whole_name": "瑶海区，合肥市，安徽省",
                            "simple_py": "YHQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0551",
                            "area_code": "340102",
                            "longitude": "117.315358",
                            "latitude": "31.86961"
                        }
                    ]
                },
                {
                    "city_id": 19884,
                    "province_id": 14,
                    "name": "六安市",
                    "whole_name": "六安市，安徽省",
                    "simple_py": "LAS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0564",
                    "area_code": "341500",
                    "longitude": "116.507676",
                    "latitude": "31.752889",
                    "children": [
                        {
                            "area_id": 21094,
                            "city_id": 19884,
                            "province_id": 14,
                            "name": "霍山县",
                            "whole_name": "霍山县，六安市，安徽省",
                            "simple_py": "HSX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0564",
                            "area_code": "341525",
                            "longitude": "116.333078",
                            "latitude": "31.402456"
                        },
                        {
                            "area_id": 21100,
                            "city_id": 19884,
                            "province_id": 14,
                            "name": "霍邱县",
                            "whole_name": "霍邱县，六安市，安徽省",
                            "simple_py": "HQX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0564",
                            "area_code": "341522",
                            "longitude": "116.278875",
                            "latitude": "32.341305"
                        },
                        {
                            "area_id": 21096,
                            "city_id": 19884,
                            "province_id": 14,
                            "name": "金寨县",
                            "whole_name": "金寨县，六安市，安徽省",
                            "simple_py": "JZX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0564",
                            "area_code": "341524",
                            "longitude": "115.878514",
                            "latitude": "31.681624"
                        },
                        {
                            "area_id": 21098,
                            "city_id": 19884,
                            "province_id": 14,
                            "name": "金安区",
                            "whole_name": "金安区，六安市，安徽省",
                            "simple_py": "JAQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0564",
                            "area_code": "341502",
                            "longitude": "116.503288",
                            "latitude": "31.754491"
                        },
                        {
                            "area_id": 21097,
                            "city_id": 19884,
                            "province_id": 14,
                            "name": "舒城县",
                            "whole_name": "舒城县，六安市，安徽省",
                            "simple_py": "SCX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0564",
                            "area_code": "341523",
                            "longitude": "116.944088",
                            "latitude": "31.462848"
                        },
                        {
                            "area_id": 21095,
                            "city_id": 19884,
                            "province_id": 14,
                            "name": "裕安区",
                            "whole_name": "裕安区，六安市，安徽省",
                            "simple_py": "YAQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0564",
                            "area_code": "341503",
                            "longitude": "116.494543",
                            "latitude": "31.750692"
                        },
                        {
                            "area_id": 21099,
                            "city_id": 19884,
                            "province_id": 14,
                            "name": "叶集区",
                            "whole_name": "叶集区，六安市，安徽省",
                            "simple_py": "YJQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0564",
                            "area_code": "341504",
                            "longitude": "115.913594",
                            "latitude": "31.84768"
                        }
                    ]
                },
                {
                    "city_id": 19876,
                    "province_id": 14,
                    "name": "马鞍山市",
                    "whole_name": "马鞍山市，安徽省",
                    "simple_py": "MASS",
                    "per_pin_yin": "M",
                    "per_pin_yin2": "M",
                    "city_code": "0555",
                    "area_code": "340500",
                    "longitude": "118.507906",
                    "latitude": "31.689362",
                    "children": [
                        {
                            "area_id": 20244,
                            "city_id": 19876,
                            "province_id": 14,
                            "name": "博望区",
                            "whole_name": "博望区，马鞍山市，安徽省",
                            "simple_py": "BWQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0555",
                            "area_code": "340506",
                            "longitude": "118.843742",
                            "latitude": "31.562321"
                        },
                        {
                            "area_id": 20245,
                            "city_id": 19876,
                            "province_id": 14,
                            "name": "当涂县",
                            "whole_name": "当涂县，马鞍山市，安徽省",
                            "simple_py": "DTX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0555",
                            "area_code": "340521",
                            "longitude": "118.489873",
                            "latitude": "31.556167"
                        },
                        {
                            "area_id": 20246,
                            "city_id": 19876,
                            "province_id": 14,
                            "name": "花山区",
                            "whole_name": "花山区，马鞍山市，安徽省",
                            "simple_py": "HSQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0555",
                            "area_code": "340503",
                            "longitude": "118.511308",
                            "latitude": "31.69902"
                        },
                        {
                            "area_id": 20248,
                            "city_id": 19876,
                            "province_id": 14,
                            "name": "和县",
                            "whole_name": "和县，马鞍山市，安徽省",
                            "simple_py": "HX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0555",
                            "area_code": "340523",
                            "longitude": "118.362998",
                            "latitude": "31.716634"
                        },
                        {
                            "area_id": 20249,
                            "city_id": 19876,
                            "province_id": 14,
                            "name": "含山县",
                            "whole_name": "含山县，马鞍山市，安徽省",
                            "simple_py": "HSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0555",
                            "area_code": "340522",
                            "longitude": "118.105545",
                            "latitude": "31.727758"
                        },
                        {
                            "area_id": 20247,
                            "city_id": 19876,
                            "province_id": 14,
                            "name": "雨山区",
                            "whole_name": "雨山区，马鞍山市，安徽省",
                            "simple_py": "YSQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0555",
                            "area_code": "340504",
                            "longitude": "118.493104",
                            "latitude": "31.685912"
                        }
                    ]
                },
                {
                    "city_id": 19887,
                    "province_id": 14,
                    "name": "宿州市",
                    "whole_name": "宿州市，安徽省",
                    "simple_py": "SZS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0557",
                    "area_code": "341300",
                    "longitude": "116.984084",
                    "latitude": "33.633891",
                    "children": [
                        {
                            "area_id": 21502,
                            "city_id": 19887,
                            "province_id": 14,
                            "name": "砀山县",
                            "whole_name": "砀山县，宿州市，安徽省",
                            "simple_py": "DSX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0557",
                            "area_code": "341321",
                            "longitude": "116.351113",
                            "latitude": "34.426247"
                        },
                        {
                            "area_id": 21505,
                            "city_id": 19887,
                            "province_id": 14,
                            "name": "灵璧县",
                            "whole_name": "灵璧县，宿州市，安徽省",
                            "simple_py": "LBX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0557",
                            "area_code": "341323",
                            "longitude": "117.551493",
                            "latitude": "33.540629"
                        },
                        {
                            "area_id": 21504,
                            "city_id": 19887,
                            "province_id": 14,
                            "name": "泗县",
                            "whole_name": "泗县，宿州市，安徽省",
                            "simple_py": "SX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0557",
                            "area_code": "341324",
                            "longitude": "117.885443",
                            "latitude": "33.47758"
                        },
                        {
                            "area_id": 21506,
                            "city_id": 19887,
                            "province_id": 14,
                            "name": "萧县",
                            "whole_name": "萧县，宿州市，安徽省",
                            "simple_py": "XX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0557",
                            "area_code": "341322",
                            "longitude": "116.945399",
                            "latitude": "34.183266"
                        },
                        {
                            "area_id": 21503,
                            "city_id": 19887,
                            "province_id": 14,
                            "name": "埇桥区",
                            "whole_name": "埇桥区，宿州市，安徽省",
                            "simple_py": "YQQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0557",
                            "area_code": "341302",
                            "longitude": "116.983309",
                            "latitude": "33.633853"
                        }
                    ]
                },
                {
                    "city_id": 19874,
                    "province_id": 14,
                    "name": "铜陵市",
                    "whole_name": "铜陵市，安徽省",
                    "simple_py": "TLS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0562",
                    "area_code": "340700",
                    "longitude": "117.816576",
                    "latitude": "30.929935",
                    "children": [
                        {
                            "area_id": 20108,
                            "city_id": 19874,
                            "province_id": 14,
                            "name": "郊区",
                            "whole_name": "郊区，铜陵市，安徽省",
                            "simple_py": "JQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0562",
                            "area_code": "340711",
                            "longitude": "117.80707",
                            "latitude": "30.908927"
                        },
                        {
                            "area_id": 20109,
                            "city_id": 19874,
                            "province_id": 14,
                            "name": "铜官区",
                            "whole_name": "铜官区，铜陵市，安徽省",
                            "simple_py": "TGQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0562",
                            "area_code": "340705",
                            "longitude": "117.818427",
                            "latitude": "30.93182"
                        },
                        {
                            "area_id": 20110,
                            "city_id": 19874,
                            "province_id": 14,
                            "name": "义安区",
                            "whole_name": "义安区，铜陵市，安徽省",
                            "simple_py": "YAQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0562",
                            "area_code": "340706",
                            "longitude": "117.792288",
                            "latitude": "30.952338"
                        },
                        {
                            "area_id": 20107,
                            "city_id": 19874,
                            "province_id": 14,
                            "name": "枞阳县",
                            "whole_name": "枞阳县，铜陵市，安徽省",
                            "simple_py": "ZYX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0562",
                            "area_code": "340722",
                            "longitude": "117.222027",
                            "latitude": "30.700615"
                        }
                    ]
                },
                {
                    "city_id": 19883,
                    "province_id": 14,
                    "name": "芜湖市",
                    "whole_name": "芜湖市，安徽省",
                    "simple_py": "WHS",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "0553",
                    "area_code": "340200",
                    "longitude": "118.376451",
                    "latitude": "31.326319",
                    "children": [
                        {
                            "area_id": 21003,
                            "city_id": 19883,
                            "province_id": 14,
                            "name": "繁昌县",
                            "whole_name": "繁昌县，芜湖市，安徽省",
                            "simple_py": "FCX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0553",
                            "area_code": "340222",
                            "longitude": "118.201349",
                            "latitude": "31.080896"
                        },
                        {
                            "area_id": 21006,
                            "city_id": 19883,
                            "province_id": 14,
                            "name": "镜湖区",
                            "whole_name": "镜湖区，芜湖市，安徽省",
                            "simple_py": "JHQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0553",
                            "area_code": "340202",
                            "longitude": "118.376343",
                            "latitude": "31.32559"
                        },
                        {
                            "area_id": 21008,
                            "city_id": 19883,
                            "province_id": 14,
                            "name": "鸠江区",
                            "whole_name": "鸠江区，芜湖市，安徽省",
                            "simple_py": "JJQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0553",
                            "area_code": "340207",
                            "longitude": "118.400174",
                            "latitude": "31.362716"
                        },
                        {
                            "area_id": 21007,
                            "city_id": 19883,
                            "province_id": 14,
                            "name": "南陵县",
                            "whole_name": "南陵县，芜湖市，安徽省",
                            "simple_py": "NLX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0553",
                            "area_code": "340223",
                            "longitude": "118.337104",
                            "latitude": "30.919638"
                        },
                        {
                            "area_id": 21009,
                            "city_id": 19883,
                            "province_id": 14,
                            "name": "三山区",
                            "whole_name": "三山区，芜湖市，安徽省",
                            "simple_py": "SSQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0553",
                            "area_code": "340208",
                            "longitude": "118.233987",
                            "latitude": "31.225423"
                        },
                        {
                            "area_id": 21004,
                            "city_id": 19883,
                            "province_id": 14,
                            "name": "无为县",
                            "whole_name": "无为县，芜湖市，安徽省",
                            "simple_py": "WWX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0553",
                            "area_code": "340225",
                            "longitude": "117.911432",
                            "latitude": "31.303075"
                        },
                        {
                            "area_id": 21010,
                            "city_id": 19883,
                            "province_id": 14,
                            "name": "芜湖县",
                            "whole_name": "芜湖县，芜湖市，安徽省",
                            "simple_py": "WHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0553",
                            "area_code": "340221",
                            "longitude": "118.572301",
                            "latitude": "31.145262"
                        },
                        {
                            "area_id": 21005,
                            "city_id": 19883,
                            "province_id": 14,
                            "name": "弋江区",
                            "whole_name": "弋江区，芜湖市，安徽省",
                            "simple_py": "YJQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0553",
                            "area_code": "340203",
                            "longitude": "118.377476",
                            "latitude": "31.313394"
                        }
                    ]
                },
                {
                    "city_id": 19882,
                    "province_id": 14,
                    "name": "宣城市",
                    "whole_name": "宣城市，安徽省",
                    "simple_py": "XCS",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "0563",
                    "area_code": "341800",
                    "longitude": "118.757995",
                    "latitude": "30.945667",
                    "children": [
                        {
                            "area_id": 20897,
                            "city_id": 19882,
                            "province_id": 14,
                            "name": "广德县",
                            "whole_name": "广德县，宣城市，安徽省",
                            "simple_py": "GDX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0563",
                            "area_code": "341822",
                            "longitude": "119.417521",
                            "latitude": "30.893116"
                        },
                        {
                            "area_id": 20898,
                            "city_id": 19882,
                            "province_id": 14,
                            "name": "泾县",
                            "whole_name": "泾县，宣城市，安徽省",
                            "simple_py": "JX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0563",
                            "area_code": "341823",
                            "longitude": "118.412397",
                            "latitude": "30.685975"
                        },
                        {
                            "area_id": 20899,
                            "city_id": 19882,
                            "province_id": 14,
                            "name": "旌德县",
                            "whole_name": "旌德县，宣城市，安徽省",
                            "simple_py": "JDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0563",
                            "area_code": "341825",
                            "longitude": "118.543081",
                            "latitude": "30.288057"
                        },
                        {
                            "area_id": 20900,
                            "city_id": 19882,
                            "province_id": 14,
                            "name": "绩溪县",
                            "whole_name": "绩溪县，宣城市，安徽省",
                            "simple_py": "JXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0563",
                            "area_code": "341824",
                            "longitude": "118.594705",
                            "latitude": "30.065267"
                        },
                        {
                            "area_id": 20902,
                            "city_id": 19882,
                            "province_id": 14,
                            "name": "郎溪县",
                            "whole_name": "郎溪县，宣城市，安徽省",
                            "simple_py": "LXX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0563",
                            "area_code": "341821",
                            "longitude": "119.185024",
                            "latitude": "31.127834"
                        },
                        {
                            "area_id": 20903,
                            "city_id": 19882,
                            "province_id": 14,
                            "name": "宁国市",
                            "whole_name": "宁国市，宣城市，安徽省",
                            "simple_py": "NGS",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0563",
                            "area_code": "341881",
                            "longitude": "118.983407",
                            "latitude": "30.626529"
                        },
                        {
                            "area_id": 20901,
                            "city_id": 19882,
                            "province_id": 14,
                            "name": "宣州区",
                            "whole_name": "宣州区，宣城市，安徽省",
                            "simple_py": "XZQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0563",
                            "area_code": "341802",
                            "longitude": "118.758412",
                            "latitude": "30.946003"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 28,
            "name": "澳门特别行政区",
            "whole_name": "澳门特别行政区",
            "simple_py": "AMTBXZQ",
            "per_pin_yin": " ",
            "per_pin_yin2": "A",
            "city_code": "",
            "area_code": "820000",
            "longitude": "113.54909",
            "latitude": "22.198951",
            "children": [
                {
                    "city_id": 36609,
                    "province_id": 28,
                    "name": "大堂区",
                    "whole_name": "大堂区，澳门特别行政区",
                    "simple_py": "DTQ",
                    "per_pin_yin": "D",
                    "per_pin_yin2": "D",
                    "city_code": "",
                    "area_code": "820004",
                    "longitude": "113.55374",
                    "latitude": "22.188119",
                    "children": []
                },
                {
                    "city_id": 36604,
                    "province_id": 28,
                    "name": "风顺堂区",
                    "whole_name": "风顺堂区，澳门特别行政区",
                    "simple_py": "FSTQ",
                    "per_pin_yin": "F",
                    "per_pin_yin2": "F",
                    "city_code": "",
                    "area_code": "820005",
                    "longitude": "113.54167",
                    "latitude": "22.187778",
                    "children": []
                },
                {
                    "city_id": 36605,
                    "province_id": 28,
                    "name": "花地玛堂区",
                    "whole_name": "花地玛堂区，澳门特别行政区",
                    "simple_py": "HDMTQ",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "",
                    "area_code": "820001",
                    "longitude": "113.552965",
                    "latitude": "22.207882",
                    "children": []
                },
                {
                    "city_id": 36607,
                    "province_id": 28,
                    "name": "花王堂区",
                    "whole_name": "花王堂区，澳门特别行政区",
                    "simple_py": "HWTQ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "",
                    "area_code": "820002",
                    "longitude": "113.549052",
                    "latitude": "22.199175",
                    "children": []
                },
                {
                    "city_id": 36610,
                    "province_id": 28,
                    "name": "嘉模堂区",
                    "whole_name": "嘉模堂区，澳门特别行政区",
                    "simple_py": "JMTQ",
                    "per_pin_yin": "J",
                    "per_pin_yin2": "J",
                    "city_code": "",
                    "area_code": "820006",
                    "longitude": "113.558783",
                    "latitude": "22.154124",
                    "children": []
                },
                {
                    "city_id": 36608,
                    "province_id": 28,
                    "name": "路凼填海区",
                    "whole_name": "路凼填海区，澳门特别行政区",
                    "simple_py": "LDTHQ",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "",
                    "area_code": "820007",
                    "longitude": "113.56925",
                    "latitude": "22.136546",
                    "children": []
                },
                {
                    "city_id": 36606,
                    "province_id": 28,
                    "name": "圣方济各堂区",
                    "whole_name": "圣方济各堂区，澳门特别行政区",
                    "simple_py": "SFJGTQ",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "",
                    "area_code": "820008",
                    "longitude": "113.559954",
                    "latitude": "22.124049",
                    "children": []
                },
                {
                    "city_id": 36611,
                    "province_id": 28,
                    "name": "望德堂区",
                    "whole_name": "望德堂区，澳门特别行政区",
                    "simple_py": "WDTQ",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "",
                    "area_code": "820003",
                    "longitude": "113.550252",
                    "latitude": "22.193791",
                    "children": []
                }
            ]
        },
        {
            "province_id": 32,
            "name": "北京市",
            "whole_name": "北京市",
            "simple_py": "BJS",
            "per_pin_yin": "B",
            "per_pin_yin2": "B",
            "city_code": "",
            "area_code": "110000",
            "longitude": "116.405285",
            "latitude": "39.904989",
            "children": [
                {
                    "city_id": 44536,
                    "province_id": 32,
                    "name": "北京城区",
                    "whole_name": "北京城区，北京市",
                    "simple_py": "BJCQ",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "",
                    "area_code": "110100",
                    "longitude": "116.405285",
                    "latitude": "39.904989",
                    "children": [
                        {
                            "area_id": 44543,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "朝阳区",
                            "whole_name": "朝阳区，北京城区，北京市",
                            "simple_py": "CYQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "010",
                            "area_code": "110105",
                            "longitude": "116.486409",
                            "latitude": "39.921489"
                        },
                        {
                            "area_id": 44550,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "昌平区",
                            "whole_name": "昌平区，北京城区，北京市",
                            "simple_py": "CPQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "010",
                            "area_code": "110114",
                            "longitude": "116.235906",
                            "latitude": "40.218085"
                        },
                        {
                            "area_id": 44546,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "东城区",
                            "whole_name": "东城区，北京城区，北京市",
                            "simple_py": "DCQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "010",
                            "area_code": "110101",
                            "longitude": "116.418757",
                            "latitude": "39.917544"
                        },
                        {
                            "area_id": 44547,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "大兴区",
                            "whole_name": "大兴区，北京城区，北京市",
                            "simple_py": "DXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "010",
                            "area_code": "110115",
                            "longitude": "116.338033",
                            "latitude": "39.728908"
                        },
                        {
                            "area_id": 44540,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "丰台区",
                            "whole_name": "丰台区，北京城区，北京市",
                            "simple_py": "FTQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "010",
                            "area_code": "110106",
                            "longitude": "116.286968",
                            "latitude": "39.863642"
                        },
                        {
                            "area_id": 44545,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "房山区",
                            "whole_name": "房山区，北京城区，北京市",
                            "simple_py": "FSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "010",
                            "area_code": "110111",
                            "longitude": "116.139157",
                            "latitude": "39.735535"
                        },
                        {
                            "area_id": 44537,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "怀柔区",
                            "whole_name": "怀柔区，北京城区，北京市",
                            "simple_py": "HRQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "010",
                            "area_code": "110116",
                            "longitude": "116.637122",
                            "latitude": "40.324272"
                        },
                        {
                            "area_id": 44551,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "海淀区",
                            "whole_name": "海淀区，北京城区，北京市",
                            "simple_py": "HDQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "010",
                            "area_code": "110108",
                            "longitude": "116.310316",
                            "latitude": "39.956074"
                        },
                        {
                            "area_id": 44539,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "密云区",
                            "whole_name": "密云区，北京城区，北京市",
                            "simple_py": "MYQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "010",
                            "area_code": "110118",
                            "longitude": "116.843352",
                            "latitude": "40.377362"
                        },
                        {
                            "area_id": 44541,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "门头沟区",
                            "whole_name": "门头沟区，北京城区，北京市",
                            "simple_py": "MTGQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "010",
                            "area_code": "110109",
                            "longitude": "116.105381",
                            "latitude": "39.937183"
                        },
                        {
                            "area_id": 44548,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "平谷区",
                            "whole_name": "平谷区，北京城区，北京市",
                            "simple_py": "PGQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "010",
                            "area_code": "110117",
                            "longitude": "117.112335",
                            "latitude": "40.144783"
                        },
                        {
                            "area_id": 44542,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "顺义区",
                            "whole_name": "顺义区，北京城区，北京市",
                            "simple_py": "SYQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "010",
                            "area_code": "110113",
                            "longitude": "116.653525",
                            "latitude": "40.128936"
                        },
                        {
                            "area_id": 44544,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "石景山区",
                            "whole_name": "石景山区，北京城区，北京市",
                            "simple_py": "SJSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "010",
                            "area_code": "110107",
                            "longitude": "116.195445",
                            "latitude": "39.914601"
                        },
                        {
                            "area_id": 44549,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "通州区",
                            "whole_name": "通州区，北京城区，北京市",
                            "simple_py": "TZQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "010",
                            "area_code": "110112",
                            "longitude": "116.658603",
                            "latitude": "39.902486"
                        },
                        {
                            "area_id": 44552,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "西城区",
                            "whole_name": "西城区，北京城区，北京市",
                            "simple_py": "XCQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "010",
                            "area_code": "110102",
                            "longitude": "116.366794",
                            "latitude": "39.915309"
                        },
                        {
                            "area_id": 44538,
                            "city_id": 44536,
                            "province_id": 32,
                            "name": "延庆区",
                            "whole_name": "延庆区，北京城区，北京市",
                            "simple_py": "YQQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "010",
                            "area_code": "110119",
                            "longitude": "115.985006",
                            "latitude": "40.465325"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 12,
            "name": "重庆市",
            "whole_name": "重庆市",
            "simple_py": "CQS",
            "per_pin_yin": "C",
            "per_pin_yin2": "C",
            "city_code": "",
            "area_code": "500000",
            "longitude": "106.504962",
            "latitude": "29.533155",
            "children": [
                {
                    "city_id": 18038,
                    "province_id": 12,
                    "name": "重庆城区",
                    "whole_name": "重庆城区，重庆市",
                    "simple_py": "CQCQ",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "",
                    "area_code": "500100",
                    "longitude": "106.504962",
                    "latitude": "29.533155",
                    "children": [
                        {
                            "area_id": 18043,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "璧山区",
                            "whole_name": "璧山区，重庆城区，重庆市",
                            "simple_py": "BSQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "023",
                            "area_code": "500120",
                            "longitude": "106.231126",
                            "latitude": "29.593581"
                        },
                        {
                            "area_id": 18063,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "巴南区",
                            "whole_name": "巴南区，重庆城区，重庆市",
                            "simple_py": "BNQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "023",
                            "area_code": "500113",
                            "longitude": "106.519423",
                            "latitude": "29.381919"
                        },
                        {
                            "area_id": 18065,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "北碚区",
                            "whole_name": "北碚区，重庆城区，重庆市",
                            "simple_py": "BBQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "023",
                            "area_code": "500109",
                            "longitude": "106.437868",
                            "latitude": "29.82543"
                        },
                        {
                            "area_id": 18045,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "长寿区",
                            "whole_name": "长寿区，重庆城区，重庆市",
                            "simple_py": "CSQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "023",
                            "area_code": "500115",
                            "longitude": "107.074854",
                            "latitude": "29.833671"
                        },
                        {
                            "area_id": 18044,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "大足区",
                            "whole_name": "大足区，重庆城区，重庆市",
                            "simple_py": "DZQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "023",
                            "area_code": "500111",
                            "longitude": "105.715319",
                            "latitude": "29.700498"
                        },
                        {
                            "area_id": 18048,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "大渡口区",
                            "whole_name": "大渡口区，重庆城区，重庆市",
                            "simple_py": "DDKQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "023",
                            "area_code": "500104",
                            "longitude": "106.48613",
                            "latitude": "29.481002"
                        },
                        {
                            "area_id": 18053,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "涪陵区",
                            "whole_name": "涪陵区，重庆城区，重庆市",
                            "simple_py": "FLQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "023",
                            "area_code": "500102",
                            "longitude": "107.394905",
                            "latitude": "29.703652"
                        },
                        {
                            "area_id": 18042,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "合川区",
                            "whole_name": "合川区，重庆城区，重庆市",
                            "simple_py": "HCQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "023",
                            "area_code": "500117",
                            "longitude": "106.265554",
                            "latitude": "29.990993"
                        },
                        {
                            "area_id": 18050,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "江北区",
                            "whole_name": "江北区，重庆城区，重庆市",
                            "simple_py": "JBQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "023",
                            "area_code": "500105",
                            "longitude": "106.532844",
                            "latitude": "29.575352"
                        },
                        {
                            "area_id": 18054,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "九龙坡区",
                            "whole_name": "九龙坡区，重庆城区，重庆市",
                            "simple_py": "JLPQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "023",
                            "area_code": "500107",
                            "longitude": "106.480989",
                            "latitude": "29.523492"
                        },
                        {
                            "area_id": 18061,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "江津区",
                            "whole_name": "江津区，重庆城区，重庆市",
                            "simple_py": "JJQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "023",
                            "area_code": "500116",
                            "longitude": "106.253156",
                            "latitude": "29.283387"
                        },
                        {
                            "area_id": 18059,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "开州区",
                            "whole_name": "开州区，重庆城区，重庆市",
                            "simple_py": "KZQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "023",
                            "area_code": "500154",
                            "longitude": "108.413317",
                            "latitude": "31.167735"
                        },
                        {
                            "area_id": 18058,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "梁平区",
                            "whole_name": "梁平区，重庆城区，重庆市",
                            "simple_py": "LPQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "023",
                            "area_code": "500155",
                            "longitude": "107.800034",
                            "latitude": "30.672168"
                        },
                        {
                            "area_id": 18056,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "南川区",
                            "whole_name": "南川区，重庆城区，重庆市",
                            "simple_py": "NCQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "023",
                            "area_code": "500119",
                            "longitude": "107.098153",
                            "latitude": "29.156646"
                        },
                        {
                            "area_id": 18062,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "南岸区",
                            "whole_name": "南岸区，重庆城区，重庆市",
                            "simple_py": "NAQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "023",
                            "area_code": "500108",
                            "longitude": "106.560813",
                            "latitude": "29.523992"
                        },
                        {
                            "area_id": 18057,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "綦江区",
                            "whole_name": "綦江区，重庆城区，重庆市",
                            "simple_py": "QJQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "023",
                            "area_code": "500110",
                            "longitude": "106.651417",
                            "latitude": "29.028091"
                        },
                        {
                            "area_id": 18060,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "黔江区",
                            "whole_name": "黔江区，重庆城区，重庆市",
                            "simple_py": "QJQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "023",
                            "area_code": "500114",
                            "longitude": "108.782577",
                            "latitude": "29.527548"
                        },
                        {
                            "area_id": 18046,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "荣昌区",
                            "whole_name": "荣昌区，重庆城区，重庆市",
                            "simple_py": "RCQ",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "023",
                            "area_code": "500153",
                            "longitude": "105.594061",
                            "latitude": "29.403627"
                        },
                        {
                            "area_id": 18064,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "沙坪坝区",
                            "whole_name": "沙坪坝区，重庆城区，重庆市",
                            "simple_py": "SPBQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "023",
                            "area_code": "500106",
                            "longitude": "106.4542",
                            "latitude": "29.541224"
                        },
                        {
                            "area_id": 18040,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "铜梁区",
                            "whole_name": "铜梁区，重庆城区，重庆市",
                            "simple_py": "TLQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "023",
                            "area_code": "500151",
                            "longitude": "106.054948",
                            "latitude": "29.839944"
                        },
                        {
                            "area_id": 18041,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "潼南区",
                            "whole_name": "潼南区，重庆城区，重庆市",
                            "simple_py": "TNQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "023",
                            "area_code": "500152",
                            "longitude": "105.841818",
                            "latitude": "30.189554"
                        },
                        {
                            "area_id": 18049,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "武隆区",
                            "whole_name": "武隆区，重庆城区，重庆市",
                            "simple_py": "WLQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "023",
                            "area_code": "500156",
                            "longitude": "107.75655",
                            "latitude": "29.32376"
                        },
                        {
                            "area_id": 18052,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "万州区",
                            "whole_name": "万州区，重庆城区，重庆市",
                            "simple_py": "WZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "023",
                            "area_code": "500101",
                            "longitude": "108.380246",
                            "latitude": "30.807807"
                        },
                        {
                            "area_id": 18047,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "永川区",
                            "whole_name": "永川区，重庆城区，重庆市",
                            "simple_py": "YCQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "023",
                            "area_code": "500118",
                            "longitude": "105.894714",
                            "latitude": "29.348748"
                        },
                        {
                            "area_id": 18051,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "渝中区",
                            "whole_name": "渝中区，重庆城区，重庆市",
                            "simple_py": "YZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "023",
                            "area_code": "500103",
                            "longitude": "106.56288",
                            "latitude": "29.556742"
                        },
                        {
                            "area_id": 18055,
                            "city_id": 18038,
                            "province_id": 12,
                            "name": "渝北区",
                            "whole_name": "渝北区，重庆城区，重庆市",
                            "simple_py": "YBQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "023",
                            "area_code": "500112",
                            "longitude": "106.512851",
                            "latitude": "29.601451"
                        }
                    ]
                },
                {
                    "city_id": 18039,
                    "province_id": 12,
                    "name": "重庆郊县",
                    "whole_name": "重庆郊县，重庆市",
                    "simple_py": "CQJX",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "C",
                    "city_code": "",
                    "area_code": "500200",
                    "longitude": "108.170255",
                    "latitude": "29.291965",
                    "children": [
                        {
                            "area_id": 18710,
                            "city_id": 18039,
                            "province_id": 12,
                            "name": "城口县",
                            "whole_name": "城口县，重庆郊县，重庆市",
                            "simple_py": "CKX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "023",
                            "area_code": "500229",
                            "longitude": "108.6649",
                            "latitude": "31.946293"
                        },
                        {
                            "area_id": 18715,
                            "city_id": 18039,
                            "province_id": 12,
                            "name": "垫江县",
                            "whole_name": "垫江县，重庆郊县，重庆市",
                            "simple_py": "DJX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "023",
                            "area_code": "500231",
                            "longitude": "107.348692",
                            "latitude": "30.330012"
                        },
                        {
                            "area_id": 18712,
                            "city_id": 18039,
                            "province_id": 12,
                            "name": "奉节县",
                            "whole_name": "奉节县，重庆郊县，重庆市",
                            "simple_py": "FJX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "023",
                            "area_code": "500236",
                            "longitude": "109.465774",
                            "latitude": "31.019967"
                        },
                        {
                            "area_id": 18713,
                            "city_id": 18039,
                            "province_id": 12,
                            "name": "丰都县",
                            "whole_name": "丰都县，重庆郊县，重庆市",
                            "simple_py": "FDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "023",
                            "area_code": "500230",
                            "longitude": "107.73248",
                            "latitude": "29.866424"
                        },
                        {
                            "area_id": 18714,
                            "city_id": 18039,
                            "province_id": 12,
                            "name": "彭水苗族土家族自治县",
                            "whole_name": "彭水苗族土家族自治县，重庆郊县，重庆市",
                            "simple_py": "PSMZTJZZZX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "023",
                            "area_code": "500243",
                            "longitude": "108.166551",
                            "latitude": "29.293856"
                        },
                        {
                            "area_id": 18721,
                            "city_id": 18039,
                            "province_id": 12,
                            "name": "石柱土家族自治县",
                            "whole_name": "石柱土家族自治县，重庆郊县，重庆市",
                            "simple_py": "SZTJZZZX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "023",
                            "area_code": "500240",
                            "longitude": "108.112448",
                            "latitude": "29.99853"
                        },
                        {
                            "area_id": 18711,
                            "city_id": 18039,
                            "province_id": 12,
                            "name": "巫溪县",
                            "whole_name": "巫溪县，重庆郊县，重庆市",
                            "simple_py": "WXX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "023",
                            "area_code": "500238",
                            "longitude": "109.628912",
                            "latitude": "31.3966"
                        },
                        {
                            "area_id": 18718,
                            "city_id": 18039,
                            "province_id": 12,
                            "name": "巫山县",
                            "whole_name": "巫山县，重庆郊县，重庆市",
                            "simple_py": "WSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "023",
                            "area_code": "500237",
                            "longitude": "109.878928",
                            "latitude": "31.074843"
                        },
                        {
                            "area_id": 18716,
                            "city_id": 18039,
                            "province_id": 12,
                            "name": "秀山土家族苗族自治县",
                            "whole_name": "秀山土家族苗族自治县，重庆郊县，重庆市",
                            "simple_py": "XSTJZMZZZX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "023",
                            "area_code": "500241",
                            "longitude": "108.996043",
                            "latitude": "28.444772"
                        },
                        {
                            "area_id": 18717,
                            "city_id": 18039,
                            "province_id": 12,
                            "name": "云阳县",
                            "whole_name": "云阳县，重庆郊县，重庆市",
                            "simple_py": "YYX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "023",
                            "area_code": "500235",
                            "longitude": "108.697698",
                            "latitude": "30.930529"
                        },
                        {
                            "area_id": 18719,
                            "city_id": 18039,
                            "province_id": 12,
                            "name": "酉阳土家族苗族自治县",
                            "whole_name": "酉阳土家族苗族自治县，重庆郊县，重庆市",
                            "simple_py": "YYTJZMZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "023",
                            "area_code": "500242",
                            "longitude": "108.767201",
                            "latitude": "28.839828"
                        },
                        {
                            "area_id": 18720,
                            "city_id": 18039,
                            "province_id": 12,
                            "name": "忠县",
                            "whole_name": "忠县，重庆郊县，重庆市",
                            "simple_py": "ZX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "023",
                            "area_code": "500233",
                            "longitude": "108.037518",
                            "latitude": "30.291537"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 15,
            "name": "福建省",
            "whole_name": "福建省",
            "simple_py": "FJS",
            "per_pin_yin": "F",
            "per_pin_yin2": "F",
            "city_code": "",
            "area_code": "350000",
            "longitude": "119.306239",
            "latitude": "26.075302",
            "children": [
                {
                    "city_id": 21626,
                    "province_id": 15,
                    "name": "福州市",
                    "whole_name": "福州市，福建省",
                    "simple_py": "FZS",
                    "per_pin_yin": "F",
                    "per_pin_yin2": "F",
                    "city_code": "0591",
                    "area_code": "350100",
                    "longitude": "119.306239",
                    "latitude": "26.075302",
                    "children": [
                        {
                            "area_id": 21776,
                            "city_id": 21626,
                            "province_id": 15,
                            "name": "长乐区",
                            "whole_name": "长乐区，福州市，福建省",
                            "simple_py": "CLQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0591",
                            "area_code": "350112",
                            "longitude": "119.510849",
                            "latitude": "25.960583"
                        },
                        {
                            "area_id": 21777,
                            "city_id": 21626,
                            "province_id": 15,
                            "name": "仓山区",
                            "whole_name": "仓山区，福州市，福建省",
                            "simple_py": "CSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0591",
                            "area_code": "350104",
                            "longitude": "119.320988",
                            "latitude": "26.038912"
                        },
                        {
                            "area_id": 21780,
                            "city_id": 21626,
                            "province_id": 15,
                            "name": "福清市",
                            "whole_name": "福清市，福州市，福建省",
                            "simple_py": "FQS",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0591",
                            "area_code": "350181",
                            "longitude": "119.376992",
                            "latitude": "25.720402"
                        },
                        {
                            "area_id": 21782,
                            "city_id": 21626,
                            "province_id": 15,
                            "name": "鼓楼区",
                            "whole_name": "鼓楼区，福州市，福建省",
                            "simple_py": "GLQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0591",
                            "area_code": "350102",
                            "longitude": "119.29929",
                            "latitude": "26.082284"
                        },
                        {
                            "area_id": 21784,
                            "city_id": 21626,
                            "province_id": 15,
                            "name": "晋安区",
                            "whole_name": "晋安区，福州市，福建省",
                            "simple_py": "JAQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0591",
                            "area_code": "350111",
                            "longitude": "119.328597",
                            "latitude": "26.078837"
                        },
                        {
                            "area_id": 21772,
                            "city_id": 21626,
                            "province_id": 15,
                            "name": "罗源县",
                            "whole_name": "罗源县，福州市，福建省",
                            "simple_py": "LYX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0591",
                            "area_code": "350123",
                            "longitude": "119.552645",
                            "latitude": "26.487234"
                        },
                        {
                            "area_id": 21773,
                            "city_id": 21626,
                            "province_id": 15,
                            "name": "连江县",
                            "whole_name": "连江县，福州市，福建省",
                            "simple_py": "LJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0591",
                            "area_code": "350122",
                            "longitude": "119.538365",
                            "latitude": "26.202109"
                        },
                        {
                            "area_id": 21774,
                            "city_id": 21626,
                            "province_id": 15,
                            "name": "闽清县",
                            "whole_name": "闽清县，福州市，福建省",
                            "simple_py": "MQX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0591",
                            "area_code": "350124",
                            "longitude": "118.868416",
                            "latitude": "26.223793"
                        },
                        {
                            "area_id": 21775,
                            "city_id": 21626,
                            "province_id": 15,
                            "name": "闽侯县",
                            "whole_name": "闽侯县，福州市，福建省",
                            "simple_py": "MHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0591",
                            "area_code": "350121",
                            "longitude": "119.145117",
                            "latitude": "26.148567"
                        },
                        {
                            "area_id": 21783,
                            "city_id": 21626,
                            "province_id": 15,
                            "name": "马尾区",
                            "whole_name": "马尾区，福州市，福建省",
                            "simple_py": "MWQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0591",
                            "area_code": "350105",
                            "longitude": "119.458725",
                            "latitude": "25.991975"
                        },
                        {
                            "area_id": 21779,
                            "city_id": 21626,
                            "province_id": 15,
                            "name": "平潭县",
                            "whole_name": "平潭县，福州市，福建省",
                            "simple_py": "PTX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0591",
                            "area_code": "350128",
                            "longitude": "119.791197",
                            "latitude": "25.503672"
                        },
                        {
                            "area_id": 21781,
                            "city_id": 21626,
                            "province_id": 15,
                            "name": "台江区",
                            "whole_name": "台江区，福州市，福建省",
                            "simple_py": "TJQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0591",
                            "area_code": "350103",
                            "longitude": "119.310156",
                            "latitude": "26.058616"
                        },
                        {
                            "area_id": 21778,
                            "city_id": 21626,
                            "province_id": 15,
                            "name": "永泰县",
                            "whole_name": "永泰县，福州市，福建省",
                            "simple_py": "YTX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0591",
                            "area_code": "350125",
                            "longitude": "118.939089",
                            "latitude": "25.864825"
                        }
                    ]
                },
                {
                    "city_id": 21627,
                    "province_id": 15,
                    "name": "龙岩市",
                    "whole_name": "龙岩市，福建省",
                    "simple_py": "LYS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0597",
                    "area_code": "350800",
                    "longitude": "117.02978",
                    "latitude": "25.091603",
                    "children": [
                        {
                            "area_id": 21980,
                            "city_id": 21627,
                            "province_id": 15,
                            "name": "长汀县",
                            "whole_name": "长汀县，龙岩市，福建省",
                            "simple_py": "CTX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0597",
                            "area_code": "350821",
                            "longitude": "116.361007",
                            "latitude": "25.842278"
                        },
                        {
                            "area_id": 21981,
                            "city_id": 21627,
                            "province_id": 15,
                            "name": "连城县",
                            "whole_name": "连城县，龙岩市，福建省",
                            "simple_py": "LCX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0597",
                            "area_code": "350825",
                            "longitude": "116.756687",
                            "latitude": "25.708506"
                        },
                        {
                            "area_id": 21983,
                            "city_id": 21627,
                            "province_id": 15,
                            "name": "上杭县",
                            "whole_name": "上杭县，龙岩市，福建省",
                            "simple_py": "SHX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0597",
                            "area_code": "350823",
                            "longitude": "116.424774",
                            "latitude": "25.050019"
                        },
                        {
                            "area_id": 21982,
                            "city_id": 21627,
                            "province_id": 15,
                            "name": "武平县",
                            "whole_name": "武平县，龙岩市，福建省",
                            "simple_py": "WPX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0597",
                            "area_code": "350824",
                            "longitude": "116.100928",
                            "latitude": "25.08865"
                        },
                        {
                            "area_id": 21978,
                            "city_id": 21627,
                            "province_id": 15,
                            "name": "新罗区",
                            "whole_name": "新罗区，龙岩市，福建省",
                            "simple_py": "XLQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0597",
                            "area_code": "350802",
                            "longitude": "117.030721",
                            "latitude": "25.0918"
                        },
                        {
                            "area_id": 21984,
                            "city_id": 21627,
                            "province_id": 15,
                            "name": "永定区",
                            "whole_name": "永定区，龙岩市，福建省",
                            "simple_py": "YDQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0597",
                            "area_code": "350803",
                            "longitude": "116.732691",
                            "latitude": "24.720442"
                        },
                        {
                            "area_id": 21979,
                            "city_id": 21627,
                            "province_id": 15,
                            "name": "漳平市",
                            "whole_name": "漳平市，龙岩市，福建省",
                            "simple_py": "ZPS",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0597",
                            "area_code": "350881",
                            "longitude": "117.42073",
                            "latitude": "25.291597"
                        }
                    ]
                },
                {
                    "city_id": 21625,
                    "province_id": 15,
                    "name": "宁德市",
                    "whole_name": "宁德市，福建省",
                    "simple_py": "NDS",
                    "per_pin_yin": "N",
                    "per_pin_yin2": "N",
                    "city_code": "0593",
                    "area_code": "350900",
                    "longitude": "119.527082",
                    "latitude": "26.65924",
                    "children": [
                        {
                            "area_id": 21637,
                            "city_id": 21625,
                            "province_id": 15,
                            "name": "福安市",
                            "whole_name": "福安市，宁德市，福建省",
                            "simple_py": "FAS",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0593",
                            "area_code": "350981",
                            "longitude": "119.650798",
                            "latitude": "27.084246"
                        },
                        {
                            "area_id": 21642,
                            "city_id": 21625,
                            "province_id": 15,
                            "name": "福鼎市",
                            "whole_name": "福鼎市，宁德市，福建省",
                            "simple_py": "FDS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0593",
                            "area_code": "350982",
                            "longitude": "120.219761",
                            "latitude": "27.318884"
                        },
                        {
                            "area_id": 21641,
                            "city_id": 21625,
                            "province_id": 15,
                            "name": "古田县",
                            "whole_name": "古田县，宁德市，福建省",
                            "simple_py": "GTX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0593",
                            "area_code": "350922",
                            "longitude": "118.743156",
                            "latitude": "26.577491"
                        },
                        {
                            "area_id": 21640,
                            "city_id": 21625,
                            "province_id": 15,
                            "name": "蕉城区",
                            "whole_name": "蕉城区，宁德市，福建省",
                            "simple_py": "JCQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0593",
                            "area_code": "350902",
                            "longitude": "119.527225",
                            "latitude": "26.659253"
                        },
                        {
                            "area_id": 21639,
                            "city_id": 21625,
                            "province_id": 15,
                            "name": "屏南县",
                            "whole_name": "屏南县，宁德市，福建省",
                            "simple_py": "PNX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0593",
                            "area_code": "350923",
                            "longitude": "118.987544",
                            "latitude": "26.910826"
                        },
                        {
                            "area_id": 21634,
                            "city_id": 21625,
                            "province_id": 15,
                            "name": "寿宁县",
                            "whole_name": "寿宁县，宁德市，福建省",
                            "simple_py": "SNX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0593",
                            "area_code": "350924",
                            "longitude": "119.506733",
                            "latitude": "27.457798"
                        },
                        {
                            "area_id": 21638,
                            "city_id": 21625,
                            "province_id": 15,
                            "name": "霞浦县",
                            "whole_name": "霞浦县，宁德市，福建省",
                            "simple_py": "XPX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0593",
                            "area_code": "350921",
                            "longitude": "120.005214",
                            "latitude": "26.882068"
                        },
                        {
                            "area_id": 21635,
                            "city_id": 21625,
                            "province_id": 15,
                            "name": "周宁县",
                            "whole_name": "周宁县，宁德市，福建省",
                            "simple_py": "ZNX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0593",
                            "area_code": "350925",
                            "longitude": "119.338239",
                            "latitude": "27.103106"
                        },
                        {
                            "area_id": 21636,
                            "city_id": 21625,
                            "province_id": 15,
                            "name": "柘荣县",
                            "whole_name": "柘荣县，宁德市，福建省",
                            "simple_py": "ZRX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0593",
                            "area_code": "350926",
                            "longitude": "119.898226",
                            "latitude": "27.236163"
                        }
                    ]
                },
                {
                    "city_id": 21633,
                    "province_id": 15,
                    "name": "南平市",
                    "whole_name": "南平市，福建省",
                    "simple_py": "NPS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "N",
                    "city_code": "0599",
                    "area_code": "350700",
                    "longitude": "118.178459",
                    "latitude": "26.635627",
                    "children": [
                        {
                            "area_id": 22755,
                            "city_id": 21633,
                            "province_id": 15,
                            "name": "光泽县",
                            "whole_name": "光泽县，南平市，福建省",
                            "simple_py": "GZX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0599",
                            "area_code": "350723",
                            "longitude": "117.337897",
                            "latitude": "27.542803"
                        },
                        {
                            "area_id": 22756,
                            "city_id": 21633,
                            "province_id": 15,
                            "name": "建阳区",
                            "whole_name": "建阳区，南平市，福建省",
                            "simple_py": "JYQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0599",
                            "area_code": "350703",
                            "longitude": "118.12267",
                            "latitude": "27.332067"
                        },
                        {
                            "area_id": 22758,
                            "city_id": 21633,
                            "province_id": 15,
                            "name": "建瓯市",
                            "whole_name": "建瓯市，南平市，福建省",
                            "simple_py": "JOS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0599",
                            "area_code": "350783",
                            "longitude": "118.321765",
                            "latitude": "27.03502"
                        },
                        {
                            "area_id": 22753,
                            "city_id": 21633,
                            "province_id": 15,
                            "name": "浦城县",
                            "whole_name": "浦城县，南平市，福建省",
                            "simple_py": "PCX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0599",
                            "area_code": "350722",
                            "longitude": "118.536822",
                            "latitude": "27.920412"
                        },
                        {
                            "area_id": 22754,
                            "city_id": 21633,
                            "province_id": 15,
                            "name": "松溪县",
                            "whole_name": "松溪县，南平市，福建省",
                            "simple_py": "SXX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0599",
                            "area_code": "350724",
                            "longitude": "118.783491",
                            "latitude": "27.525785"
                        },
                        {
                            "area_id": 22757,
                            "city_id": 21633,
                            "province_id": 15,
                            "name": "邵武市",
                            "whole_name": "邵武市，南平市，福建省",
                            "simple_py": "SWS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0599",
                            "area_code": "350781",
                            "longitude": "117.491544",
                            "latitude": "27.337952"
                        },
                        {
                            "area_id": 22760,
                            "city_id": 21633,
                            "province_id": 15,
                            "name": "顺昌县",
                            "whole_name": "顺昌县，南平市，福建省",
                            "simple_py": "SCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0599",
                            "area_code": "350721",
                            "longitude": "117.80771",
                            "latitude": "26.792851"
                        },
                        {
                            "area_id": 22752,
                            "city_id": 21633,
                            "province_id": 15,
                            "name": "武夷山市",
                            "whole_name": "武夷山市，南平市，福建省",
                            "simple_py": "WYSS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0599",
                            "area_code": "350782",
                            "longitude": "118.032796",
                            "latitude": "27.751733"
                        },
                        {
                            "area_id": 22761,
                            "city_id": 21633,
                            "province_id": 15,
                            "name": "延平区",
                            "whole_name": "延平区，南平市，福建省",
                            "simple_py": "YPQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0599",
                            "area_code": "350702",
                            "longitude": "118.178918",
                            "latitude": "26.636079"
                        },
                        {
                            "area_id": 22759,
                            "city_id": 21633,
                            "province_id": 15,
                            "name": "政和县",
                            "whole_name": "政和县，南平市，福建省",
                            "simple_py": "ZHX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0599",
                            "area_code": "350725",
                            "longitude": "118.858661",
                            "latitude": "27.365398"
                        }
                    ]
                },
                {
                    "city_id": 21628,
                    "province_id": 15,
                    "name": "莆田市",
                    "whole_name": "莆田市，福建省",
                    "simple_py": "PTS",
                    "per_pin_yin": "P",
                    "per_pin_yin2": "P",
                    "city_code": "0594",
                    "area_code": "350300",
                    "longitude": "119.007558",
                    "latitude": "25.431011",
                    "children": [
                        {
                            "area_id": 22119,
                            "city_id": 21628,
                            "province_id": 15,
                            "name": "城厢区",
                            "whole_name": "城厢区，莆田市，福建省",
                            "simple_py": "CXQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0594",
                            "area_code": "350302",
                            "longitude": "119.001028",
                            "latitude": "25.433737"
                        },
                        {
                            "area_id": 22123,
                            "city_id": 21628,
                            "province_id": 15,
                            "name": "涵江区",
                            "whole_name": "涵江区，莆田市，福建省",
                            "simple_py": "HJQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0594",
                            "area_code": "350303",
                            "longitude": "119.119102",
                            "latitude": "25.459273"
                        },
                        {
                            "area_id": 22122,
                            "city_id": 21628,
                            "province_id": 15,
                            "name": "荔城区",
                            "whole_name": "荔城区，莆田市，福建省",
                            "simple_py": "LCQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0594",
                            "area_code": "350304",
                            "longitude": "119.020047",
                            "latitude": "25.430047"
                        },
                        {
                            "area_id": 22120,
                            "city_id": 21628,
                            "province_id": 15,
                            "name": "仙游县",
                            "whole_name": "仙游县，莆田市，福建省",
                            "simple_py": "XYX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0594",
                            "area_code": "350322",
                            "longitude": "118.694331",
                            "latitude": "25.356529"
                        },
                        {
                            "area_id": 22121,
                            "city_id": 21628,
                            "province_id": 15,
                            "name": "秀屿区",
                            "whole_name": "秀屿区，莆田市，福建省",
                            "simple_py": "XYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0594",
                            "area_code": "350305",
                            "longitude": "119.092607",
                            "latitude": "25.316141"
                        }
                    ]
                },
                {
                    "city_id": 21629,
                    "province_id": 15,
                    "name": "泉州市",
                    "whole_name": "泉州市，福建省",
                    "simple_py": "QZS",
                    "per_pin_yin": "Q",
                    "per_pin_yin2": "Q",
                    "city_code": "0595",
                    "area_code": "350500",
                    "longitude": "118.589421",
                    "latitude": "24.908853",
                    "children": [
                        {
                            "area_id": 22185,
                            "city_id": 21629,
                            "province_id": 15,
                            "name": "安溪县",
                            "whole_name": "安溪县，泉州市，福建省",
                            "simple_py": "AXX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0595",
                            "area_code": "350524",
                            "longitude": "118.186014",
                            "latitude": "25.056824"
                        },
                        {
                            "area_id": 22181,
                            "city_id": 21629,
                            "province_id": 15,
                            "name": "德化县",
                            "whole_name": "德化县，泉州市，福建省",
                            "simple_py": "DHX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0595",
                            "area_code": "350526",
                            "longitude": "118.242986",
                            "latitude": "25.489004"
                        },
                        {
                            "area_id": 22187,
                            "city_id": 21629,
                            "province_id": 15,
                            "name": "丰泽区",
                            "whole_name": "丰泽区，泉州市，福建省",
                            "simple_py": "FZQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0595",
                            "area_code": "350503",
                            "longitude": "118.605147",
                            "latitude": "24.896041"
                        },
                        {
                            "area_id": 22188,
                            "city_id": 21629,
                            "province_id": 15,
                            "name": "惠安县",
                            "whole_name": "惠安县，泉州市，福建省",
                            "simple_py": "HAX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0595",
                            "area_code": "350521",
                            "longitude": "118.798954",
                            "latitude": "25.028718"
                        },
                        {
                            "area_id": 22189,
                            "city_id": 21629,
                            "province_id": 15,
                            "name": "晋江市",
                            "whole_name": "晋江市，泉州市，福建省",
                            "simple_py": "JJS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0595",
                            "area_code": "350582",
                            "longitude": "118.577338",
                            "latitude": "24.807322"
                        },
                        {
                            "area_id": 22191,
                            "city_id": 21629,
                            "province_id": 15,
                            "name": "金门县",
                            "whole_name": "金门县，泉州市，福建省",
                            "simple_py": "JMX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "",
                            "area_code": "350527",
                            "longitude": "118.323221",
                            "latitude": "24.436417"
                        },
                        {
                            "area_id": 22184,
                            "city_id": 21629,
                            "province_id": 15,
                            "name": "洛江区",
                            "whole_name": "洛江区，泉州市，福建省",
                            "simple_py": "LJQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0595",
                            "area_code": "350504",
                            "longitude": "118.670312",
                            "latitude": "24.941153"
                        },
                        {
                            "area_id": 22192,
                            "city_id": 21629,
                            "province_id": 15,
                            "name": "鲤城区",
                            "whole_name": "鲤城区，泉州市，福建省",
                            "simple_py": "LCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0595",
                            "area_code": "350502",
                            "longitude": "118.588929",
                            "latitude": "24.907645"
                        },
                        {
                            "area_id": 22183,
                            "city_id": 21629,
                            "province_id": 15,
                            "name": "南安市",
                            "whole_name": "南安市，泉州市，福建省",
                            "simple_py": "NAS",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0595",
                            "area_code": "350583",
                            "longitude": "118.387031",
                            "latitude": "24.959494"
                        },
                        {
                            "area_id": 22186,
                            "city_id": 21629,
                            "province_id": 15,
                            "name": "泉港区",
                            "whole_name": "泉港区，泉州市，福建省",
                            "simple_py": "QGQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0595",
                            "area_code": "350505",
                            "longitude": "118.912285",
                            "latitude": "25.126859"
                        },
                        {
                            "area_id": 22190,
                            "city_id": 21629,
                            "province_id": 15,
                            "name": "石狮市",
                            "whole_name": "石狮市，泉州市，福建省",
                            "simple_py": "SSS",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0595",
                            "area_code": "350581",
                            "longitude": "118.628402",
                            "latitude": "24.731978"
                        },
                        {
                            "area_id": 22182,
                            "city_id": 21629,
                            "province_id": 15,
                            "name": "永春县",
                            "whole_name": "永春县，泉州市，福建省",
                            "simple_py": "YCX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0595",
                            "area_code": "350525",
                            "longitude": "118.29503",
                            "latitude": "25.320721"
                        }
                    ]
                },
                {
                    "city_id": 21630,
                    "province_id": 15,
                    "name": "三明市",
                    "whole_name": "三明市，福建省",
                    "simple_py": "SMS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0598",
                    "area_code": "350400",
                    "longitude": "117.635001",
                    "latitude": "26.265444",
                    "children": [
                        {
                            "area_id": 22365,
                            "city_id": 21630,
                            "province_id": 15,
                            "name": "大田县",
                            "whole_name": "大田县，三明市，福建省",
                            "simple_py": "DTX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0598",
                            "area_code": "350425",
                            "longitude": "117.849355",
                            "latitude": "25.690803"
                        },
                        {
                            "area_id": 22371,
                            "city_id": 21630,
                            "province_id": 15,
                            "name": "建宁县",
                            "whole_name": "建宁县，三明市，福建省",
                            "simple_py": "JNX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0598",
                            "area_code": "350430",
                            "longitude": "116.845832",
                            "latitude": "26.831398"
                        },
                        {
                            "area_id": 22373,
                            "city_id": 21630,
                            "province_id": 15,
                            "name": "将乐县",
                            "whole_name": "将乐县，三明市，福建省",
                            "simple_py": "JLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0598",
                            "area_code": "350428",
                            "longitude": "117.473558",
                            "latitude": "26.728667"
                        },
                        {
                            "area_id": 22366,
                            "city_id": 21630,
                            "province_id": 15,
                            "name": "梅列区",
                            "whole_name": "梅列区，三明市，福建省",
                            "simple_py": "MLQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0598",
                            "area_code": "350402",
                            "longitude": "117.63687",
                            "latitude": "26.269208"
                        },
                        {
                            "area_id": 22374,
                            "city_id": 21630,
                            "province_id": 15,
                            "name": "明溪县",
                            "whole_name": "明溪县，三明市，福建省",
                            "simple_py": "MXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0598",
                            "area_code": "350421",
                            "longitude": "117.201845",
                            "latitude": "26.357375"
                        },
                        {
                            "area_id": 22363,
                            "city_id": 21630,
                            "province_id": 15,
                            "name": "宁化县",
                            "whole_name": "宁化县，三明市，福建省",
                            "simple_py": "NHX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0598",
                            "area_code": "350424",
                            "longitude": "116.659725",
                            "latitude": "26.259932"
                        },
                        {
                            "area_id": 22369,
                            "city_id": 21630,
                            "province_id": 15,
                            "name": "清流县",
                            "whole_name": "清流县，三明市，福建省",
                            "simple_py": "QLX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0598",
                            "area_code": "350423",
                            "longitude": "116.815821",
                            "latitude": "26.17761"
                        },
                        {
                            "area_id": 22368,
                            "city_id": 21630,
                            "province_id": 15,
                            "name": "三元区",
                            "whole_name": "三元区，三明市，福建省",
                            "simple_py": "SYQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0598",
                            "area_code": "350403",
                            "longitude": "117.607418",
                            "latitude": "26.234191"
                        },
                        {
                            "area_id": 22370,
                            "city_id": 21630,
                            "province_id": 15,
                            "name": "沙县",
                            "whole_name": "沙县，三明市，福建省",
                            "simple_py": "SX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0598",
                            "area_code": "350427",
                            "longitude": "117.789095",
                            "latitude": "26.397361"
                        },
                        {
                            "area_id": 22364,
                            "city_id": 21630,
                            "province_id": 15,
                            "name": "泰宁县",
                            "whole_name": "泰宁县，三明市，福建省",
                            "simple_py": "TNX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0598",
                            "area_code": "350429",
                            "longitude": "117.177522",
                            "latitude": "26.897995"
                        },
                        {
                            "area_id": 22367,
                            "city_id": 21630,
                            "province_id": 15,
                            "name": "永安市",
                            "whole_name": "永安市，三明市，福建省",
                            "simple_py": "YAS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0598",
                            "area_code": "350481",
                            "longitude": "117.364447",
                            "latitude": "25.974075"
                        },
                        {
                            "area_id": 22372,
                            "city_id": 21630,
                            "province_id": 15,
                            "name": "尤溪县",
                            "whole_name": "尤溪县，三明市，福建省",
                            "simple_py": "YXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0598",
                            "area_code": "350426",
                            "longitude": "118.188577",
                            "latitude": "26.169261"
                        }
                    ]
                },
                {
                    "city_id": 21631,
                    "province_id": 15,
                    "name": "厦门市",
                    "whole_name": "厦门市，福建省",
                    "simple_py": "XMS",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "0592",
                    "area_code": "350200",
                    "longitude": "118.11022",
                    "latitude": "24.490474",
                    "children": [
                        {
                            "area_id": 22525,
                            "city_id": 21631,
                            "province_id": 15,
                            "name": "海沧区",
                            "whole_name": "海沧区，厦门市，福建省",
                            "simple_py": "HCQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0592",
                            "area_code": "350205",
                            "longitude": "118.036364",
                            "latitude": "24.492512"
                        },
                        {
                            "area_id": 22527,
                            "city_id": 21631,
                            "province_id": 15,
                            "name": "湖里区",
                            "whole_name": "湖里区，厦门市，福建省",
                            "simple_py": "HLQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0592",
                            "area_code": "350206",
                            "longitude": "118.10943",
                            "latitude": "24.512764"
                        },
                        {
                            "area_id": 22526,
                            "city_id": 21631,
                            "province_id": 15,
                            "name": "集美区",
                            "whole_name": "集美区，厦门市，福建省",
                            "simple_py": "JMQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0592",
                            "area_code": "350211",
                            "longitude": "118.100869",
                            "latitude": "24.572874"
                        },
                        {
                            "area_id": 22528,
                            "city_id": 21631,
                            "province_id": 15,
                            "name": "思明区",
                            "whole_name": "思明区，厦门市，福建省",
                            "simple_py": "SMQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0592",
                            "area_code": "350203",
                            "longitude": "118.087828",
                            "latitude": "24.462059"
                        },
                        {
                            "area_id": 22524,
                            "city_id": 21631,
                            "province_id": 15,
                            "name": "同安区",
                            "whole_name": "同安区，厦门市，福建省",
                            "simple_py": "TAQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0592",
                            "area_code": "350212",
                            "longitude": "118.150455",
                            "latitude": "24.729333"
                        },
                        {
                            "area_id": 22529,
                            "city_id": 21631,
                            "province_id": 15,
                            "name": "翔安区",
                            "whole_name": "翔安区，厦门市，福建省",
                            "simple_py": "XAQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0592",
                            "area_code": "350213",
                            "longitude": "118.242811",
                            "latitude": "24.637479"
                        }
                    ]
                },
                {
                    "city_id": 21632,
                    "province_id": 15,
                    "name": "漳州市",
                    "whole_name": "漳州市，福建省",
                    "simple_py": "ZZS",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "0596",
                    "area_code": "350600",
                    "longitude": "117.661801",
                    "latitude": "24.510897",
                    "children": [
                        {
                            "area_id": 22583,
                            "city_id": 21632,
                            "province_id": 15,
                            "name": "长泰县",
                            "whole_name": "长泰县，漳州市，福建省",
                            "simple_py": "CTX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0596",
                            "area_code": "350625",
                            "longitude": "117.755913",
                            "latitude": "24.621475"
                        },
                        {
                            "area_id": 22589,
                            "city_id": 21632,
                            "province_id": 15,
                            "name": "东山县",
                            "whole_name": "东山县，漳州市，福建省",
                            "simple_py": "DSX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0596",
                            "area_code": "350626",
                            "longitude": "117.427679",
                            "latitude": "23.702845"
                        },
                        {
                            "area_id": 22581,
                            "city_id": 21632,
                            "province_id": 15,
                            "name": "华安县",
                            "whole_name": "华安县，漳州市，福建省",
                            "simple_py": "HAX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0596",
                            "area_code": "350629",
                            "longitude": "117.53631",
                            "latitude": "25.001416"
                        },
                        {
                            "area_id": 22588,
                            "city_id": 21632,
                            "province_id": 15,
                            "name": "龙海市",
                            "whole_name": "龙海市，漳州市，福建省",
                            "simple_py": "LHS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0596",
                            "area_code": "350681",
                            "longitude": "117.817292",
                            "latitude": "24.445341"
                        },
                        {
                            "area_id": 22590,
                            "city_id": 21632,
                            "province_id": 15,
                            "name": "龙文区",
                            "whole_name": "龙文区，漳州市，福建省",
                            "simple_py": "LWQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0596",
                            "area_code": "350603",
                            "longitude": "117.671387",
                            "latitude": "24.515656"
                        },
                        {
                            "area_id": 22582,
                            "city_id": 21632,
                            "province_id": 15,
                            "name": "南靖县",
                            "whole_name": "南靖县，漳州市，福建省",
                            "simple_py": "NJX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0596",
                            "area_code": "350627",
                            "longitude": "117.365462",
                            "latitude": "24.516425"
                        },
                        {
                            "area_id": 22585,
                            "city_id": 21632,
                            "province_id": 15,
                            "name": "平和县",
                            "whole_name": "平和县，漳州市，福建省",
                            "simple_py": "PHX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0596",
                            "area_code": "350628",
                            "longitude": "117.313549",
                            "latitude": "24.366158"
                        },
                        {
                            "area_id": 22591,
                            "city_id": 21632,
                            "province_id": 15,
                            "name": "芗城区",
                            "whole_name": "芗城区，漳州市，福建省",
                            "simple_py": "XCQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0596",
                            "area_code": "350602",
                            "longitude": "117.656461",
                            "latitude": "24.509955"
                        },
                        {
                            "area_id": 22584,
                            "city_id": 21632,
                            "province_id": 15,
                            "name": "云霄县",
                            "whole_name": "云霄县，漳州市，福建省",
                            "simple_py": "YXX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0596",
                            "area_code": "350622",
                            "longitude": "117.340946",
                            "latitude": "23.950486"
                        },
                        {
                            "area_id": 22586,
                            "city_id": 21632,
                            "province_id": 15,
                            "name": "诏安县",
                            "whole_name": "诏安县，漳州市，福建省",
                            "simple_py": "ZAX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0596",
                            "area_code": "350624",
                            "longitude": "117.176083",
                            "latitude": "23.710834"
                        },
                        {
                            "area_id": 22587,
                            "city_id": 21632,
                            "province_id": 15,
                            "name": "漳浦县",
                            "whole_name": "漳浦县，漳州市，福建省",
                            "simple_py": "ZPX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0596",
                            "area_code": "350623",
                            "longitude": "117.614023",
                            "latitude": "24.117907"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 1,
            "name": "广东省",
            "whole_name": "广东省",
            "simple_py": "GDS",
            "per_pin_yin": "G",
            "per_pin_yin2": "G",
            "city_code": "",
            "area_code": "440000",
            "longitude": "113.280637",
            "latitude": "23.125178",
            "children": [
                {
                    "city_id": 46,
                    "province_id": 1,
                    "name": "潮州市",
                    "whole_name": "潮州市，广东省",
                    "simple_py": "CZS",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0768",
                    "area_code": "445100",
                    "longitude": "116.632301",
                    "latitude": "23.661701",
                    "children": [
                        {
                            "area_id": 994,
                            "city_id": 46,
                            "province_id": 1,
                            "name": "潮安区",
                            "whole_name": "潮安区，潮州市，广东省",
                            "simple_py": "CAQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0768",
                            "area_code": "445103",
                            "longitude": "116.67931",
                            "latitude": "23.461012"
                        },
                        {
                            "area_id": 992,
                            "city_id": 46,
                            "province_id": 1,
                            "name": "饶平县",
                            "whole_name": "饶平县，潮州市，广东省",
                            "simple_py": "RPX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0768",
                            "area_code": "445122",
                            "longitude": "117.00205",
                            "latitude": "23.668171"
                        },
                        {
                            "area_id": 993,
                            "city_id": 46,
                            "province_id": 1,
                            "name": "湘桥区",
                            "whole_name": "湘桥区，潮州市，广东省",
                            "simple_py": "XQQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0768",
                            "area_code": "445102",
                            "longitude": "116.63365",
                            "latitude": "23.664675"
                        }
                    ]
                },
                {
                    "city_id": 51,
                    "province_id": 1,
                    "name": "东莞市",
                    "whole_name": "东莞市，广东省",
                    "simple_py": "DGS",
                    "per_pin_yin": "D",
                    "per_pin_yin2": "D",
                    "city_code": "0769",
                    "area_code": "441900",
                    "longitude": "113.746262",
                    "latitude": "23.046237",
                    "children": [
                        {
                            "area_id": 1508,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "常平镇",
                            "whole_name": "常平镇，东莞市，广东省",
                            "simple_py": "CPZ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "114.036",
                            "latitude": "23.0074"
                        },
                        {
                            "area_id": 1535,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "长安镇",
                            "whole_name": "长安镇，东莞市，广东省",
                            "simple_py": "CAZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.77",
                            "latitude": "22.8195"
                        },
                        {
                            "area_id": 1539,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "茶山镇",
                            "whole_name": "茶山镇，东莞市，广东省",
                            "simple_py": "CSZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.839",
                            "latitude": "23.0813"
                        },
                        {
                            "area_id": 1511,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "大朗镇",
                            "whole_name": "大朗镇，东莞市，广东省",
                            "simple_py": "DLZ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.939",
                            "latitude": "22.8654"
                        },
                        {
                            "area_id": 1516,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "东莞生态园",
                            "whole_name": "东莞生态园，东莞市，广东省",
                            "simple_py": "DGSTY",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.917",
                            "latitude": "23.0806"
                        },
                        {
                            "area_id": 1530,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "东坑镇",
                            "whole_name": "东坑镇，东莞市，广东省",
                            "simple_py": "DKZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.918",
                            "latitude": "22.995"
                        },
                        {
                            "area_id": 1531,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "东城街道",
                            "whole_name": "东城街道，东莞市，广东省",
                            "simple_py": "DCJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.757",
                            "latitude": "23.0485"
                        },
                        {
                            "area_id": 1536,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "道滘镇",
                            "whole_name": "道滘镇，东莞市，广东省",
                            "simple_py": "DJZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.692",
                            "latitude": "23.004"
                        },
                        {
                            "area_id": 1537,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "大岭山镇",
                            "whole_name": "大岭山镇，东莞市，广东省",
                            "simple_py": "DLSZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.843",
                            "latitude": "22.9534"
                        },
                        {
                            "area_id": 1514,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "凤岗镇",
                            "whole_name": "凤岗镇，东莞市，广东省",
                            "simple_py": "FGZ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "114.105",
                            "latitude": "22.7308"
                        },
                        {
                            "area_id": 1521,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "高埗镇",
                            "whole_name": "高埗镇，东莞市，广东省",
                            "simple_py": "GBZ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.773",
                            "latitude": "23.112"
                        },
                        {
                            "area_id": 1513,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "黄江镇",
                            "whole_name": "黄江镇，东莞市，广东省",
                            "simple_py": "HJZ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.973",
                            "latitude": "22.8121"
                        },
                        {
                            "area_id": 1523,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "厚街镇",
                            "whole_name": "厚街镇，东莞市，广东省",
                            "simple_py": "HJZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.776",
                            "latitude": "22.9097"
                        },
                        {
                            "area_id": 1525,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "虎门镇",
                            "whole_name": "虎门镇，东莞市，广东省",
                            "simple_py": "HMZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.797",
                            "latitude": "22.8587"
                        },
                        {
                            "area_id": 1527,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "虎门港管委会",
                            "whole_name": "虎门港管委会，东莞市，广东省",
                            "simple_py": "HMGGWH",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.562",
                            "latitude": "22.9718"
                        },
                        {
                            "area_id": 1528,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "横沥镇",
                            "whole_name": "横沥镇，东莞市，广东省",
                            "simple_py": "HLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "114.006",
                            "latitude": "23.0504"
                        },
                        {
                            "area_id": 1533,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "洪梅镇",
                            "whole_name": "洪梅镇，东莞市，广东省",
                            "simple_py": "HMZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.607",
                            "latitude": "23.0155"
                        },
                        {
                            "area_id": 1520,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "寮步镇",
                            "whole_name": "寮步镇，东莞市，广东省",
                            "simple_py": "LBZ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.888",
                            "latitude": "22.9529"
                        },
                        {
                            "area_id": 1512,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "麻涌镇",
                            "whole_name": "麻涌镇，东莞市，广东省",
                            "simple_py": "MYZ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.562",
                            "latitude": "22.9718"
                        },
                        {
                            "area_id": 1526,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "南城街道",
                            "whole_name": "南城街道，东莞市，广东省",
                            "simple_py": "NCJD",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.737",
                            "latitude": "23.0249"
                        },
                        {
                            "area_id": 1518,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "桥头镇",
                            "whole_name": "桥头镇，东莞市，广东省",
                            "simple_py": "QTZ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "114.065",
                            "latitude": "23.0315"
                        },
                        {
                            "area_id": 1529,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "企石镇",
                            "whole_name": "企石镇，东莞市，广东省",
                            "simple_py": "QSZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.99",
                            "latitude": "23.0541"
                        },
                        {
                            "area_id": 1538,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "清溪镇",
                            "whole_name": "清溪镇，东莞市，广东省",
                            "simple_py": "QXZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "114.11",
                            "latitude": "22.862"
                        },
                        {
                            "area_id": 1517,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "松山湖管委会",
                            "whole_name": "松山湖管委会，东莞市，广东省",
                            "simple_py": "SSHGWH",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.875",
                            "latitude": "22.869"
                        },
                        {
                            "area_id": 1519,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "石龙镇",
                            "whole_name": "石龙镇，东莞市，广东省",
                            "simple_py": "SLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.833",
                            "latitude": "23.1123"
                        },
                        {
                            "area_id": 1532,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "石排镇",
                            "whole_name": "石排镇，东莞市，广东省",
                            "simple_py": "SPZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.988",
                            "latitude": "23.068"
                        },
                        {
                            "area_id": 1534,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "沙田镇",
                            "whole_name": "沙田镇，东莞市，广东省",
                            "simple_py": "STZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.582",
                            "latitude": "22.9426"
                        },
                        {
                            "area_id": 1542,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "石碣镇",
                            "whole_name": "石碣镇，东莞市，广东省",
                            "simple_py": "SJZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.846",
                            "latitude": "23.1024"
                        },
                        {
                            "area_id": 1522,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "塘厦镇",
                            "whole_name": "塘厦镇，东莞市，广东省",
                            "simple_py": "TSZ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "114.05",
                            "latitude": "22.7713"
                        },
                        {
                            "area_id": 1509,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "莞城街道",
                            "whole_name": "莞城街道，东莞市，广东省",
                            "simple_py": "WCJD",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.743",
                            "latitude": "23.0225"
                        },
                        {
                            "area_id": 1510,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "望牛墩镇",
                            "whole_name": "望牛墩镇，东莞市，广东省",
                            "simple_py": "WNDZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.676",
                            "latitude": "23.0683"
                        },
                        {
                            "area_id": 1541,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "万江街道",
                            "whole_name": "万江街道，东莞市，广东省",
                            "simple_py": "WJJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.709",
                            "latitude": "23.0014"
                        },
                        {
                            "area_id": 1524,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "谢岗镇",
                            "whole_name": "谢岗镇，东莞市，广东省",
                            "simple_py": "XGZ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "114.128",
                            "latitude": "22.9901"
                        },
                        {
                            "area_id": 1515,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "樟木头镇",
                            "whole_name": "樟木头镇，东莞市，广东省",
                            "simple_py": "ZMTZ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "114.018",
                            "latitude": "22.8704"
                        },
                        {
                            "area_id": 1540,
                            "city_id": 51,
                            "province_id": 1,
                            "name": "中堂镇",
                            "whole_name": "中堂镇，东莞市，广东省",
                            "simple_py": "ZTZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0769",
                            "area_code": "441900",
                            "longitude": "113.734",
                            "latitude": "23.1164"
                        }
                    ]
                },
                {
                    "city_id": 56,
                    "province_id": 1,
                    "name": "东沙群岛",
                    "whole_name": "东沙群岛，广东省",
                    "simple_py": "DSQD",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "D",
                    "city_code": "",
                    "area_code": "442100",
                    "longitude": "116.887312",
                    "latitude": "20.617512",
                    "children": []
                },
                {
                    "city_id": 36,
                    "province_id": 1,
                    "name": "佛山市",
                    "whole_name": "佛山市，广东省",
                    "simple_py": "FSS",
                    "per_pin_yin": "F",
                    "per_pin_yin2": "F",
                    "city_code": "0757",
                    "area_code": "440600",
                    "longitude": "113.122717",
                    "latitude": "23.028762",
                    "children": [
                        {
                            "area_id": 136,
                            "city_id": 36,
                            "province_id": 1,
                            "name": "禅城区",
                            "whole_name": "禅城区，佛山市，广东省",
                            "simple_py": "CCQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0757",
                            "area_code": "440604",
                            "longitude": "113.112414",
                            "latitude": "23.019643"
                        },
                        {
                            "area_id": 134,
                            "city_id": 36,
                            "province_id": 1,
                            "name": "高明区",
                            "whole_name": "高明区，佛山市，广东省",
                            "simple_py": "GMQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0757",
                            "area_code": "440608",
                            "longitude": "112.882123",
                            "latitude": "22.893855"
                        },
                        {
                            "area_id": 137,
                            "city_id": 36,
                            "province_id": 1,
                            "name": "南海区",
                            "whole_name": "南海区，佛山市，广东省",
                            "simple_py": "NHQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0757",
                            "area_code": "440605",
                            "longitude": "113.145577",
                            "latitude": "23.031562"
                        },
                        {
                            "area_id": 133,
                            "city_id": 36,
                            "province_id": 1,
                            "name": "三水区",
                            "whole_name": "三水区，佛山市，广东省",
                            "simple_py": "SSQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0757",
                            "area_code": "440607",
                            "longitude": "112.899414",
                            "latitude": "23.16504"
                        },
                        {
                            "area_id": 135,
                            "city_id": 36,
                            "province_id": 1,
                            "name": "顺德区",
                            "whole_name": "顺德区，佛山市，广东省",
                            "simple_py": "SDQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0757",
                            "area_code": "440606",
                            "longitude": "113.281826",
                            "latitude": "22.75851"
                        }
                    ]
                },
                {
                    "city_id": 54,
                    "province_id": 1,
                    "name": "广州市",
                    "whole_name": "广州市，广东省",
                    "simple_py": "GZS",
                    "per_pin_yin": "G",
                    "per_pin_yin2": "G",
                    "city_code": "020",
                    "area_code": "440100",
                    "longitude": "113.280637",
                    "latitude": "23.125178",
                    "children": [
                        {
                            "area_id": 1739,
                            "city_id": 54,
                            "province_id": 1,
                            "name": "白云区",
                            "whole_name": "白云区，广州市，广东省",
                            "simple_py": "BYQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "020",
                            "area_code": "440111",
                            "longitude": "113.262831",
                            "latitude": "23.162281"
                        },
                        {
                            "area_id": 1734,
                            "city_id": 54,
                            "province_id": 1,
                            "name": "从化区",
                            "whole_name": "从化区，广州市，广东省",
                            "simple_py": "CHQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "020",
                            "area_code": "440117",
                            "longitude": "113.587386",
                            "latitude": "23.545283"
                        },
                        {
                            "area_id": 1744,
                            "city_id": 54,
                            "province_id": 1,
                            "name": "番禺区",
                            "whole_name": "番禺区，广州市，广东省",
                            "simple_py": "FYQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "020",
                            "area_code": "440113",
                            "longitude": "113.364619",
                            "latitude": "22.938582"
                        },
                        {
                            "area_id": 1737,
                            "city_id": 54,
                            "province_id": 1,
                            "name": "花都区",
                            "whole_name": "花都区，广州市，广东省",
                            "simple_py": "HDQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "020",
                            "area_code": "440114",
                            "longitude": "113.211184",
                            "latitude": "23.39205"
                        },
                        {
                            "area_id": 1738,
                            "city_id": 54,
                            "province_id": 1,
                            "name": "黄埔区",
                            "whole_name": "黄埔区，广州市，广东省",
                            "simple_py": "HPQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "020",
                            "area_code": "440112",
                            "longitude": "113.450761",
                            "latitude": "23.103239"
                        },
                        {
                            "area_id": 1741,
                            "city_id": 54,
                            "province_id": 1,
                            "name": "海珠区",
                            "whole_name": "海珠区，广州市，广东省",
                            "simple_py": "HZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "020",
                            "area_code": "440105",
                            "longitude": "113.262008",
                            "latitude": "23.103131"
                        },
                        {
                            "area_id": 1742,
                            "city_id": 54,
                            "province_id": 1,
                            "name": "荔湾区",
                            "whole_name": "荔湾区，广州市，广东省",
                            "simple_py": "LWQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "020",
                            "area_code": "440103",
                            "longitude": "113.243038",
                            "latitude": "23.124943"
                        },
                        {
                            "area_id": 1736,
                            "city_id": 54,
                            "province_id": 1,
                            "name": "南沙区",
                            "whole_name": "南沙区，广州市，广东省",
                            "simple_py": "NSQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "020",
                            "area_code": "440115",
                            "longitude": "113.53738",
                            "latitude": "22.794531"
                        },
                        {
                            "area_id": 1740,
                            "city_id": 54,
                            "province_id": 1,
                            "name": "天河区",
                            "whole_name": "天河区，广州市，广东省",
                            "simple_py": "THQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "020",
                            "area_code": "440106",
                            "longitude": "113.335367",
                            "latitude": "23.13559"
                        },
                        {
                            "area_id": 1743,
                            "city_id": 54,
                            "province_id": 1,
                            "name": "越秀区",
                            "whole_name": "越秀区，广州市，广东省",
                            "simple_py": "YXQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "020",
                            "area_code": "440104",
                            "longitude": "113.280714",
                            "latitude": "23.125624"
                        },
                        {
                            "area_id": 1735,
                            "city_id": 54,
                            "province_id": 1,
                            "name": "增城区",
                            "whole_name": "增城区，广州市，广东省",
                            "simple_py": "ZCQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "020",
                            "area_code": "440118",
                            "longitude": "113.829579",
                            "latitude": "23.290497"
                        }
                    ]
                },
                {
                    "city_id": 40,
                    "province_id": 1,
                    "name": "惠州市",
                    "whole_name": "惠州市，广东省",
                    "simple_py": "HZS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0752",
                    "area_code": "441300",
                    "longitude": "114.412599",
                    "latitude": "23.079404",
                    "children": [
                        {
                            "area_id": 449,
                            "city_id": 40,
                            "province_id": 1,
                            "name": "博罗县",
                            "whole_name": "博罗县，惠州市，广东省",
                            "simple_py": "BLX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0752",
                            "area_code": "441322",
                            "longitude": "114.284254",
                            "latitude": "23.167575"
                        },
                        {
                            "area_id": 450,
                            "city_id": 40,
                            "province_id": 1,
                            "name": "惠东县",
                            "whole_name": "惠东县，惠州市，广东省",
                            "simple_py": "HDX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0752",
                            "area_code": "441323",
                            "longitude": "114.723092",
                            "latitude": "22.983036"
                        },
                        {
                            "area_id": 451,
                            "city_id": 40,
                            "province_id": 1,
                            "name": "惠阳区",
                            "whole_name": "惠阳区，惠州市，广东省",
                            "simple_py": "HYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0752",
                            "area_code": "441303",
                            "longitude": "114.469444",
                            "latitude": "22.78851"
                        },
                        {
                            "area_id": 452,
                            "city_id": 40,
                            "province_id": 1,
                            "name": "惠城区",
                            "whole_name": "惠城区，惠州市，广东省",
                            "simple_py": "HCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0752",
                            "area_code": "441302",
                            "longitude": "114.413978",
                            "latitude": "23.079883"
                        },
                        {
                            "area_id": 448,
                            "city_id": 40,
                            "province_id": 1,
                            "name": "龙门县",
                            "whole_name": "龙门县，惠州市，广东省",
                            "simple_py": "LMX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0752",
                            "area_code": "441324",
                            "longitude": "114.259986",
                            "latitude": "23.723894"
                        }
                    ]
                },
                {
                    "city_id": 49,
                    "province_id": 1,
                    "name": "河源市",
                    "whole_name": "河源市，广东省",
                    "simple_py": "HYS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0762",
                    "area_code": "441600",
                    "longitude": "114.697802",
                    "latitude": "23.746266",
                    "children": [
                        {
                            "area_id": 1307,
                            "city_id": 49,
                            "province_id": 1,
                            "name": "东源县",
                            "whole_name": "东源县，河源市，广东省",
                            "simple_py": "DYX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0762",
                            "area_code": "441625",
                            "longitude": "114.742711",
                            "latitude": "23.789093"
                        },
                        {
                            "area_id": 1305,
                            "city_id": 49,
                            "province_id": 1,
                            "name": "和平县",
                            "whole_name": "和平县，河源市，广东省",
                            "simple_py": "HPX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0762",
                            "area_code": "441624",
                            "longitude": "114.941473",
                            "latitude": "24.44318"
                        },
                        {
                            "area_id": 1304,
                            "city_id": 49,
                            "province_id": 1,
                            "name": "龙川县",
                            "whole_name": "龙川县，河源市，广东省",
                            "simple_py": "LCX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0762",
                            "area_code": "441622",
                            "longitude": "115.256415",
                            "latitude": "24.101174"
                        },
                        {
                            "area_id": 1306,
                            "city_id": 49,
                            "province_id": 1,
                            "name": "连平县",
                            "whole_name": "连平县，河源市，广东省",
                            "simple_py": "LPX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0762",
                            "area_code": "441623",
                            "longitude": "114.495952",
                            "latitude": "24.364227"
                        },
                        {
                            "area_id": 1308,
                            "city_id": 49,
                            "province_id": 1,
                            "name": "源城区",
                            "whole_name": "源城区，河源市，广东省",
                            "simple_py": "YCQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0762",
                            "area_code": "441602",
                            "longitude": "114.696828",
                            "latitude": "23.746255"
                        },
                        {
                            "area_id": 1309,
                            "city_id": 49,
                            "province_id": 1,
                            "name": "紫金县",
                            "whole_name": "紫金县，河源市，广东省",
                            "simple_py": "ZJX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0762",
                            "area_code": "441621",
                            "longitude": "115.184383",
                            "latitude": "23.633744"
                        }
                    ]
                },
                {
                    "city_id": 38,
                    "province_id": 1,
                    "name": "江门市",
                    "whole_name": "江门市，广东省",
                    "simple_py": "JMS",
                    "per_pin_yin": "J",
                    "per_pin_yin2": "J",
                    "city_code": "0750",
                    "area_code": "440700",
                    "longitude": "113.094942",
                    "latitude": "22.590431",
                    "children": [
                        {
                            "area_id": 219,
                            "city_id": 38,
                            "province_id": 1,
                            "name": "恩平市",
                            "whole_name": "恩平市，江门市，广东省",
                            "simple_py": "EPS",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0750",
                            "area_code": "440785",
                            "longitude": "112.314051",
                            "latitude": "22.182956"
                        },
                        {
                            "area_id": 215,
                            "city_id": 38,
                            "province_id": 1,
                            "name": "鹤山市",
                            "whole_name": "鹤山市，江门市，广东省",
                            "simple_py": "HSS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0750",
                            "area_code": "440784",
                            "longitude": "112.961795",
                            "latitude": "22.768104"
                        },
                        {
                            "area_id": 216,
                            "city_id": 38,
                            "province_id": 1,
                            "name": "江海区",
                            "whole_name": "江海区，江门市，广东省",
                            "simple_py": "JHQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0750",
                            "area_code": "440704",
                            "longitude": "113.120601",
                            "latitude": "22.572211"
                        },
                        {
                            "area_id": 217,
                            "city_id": 38,
                            "province_id": 1,
                            "name": "开平市",
                            "whole_name": "开平市，江门市，广东省",
                            "simple_py": "KPS",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0750",
                            "area_code": "440783",
                            "longitude": "112.692262",
                            "latitude": "22.366286"
                        },
                        {
                            "area_id": 221,
                            "city_id": 38,
                            "province_id": 1,
                            "name": "蓬江区",
                            "whole_name": "蓬江区，江门市，广东省",
                            "simple_py": "PJQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0750",
                            "area_code": "440703",
                            "longitude": "113.07859",
                            "latitude": "22.59677"
                        },
                        {
                            "area_id": 218,
                            "city_id": 38,
                            "province_id": 1,
                            "name": "台山市",
                            "whole_name": "台山市，江门市，广东省",
                            "simple_py": "TSS",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0750",
                            "area_code": "440781",
                            "longitude": "112.793414",
                            "latitude": "22.250713"
                        },
                        {
                            "area_id": 220,
                            "city_id": 38,
                            "province_id": 1,
                            "name": "新会区",
                            "whole_name": "新会区，江门市，广东省",
                            "simple_py": "XHQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0750",
                            "area_code": "440705",
                            "longitude": "113.038584",
                            "latitude": "22.520247"
                        }
                    ]
                },
                {
                    "city_id": 53,
                    "province_id": 1,
                    "name": "揭阳市",
                    "whole_name": "揭阳市，广东省",
                    "simple_py": "JYS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "J",
                    "city_code": "0663",
                    "area_code": "445200",
                    "longitude": "116.355733",
                    "latitude": "23.543778",
                    "children": [
                        {
                            "area_id": 1622,
                            "city_id": 53,
                            "province_id": 1,
                            "name": "惠来县",
                            "whole_name": "惠来县，揭阳市，广东省",
                            "simple_py": "HLX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0663",
                            "area_code": "445224",
                            "longitude": "116.295832",
                            "latitude": "23.029834"
                        },
                        {
                            "area_id": 1620,
                            "city_id": 53,
                            "province_id": 1,
                            "name": "揭西县",
                            "whole_name": "揭西县，揭阳市，广东省",
                            "simple_py": "JXX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0663",
                            "area_code": "445222",
                            "longitude": "115.838708",
                            "latitude": "23.4273"
                        },
                        {
                            "area_id": 1623,
                            "city_id": 53,
                            "province_id": 1,
                            "name": "揭东区",
                            "whole_name": "揭东区，揭阳市，广东省",
                            "simple_py": "JDQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0663",
                            "area_code": "445203",
                            "longitude": "116.412947",
                            "latitude": "23.569887"
                        },
                        {
                            "area_id": 1621,
                            "city_id": 53,
                            "province_id": 1,
                            "name": "普宁市",
                            "whole_name": "普宁市，揭阳市，广东省",
                            "simple_py": "PNS",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0663",
                            "area_code": "445281",
                            "longitude": "116.165082",
                            "latitude": "23.29788"
                        },
                        {
                            "area_id": 1624,
                            "city_id": 53,
                            "province_id": 1,
                            "name": "榕城区",
                            "whole_name": "榕城区，揭阳市，广东省",
                            "simple_py": "RCQ",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0663",
                            "area_code": "445202",
                            "longitude": "116.357045",
                            "latitude": "23.535524"
                        }
                    ]
                },
                {
                    "city_id": 43,
                    "province_id": 1,
                    "name": "茂名市",
                    "whole_name": "茂名市，广东省",
                    "simple_py": "MMS",
                    "per_pin_yin": "M",
                    "per_pin_yin2": "M",
                    "city_code": "0668",
                    "area_code": "440900",
                    "longitude": "110.919229",
                    "latitude": "21.659751",
                    "children": [
                        {
                            "area_id": 721,
                            "city_id": 43,
                            "province_id": 1,
                            "name": "电白区",
                            "whole_name": "电白区，茂名市，广东省",
                            "simple_py": "DBQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0668",
                            "area_code": "440904",
                            "longitude": "111.007264",
                            "latitude": "21.507219"
                        },
                        {
                            "area_id": 720,
                            "city_id": 43,
                            "province_id": 1,
                            "name": "高州市",
                            "whole_name": "高州市，茂名市，广东省",
                            "simple_py": "GZS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0668",
                            "area_code": "440981",
                            "longitude": "110.853251",
                            "latitude": "21.915153"
                        },
                        {
                            "area_id": 719,
                            "city_id": 43,
                            "province_id": 1,
                            "name": "化州市",
                            "whole_name": "化州市，茂名市，广东省",
                            "simple_py": "HZS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0668",
                            "area_code": "440982",
                            "longitude": "110.63839",
                            "latitude": "21.654953"
                        },
                        {
                            "area_id": 722,
                            "city_id": 43,
                            "province_id": 1,
                            "name": "茂南区",
                            "whole_name": "茂南区，茂名市，广东省",
                            "simple_py": "MNQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0668",
                            "area_code": "440902",
                            "longitude": "110.920542",
                            "latitude": "21.660425"
                        },
                        {
                            "area_id": 718,
                            "city_id": 43,
                            "province_id": 1,
                            "name": "信宜市",
                            "whole_name": "信宜市，茂名市，广东省",
                            "simple_py": "XYS",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0668",
                            "area_code": "440983",
                            "longitude": "110.941656",
                            "latitude": "22.352681"
                        }
                    ]
                },
                {
                    "city_id": 48,
                    "province_id": 1,
                    "name": "梅州市",
                    "whole_name": "梅州市，广东省",
                    "simple_py": "MZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "M",
                    "city_code": "0753",
                    "area_code": "441400",
                    "longitude": "116.117582",
                    "latitude": "24.299112",
                    "children": [
                        {
                            "area_id": 1184,
                            "city_id": 48,
                            "province_id": 1,
                            "name": "大埔县",
                            "whole_name": "大埔县，梅州市，广东省",
                            "simple_py": "DBX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0753",
                            "area_code": "441422",
                            "longitude": "116.69552",
                            "latitude": "24.351587"
                        },
                        {
                            "area_id": 1183,
                            "city_id": 48,
                            "province_id": 1,
                            "name": "丰顺县",
                            "whole_name": "丰顺县，梅州市，广东省",
                            "simple_py": "FSX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0753",
                            "area_code": "441423",
                            "longitude": "116.184419",
                            "latitude": "23.752771"
                        },
                        {
                            "area_id": 1179,
                            "city_id": 48,
                            "province_id": 1,
                            "name": "蕉岭县",
                            "whole_name": "蕉岭县，梅州市，广东省",
                            "simple_py": "JLX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0753",
                            "area_code": "441427",
                            "longitude": "116.170531",
                            "latitude": "24.653313"
                        },
                        {
                            "area_id": 1182,
                            "city_id": 48,
                            "province_id": 1,
                            "name": "梅县区",
                            "whole_name": "梅县区，梅州市，广东省",
                            "simple_py": "MXQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0753",
                            "area_code": "441403",
                            "longitude": "116.083482",
                            "latitude": "24.267825"
                        },
                        {
                            "area_id": 1185,
                            "city_id": 48,
                            "province_id": 1,
                            "name": "梅江区",
                            "whole_name": "梅江区，梅州市，广东省",
                            "simple_py": "MJQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0753",
                            "area_code": "441402",
                            "longitude": "116.12116",
                            "latitude": "24.302593"
                        },
                        {
                            "area_id": 1178,
                            "city_id": 48,
                            "province_id": 1,
                            "name": "平远县",
                            "whole_name": "平远县，梅州市，广东省",
                            "simple_py": "PYX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0753",
                            "area_code": "441426",
                            "longitude": "115.891729",
                            "latitude": "24.569651"
                        },
                        {
                            "area_id": 1181,
                            "city_id": 48,
                            "province_id": 1,
                            "name": "五华县",
                            "whole_name": "五华县，梅州市，广东省",
                            "simple_py": "WHX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0753",
                            "area_code": "441424",
                            "longitude": "115.775004",
                            "latitude": "23.925424"
                        },
                        {
                            "area_id": 1180,
                            "city_id": 48,
                            "province_id": 1,
                            "name": "兴宁市",
                            "whole_name": "兴宁市，梅州市，广东省",
                            "simple_py": "XNS",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0753",
                            "area_code": "441481",
                            "longitude": "115.731648",
                            "latitude": "24.138077"
                        }
                    ]
                },
                {
                    "city_id": 50,
                    "province_id": 1,
                    "name": "清远市",
                    "whole_name": "清远市，广东省",
                    "simple_py": "QYS",
                    "per_pin_yin": "Q",
                    "per_pin_yin2": "Q",
                    "city_code": "0763",
                    "area_code": "441800",
                    "longitude": "113.051227",
                    "latitude": "23.685022",
                    "children": [
                        {
                            "area_id": 1414,
                            "city_id": 50,
                            "province_id": 1,
                            "name": "佛冈县",
                            "whole_name": "佛冈县，清远市，广东省",
                            "simple_py": "FGX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0763",
                            "area_code": "441821",
                            "longitude": "113.534094",
                            "latitude": "23.866739"
                        },
                        {
                            "area_id": 1410,
                            "city_id": 50,
                            "province_id": 1,
                            "name": "连南瑶族自治县",
                            "whole_name": "连南瑶族自治县，清远市，广东省",
                            "simple_py": "LNYZZZX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0763",
                            "area_code": "441826",
                            "longitude": "112.290808",
                            "latitude": "24.719097"
                        },
                        {
                            "area_id": 1411,
                            "city_id": 50,
                            "province_id": 1,
                            "name": "连州市",
                            "whole_name": "连州市，清远市，广东省",
                            "simple_py": "LZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0763",
                            "area_code": "441882",
                            "longitude": "112.379271",
                            "latitude": "24.783966"
                        },
                        {
                            "area_id": 1412,
                            "city_id": 50,
                            "province_id": 1,
                            "name": "连山壮族瑶族自治县",
                            "whole_name": "连山壮族瑶族自治县，清远市，广东省",
                            "simple_py": "LSZZYZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0763",
                            "area_code": "441825",
                            "longitude": "112.086555",
                            "latitude": "24.567271"
                        },
                        {
                            "area_id": 1416,
                            "city_id": 50,
                            "province_id": 1,
                            "name": "清新区",
                            "whole_name": "清新区，清远市，广东省",
                            "simple_py": "QXQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0763",
                            "area_code": "441803",
                            "longitude": "113.015203",
                            "latitude": "23.736949"
                        },
                        {
                            "area_id": 1417,
                            "city_id": 50,
                            "province_id": 1,
                            "name": "清城区",
                            "whole_name": "清城区，清远市，广东省",
                            "simple_py": "QCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0763",
                            "area_code": "441802",
                            "longitude": "113.048698",
                            "latitude": "23.688976"
                        },
                        {
                            "area_id": 1413,
                            "city_id": 50,
                            "province_id": 1,
                            "name": "英德市",
                            "whole_name": "英德市，清远市，广东省",
                            "simple_py": "YDS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0763",
                            "area_code": "441881",
                            "longitude": "113.405404",
                            "latitude": "24.18612"
                        },
                        {
                            "area_id": 1415,
                            "city_id": 50,
                            "province_id": 1,
                            "name": "阳山县",
                            "whole_name": "阳山县，清远市，广东省",
                            "simple_py": "YSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0763",
                            "area_code": "441823",
                            "longitude": "112.634019",
                            "latitude": "24.470286"
                        }
                    ]
                },
                {
                    "city_id": 35,
                    "province_id": 1,
                    "name": "汕头市",
                    "whole_name": "汕头市，广东省",
                    "simple_py": "STS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0754",
                    "area_code": "440500",
                    "longitude": "116.708463",
                    "latitude": "23.37102",
                    "children": [
                        {
                            "area_id": 58,
                            "city_id": 35,
                            "province_id": 1,
                            "name": "澄海区",
                            "whole_name": "澄海区，汕头市，广东省",
                            "simple_py": "CHQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0754",
                            "area_code": "440515",
                            "longitude": "116.76336",
                            "latitude": "23.46844"
                        },
                        {
                            "area_id": 60,
                            "city_id": 35,
                            "province_id": 1,
                            "name": "潮阳区",
                            "whole_name": "潮阳区，汕头市，广东省",
                            "simple_py": "CYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0754",
                            "area_code": "440513",
                            "longitude": "116.602602",
                            "latitude": "23.262336"
                        },
                        {
                            "area_id": 61,
                            "city_id": 35,
                            "province_id": 1,
                            "name": "潮南区",
                            "whole_name": "潮南区，汕头市，广东省",
                            "simple_py": "CNQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0754",
                            "area_code": "440514",
                            "longitude": "116.423607",
                            "latitude": "23.249798"
                        },
                        {
                            "area_id": 59,
                            "city_id": 35,
                            "province_id": 1,
                            "name": "濠江区",
                            "whole_name": "濠江区，汕头市，广东省",
                            "simple_py": "HJQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0754",
                            "area_code": "440512",
                            "longitude": "116.729528",
                            "latitude": "23.279345"
                        },
                        {
                            "area_id": 63,
                            "city_id": 35,
                            "province_id": 1,
                            "name": "金平区",
                            "whole_name": "金平区，汕头市，广东省",
                            "simple_py": "JPQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0754",
                            "area_code": "440511",
                            "longitude": "116.703583",
                            "latitude": "23.367071"
                        },
                        {
                            "area_id": 62,
                            "city_id": 35,
                            "province_id": 1,
                            "name": "龙湖区",
                            "whole_name": "龙湖区，汕头市，广东省",
                            "simple_py": "LHQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0754",
                            "area_code": "440507",
                            "longitude": "116.732015",
                            "latitude": "23.373754"
                        },
                        {
                            "area_id": 57,
                            "city_id": 35,
                            "province_id": 1,
                            "name": "南澳县",
                            "whole_name": "南澳县，汕头市，广东省",
                            "simple_py": "NAX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0754",
                            "area_code": "440523",
                            "longitude": "117.027105",
                            "latitude": "23.419562"
                        }
                    ]
                },
                {
                    "city_id": 42,
                    "province_id": 1,
                    "name": "汕尾市",
                    "whole_name": "汕尾市，广东省",
                    "simple_py": "SWS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "S",
                    "city_code": "0660",
                    "area_code": "441500",
                    "longitude": "115.364238",
                    "latitude": "22.774485",
                    "children": [
                        {
                            "area_id": 653,
                            "city_id": 42,
                            "province_id": 1,
                            "name": "城区",
                            "whole_name": "城区，汕尾市，广东省",
                            "simple_py": "CQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0660",
                            "area_code": "441502",
                            "longitude": "115.363667",
                            "latitude": "22.776227"
                        },
                        {
                            "area_id": 652,
                            "city_id": 42,
                            "province_id": 1,
                            "name": "海丰县",
                            "whole_name": "海丰县，汕尾市，广东省",
                            "simple_py": "HFX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0660",
                            "area_code": "441521",
                            "longitude": "115.337324",
                            "latitude": "22.971042"
                        },
                        {
                            "area_id": 650,
                            "city_id": 42,
                            "province_id": 1,
                            "name": "陆河县",
                            "whole_name": "陆河县，汕尾市，广东省",
                            "simple_py": "LHX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0660",
                            "area_code": "441523",
                            "longitude": "115.657565",
                            "latitude": "23.302682"
                        },
                        {
                            "area_id": 651,
                            "city_id": 42,
                            "province_id": 1,
                            "name": "陆丰市",
                            "whole_name": "陆丰市，汕尾市，广东省",
                            "simple_py": "LFS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0660",
                            "area_code": "441581",
                            "longitude": "115.644203",
                            "latitude": "22.946104"
                        }
                    ]
                },
                {
                    "city_id": 44,
                    "province_id": 1,
                    "name": "深圳市",
                    "whole_name": "深圳市，广东省",
                    "simple_py": "SZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "S",
                    "city_code": "0755",
                    "area_code": "440300",
                    "longitude": "114.085947",
                    "latitude": "22.547",
                    "children": [
                        {
                            "area_id": 848,
                            "city_id": 44,
                            "province_id": 1,
                            "name": "宝安区",
                            "whole_name": "宝安区，深圳市，广东省",
                            "simple_py": "BAQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0755",
                            "area_code": "440306",
                            "longitude": "113.828671",
                            "latitude": "22.754741"
                        },
                        {
                            "area_id": 850,
                            "city_id": 44,
                            "province_id": 1,
                            "name": "福田区",
                            "whole_name": "福田区，深圳市，广东省",
                            "simple_py": "FTQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0755",
                            "area_code": "440304",
                            "longitude": "114.05096",
                            "latitude": "22.541009"
                        },
                        {
                            "area_id": 852,
                            "city_id": 44,
                            "province_id": 1,
                            "name": "罗湖区",
                            "whole_name": "罗湖区，深圳市，广东省",
                            "simple_py": "LHQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0755",
                            "area_code": "440303",
                            "longitude": "114.123885",
                            "latitude": "22.555341"
                        },
                        {
                            "area_id": 853,
                            "city_id": 44,
                            "province_id": 1,
                            "name": "龙华区",
                            "whole_name": "龙华区，深圳市，广东省",
                            "simple_py": "LHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0755",
                            "area_code": "440309",
                            "longitude": "114.044346",
                            "latitude": "22.691963"
                        },
                        {
                            "area_id": 854,
                            "city_id": 44,
                            "province_id": 1,
                            "name": "龙岗区",
                            "whole_name": "龙岗区，深圳市，广东省",
                            "simple_py": "LGQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0755",
                            "area_code": "440307",
                            "longitude": "114.251372",
                            "latitude": "22.721511"
                        },
                        {
                            "area_id": 849,
                            "city_id": 44,
                            "province_id": 1,
                            "name": "南山区",
                            "whole_name": "南山区，深圳市，广东省",
                            "simple_py": "NSQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0755",
                            "area_code": "440305",
                            "longitude": "113.92943",
                            "latitude": "22.531221"
                        },
                        {
                            "area_id": 855,
                            "city_id": 44,
                            "province_id": 1,
                            "name": "坪山区",
                            "whole_name": "坪山区，深圳市，广东省",
                            "simple_py": "PSQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0755",
                            "area_code": "440310",
                            "longitude": "114.338441",
                            "latitude": "22.69423"
                        },
                        {
                            "area_id": 851,
                            "city_id": 44,
                            "province_id": 1,
                            "name": "盐田区",
                            "whole_name": "盐田区，深圳市，广东省",
                            "simple_py": "YTQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0755",
                            "area_code": "440308",
                            "longitude": "114.235366",
                            "latitude": "22.555069"
                        }
                    ]
                },
                {
                    "city_id": 47,
                    "province_id": 1,
                    "name": "韶关市",
                    "whole_name": "韶关市，广东省",
                    "simple_py": "SGS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "S",
                    "city_code": "0751",
                    "area_code": "440200",
                    "longitude": "113.591544",
                    "latitude": "24.801322",
                    "children": [
                        {
                            "area_id": 1061,
                            "city_id": 47,
                            "province_id": 1,
                            "name": "乐昌市",
                            "whole_name": "乐昌市，韶关市，广东省",
                            "simple_py": "LCS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0751",
                            "area_code": "440281",
                            "longitude": "113.352413",
                            "latitude": "25.128445"
                        },
                        {
                            "area_id": 1053,
                            "city_id": 47,
                            "province_id": 1,
                            "name": "南雄市",
                            "whole_name": "南雄市，韶关市，广东省",
                            "simple_py": "NXS",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0751",
                            "area_code": "440282",
                            "longitude": "114.311231",
                            "latitude": "25.115328"
                        },
                        {
                            "area_id": 1054,
                            "city_id": 47,
                            "province_id": 1,
                            "name": "曲江区",
                            "whole_name": "曲江区，韶关市，广东省",
                            "simple_py": "QJQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0751",
                            "area_code": "440205",
                            "longitude": "113.605582",
                            "latitude": "24.680195"
                        },
                        {
                            "area_id": 1052,
                            "city_id": 47,
                            "province_id": 1,
                            "name": "仁化县",
                            "whole_name": "仁化县，韶关市，广东省",
                            "simple_py": "RHX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0751",
                            "area_code": "440224",
                            "longitude": "113.748627",
                            "latitude": "25.088226"
                        },
                        {
                            "area_id": 1057,
                            "city_id": 47,
                            "province_id": 1,
                            "name": "乳源瑶族自治县",
                            "whole_name": "乳源瑶族自治县，韶关市，广东省",
                            "simple_py": "RYYZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "R",
                            "city_code": "0751",
                            "area_code": "440232",
                            "longitude": "113.278417",
                            "latitude": "24.776109"
                        },
                        {
                            "area_id": 1056,
                            "city_id": 47,
                            "province_id": 1,
                            "name": "始兴县",
                            "whole_name": "始兴县，韶关市，广东省",
                            "simple_py": "SXX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0751",
                            "area_code": "440222",
                            "longitude": "114.067205",
                            "latitude": "24.948364"
                        },
                        {
                            "area_id": 1058,
                            "city_id": 47,
                            "province_id": 1,
                            "name": "武江区",
                            "whole_name": "武江区，韶关市，广东省",
                            "simple_py": "WJQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0751",
                            "area_code": "440203",
                            "longitude": "113.588289",
                            "latitude": "24.80016"
                        },
                        {
                            "area_id": 1059,
                            "city_id": 47,
                            "province_id": 1,
                            "name": "翁源县",
                            "whole_name": "翁源县，韶关市，广东省",
                            "simple_py": "WYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0751",
                            "area_code": "440229",
                            "longitude": "114.131289",
                            "latitude": "24.353887"
                        },
                        {
                            "area_id": 1060,
                            "city_id": 47,
                            "province_id": 1,
                            "name": "新丰县",
                            "whole_name": "新丰县，韶关市，广东省",
                            "simple_py": "XFX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0751",
                            "area_code": "440233",
                            "longitude": "114.207034",
                            "latitude": "24.055412"
                        },
                        {
                            "area_id": 1055,
                            "city_id": 47,
                            "province_id": 1,
                            "name": "浈江区",
                            "whole_name": "浈江区，韶关市，广东省",
                            "simple_py": "ZJQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0751",
                            "area_code": "440204",
                            "longitude": "113.599224",
                            "latitude": "24.803977"
                        }
                    ]
                },
                {
                    "city_id": 45,
                    "province_id": 1,
                    "name": "阳江市",
                    "whole_name": "阳江市，广东省",
                    "simple_py": "YJS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0662",
                    "area_code": "441700",
                    "longitude": "111.975107",
                    "latitude": "21.859222",
                    "children": [
                        {
                            "area_id": 918,
                            "city_id": 45,
                            "province_id": 1,
                            "name": "江城区",
                            "whole_name": "江城区，阳江市，广东省",
                            "simple_py": "JCQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0662",
                            "area_code": "441702",
                            "longitude": "111.968909",
                            "latitude": "21.859182"
                        },
                        {
                            "area_id": 917,
                            "city_id": 45,
                            "province_id": 1,
                            "name": "阳春市",
                            "whole_name": "阳春市，阳江市，广东省",
                            "simple_py": "YCS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0662",
                            "area_code": "441781",
                            "longitude": "111.7905",
                            "latitude": "22.169598"
                        },
                        {
                            "area_id": 919,
                            "city_id": 45,
                            "province_id": 1,
                            "name": "阳西县",
                            "whole_name": "阳西县，阳江市，广东省",
                            "simple_py": "YXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0662",
                            "area_code": "441721",
                            "longitude": "111.617556",
                            "latitude": "21.75367"
                        },
                        {
                            "area_id": 920,
                            "city_id": 45,
                            "province_id": 1,
                            "name": "阳东区",
                            "whole_name": "阳东区，阳江市，广东省",
                            "simple_py": "YDQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0662",
                            "area_code": "441704",
                            "longitude": "112.011267",
                            "latitude": "21.864728"
                        }
                    ]
                },
                {
                    "city_id": 52,
                    "province_id": 1,
                    "name": "云浮市",
                    "whole_name": "云浮市，广东省",
                    "simple_py": "YFS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Y",
                    "city_code": "0766",
                    "area_code": "445300",
                    "longitude": "112.044439",
                    "latitude": "22.929801",
                    "children": [
                        {
                            "area_id": 1543,
                            "city_id": 52,
                            "province_id": 1,
                            "name": "罗定市",
                            "whole_name": "罗定市，云浮市，广东省",
                            "simple_py": "LDS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0766",
                            "area_code": "445381",
                            "longitude": "111.578201",
                            "latitude": "22.765415"
                        },
                        {
                            "area_id": 1545,
                            "city_id": 52,
                            "province_id": 1,
                            "name": "新兴县",
                            "whole_name": "新兴县，云浮市，广东省",
                            "simple_py": "XXX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0766",
                            "area_code": "445321",
                            "longitude": "112.23083",
                            "latitude": "22.703204"
                        },
                        {
                            "area_id": 1544,
                            "city_id": 52,
                            "province_id": 1,
                            "name": "郁南县",
                            "whole_name": "郁南县，云浮市，广东省",
                            "simple_py": "YNX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0766",
                            "area_code": "445322",
                            "longitude": "111.535921",
                            "latitude": "23.237709"
                        },
                        {
                            "area_id": 1546,
                            "city_id": 52,
                            "province_id": 1,
                            "name": "云安区",
                            "whole_name": "云安区，云浮市，广东省",
                            "simple_py": "YAQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0766",
                            "area_code": "445303",
                            "longitude": "112.005609",
                            "latitude": "23.073152"
                        },
                        {
                            "area_id": 1547,
                            "city_id": 52,
                            "province_id": 1,
                            "name": "云城区",
                            "whole_name": "云城区，云浮市，广东省",
                            "simple_py": "YCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0766",
                            "area_code": "445302",
                            "longitude": "112.04471",
                            "latitude": "22.930827"
                        }
                    ]
                },
                {
                    "city_id": 37,
                    "province_id": 1,
                    "name": "珠海市",
                    "whole_name": "珠海市，广东省",
                    "simple_py": "ZHS",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "0756",
                    "area_code": "440400",
                    "longitude": "113.553986",
                    "latitude": "22.224979",
                    "children": [
                        {
                            "area_id": 182,
                            "city_id": 37,
                            "province_id": 1,
                            "name": "澳门大学横琴校区(由澳门管辖)",
                            "whole_name": "澳门大学横琴校区(由澳门管辖)，珠海市，广东省",
                            "simple_py": "AMDXHQXQ(YAMGX)",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "",
                            "area_code": "440499",
                            "longitude": "",
                            "latitude": ""
                        },
                        {
                            "area_id": 180,
                            "city_id": 37,
                            "province_id": 1,
                            "name": "斗门区",
                            "whole_name": "斗门区，珠海市，广东省",
                            "simple_py": "DMQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0756",
                            "area_code": "440403",
                            "longitude": "113.297739",
                            "latitude": "22.209117"
                        },
                        {
                            "area_id": 181,
                            "city_id": 37,
                            "province_id": 1,
                            "name": "金湾区",
                            "whole_name": "金湾区，珠海市，广东省",
                            "simple_py": "JWQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0756",
                            "area_code": "440404",
                            "longitude": "113.345071",
                            "latitude": "22.139122"
                        },
                        {
                            "area_id": 179,
                            "city_id": 37,
                            "province_id": 1,
                            "name": "香洲区",
                            "whole_name": "香洲区，珠海市，广东省",
                            "simple_py": "XZQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0756",
                            "area_code": "440402",
                            "longitude": "113.55027",
                            "latitude": "22.271249"
                        }
                    ]
                },
                {
                    "city_id": 39,
                    "province_id": 1,
                    "name": "湛江市",
                    "whole_name": "湛江市，广东省",
                    "simple_py": "ZJS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Z",
                    "city_code": "0759",
                    "area_code": "440800",
                    "longitude": "110.364977",
                    "latitude": "21.274898",
                    "children": [
                        {
                            "area_id": 309,
                            "city_id": 39,
                            "province_id": 1,
                            "name": "赤坎区",
                            "whole_name": "赤坎区，湛江市，广东省",
                            "simple_py": "CKQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0759",
                            "area_code": "440802",
                            "longitude": "110.361634",
                            "latitude": "21.273365"
                        },
                        {
                            "area_id": 303,
                            "city_id": 39,
                            "province_id": 1,
                            "name": "廉江市",
                            "whole_name": "廉江市，湛江市，广东省",
                            "simple_py": "LJS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0759",
                            "area_code": "440881",
                            "longitude": "110.284961",
                            "latitude": "21.611281"
                        },
                        {
                            "area_id": 304,
                            "city_id": 39,
                            "province_id": 1,
                            "name": "雷州市",
                            "whole_name": "雷州市，湛江市，广东省",
                            "simple_py": "LZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0759",
                            "area_code": "440882",
                            "longitude": "110.088275",
                            "latitude": "20.908523"
                        },
                        {
                            "area_id": 307,
                            "city_id": 39,
                            "province_id": 1,
                            "name": "麻章区",
                            "whole_name": "麻章区，湛江市，广东省",
                            "simple_py": "MZQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0759",
                            "area_code": "440811",
                            "longitude": "110.329167",
                            "latitude": "21.265997"
                        },
                        {
                            "area_id": 308,
                            "city_id": 39,
                            "province_id": 1,
                            "name": "坡头区",
                            "whole_name": "坡头区，湛江市，广东省",
                            "simple_py": "PTQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0759",
                            "area_code": "440804",
                            "longitude": "110.455632",
                            "latitude": "21.24441"
                        },
                        {
                            "area_id": 310,
                            "city_id": 39,
                            "province_id": 1,
                            "name": "遂溪县",
                            "whole_name": "遂溪县，湛江市，广东省",
                            "simple_py": "SXX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0759",
                            "area_code": "440823",
                            "longitude": "110.255321",
                            "latitude": "21.376915"
                        },
                        {
                            "area_id": 302,
                            "city_id": 39,
                            "province_id": 1,
                            "name": "吴川市",
                            "whole_name": "吴川市，湛江市，广东省",
                            "simple_py": "WCS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0759",
                            "area_code": "440883",
                            "longitude": "110.780508",
                            "latitude": "21.428453"
                        },
                        {
                            "area_id": 305,
                            "city_id": 39,
                            "province_id": 1,
                            "name": "徐闻县",
                            "whole_name": "徐闻县，湛江市，广东省",
                            "simple_py": "XWX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0759",
                            "area_code": "440825",
                            "longitude": "110.175718",
                            "latitude": "20.326083"
                        },
                        {
                            "area_id": 306,
                            "city_id": 39,
                            "province_id": 1,
                            "name": "霞山区",
                            "whole_name": "霞山区，湛江市，广东省",
                            "simple_py": "XSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0759",
                            "area_code": "440803",
                            "longitude": "110.406382",
                            "latitude": "21.194229"
                        }
                    ]
                },
                {
                    "city_id": 41,
                    "province_id": 1,
                    "name": "肇庆市",
                    "whole_name": "肇庆市，广东省",
                    "simple_py": "ZQS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Z",
                    "city_code": "0758",
                    "area_code": "441200",
                    "longitude": "112.472529",
                    "latitude": "23.051546",
                    "children": [
                        {
                            "area_id": 539,
                            "city_id": 41,
                            "province_id": 1,
                            "name": "德庆县",
                            "whole_name": "德庆县，肇庆市，广东省",
                            "simple_py": "DQX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0758",
                            "area_code": "441226",
                            "longitude": "111.78156",
                            "latitude": "23.141711"
                        },
                        {
                            "area_id": 540,
                            "city_id": 41,
                            "province_id": 1,
                            "name": "鼎湖区",
                            "whole_name": "鼎湖区，肇庆市，广东省",
                            "simple_py": "DHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0758",
                            "area_code": "441203",
                            "longitude": "112.565249",
                            "latitude": "23.155822"
                        },
                        {
                            "area_id": 541,
                            "city_id": 41,
                            "province_id": 1,
                            "name": "端州区",
                            "whole_name": "端州区，肇庆市，广东省",
                            "simple_py": "DZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0758",
                            "area_code": "441202",
                            "longitude": "112.472329",
                            "latitude": "23.052662"
                        },
                        {
                            "area_id": 536,
                            "city_id": 41,
                            "province_id": 1,
                            "name": "封开县",
                            "whole_name": "封开县，肇庆市，广东省",
                            "simple_py": "FKX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0758",
                            "area_code": "441225",
                            "longitude": "111.502973",
                            "latitude": "23.434731"
                        },
                        {
                            "area_id": 537,
                            "city_id": 41,
                            "province_id": 1,
                            "name": "广宁县",
                            "whole_name": "广宁县，肇庆市，广东省",
                            "simple_py": "GNX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0758",
                            "area_code": "441223",
                            "longitude": "112.440419",
                            "latitude": "23.631486"
                        },
                        {
                            "area_id": 542,
                            "city_id": 41,
                            "province_id": 1,
                            "name": "高要区",
                            "whole_name": "高要区，肇庆市，广东省",
                            "simple_py": "GYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0758",
                            "area_code": "441204",
                            "longitude": "112.460846",
                            "latitude": "23.027694"
                        },
                        {
                            "area_id": 535,
                            "city_id": 41,
                            "province_id": 1,
                            "name": "怀集县",
                            "whole_name": "怀集县，肇庆市，广东省",
                            "simple_py": "HJX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0758",
                            "area_code": "441224",
                            "longitude": "112.182466",
                            "latitude": "23.913072"
                        },
                        {
                            "area_id": 538,
                            "city_id": 41,
                            "province_id": 1,
                            "name": "四会市",
                            "whole_name": "四会市，肇庆市，广东省",
                            "simple_py": "SHS",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0758",
                            "area_code": "441284",
                            "longitude": "112.695028",
                            "latitude": "23.340324"
                        }
                    ]
                },
                {
                    "city_id": 55,
                    "province_id": 1,
                    "name": "中山市",
                    "whole_name": "中山市，广东省",
                    "simple_py": "ZSS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Z",
                    "city_code": "0760",
                    "area_code": "442000",
                    "longitude": "113.382391",
                    "latitude": "22.521113",
                    "children": [
                        {
                            "area_id": 1935,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "板芙镇",
                            "whole_name": "板芙镇，中山市，广东省",
                            "simple_py": "BFZ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0760",
                            "area_code": "442001",
                            "longitude": "113.358",
                            "latitude": "22.4068"
                        },
                        {
                            "area_id": 1920,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "东升镇",
                            "whole_name": "东升镇，中山市，广东省",
                            "simple_py": "DSZ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0760",
                            "area_code": "442002",
                            "longitude": "113.321",
                            "latitude": "22.5607"
                        },
                        {
                            "area_id": 1930,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "大涌镇",
                            "whole_name": "大涌镇，中山市，广东省",
                            "simple_py": "DYZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0760",
                            "area_code": "442003",
                            "longitude": "113.297",
                            "latitude": "22.4834"
                        },
                        {
                            "area_id": 1933,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "东区街道",
                            "whole_name": "东区街道，中山市，广东省",
                            "simple_py": "DQJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0760",
                            "area_code": "442004",
                            "longitude": "113.4",
                            "latitude": "22.5274"
                        },
                        {
                            "area_id": 1940,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "东凤镇",
                            "whole_name": "东凤镇，中山市，广东省",
                            "simple_py": "DFZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0760",
                            "area_code": "442005",
                            "longitude": "113.308",
                            "latitude": "22.6803"
                        },
                        {
                            "area_id": 1934,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "阜沙镇",
                            "whole_name": "阜沙镇，中山市，广东省",
                            "simple_py": "FSZ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0760",
                            "area_code": "442006",
                            "longitude": "113.34",
                            "latitude": "22.6406"
                        },
                        {
                            "area_id": 1925,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "古镇镇",
                            "whole_name": "古镇镇，中山市，广东省",
                            "simple_py": "GZZ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0760",
                            "area_code": "442007",
                            "longitude": "113.167",
                            "latitude": "22.6751"
                        },
                        {
                            "area_id": 1927,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "港口镇",
                            "whole_name": "港口镇，中山市，广东省",
                            "simple_py": "GKZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0760",
                            "area_code": "442008",
                            "longitude": "113.354",
                            "latitude": "22.6027"
                        },
                        {
                            "area_id": 1917,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "横栏镇",
                            "whole_name": "横栏镇，中山市，广东省",
                            "simple_py": "HLZ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0760",
                            "area_code": "442009",
                            "longitude": "113.224",
                            "latitude": "22.6048"
                        },
                        {
                            "area_id": 1922,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "火炬开发区街道",
                            "whole_name": "火炬开发区街道，中山市，广东省",
                            "simple_py": "HJKFQJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0760",
                            "area_code": "442010",
                            "longitude": "113.42",
                            "latitude": "22.5577"
                        },
                        {
                            "area_id": 1932,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "黄圃镇",
                            "whole_name": "黄圃镇，中山市，广东省",
                            "simple_py": "HPZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0760",
                            "area_code": "442011",
                            "longitude": "113.329",
                            "latitude": "22.7457"
                        },
                        {
                            "area_id": 1926,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "民众镇",
                            "whole_name": "民众镇，中山市，广东省",
                            "simple_py": "MZZ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0760",
                            "area_code": "442012",
                            "longitude": "113.499",
                            "latitude": "22.6855"
                        },
                        {
                            "area_id": 1924,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "南朗镇",
                            "whole_name": "南朗镇，中山市，广东省",
                            "simple_py": "NLZ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0760",
                            "area_code": "442013",
                            "longitude": "113.482",
                            "latitude": "22.519"
                        },
                        {
                            "area_id": 1931,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "南头镇",
                            "whole_name": "南头镇，中山市，广东省",
                            "simple_py": "NTZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0760",
                            "area_code": "442014",
                            "longitude": "113.328",
                            "latitude": "22.6882"
                        },
                        {
                            "area_id": 1938,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "南区街道",
                            "whole_name": "南区街道，中山市，广东省",
                            "simple_py": "NQJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0760",
                            "area_code": "442015",
                            "longitude": "113.367",
                            "latitude": "22.4892"
                        },
                        {
                            "area_id": 1918,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "三角镇",
                            "whole_name": "三角镇，中山市，广东省",
                            "simple_py": "SJZ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0760",
                            "area_code": "442016",
                            "longitude": "113.416",
                            "latitude": "22.7079"
                        },
                        {
                            "area_id": 1921,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "神湾镇",
                            "whole_name": "神湾镇，中山市，广东省",
                            "simple_py": "SWZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0760",
                            "area_code": "442017",
                            "longitude": "113.376",
                            "latitude": "22.2768"
                        },
                        {
                            "area_id": 1928,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "三乡镇",
                            "whole_name": "三乡镇，中山市，广东省",
                            "simple_py": "SXZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0760",
                            "area_code": "442018",
                            "longitude": "113.432",
                            "latitude": "22.3879"
                        },
                        {
                            "area_id": 1929,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "石岐区街道",
                            "whole_name": "石岐区街道，中山市，广东省",
                            "simple_py": "SQQJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0760",
                            "area_code": "442019",
                            "longitude": "113.405",
                            "latitude": "22.5247"
                        },
                        {
                            "area_id": 1939,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "沙溪镇",
                            "whole_name": "沙溪镇，中山市，广东省",
                            "simple_py": "SXZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0760",
                            "area_code": "442020",
                            "longitude": "113.344",
                            "latitude": "22.5248"
                        },
                        {
                            "area_id": 1937,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "坦洲镇",
                            "whole_name": "坦洲镇，中山市，广东省",
                            "simple_py": "TZZ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0760",
                            "area_code": "442021",
                            "longitude": "113.434",
                            "latitude": "22.321"
                        },
                        {
                            "area_id": 1919,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "五桂山街道",
                            "whole_name": "五桂山街道，中山市，广东省",
                            "simple_py": "WGSJD",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0760",
                            "area_code": "442022",
                            "longitude": "113.399",
                            "latitude": "22.4847"
                        },
                        {
                            "area_id": 1923,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "小榄镇",
                            "whole_name": "小榄镇，中山市，广东省",
                            "simple_py": "XLZ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0760",
                            "area_code": "442023",
                            "longitude": "113.23",
                            "latitude": "22.7026"
                        },
                        {
                            "area_id": 1936,
                            "city_id": 55,
                            "province_id": 1,
                            "name": "西区街道",
                            "whole_name": "西区街道，中山市，广东省",
                            "simple_py": "XQJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0760",
                            "area_code": "442024",
                            "longitude": "113.314",
                            "latitude": "22.5649"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 11,
            "name": "贵州省",
            "whole_name": "贵州省",
            "simple_py": "GZS",
            "per_pin_yin": " ",
            "per_pin_yin2": "G",
            "city_code": "",
            "area_code": "520000",
            "longitude": "106.713478",
            "latitude": "26.578343",
            "children": [
                {
                    "city_id": 16422,
                    "province_id": 11,
                    "name": "安顺市",
                    "whole_name": "安顺市，贵州省",
                    "simple_py": "ASS",
                    "per_pin_yin": "A",
                    "per_pin_yin2": "A",
                    "city_code": "0853",
                    "area_code": "520400",
                    "longitude": "105.932188",
                    "latitude": "26.245544",
                    "children": [
                        {
                            "area_id": 17504,
                            "city_id": 16422,
                            "province_id": 11,
                            "name": "关岭布依族苗族自治县",
                            "whole_name": "关岭布依族苗族自治县，安顺市，贵州省",
                            "simple_py": "GLBYZMZZZX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0853",
                            "area_code": "520424",
                            "longitude": "105.618454",
                            "latitude": "25.944248"
                        },
                        {
                            "area_id": 17501,
                            "city_id": 16422,
                            "province_id": 11,
                            "name": "普定县",
                            "whole_name": "普定县，安顺市，贵州省",
                            "simple_py": "PDX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0853",
                            "area_code": "520422",
                            "longitude": "105.745609",
                            "latitude": "26.305794"
                        },
                        {
                            "area_id": 17505,
                            "city_id": 16422,
                            "province_id": 11,
                            "name": "平坝区",
                            "whole_name": "平坝区，安顺市，贵州省",
                            "simple_py": "PBQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "P",
                            "city_code": "0853",
                            "area_code": "520403",
                            "longitude": "106.259942",
                            "latitude": "26.40608"
                        },
                        {
                            "area_id": 17500,
                            "city_id": 16422,
                            "province_id": 11,
                            "name": "西秀区",
                            "whole_name": "西秀区，安顺市，贵州省",
                            "simple_py": "XXQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0853",
                            "area_code": "520402",
                            "longitude": "105.946169",
                            "latitude": "26.248323"
                        },
                        {
                            "area_id": 17502,
                            "city_id": 16422,
                            "province_id": 11,
                            "name": "紫云苗族布依族自治县",
                            "whole_name": "紫云苗族布依族自治县，安顺市，贵州省",
                            "simple_py": "ZYMZBYZZZX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0853",
                            "area_code": "520425",
                            "longitude": "106.084515",
                            "latitude": "25.751567"
                        },
                        {
                            "area_id": 17503,
                            "city_id": 16422,
                            "province_id": 11,
                            "name": "镇宁布依族苗族自治县",
                            "whole_name": "镇宁布依族苗族自治县，安顺市，贵州省",
                            "simple_py": "ZNBYZMZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0853",
                            "area_code": "520423",
                            "longitude": "105.768656",
                            "latitude": "26.056096"
                        }
                    ]
                },
                {
                    "city_id": 16423,
                    "province_id": 11,
                    "name": "毕节市",
                    "whole_name": "毕节市，贵州省",
                    "simple_py": "BJS",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "0857",
                    "area_code": "520500",
                    "longitude": "105.28501",
                    "latitude": "27.301693",
                    "children": [
                        {
                            "area_id": 17595,
                            "city_id": 16423,
                            "province_id": 11,
                            "name": "大方县",
                            "whole_name": "大方县，毕节市，贵州省",
                            "simple_py": "DFX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0857",
                            "area_code": "520521",
                            "longitude": "105.609254",
                            "latitude": "27.143521"
                        },
                        {
                            "area_id": 17600,
                            "city_id": 16423,
                            "province_id": 11,
                            "name": "赫章县",
                            "whole_name": "赫章县，毕节市，贵州省",
                            "simple_py": "HZX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0857",
                            "area_code": "520527",
                            "longitude": "104.726438",
                            "latitude": "27.119243"
                        },
                        {
                            "area_id": 17597,
                            "city_id": 16423,
                            "province_id": 11,
                            "name": "金沙县",
                            "whole_name": "金沙县，毕节市，贵州省",
                            "simple_py": "JSX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0857",
                            "area_code": "520523",
                            "longitude": "106.222103",
                            "latitude": "27.459693"
                        },
                        {
                            "area_id": 17598,
                            "city_id": 16423,
                            "province_id": 11,
                            "name": "纳雍县",
                            "whole_name": "纳雍县，毕节市，贵州省",
                            "simple_py": "NYX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0857",
                            "area_code": "520525",
                            "longitude": "105.375322",
                            "latitude": "26.769875"
                        },
                        {
                            "area_id": 17594,
                            "city_id": 16423,
                            "province_id": 11,
                            "name": "七星关区",
                            "whole_name": "七星关区，毕节市，贵州省",
                            "simple_py": "QXGQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0857",
                            "area_code": "520502",
                            "longitude": "105.284852",
                            "latitude": "27.302085"
                        },
                        {
                            "area_id": 17596,
                            "city_id": 16423,
                            "province_id": 11,
                            "name": "黔西县",
                            "whole_name": "黔西县，毕节市，贵州省",
                            "simple_py": "QXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0857",
                            "area_code": "520522",
                            "longitude": "106.038299",
                            "latitude": "27.024923"
                        },
                        {
                            "area_id": 17601,
                            "city_id": 16423,
                            "province_id": 11,
                            "name": "威宁彝族回族苗族自治县",
                            "whole_name": "威宁彝族回族苗族自治县，毕节市，贵州省",
                            "simple_py": "WNYZHZMZZZX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0857",
                            "area_code": "520526",
                            "longitude": "104.286523",
                            "latitude": "26.859099"
                        },
                        {
                            "area_id": 17599,
                            "city_id": 16423,
                            "province_id": 11,
                            "name": "织金县",
                            "whole_name": "织金县，毕节市，贵州省",
                            "simple_py": "ZJX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0857",
                            "area_code": "520524",
                            "longitude": "105.768997",
                            "latitude": "26.668497"
                        }
                    ]
                },
                {
                    "city_id": 16424,
                    "province_id": 11,
                    "name": "贵阳市",
                    "whole_name": "贵阳市，贵州省",
                    "simple_py": "GYS",
                    "per_pin_yin": "G",
                    "per_pin_yin2": "G",
                    "city_code": "0851",
                    "area_code": "520100",
                    "longitude": "106.713478",
                    "latitude": "26.578343",
                    "children": [
                        {
                            "area_id": 17861,
                            "city_id": 16424,
                            "province_id": 11,
                            "name": "白云区",
                            "whole_name": "白云区，贵阳市，贵州省",
                            "simple_py": "BYQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0851",
                            "area_code": "520113",
                            "longitude": "106.633037",
                            "latitude": "26.676849"
                        },
                        {
                            "area_id": 17863,
                            "city_id": 16424,
                            "province_id": 11,
                            "name": "观山湖区",
                            "whole_name": "观山湖区，贵阳市，贵州省",
                            "simple_py": "GSHQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0851",
                            "area_code": "520115",
                            "longitude": "106.626323",
                            "latitude": "26.646358"
                        },
                        {
                            "area_id": 17867,
                            "city_id": 16424,
                            "province_id": 11,
                            "name": "花溪区",
                            "whole_name": "花溪区，贵阳市，贵州省",
                            "simple_py": "HXQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0851",
                            "area_code": "520111",
                            "longitude": "106.670791",
                            "latitude": "26.410464"
                        },
                        {
                            "area_id": 17860,
                            "city_id": 16424,
                            "province_id": 11,
                            "name": "开阳县",
                            "whole_name": "开阳县，贵阳市，贵州省",
                            "simple_py": "KYX",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0851",
                            "area_code": "520121",
                            "longitude": "106.969438",
                            "latitude": "27.056793"
                        },
                        {
                            "area_id": 17868,
                            "city_id": 16424,
                            "province_id": 11,
                            "name": "南明区",
                            "whole_name": "南明区，贵阳市，贵州省",
                            "simple_py": "NMQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0851",
                            "area_code": "520102",
                            "longitude": "106.715963",
                            "latitude": "26.573743"
                        },
                        {
                            "area_id": 17866,
                            "city_id": 16424,
                            "province_id": 11,
                            "name": "清镇市",
                            "whole_name": "清镇市，贵阳市，贵州省",
                            "simple_py": "QZS",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0851",
                            "area_code": "520181",
                            "longitude": "106.470278",
                            "latitude": "26.551289"
                        },
                        {
                            "area_id": 17862,
                            "city_id": 16424,
                            "province_id": 11,
                            "name": "乌当区",
                            "whole_name": "乌当区，贵阳市，贵州省",
                            "simple_py": "WDQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0851",
                            "area_code": "520112",
                            "longitude": "106.762123",
                            "latitude": "26.630928"
                        },
                        {
                            "area_id": 17864,
                            "city_id": 16424,
                            "province_id": 11,
                            "name": "息烽县",
                            "whole_name": "息烽县，贵阳市，贵州省",
                            "simple_py": "XFX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0851",
                            "area_code": "520122",
                            "longitude": "106.737693",
                            "latitude": "27.092665"
                        },
                        {
                            "area_id": 17865,
                            "city_id": 16424,
                            "province_id": 11,
                            "name": "修文县",
                            "whole_name": "修文县，贵阳市，贵州省",
                            "simple_py": "XWX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0851",
                            "area_code": "520123",
                            "longitude": "106.599218",
                            "latitude": "26.840672"
                        },
                        {
                            "area_id": 17869,
                            "city_id": 16424,
                            "province_id": 11,
                            "name": "云岩区",
                            "whole_name": "云岩区，贵阳市，贵州省",
                            "simple_py": "YYQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0851",
                            "area_code": "520103",
                            "longitude": "106.713397",
                            "latitude": "26.58301"
                        }
                    ]
                },
                {
                    "city_id": 16417,
                    "province_id": 11,
                    "name": "六盘水市",
                    "whole_name": "六盘水市，贵州省",
                    "simple_py": "LPSS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0858",
                    "area_code": "520200",
                    "longitude": "104.846743",
                    "latitude": "26.584643",
                    "children": [
                        {
                            "area_id": 16607,
                            "city_id": 16417,
                            "province_id": 11,
                            "name": "六枝特区",
                            "whole_name": "六枝特区，六盘水市，贵州省",
                            "simple_py": "LZTQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0858",
                            "area_code": "520203",
                            "longitude": "105.474235",
                            "latitude": "26.210662"
                        },
                        {
                            "area_id": 16608,
                            "city_id": 16417,
                            "province_id": 11,
                            "name": "盘州市",
                            "whole_name": "盘州市，六盘水市，贵州省",
                            "simple_py": "PZS",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0858",
                            "area_code": "520281",
                            "longitude": "104.468367",
                            "latitude": "25.706966"
                        },
                        {
                            "area_id": 16609,
                            "city_id": 16417,
                            "province_id": 11,
                            "name": "水城县",
                            "whole_name": "水城县，六盘水市，贵州省",
                            "simple_py": "SCX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0858",
                            "area_code": "520221",
                            "longitude": "104.95685",
                            "latitude": "26.540478"
                        },
                        {
                            "area_id": 16606,
                            "city_id": 16417,
                            "province_id": 11,
                            "name": "钟山区",
                            "whole_name": "钟山区，六盘水市，贵州省",
                            "simple_py": "ZSQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0858",
                            "area_code": "520201",
                            "longitude": "104.846244",
                            "latitude": "26.584805"
                        }
                    ]
                },
                {
                    "city_id": 16418,
                    "province_id": 11,
                    "name": "黔东南苗族侗族自治州",
                    "whole_name": "黔东南苗族侗族自治州，贵州省",
                    "simple_py": "QDNMZDZZZZ",
                    "per_pin_yin": "Q",
                    "per_pin_yin2": "Q",
                    "city_code": "0855",
                    "area_code": "522600",
                    "longitude": "107.977488",
                    "latitude": "26.583352",
                    "children": [
                        {
                            "area_id": 16701,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "从江县",
                            "whole_name": "从江县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "CJX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0855",
                            "area_code": "522633",
                            "longitude": "108.912648",
                            "latitude": "25.747058"
                        },
                        {
                            "area_id": 16712,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "岑巩县",
                            "whole_name": "岑巩县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "CGX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0855",
                            "area_code": "522626",
                            "longitude": "108.816459",
                            "latitude": "27.173244"
                        },
                        {
                            "area_id": 16708,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "丹寨县",
                            "whole_name": "丹寨县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "DZX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0855",
                            "area_code": "522636",
                            "longitude": "107.794808",
                            "latitude": "26.199497"
                        },
                        {
                            "area_id": 16710,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "黄平县",
                            "whole_name": "黄平县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "HPX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0855",
                            "area_code": "522622",
                            "longitude": "107.901337",
                            "latitude": "26.896973"
                        },
                        {
                            "area_id": 16698,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "锦屏县",
                            "whole_name": "锦屏县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "JPX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0855",
                            "area_code": "522628",
                            "longitude": "109.20252",
                            "latitude": "26.680625"
                        },
                        {
                            "area_id": 16699,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "剑河县",
                            "whole_name": "剑河县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "JHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0855",
                            "area_code": "522629",
                            "longitude": "108.440499",
                            "latitude": "26.727349"
                        },
                        {
                            "area_id": 16707,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "凯里市",
                            "whole_name": "凯里市，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "KLS",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0855",
                            "area_code": "522601",
                            "longitude": "107.977541",
                            "latitude": "26.582964"
                        },
                        {
                            "area_id": 16702,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "雷山县",
                            "whole_name": "雷山县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "LSX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0855",
                            "area_code": "522634",
                            "longitude": "108.079613",
                            "latitude": "26.381027"
                        },
                        {
                            "area_id": 16703,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "黎平县",
                            "whole_name": "黎平县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "LPX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0855",
                            "area_code": "522631",
                            "longitude": "109.136504",
                            "latitude": "26.230636"
                        },
                        {
                            "area_id": 16709,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "麻江县",
                            "whole_name": "麻江县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "MJX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0855",
                            "area_code": "522635",
                            "longitude": "107.593172",
                            "latitude": "26.494803"
                        },
                        {
                            "area_id": 16704,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "榕江县",
                            "whole_name": "榕江县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "RJX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0855",
                            "area_code": "522632",
                            "longitude": "108.521026",
                            "latitude": "25.931085"
                        },
                        {
                            "area_id": 16697,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "三穗县",
                            "whole_name": "三穗县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "SSX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0855",
                            "area_code": "522624",
                            "longitude": "108.681121",
                            "latitude": "26.959884"
                        },
                        {
                            "area_id": 16705,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "施秉县",
                            "whole_name": "施秉县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "SBX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0855",
                            "area_code": "522623",
                            "longitude": "108.12678",
                            "latitude": "27.034657"
                        },
                        {
                            "area_id": 16700,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "天柱县",
                            "whole_name": "天柱县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "TZX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0855",
                            "area_code": "522627",
                            "longitude": "109.212798",
                            "latitude": "26.909684"
                        },
                        {
                            "area_id": 16711,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "台江县",
                            "whole_name": "台江县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "TJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0855",
                            "area_code": "522630",
                            "longitude": "108.314637",
                            "latitude": "26.669138"
                        },
                        {
                            "area_id": 16706,
                            "city_id": 16418,
                            "province_id": 11,
                            "name": "镇远县",
                            "whole_name": "镇远县，黔东南苗族侗族自治州，贵州省",
                            "simple_py": "ZYX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0855",
                            "area_code": "522625",
                            "longitude": "108.423656",
                            "latitude": "27.050233"
                        }
                    ]
                },
                {
                    "city_id": 16420,
                    "province_id": 11,
                    "name": "黔南布依族苗族自治州",
                    "whole_name": "黔南布依族苗族自治州，贵州省",
                    "simple_py": "QNBYZMZZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Q",
                    "city_code": "0854",
                    "area_code": "522700",
                    "longitude": "107.517156",
                    "latitude": "26.258219",
                    "children": [
                        {
                            "area_id": 17185,
                            "city_id": 16420,
                            "province_id": 11,
                            "name": "长顺县",
                            "whole_name": "长顺县，黔南布依族苗族自治州，贵州省",
                            "simple_py": "CSX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0854",
                            "area_code": "522729",
                            "longitude": "106.447376",
                            "latitude": "26.022116"
                        },
                        {
                            "area_id": 17179,
                            "city_id": 16420,
                            "province_id": 11,
                            "name": "都匀市",
                            "whole_name": "都匀市，黔南布依族苗族自治州，贵州省",
                            "simple_py": "DYS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0854",
                            "area_code": "522701",
                            "longitude": "107.517021",
                            "latitude": "26.258205"
                        },
                        {
                            "area_id": 17182,
                            "city_id": 16420,
                            "province_id": 11,
                            "name": "独山县",
                            "whole_name": "独山县，黔南布依族苗族自治州，贵州省",
                            "simple_py": "DSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0854",
                            "area_code": "522726",
                            "longitude": "107.542757",
                            "latitude": "25.826283"
                        },
                        {
                            "area_id": 17189,
                            "city_id": 16420,
                            "province_id": 11,
                            "name": "福泉市",
                            "whole_name": "福泉市，黔南布依族苗族自治州，贵州省",
                            "simple_py": "FQS",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0854",
                            "area_code": "522702",
                            "longitude": "107.513508",
                            "latitude": "26.702508"
                        },
                        {
                            "area_id": 17187,
                            "city_id": 16420,
                            "province_id": 11,
                            "name": "贵定县",
                            "whole_name": "贵定县，黔南布依族苗族自治州，贵州省",
                            "simple_py": "GDX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0854",
                            "area_code": "522723",
                            "longitude": "107.233588",
                            "latitude": "26.580807"
                        },
                        {
                            "area_id": 17180,
                            "city_id": 16420,
                            "province_id": 11,
                            "name": "惠水县",
                            "whole_name": "惠水县，黔南布依族苗族自治州，贵州省",
                            "simple_py": "HSX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0854",
                            "area_code": "522731",
                            "longitude": "106.657848",
                            "latitude": "26.128637"
                        },
                        {
                            "area_id": 17183,
                            "city_id": 16420,
                            "province_id": 11,
                            "name": "罗甸县",
                            "whole_name": "罗甸县，黔南布依族苗族自治州，贵州省",
                            "simple_py": "LDX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0854",
                            "area_code": "522728",
                            "longitude": "106.750006",
                            "latitude": "25.429894"
                        },
                        {
                            "area_id": 17184,
                            "city_id": 16420,
                            "province_id": 11,
                            "name": "荔波县",
                            "whole_name": "荔波县，黔南布依族苗族自治州，贵州省",
                            "simple_py": "LBX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0854",
                            "area_code": "522722",
                            "longitude": "107.8838",
                            "latitude": "25.412239"
                        },
                        {
                            "area_id": 17186,
                            "city_id": 16420,
                            "province_id": 11,
                            "name": "龙里县",
                            "whole_name": "龙里县，黔南布依族苗族自治州，贵州省",
                            "simple_py": "LLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0854",
                            "area_code": "522730",
                            "longitude": "106.977733",
                            "latitude": "26.448809"
                        },
                        {
                            "area_id": 17181,
                            "city_id": 16420,
                            "province_id": 11,
                            "name": "平塘县",
                            "whole_name": "平塘县，黔南布依族苗族自治州，贵州省",
                            "simple_py": "PTX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0854",
                            "area_code": "522727",
                            "longitude": "107.32405",
                            "latitude": "25.831803"
                        },
                        {
                            "area_id": 17188,
                            "city_id": 16420,
                            "province_id": 11,
                            "name": "三都水族自治县",
                            "whole_name": "三都水族自治县，黔南布依族苗族自治州，贵州省",
                            "simple_py": "SDSZZZX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0854",
                            "area_code": "522732",
                            "longitude": "107.87747",
                            "latitude": "25.985183"
                        },
                        {
                            "area_id": 17190,
                            "city_id": 16420,
                            "province_id": 11,
                            "name": "瓮安县",
                            "whole_name": "瓮安县，黔南布依族苗族自治州，贵州省",
                            "simple_py": "WAX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0854",
                            "area_code": "522725",
                            "longitude": "107.478417",
                            "latitude": "27.066339"
                        }
                    ]
                },
                {
                    "city_id": 16421,
                    "province_id": 11,
                    "name": "黔西南布依族苗族自治州",
                    "whole_name": "黔西南布依族苗族自治州，贵州省",
                    "simple_py": "QXNBYZMZZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Q",
                    "city_code": "0859",
                    "area_code": "522300",
                    "longitude": "104.897971",
                    "latitude": "25.08812",
                    "children": [
                        {
                            "area_id": 17367,
                            "city_id": 16421,
                            "province_id": 11,
                            "name": "安龙县",
                            "whole_name": "安龙县，黔西南布依族苗族自治州，贵州省",
                            "simple_py": "ALX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0859",
                            "area_code": "522328",
                            "longitude": "105.471498",
                            "latitude": "25.108959"
                        },
                        {
                            "area_id": 17368,
                            "city_id": 16421,
                            "province_id": 11,
                            "name": "册亨县",
                            "whole_name": "册亨县，黔西南布依族苗族自治州，贵州省",
                            "simple_py": "CHX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0859",
                            "area_code": "522327",
                            "longitude": "105.81241",
                            "latitude": "24.983338"
                        },
                        {
                            "area_id": 17370,
                            "city_id": 16421,
                            "province_id": 11,
                            "name": "普安县",
                            "whole_name": "普安县，黔西南布依族苗族自治州，贵州省",
                            "simple_py": "PAX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0859",
                            "area_code": "522323",
                            "longitude": "104.955347",
                            "latitude": "25.786404"
                        },
                        {
                            "area_id": 17369,
                            "city_id": 16421,
                            "province_id": 11,
                            "name": "晴隆县",
                            "whole_name": "晴隆县，黔西南布依族苗族自治州，贵州省",
                            "simple_py": "QLX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0859",
                            "area_code": "522324",
                            "longitude": "105.218773",
                            "latitude": "25.832881"
                        },
                        {
                            "area_id": 17372,
                            "city_id": 16421,
                            "province_id": 11,
                            "name": "望谟县",
                            "whole_name": "望谟县，黔西南布依族苗族自治州，贵州省",
                            "simple_py": "WMX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0859",
                            "area_code": "522326",
                            "longitude": "106.091563",
                            "latitude": "25.166667"
                        },
                        {
                            "area_id": 17365,
                            "city_id": 16421,
                            "province_id": 11,
                            "name": "兴仁县",
                            "whole_name": "兴仁县，黔西南布依族苗族自治州，贵州省",
                            "simple_py": "XRX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0859",
                            "area_code": "522322",
                            "longitude": "105.192778",
                            "latitude": "25.431378"
                        },
                        {
                            "area_id": 17366,
                            "city_id": 16421,
                            "province_id": 11,
                            "name": "兴义市",
                            "whole_name": "兴义市，黔西南布依族苗族自治州，贵州省",
                            "simple_py": "XYS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0859",
                            "area_code": "522301",
                            "longitude": "104.897982",
                            "latitude": "25.088599"
                        },
                        {
                            "area_id": 17371,
                            "city_id": 16421,
                            "province_id": 11,
                            "name": "贞丰县",
                            "whole_name": "贞丰县，黔西南布依族苗族自治州，贵州省",
                            "simple_py": "ZFX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0859",
                            "area_code": "522325",
                            "longitude": "105.650133",
                            "latitude": "25.385752"
                        }
                    ]
                },
                {
                    "city_id": 16416,
                    "province_id": 11,
                    "name": "铜仁市",
                    "whole_name": "铜仁市，贵州省",
                    "simple_py": "TRS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0856",
                    "area_code": "520600",
                    "longitude": "109.191555",
                    "latitude": "27.718346",
                    "children": [
                        {
                            "area_id": 16428,
                            "city_id": 16416,
                            "province_id": 11,
                            "name": "碧江区",
                            "whole_name": "碧江区，铜仁市，贵州省",
                            "simple_py": "BJQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0856",
                            "area_code": "520602",
                            "longitude": "109.192117",
                            "latitude": "27.718745"
                        },
                        {
                            "area_id": 16430,
                            "city_id": 16416,
                            "province_id": 11,
                            "name": "德江县",
                            "whole_name": "德江县，铜仁市，贵州省",
                            "simple_py": "DJX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0856",
                            "area_code": "520626",
                            "longitude": "108.117317",
                            "latitude": "28.26094"
                        },
                        {
                            "area_id": 16432,
                            "city_id": 16416,
                            "province_id": 11,
                            "name": "江口县",
                            "whole_name": "江口县，铜仁市，贵州省",
                            "simple_py": "JKX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0856",
                            "area_code": "520621",
                            "longitude": "108.848427",
                            "latitude": "27.691904"
                        },
                        {
                            "area_id": 16427,
                            "city_id": 16416,
                            "province_id": 11,
                            "name": "石阡县",
                            "whole_name": "石阡县，铜仁市，贵州省",
                            "simple_py": "SQX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0856",
                            "area_code": "520623",
                            "longitude": "108.229854",
                            "latitude": "27.519386"
                        },
                        {
                            "area_id": 16429,
                            "city_id": 16416,
                            "province_id": 11,
                            "name": "思南县",
                            "whole_name": "思南县，铜仁市，贵州省",
                            "simple_py": "SNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0856",
                            "area_code": "520624",
                            "longitude": "108.255827",
                            "latitude": "27.941331"
                        },
                        {
                            "area_id": 16434,
                            "city_id": 16416,
                            "province_id": 11,
                            "name": "松桃苗族自治县",
                            "whole_name": "松桃苗族自治县，铜仁市，贵州省",
                            "simple_py": "STMZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0856",
                            "area_code": "520628",
                            "longitude": "109.202627",
                            "latitude": "28.165419"
                        },
                        {
                            "area_id": 16433,
                            "city_id": 16416,
                            "province_id": 11,
                            "name": "万山区",
                            "whole_name": "万山区，铜仁市，贵州省",
                            "simple_py": "WSQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0856",
                            "area_code": "520603",
                            "longitude": "109.21199",
                            "latitude": "27.51903"
                        },
                        {
                            "area_id": 16425,
                            "city_id": 16416,
                            "province_id": 11,
                            "name": "印江土家族苗族自治县",
                            "whole_name": "印江土家族苗族自治县，铜仁市，贵州省",
                            "simple_py": "YJTJZMZZZX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0856",
                            "area_code": "520625",
                            "longitude": "108.405517",
                            "latitude": "27.997976"
                        },
                        {
                            "area_id": 16426,
                            "city_id": 16416,
                            "province_id": 11,
                            "name": "玉屏侗族自治县",
                            "whole_name": "玉屏侗族自治县，铜仁市，贵州省",
                            "simple_py": "YPDZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0856",
                            "area_code": "520622",
                            "longitude": "108.917882",
                            "latitude": "27.238024"
                        },
                        {
                            "area_id": 16431,
                            "city_id": 16416,
                            "province_id": 11,
                            "name": "沿河土家族自治县",
                            "whole_name": "沿河土家族自治县，铜仁市，贵州省",
                            "simple_py": "YHTJZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0856",
                            "area_code": "520627",
                            "longitude": "108.495746",
                            "latitude": "28.560487"
                        }
                    ]
                },
                {
                    "city_id": 16419,
                    "province_id": 11,
                    "name": "遵义市",
                    "whole_name": "遵义市，贵州省",
                    "simple_py": "ZYS",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "0852",
                    "area_code": "520300",
                    "longitude": "106.937265",
                    "latitude": "27.706626",
                    "children": [
                        {
                            "area_id": 16926,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "播州区",
                            "whole_name": "播州区，遵义市，贵州省",
                            "simple_py": "BZQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0851",
                            "area_code": "520304",
                            "longitude": "106.831668",
                            "latitude": "27.535288"
                        },
                        {
                            "area_id": 16927,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "赤水市",
                            "whole_name": "赤水市，遵义市，贵州省",
                            "simple_py": "CSS",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0852",
                            "area_code": "520381",
                            "longitude": "105.698116",
                            "latitude": "28.587057"
                        },
                        {
                            "area_id": 16930,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "道真仡佬族苗族自治县",
                            "whole_name": "道真仡佬族苗族自治县，遵义市，贵州省",
                            "simple_py": "DZYLZMZZZX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0852",
                            "area_code": "520325",
                            "longitude": "107.605342",
                            "latitude": "28.880088"
                        },
                        {
                            "area_id": 16923,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "凤冈县",
                            "whole_name": "凤冈县，遵义市，贵州省",
                            "simple_py": "FGX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0852",
                            "area_code": "520327",
                            "longitude": "107.722021",
                            "latitude": "27.960858"
                        },
                        {
                            "area_id": 16921,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "红花岗区",
                            "whole_name": "红花岗区，遵义市，贵州省",
                            "simple_py": "HHGQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0852",
                            "area_code": "520302",
                            "longitude": "106.943784",
                            "latitude": "27.694395"
                        },
                        {
                            "area_id": 16922,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "汇川区",
                            "whole_name": "汇川区，遵义市，贵州省",
                            "simple_py": "HCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0852",
                            "area_code": "520303",
                            "longitude": "106.937265",
                            "latitude": "27.706626"
                        },
                        {
                            "area_id": 16918,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "湄潭县",
                            "whole_name": "湄潭县，遵义市，贵州省",
                            "simple_py": "MTX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0852",
                            "area_code": "520328",
                            "longitude": "107.485723",
                            "latitude": "27.765839"
                        },
                        {
                            "area_id": 16925,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "仁怀市",
                            "whole_name": "仁怀市，遵义市，贵州省",
                            "simple_py": "RHS",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0852",
                            "area_code": "520382",
                            "longitude": "106.412476",
                            "latitude": "27.803377"
                        },
                        {
                            "area_id": 16919,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "绥阳县",
                            "whole_name": "绥阳县，遵义市，贵州省",
                            "simple_py": "SYX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0852",
                            "area_code": "520323",
                            "longitude": "107.191024",
                            "latitude": "27.951342"
                        },
                        {
                            "area_id": 16917,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "桐梓县",
                            "whole_name": "桐梓县，遵义市，贵州省",
                            "simple_py": "TZX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0852",
                            "area_code": "520322",
                            "longitude": "106.826591",
                            "latitude": "28.131559"
                        },
                        {
                            "area_id": 16924,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "务川仡佬族苗族自治县",
                            "whole_name": "务川仡佬族苗族自治县，遵义市，贵州省",
                            "simple_py": "WCYLZMZZZX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0852",
                            "area_code": "520326",
                            "longitude": "107.887857",
                            "latitude": "28.521567"
                        },
                        {
                            "area_id": 16928,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "习水县",
                            "whole_name": "习水县，遵义市，贵州省",
                            "simple_py": "XSX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0852",
                            "area_code": "520330",
                            "longitude": "106.200954",
                            "latitude": "28.327826"
                        },
                        {
                            "area_id": 16920,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "余庆县",
                            "whole_name": "余庆县，遵义市，贵州省",
                            "simple_py": "YQX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0852",
                            "area_code": "520329",
                            "longitude": "107.892566",
                            "latitude": "27.221552"
                        },
                        {
                            "area_id": 16929,
                            "city_id": 16419,
                            "province_id": 11,
                            "name": "正安县",
                            "whole_name": "正安县，遵义市，贵州省",
                            "simple_py": "ZAX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0852",
                            "area_code": "520324",
                            "longitude": "107.441872",
                            "latitude": "28.550337"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 20,
            "name": "广西壮族自治区",
            "whole_name": "广西壮族自治区",
            "simple_py": "GXZZZZQ",
            "per_pin_yin": " ",
            "per_pin_yin2": "G",
            "city_code": "",
            "area_code": "450000",
            "longitude": "108.320004",
            "latitude": "22.82402",
            "children": [
                {
                    "city_id": 27487,
                    "province_id": 20,
                    "name": "百色市",
                    "whole_name": "百色市，广西壮族自治区",
                    "simple_py": "BSS",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "0776",
                    "area_code": "451000",
                    "longitude": "106.616285",
                    "latitude": "23.897742",
                    "children": [
                        {
                            "area_id": 27743,
                            "city_id": 27487,
                            "province_id": 20,
                            "name": "德保县",
                            "whole_name": "德保县，百色市，广西壮族自治区",
                            "simple_py": "DBX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0776",
                            "area_code": "451024",
                            "longitude": "106.618164",
                            "latitude": "23.321464"
                        },
                        {
                            "area_id": 27745,
                            "city_id": 27487,
                            "province_id": 20,
                            "name": "靖西市",
                            "whole_name": "靖西市，百色市，广西壮族自治区",
                            "simple_py": "JXS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0776",
                            "area_code": "451081",
                            "longitude": "106.417549",
                            "latitude": "23.134766"
                        },
                        {
                            "area_id": 27736,
                            "city_id": 27487,
                            "province_id": 20,
                            "name": "乐业县",
                            "whole_name": "乐业县，百色市，广西壮族自治区",
                            "simple_py": "LYX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0776",
                            "area_code": "451028",
                            "longitude": "106.559638",
                            "latitude": "24.782204"
                        },
                        {
                            "area_id": 27737,
                            "city_id": 27487,
                            "province_id": 20,
                            "name": "隆林各族自治县",
                            "whole_name": "隆林各族自治县，百色市，广西壮族自治区",
                            "simple_py": "LLGZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0776",
                            "area_code": "451031",
                            "longitude": "105.342363",
                            "latitude": "24.774318"
                        },
                        {
                            "area_id": 27739,
                            "city_id": 27487,
                            "province_id": 20,
                            "name": "凌云县",
                            "whole_name": "凌云县，百色市，广西壮族自治区",
                            "simple_py": "LYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0776",
                            "area_code": "451027",
                            "longitude": "106.56487",
                            "latitude": "24.345643"
                        },
                        {
                            "area_id": 27747,
                            "city_id": 27487,
                            "province_id": 20,
                            "name": "那坡县",
                            "whole_name": "那坡县，百色市，广西壮族自治区",
                            "simple_py": "NPX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0776",
                            "area_code": "451026",
                            "longitude": "105.833553",
                            "latitude": "23.400785"
                        },
                        {
                            "area_id": 27741,
                            "city_id": 27487,
                            "province_id": 20,
                            "name": "平果县",
                            "whole_name": "平果县，百色市，广西壮族自治区",
                            "simple_py": "PGX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0776",
                            "area_code": "451023",
                            "longitude": "107.580403",
                            "latitude": "23.320479"
                        },
                        {
                            "area_id": 27740,
                            "city_id": 27487,
                            "province_id": 20,
                            "name": "田东县",
                            "whole_name": "田东县，百色市，广西壮族自治区",
                            "simple_py": "TDX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0776",
                            "area_code": "451022",
                            "longitude": "107.12426",
                            "latitude": "23.600444"
                        },
                        {
                            "area_id": 27744,
                            "city_id": 27487,
                            "province_id": 20,
                            "name": "田阳县",
                            "whole_name": "田阳县，百色市，广西壮族自治区",
                            "simple_py": "TYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0776",
                            "area_code": "451021",
                            "longitude": "106.904315",
                            "latitude": "23.736079"
                        },
                        {
                            "area_id": 27746,
                            "city_id": 27487,
                            "province_id": 20,
                            "name": "田林县",
                            "whole_name": "田林县，百色市，广西壮族自治区",
                            "simple_py": "TLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0776",
                            "area_code": "451029",
                            "longitude": "106.235047",
                            "latitude": "24.290262"
                        },
                        {
                            "area_id": 27738,
                            "city_id": 27487,
                            "province_id": 20,
                            "name": "西林县",
                            "whole_name": "西林县，百色市，广西壮族自治区",
                            "simple_py": "XLX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0776",
                            "area_code": "451030",
                            "longitude": "105.095025",
                            "latitude": "24.492041"
                        },
                        {
                            "area_id": 27742,
                            "city_id": 27487,
                            "province_id": 20,
                            "name": "右江区",
                            "whole_name": "右江区，百色市，广西壮族自治区",
                            "simple_py": "YJQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0776",
                            "area_code": "451002",
                            "longitude": "106.615727",
                            "latitude": "23.897675"
                        }
                    ]
                },
                {
                    "city_id": 27488,
                    "province_id": 20,
                    "name": "北海市",
                    "whole_name": "北海市，广西壮族自治区",
                    "simple_py": "BHS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "B",
                    "city_code": "0779",
                    "area_code": "450500",
                    "longitude": "109.119254",
                    "latitude": "21.473343",
                    "children": [
                        {
                            "area_id": 27885,
                            "city_id": 27488,
                            "province_id": 20,
                            "name": "合浦县",
                            "whole_name": "合浦县，北海市，广西壮族自治区",
                            "simple_py": "HPX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0779",
                            "area_code": "450521",
                            "longitude": "109.200695",
                            "latitude": "21.663554"
                        },
                        {
                            "area_id": 27886,
                            "city_id": 27488,
                            "province_id": 20,
                            "name": "海城区",
                            "whole_name": "海城区，北海市，广西壮族自治区",
                            "simple_py": "HCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0779",
                            "area_code": "450502",
                            "longitude": "109.107529",
                            "latitude": "21.468443"
                        },
                        {
                            "area_id": 27888,
                            "city_id": 27488,
                            "province_id": 20,
                            "name": "铁山港区",
                            "whole_name": "铁山港区，北海市，广西壮族自治区",
                            "simple_py": "TSGQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0779",
                            "area_code": "450512",
                            "longitude": "109.450573",
                            "latitude": "21.5928"
                        },
                        {
                            "area_id": 27887,
                            "city_id": 27488,
                            "province_id": 20,
                            "name": "银海区",
                            "whole_name": "银海区，北海市，广西壮族自治区",
                            "simple_py": "YHQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0779",
                            "area_code": "450503",
                            "longitude": "109.118707",
                            "latitude": "21.444909"
                        }
                    ]
                },
                {
                    "city_id": 27494,
                    "province_id": 20,
                    "name": "崇左市",
                    "whole_name": "崇左市，广西壮族自治区",
                    "simple_py": "CZS",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0771",
                    "area_code": "451400",
                    "longitude": "107.353926",
                    "latitude": "22.404108",
                    "children": [
                        {
                            "area_id": 28512,
                            "city_id": 27494,
                            "province_id": 20,
                            "name": "大新县",
                            "whole_name": "大新县，崇左市，广西壮族自治区",
                            "simple_py": "DXX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0771",
                            "area_code": "451424",
                            "longitude": "107.200803",
                            "latitude": "22.833369"
                        },
                        {
                            "area_id": 28508,
                            "city_id": 27494,
                            "province_id": 20,
                            "name": "扶绥县",
                            "whole_name": "扶绥县，崇左市，广西壮族自治区",
                            "simple_py": "FSX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0771",
                            "area_code": "451421",
                            "longitude": "107.911533",
                            "latitude": "22.635821"
                        },
                        {
                            "area_id": 28511,
                            "city_id": 27494,
                            "province_id": 20,
                            "name": "江州区",
                            "whole_name": "江州区，崇左市，广西壮族自治区",
                            "simple_py": "JZQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0771",
                            "area_code": "451402",
                            "longitude": "107.354443",
                            "latitude": "22.40469"
                        },
                        {
                            "area_id": 28514,
                            "city_id": 27494,
                            "province_id": 20,
                            "name": "龙州县",
                            "whole_name": "龙州县，崇左市，广西壮族自治区",
                            "simple_py": "LZX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0771",
                            "area_code": "451423",
                            "longitude": "106.857502",
                            "latitude": "22.343716"
                        },
                        {
                            "area_id": 28509,
                            "city_id": 27494,
                            "province_id": 20,
                            "name": "宁明县",
                            "whole_name": "宁明县，崇左市，广西壮族自治区",
                            "simple_py": "NMX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0771",
                            "area_code": "451422",
                            "longitude": "107.067616",
                            "latitude": "22.131353"
                        },
                        {
                            "area_id": 28510,
                            "city_id": 27494,
                            "province_id": 20,
                            "name": "凭祥市",
                            "whole_name": "凭祥市，崇左市，广西壮族自治区",
                            "simple_py": "PXS",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0771",
                            "area_code": "451481",
                            "longitude": "106.759038",
                            "latitude": "22.108882"
                        },
                        {
                            "area_id": 28513,
                            "city_id": 27494,
                            "province_id": 20,
                            "name": "天等县",
                            "whole_name": "天等县，崇左市，广西壮族自治区",
                            "simple_py": "TDX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0771",
                            "area_code": "451425",
                            "longitude": "107.142441",
                            "latitude": "23.082484"
                        }
                    ]
                },
                {
                    "city_id": 27496,
                    "province_id": 20,
                    "name": "防城港市",
                    "whole_name": "防城港市，广西壮族自治区",
                    "simple_py": "FCGS",
                    "per_pin_yin": "F",
                    "per_pin_yin2": "F",
                    "city_code": "0770",
                    "area_code": "450600",
                    "longitude": "108.345478",
                    "latitude": "21.614631",
                    "children": [
                        {
                            "area_id": 28668,
                            "city_id": 27496,
                            "province_id": 20,
                            "name": "东兴市",
                            "whole_name": "东兴市，防城港市，广西壮族自治区",
                            "simple_py": "DXS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0770",
                            "area_code": "450681",
                            "longitude": "107.97017",
                            "latitude": "21.541172"
                        },
                        {
                            "area_id": 28666,
                            "city_id": 27496,
                            "province_id": 20,
                            "name": "防城区",
                            "whole_name": "防城区，防城港市，广西壮族自治区",
                            "simple_py": "FCQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0770",
                            "area_code": "450603",
                            "longitude": "108.358426",
                            "latitude": "21.764758"
                        },
                        {
                            "area_id": 28667,
                            "city_id": 27496,
                            "province_id": 20,
                            "name": "港口区",
                            "whole_name": "港口区，防城港市，广西壮族自治区",
                            "simple_py": "GKQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0770",
                            "area_code": "450602",
                            "longitude": "108.346281",
                            "latitude": "21.614406"
                        },
                        {
                            "area_id": 28665,
                            "city_id": 27496,
                            "province_id": 20,
                            "name": "上思县",
                            "whole_name": "上思县，防城港市，广西壮族自治区",
                            "simple_py": "SSX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0770",
                            "area_code": "450621",
                            "longitude": "107.982139",
                            "latitude": "22.151423"
                        }
                    ]
                },
                {
                    "city_id": 27486,
                    "province_id": 20,
                    "name": "桂林市",
                    "whole_name": "桂林市，广西壮族自治区",
                    "simple_py": "GLS",
                    "per_pin_yin": "G",
                    "per_pin_yin2": "G",
                    "city_code": "0773",
                    "area_code": "450300",
                    "longitude": "110.299121",
                    "latitude": "25.274215",
                    "children": [
                        {
                            "area_id": 27576,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "叠彩区",
                            "whole_name": "叠彩区，桂林市，广西壮族自治区",
                            "simple_py": "DCQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0773",
                            "area_code": "450303",
                            "longitude": "110.300783",
                            "latitude": "25.301334"
                        },
                        {
                            "area_id": 27581,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "恭城瑶族自治县",
                            "whole_name": "恭城瑶族自治县，桂林市，广西壮族自治区",
                            "simple_py": "GCYZZZX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0773",
                            "area_code": "450332",
                            "longitude": "110.82952",
                            "latitude": "24.833612"
                        },
                        {
                            "area_id": 27589,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "灌阳县",
                            "whole_name": "灌阳县，桂林市，广西壮族自治区",
                            "simple_py": "GYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0773",
                            "area_code": "450327",
                            "longitude": "111.160248",
                            "latitude": "25.489098"
                        },
                        {
                            "area_id": 27575,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "临桂区",
                            "whole_name": "临桂区，桂林市，广西壮族自治区",
                            "simple_py": "LGQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0773",
                            "area_code": "450312",
                            "longitude": "110.205487",
                            "latitude": "25.246257"
                        },
                        {
                            "area_id": 27580,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "灵川县",
                            "whole_name": "灵川县，桂林市，广西壮族自治区",
                            "simple_py": "LCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0773",
                            "area_code": "450323",
                            "longitude": "110.325712",
                            "latitude": "25.408541"
                        },
                        {
                            "area_id": 27582,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "荔浦县",
                            "whole_name": "荔浦县，桂林市，广西壮族自治区",
                            "simple_py": "LPX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0773",
                            "area_code": "450331",
                            "longitude": "110.400149",
                            "latitude": "24.497786"
                        },
                        {
                            "area_id": 27586,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "龙胜各族自治县",
                            "whole_name": "龙胜各族自治县，桂林市，广西壮族自治区",
                            "simple_py": "LSGZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0773",
                            "area_code": "450328",
                            "longitude": "110.009423",
                            "latitude": "25.796428"
                        },
                        {
                            "area_id": 27585,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "平乐县",
                            "whole_name": "平乐县，桂林市，广西壮族自治区",
                            "simple_py": "PLX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0773",
                            "area_code": "450330",
                            "longitude": "110.642821",
                            "latitude": "24.632216"
                        },
                        {
                            "area_id": 27574,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "七星区",
                            "whole_name": "七星区，桂林市，广西壮族自治区",
                            "simple_py": "QXQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0773",
                            "area_code": "450305",
                            "longitude": "110.317577",
                            "latitude": "25.254339"
                        },
                        {
                            "area_id": 27590,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "全州县",
                            "whole_name": "全州县，桂林市，广西壮族自治区",
                            "simple_py": "QZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0773",
                            "area_code": "450324",
                            "longitude": "111.072989",
                            "latitude": "25.929897"
                        },
                        {
                            "area_id": 27577,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "兴安县",
                            "whole_name": "兴安县，桂林市，广西壮族自治区",
                            "simple_py": "XAX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0773",
                            "area_code": "450325",
                            "longitude": "110.670783",
                            "latitude": "25.609554"
                        },
                        {
                            "area_id": 27587,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "秀峰区",
                            "whole_name": "秀峰区，桂林市，广西壮族自治区",
                            "simple_py": "XFQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0773",
                            "area_code": "450302",
                            "longitude": "110.292445",
                            "latitude": "25.278544"
                        },
                        {
                            "area_id": 27588,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "象山区",
                            "whole_name": "象山区，桂林市，广西壮族自治区",
                            "simple_py": "XSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0773",
                            "area_code": "450304",
                            "longitude": "110.284882",
                            "latitude": "25.261986"
                        },
                        {
                            "area_id": 27579,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "阳朔县",
                            "whole_name": "阳朔县，桂林市，广西壮族自治区",
                            "simple_py": "YSX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0773",
                            "area_code": "450321",
                            "longitude": "110.494699",
                            "latitude": "24.77534"
                        },
                        {
                            "area_id": 27583,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "雁山区",
                            "whole_name": "雁山区，桂林市，广西壮族自治区",
                            "simple_py": "YSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0773",
                            "area_code": "450311",
                            "longitude": "110.305667",
                            "latitude": "25.077646"
                        },
                        {
                            "area_id": 27584,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "永福县",
                            "whole_name": "永福县，桂林市，广西壮族自治区",
                            "simple_py": "YFX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0773",
                            "area_code": "450326",
                            "longitude": "109.989208",
                            "latitude": "24.986692"
                        },
                        {
                            "area_id": 27578,
                            "city_id": 27486,
                            "province_id": 20,
                            "name": "资源县",
                            "whole_name": "资源县，桂林市，广西壮族自治区",
                            "simple_py": "ZYX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0773",
                            "area_code": "450329",
                            "longitude": "110.642587",
                            "latitude": "26.0342"
                        }
                    ]
                },
                {
                    "city_id": 27489,
                    "province_id": 20,
                    "name": "贵港市",
                    "whole_name": "贵港市，广西壮族自治区",
                    "simple_py": "GGS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "G",
                    "city_code": "0775",
                    "area_code": "450800",
                    "longitude": "109.602146",
                    "latitude": "23.0936",
                    "children": [
                        {
                            "area_id": 27920,
                            "city_id": 27489,
                            "province_id": 20,
                            "name": "桂平市",
                            "whole_name": "桂平市，贵港市，广西壮族自治区",
                            "simple_py": "GPS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0775",
                            "area_code": "450881",
                            "longitude": "110.074668",
                            "latitude": "23.382473"
                        },
                        {
                            "area_id": 27922,
                            "city_id": 27489,
                            "province_id": 20,
                            "name": "港南区",
                            "whole_name": "港南区，贵港市，广西壮族自治区",
                            "simple_py": "GNQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0775",
                            "area_code": "450803",
                            "longitude": "109.604665",
                            "latitude": "23.067516"
                        },
                        {
                            "area_id": 27923,
                            "city_id": 27489,
                            "province_id": 20,
                            "name": "港北区",
                            "whole_name": "港北区，贵港市，广西壮族自治区",
                            "simple_py": "GBQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0775",
                            "area_code": "450802",
                            "longitude": "109.59481",
                            "latitude": "23.107677"
                        },
                        {
                            "area_id": 27919,
                            "city_id": 27489,
                            "province_id": 20,
                            "name": "平南县",
                            "whole_name": "平南县，贵港市，广西壮族自治区",
                            "simple_py": "PNX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0775",
                            "area_code": "450821",
                            "longitude": "110.397485",
                            "latitude": "23.544546"
                        },
                        {
                            "area_id": 27921,
                            "city_id": 27489,
                            "province_id": 20,
                            "name": "覃塘区",
                            "whole_name": "覃塘区，贵港市，广西壮族自治区",
                            "simple_py": "TTQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0775",
                            "area_code": "450804",
                            "longitude": "109.415697",
                            "latitude": "23.132815"
                        }
                    ]
                },
                {
                    "city_id": 27490,
                    "province_id": 20,
                    "name": "河池市",
                    "whole_name": "河池市，广西壮族自治区",
                    "simple_py": "HCS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0778",
                    "area_code": "451200",
                    "longitude": "108.062105",
                    "latitude": "24.695899",
                    "children": [
                        {
                            "area_id": 28006,
                            "city_id": 27490,
                            "province_id": 20,
                            "name": "巴马瑶族自治县",
                            "whole_name": "巴马瑶族自治县，河池市，广西壮族自治区",
                            "simple_py": "BMYZZZX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0778",
                            "area_code": "451227",
                            "longitude": "107.253126",
                            "latitude": "24.139538"
                        },
                        {
                            "area_id": 28005,
                            "city_id": 27490,
                            "province_id": 20,
                            "name": "大化瑶族自治县",
                            "whole_name": "大化瑶族自治县，河池市，广西壮族自治区",
                            "simple_py": "DHYZZZX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0778",
                            "area_code": "451229",
                            "longitude": "107.9945",
                            "latitude": "23.739596"
                        },
                        {
                            "area_id": 28007,
                            "city_id": 27490,
                            "province_id": 20,
                            "name": "都安瑶族自治县",
                            "whole_name": "都安瑶族自治县，河池市，广西壮族自治区",
                            "simple_py": "DAYZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0778",
                            "area_code": "451228",
                            "longitude": "108.102761",
                            "latitude": "23.934964"
                        },
                        {
                            "area_id": 28008,
                            "city_id": 27490,
                            "province_id": 20,
                            "name": "东兰县",
                            "whole_name": "东兰县，河池市，广西壮族自治区",
                            "simple_py": "DLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0778",
                            "area_code": "451224",
                            "longitude": "107.373696",
                            "latitude": "24.509367"
                        },
                        {
                            "area_id": 28003,
                            "city_id": 27490,
                            "province_id": 20,
                            "name": "凤山县",
                            "whole_name": "凤山县，河池市，广西壮族自治区",
                            "simple_py": "FSX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0778",
                            "area_code": "451223",
                            "longitude": "107.044592",
                            "latitude": "24.544561"
                        },
                        {
                            "area_id": 27998,
                            "city_id": 27490,
                            "province_id": 20,
                            "name": "环江毛南族自治县",
                            "whole_name": "环江毛南族自治县，河池市，广西壮族自治区",
                            "simple_py": "HJMNZZZX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0778",
                            "area_code": "451226",
                            "longitude": "108.258669",
                            "latitude": "24.827628"
                        },
                        {
                            "area_id": 27999,
                            "city_id": 27490,
                            "province_id": 20,
                            "name": "金城江区",
                            "whole_name": "金城江区，河池市，广西壮族自治区",
                            "simple_py": "JCJQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0778",
                            "area_code": "451202",
                            "longitude": "108.062131",
                            "latitude": "24.695625"
                        },
                        {
                            "area_id": 28000,
                            "city_id": 27490,
                            "province_id": 20,
                            "name": "罗城仫佬族自治县",
                            "whole_name": "罗城仫佬族自治县，河池市，广西壮族自治区",
                            "simple_py": "LCMLZZZX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0778",
                            "area_code": "451225",
                            "longitude": "108.902453",
                            "latitude": "24.779327"
                        },
                        {
                            "area_id": 28004,
                            "city_id": 27490,
                            "province_id": 20,
                            "name": "南丹县",
                            "whole_name": "南丹县，河池市，广西壮族自治区",
                            "simple_py": "NDX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0778",
                            "area_code": "451221",
                            "longitude": "107.546605",
                            "latitude": "24.983192"
                        },
                        {
                            "area_id": 28001,
                            "city_id": 27490,
                            "province_id": 20,
                            "name": "天峨县",
                            "whole_name": "天峨县，河池市，广西壮族自治区",
                            "simple_py": "TEX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0778",
                            "area_code": "451222",
                            "longitude": "107.174939",
                            "latitude": "24.985964"
                        },
                        {
                            "area_id": 28002,
                            "city_id": 27490,
                            "province_id": 20,
                            "name": "宜州区",
                            "whole_name": "宜州区，河池市，广西壮族自治区",
                            "simple_py": "YZQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0778",
                            "area_code": "451203",
                            "longitude": "108.653965",
                            "latitude": "24.492193"
                        }
                    ]
                },
                {
                    "city_id": 27495,
                    "province_id": 20,
                    "name": "贺州市",
                    "whole_name": "贺州市，广西壮族自治区",
                    "simple_py": "HZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0774",
                    "area_code": "451100",
                    "longitude": "111.552056",
                    "latitude": "24.414141",
                    "children": [
                        {
                            "area_id": 28601,
                            "city_id": 27495,
                            "province_id": 20,
                            "name": "八步区",
                            "whole_name": "八步区，贺州市，广西壮族自治区",
                            "simple_py": "BBQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0774",
                            "area_code": "451102",
                            "longitude": "111.551991",
                            "latitude": "24.412446"
                        },
                        {
                            "area_id": 28599,
                            "city_id": 27495,
                            "province_id": 20,
                            "name": "富川瑶族自治县",
                            "whole_name": "富川瑶族自治县，贺州市，广西壮族自治区",
                            "simple_py": "FCYZZZX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0774",
                            "area_code": "451123",
                            "longitude": "111.277228",
                            "latitude": "24.81896"
                        },
                        {
                            "area_id": 28603,
                            "city_id": 27495,
                            "province_id": 20,
                            "name": "平桂区",
                            "whole_name": "平桂区，贺州市，广西壮族自治区",
                            "simple_py": "PGQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0774",
                            "area_code": "451103",
                            "longitude": "111.524014",
                            "latitude": "24.417148"
                        },
                        {
                            "area_id": 28600,
                            "city_id": 27495,
                            "province_id": 20,
                            "name": "昭平县",
                            "whole_name": "昭平县，贺州市，广西壮族自治区",
                            "simple_py": "ZPX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0774",
                            "area_code": "451121",
                            "longitude": "110.810865",
                            "latitude": "24.172958"
                        },
                        {
                            "area_id": 28602,
                            "city_id": 27495,
                            "province_id": 20,
                            "name": "钟山县",
                            "whole_name": "钟山县，贺州市，广西壮族自治区",
                            "simple_py": "ZSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0774",
                            "area_code": "451122",
                            "longitude": "111.303629",
                            "latitude": "24.528566"
                        }
                    ]
                },
                {
                    "city_id": 27491,
                    "province_id": 20,
                    "name": "柳州市",
                    "whole_name": "柳州市，广西壮族自治区",
                    "simple_py": "LZS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0772",
                    "area_code": "450200",
                    "longitude": "109.411703",
                    "latitude": "24.314617",
                    "children": [
                        {
                            "area_id": 28151,
                            "city_id": 27491,
                            "province_id": 20,
                            "name": "城中区",
                            "whole_name": "城中区，柳州市，广西壮族自治区",
                            "simple_py": "CZQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0772",
                            "area_code": "450202",
                            "longitude": "109.411749",
                            "latitude": "24.312324"
                        },
                        {
                            "area_id": 28152,
                            "city_id": 27491,
                            "province_id": 20,
                            "name": "柳北区",
                            "whole_name": "柳北区，柳州市，广西壮族自治区",
                            "simple_py": "LBQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0772",
                            "area_code": "450205",
                            "longitude": "109.406577",
                            "latitude": "24.359145"
                        },
                        {
                            "area_id": 28153,
                            "city_id": 27491,
                            "province_id": 20,
                            "name": "鹿寨县",
                            "whole_name": "鹿寨县，柳州市，广西壮族自治区",
                            "simple_py": "LZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0772",
                            "area_code": "450223",
                            "longitude": "109.740805",
                            "latitude": "24.483405"
                        },
                        {
                            "area_id": 28154,
                            "city_id": 27491,
                            "province_id": 20,
                            "name": "柳城县",
                            "whole_name": "柳城县，柳州市，广西壮族自治区",
                            "simple_py": "LCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0772",
                            "area_code": "450222",
                            "longitude": "109.245812",
                            "latitude": "24.655121"
                        },
                        {
                            "area_id": 28156,
                            "city_id": 27491,
                            "province_id": 20,
                            "name": "柳江区",
                            "whole_name": "柳江区，柳州市，广西壮族自治区",
                            "simple_py": "LJQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0772",
                            "area_code": "450206",
                            "longitude": "109.334503",
                            "latitude": "24.257512"
                        },
                        {
                            "area_id": 28157,
                            "city_id": 27491,
                            "province_id": 20,
                            "name": "柳南区",
                            "whole_name": "柳南区，柳州市，广西壮族自治区",
                            "simple_py": "LNQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0772",
                            "area_code": "450204",
                            "longitude": "109.395936",
                            "latitude": "24.287013"
                        },
                        {
                            "area_id": 28148,
                            "city_id": 27491,
                            "province_id": 20,
                            "name": "融安县",
                            "whole_name": "融安县，柳州市，广西壮族自治区",
                            "simple_py": "RAX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0772",
                            "area_code": "450224",
                            "longitude": "109.403621",
                            "latitude": "25.214703"
                        },
                        {
                            "area_id": 28149,
                            "city_id": 27491,
                            "province_id": 20,
                            "name": "融水苗族自治县",
                            "whole_name": "融水苗族自治县，柳州市，广西壮族自治区",
                            "simple_py": "RSMZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "R",
                            "city_code": "0772",
                            "area_code": "450225",
                            "longitude": "109.252744",
                            "latitude": "25.068812"
                        },
                        {
                            "area_id": 28150,
                            "city_id": 27491,
                            "province_id": 20,
                            "name": "三江侗族自治县",
                            "whole_name": "三江侗族自治县，柳州市，广西壮族自治区",
                            "simple_py": "SJDZZZX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0772",
                            "area_code": "450226",
                            "longitude": "109.614846",
                            "latitude": "25.78553"
                        },
                        {
                            "area_id": 28155,
                            "city_id": 27491,
                            "province_id": 20,
                            "name": "鱼峰区",
                            "whole_name": "鱼峰区，柳州市，广西壮族自治区",
                            "simple_py": "YFQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0772",
                            "area_code": "450203",
                            "longitude": "109.415364",
                            "latitude": "24.303848"
                        }
                    ]
                },
                {
                    "city_id": 27493,
                    "province_id": 20,
                    "name": "来宾市",
                    "whole_name": "来宾市，广西壮族自治区",
                    "simple_py": "LBS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "L",
                    "city_code": "0772",
                    "area_code": "451300",
                    "longitude": "109.229772",
                    "latitude": "23.733766",
                    "children": [
                        {
                            "area_id": 28434,
                            "city_id": 27493,
                            "province_id": 20,
                            "name": "合山市",
                            "whole_name": "合山市，来宾市，广西壮族自治区",
                            "simple_py": "HSS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0772",
                            "area_code": "451381",
                            "longitude": "108.88858",
                            "latitude": "23.81311"
                        },
                        {
                            "area_id": 28432,
                            "city_id": 27493,
                            "province_id": 20,
                            "name": "金秀瑶族自治县",
                            "whole_name": "金秀瑶族自治县，来宾市，广西壮族自治区",
                            "simple_py": "JXYZZZX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0772",
                            "area_code": "451324",
                            "longitude": "110.188556",
                            "latitude": "24.134941"
                        },
                        {
                            "area_id": 28433,
                            "city_id": 27493,
                            "province_id": 20,
                            "name": "武宣县",
                            "whole_name": "武宣县，来宾市，广西壮族自治区",
                            "simple_py": "WXX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0772",
                            "area_code": "451323",
                            "longitude": "109.66287",
                            "latitude": "23.604162"
                        },
                        {
                            "area_id": 28429,
                            "city_id": 27493,
                            "province_id": 20,
                            "name": "兴宾区",
                            "whole_name": "兴宾区，来宾市，广西壮族自治区",
                            "simple_py": "XBQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0772",
                            "area_code": "451302",
                            "longitude": "109.230541",
                            "latitude": "23.732926"
                        },
                        {
                            "area_id": 28430,
                            "city_id": 27493,
                            "province_id": 20,
                            "name": "象州县",
                            "whole_name": "象州县，来宾市，广西壮族自治区",
                            "simple_py": "XZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0772",
                            "area_code": "451322",
                            "longitude": "109.684555",
                            "latitude": "23.959824"
                        },
                        {
                            "area_id": 28431,
                            "city_id": 27493,
                            "province_id": 20,
                            "name": "忻城县",
                            "whole_name": "忻城县，来宾市，广西壮族自治区",
                            "simple_py": "XCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0772",
                            "area_code": "451321",
                            "longitude": "108.667361",
                            "latitude": "24.064779"
                        }
                    ]
                },
                {
                    "city_id": 27492,
                    "province_id": 20,
                    "name": "南宁市",
                    "whole_name": "南宁市，广西壮族自治区",
                    "simple_py": "NNS",
                    "per_pin_yin": "N",
                    "per_pin_yin2": "N",
                    "city_code": "0771",
                    "area_code": "450100",
                    "longitude": "108.320004",
                    "latitude": "22.82402",
                    "children": [
                        {
                            "area_id": 28284,
                            "city_id": 27492,
                            "province_id": 20,
                            "name": "宾阳县",
                            "whole_name": "宾阳县，南宁市，广西壮族自治区",
                            "simple_py": "BYX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0771",
                            "area_code": "450126",
                            "longitude": "108.816735",
                            "latitude": "23.216884"
                        },
                        {
                            "area_id": 28278,
                            "city_id": 27492,
                            "province_id": 20,
                            "name": "横县",
                            "whole_name": "横县，南宁市，广西壮族自治区",
                            "simple_py": "HX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0771",
                            "area_code": "450127",
                            "longitude": "109.270987",
                            "latitude": "22.68743"
                        },
                        {
                            "area_id": 28280,
                            "city_id": 27492,
                            "province_id": 20,
                            "name": "江南区",
                            "whole_name": "江南区，南宁市，广西壮族自治区",
                            "simple_py": "JNQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0771",
                            "area_code": "450105",
                            "longitude": "108.310478",
                            "latitude": "22.799593"
                        },
                        {
                            "area_id": 28281,
                            "city_id": 27492,
                            "province_id": 20,
                            "name": "隆安县",
                            "whole_name": "隆安县，南宁市，广西壮族自治区",
                            "simple_py": "LAX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0771",
                            "area_code": "450123",
                            "longitude": "107.688661",
                            "latitude": "23.174763"
                        },
                        {
                            "area_id": 28286,
                            "city_id": 27492,
                            "province_id": 20,
                            "name": "良庆区",
                            "whole_name": "良庆区，南宁市，广西壮族自治区",
                            "simple_py": "LQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0771",
                            "area_code": "450108",
                            "longitude": "108.322102",
                            "latitude": "22.75909"
                        },
                        {
                            "area_id": 28277,
                            "city_id": 27492,
                            "province_id": 20,
                            "name": "马山县",
                            "whole_name": "马山县，南宁市，广西壮族自治区",
                            "simple_py": "MSX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0771",
                            "area_code": "450124",
                            "longitude": "108.172903",
                            "latitude": "23.711758"
                        },
                        {
                            "area_id": 28287,
                            "city_id": 27492,
                            "province_id": 20,
                            "name": "青秀区",
                            "whole_name": "青秀区，南宁市，广西壮族自治区",
                            "simple_py": "QXQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0771",
                            "area_code": "450103",
                            "longitude": "108.346113",
                            "latitude": "22.816614"
                        },
                        {
                            "area_id": 28276,
                            "city_id": 27492,
                            "province_id": 20,
                            "name": "上林县",
                            "whole_name": "上林县，南宁市，广西壮族自治区",
                            "simple_py": "SLX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0771",
                            "area_code": "450125",
                            "longitude": "108.603937",
                            "latitude": "23.431769"
                        },
                        {
                            "area_id": 28282,
                            "city_id": 27492,
                            "province_id": 20,
                            "name": "武鸣区",
                            "whole_name": "武鸣区，南宁市，广西壮族自治区",
                            "simple_py": "WMQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0771",
                            "area_code": "450110",
                            "longitude": "108.280717",
                            "latitude": "23.157163"
                        },
                        {
                            "area_id": 28279,
                            "city_id": 27492,
                            "province_id": 20,
                            "name": "西乡塘区",
                            "whole_name": "西乡塘区，南宁市，广西壮族自治区",
                            "simple_py": "XXTQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0771",
                            "area_code": "450107",
                            "longitude": "108.306903",
                            "latitude": "22.832779"
                        },
                        {
                            "area_id": 28283,
                            "city_id": 27492,
                            "province_id": 20,
                            "name": "兴宁区",
                            "whole_name": "兴宁区，南宁市，广西壮族自治区",
                            "simple_py": "XNQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0771",
                            "area_code": "450102",
                            "longitude": "108.320189",
                            "latitude": "22.819511"
                        },
                        {
                            "area_id": 28285,
                            "city_id": 27492,
                            "province_id": 20,
                            "name": "邕宁区",
                            "whole_name": "邕宁区，南宁市，广西壮族自治区",
                            "simple_py": "YNQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0771",
                            "area_code": "450109",
                            "longitude": "108.484251",
                            "latitude": "22.756598"
                        }
                    ]
                },
                {
                    "city_id": 27485,
                    "province_id": 20,
                    "name": "钦州市",
                    "whole_name": "钦州市，广西壮族自治区",
                    "simple_py": "QZS",
                    "per_pin_yin": "Q",
                    "per_pin_yin2": "Q",
                    "city_code": "0777",
                    "area_code": "450700",
                    "longitude": "108.624175",
                    "latitude": "21.967127",
                    "children": [
                        {
                            "area_id": 27500,
                            "city_id": 27485,
                            "province_id": 20,
                            "name": "灵山县",
                            "whole_name": "灵山县，钦州市，广西壮族自治区",
                            "simple_py": "LSX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0777",
                            "area_code": "450721",
                            "longitude": "109.293468",
                            "latitude": "22.418041"
                        },
                        {
                            "area_id": 27501,
                            "city_id": 27485,
                            "province_id": 20,
                            "name": "浦北县",
                            "whole_name": "浦北县，钦州市，广西壮族自治区",
                            "simple_py": "PBX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0777",
                            "area_code": "450722",
                            "longitude": "109.556341",
                            "latitude": "22.268335"
                        },
                        {
                            "area_id": 27499,
                            "city_id": 27485,
                            "province_id": 20,
                            "name": "钦南区",
                            "whole_name": "钦南区，钦州市，广西壮族自治区",
                            "simple_py": "QNQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0777",
                            "area_code": "450702",
                            "longitude": "108.626629",
                            "latitude": "21.966808"
                        },
                        {
                            "area_id": 27502,
                            "city_id": 27485,
                            "province_id": 20,
                            "name": "钦北区",
                            "whole_name": "钦北区，钦州市，广西壮族自治区",
                            "simple_py": "QBQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0777",
                            "area_code": "450703",
                            "longitude": "108.44911",
                            "latitude": "22.132761"
                        }
                    ]
                },
                {
                    "city_id": 27497,
                    "province_id": 20,
                    "name": "梧州市",
                    "whole_name": "梧州市，广西壮族自治区",
                    "simple_py": "WZS",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "0774",
                    "area_code": "450400",
                    "longitude": "111.297604",
                    "latitude": "23.474803",
                    "children": [
                        {
                            "area_id": 28703,
                            "city_id": 27497,
                            "province_id": 20,
                            "name": "岑溪市",
                            "whole_name": "岑溪市，梧州市，广西壮族自治区",
                            "simple_py": "CXS",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0774",
                            "area_code": "450481",
                            "longitude": "110.998114",
                            "latitude": "22.918406"
                        },
                        {
                            "area_id": 28706,
                            "city_id": 27497,
                            "province_id": 20,
                            "name": "长洲区",
                            "whole_name": "长洲区，梧州市，广西壮族自治区",
                            "simple_py": "CZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0774",
                            "area_code": "450405",
                            "longitude": "111.275678",
                            "latitude": "23.4777"
                        },
                        {
                            "area_id": 28707,
                            "city_id": 27497,
                            "province_id": 20,
                            "name": "苍梧县",
                            "whole_name": "苍梧县，梧州市，广西壮族自治区",
                            "simple_py": "CWX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0774",
                            "area_code": "450421",
                            "longitude": "111.544008",
                            "latitude": "23.845097"
                        },
                        {
                            "area_id": 28705,
                            "city_id": 27497,
                            "province_id": 20,
                            "name": "龙圩区",
                            "whole_name": "龙圩区，梧州市，广西壮族自治区",
                            "simple_py": "LXQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0774",
                            "area_code": "450406",
                            "longitude": "111.246035",
                            "latitude": "23.40996"
                        },
                        {
                            "area_id": 28701,
                            "city_id": 27497,
                            "province_id": 20,
                            "name": "蒙山县",
                            "whole_name": "蒙山县，梧州市，广西壮族自治区",
                            "simple_py": "MSX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0774",
                            "area_code": "450423",
                            "longitude": "110.5226",
                            "latitude": "24.199829"
                        },
                        {
                            "area_id": 28702,
                            "city_id": 27497,
                            "province_id": 20,
                            "name": "藤县",
                            "whole_name": "藤县，梧州市，广西壮族自治区",
                            "simple_py": "TX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0774",
                            "area_code": "450422",
                            "longitude": "110.931826",
                            "latitude": "23.373963"
                        },
                        {
                            "area_id": 28704,
                            "city_id": 27497,
                            "province_id": 20,
                            "name": "万秀区",
                            "whole_name": "万秀区，梧州市，广西壮族自治区",
                            "simple_py": "WXQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0774",
                            "area_code": "450403",
                            "longitude": "111.315817",
                            "latitude": "23.471318"
                        }
                    ]
                },
                {
                    "city_id": 27498,
                    "province_id": 20,
                    "name": "玉林市",
                    "whole_name": "玉林市，广西壮族自治区",
                    "simple_py": "YLS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0775",
                    "area_code": "450900",
                    "longitude": "110.154393",
                    "latitude": "22.63136",
                    "children": [
                        {
                            "area_id": 28778,
                            "city_id": 27498,
                            "province_id": 20,
                            "name": "博白县",
                            "whole_name": "博白县，玉林市，广西壮族自治区",
                            "simple_py": "BBX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0775",
                            "area_code": "450923",
                            "longitude": "109.980004",
                            "latitude": "22.271285"
                        },
                        {
                            "area_id": 28781,
                            "city_id": 27498,
                            "province_id": 20,
                            "name": "北流市",
                            "whole_name": "北流市，玉林市，广西壮族自治区",
                            "simple_py": "BLS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0775",
                            "area_code": "450981",
                            "longitude": "110.348052",
                            "latitude": "22.701648"
                        },
                        {
                            "area_id": 28776,
                            "city_id": 27498,
                            "province_id": 20,
                            "name": "福绵区",
                            "whole_name": "福绵区，玉林市，广西壮族自治区",
                            "simple_py": "FMQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0775",
                            "area_code": "450903",
                            "longitude": "110.054155",
                            "latitude": "22.58163"
                        },
                        {
                            "area_id": 28779,
                            "city_id": 27498,
                            "province_id": 20,
                            "name": "陆川县",
                            "whole_name": "陆川县，玉林市，广西壮族自治区",
                            "simple_py": "LCX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0775",
                            "area_code": "450922",
                            "longitude": "110.264842",
                            "latitude": "22.321054"
                        },
                        {
                            "area_id": 28780,
                            "city_id": 27498,
                            "province_id": 20,
                            "name": "容县",
                            "whole_name": "容县，玉林市，广西壮族自治区",
                            "simple_py": "RX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0775",
                            "area_code": "450921",
                            "longitude": "110.552467",
                            "latitude": "22.856435"
                        },
                        {
                            "area_id": 28775,
                            "city_id": 27498,
                            "province_id": 20,
                            "name": "兴业县",
                            "whole_name": "兴业县，玉林市，广西壮族自治区",
                            "simple_py": "XYX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0775",
                            "area_code": "450924",
                            "longitude": "109.877768",
                            "latitude": "22.74187"
                        },
                        {
                            "area_id": 28777,
                            "city_id": 27498,
                            "province_id": 20,
                            "name": "玉州区",
                            "whole_name": "玉州区，玉林市，广西壮族自治区",
                            "simple_py": "YZQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0775",
                            "area_code": "450902",
                            "longitude": "110.154912",
                            "latitude": "22.632132"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 29,
            "name": "甘肃省",
            "whole_name": "甘肃省",
            "simple_py": "GSS",
            "per_pin_yin": " ",
            "per_pin_yin2": "G",
            "city_code": "",
            "area_code": "620000",
            "longitude": "103.823557",
            "latitude": "36.058039",
            "children": [
                {
                    "city_id": 36617,
                    "province_id": 29,
                    "name": "白银市",
                    "whole_name": "白银市，甘肃省",
                    "simple_py": "BYS",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "0943",
                    "area_code": "620400",
                    "longitude": "104.173606",
                    "latitude": "36.54568",
                    "children": [
                        {
                            "area_id": 37004,
                            "city_id": 36617,
                            "province_id": 29,
                            "name": "白银区",
                            "whole_name": "白银区，白银市，甘肃省",
                            "simple_py": "BYQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0943",
                            "area_code": "620402",
                            "longitude": "104.17425",
                            "latitude": "36.545649"
                        },
                        {
                            "area_id": 37007,
                            "city_id": 36617,
                            "province_id": 29,
                            "name": "会宁县",
                            "whole_name": "会宁县，白银市，甘肃省",
                            "simple_py": "HNX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0943",
                            "area_code": "620422",
                            "longitude": "105.054337",
                            "latitude": "35.692486"
                        },
                        {
                            "area_id": 37003,
                            "city_id": 36617,
                            "province_id": 29,
                            "name": "靖远县",
                            "whole_name": "靖远县，白银市，甘肃省",
                            "simple_py": "JYX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0943",
                            "area_code": "620421",
                            "longitude": "104.686972",
                            "latitude": "36.561424"
                        },
                        {
                            "area_id": 37006,
                            "city_id": 36617,
                            "province_id": 29,
                            "name": "景泰县",
                            "whole_name": "景泰县，白银市，甘肃省",
                            "simple_py": "JTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0943",
                            "area_code": "620423",
                            "longitude": "104.066394",
                            "latitude": "37.193519"
                        },
                        {
                            "area_id": 37005,
                            "city_id": 36617,
                            "province_id": 29,
                            "name": "平川区",
                            "whole_name": "平川区，白银市，甘肃省",
                            "simple_py": "PCQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0943",
                            "area_code": "620403",
                            "longitude": "104.819207",
                            "latitude": "36.72921"
                        }
                    ]
                },
                {
                    "city_id": 36624,
                    "province_id": 29,
                    "name": "定西市",
                    "whole_name": "定西市，甘肃省",
                    "simple_py": "DXS",
                    "per_pin_yin": "D",
                    "per_pin_yin2": "D",
                    "city_code": "0932",
                    "area_code": "621100",
                    "longitude": "104.626294",
                    "latitude": "35.579578",
                    "children": [
                        {
                            "area_id": 37877,
                            "city_id": 36624,
                            "province_id": 29,
                            "name": "安定区",
                            "whole_name": "安定区，定西市，甘肃省",
                            "simple_py": "ADQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0932",
                            "area_code": "621102",
                            "longitude": "104.62577",
                            "latitude": "35.579764"
                        },
                        {
                            "area_id": 37873,
                            "city_id": 36624,
                            "province_id": 29,
                            "name": "临洮县",
                            "whole_name": "临洮县，定西市，甘肃省",
                            "simple_py": "LTX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0932",
                            "area_code": "621124",
                            "longitude": "103.862186",
                            "latitude": "35.376233"
                        },
                        {
                            "area_id": 37874,
                            "city_id": 36624,
                            "province_id": 29,
                            "name": "陇西县",
                            "whole_name": "陇西县，定西市，甘肃省",
                            "simple_py": "LXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0932",
                            "area_code": "621122",
                            "longitude": "104.637554",
                            "latitude": "35.003409"
                        },
                        {
                            "area_id": 37878,
                            "city_id": 36624,
                            "province_id": 29,
                            "name": "岷县",
                            "whole_name": "岷县，定西市，甘肃省",
                            "simple_py": "MX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0932",
                            "area_code": "621126",
                            "longitude": "104.039882",
                            "latitude": "34.439105"
                        },
                        {
                            "area_id": 37879,
                            "city_id": 36624,
                            "province_id": 29,
                            "name": "通渭县",
                            "whole_name": "通渭县，定西市，甘肃省",
                            "simple_py": "TWX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0932",
                            "area_code": "621121",
                            "longitude": "105.250102",
                            "latitude": "35.208922"
                        },
                        {
                            "area_id": 37876,
                            "city_id": 36624,
                            "province_id": 29,
                            "name": "渭源县",
                            "whole_name": "渭源县，定西市，甘肃省",
                            "simple_py": "WYX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0932",
                            "area_code": "621123",
                            "longitude": "104.211742",
                            "latitude": "35.133023"
                        },
                        {
                            "area_id": 37875,
                            "city_id": 36624,
                            "province_id": 29,
                            "name": "漳县",
                            "whole_name": "漳县，定西市，甘肃省",
                            "simple_py": "ZX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0932",
                            "area_code": "621125",
                            "longitude": "104.466756",
                            "latitude": "34.848642"
                        }
                    ]
                },
                {
                    "city_id": 36619,
                    "province_id": 29,
                    "name": "甘南藏族自治州",
                    "whole_name": "甘南藏族自治州，甘肃省",
                    "simple_py": "GNCZZZZ",
                    "per_pin_yin": "G",
                    "per_pin_yin2": "G",
                    "city_code": "0941",
                    "area_code": "623000",
                    "longitude": "102.911008",
                    "latitude": "34.986354",
                    "children": [
                        {
                            "area_id": 37176,
                            "city_id": 36619,
                            "province_id": 29,
                            "name": "迭部县",
                            "whole_name": "迭部县，甘南藏族自治州，甘肃省",
                            "simple_py": "DBX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0941",
                            "area_code": "623024",
                            "longitude": "103.221009",
                            "latitude": "34.055348"
                        },
                        {
                            "area_id": 37179,
                            "city_id": 36619,
                            "province_id": 29,
                            "name": "合作市",
                            "whole_name": "合作市，甘南藏族自治州，甘肃省",
                            "simple_py": "HZS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0941",
                            "area_code": "623001",
                            "longitude": "102.91149",
                            "latitude": "34.985973"
                        },
                        {
                            "area_id": 37178,
                            "city_id": 36619,
                            "province_id": 29,
                            "name": "碌曲县",
                            "whole_name": "碌曲县，甘南藏族自治州，甘肃省",
                            "simple_py": "LQX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0941",
                            "area_code": "623026",
                            "longitude": "102.488495",
                            "latitude": "34.589591"
                        },
                        {
                            "area_id": 37180,
                            "city_id": 36619,
                            "province_id": 29,
                            "name": "临潭县",
                            "whole_name": "临潭县，甘南藏族自治州，甘肃省",
                            "simple_py": "LTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0941",
                            "area_code": "623021",
                            "longitude": "103.353054",
                            "latitude": "34.69164"
                        },
                        {
                            "area_id": 37177,
                            "city_id": 36619,
                            "province_id": 29,
                            "name": "玛曲县",
                            "whole_name": "玛曲县，甘南藏族自治州，甘肃省",
                            "simple_py": "MQX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0941",
                            "area_code": "623025",
                            "longitude": "102.075767",
                            "latitude": "33.998068"
                        },
                        {
                            "area_id": 37175,
                            "city_id": 36619,
                            "province_id": 29,
                            "name": "夏河县",
                            "whole_name": "夏河县，甘南藏族自治州，甘肃省",
                            "simple_py": "XHX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0941",
                            "area_code": "623027",
                            "longitude": "102.520743",
                            "latitude": "35.200853"
                        },
                        {
                            "area_id": 37174,
                            "city_id": 36619,
                            "province_id": 29,
                            "name": "舟曲县",
                            "whole_name": "舟曲县，甘南藏族自治州，甘肃省",
                            "simple_py": "ZQX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0941",
                            "area_code": "623023",
                            "longitude": "104.370271",
                            "latitude": "33.782964"
                        },
                        {
                            "area_id": 37181,
                            "city_id": 36619,
                            "province_id": 29,
                            "name": "卓尼县",
                            "whole_name": "卓尼县，甘南藏族自治州，甘肃省",
                            "simple_py": "ZNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0941",
                            "area_code": "623022",
                            "longitude": "103.508508",
                            "latitude": "34.588165"
                        }
                    ]
                },
                {
                    "city_id": 36613,
                    "province_id": 29,
                    "name": "金昌市",
                    "whole_name": "金昌市，甘肃省",
                    "simple_py": "JCS",
                    "per_pin_yin": "J",
                    "per_pin_yin2": "J",
                    "city_code": "0935",
                    "area_code": "620300",
                    "longitude": "102.187888",
                    "latitude": "38.514238",
                    "children": [
                        {
                            "area_id": 36752,
                            "city_id": 36613,
                            "province_id": 29,
                            "name": "金川区",
                            "whole_name": "金川区，金昌市，甘肃省",
                            "simple_py": "JCQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0935",
                            "area_code": "620302",
                            "longitude": "102.187683",
                            "latitude": "38.513793"
                        },
                        {
                            "area_id": 36753,
                            "city_id": 36613,
                            "province_id": 29,
                            "name": "永昌县",
                            "whole_name": "永昌县，金昌市，甘肃省",
                            "simple_py": "YCX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0935",
                            "area_code": "620321",
                            "longitude": "101.971957",
                            "latitude": "38.247354"
                        }
                    ]
                },
                {
                    "city_id": 36614,
                    "province_id": 29,
                    "name": "嘉峪关市",
                    "whole_name": "嘉峪关市，甘肃省",
                    "simple_py": "JYGS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "J",
                    "city_code": "0937",
                    "area_code": "620200",
                    "longitude": "98.277304",
                    "latitude": "39.786529",
                    "children": [
                        {
                            "area_id": 36777,
                            "city_id": 36614,
                            "province_id": 29,
                            "name": "长城区",
                            "whole_name": "长城区，嘉峪关市，甘肃省",
                            "simple_py": "CCQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0937",
                            "area_code": "620200",
                            "longitude": "98.255",
                            "latitude": "39.8552"
                        },
                        {
                            "area_id": 36776,
                            "city_id": 36614,
                            "province_id": 29,
                            "name": "镜铁区",
                            "whole_name": "镜铁区，嘉峪关市，甘肃省",
                            "simple_py": "JTQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0937",
                            "area_code": "620200",
                            "longitude": "98.3342",
                            "latitude": "39.7378"
                        },
                        {
                            "area_id": 36775,
                            "city_id": 36614,
                            "province_id": 29,
                            "name": "雄关区",
                            "whole_name": "雄关区，嘉峪关市，甘肃省",
                            "simple_py": "XGQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0937",
                            "area_code": "620200",
                            "longitude": "98.317",
                            "latitude": "39.8839"
                        }
                    ]
                },
                {
                    "city_id": 36615,
                    "province_id": 29,
                    "name": "酒泉市",
                    "whole_name": "酒泉市，甘肃省",
                    "simple_py": "JQS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "J",
                    "city_code": "0937",
                    "area_code": "620900",
                    "longitude": "98.510795",
                    "latitude": "39.744023",
                    "children": [
                        {
                            "area_id": 36783,
                            "city_id": 36615,
                            "province_id": 29,
                            "name": "阿克塞哈萨克族自治县",
                            "whole_name": "阿克塞哈萨克族自治县，酒泉市，甘肃省",
                            "simple_py": "AKSHSKZZZX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0937",
                            "area_code": "620924",
                            "longitude": "94.337642",
                            "latitude": "39.631642"
                        },
                        {
                            "area_id": 36779,
                            "city_id": 36615,
                            "province_id": 29,
                            "name": "敦煌市",
                            "whole_name": "敦煌市，酒泉市，甘肃省",
                            "simple_py": "DHS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0937",
                            "area_code": "620982",
                            "longitude": "94.664279",
                            "latitude": "40.141119"
                        },
                        {
                            "area_id": 36784,
                            "city_id": 36615,
                            "province_id": 29,
                            "name": "瓜州县",
                            "whole_name": "瓜州县，酒泉市，甘肃省",
                            "simple_py": "GZX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0937",
                            "area_code": "620922",
                            "longitude": "95.780591",
                            "latitude": "40.516525"
                        },
                        {
                            "area_id": 36782,
                            "city_id": 36615,
                            "province_id": 29,
                            "name": "金塔县",
                            "whole_name": "金塔县，酒泉市，甘肃省",
                            "simple_py": "JTX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0937",
                            "area_code": "620921",
                            "longitude": "98.902959",
                            "latitude": "39.983036"
                        },
                        {
                            "area_id": 36780,
                            "city_id": 36615,
                            "province_id": 29,
                            "name": "肃北蒙古族自治县",
                            "whole_name": "肃北蒙古族自治县，酒泉市，甘肃省",
                            "simple_py": "SBMGZZZX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0937",
                            "area_code": "620923",
                            "longitude": "94.87728",
                            "latitude": "39.51224"
                        },
                        {
                            "area_id": 36781,
                            "city_id": 36615,
                            "province_id": 29,
                            "name": "肃州区",
                            "whole_name": "肃州区，酒泉市，甘肃省",
                            "simple_py": "SZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0937",
                            "area_code": "620902",
                            "longitude": "98.511155",
                            "latitude": "39.743858"
                        },
                        {
                            "area_id": 36778,
                            "city_id": 36615,
                            "province_id": 29,
                            "name": "玉门市",
                            "whole_name": "玉门市，酒泉市，甘肃省",
                            "simple_py": "YMS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0937",
                            "area_code": "620981",
                            "longitude": "97.037206",
                            "latitude": "40.28682"
                        }
                    ]
                },
                {
                    "city_id": 36612,
                    "province_id": 29,
                    "name": "兰州市",
                    "whole_name": "兰州市，甘肃省",
                    "simple_py": "LZS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0931",
                    "area_code": "620100",
                    "longitude": "103.823557",
                    "latitude": "36.058039",
                    "children": [
                        {
                            "area_id": 36633,
                            "city_id": 36612,
                            "province_id": 29,
                            "name": "安宁区",
                            "whole_name": "安宁区，兰州市，甘肃省",
                            "simple_py": "ANQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0931",
                            "area_code": "620105",
                            "longitude": "103.724038",
                            "latitude": "36.10329"
                        },
                        {
                            "area_id": 36632,
                            "city_id": 36612,
                            "province_id": 29,
                            "name": "城关区",
                            "whole_name": "城关区，兰州市，甘肃省",
                            "simple_py": "CGQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0931",
                            "area_code": "620102",
                            "longitude": "103.841032",
                            "latitude": "36.049115"
                        },
                        {
                            "area_id": 36626,
                            "city_id": 36612,
                            "province_id": 29,
                            "name": "皋兰县",
                            "whole_name": "皋兰县，兰州市，甘肃省",
                            "simple_py": "GLX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0931",
                            "area_code": "620122",
                            "longitude": "103.94933",
                            "latitude": "36.331254"
                        },
                        {
                            "area_id": 36627,
                            "city_id": 36612,
                            "province_id": 29,
                            "name": "红古区",
                            "whole_name": "红古区，兰州市，甘肃省",
                            "simple_py": "HGQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0931",
                            "area_code": "620111",
                            "longitude": "102.861814",
                            "latitude": "36.344177"
                        },
                        {
                            "area_id": 36630,
                            "city_id": 36612,
                            "province_id": 29,
                            "name": "七里河区",
                            "whole_name": "七里河区，兰州市，甘肃省",
                            "simple_py": "QLHQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0931",
                            "area_code": "620103",
                            "longitude": "103.784326",
                            "latitude": "36.06673"
                        },
                        {
                            "area_id": 36628,
                            "city_id": 36612,
                            "province_id": 29,
                            "name": "西固区",
                            "whole_name": "西固区，兰州市，甘肃省",
                            "simple_py": "XGQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0931",
                            "area_code": "620104",
                            "longitude": "103.622331",
                            "latitude": "36.100369"
                        },
                        {
                            "area_id": 36629,
                            "city_id": 36612,
                            "province_id": 29,
                            "name": "永登县",
                            "whole_name": "永登县，兰州市，甘肃省",
                            "simple_py": "YDX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0931",
                            "area_code": "620121",
                            "longitude": "103.262203",
                            "latitude": "36.734428"
                        },
                        {
                            "area_id": 36631,
                            "city_id": 36612,
                            "province_id": 29,
                            "name": "榆中县",
                            "whole_name": "榆中县，兰州市，甘肃省",
                            "simple_py": "YZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0931",
                            "area_code": "620123",
                            "longitude": "104.114975",
                            "latitude": "35.84443"
                        }
                    ]
                },
                {
                    "city_id": 36620,
                    "province_id": 29,
                    "name": "临夏回族自治州",
                    "whole_name": "临夏回族自治州，甘肃省",
                    "simple_py": "LXHZZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "L",
                    "city_code": "0930",
                    "area_code": "622900",
                    "longitude": "103.212006",
                    "latitude": "35.599446",
                    "children": [
                        {
                            "area_id": 37288,
                            "city_id": 36620,
                            "province_id": 29,
                            "name": "东乡族自治县",
                            "whole_name": "东乡族自治县，临夏回族自治州，甘肃省",
                            "simple_py": "DXZZZX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0930",
                            "area_code": "622926",
                            "longitude": "103.389568",
                            "latitude": "35.66383"
                        },
                        {
                            "area_id": 37289,
                            "city_id": 36620,
                            "province_id": 29,
                            "name": "广河县",
                            "whole_name": "广河县，临夏回族自治州，甘肃省",
                            "simple_py": "GHX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0930",
                            "area_code": "622924",
                            "longitude": "103.576188",
                            "latitude": "35.481688"
                        },
                        {
                            "area_id": 37293,
                            "city_id": 36620,
                            "province_id": 29,
                            "name": "和政县",
                            "whole_name": "和政县，临夏回族自治州，甘肃省",
                            "simple_py": "HZX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0930",
                            "area_code": "622925",
                            "longitude": "103.350357",
                            "latitude": "35.425971"
                        },
                        {
                            "area_id": 37291,
                            "city_id": 36620,
                            "province_id": 29,
                            "name": "积石山保安族东乡族撒拉族自治县",
                            "whole_name": "积石山保安族东乡族撒拉族自治县，临夏回族自治州，甘肃省",
                            "simple_py": "JSSBAZDXZSLZZZX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0930",
                            "area_code": "622927",
                            "longitude": "102.877473",
                            "latitude": "35.712906"
                        },
                        {
                            "area_id": 37290,
                            "city_id": 36620,
                            "province_id": 29,
                            "name": "康乐县",
                            "whole_name": "康乐县，临夏回族自治州，甘肃省",
                            "simple_py": "KLX",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0930",
                            "area_code": "622922",
                            "longitude": "103.709852",
                            "latitude": "35.371906"
                        },
                        {
                            "area_id": 37287,
                            "city_id": 36620,
                            "province_id": 29,
                            "name": "临夏县",
                            "whole_name": "临夏县，临夏回族自治州，甘肃省",
                            "simple_py": "LXX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0930",
                            "area_code": "622921",
                            "longitude": "102.993873",
                            "latitude": "35.49236"
                        },
                        {
                            "area_id": 37292,
                            "city_id": 36620,
                            "province_id": 29,
                            "name": "临夏市",
                            "whole_name": "临夏市，临夏回族自治州，甘肃省",
                            "simple_py": "LXS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0930",
                            "area_code": "622901",
                            "longitude": "103.211634",
                            "latitude": "35.59941"
                        },
                        {
                            "area_id": 37286,
                            "city_id": 36620,
                            "province_id": 29,
                            "name": "永靖县",
                            "whole_name": "永靖县，临夏回族自治州，甘肃省",
                            "simple_py": "YJX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0930",
                            "area_code": "622923",
                            "longitude": "103.319871",
                            "latitude": "35.938933"
                        }
                    ]
                },
                {
                    "city_id": 36621,
                    "province_id": 29,
                    "name": "陇南市",
                    "whole_name": "陇南市，甘肃省",
                    "simple_py": "LNS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "L",
                    "city_code": "0939",
                    "area_code": "621200",
                    "longitude": "104.929379",
                    "latitude": "33.388598",
                    "children": [
                        {
                            "area_id": 37424,
                            "city_id": 36621,
                            "province_id": 29,
                            "name": "成县",
                            "whole_name": "成县，陇南市，甘肃省",
                            "simple_py": "CX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0939",
                            "area_code": "621221",
                            "longitude": "105.734434",
                            "latitude": "33.739863"
                        },
                        {
                            "area_id": 37428,
                            "city_id": 36621,
                            "province_id": 29,
                            "name": "宕昌县",
                            "whole_name": "宕昌县，陇南市，甘肃省",
                            "simple_py": "DCX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0939",
                            "area_code": "621223",
                            "longitude": "104.394475",
                            "latitude": "34.042655"
                        },
                        {
                            "area_id": 37427,
                            "city_id": 36621,
                            "province_id": 29,
                            "name": "徽县",
                            "whole_name": "徽县，陇南市，甘肃省",
                            "simple_py": "HX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0939",
                            "area_code": "621227",
                            "longitude": "106.085632",
                            "latitude": "33.767785"
                        },
                        {
                            "area_id": 37430,
                            "city_id": 36621,
                            "province_id": 29,
                            "name": "康县",
                            "whole_name": "康县，陇南市，甘肃省",
                            "simple_py": "KX",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0939",
                            "area_code": "621224",
                            "longitude": "105.609534",
                            "latitude": "33.328266"
                        },
                        {
                            "area_id": 37426,
                            "city_id": 36621,
                            "province_id": 29,
                            "name": "礼县",
                            "whole_name": "礼县，陇南市，甘肃省",
                            "simple_py": "LX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0939",
                            "area_code": "621226",
                            "longitude": "105.181616",
                            "latitude": "34.189387"
                        },
                        {
                            "area_id": 37429,
                            "city_id": 36621,
                            "province_id": 29,
                            "name": "两当县",
                            "whole_name": "两当县，陇南市，甘肃省",
                            "simple_py": "LDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0939",
                            "area_code": "621228",
                            "longitude": "106.306959",
                            "latitude": "33.910729"
                        },
                        {
                            "area_id": 37425,
                            "city_id": 36621,
                            "province_id": 29,
                            "name": "武都区",
                            "whole_name": "武都区，陇南市，甘肃省",
                            "simple_py": "WDQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0939",
                            "area_code": "621202",
                            "longitude": "104.929866",
                            "latitude": "33.388155"
                        },
                        {
                            "area_id": 37431,
                            "city_id": 36621,
                            "province_id": 29,
                            "name": "文县",
                            "whole_name": "文县，陇南市，甘肃省",
                            "simple_py": "WX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0939",
                            "area_code": "621222",
                            "longitude": "104.682448",
                            "latitude": "32.942171"
                        },
                        {
                            "area_id": 37432,
                            "city_id": 36621,
                            "province_id": 29,
                            "name": "西和县",
                            "whole_name": "西和县，陇南市，甘肃省",
                            "simple_py": "XHX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0939",
                            "area_code": "621225",
                            "longitude": "105.299737",
                            "latitude": "34.013718"
                        }
                    ]
                },
                {
                    "city_id": 36616,
                    "province_id": 29,
                    "name": "平凉市",
                    "whole_name": "平凉市，甘肃省",
                    "simple_py": "PLS",
                    "per_pin_yin": "P",
                    "per_pin_yin2": "P",
                    "city_code": "0933",
                    "area_code": "620800",
                    "longitude": "106.684691",
                    "latitude": "35.54279",
                    "children": [
                        {
                            "area_id": 36879,
                            "city_id": 36616,
                            "province_id": 29,
                            "name": "崇信县",
                            "whole_name": "崇信县，平凉市，甘肃省",
                            "simple_py": "CXX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0933",
                            "area_code": "620823",
                            "longitude": "107.031253",
                            "latitude": "35.304533"
                        },
                        {
                            "area_id": 36880,
                            "city_id": 36616,
                            "province_id": 29,
                            "name": "华亭县",
                            "whole_name": "华亭县，平凉市，甘肃省",
                            "simple_py": "HTX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0933",
                            "area_code": "620824",
                            "longitude": "106.649308",
                            "latitude": "35.215342"
                        },
                        {
                            "area_id": 36881,
                            "city_id": 36616,
                            "province_id": 29,
                            "name": "静宁县",
                            "whole_name": "静宁县，平凉市，甘肃省",
                            "simple_py": "JNX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0933",
                            "area_code": "620826",
                            "longitude": "105.733489",
                            "latitude": "35.525243"
                        },
                        {
                            "area_id": 36882,
                            "city_id": 36616,
                            "province_id": 29,
                            "name": "泾川县",
                            "whole_name": "泾川县，平凉市，甘肃省",
                            "simple_py": "JCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0933",
                            "area_code": "620821",
                            "longitude": "107.365218",
                            "latitude": "35.335283"
                        },
                        {
                            "area_id": 36876,
                            "city_id": 36616,
                            "province_id": 29,
                            "name": "崆峒区",
                            "whole_name": "崆峒区，平凉市，甘肃省",
                            "simple_py": "KTQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0933",
                            "area_code": "620802",
                            "longitude": "106.684223",
                            "latitude": "35.54173"
                        },
                        {
                            "area_id": 36877,
                            "city_id": 36616,
                            "province_id": 29,
                            "name": "灵台县",
                            "whole_name": "灵台县，平凉市，甘肃省",
                            "simple_py": "LTX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0933",
                            "area_code": "620822",
                            "longitude": "107.620587",
                            "latitude": "35.064009"
                        },
                        {
                            "area_id": 36878,
                            "city_id": 36616,
                            "province_id": 29,
                            "name": "庄浪县",
                            "whole_name": "庄浪县，平凉市，甘肃省",
                            "simple_py": "ZLX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0933",
                            "area_code": "620825",
                            "longitude": "106.041979",
                            "latitude": "35.203428"
                        }
                    ]
                },
                {
                    "city_id": 36625,
                    "province_id": 29,
                    "name": "庆阳市",
                    "whole_name": "庆阳市，甘肃省",
                    "simple_py": "QYS",
                    "per_pin_yin": "Q",
                    "per_pin_yin2": "Q",
                    "city_code": "0934",
                    "area_code": "621000",
                    "longitude": "107.638372",
                    "latitude": "35.734218",
                    "children": [
                        {
                            "area_id": 38001,
                            "city_id": 36625,
                            "province_id": 29,
                            "name": "合水县",
                            "whole_name": "合水县，庆阳市，甘肃省",
                            "simple_py": "HSX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0934",
                            "area_code": "621024",
                            "longitude": "108.019865",
                            "latitude": "35.819005"
                        },
                        {
                            "area_id": 38003,
                            "city_id": 36625,
                            "province_id": 29,
                            "name": "华池县",
                            "whole_name": "华池县，庆阳市，甘肃省",
                            "simple_py": "HCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0934",
                            "area_code": "621023",
                            "longitude": "107.986288",
                            "latitude": "36.457304"
                        },
                        {
                            "area_id": 38007,
                            "city_id": 36625,
                            "province_id": 29,
                            "name": "环县",
                            "whole_name": "环县，庆阳市，甘肃省",
                            "simple_py": "HX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0934",
                            "area_code": "621022",
                            "longitude": "107.308754",
                            "latitude": "36.569322"
                        },
                        {
                            "area_id": 38006,
                            "city_id": 36625,
                            "province_id": 29,
                            "name": "宁县",
                            "whole_name": "宁县，庆阳市，甘肃省",
                            "simple_py": "NX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0934",
                            "area_code": "621026",
                            "longitude": "107.921182",
                            "latitude": "35.50201"
                        },
                        {
                            "area_id": 38002,
                            "city_id": 36625,
                            "province_id": 29,
                            "name": "庆城县",
                            "whole_name": "庆城县，庆阳市，甘肃省",
                            "simple_py": "QCX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0934",
                            "area_code": "621021",
                            "longitude": "107.885664",
                            "latitude": "36.013504"
                        },
                        {
                            "area_id": 38008,
                            "city_id": 36625,
                            "province_id": 29,
                            "name": "西峰区",
                            "whole_name": "西峰区，庆阳市，甘肃省",
                            "simple_py": "XFQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0934",
                            "area_code": "621002",
                            "longitude": "107.638824",
                            "latitude": "35.733713"
                        },
                        {
                            "area_id": 38004,
                            "city_id": 36625,
                            "province_id": 29,
                            "name": "正宁县",
                            "whole_name": "正宁县，庆阳市，甘肃省",
                            "simple_py": "ZNX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0934",
                            "area_code": "621025",
                            "longitude": "108.361068",
                            "latitude": "35.490642"
                        },
                        {
                            "area_id": 38005,
                            "city_id": 36625,
                            "province_id": 29,
                            "name": "镇原县",
                            "whole_name": "镇原县，庆阳市，甘肃省",
                            "simple_py": "ZYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0934",
                            "area_code": "621027",
                            "longitude": "107.195706",
                            "latitude": "35.677806"
                        }
                    ]
                },
                {
                    "city_id": 36622,
                    "province_id": 29,
                    "name": "天水市",
                    "whole_name": "天水市，甘肃省",
                    "simple_py": "TSS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0938",
                    "area_code": "620500",
                    "longitude": "105.724998",
                    "latitude": "34.578529",
                    "children": [
                        {
                            "area_id": 37634,
                            "city_id": 36622,
                            "province_id": 29,
                            "name": "甘谷县",
                            "whole_name": "甘谷县，天水市，甘肃省",
                            "simple_py": "GGX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0938",
                            "area_code": "620523",
                            "longitude": "105.332347",
                            "latitude": "34.747327"
                        },
                        {
                            "area_id": 37632,
                            "city_id": 36622,
                            "province_id": 29,
                            "name": "麦积区",
                            "whole_name": "麦积区，天水市，甘肃省",
                            "simple_py": "MJQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0938",
                            "area_code": "620503",
                            "longitude": "105.897631",
                            "latitude": "34.563504"
                        },
                        {
                            "area_id": 37630,
                            "city_id": 36622,
                            "province_id": 29,
                            "name": "秦安县",
                            "whole_name": "秦安县，天水市，甘肃省",
                            "simple_py": "QAX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0938",
                            "area_code": "620522",
                            "longitude": "105.6733",
                            "latitude": "34.862354"
                        },
                        {
                            "area_id": 37631,
                            "city_id": 36622,
                            "province_id": 29,
                            "name": "清水县",
                            "whole_name": "清水县，天水市，甘肃省",
                            "simple_py": "QSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0938",
                            "area_code": "620521",
                            "longitude": "106.139878",
                            "latitude": "34.75287"
                        },
                        {
                            "area_id": 37633,
                            "city_id": 36622,
                            "province_id": 29,
                            "name": "秦州区",
                            "whole_name": "秦州区，天水市，甘肃省",
                            "simple_py": "QZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0938",
                            "area_code": "620502",
                            "longitude": "105.724477",
                            "latitude": "34.578645"
                        },
                        {
                            "area_id": 37629,
                            "city_id": 36622,
                            "province_id": 29,
                            "name": "武山县",
                            "whole_name": "武山县，天水市，甘肃省",
                            "simple_py": "WSX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0938",
                            "area_code": "620524",
                            "longitude": "104.891696",
                            "latitude": "34.721955"
                        },
                        {
                            "area_id": 37628,
                            "city_id": 36622,
                            "province_id": 29,
                            "name": "张家川回族自治县",
                            "whole_name": "张家川回族自治县，天水市，甘肃省",
                            "simple_py": "ZJCHZZZX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0938",
                            "area_code": "620525",
                            "longitude": "106.212416",
                            "latitude": "34.993237"
                        }
                    ]
                },
                {
                    "city_id": 36623,
                    "province_id": 29,
                    "name": "武威市",
                    "whole_name": "武威市，甘肃省",
                    "simple_py": "WWS",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "0935",
                    "area_code": "620600",
                    "longitude": "102.634697",
                    "latitude": "37.929996",
                    "children": [
                        {
                            "area_id": 37766,
                            "city_id": 36623,
                            "province_id": 29,
                            "name": "古浪县",
                            "whole_name": "古浪县，武威市，甘肃省",
                            "simple_py": "GLX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0935",
                            "area_code": "620622",
                            "longitude": "102.898047",
                            "latitude": "37.470571"
                        },
                        {
                            "area_id": 37767,
                            "city_id": 36623,
                            "province_id": 29,
                            "name": "凉州区",
                            "whole_name": "凉州区，武威市，甘肃省",
                            "simple_py": "LZQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0935",
                            "area_code": "620602",
                            "longitude": "102.634492",
                            "latitude": "37.93025"
                        },
                        {
                            "area_id": 37768,
                            "city_id": 36623,
                            "province_id": 29,
                            "name": "民勤县",
                            "whole_name": "民勤县，武威市，甘肃省",
                            "simple_py": "MQX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0935",
                            "area_code": "620621",
                            "longitude": "103.090654",
                            "latitude": "38.624621"
                        },
                        {
                            "area_id": 37765,
                            "city_id": 36623,
                            "province_id": 29,
                            "name": "天祝藏族自治县",
                            "whole_name": "天祝藏族自治县，武威市，甘肃省",
                            "simple_py": "TZCZZZX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0935",
                            "area_code": "620623",
                            "longitude": "103.142034",
                            "latitude": "36.971678"
                        }
                    ]
                },
                {
                    "city_id": 36618,
                    "province_id": 29,
                    "name": "张掖市",
                    "whole_name": "张掖市，甘肃省",
                    "simple_py": "ZYS",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "0936",
                    "area_code": "620700",
                    "longitude": "100.455472",
                    "latitude": "38.932897",
                    "children": [
                        {
                            "area_id": 37087,
                            "city_id": 36618,
                            "province_id": 29,
                            "name": "高台县",
                            "whole_name": "高台县，张掖市，甘肃省",
                            "simple_py": "GTX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0936",
                            "area_code": "620724",
                            "longitude": "99.81665",
                            "latitude": "39.376308"
                        },
                        {
                            "area_id": 37090,
                            "city_id": 36618,
                            "province_id": 29,
                            "name": "甘州区",
                            "whole_name": "甘州区，张掖市，甘肃省",
                            "simple_py": "GZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0936",
                            "area_code": "620702",
                            "longitude": "100.454862",
                            "latitude": "38.931774"
                        },
                        {
                            "area_id": 37089,
                            "city_id": 36618,
                            "province_id": 29,
                            "name": "临泽县",
                            "whole_name": "临泽县，张掖市，甘肃省",
                            "simple_py": "LZX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0936",
                            "area_code": "620723",
                            "longitude": "100.166333",
                            "latitude": "39.152151"
                        },
                        {
                            "area_id": 37092,
                            "city_id": 36618,
                            "province_id": 29,
                            "name": "民乐县",
                            "whole_name": "民乐县，张掖市，甘肃省",
                            "simple_py": "MLX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0936",
                            "area_code": "620722",
                            "longitude": "100.816623",
                            "latitude": "38.434454"
                        },
                        {
                            "area_id": 37088,
                            "city_id": 36618,
                            "province_id": 29,
                            "name": "肃南裕固族自治县",
                            "whole_name": "肃南裕固族自治县，张掖市，甘肃省",
                            "simple_py": "SNYGZZZX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0936",
                            "area_code": "620721",
                            "longitude": "99.617086",
                            "latitude": "38.837269"
                        },
                        {
                            "area_id": 37091,
                            "city_id": 36618,
                            "province_id": 29,
                            "name": "山丹县",
                            "whole_name": "山丹县，张掖市，甘肃省",
                            "simple_py": "SDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0936",
                            "area_code": "620725",
                            "longitude": "101.088442",
                            "latitude": "38.784839"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 2,
            "name": "河南省",
            "whole_name": "河南省",
            "simple_py": "HNS",
            "per_pin_yin": "H",
            "per_pin_yin2": "H",
            "city_code": "",
            "area_code": "410000",
            "longitude": "113.665412",
            "latitude": "34.757975",
            "children": [
                {
                    "city_id": 1952,
                    "province_id": 2,
                    "name": "安阳市",
                    "whole_name": "安阳市，河南省",
                    "simple_py": "AYS",
                    "per_pin_yin": "A",
                    "per_pin_yin2": "A",
                    "city_code": "0372",
                    "area_code": "410500",
                    "longitude": "114.352482",
                    "latitude": "36.103442",
                    "children": [
                        {
                            "area_id": 3509,
                            "city_id": 1952,
                            "province_id": 2,
                            "name": "安阳县",
                            "whole_name": "安阳县，安阳市，河南省",
                            "simple_py": "AYX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0372",
                            "area_code": "410522",
                            "longitude": "114.130207",
                            "latitude": "36.130585"
                        },
                        {
                            "area_id": 3508,
                            "city_id": 1952,
                            "province_id": 2,
                            "name": "北关区",
                            "whole_name": "北关区，安阳市，河南省",
                            "simple_py": "BGQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0372",
                            "area_code": "410503",
                            "longitude": "114.352646",
                            "latitude": "36.10978"
                        },
                        {
                            "area_id": 3506,
                            "city_id": 1952,
                            "province_id": 2,
                            "name": "滑县",
                            "whole_name": "滑县，安阳市，河南省",
                            "simple_py": "HX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0372",
                            "area_code": "410526",
                            "longitude": "114.524",
                            "latitude": "35.574628"
                        },
                        {
                            "area_id": 3504,
                            "city_id": 1952,
                            "province_id": 2,
                            "name": "龙安区",
                            "whole_name": "龙安区，安阳市，河南省",
                            "simple_py": "LAQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0372",
                            "area_code": "410506",
                            "longitude": "114.323522",
                            "latitude": "36.095568"
                        },
                        {
                            "area_id": 3510,
                            "city_id": 1952,
                            "province_id": 2,
                            "name": "林州市",
                            "whole_name": "林州市，安阳市，河南省",
                            "simple_py": "LZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0372",
                            "area_code": "410581",
                            "longitude": "113.823767",
                            "latitude": "36.063403"
                        },
                        {
                            "area_id": 3503,
                            "city_id": 1952,
                            "province_id": 2,
                            "name": "内黄县",
                            "whole_name": "内黄县，安阳市，河南省",
                            "simple_py": "NHX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0372",
                            "area_code": "410527",
                            "longitude": "114.904582",
                            "latitude": "35.953702"
                        },
                        {
                            "area_id": 3505,
                            "city_id": 1952,
                            "province_id": 2,
                            "name": "汤阴县",
                            "whole_name": "汤阴县，安阳市，河南省",
                            "simple_py": "TYX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0372",
                            "area_code": "410523",
                            "longitude": "114.362357",
                            "latitude": "35.922349"
                        },
                        {
                            "area_id": 3507,
                            "city_id": 1952,
                            "province_id": 2,
                            "name": "文峰区",
                            "whole_name": "文峰区，安阳市，河南省",
                            "simple_py": "WFQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0372",
                            "area_code": "410502",
                            "longitude": "114.352562",
                            "latitude": "36.098101"
                        },
                        {
                            "area_id": 3502,
                            "city_id": 1952,
                            "province_id": 2,
                            "name": "殷都区",
                            "whole_name": "殷都区，安阳市，河南省",
                            "simple_py": "YDQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0372",
                            "area_code": "410505",
                            "longitude": "114.300098",
                            "latitude": "36.108974"
                        }
                    ]
                },
                {
                    "city_id": 1956,
                    "province_id": 2,
                    "name": "鹤壁市",
                    "whole_name": "鹤壁市，河南省",
                    "simple_py": "HBS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0392",
                    "area_code": "410600",
                    "longitude": "114.295444",
                    "latitude": "35.748236",
                    "children": [
                        {
                            "area_id": 4234,
                            "city_id": 1956,
                            "province_id": 2,
                            "name": "鹤山区",
                            "whole_name": "鹤山区，鹤壁市，河南省",
                            "simple_py": "HSQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0392",
                            "area_code": "410602",
                            "longitude": "114.166551",
                            "latitude": "35.936128"
                        },
                        {
                            "area_id": 4235,
                            "city_id": 1956,
                            "province_id": 2,
                            "name": "浚县",
                            "whole_name": "浚县，鹤壁市，河南省",
                            "simple_py": "JX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0392",
                            "area_code": "410621",
                            "longitude": "114.550162",
                            "latitude": "35.671282"
                        },
                        {
                            "area_id": 4233,
                            "city_id": 1956,
                            "province_id": 2,
                            "name": "淇滨区",
                            "whole_name": "淇滨区，鹤壁市，河南省",
                            "simple_py": "QBQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0392",
                            "area_code": "410611",
                            "longitude": "114.293917",
                            "latitude": "35.748382"
                        },
                        {
                            "area_id": 4236,
                            "city_id": 1956,
                            "province_id": 2,
                            "name": "淇县",
                            "whole_name": "淇县，鹤壁市，河南省",
                            "simple_py": "QX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0392",
                            "area_code": "410622",
                            "longitude": "114.200379",
                            "latitude": "35.609478"
                        },
                        {
                            "area_id": 4237,
                            "city_id": 1956,
                            "province_id": 2,
                            "name": "山城区",
                            "whole_name": "山城区，鹤壁市，河南省",
                            "simple_py": "SCQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0392",
                            "area_code": "410603",
                            "longitude": "114.184202",
                            "latitude": "35.896058"
                        }
                    ]
                },
                {
                    "city_id": 1948,
                    "province_id": 2,
                    "name": "济源市",
                    "whole_name": "济源市，河南省",
                    "simple_py": "JYS",
                    "per_pin_yin": "J",
                    "per_pin_yin2": "J",
                    "city_code": "0391",
                    "area_code": "419001",
                    "longitude": "112.590047",
                    "latitude": "35.090378",
                    "children": [
                        {
                            "area_id": 2986,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市坡头镇",
                            "whole_name": "济源市坡头镇，济源市，河南省",
                            "simple_py": "JYSPTZ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.538",
                            "latitude": "34.9308"
                        },
                        {
                            "area_id": 2987,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市梨林镇",
                            "whole_name": "济源市梨林镇，济源市，河南省",
                            "simple_py": "JYSLLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.753",
                            "latitude": "35.0882"
                        },
                        {
                            "area_id": 2988,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市思礼镇",
                            "whole_name": "济源市思礼镇，济源市，河南省",
                            "simple_py": "JYSSLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.388",
                            "latitude": "35.2103"
                        },
                        {
                            "area_id": 2989,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市大峪镇",
                            "whole_name": "济源市大峪镇，济源市，河南省",
                            "simple_py": "JYSDYZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.338",
                            "latitude": "34.9398"
                        },
                        {
                            "area_id": 2990,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市五龙口镇",
                            "whole_name": "济源市五龙口镇，济源市，河南省",
                            "simple_py": "JYSWLKZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.761",
                            "latitude": "35.1956"
                        },
                        {
                            "area_id": 2991,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市王屋镇",
                            "whole_name": "济源市王屋镇，济源市，河南省",
                            "simple_py": "JYSWWZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.169",
                            "latitude": "35.1244"
                        },
                        {
                            "area_id": 2992,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市玉泉街道",
                            "whole_name": "济源市玉泉街道，济源市，河南省",
                            "simple_py": "JYSYQJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.624",
                            "latitude": "35.1189"
                        },
                        {
                            "area_id": 2993,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市轵城镇",
                            "whole_name": "济源市轵城镇，济源市，河南省",
                            "simple_py": "JYSZCZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.622",
                            "latitude": "35.0625"
                        },
                        {
                            "area_id": 2994,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市济水街道",
                            "whole_name": "济源市济水街道，济源市，河南省",
                            "simple_py": "JYSJSJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.595",
                            "latitude": "35.0944"
                        },
                        {
                            "area_id": 2995,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市沁园街道",
                            "whole_name": "济源市沁园街道，济源市，河南省",
                            "simple_py": "JYSQYJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.593",
                            "latitude": "35.0822"
                        },
                        {
                            "area_id": 2996,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市下冶镇",
                            "whole_name": "济源市下冶镇，济源市，河南省",
                            "simple_py": "JYSXYZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.212",
                            "latitude": "35.1131"
                        },
                        {
                            "area_id": 2997,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市天坛街道",
                            "whole_name": "济源市天坛街道，济源市，河南省",
                            "simple_py": "JYSTTJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.567",
                            "latitude": "35.1229"
                        },
                        {
                            "area_id": 2998,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市克井镇",
                            "whole_name": "济源市克井镇，济源市，河南省",
                            "simple_py": "JYSKJZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.635",
                            "latitude": "35.255"
                        },
                        {
                            "area_id": 2999,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市邵原镇",
                            "whole_name": "济源市邵原镇，济源市，河南省",
                            "simple_py": "JYSSYZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.113",
                            "latitude": "35.2704"
                        },
                        {
                            "area_id": 3000,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市北海街道",
                            "whole_name": "济源市北海街道，济源市，河南省",
                            "simple_py": "JYSBHJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.569",
                            "latitude": "35.1116"
                        },
                        {
                            "area_id": 3001,
                            "city_id": 1948,
                            "province_id": 2,
                            "name": "济源市承留镇",
                            "whole_name": "济源市承留镇，济源市，河南省",
                            "simple_py": "JYSCLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "419001",
                            "longitude": "112.509",
                            "latitude": "35.0243"
                        }
                    ]
                },
                {
                    "city_id": 1951,
                    "province_id": 2,
                    "name": "焦作市",
                    "whole_name": "焦作市，河南省",
                    "simple_py": "JZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "J",
                    "city_code": "0391",
                    "area_code": "410800",
                    "longitude": "113.238266",
                    "latitude": "35.23904",
                    "children": [
                        {
                            "area_id": 3390,
                            "city_id": 1951,
                            "province_id": 2,
                            "name": "博爱县",
                            "whole_name": "博爱县，焦作市，河南省",
                            "simple_py": "BAX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0391",
                            "area_code": "410822",
                            "longitude": "113.069313",
                            "latitude": "35.170351"
                        },
                        {
                            "area_id": 3385,
                            "city_id": 1951,
                            "province_id": 2,
                            "name": "解放区",
                            "whole_name": "解放区，焦作市，河南省",
                            "simple_py": "JFQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0391",
                            "area_code": "410802",
                            "longitude": "113.226126",
                            "latitude": "35.241353"
                        },
                        {
                            "area_id": 3384,
                            "city_id": 1951,
                            "province_id": 2,
                            "name": "马村区",
                            "whole_name": "马村区，焦作市，河南省",
                            "simple_py": "MCQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0391",
                            "area_code": "410804",
                            "longitude": "113.321703",
                            "latitude": "35.265453"
                        },
                        {
                            "area_id": 3388,
                            "city_id": 1951,
                            "province_id": 2,
                            "name": "孟州市",
                            "whole_name": "孟州市，焦作市，河南省",
                            "simple_py": "MZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0391",
                            "area_code": "410883",
                            "longitude": "112.78708",
                            "latitude": "34.90963"
                        },
                        {
                            "area_id": 3386,
                            "city_id": 1951,
                            "province_id": 2,
                            "name": "沁阳市",
                            "whole_name": "沁阳市，焦作市，河南省",
                            "simple_py": "QYS",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0391",
                            "area_code": "410882",
                            "longitude": "112.934538",
                            "latitude": "35.08901"
                        },
                        {
                            "area_id": 3389,
                            "city_id": 1951,
                            "province_id": 2,
                            "name": "山阳区",
                            "whole_name": "山阳区，焦作市，河南省",
                            "simple_py": "SYQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0391",
                            "area_code": "410811",
                            "longitude": "113.26766",
                            "latitude": "35.21476"
                        },
                        {
                            "area_id": 3387,
                            "city_id": 1951,
                            "province_id": 2,
                            "name": "温县",
                            "whole_name": "温县，焦作市，河南省",
                            "simple_py": "WX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0391",
                            "area_code": "410825",
                            "longitude": "113.079118",
                            "latitude": "34.941233"
                        },
                        {
                            "area_id": 3391,
                            "city_id": 1951,
                            "province_id": 2,
                            "name": "武陟县",
                            "whole_name": "武陟县，焦作市，河南省",
                            "simple_py": "WZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0391",
                            "area_code": "410823",
                            "longitude": "113.408334",
                            "latitude": "35.09885"
                        },
                        {
                            "area_id": 3392,
                            "city_id": 1951,
                            "province_id": 2,
                            "name": "修武县",
                            "whole_name": "修武县，焦作市，河南省",
                            "simple_py": "XWX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0391",
                            "area_code": "410821",
                            "longitude": "113.447465",
                            "latitude": "35.229923"
                        },
                        {
                            "area_id": 3393,
                            "city_id": 1951,
                            "province_id": 2,
                            "name": "中站区",
                            "whole_name": "中站区，焦作市，河南省",
                            "simple_py": "ZZQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0391",
                            "area_code": "410803",
                            "longitude": "113.175485",
                            "latitude": "35.236145"
                        }
                    ]
                },
                {
                    "city_id": 1958,
                    "province_id": 2,
                    "name": "开封市",
                    "whole_name": "开封市，河南省",
                    "simple_py": "KFS",
                    "per_pin_yin": "K",
                    "per_pin_yin2": "K",
                    "city_code": "0371",
                    "area_code": "410200",
                    "longitude": "114.341447",
                    "latitude": "34.797049",
                    "children": [
                        {
                            "area_id": 4504,
                            "city_id": 1958,
                            "province_id": 2,
                            "name": "鼓楼区",
                            "whole_name": "鼓楼区，开封市，河南省",
                            "simple_py": "GLQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0371",
                            "area_code": "410204",
                            "longitude": "114.3485",
                            "latitude": "34.792383"
                        },
                        {
                            "area_id": 4502,
                            "city_id": 1958,
                            "province_id": 2,
                            "name": "兰考县",
                            "whole_name": "兰考县，开封市，河南省",
                            "simple_py": "LKX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0371",
                            "area_code": "410225",
                            "longitude": "114.820572",
                            "latitude": "34.829899"
                        },
                        {
                            "area_id": 4508,
                            "city_id": 1958,
                            "province_id": 2,
                            "name": "龙亭区",
                            "whole_name": "龙亭区，开封市，河南省",
                            "simple_py": "LTQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0371",
                            "area_code": "410202",
                            "longitude": "114.353348",
                            "latitude": "34.799833"
                        },
                        {
                            "area_id": 4507,
                            "city_id": 1958,
                            "province_id": 2,
                            "name": "杞县",
                            "whole_name": "杞县，开封市，河南省",
                            "simple_py": "QX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0371",
                            "area_code": "410221",
                            "longitude": "114.770472",
                            "latitude": "34.554585"
                        },
                        {
                            "area_id": 4505,
                            "city_id": 1958,
                            "province_id": 2,
                            "name": "顺河回族区",
                            "whole_name": "顺河回族区，开封市，河南省",
                            "simple_py": "SHHZQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0371",
                            "area_code": "410203",
                            "longitude": "114.364875",
                            "latitude": "34.800459"
                        },
                        {
                            "area_id": 4510,
                            "city_id": 1958,
                            "province_id": 2,
                            "name": "通许县",
                            "whole_name": "通许县，开封市，河南省",
                            "simple_py": "TXX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0371",
                            "area_code": "410222",
                            "longitude": "114.467734",
                            "latitude": "34.477302"
                        },
                        {
                            "area_id": 4509,
                            "city_id": 1958,
                            "province_id": 2,
                            "name": "尉氏县",
                            "whole_name": "尉氏县，开封市，河南省",
                            "simple_py": "WSX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0371",
                            "area_code": "410223",
                            "longitude": "114.193927",
                            "latitude": "34.412256"
                        },
                        {
                            "area_id": 4503,
                            "city_id": 1958,
                            "province_id": 2,
                            "name": "祥符区",
                            "whole_name": "祥符区，开封市，河南省",
                            "simple_py": "XFQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0371",
                            "area_code": "410212",
                            "longitude": "114.437622",
                            "latitude": "34.756476"
                        },
                        {
                            "area_id": 4506,
                            "city_id": 1958,
                            "province_id": 2,
                            "name": "禹王台区",
                            "whole_name": "禹王台区，开封市，河南省",
                            "simple_py": "YWTQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0371",
                            "area_code": "410205",
                            "longitude": "114.350246",
                            "latitude": "34.779727"
                        }
                    ]
                },
                {
                    "city_id": 1942,
                    "province_id": 2,
                    "name": "洛阳市",
                    "whole_name": "洛阳市，河南省",
                    "simple_py": "LYS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0379",
                    "area_code": "410300",
                    "longitude": "112.434468",
                    "latitude": "34.663041",
                    "children": [
                        {
                            "area_id": 2065,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "瀍河回族区",
                            "whole_name": "瀍河回族区，洛阳市，河南省",
                            "simple_py": "CHHZQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0379",
                            "area_code": "410304",
                            "longitude": "112.491625",
                            "latitude": "34.684738"
                        },
                        {
                            "area_id": 2059,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "涧西区",
                            "whole_name": "涧西区，洛阳市，河南省",
                            "simple_py": "JXQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0379",
                            "area_code": "410305",
                            "longitude": "112.399243",
                            "latitude": "34.654251"
                        },
                        {
                            "area_id": 2061,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "吉利区",
                            "whole_name": "吉利区，洛阳市，河南省",
                            "simple_py": "JLQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0379",
                            "area_code": "410306",
                            "longitude": "112.584796",
                            "latitude": "34.899093"
                        },
                        {
                            "area_id": 2057,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "栾川县",
                            "whole_name": "栾川县，洛阳市，河南省",
                            "simple_py": "LCX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0379",
                            "area_code": "410324",
                            "longitude": "111.618386",
                            "latitude": "33.783195"
                        },
                        {
                            "area_id": 2063,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "洛宁县",
                            "whole_name": "洛宁县，洛阳市，河南省",
                            "simple_py": "LNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0379",
                            "area_code": "410328",
                            "longitude": "111.655399",
                            "latitude": "34.387179"
                        },
                        {
                            "area_id": 2066,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "洛龙区",
                            "whole_name": "洛龙区，洛阳市，河南省",
                            "simple_py": "LLQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0379",
                            "area_code": "410311",
                            "longitude": "112.456634",
                            "latitude": "34.618557"
                        },
                        {
                            "area_id": 2067,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "老城区",
                            "whole_name": "老城区，洛阳市，河南省",
                            "simple_py": "LCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0379",
                            "area_code": "410302",
                            "longitude": "112.477298",
                            "latitude": "34.682945"
                        },
                        {
                            "area_id": 2055,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "孟津县",
                            "whole_name": "孟津县，洛阳市，河南省",
                            "simple_py": "MJX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0379",
                            "area_code": "410322",
                            "longitude": "112.443892",
                            "latitude": "34.826485"
                        },
                        {
                            "area_id": 2058,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "汝阳县",
                            "whole_name": "汝阳县，洛阳市，河南省",
                            "simple_py": "RYX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0379",
                            "area_code": "410326",
                            "longitude": "112.473789",
                            "latitude": "34.15323"
                        },
                        {
                            "area_id": 2056,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "嵩县",
                            "whole_name": "嵩县，洛阳市，河南省",
                            "simple_py": "SX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0379",
                            "area_code": "410325",
                            "longitude": "112.087765",
                            "latitude": "34.131563"
                        },
                        {
                            "area_id": 2054,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "新安县",
                            "whole_name": "新安县，洛阳市，河南省",
                            "simple_py": "XAX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0379",
                            "area_code": "410323",
                            "longitude": "112.141403",
                            "latitude": "34.728679"
                        },
                        {
                            "area_id": 2068,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "西工区",
                            "whole_name": "西工区，洛阳市，河南省",
                            "simple_py": "XGQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0379",
                            "area_code": "410303",
                            "longitude": "112.443232",
                            "latitude": "34.667847"
                        },
                        {
                            "area_id": 2060,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "伊川县",
                            "whole_name": "伊川县，洛阳市，河南省",
                            "simple_py": "YCX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0379",
                            "area_code": "410329",
                            "longitude": "112.429384",
                            "latitude": "34.423416"
                        },
                        {
                            "area_id": 2062,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "宜阳县",
                            "whole_name": "宜阳县，洛阳市，河南省",
                            "simple_py": "YYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0379",
                            "area_code": "410327",
                            "longitude": "112.179989",
                            "latitude": "34.516478"
                        },
                        {
                            "area_id": 2064,
                            "city_id": 1942,
                            "province_id": 2,
                            "name": "偃师市",
                            "whole_name": "偃师市，洛阳市，河南省",
                            "simple_py": "YSS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0379",
                            "area_code": "410381",
                            "longitude": "112.787739",
                            "latitude": "34.723042"
                        }
                    ]
                },
                {
                    "city_id": 1947,
                    "province_id": 2,
                    "name": "漯河市",
                    "whole_name": "漯河市，河南省",
                    "simple_py": "LHS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "L",
                    "city_code": "0395",
                    "area_code": "411100",
                    "longitude": "114.026405",
                    "latitude": "33.575855",
                    "children": [
                        {
                            "area_id": 2927,
                            "city_id": 1947,
                            "province_id": 2,
                            "name": "临颍县",
                            "whole_name": "临颍县，漯河市，河南省",
                            "simple_py": "LYX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0395",
                            "area_code": "411122",
                            "longitude": "113.938891",
                            "latitude": "33.80609"
                        },
                        {
                            "area_id": 2929,
                            "city_id": 1947,
                            "province_id": 2,
                            "name": "舞阳县",
                            "whole_name": "舞阳县，漯河市，河南省",
                            "simple_py": "WYX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0395",
                            "area_code": "411121",
                            "longitude": "113.610565",
                            "latitude": "33.436278"
                        },
                        {
                            "area_id": 2926,
                            "city_id": 1947,
                            "province_id": 2,
                            "name": "郾城区",
                            "whole_name": "郾城区，漯河市，河南省",
                            "simple_py": "YCQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0395",
                            "area_code": "411103",
                            "longitude": "114.016813",
                            "latitude": "33.588897"
                        },
                        {
                            "area_id": 2930,
                            "city_id": 1947,
                            "province_id": 2,
                            "name": "源汇区",
                            "whole_name": "源汇区，漯河市，河南省",
                            "simple_py": "YHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0395",
                            "area_code": "411102",
                            "longitude": "114.017948",
                            "latitude": "33.565441"
                        },
                        {
                            "area_id": 2928,
                            "city_id": 1947,
                            "province_id": 2,
                            "name": "召陵区",
                            "whole_name": "召陵区，漯河市，河南省",
                            "simple_py": "ZLQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0395",
                            "area_code": "411104",
                            "longitude": "114.051686",
                            "latitude": "33.567555"
                        }
                    ]
                },
                {
                    "city_id": 1946,
                    "province_id": 2,
                    "name": "南阳市",
                    "whole_name": "南阳市，河南省",
                    "simple_py": "NYS",
                    "per_pin_yin": "N",
                    "per_pin_yin2": "N",
                    "city_code": "0377",
                    "area_code": "411300",
                    "longitude": "112.540918",
                    "latitude": "32.999082",
                    "children": [
                        {
                            "area_id": 2673,
                            "city_id": 1946,
                            "province_id": 2,
                            "name": "邓州市",
                            "whole_name": "邓州市，南阳市，河南省",
                            "simple_py": "DZS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0377",
                            "area_code": "411381",
                            "longitude": "112.092716",
                            "latitude": "32.681642"
                        },
                        {
                            "area_id": 2669,
                            "city_id": 1946,
                            "province_id": 2,
                            "name": "方城县",
                            "whole_name": "方城县，南阳市，河南省",
                            "simple_py": "FCX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0377",
                            "area_code": "411322",
                            "longitude": "113.010933",
                            "latitude": "33.255138"
                        },
                        {
                            "area_id": 2664,
                            "city_id": 1946,
                            "province_id": 2,
                            "name": "南召县",
                            "whole_name": "南召县，南阳市，河南省",
                            "simple_py": "NZX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0377",
                            "area_code": "411321",
                            "longitude": "112.435583",
                            "latitude": "33.488617"
                        },
                        {
                            "area_id": 2671,
                            "city_id": 1946,
                            "province_id": 2,
                            "name": "内乡县",
                            "whole_name": "内乡县，南阳市，河南省",
                            "simple_py": "NXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0377",
                            "area_code": "411325",
                            "longitude": "111.843801",
                            "latitude": "33.046358"
                        },
                        {
                            "area_id": 2668,
                            "city_id": 1946,
                            "province_id": 2,
                            "name": "社旗县",
                            "whole_name": "社旗县，南阳市，河南省",
                            "simple_py": "SQX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0377",
                            "area_code": "411327",
                            "longitude": "112.938279",
                            "latitude": "33.056126"
                        },
                        {
                            "area_id": 2666,
                            "city_id": 1946,
                            "province_id": 2,
                            "name": "唐河县",
                            "whole_name": "唐河县，南阳市，河南省",
                            "simple_py": "THX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0377",
                            "area_code": "411328",
                            "longitude": "112.838492",
                            "latitude": "32.687892"
                        },
                        {
                            "area_id": 2667,
                            "city_id": 1946,
                            "province_id": 2,
                            "name": "桐柏县",
                            "whole_name": "桐柏县，南阳市，河南省",
                            "simple_py": "TBX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0377",
                            "area_code": "411330",
                            "longitude": "113.406059",
                            "latitude": "32.367153"
                        },
                        {
                            "area_id": 2665,
                            "city_id": 1946,
                            "province_id": 2,
                            "name": "卧龙区",
                            "whole_name": "卧龙区，南阳市，河南省",
                            "simple_py": "WLQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0377",
                            "area_code": "411303",
                            "longitude": "112.528789",
                            "latitude": "32.989877"
                        },
                        {
                            "area_id": 2674,
                            "city_id": 1946,
                            "province_id": 2,
                            "name": "宛城区",
                            "whole_name": "宛城区，南阳市，河南省",
                            "simple_py": "WCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0377",
                            "area_code": "411302",
                            "longitude": "112.544591",
                            "latitude": "32.994857"
                        },
                        {
                            "area_id": 2662,
                            "city_id": 1946,
                            "province_id": 2,
                            "name": "西峡县",
                            "whole_name": "西峡县，南阳市，河南省",
                            "simple_py": "XXX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0377",
                            "area_code": "411323",
                            "longitude": "111.485772",
                            "latitude": "33.302981"
                        },
                        {
                            "area_id": 2663,
                            "city_id": 1946,
                            "province_id": 2,
                            "name": "淅川县",
                            "whole_name": "淅川县，南阳市，河南省",
                            "simple_py": "XCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0377",
                            "area_code": "411326",
                            "longitude": "111.489026",
                            "latitude": "33.136106"
                        },
                        {
                            "area_id": 2672,
                            "city_id": 1946,
                            "province_id": 2,
                            "name": "新野县",
                            "whole_name": "新野县，南阳市，河南省",
                            "simple_py": "XYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0377",
                            "area_code": "411329",
                            "longitude": "112.365624",
                            "latitude": "32.524006"
                        },
                        {
                            "area_id": 2670,
                            "city_id": 1946,
                            "province_id": 2,
                            "name": "镇平县",
                            "whole_name": "镇平县，南阳市，河南省",
                            "simple_py": "ZPX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0377",
                            "area_code": "411324",
                            "longitude": "112.232722",
                            "latitude": "33.036651"
                        }
                    ]
                },
                {
                    "city_id": 1941,
                    "province_id": 2,
                    "name": "濮阳市",
                    "whole_name": "濮阳市，河南省",
                    "simple_py": "PYS",
                    "per_pin_yin": "P",
                    "per_pin_yin2": "P",
                    "city_code": "0393",
                    "area_code": "410900",
                    "longitude": "115.041299",
                    "latitude": "35.768234",
                    "children": [
                        {
                            "area_id": 1963,
                            "city_id": 1941,
                            "province_id": 2,
                            "name": "范县",
                            "whole_name": "范县，濮阳市，河南省",
                            "simple_py": "FX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0393",
                            "area_code": "410926",
                            "longitude": "115.504212",
                            "latitude": "35.851977"
                        },
                        {
                            "area_id": 1962,
                            "city_id": 1941,
                            "province_id": 2,
                            "name": "华龙区",
                            "whole_name": "华龙区，濮阳市，河南省",
                            "simple_py": "HLQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0393",
                            "area_code": "410902",
                            "longitude": "115.03184",
                            "latitude": "35.760473"
                        },
                        {
                            "area_id": 1960,
                            "city_id": 1941,
                            "province_id": 2,
                            "name": "南乐县",
                            "whole_name": "南乐县，濮阳市，河南省",
                            "simple_py": "NLX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0393",
                            "area_code": "410923",
                            "longitude": "115.204336",
                            "latitude": "36.075204"
                        },
                        {
                            "area_id": 1964,
                            "city_id": 1941,
                            "province_id": 2,
                            "name": "濮阳县",
                            "whole_name": "濮阳县，濮阳市，河南省",
                            "simple_py": "PYX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0393",
                            "area_code": "410928",
                            "longitude": "115.023844",
                            "latitude": "35.710349"
                        },
                        {
                            "area_id": 1959,
                            "city_id": 1941,
                            "province_id": 2,
                            "name": "清丰县",
                            "whole_name": "清丰县，濮阳市，河南省",
                            "simple_py": "QFX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0393",
                            "area_code": "410922",
                            "longitude": "115.107287",
                            "latitude": "35.902413"
                        },
                        {
                            "area_id": 1961,
                            "city_id": 1941,
                            "province_id": 2,
                            "name": "台前县",
                            "whole_name": "台前县，濮阳市，河南省",
                            "simple_py": "TQX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0393",
                            "area_code": "410927",
                            "longitude": "115.855681",
                            "latitude": "35.996474"
                        }
                    ]
                },
                {
                    "city_id": 1949,
                    "province_id": 2,
                    "name": "平顶山市",
                    "whole_name": "平顶山市，河南省",
                    "simple_py": "PDSS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "P",
                    "city_code": "0375",
                    "area_code": "410400",
                    "longitude": "113.307718",
                    "latitude": "33.735241",
                    "children": [
                        {
                            "area_id": 3003,
                            "city_id": 1949,
                            "province_id": 2,
                            "name": "宝丰县",
                            "whole_name": "宝丰县，平顶山市，河南省",
                            "simple_py": "BFX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0375",
                            "area_code": "410421",
                            "longitude": "113.066812",
                            "latitude": "33.866359"
                        },
                        {
                            "area_id": 3002,
                            "city_id": 1949,
                            "province_id": 2,
                            "name": "郏县",
                            "whole_name": "郏县，平顶山市，河南省",
                            "simple_py": "JX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0375",
                            "area_code": "410425",
                            "longitude": "113.220451",
                            "latitude": "33.971993"
                        },
                        {
                            "area_id": 3007,
                            "city_id": 1949,
                            "province_id": 2,
                            "name": "鲁山县",
                            "whole_name": "鲁山县，平顶山市，河南省",
                            "simple_py": "LSX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0375",
                            "area_code": "410423",
                            "longitude": "112.906703",
                            "latitude": "33.740325"
                        },
                        {
                            "area_id": 3011,
                            "city_id": 1949,
                            "province_id": 2,
                            "name": "汝州市",
                            "whole_name": "汝州市，平顶山市，河南省",
                            "simple_py": "RZS",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0375",
                            "area_code": "410482",
                            "longitude": "112.845336",
                            "latitude": "34.167408"
                        },
                        {
                            "area_id": 3004,
                            "city_id": 1949,
                            "province_id": 2,
                            "name": "石龙区",
                            "whole_name": "石龙区，平顶山市，河南省",
                            "simple_py": "SLQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0375",
                            "area_code": "410404",
                            "longitude": "112.889885",
                            "latitude": "33.901538"
                        },
                        {
                            "area_id": 3005,
                            "city_id": 1949,
                            "province_id": 2,
                            "name": "卫东区",
                            "whole_name": "卫东区，平顶山市，河南省",
                            "simple_py": "WDQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0375",
                            "area_code": "410403",
                            "longitude": "113.310327",
                            "latitude": "33.739285"
                        },
                        {
                            "area_id": 3008,
                            "city_id": 1949,
                            "province_id": 2,
                            "name": "舞钢市",
                            "whole_name": "舞钢市，平顶山市，河南省",
                            "simple_py": "WGS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0375",
                            "area_code": "410481",
                            "longitude": "113.52625",
                            "latitude": "33.302082"
                        },
                        {
                            "area_id": 3010,
                            "city_id": 1949,
                            "province_id": 2,
                            "name": "新华区",
                            "whole_name": "新华区，平顶山市，河南省",
                            "simple_py": "XHQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0375",
                            "area_code": "410402",
                            "longitude": "113.299061",
                            "latitude": "33.737579"
                        },
                        {
                            "area_id": 3009,
                            "city_id": 1949,
                            "province_id": 2,
                            "name": "叶县",
                            "whole_name": "叶县，平顶山市，河南省",
                            "simple_py": "YX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0375",
                            "area_code": "410422",
                            "longitude": "113.358298",
                            "latitude": "33.621252"
                        },
                        {
                            "area_id": 3006,
                            "city_id": 1949,
                            "province_id": 2,
                            "name": "湛河区",
                            "whole_name": "湛河区，平顶山市，河南省",
                            "simple_py": "ZHQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0375",
                            "area_code": "410411",
                            "longitude": "113.320873",
                            "latitude": "33.725681"
                        }
                    ]
                },
                {
                    "city_id": 1943,
                    "province_id": 2,
                    "name": "三门峡市",
                    "whole_name": "三门峡市，河南省",
                    "simple_py": "SMXS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0398",
                    "area_code": "411200",
                    "longitude": "111.194099",
                    "latitude": "34.777338",
                    "children": [
                        {
                            "area_id": 2260,
                            "city_id": 1943,
                            "province_id": 2,
                            "name": "湖滨区",
                            "whole_name": "湖滨区，三门峡市，河南省",
                            "simple_py": "HBQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0398",
                            "area_code": "411202",
                            "longitude": "111.19487",
                            "latitude": "34.77812"
                        },
                        {
                            "area_id": 2263,
                            "city_id": 1943,
                            "province_id": 2,
                            "name": "卢氏县",
                            "whole_name": "卢氏县，三门峡市，河南省",
                            "simple_py": "LSX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0398",
                            "area_code": "411224",
                            "longitude": "111.052649",
                            "latitude": "34.053995"
                        },
                        {
                            "area_id": 2265,
                            "city_id": 1943,
                            "province_id": 2,
                            "name": "灵宝市",
                            "whole_name": "灵宝市，三门峡市，河南省",
                            "simple_py": "LBS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0398",
                            "area_code": "411282",
                            "longitude": "110.88577",
                            "latitude": "34.521264"
                        },
                        {
                            "area_id": 2262,
                            "city_id": 1943,
                            "province_id": 2,
                            "name": "渑池县",
                            "whole_name": "渑池县，三门峡市，河南省",
                            "simple_py": "MCX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0398",
                            "area_code": "411221",
                            "longitude": "111.762992",
                            "latitude": "34.763487"
                        },
                        {
                            "area_id": 2264,
                            "city_id": 1943,
                            "province_id": 2,
                            "name": "陕州区",
                            "whole_name": "陕州区，三门峡市，河南省",
                            "simple_py": "SZQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0398",
                            "area_code": "411203",
                            "longitude": "111.103851",
                            "latitude": "34.720244"
                        },
                        {
                            "area_id": 2261,
                            "city_id": 1943,
                            "province_id": 2,
                            "name": "义马市",
                            "whole_name": "义马市，三门峡市，河南省",
                            "simple_py": "YMS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0398",
                            "area_code": "411281",
                            "longitude": "111.869417",
                            "latitude": "34.746868"
                        }
                    ]
                },
                {
                    "city_id": 1954,
                    "province_id": 2,
                    "name": "商丘市",
                    "whole_name": "商丘市，河南省",
                    "simple_py": "SQS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "S",
                    "city_code": "0370",
                    "area_code": "411400",
                    "longitude": "115.650497",
                    "latitude": "34.437054",
                    "children": [
                        {
                            "area_id": 3859,
                            "city_id": 1954,
                            "province_id": 2,
                            "name": "睢县",
                            "whole_name": "睢县，商丘市，河南省",
                            "simple_py": "HX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0370",
                            "area_code": "411422",
                            "longitude": "115.070109",
                            "latitude": "34.428433"
                        },
                        {
                            "area_id": 3860,
                            "city_id": 1954,
                            "province_id": 2,
                            "name": "睢阳区",
                            "whole_name": "睢阳区，商丘市，河南省",
                            "simple_py": "HYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0370",
                            "area_code": "411403",
                            "longitude": "115.653813",
                            "latitude": "34.390536"
                        },
                        {
                            "area_id": 3864,
                            "city_id": 1954,
                            "province_id": 2,
                            "name": "梁园区",
                            "whole_name": "梁园区，商丘市，河南省",
                            "simple_py": "LYQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0370",
                            "area_code": "411402",
                            "longitude": "115.65459",
                            "latitude": "34.436553"
                        },
                        {
                            "area_id": 3857,
                            "city_id": 1954,
                            "province_id": 2,
                            "name": "民权县",
                            "whole_name": "民权县，商丘市，河南省",
                            "simple_py": "MQX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0370",
                            "area_code": "411421",
                            "longitude": "115.148146",
                            "latitude": "34.648455"
                        },
                        {
                            "area_id": 3858,
                            "city_id": 1954,
                            "province_id": 2,
                            "name": "宁陵县",
                            "whole_name": "宁陵县，商丘市，河南省",
                            "simple_py": "NLX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0370",
                            "area_code": "411423",
                            "longitude": "115.320055",
                            "latitude": "34.449299"
                        },
                        {
                            "area_id": 3862,
                            "city_id": 1954,
                            "province_id": 2,
                            "name": "夏邑县",
                            "whole_name": "夏邑县，商丘市，河南省",
                            "simple_py": "XYX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0370",
                            "area_code": "411426",
                            "longitude": "116.13989",
                            "latitude": "34.240894"
                        },
                        {
                            "area_id": 3861,
                            "city_id": 1954,
                            "province_id": 2,
                            "name": "永城市",
                            "whole_name": "永城市，商丘市，河南省",
                            "simple_py": "YCS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0370",
                            "area_code": "411481",
                            "longitude": "116.449672",
                            "latitude": "33.931318"
                        },
                        {
                            "area_id": 3865,
                            "city_id": 1954,
                            "province_id": 2,
                            "name": "虞城县",
                            "whole_name": "虞城县，商丘市，河南省",
                            "simple_py": "YCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0370",
                            "area_code": "411425",
                            "longitude": "115.863811",
                            "latitude": "34.399634"
                        },
                        {
                            "area_id": 3863,
                            "city_id": 1954,
                            "province_id": 2,
                            "name": "柘城县",
                            "whole_name": "柘城县，商丘市，河南省",
                            "simple_py": "ZCX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0370",
                            "area_code": "411424",
                            "longitude": "115.307433",
                            "latitude": "34.075277"
                        }
                    ]
                },
                {
                    "city_id": 1945,
                    "province_id": 2,
                    "name": "许昌市",
                    "whole_name": "许昌市，河南省",
                    "simple_py": "XCS",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "0374",
                    "area_code": "411000",
                    "longitude": "113.826063",
                    "latitude": "34.022956",
                    "children": [
                        {
                            "area_id": 2560,
                            "city_id": 1945,
                            "province_id": 2,
                            "name": "长葛市",
                            "whole_name": "长葛市，许昌市，河南省",
                            "simple_py": "CGS",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0374",
                            "area_code": "411082",
                            "longitude": "113.768912",
                            "latitude": "34.219257"
                        },
                        {
                            "area_id": 2557,
                            "city_id": 1945,
                            "province_id": 2,
                            "name": "建安区",
                            "whole_name": "建安区，许昌市，河南省",
                            "simple_py": "JAQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0374",
                            "area_code": "411003",
                            "longitude": "113.842898",
                            "latitude": "34.005018"
                        },
                        {
                            "area_id": 2559,
                            "city_id": 1945,
                            "province_id": 2,
                            "name": "魏都区",
                            "whole_name": "魏都区，许昌市，河南省",
                            "simple_py": "WDQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0374",
                            "area_code": "411002",
                            "longitude": "113.828307",
                            "latitude": "34.02711"
                        },
                        {
                            "area_id": 2558,
                            "city_id": 1945,
                            "province_id": 2,
                            "name": "襄城县",
                            "whole_name": "襄城县，许昌市，河南省",
                            "simple_py": "XCX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0374",
                            "area_code": "411025",
                            "longitude": "113.493166",
                            "latitude": "33.855943"
                        },
                        {
                            "area_id": 2561,
                            "city_id": 1945,
                            "province_id": 2,
                            "name": "禹州市",
                            "whole_name": "禹州市，许昌市，河南省",
                            "simple_py": "YZS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0374",
                            "area_code": "411081",
                            "longitude": "113.471316",
                            "latitude": "34.154403"
                        },
                        {
                            "area_id": 2562,
                            "city_id": 1945,
                            "province_id": 2,
                            "name": "鄢陵县",
                            "whole_name": "鄢陵县，许昌市，河南省",
                            "simple_py": "YLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0374",
                            "area_code": "411024",
                            "longitude": "114.188507",
                            "latitude": "34.100502"
                        }
                    ]
                },
                {
                    "city_id": 1950,
                    "province_id": 2,
                    "name": "信阳市",
                    "whole_name": "信阳市，河南省",
                    "simple_py": "XYS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "X",
                    "city_code": "0376",
                    "area_code": "411500",
                    "longitude": "114.075031",
                    "latitude": "32.123274",
                    "children": [
                        {
                            "area_id": 3156,
                            "city_id": 1950,
                            "province_id": 2,
                            "name": "光山县",
                            "whole_name": "光山县，信阳市，河南省",
                            "simple_py": "GSX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0376",
                            "area_code": "411522",
                            "longitude": "114.903577",
                            "latitude": "32.010398"
                        },
                        {
                            "area_id": 3160,
                            "city_id": 1950,
                            "province_id": 2,
                            "name": "固始县",
                            "whole_name": "固始县，信阳市，河南省",
                            "simple_py": "GSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0376",
                            "area_code": "411525",
                            "longitude": "115.667328",
                            "latitude": "32.183074"
                        },
                        {
                            "area_id": 3154,
                            "city_id": 1950,
                            "province_id": 2,
                            "name": "潢川县",
                            "whole_name": "潢川县，信阳市，河南省",
                            "simple_py": "HCX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0376",
                            "area_code": "411526",
                            "longitude": "115.050123",
                            "latitude": "32.134024"
                        },
                        {
                            "area_id": 3155,
                            "city_id": 1950,
                            "province_id": 2,
                            "name": "淮滨县",
                            "whole_name": "淮滨县，信阳市，河南省",
                            "simple_py": "HBX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0376",
                            "area_code": "411527",
                            "longitude": "115.415451",
                            "latitude": "32.452639"
                        },
                        {
                            "area_id": 3157,
                            "city_id": 1950,
                            "province_id": 2,
                            "name": "罗山县",
                            "whole_name": "罗山县，信阳市，河南省",
                            "simple_py": "LSX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0376",
                            "area_code": "411521",
                            "longitude": "114.533414",
                            "latitude": "32.203206"
                        },
                        {
                            "area_id": 3163,
                            "city_id": 1950,
                            "province_id": 2,
                            "name": "平桥区",
                            "whole_name": "平桥区，信阳市，河南省",
                            "simple_py": "PQQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0376",
                            "area_code": "411503",
                            "longitude": "114.126027",
                            "latitude": "32.098395"
                        },
                        {
                            "area_id": 3158,
                            "city_id": 1950,
                            "province_id": 2,
                            "name": "商城县",
                            "whole_name": "商城县，信阳市，河南省",
                            "simple_py": "SCX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0376",
                            "area_code": "411524",
                            "longitude": "115.406297",
                            "latitude": "31.799982"
                        },
                        {
                            "area_id": 3159,
                            "city_id": 1950,
                            "province_id": 2,
                            "name": "浉河区",
                            "whole_name": "浉河区，信阳市，河南省",
                            "simple_py": "SHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0376",
                            "area_code": "411502",
                            "longitude": "114.075031",
                            "latitude": "32.123274"
                        },
                        {
                            "area_id": 3161,
                            "city_id": 1950,
                            "province_id": 2,
                            "name": "新县",
                            "whole_name": "新县，信阳市，河南省",
                            "simple_py": "XX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0376",
                            "area_code": "411523",
                            "longitude": "114.87705",
                            "latitude": "31.63515"
                        },
                        {
                            "area_id": 3162,
                            "city_id": 1950,
                            "province_id": 2,
                            "name": "息县",
                            "whole_name": "息县，信阳市，河南省",
                            "simple_py": "XX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0376",
                            "area_code": "411528",
                            "longitude": "114.740713",
                            "latitude": "32.344744"
                        }
                    ]
                },
                {
                    "city_id": 1955,
                    "province_id": 2,
                    "name": "新乡市",
                    "whole_name": "新乡市，河南省",
                    "simple_py": "XXS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "X",
                    "city_code": "0373",
                    "area_code": "410700",
                    "longitude": "113.883991",
                    "latitude": "35.302616",
                    "children": [
                        {
                            "area_id": 4069,
                            "city_id": 1955,
                            "province_id": 2,
                            "name": "长垣县",
                            "whole_name": "长垣县，新乡市，河南省",
                            "simple_py": "CYX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0373",
                            "area_code": "410728",
                            "longitude": "114.673807",
                            "latitude": "35.19615"
                        },
                        {
                            "area_id": 4062,
                            "city_id": 1955,
                            "province_id": 2,
                            "name": "凤泉区",
                            "whole_name": "凤泉区，新乡市，河南省",
                            "simple_py": "FQQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0373",
                            "area_code": "410704",
                            "longitude": "113.906712",
                            "latitude": "35.379855"
                        },
                        {
                            "area_id": 4067,
                            "city_id": 1955,
                            "province_id": 2,
                            "name": "封丘县",
                            "whole_name": "封丘县，新乡市，河南省",
                            "simple_py": "FQX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0373",
                            "area_code": "410727",
                            "longitude": "114.423405",
                            "latitude": "35.04057"
                        },
                        {
                            "area_id": 4061,
                            "city_id": 1955,
                            "province_id": 2,
                            "name": "红旗区",
                            "whole_name": "红旗区，新乡市，河南省",
                            "simple_py": "HQQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0373",
                            "area_code": "410702",
                            "longitude": "113.878158",
                            "latitude": "35.302684"
                        },
                        {
                            "area_id": 4063,
                            "city_id": 1955,
                            "province_id": 2,
                            "name": "辉县市",
                            "whole_name": "辉县市，新乡市，河南省",
                            "simple_py": "HXS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0373",
                            "area_code": "410782",
                            "longitude": "113.802518",
                            "latitude": "35.461318"
                        },
                        {
                            "area_id": 4064,
                            "city_id": 1955,
                            "province_id": 2,
                            "name": "获嘉县",
                            "whole_name": "获嘉县，新乡市，河南省",
                            "simple_py": "HJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0373",
                            "area_code": "410724",
                            "longitude": "113.657249",
                            "latitude": "35.261685"
                        },
                        {
                            "area_id": 4072,
                            "city_id": 1955,
                            "province_id": 2,
                            "name": "牧野区",
                            "whole_name": "牧野区，新乡市，河南省",
                            "simple_py": "MYQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0373",
                            "area_code": "410711",
                            "longitude": "113.89716",
                            "latitude": "35.312974"
                        },
                        {
                            "area_id": 4065,
                            "city_id": 1955,
                            "province_id": 2,
                            "name": "卫辉市",
                            "whole_name": "卫辉市，新乡市，河南省",
                            "simple_py": "WHS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0373",
                            "area_code": "410781",
                            "longitude": "114.065855",
                            "latitude": "35.404295"
                        },
                        {
                            "area_id": 4071,
                            "city_id": 1955,
                            "province_id": 2,
                            "name": "卫滨区",
                            "whole_name": "卫滨区，新乡市，河南省",
                            "simple_py": "WBQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0373",
                            "area_code": "410703",
                            "longitude": "113.866065",
                            "latitude": "35.304905"
                        },
                        {
                            "area_id": 4070,
                            "city_id": 1955,
                            "province_id": 2,
                            "name": "新乡县",
                            "whole_name": "新乡县，新乡市，河南省",
                            "simple_py": "XXX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0373",
                            "area_code": "410721",
                            "longitude": "113.806186",
                            "latitude": "35.190021"
                        },
                        {
                            "area_id": 4066,
                            "city_id": 1955,
                            "province_id": 2,
                            "name": "延津县",
                            "whole_name": "延津县，新乡市，河南省",
                            "simple_py": "YJX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0373",
                            "area_code": "410726",
                            "longitude": "114.200982",
                            "latitude": "35.149515"
                        },
                        {
                            "area_id": 4068,
                            "city_id": 1955,
                            "province_id": 2,
                            "name": "原阳县",
                            "whole_name": "原阳县，新乡市，河南省",
                            "simple_py": "YYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0373",
                            "area_code": "410725",
                            "longitude": "113.965966",
                            "latitude": "35.054001"
                        }
                    ]
                },
                {
                    "city_id": 1944,
                    "province_id": 2,
                    "name": "郑州市",
                    "whole_name": "郑州市，河南省",
                    "simple_py": "ZZS",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "0371",
                    "area_code": "410100",
                    "longitude": "113.665412",
                    "latitude": "34.757975",
                    "children": [
                        {
                            "area_id": 2346,
                            "city_id": 1944,
                            "province_id": 2,
                            "name": "登封市",
                            "whole_name": "登封市，郑州市，河南省",
                            "simple_py": "DFS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0371",
                            "area_code": "410185",
                            "longitude": "113.037768",
                            "latitude": "34.459939"
                        },
                        {
                            "area_id": 2354,
                            "city_id": 1944,
                            "province_id": 2,
                            "name": "二七区",
                            "whole_name": "二七区，郑州市，河南省",
                            "simple_py": "EQQ",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0371",
                            "area_code": "410103",
                            "longitude": "113.645422",
                            "latitude": "34.730936"
                        },
                        {
                            "area_id": 2347,
                            "city_id": 1944,
                            "province_id": 2,
                            "name": "巩义市",
                            "whole_name": "巩义市，郑州市，河南省",
                            "simple_py": "GYS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0371",
                            "area_code": "410181",
                            "longitude": "112.98283",
                            "latitude": "34.75218"
                        },
                        {
                            "area_id": 2356,
                            "city_id": 1944,
                            "province_id": 2,
                            "name": "管城回族区",
                            "whole_name": "管城回族区，郑州市，河南省",
                            "simple_py": "GCHZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0371",
                            "area_code": "410104",
                            "longitude": "113.685313",
                            "latitude": "34.746453"
                        },
                        {
                            "area_id": 2351,
                            "city_id": 1944,
                            "province_id": 2,
                            "name": "惠济区",
                            "whole_name": "惠济区，郑州市，河南省",
                            "simple_py": "HJQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0371",
                            "area_code": "410108",
                            "longitude": "113.61836",
                            "latitude": "34.828591"
                        },
                        {
                            "area_id": 2352,
                            "city_id": 1944,
                            "province_id": 2,
                            "name": "金水区",
                            "whole_name": "金水区，郑州市，河南省",
                            "simple_py": "JSQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0371",
                            "area_code": "410105",
                            "longitude": "113.686037",
                            "latitude": "34.775838"
                        },
                        {
                            "area_id": 2349,
                            "city_id": 1944,
                            "province_id": 2,
                            "name": "上街区",
                            "whole_name": "上街区，郑州市，河南省",
                            "simple_py": "SJQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0371",
                            "area_code": "410106",
                            "longitude": "113.298282",
                            "latitude": "34.808689"
                        },
                        {
                            "area_id": 2348,
                            "city_id": 1944,
                            "province_id": 2,
                            "name": "荥阳市",
                            "whole_name": "荥阳市，郑州市，河南省",
                            "simple_py": "XYS",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0371",
                            "area_code": "410182",
                            "longitude": "113.391523",
                            "latitude": "34.789077"
                        },
                        {
                            "area_id": 2350,
                            "city_id": 1944,
                            "province_id": 2,
                            "name": "新郑市",
                            "whole_name": "新郑市，郑州市，河南省",
                            "simple_py": "XZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0371",
                            "area_code": "410184",
                            "longitude": "113.73967",
                            "latitude": "34.394219"
                        },
                        {
                            "area_id": 2355,
                            "city_id": 1944,
                            "province_id": 2,
                            "name": "新密市",
                            "whole_name": "新密市，郑州市，河南省",
                            "simple_py": "XMS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0371",
                            "area_code": "410183",
                            "longitude": "113.380616",
                            "latitude": "34.537846"
                        },
                        {
                            "area_id": 2353,
                            "city_id": 1944,
                            "province_id": 2,
                            "name": "中原区",
                            "whole_name": "中原区，郑州市，河南省",
                            "simple_py": "ZYQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0371",
                            "area_code": "410102",
                            "longitude": "113.611576",
                            "latitude": "34.748286"
                        },
                        {
                            "area_id": 2357,
                            "city_id": 1944,
                            "province_id": 2,
                            "name": "中牟县",
                            "whole_name": "中牟县，郑州市，河南省",
                            "simple_py": "ZMX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0371",
                            "area_code": "410122",
                            "longitude": "114.022521",
                            "latitude": "34.721976"
                        }
                    ]
                },
                {
                    "city_id": 1953,
                    "province_id": 2,
                    "name": "驻马店市",
                    "whole_name": "驻马店市，河南省",
                    "simple_py": "ZMDS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Z",
                    "city_code": "0396",
                    "area_code": "411700",
                    "longitude": "114.024736",
                    "latitude": "32.980169",
                    "children": [
                        {
                            "area_id": 3652,
                            "city_id": 1953,
                            "province_id": 2,
                            "name": "泌阳县",
                            "whole_name": "泌阳县，驻马店市，河南省",
                            "simple_py": "BYX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0396",
                            "area_code": "411726",
                            "longitude": "113.32605",
                            "latitude": "32.725129"
                        },
                        {
                            "area_id": 3650,
                            "city_id": 1953,
                            "province_id": 2,
                            "name": "平舆县",
                            "whole_name": "平舆县，驻马店市，河南省",
                            "simple_py": "PYX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0396",
                            "area_code": "411723",
                            "longitude": "114.637105",
                            "latitude": "32.955626"
                        },
                        {
                            "area_id": 3655,
                            "city_id": 1953,
                            "province_id": 2,
                            "name": "确山县",
                            "whole_name": "确山县，驻马店市，河南省",
                            "simple_py": "QSX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0396",
                            "area_code": "411725",
                            "longitude": "114.026679",
                            "latitude": "32.801538"
                        },
                        {
                            "area_id": 3649,
                            "city_id": 1953,
                            "province_id": 2,
                            "name": "汝南县",
                            "whole_name": "汝南县，驻马店市，河南省",
                            "simple_py": "RNX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0396",
                            "area_code": "411727",
                            "longitude": "114.359495",
                            "latitude": "33.004535"
                        },
                        {
                            "area_id": 3647,
                            "city_id": 1953,
                            "province_id": 2,
                            "name": "上蔡县",
                            "whole_name": "上蔡县，驻马店市，河南省",
                            "simple_py": "SCX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0396",
                            "area_code": "411722",
                            "longitude": "114.266892",
                            "latitude": "33.264719"
                        },
                        {
                            "area_id": 3653,
                            "city_id": 1953,
                            "province_id": 2,
                            "name": "遂平县",
                            "whole_name": "遂平县，驻马店市，河南省",
                            "simple_py": "SPX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0396",
                            "area_code": "411728",
                            "longitude": "114.00371",
                            "latitude": "33.14698"
                        },
                        {
                            "area_id": 3648,
                            "city_id": 1953,
                            "province_id": 2,
                            "name": "西平县",
                            "whole_name": "西平县，驻马店市，河南省",
                            "simple_py": "XPX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0396",
                            "area_code": "411721",
                            "longitude": "114.026864",
                            "latitude": "33.382315"
                        },
                        {
                            "area_id": 3651,
                            "city_id": 1953,
                            "province_id": 2,
                            "name": "新蔡县",
                            "whole_name": "新蔡县，驻马店市，河南省",
                            "simple_py": "XCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0396",
                            "area_code": "411729",
                            "longitude": "114.975246",
                            "latitude": "32.749948"
                        },
                        {
                            "area_id": 3654,
                            "city_id": 1953,
                            "province_id": 2,
                            "name": "驿城区",
                            "whole_name": "驿城区，驻马店市，河南省",
                            "simple_py": "YCQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0396",
                            "area_code": "411702",
                            "longitude": "114.029149",
                            "latitude": "32.977559"
                        },
                        {
                            "area_id": 3656,
                            "city_id": 1953,
                            "province_id": 2,
                            "name": "正阳县",
                            "whole_name": "正阳县，驻马店市，河南省",
                            "simple_py": "ZYX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0396",
                            "area_code": "411724",
                            "longitude": "114.38948",
                            "latitude": "32.601826"
                        }
                    ]
                },
                {
                    "city_id": 1957,
                    "province_id": 2,
                    "name": "周口市",
                    "whole_name": "周口市，河南省",
                    "simple_py": "ZKS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Z",
                    "city_code": "0394",
                    "area_code": "411600",
                    "longitude": "114.649653",
                    "latitude": "33.620357",
                    "children": [
                        {
                            "area_id": 4292,
                            "city_id": 1957,
                            "province_id": 2,
                            "name": "川汇区",
                            "whole_name": "川汇区，周口市，河南省",
                            "simple_py": "CHQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0394",
                            "area_code": "411602",
                            "longitude": "114.652136",
                            "latitude": "33.614836"
                        },
                        {
                            "area_id": 4287,
                            "city_id": 1957,
                            "province_id": 2,
                            "name": "郸城县",
                            "whole_name": "郸城县，周口市，河南省",
                            "simple_py": "DCX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0394",
                            "area_code": "411625",
                            "longitude": "115.189",
                            "latitude": "33.643852"
                        },
                        {
                            "area_id": 4290,
                            "city_id": 1957,
                            "province_id": 2,
                            "name": "扶沟县",
                            "whole_name": "扶沟县，周口市，河南省",
                            "simple_py": "FGX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0394",
                            "area_code": "411621",
                            "longitude": "114.392008",
                            "latitude": "34.054061"
                        },
                        {
                            "area_id": 4291,
                            "city_id": 1957,
                            "province_id": 2,
                            "name": "淮阳县",
                            "whole_name": "淮阳县，周口市，河南省",
                            "simple_py": "HYX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0394",
                            "area_code": "411626",
                            "longitude": "114.870166",
                            "latitude": "33.732547"
                        },
                        {
                            "area_id": 4285,
                            "city_id": 1957,
                            "province_id": 2,
                            "name": "鹿邑县",
                            "whole_name": "鹿邑县，周口市，河南省",
                            "simple_py": "LYX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0394",
                            "area_code": "411628",
                            "longitude": "115.486386",
                            "latitude": "33.861067"
                        },
                        {
                            "area_id": 4288,
                            "city_id": 1957,
                            "province_id": 2,
                            "name": "沈丘县",
                            "whole_name": "沈丘县，周口市，河南省",
                            "simple_py": "SQX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0394",
                            "area_code": "411624",
                            "longitude": "115.078375",
                            "latitude": "33.395514"
                        },
                        {
                            "area_id": 4293,
                            "city_id": 1957,
                            "province_id": 2,
                            "name": "商水县",
                            "whole_name": "商水县，周口市，河南省",
                            "simple_py": "SSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0394",
                            "area_code": "411623",
                            "longitude": "114.60927",
                            "latitude": "33.543845"
                        },
                        {
                            "area_id": 4284,
                            "city_id": 1957,
                            "province_id": 2,
                            "name": "太康县",
                            "whole_name": "太康县，周口市，河南省",
                            "simple_py": "TKX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0394",
                            "area_code": "411627",
                            "longitude": "114.853834",
                            "latitude": "34.065312"
                        },
                        {
                            "area_id": 4286,
                            "city_id": 1957,
                            "province_id": 2,
                            "name": "西华县",
                            "whole_name": "西华县，周口市，河南省",
                            "simple_py": "XHX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0394",
                            "area_code": "411622",
                            "longitude": "114.530067",
                            "latitude": "33.784378"
                        },
                        {
                            "area_id": 4289,
                            "city_id": 1957,
                            "province_id": 2,
                            "name": "项城市",
                            "whole_name": "项城市，周口市，河南省",
                            "simple_py": "XCS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0394",
                            "area_code": "411681",
                            "longitude": "114.899521",
                            "latitude": "33.443085"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 4,
            "name": "黑龙江省",
            "whole_name": "黑龙江省",
            "simple_py": "HLJS",
            "per_pin_yin": " ",
            "per_pin_yin2": "H",
            "city_code": "",
            "area_code": "230000",
            "longitude": "126.642464",
            "latitude": "45.756967",
            "children": [
                {
                    "city_id": 5971,
                    "province_id": 4,
                    "name": "大兴安岭地区",
                    "whole_name": "大兴安岭地区，黑龙江省",
                    "simple_py": "DXALDQ",
                    "per_pin_yin": "D",
                    "per_pin_yin2": "D",
                    "city_code": "0457",
                    "area_code": "232700",
                    "longitude": "124.711526",
                    "latitude": "52.335262",
                    "children": [
                        {
                            "area_id": 5985,
                            "city_id": 5971,
                            "province_id": 4,
                            "name": "呼玛县",
                            "whole_name": "呼玛县，大兴安岭地区，黑龙江省",
                            "simple_py": "HMX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0457",
                            "area_code": "232721",
                            "longitude": "126.662105",
                            "latitude": "51.726998"
                        },
                        {
                            "area_id": 5987,
                            "city_id": 5971,
                            "province_id": 4,
                            "name": "加格达奇区",
                            "whole_name": "加格达奇区，大兴安岭地区，黑龙江省",
                            "simple_py": "JGDQQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0457",
                            "area_code": "232701",
                            "longitude": "124.126716",
                            "latitude": "50.424654"
                        },
                        {
                            "area_id": 5984,
                            "city_id": 5971,
                            "province_id": 4,
                            "name": "漠河县",
                            "whole_name": "漠河县，大兴安岭地区，黑龙江省",
                            "simple_py": "MHX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0457",
                            "area_code": "232723",
                            "longitude": "122.536256",
                            "latitude": "52.972074"
                        },
                        {
                            "area_id": 5986,
                            "city_id": 5971,
                            "province_id": 4,
                            "name": "塔河县",
                            "whole_name": "塔河县，大兴安岭地区，黑龙江省",
                            "simple_py": "THX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0457",
                            "area_code": "232722",
                            "longitude": "124.710516",
                            "latitude": "52.335229"
                        }
                    ]
                },
                {
                    "city_id": 5973,
                    "province_id": 4,
                    "name": "大庆市",
                    "whole_name": "大庆市，黑龙江省",
                    "simple_py": "DQS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "D",
                    "city_code": "0459",
                    "area_code": "230600",
                    "longitude": "125.11272",
                    "latitude": "46.590734",
                    "children": [
                        {
                            "area_id": 6096,
                            "city_id": 5973,
                            "province_id": 4,
                            "name": "大同区",
                            "whole_name": "大同区，大庆市，黑龙江省",
                            "simple_py": "DTQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0459",
                            "area_code": "230606",
                            "longitude": "124.818509",
                            "latitude": "46.034304"
                        },
                        {
                            "area_id": 6098,
                            "city_id": 5973,
                            "province_id": 4,
                            "name": "杜尔伯特蒙古族自治县",
                            "whole_name": "杜尔伯特蒙古族自治县，大庆市，黑龙江省",
                            "simple_py": "DEBTMGZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0459",
                            "area_code": "230624",
                            "longitude": "124.446259",
                            "latitude": "46.865973"
                        },
                        {
                            "area_id": 6094,
                            "city_id": 5973,
                            "province_id": 4,
                            "name": "红岗区",
                            "whole_name": "红岗区，大庆市，黑龙江省",
                            "simple_py": "HGQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0459",
                            "area_code": "230605",
                            "longitude": "124.889528",
                            "latitude": "46.403049"
                        },
                        {
                            "area_id": 6097,
                            "city_id": 5973,
                            "province_id": 4,
                            "name": "林甸县",
                            "whole_name": "林甸县，大庆市，黑龙江省",
                            "simple_py": "LDX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0459",
                            "area_code": "230623",
                            "longitude": "124.877742",
                            "latitude": "47.186411"
                        },
                        {
                            "area_id": 6100,
                            "city_id": 5973,
                            "province_id": 4,
                            "name": "龙凤区",
                            "whole_name": "龙凤区，大庆市，黑龙江省",
                            "simple_py": "LFQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0459",
                            "area_code": "230603",
                            "longitude": "125.145794",
                            "latitude": "46.573948"
                        },
                        {
                            "area_id": 6093,
                            "city_id": 5973,
                            "province_id": 4,
                            "name": "让胡路区",
                            "whole_name": "让胡路区，大庆市，黑龙江省",
                            "simple_py": "RHLQ",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0459",
                            "area_code": "230604",
                            "longitude": "124.868341",
                            "latitude": "46.653254"
                        },
                        {
                            "area_id": 6101,
                            "city_id": 5973,
                            "province_id": 4,
                            "name": "萨尔图区",
                            "whole_name": "萨尔图区，大庆市，黑龙江省",
                            "simple_py": "SETQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0459",
                            "area_code": "230602",
                            "longitude": "125.114643",
                            "latitude": "46.596356"
                        },
                        {
                            "area_id": 6095,
                            "city_id": 5973,
                            "province_id": 4,
                            "name": "肇源县",
                            "whole_name": "肇源县，大庆市，黑龙江省",
                            "simple_py": "ZYX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0459",
                            "area_code": "230622",
                            "longitude": "125.081974",
                            "latitude": "45.518832"
                        },
                        {
                            "area_id": 6099,
                            "city_id": 5973,
                            "province_id": 4,
                            "name": "肇州县",
                            "whole_name": "肇州县，大庆市，黑龙江省",
                            "simple_py": "ZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0459",
                            "area_code": "230621",
                            "longitude": "125.273254",
                            "latitude": "45.708685"
                        }
                    ]
                },
                {
                    "city_id": 5974,
                    "province_id": 4,
                    "name": "鹤岗市",
                    "whole_name": "鹤岗市，黑龙江省",
                    "simple_py": "HGS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0468",
                    "area_code": "230400",
                    "longitude": "130.277487",
                    "latitude": "47.332085",
                    "children": [
                        {
                            "area_id": 6217,
                            "city_id": 5974,
                            "province_id": 4,
                            "name": "东山区",
                            "whole_name": "东山区，鹤岗市，黑龙江省",
                            "simple_py": "DSQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0468",
                            "area_code": "230406",
                            "longitude": "130.31714",
                            "latitude": "47.337385"
                        },
                        {
                            "area_id": 6215,
                            "city_id": 5974,
                            "province_id": 4,
                            "name": "工农区",
                            "whole_name": "工农区，鹤岗市，黑龙江省",
                            "simple_py": "GNQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0468",
                            "area_code": "230403",
                            "longitude": "130.276652",
                            "latitude": "47.331678"
                        },
                        {
                            "area_id": 6213,
                            "city_id": 5974,
                            "province_id": 4,
                            "name": "萝北县",
                            "whole_name": "萝北县，鹤岗市，黑龙江省",
                            "simple_py": "LBX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0468",
                            "area_code": "230421",
                            "longitude": "130.829087",
                            "latitude": "47.577577"
                        },
                        {
                            "area_id": 6219,
                            "city_id": 5974,
                            "province_id": 4,
                            "name": "南山区",
                            "whole_name": "南山区，鹤岗市，黑龙江省",
                            "simple_py": "NSQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0468",
                            "area_code": "230404",
                            "longitude": "130.275533",
                            "latitude": "47.31324"
                        },
                        {
                            "area_id": 6214,
                            "city_id": 5974,
                            "province_id": 4,
                            "name": "绥滨县",
                            "whole_name": "绥滨县，鹤岗市，黑龙江省",
                            "simple_py": "SBX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0468",
                            "area_code": "230422",
                            "longitude": "131.860526",
                            "latitude": "47.289892"
                        },
                        {
                            "area_id": 6216,
                            "city_id": 5974,
                            "province_id": 4,
                            "name": "向阳区",
                            "whole_name": "向阳区，鹤岗市，黑龙江省",
                            "simple_py": "XYQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0468",
                            "area_code": "230402",
                            "longitude": "130.292478",
                            "latitude": "47.345372"
                        },
                        {
                            "area_id": 6218,
                            "city_id": 5974,
                            "province_id": 4,
                            "name": "兴山区",
                            "whole_name": "兴山区，鹤岗市，黑龙江省",
                            "simple_py": "XSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0468",
                            "area_code": "230407",
                            "longitude": "130.30534",
                            "latitude": "47.35997"
                        },
                        {
                            "area_id": 6220,
                            "city_id": 5974,
                            "province_id": 4,
                            "name": "兴安区",
                            "whole_name": "兴安区，鹤岗市，黑龙江省",
                            "simple_py": "XAQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0468",
                            "area_code": "230405",
                            "longitude": "130.236169",
                            "latitude": "47.252911"
                        }
                    ]
                },
                {
                    "city_id": 5981,
                    "province_id": 4,
                    "name": "哈尔滨市",
                    "whole_name": "哈尔滨市，黑龙江省",
                    "simple_py": "HEBS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0451",
                    "area_code": "230100",
                    "longitude": "126.642464",
                    "latitude": "45.756967",
                    "children": [
                        {
                            "area_id": 7349,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "阿城区",
                            "whole_name": "阿城区，哈尔滨市，黑龙江省",
                            "simple_py": "ACQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0451",
                            "area_code": "230112",
                            "longitude": "126.972726",
                            "latitude": "45.538372"
                        },
                        {
                            "area_id": 7332,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "巴彦县",
                            "whole_name": "巴彦县，哈尔滨市，黑龙江省",
                            "simple_py": "BYX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0451",
                            "area_code": "230126",
                            "longitude": "127.403602",
                            "latitude": "46.081889"
                        },
                        {
                            "area_id": 7339,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "宾县",
                            "whole_name": "宾县，哈尔滨市，黑龙江省",
                            "simple_py": "BX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0451",
                            "area_code": "230125",
                            "longitude": "127.48594",
                            "latitude": "45.759369"
                        },
                        {
                            "area_id": 7344,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "道里区",
                            "whole_name": "道里区，哈尔滨市，黑龙江省",
                            "simple_py": "DLQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0451",
                            "area_code": "230102",
                            "longitude": "126.612532",
                            "latitude": "45.762035"
                        },
                        {
                            "area_id": 7348,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "道外区",
                            "whole_name": "道外区，哈尔滨市，黑龙江省",
                            "simple_py": "DWQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0451",
                            "area_code": "230104",
                            "longitude": "126.648838",
                            "latitude": "45.78454"
                        },
                        {
                            "area_id": 7337,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "方正县",
                            "whole_name": "方正县，哈尔滨市，黑龙江省",
                            "simple_py": "FZX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0451",
                            "area_code": "230124",
                            "longitude": "128.836131",
                            "latitude": "45.839536"
                        },
                        {
                            "area_id": 7335,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "呼兰区",
                            "whole_name": "呼兰区，哈尔滨市，黑龙江省",
                            "simple_py": "HLQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0451",
                            "area_code": "230111",
                            "longitude": "126.603302",
                            "latitude": "45.98423"
                        },
                        {
                            "area_id": 7336,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "木兰县",
                            "whole_name": "木兰县，哈尔滨市，黑龙江省",
                            "simple_py": "MLX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0451",
                            "area_code": "230127",
                            "longitude": "128.042675",
                            "latitude": "45.949826"
                        },
                        {
                            "area_id": 7347,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "南岗区",
                            "whole_name": "南岗区，哈尔滨市，黑龙江省",
                            "simple_py": "NGQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0451",
                            "area_code": "230103",
                            "longitude": "126.652098",
                            "latitude": "45.755971"
                        },
                        {
                            "area_id": 7341,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "平房区",
                            "whole_name": "平房区，哈尔滨市，黑龙江省",
                            "simple_py": "PFQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0451",
                            "area_code": "230108",
                            "longitude": "126.629257",
                            "latitude": "45.605567"
                        },
                        {
                            "area_id": 7340,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "双城区",
                            "whole_name": "双城区，哈尔滨市，黑龙江省",
                            "simple_py": "SCQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0451",
                            "area_code": "230113",
                            "longitude": "126.308784",
                            "latitude": "45.377942"
                        },
                        {
                            "area_id": 7342,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "尚志市",
                            "whole_name": "尚志市，哈尔滨市，黑龙江省",
                            "simple_py": "SZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0451",
                            "area_code": "230183",
                            "longitude": "127.968539",
                            "latitude": "45.214953"
                        },
                        {
                            "area_id": 7345,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "松北区",
                            "whole_name": "松北区，哈尔滨市，黑龙江省",
                            "simple_py": "SBQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0451",
                            "area_code": "230109",
                            "longitude": "126.563066",
                            "latitude": "45.814656"
                        },
                        {
                            "area_id": 7334,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "通河县",
                            "whole_name": "通河县，哈尔滨市，黑龙江省",
                            "simple_py": "THX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0451",
                            "area_code": "230128",
                            "longitude": "128.747786",
                            "latitude": "45.977618"
                        },
                        {
                            "area_id": 7346,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "五常市",
                            "whole_name": "五常市，哈尔滨市，黑龙江省",
                            "simple_py": "WCS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0451",
                            "area_code": "230184",
                            "longitude": "127.15759",
                            "latitude": "44.919418"
                        },
                        {
                            "area_id": 7343,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "香坊区",
                            "whole_name": "香坊区，哈尔滨市，黑龙江省",
                            "simple_py": "XFQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0451",
                            "area_code": "230110",
                            "longitude": "126.667049",
                            "latitude": "45.713067"
                        },
                        {
                            "area_id": 7333,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "依兰县",
                            "whole_name": "依兰县，哈尔滨市，黑龙江省",
                            "simple_py": "YLX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0451",
                            "area_code": "230123",
                            "longitude": "129.565594",
                            "latitude": "46.315105"
                        },
                        {
                            "area_id": 7338,
                            "city_id": 5981,
                            "province_id": 4,
                            "name": "延寿县",
                            "whole_name": "延寿县，哈尔滨市，黑龙江省",
                            "simple_py": "YSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0451",
                            "area_code": "230129",
                            "longitude": "128.331886",
                            "latitude": "45.455648"
                        }
                    ]
                },
                {
                    "city_id": 5982,
                    "province_id": 4,
                    "name": "黑河市",
                    "whole_name": "黑河市，黑龙江省",
                    "simple_py": "HHS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0456",
                    "area_code": "231100",
                    "longitude": "127.499023",
                    "latitude": "50.249585",
                    "children": [
                        {
                            "area_id": 7671,
                            "city_id": 5982,
                            "province_id": 4,
                            "name": "爱辉区",
                            "whole_name": "爱辉区，黑河市，黑龙江省",
                            "simple_py": "AHQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0456",
                            "area_code": "231102",
                            "longitude": "127.497639",
                            "latitude": "50.249027"
                        },
                        {
                            "area_id": 7673,
                            "city_id": 5982,
                            "province_id": 4,
                            "name": "北安市",
                            "whole_name": "北安市，黑河市，黑龙江省",
                            "simple_py": "BAS",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0456",
                            "area_code": "231181",
                            "longitude": "126.508737",
                            "latitude": "48.245437"
                        },
                        {
                            "area_id": 7670,
                            "city_id": 5982,
                            "province_id": 4,
                            "name": "嫩江县",
                            "whole_name": "嫩江县，黑河市，黑龙江省",
                            "simple_py": "NJX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0456",
                            "area_code": "231121",
                            "longitude": "125.229904",
                            "latitude": "49.177461"
                        },
                        {
                            "area_id": 7669,
                            "city_id": 5982,
                            "province_id": 4,
                            "name": "孙吴县",
                            "whole_name": "孙吴县，黑河市，黑龙江省",
                            "simple_py": "SWX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0456",
                            "area_code": "231124",
                            "longitude": "127.327315",
                            "latitude": "49.423941"
                        },
                        {
                            "area_id": 7672,
                            "city_id": 5982,
                            "province_id": 4,
                            "name": "五大连池市",
                            "whole_name": "五大连池市，黑河市，黑龙江省",
                            "simple_py": "WDLCS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0456",
                            "area_code": "231182",
                            "longitude": "126.197694",
                            "latitude": "48.512688"
                        },
                        {
                            "area_id": 7668,
                            "city_id": 5982,
                            "province_id": 4,
                            "name": "逊克县",
                            "whole_name": "逊克县，黑河市，黑龙江省",
                            "simple_py": "XKX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0456",
                            "area_code": "231123",
                            "longitude": "128.476152",
                            "latitude": "49.582974"
                        }
                    ]
                },
                {
                    "city_id": 5977,
                    "province_id": 4,
                    "name": "佳木斯市",
                    "whole_name": "佳木斯市，黑龙江省",
                    "simple_py": "JMSS",
                    "per_pin_yin": "J",
                    "per_pin_yin2": "J",
                    "city_code": "0454",
                    "area_code": "230800",
                    "longitude": "130.361634",
                    "latitude": "46.809606",
                    "children": [
                        {
                            "area_id": 6735,
                            "city_id": 5977,
                            "province_id": 4,
                            "name": "东风区",
                            "whole_name": "东风区，佳木斯市，黑龙江省",
                            "simple_py": "DFQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0454",
                            "area_code": "230805",
                            "longitude": "130.403297",
                            "latitude": "46.822476"
                        },
                        {
                            "area_id": 6729,
                            "city_id": 5977,
                            "province_id": 4,
                            "name": "抚远市",
                            "whole_name": "抚远市，佳木斯市，黑龙江省",
                            "simple_py": "FYS",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0454",
                            "area_code": "230883",
                            "longitude": "134.294501",
                            "latitude": "48.364707"
                        },
                        {
                            "area_id": 6734,
                            "city_id": 5977,
                            "province_id": 4,
                            "name": "富锦市",
                            "whole_name": "富锦市，佳木斯市，黑龙江省",
                            "simple_py": "FJS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0454",
                            "area_code": "230882",
                            "longitude": "132.037951",
                            "latitude": "47.250747"
                        },
                        {
                            "area_id": 6731,
                            "city_id": 5977,
                            "province_id": 4,
                            "name": "桦川县",
                            "whole_name": "桦川县，佳木斯市，黑龙江省",
                            "simple_py": "HCX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0454",
                            "area_code": "230826",
                            "longitude": "130.723713",
                            "latitude": "47.023039"
                        },
                        {
                            "area_id": 6732,
                            "city_id": 5977,
                            "province_id": 4,
                            "name": "桦南县",
                            "whole_name": "桦南县，佳木斯市，黑龙江省",
                            "simple_py": "HNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0454",
                            "area_code": "230822",
                            "longitude": "130.570112",
                            "latitude": "46.240118"
                        },
                        {
                            "area_id": 6738,
                            "city_id": 5977,
                            "province_id": 4,
                            "name": "郊区",
                            "whole_name": "郊区，佳木斯市，黑龙江省",
                            "simple_py": "JQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0454",
                            "area_code": "230811",
                            "longitude": "130.351588",
                            "latitude": "46.80712"
                        },
                        {
                            "area_id": 6737,
                            "city_id": 5977,
                            "province_id": 4,
                            "name": "前进区",
                            "whole_name": "前进区，佳木斯市，黑龙江省",
                            "simple_py": "QJQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0454",
                            "area_code": "230804",
                            "longitude": "130.377684",
                            "latitude": "46.812345"
                        },
                        {
                            "area_id": 6730,
                            "city_id": 5977,
                            "province_id": 4,
                            "name": "同江市",
                            "whole_name": "同江市，佳木斯市，黑龙江省",
                            "simple_py": "TJS",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0454",
                            "area_code": "230881",
                            "longitude": "132.510119",
                            "latitude": "47.651131"
                        },
                        {
                            "area_id": 6733,
                            "city_id": 5977,
                            "province_id": 4,
                            "name": "汤原县",
                            "whole_name": "汤原县，佳木斯市，黑龙江省",
                            "simple_py": "TYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0454",
                            "area_code": "230828",
                            "longitude": "129.904463",
                            "latitude": "46.730048"
                        },
                        {
                            "area_id": 6736,
                            "city_id": 5977,
                            "province_id": 4,
                            "name": "向阳区",
                            "whole_name": "向阳区，佳木斯市，黑龙江省",
                            "simple_py": "XYQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0454",
                            "area_code": "230803",
                            "longitude": "130.361786",
                            "latitude": "46.809645"
                        }
                    ]
                },
                {
                    "city_id": 5979,
                    "province_id": 4,
                    "name": "鸡西市",
                    "whole_name": "鸡西市，黑龙江省",
                    "simple_py": "JXS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "J",
                    "city_code": "0467",
                    "area_code": "230300",
                    "longitude": "130.975966",
                    "latitude": "45.300046",
                    "children": [
                        {
                            "area_id": 7105,
                            "city_id": 5979,
                            "province_id": 4,
                            "name": "城子河区",
                            "whole_name": "城子河区，鸡西市，黑龙江省",
                            "simple_py": "CZHQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0467",
                            "area_code": "230306",
                            "longitude": "131.010501",
                            "latitude": "45.338248"
                        },
                        {
                            "area_id": 7106,
                            "city_id": 5979,
                            "province_id": 4,
                            "name": "滴道区",
                            "whole_name": "滴道区，鸡西市，黑龙江省",
                            "simple_py": "DDQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0467",
                            "area_code": "230304",
                            "longitude": "130.846823",
                            "latitude": "45.348812"
                        },
                        {
                            "area_id": 7104,
                            "city_id": 5979,
                            "province_id": 4,
                            "name": "虎林市",
                            "whole_name": "虎林市，鸡西市，黑龙江省",
                            "simple_py": "HLS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0467",
                            "area_code": "230381",
                            "longitude": "132.973881",
                            "latitude": "45.767985"
                        },
                        {
                            "area_id": 7109,
                            "city_id": 5979,
                            "province_id": 4,
                            "name": "恒山区",
                            "whole_name": "恒山区，鸡西市，黑龙江省",
                            "simple_py": "HSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0467",
                            "area_code": "230303",
                            "longitude": "130.910636",
                            "latitude": "45.213242"
                        },
                        {
                            "area_id": 7108,
                            "city_id": 5979,
                            "province_id": 4,
                            "name": "鸡冠区",
                            "whole_name": "鸡冠区，鸡西市，黑龙江省",
                            "simple_py": "JGQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0467",
                            "area_code": "230302",
                            "longitude": "130.974374",
                            "latitude": "45.30034"
                        },
                        {
                            "area_id": 7112,
                            "city_id": 5979,
                            "province_id": 4,
                            "name": "鸡东县",
                            "whole_name": "鸡东县，鸡西市，黑龙江省",
                            "simple_py": "JDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0467",
                            "area_code": "230321",
                            "longitude": "131.148907",
                            "latitude": "45.250892"
                        },
                        {
                            "area_id": 7110,
                            "city_id": 5979,
                            "province_id": 4,
                            "name": "梨树区",
                            "whole_name": "梨树区，鸡西市，黑龙江省",
                            "simple_py": "LSQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0467",
                            "area_code": "230305",
                            "longitude": "130.697781",
                            "latitude": "45.092195"
                        },
                        {
                            "area_id": 7107,
                            "city_id": 5979,
                            "province_id": 4,
                            "name": "麻山区",
                            "whole_name": "麻山区，鸡西市，黑龙江省",
                            "simple_py": "MSQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0467",
                            "area_code": "230307",
                            "longitude": "130.481126",
                            "latitude": "45.209607"
                        },
                        {
                            "area_id": 7111,
                            "city_id": 5979,
                            "province_id": 4,
                            "name": "密山市",
                            "whole_name": "密山市，鸡西市，黑龙江省",
                            "simple_py": "MSS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0467",
                            "area_code": "230382",
                            "longitude": "131.874137",
                            "latitude": "45.54725"
                        }
                    ]
                },
                {
                    "city_id": 5983,
                    "province_id": 4,
                    "name": "牡丹江市",
                    "whole_name": "牡丹江市，黑龙江省",
                    "simple_py": "MDJS",
                    "per_pin_yin": "M",
                    "per_pin_yin2": "M",
                    "city_code": "0453",
                    "area_code": "231000",
                    "longitude": "129.618602",
                    "latitude": "44.582962",
                    "children": [
                        {
                            "area_id": 7838,
                            "city_id": 5983,
                            "province_id": 4,
                            "name": "爱民区",
                            "whole_name": "爱民区，牡丹江市，黑龙江省",
                            "simple_py": "AMQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0453",
                            "area_code": "231004",
                            "longitude": "129.601232",
                            "latitude": "44.595443"
                        },
                        {
                            "area_id": 7837,
                            "city_id": 5983,
                            "province_id": 4,
                            "name": "东安区",
                            "whole_name": "东安区，牡丹江市，黑龙江省",
                            "simple_py": "DAQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0453",
                            "area_code": "231002",
                            "longitude": "129.623292",
                            "latitude": "44.582399"
                        },
                        {
                            "area_id": 7840,
                            "city_id": 5983,
                            "province_id": 4,
                            "name": "东宁市",
                            "whole_name": "东宁市，牡丹江市，黑龙江省",
                            "simple_py": "DNS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0453",
                            "area_code": "231086",
                            "longitude": "131.125296",
                            "latitude": "44.063578"
                        },
                        {
                            "area_id": 7846,
                            "city_id": 5983,
                            "province_id": 4,
                            "name": "海林市",
                            "whole_name": "海林市，牡丹江市，黑龙江省",
                            "simple_py": "HLS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0453",
                            "area_code": "231083",
                            "longitude": "129.387902",
                            "latitude": "44.574149"
                        },
                        {
                            "area_id": 7844,
                            "city_id": 5983,
                            "province_id": 4,
                            "name": "林口县",
                            "whole_name": "林口县，牡丹江市，黑龙江省",
                            "simple_py": "LKX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0453",
                            "area_code": "231025",
                            "longitude": "130.268402",
                            "latitude": "45.286645"
                        },
                        {
                            "area_id": 7842,
                            "city_id": 5983,
                            "province_id": 4,
                            "name": "穆棱市",
                            "whole_name": "穆棱市，牡丹江市，黑龙江省",
                            "simple_py": "MLS",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0453",
                            "area_code": "231085",
                            "longitude": "130.527085",
                            "latitude": "44.91967"
                        },
                        {
                            "area_id": 7841,
                            "city_id": 5983,
                            "province_id": 4,
                            "name": "宁安市",
                            "whole_name": "宁安市，牡丹江市，黑龙江省",
                            "simple_py": "NAS",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0453",
                            "area_code": "231084",
                            "longitude": "129.470019",
                            "latitude": "44.346836"
                        },
                        {
                            "area_id": 7839,
                            "city_id": 5983,
                            "province_id": 4,
                            "name": "绥芬河市",
                            "whole_name": "绥芬河市，牡丹江市，黑龙江省",
                            "simple_py": "SFHS",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0453",
                            "area_code": "231081",
                            "longitude": "131.164856",
                            "latitude": "44.396864"
                        },
                        {
                            "area_id": 7845,
                            "city_id": 5983,
                            "province_id": 4,
                            "name": "西安区",
                            "whole_name": "西安区，牡丹江市，黑龙江省",
                            "simple_py": "XAQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0453",
                            "area_code": "231005",
                            "longitude": "129.61311",
                            "latitude": "44.581032"
                        },
                        {
                            "area_id": 7843,
                            "city_id": 5983,
                            "province_id": 4,
                            "name": "阳明区",
                            "whole_name": "阳明区，牡丹江市，黑龙江省",
                            "simple_py": "YMQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0453",
                            "area_code": "231003",
                            "longitude": "129.634645",
                            "latitude": "44.596328"
                        }
                    ]
                },
                {
                    "city_id": 5972,
                    "province_id": 4,
                    "name": "七台河市",
                    "whole_name": "七台河市，黑龙江省",
                    "simple_py": "QTHS",
                    "per_pin_yin": "Q",
                    "per_pin_yin2": "Q",
                    "city_code": "0464",
                    "area_code": "230900",
                    "longitude": "131.015584",
                    "latitude": "45.771266",
                    "children": [
                        {
                            "area_id": 6032,
                            "city_id": 5972,
                            "province_id": 4,
                            "name": "勃利县",
                            "whole_name": "勃利县，七台河市，黑龙江省",
                            "simple_py": "BLX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0464",
                            "area_code": "230921",
                            "longitude": "130.575025",
                            "latitude": "45.751573"
                        },
                        {
                            "area_id": 6033,
                            "city_id": 5972,
                            "province_id": 4,
                            "name": "茄子河区",
                            "whole_name": "茄子河区，七台河市，黑龙江省",
                            "simple_py": "QZHQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0464",
                            "area_code": "230904",
                            "longitude": "131.071561",
                            "latitude": "45.776587"
                        },
                        {
                            "area_id": 6035,
                            "city_id": 5972,
                            "province_id": 4,
                            "name": "桃山区",
                            "whole_name": "桃山区，七台河市，黑龙江省",
                            "simple_py": "TSQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0464",
                            "area_code": "230903",
                            "longitude": "131.015848",
                            "latitude": "45.771217"
                        },
                        {
                            "area_id": 6034,
                            "city_id": 5972,
                            "province_id": 4,
                            "name": "新兴区",
                            "whole_name": "新兴区，七台河市，黑龙江省",
                            "simple_py": "XXQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0464",
                            "area_code": "230902",
                            "longitude": "130.889482",
                            "latitude": "45.794258"
                        }
                    ]
                },
                {
                    "city_id": 5978,
                    "province_id": 4,
                    "name": "齐齐哈尔市",
                    "whole_name": "齐齐哈尔市，黑龙江省",
                    "simple_py": "QQHES",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Q",
                    "city_code": "0452",
                    "area_code": "230200",
                    "longitude": "123.95792",
                    "latitude": "47.342081",
                    "children": [
                        {
                            "area_id": 6882,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "昂昂溪区",
                            "whole_name": "昂昂溪区，齐齐哈尔市，黑龙江省",
                            "simple_py": "AAXQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0452",
                            "area_code": "230205",
                            "longitude": "123.813181",
                            "latitude": "47.156867"
                        },
                        {
                            "area_id": 6885,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "拜泉县",
                            "whole_name": "拜泉县，齐齐哈尔市，黑龙江省",
                            "simple_py": "BQX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0452",
                            "area_code": "230231",
                            "longitude": "126.091911",
                            "latitude": "47.607363"
                        },
                        {
                            "area_id": 6874,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "富裕县",
                            "whole_name": "富裕县，齐齐哈尔市，黑龙江省",
                            "simple_py": "FYX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0452",
                            "area_code": "230227",
                            "longitude": "124.469106",
                            "latitude": "47.797172"
                        },
                        {
                            "area_id": 6880,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "富拉尔基区",
                            "whole_name": "富拉尔基区，齐齐哈尔市，黑龙江省",
                            "simple_py": "FLEJQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0452",
                            "area_code": "230206",
                            "longitude": "123.638873",
                            "latitude": "47.20697"
                        },
                        {
                            "area_id": 6872,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "甘南县",
                            "whole_name": "甘南县，齐齐哈尔市，黑龙江省",
                            "simple_py": "GNX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0452",
                            "area_code": "230225",
                            "longitude": "123.506034",
                            "latitude": "47.917838"
                        },
                        {
                            "area_id": 6883,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "建华区",
                            "whole_name": "建华区，齐齐哈尔市，黑龙江省",
                            "simple_py": "JHQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0452",
                            "area_code": "230203",
                            "longitude": "123.955888",
                            "latitude": "47.354494"
                        },
                        {
                            "area_id": 6871,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "克山县",
                            "whole_name": "克山县，齐齐哈尔市，黑龙江省",
                            "simple_py": "KSX",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0452",
                            "area_code": "230229",
                            "longitude": "125.874355",
                            "latitude": "48.034342"
                        },
                        {
                            "area_id": 6873,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "克东县",
                            "whole_name": "克东县，齐齐哈尔市，黑龙江省",
                            "simple_py": "KDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "K",
                            "city_code": "0452",
                            "area_code": "230230",
                            "longitude": "126.249094",
                            "latitude": "48.03732"
                        },
                        {
                            "area_id": 6877,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "龙江县",
                            "whole_name": "龙江县，齐齐哈尔市，黑龙江省",
                            "simple_py": "LJX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0452",
                            "area_code": "230221",
                            "longitude": "123.187225",
                            "latitude": "47.336388"
                        },
                        {
                            "area_id": 6879,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "龙沙区",
                            "whole_name": "龙沙区，齐齐哈尔市，黑龙江省",
                            "simple_py": "LSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0452",
                            "area_code": "230202",
                            "longitude": "123.957338",
                            "latitude": "47.341736"
                        },
                        {
                            "area_id": 6876,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "梅里斯达斡尔族区",
                            "whole_name": "梅里斯达斡尔族区，齐齐哈尔市，黑龙江省",
                            "simple_py": "MLSDWEZQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0452",
                            "area_code": "230208",
                            "longitude": "123.754599",
                            "latitude": "47.311113"
                        },
                        {
                            "area_id": 6870,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "讷河市",
                            "whole_name": "讷河市，齐齐哈尔市，黑龙江省",
                            "simple_py": "NHS",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0452",
                            "area_code": "230281",
                            "longitude": "124.882172",
                            "latitude": "48.481133"
                        },
                        {
                            "area_id": 6878,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "碾子山区",
                            "whole_name": "碾子山区，齐齐哈尔市，黑龙江省",
                            "simple_py": "NZSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0452",
                            "area_code": "230207",
                            "longitude": "122.887972",
                            "latitude": "47.51401"
                        },
                        {
                            "area_id": 6881,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "铁锋区",
                            "whole_name": "铁锋区，齐齐哈尔市，黑龙江省",
                            "simple_py": "TFQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0452",
                            "area_code": "230204",
                            "longitude": "123.973555",
                            "latitude": "47.339499"
                        },
                        {
                            "area_id": 6884,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "泰来县",
                            "whole_name": "泰来县，齐齐哈尔市，黑龙江省",
                            "simple_py": "TLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0452",
                            "area_code": "230224",
                            "longitude": "123.41953",
                            "latitude": "46.39233"
                        },
                        {
                            "area_id": 6875,
                            "city_id": 5978,
                            "province_id": 4,
                            "name": "依安县",
                            "whole_name": "依安县，齐齐哈尔市，黑龙江省",
                            "simple_py": "YAX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0452",
                            "area_code": "230223",
                            "longitude": "125.307561",
                            "latitude": "47.890098"
                        }
                    ]
                },
                {
                    "city_id": 5976,
                    "province_id": 4,
                    "name": "绥化市",
                    "whole_name": "绥化市，黑龙江省",
                    "simple_py": "SHS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0455",
                    "area_code": "231200",
                    "longitude": "126.99293",
                    "latitude": "46.637393",
                    "children": [
                        {
                            "area_id": 6508,
                            "city_id": 5976,
                            "province_id": 4,
                            "name": "安达市",
                            "whole_name": "安达市，绥化市，黑龙江省",
                            "simple_py": "ADS",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0455",
                            "area_code": "231281",
                            "longitude": "125.329926",
                            "latitude": "46.410614"
                        },
                        {
                            "area_id": 6505,
                            "city_id": 5976,
                            "province_id": 4,
                            "name": "北林区",
                            "whole_name": "北林区，绥化市，黑龙江省",
                            "simple_py": "BLQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0455",
                            "area_code": "231202",
                            "longitude": "126.990665",
                            "latitude": "46.634912"
                        },
                        {
                            "area_id": 6503,
                            "city_id": 5976,
                            "province_id": 4,
                            "name": "海伦市",
                            "whole_name": "海伦市，绥化市，黑龙江省",
                            "simple_py": "HLS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0455",
                            "area_code": "231283",
                            "longitude": "126.969383",
                            "latitude": "47.460428"
                        },
                        {
                            "area_id": 6511,
                            "city_id": 5976,
                            "province_id": 4,
                            "name": "兰西县",
                            "whole_name": "兰西县，绥化市，黑龙江省",
                            "simple_py": "LXX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0455",
                            "area_code": "231222",
                            "longitude": "126.289315",
                            "latitude": "46.259037"
                        },
                        {
                            "area_id": 6509,
                            "city_id": 5976,
                            "province_id": 4,
                            "name": "明水县",
                            "whole_name": "明水县，绥化市，黑龙江省",
                            "simple_py": "MSX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0455",
                            "area_code": "231225",
                            "longitude": "125.907544",
                            "latitude": "47.183527"
                        },
                        {
                            "area_id": 6504,
                            "city_id": 5976,
                            "province_id": 4,
                            "name": "庆安县",
                            "whole_name": "庆安县，绥化市，黑龙江省",
                            "simple_py": "QAX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0455",
                            "area_code": "231224",
                            "longitude": "127.510024",
                            "latitude": "46.879203"
                        },
                        {
                            "area_id": 6506,
                            "city_id": 5976,
                            "province_id": 4,
                            "name": "青冈县",
                            "whole_name": "青冈县，绥化市，黑龙江省",
                            "simple_py": "QGX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0455",
                            "area_code": "231223",
                            "longitude": "126.112268",
                            "latitude": "46.686596"
                        },
                        {
                            "area_id": 6502,
                            "city_id": 5976,
                            "province_id": 4,
                            "name": "绥棱县",
                            "whole_name": "绥棱县，绥化市，黑龙江省",
                            "simple_py": "SLX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0455",
                            "area_code": "231226",
                            "longitude": "127.111121",
                            "latitude": "47.247195"
                        },
                        {
                            "area_id": 6507,
                            "city_id": 5976,
                            "province_id": 4,
                            "name": "望奎县",
                            "whole_name": "望奎县，绥化市，黑龙江省",
                            "simple_py": "WKX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0455",
                            "area_code": "231221",
                            "longitude": "126.484191",
                            "latitude": "46.83352"
                        },
                        {
                            "area_id": 6510,
                            "city_id": 5976,
                            "province_id": 4,
                            "name": "肇东市",
                            "whole_name": "肇东市，绥化市，黑龙江省",
                            "simple_py": "ZDS",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0455",
                            "area_code": "231282",
                            "longitude": "125.991402",
                            "latitude": "46.069471"
                        }
                    ]
                },
                {
                    "city_id": 5980,
                    "province_id": 4,
                    "name": "双鸭山市",
                    "whole_name": "双鸭山市，黑龙江省",
                    "simple_py": "SYSS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "S",
                    "city_code": "0469",
                    "area_code": "230500",
                    "longitude": "131.157304",
                    "latitude": "46.643442",
                    "children": [
                        {
                            "area_id": 7221,
                            "city_id": 5980,
                            "province_id": 4,
                            "name": "宝山区",
                            "whole_name": "宝山区，双鸭山市，黑龙江省",
                            "simple_py": "BSQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0469",
                            "area_code": "230506",
                            "longitude": "131.404294",
                            "latitude": "46.573366"
                        },
                        {
                            "area_id": 7222,
                            "city_id": 5980,
                            "province_id": 4,
                            "name": "宝清县",
                            "whole_name": "宝清县，双鸭山市，黑龙江省",
                            "simple_py": "BQX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0469",
                            "area_code": "230523",
                            "longitude": "132.206415",
                            "latitude": "46.328781"
                        },
                        {
                            "area_id": 7218,
                            "city_id": 5980,
                            "province_id": 4,
                            "name": "尖山区",
                            "whole_name": "尖山区，双鸭山市，黑龙江省",
                            "simple_py": "JSQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0469",
                            "area_code": "230502",
                            "longitude": "131.15896",
                            "latitude": "46.642961"
                        },
                        {
                            "area_id": 7219,
                            "city_id": 5980,
                            "province_id": 4,
                            "name": "集贤县",
                            "whole_name": "集贤县，双鸭山市，黑龙江省",
                            "simple_py": "JXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0469",
                            "area_code": "230521",
                            "longitude": "131.13933",
                            "latitude": "46.72898"
                        },
                        {
                            "area_id": 7220,
                            "city_id": 5980,
                            "province_id": 4,
                            "name": "岭东区",
                            "whole_name": "岭东区，双鸭山市，黑龙江省",
                            "simple_py": "LDQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0469",
                            "area_code": "230503",
                            "longitude": "131.163675",
                            "latitude": "46.591076"
                        },
                        {
                            "area_id": 7215,
                            "city_id": 5980,
                            "province_id": 4,
                            "name": "饶河县",
                            "whole_name": "饶河县，双鸭山市，黑龙江省",
                            "simple_py": "RHX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0469",
                            "area_code": "230524",
                            "longitude": "134.021162",
                            "latitude": "46.801288"
                        },
                        {
                            "area_id": 7216,
                            "city_id": 5980,
                            "province_id": 4,
                            "name": "四方台区",
                            "whole_name": "四方台区，双鸭山市，黑龙江省",
                            "simple_py": "SFTQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0469",
                            "area_code": "230505",
                            "longitude": "131.333181",
                            "latitude": "46.594347"
                        },
                        {
                            "area_id": 7217,
                            "city_id": 5980,
                            "province_id": 4,
                            "name": "友谊县",
                            "whole_name": "友谊县，双鸭山市，黑龙江省",
                            "simple_py": "YYX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0469",
                            "area_code": "230522",
                            "longitude": "131.810622",
                            "latitude": "46.775159"
                        }
                    ]
                },
                {
                    "city_id": 5975,
                    "province_id": 4,
                    "name": "伊春市",
                    "whole_name": "伊春市，黑龙江省",
                    "simple_py": "YCS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0458",
                    "area_code": "230700",
                    "longitude": "128.899396",
                    "latitude": "47.724775",
                    "children": [
                        {
                            "area_id": 6301,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "翠峦区",
                            "whole_name": "翠峦区，伊春市，黑龙江省",
                            "simple_py": "CLQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0458",
                            "area_code": "230706",
                            "longitude": "128.671746",
                            "latitude": "47.726228"
                        },
                        {
                            "area_id": 6308,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "带岭区",
                            "whole_name": "带岭区，伊春市，黑龙江省",
                            "simple_py": "DLQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0458",
                            "area_code": "230713",
                            "longitude": "129.021151",
                            "latitude": "47.027532"
                        },
                        {
                            "area_id": 6296,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "红星区",
                            "whole_name": "红星区，伊春市，黑龙江省",
                            "simple_py": "HXQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0458",
                            "area_code": "230715",
                            "longitude": "129.388796",
                            "latitude": "48.238368"
                        },
                        {
                            "area_id": 6294,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "嘉荫县",
                            "whole_name": "嘉荫县，伊春市，黑龙江省",
                            "simple_py": "JYX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0458",
                            "area_code": "230722",
                            "longitude": "130.397684",
                            "latitude": "48.891378"
                        },
                        {
                            "area_id": 6305,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "金山屯区",
                            "whole_name": "金山屯区，伊春市，黑龙江省",
                            "simple_py": "JSTQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0458",
                            "area_code": "230709",
                            "longitude": "129.435944",
                            "latitude": "47.41295"
                        },
                        {
                            "area_id": 6302,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "美溪区",
                            "whole_name": "美溪区，伊春市，黑龙江省",
                            "simple_py": "MXQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0458",
                            "area_code": "230708",
                            "longitude": "129.133411",
                            "latitude": "47.636102"
                        },
                        {
                            "area_id": 6309,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "南岔区",
                            "whole_name": "南岔区，伊春市，黑龙江省",
                            "simple_py": "NCQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0458",
                            "area_code": "230703",
                            "longitude": "129.28246",
                            "latitude": "47.137314"
                        },
                        {
                            "area_id": 6300,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "上甘岭区",
                            "whole_name": "上甘岭区，伊春市，黑龙江省",
                            "simple_py": "SGLQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0458",
                            "area_code": "230716",
                            "longitude": "129.02508",
                            "latitude": "47.974859"
                        },
                        {
                            "area_id": 6298,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "汤旺河区",
                            "whole_name": "汤旺河区，伊春市，黑龙江省",
                            "simple_py": "TWHQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0458",
                            "area_code": "230712",
                            "longitude": "129.57224",
                            "latitude": "48.453651"
                        },
                        {
                            "area_id": 6306,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "铁力市",
                            "whole_name": "铁力市，伊春市，黑龙江省",
                            "simple_py": "TLS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0458",
                            "area_code": "230781",
                            "longitude": "128.030561",
                            "latitude": "46.985772"
                        },
                        {
                            "area_id": 6293,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "乌伊岭区",
                            "whole_name": "乌伊岭区，伊春市，黑龙江省",
                            "simple_py": "WYLQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0458",
                            "area_code": "230714",
                            "longitude": "129.437847",
                            "latitude": "48.59112"
                        },
                        {
                            "area_id": 6297,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "五营区",
                            "whole_name": "五营区，伊春市，黑龙江省",
                            "simple_py": "WYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0458",
                            "area_code": "230710",
                            "longitude": "129.245028",
                            "latitude": "48.108204"
                        },
                        {
                            "area_id": 6303,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "乌马河区",
                            "whole_name": "乌马河区，伊春市，黑龙江省",
                            "simple_py": "WMHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0458",
                            "area_code": "230711",
                            "longitude": "128.802941",
                            "latitude": "47.726961"
                        },
                        {
                            "area_id": 6299,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "新青区",
                            "whole_name": "新青区，伊春市，黑龙江省",
                            "simple_py": "XQQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0458",
                            "area_code": "230707",
                            "longitude": "129.52995",
                            "latitude": "48.288292"
                        },
                        {
                            "area_id": 6307,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "西林区",
                            "whole_name": "西林区，伊春市，黑龙江省",
                            "simple_py": "XLQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0458",
                            "area_code": "230705",
                            "longitude": "129.311441",
                            "latitude": "47.479437"
                        },
                        {
                            "area_id": 6295,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "友好区",
                            "whole_name": "友好区，伊春市，黑龙江省",
                            "simple_py": "YHQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0458",
                            "area_code": "230704",
                            "longitude": "128.838961",
                            "latitude": "47.854303"
                        },
                        {
                            "area_id": 6304,
                            "city_id": 5975,
                            "province_id": 4,
                            "name": "伊春区",
                            "whole_name": "伊春区，伊春市，黑龙江省",
                            "simple_py": "YCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0458",
                            "area_code": "230702",
                            "longitude": "128.899284",
                            "latitude": "47.726851"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 6,
            "name": "湖北省",
            "whole_name": "湖北省",
            "simple_py": "HBS",
            "per_pin_yin": " ",
            "per_pin_yin2": "H",
            "city_code": "",
            "area_code": "420000",
            "longitude": "114.298572",
            "latitude": "30.584355",
            "children": [
                {
                    "city_id": 9467,
                    "province_id": 6,
                    "name": "恩施土家族苗族自治州",
                    "whole_name": "恩施土家族苗族自治州，湖北省",
                    "simple_py": "ESTJZMZZZZ",
                    "per_pin_yin": "E",
                    "per_pin_yin2": "E",
                    "city_code": "0718",
                    "area_code": "422800",
                    "longitude": "109.48699",
                    "latitude": "30.283114",
                    "children": [
                        {
                            "area_id": 10121,
                            "city_id": 9467,
                            "province_id": 6,
                            "name": "巴东县",
                            "whole_name": "巴东县，恩施土家族苗族自治州，湖北省",
                            "simple_py": "BDX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0718",
                            "area_code": "422823",
                            "longitude": "110.336665",
                            "latitude": "31.041403"
                        },
                        {
                            "area_id": 10118,
                            "city_id": 9467,
                            "province_id": 6,
                            "name": "恩施市",
                            "whole_name": "恩施市，恩施土家族苗族自治州，湖北省",
                            "simple_py": "ESS",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0718",
                            "area_code": "422801",
                            "longitude": "109.486761",
                            "latitude": "30.282406"
                        },
                        {
                            "area_id": 10119,
                            "city_id": 9467,
                            "province_id": 6,
                            "name": "鹤峰县",
                            "whole_name": "鹤峰县，恩施土家族苗族自治州，湖北省",
                            "simple_py": "HFX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0718",
                            "area_code": "422828",
                            "longitude": "110.033699",
                            "latitude": "29.887298"
                        },
                        {
                            "area_id": 10116,
                            "city_id": 9467,
                            "province_id": 6,
                            "name": "建始县",
                            "whole_name": "建始县，恩施土家族苗族自治州，湖北省",
                            "simple_py": "JSX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0718",
                            "area_code": "422822",
                            "longitude": "109.723822",
                            "latitude": "30.601632"
                        },
                        {
                            "area_id": 10117,
                            "city_id": 9467,
                            "province_id": 6,
                            "name": "利川市",
                            "whole_name": "利川市，恩施土家族苗族自治州，湖北省",
                            "simple_py": "LCS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0718",
                            "area_code": "422802",
                            "longitude": "108.943491",
                            "latitude": "30.294247"
                        },
                        {
                            "area_id": 10120,
                            "city_id": 9467,
                            "province_id": 6,
                            "name": "来凤县",
                            "whole_name": "来凤县，恩施土家族苗族自治州，湖北省",
                            "simple_py": "LFX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0718",
                            "area_code": "422827",
                            "longitude": "109.408328",
                            "latitude": "29.506945"
                        },
                        {
                            "area_id": 10122,
                            "city_id": 9467,
                            "province_id": 6,
                            "name": "宣恩县",
                            "whole_name": "宣恩县，恩施土家族苗族自治州，湖北省",
                            "simple_py": "XEX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0718",
                            "area_code": "422825",
                            "longitude": "109.482819",
                            "latitude": "29.98867"
                        },
                        {
                            "area_id": 10123,
                            "city_id": 9467,
                            "province_id": 6,
                            "name": "咸丰县",
                            "whole_name": "咸丰县，恩施土家族苗族自治州，湖北省",
                            "simple_py": "XFX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0718",
                            "area_code": "422826",
                            "longitude": "109.15041",
                            "latitude": "29.678967"
                        }
                    ]
                },
                {
                    "city_id": 9479,
                    "province_id": 6,
                    "name": "鄂州市",
                    "whole_name": "鄂州市，湖北省",
                    "simple_py": "EZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "E",
                    "city_code": "0711",
                    "area_code": "420700",
                    "longitude": "114.890593",
                    "latitude": "30.396536",
                    "children": [
                        {
                            "area_id": 11040,
                            "city_id": 9479,
                            "province_id": 6,
                            "name": "鄂城区",
                            "whole_name": "鄂城区，鄂州市，湖北省",
                            "simple_py": "ECQ",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0711",
                            "area_code": "420704",
                            "longitude": "114.890012",
                            "latitude": "30.39669"
                        },
                        {
                            "area_id": 11038,
                            "city_id": 9479,
                            "province_id": 6,
                            "name": "华容区",
                            "whole_name": "华容区，鄂州市，湖北省",
                            "simple_py": "HRQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0711",
                            "area_code": "420703",
                            "longitude": "114.74148",
                            "latitude": "30.534468"
                        },
                        {
                            "area_id": 11039,
                            "city_id": 9479,
                            "province_id": 6,
                            "name": "梁子湖区",
                            "whole_name": "梁子湖区，鄂州市，湖北省",
                            "simple_py": "LZHQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0711",
                            "area_code": "420702",
                            "longitude": "114.681967",
                            "latitude": "30.098191"
                        }
                    ]
                },
                {
                    "city_id": 9469,
                    "province_id": 6,
                    "name": "黄冈市",
                    "whole_name": "黄冈市，湖北省",
                    "simple_py": "HGS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0713",
                    "area_code": "421100",
                    "longitude": "114.879365",
                    "latitude": "30.447711",
                    "children": [
                        {
                            "area_id": 10243,
                            "city_id": 9469,
                            "province_id": 6,
                            "name": "红安县",
                            "whole_name": "红安县，黄冈市，湖北省",
                            "simple_py": "HAX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0713",
                            "area_code": "421122",
                            "longitude": "114.615095",
                            "latitude": "31.284777"
                        },
                        {
                            "area_id": 10250,
                            "city_id": 9469,
                            "province_id": 6,
                            "name": "黄州区",
                            "whole_name": "黄州区，黄冈市，湖北省",
                            "simple_py": "HZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0713",
                            "area_code": "421102",
                            "longitude": "114.878934",
                            "latitude": "30.447435"
                        },
                        {
                            "area_id": 10251,
                            "city_id": 9469,
                            "province_id": 6,
                            "name": "黄梅县",
                            "whole_name": "黄梅县，黄冈市，湖北省",
                            "simple_py": "HMX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0713",
                            "area_code": "421127",
                            "longitude": "115.942548",
                            "latitude": "30.075113"
                        },
                        {
                            "area_id": 10245,
                            "city_id": 9469,
                            "province_id": 6,
                            "name": "罗田县",
                            "whole_name": "罗田县，黄冈市，湖北省",
                            "simple_py": "LTX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0713",
                            "area_code": "421123",
                            "longitude": "115.398984",
                            "latitude": "30.781679"
                        },
                        {
                            "area_id": 10248,
                            "city_id": 9469,
                            "province_id": 6,
                            "name": "麻城市",
                            "whole_name": "麻城市，黄冈市，湖北省",
                            "simple_py": "MCS",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0713",
                            "area_code": "421181",
                            "longitude": "115.02541",
                            "latitude": "31.177906"
                        },
                        {
                            "area_id": 10249,
                            "city_id": 9469,
                            "province_id": 6,
                            "name": "蕲春县",
                            "whole_name": "蕲春县，黄冈市，湖北省",
                            "simple_py": "QCX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0713",
                            "area_code": "421126",
                            "longitude": "115.433964",
                            "latitude": "30.234927"
                        },
                        {
                            "area_id": 10246,
                            "city_id": 9469,
                            "province_id": 6,
                            "name": "团风县",
                            "whole_name": "团风县，黄冈市，湖北省",
                            "simple_py": "TFX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0713",
                            "area_code": "421121",
                            "longitude": "114.872029",
                            "latitude": "30.63569"
                        },
                        {
                            "area_id": 10252,
                            "city_id": 9469,
                            "province_id": 6,
                            "name": "武穴市",
                            "whole_name": "武穴市，黄冈市，湖北省",
                            "simple_py": "WXS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0713",
                            "area_code": "421182",
                            "longitude": "115.56242",
                            "latitude": "29.849342"
                        },
                        {
                            "area_id": 10247,
                            "city_id": 9469,
                            "province_id": 6,
                            "name": "浠水县",
                            "whole_name": "浠水县，黄冈市，湖北省",
                            "simple_py": "XSX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0713",
                            "area_code": "421125",
                            "longitude": "115.26344",
                            "latitude": "30.454837"
                        },
                        {
                            "area_id": 10244,
                            "city_id": 9469,
                            "province_id": 6,
                            "name": "英山县",
                            "whole_name": "英山县，黄冈市，湖北省",
                            "simple_py": "YSX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0713",
                            "area_code": "421124",
                            "longitude": "115.67753",
                            "latitude": "30.735794"
                        }
                    ]
                },
                {
                    "city_id": 9478,
                    "province_id": 6,
                    "name": "黄石市",
                    "whole_name": "黄石市，湖北省",
                    "simple_py": "HSS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0714",
                    "area_code": "420200",
                    "longitude": "115.077048",
                    "latitude": "30.220074",
                    "children": [
                        {
                            "area_id": 10988,
                            "city_id": 9478,
                            "province_id": 6,
                            "name": "大冶市",
                            "whole_name": "大冶市，黄石市，湖北省",
                            "simple_py": "DYS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0714",
                            "area_code": "420281",
                            "longitude": "114.974842",
                            "latitude": "30.098804"
                        },
                        {
                            "area_id": 10989,
                            "city_id": 9478,
                            "province_id": 6,
                            "name": "黄石港区",
                            "whole_name": "黄石港区，黄石市，湖北省",
                            "simple_py": "HSGQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0714",
                            "area_code": "420202",
                            "longitude": "115.090164",
                            "latitude": "30.212086"
                        },
                        {
                            "area_id": 10984,
                            "city_id": 9478,
                            "province_id": 6,
                            "name": "铁山区",
                            "whole_name": "铁山区，黄石市，湖北省",
                            "simple_py": "TSQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0714",
                            "area_code": "420205",
                            "longitude": "114.901366",
                            "latitude": "30.20601"
                        },
                        {
                            "area_id": 10985,
                            "city_id": 9478,
                            "province_id": 6,
                            "name": "西塞山区",
                            "whole_name": "西塞山区，黄石市，湖北省",
                            "simple_py": "XSSQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0714",
                            "area_code": "420203",
                            "longitude": "115.093354",
                            "latitude": "30.205365"
                        },
                        {
                            "area_id": 10986,
                            "city_id": 9478,
                            "province_id": 6,
                            "name": "下陆区",
                            "whole_name": "下陆区，黄石市，湖北省",
                            "simple_py": "XLQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0714",
                            "area_code": "420204",
                            "longitude": "114.975755",
                            "latitude": "30.177845"
                        },
                        {
                            "area_id": 10987,
                            "city_id": 9478,
                            "province_id": 6,
                            "name": "阳新县",
                            "whole_name": "阳新县，黄石市，湖北省",
                            "simple_py": "YXX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0714",
                            "area_code": "420222",
                            "longitude": "115.212883",
                            "latitude": "29.841572"
                        }
                    ]
                },
                {
                    "city_id": 9472,
                    "province_id": 6,
                    "name": "荆门市",
                    "whole_name": "荆门市，湖北省",
                    "simple_py": "JMS",
                    "per_pin_yin": "J",
                    "per_pin_yin2": "J",
                    "city_code": "0724",
                    "area_code": "420800",
                    "longitude": "112.204251",
                    "latitude": "31.03542",
                    "children": [
                        {
                            "area_id": 10581,
                            "city_id": 9472,
                            "province_id": 6,
                            "name": "东宝区",
                            "whole_name": "东宝区，荆门市，湖北省",
                            "simple_py": "DBQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0724",
                            "area_code": "420802",
                            "longitude": "112.204804",
                            "latitude": "31.033461"
                        },
                        {
                            "area_id": 10583,
                            "city_id": 9472,
                            "province_id": 6,
                            "name": "掇刀区",
                            "whole_name": "掇刀区，荆门市，湖北省",
                            "simple_py": "DDQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0724",
                            "area_code": "420804",
                            "longitude": "112.198413",
                            "latitude": "30.980798"
                        },
                        {
                            "area_id": 10580,
                            "city_id": 9472,
                            "province_id": 6,
                            "name": "京山县",
                            "whole_name": "京山县，荆门市，湖北省",
                            "simple_py": "JSX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0724",
                            "area_code": "420821",
                            "longitude": "113.114595",
                            "latitude": "31.022458"
                        },
                        {
                            "area_id": 10584,
                            "city_id": 9472,
                            "province_id": 6,
                            "name": "沙洋县",
                            "whole_name": "沙洋县，荆门市，湖北省",
                            "simple_py": "SYX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0724",
                            "area_code": "420822",
                            "longitude": "112.595218",
                            "latitude": "30.70359"
                        },
                        {
                            "area_id": 10582,
                            "city_id": 9472,
                            "province_id": 6,
                            "name": "钟祥市",
                            "whole_name": "钟祥市，荆门市，湖北省",
                            "simple_py": "ZXS",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0724",
                            "area_code": "420881",
                            "longitude": "112.587267",
                            "latitude": "31.165573"
                        }
                    ]
                },
                {
                    "city_id": 9476,
                    "province_id": 6,
                    "name": "荆州市",
                    "whole_name": "荆州市，湖北省",
                    "simple_py": "JZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "J",
                    "city_code": "0716",
                    "area_code": "421000",
                    "longitude": "112.23813",
                    "latitude": "30.326857",
                    "children": [
                        {
                            "area_id": 10761,
                            "city_id": 9476,
                            "province_id": 6,
                            "name": "公安县",
                            "whole_name": "公安县，荆州市，湖北省",
                            "simple_py": "GAX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0716",
                            "area_code": "421022",
                            "longitude": "112.230179",
                            "latitude": "30.059065"
                        },
                        {
                            "area_id": 10758,
                            "city_id": 9476,
                            "province_id": 6,
                            "name": "洪湖市",
                            "whole_name": "洪湖市，荆州市，湖北省",
                            "simple_py": "HHS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0716",
                            "area_code": "421083",
                            "longitude": "113.470304",
                            "latitude": "29.81297"
                        },
                        {
                            "area_id": 10754,
                            "city_id": 9476,
                            "province_id": 6,
                            "name": "荆州区",
                            "whole_name": "荆州区，荆州市，湖北省",
                            "simple_py": "JZQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0716",
                            "area_code": "421003",
                            "longitude": "112.195354",
                            "latitude": "30.350674"
                        },
                        {
                            "area_id": 10755,
                            "city_id": 9476,
                            "province_id": 6,
                            "name": "江陵县",
                            "whole_name": "江陵县，荆州市，湖北省",
                            "simple_py": "JLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0716",
                            "area_code": "421024",
                            "longitude": "112.41735",
                            "latitude": "30.033919"
                        },
                        {
                            "area_id": 10756,
                            "city_id": 9476,
                            "province_id": 6,
                            "name": "监利县",
                            "whole_name": "监利县，荆州市，湖北省",
                            "simple_py": "JLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0716",
                            "area_code": "421023",
                            "longitude": "112.904344",
                            "latitude": "29.820079"
                        },
                        {
                            "area_id": 10757,
                            "city_id": 9476,
                            "province_id": 6,
                            "name": "石首市",
                            "whole_name": "石首市，荆州市，湖北省",
                            "simple_py": "SSS",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0716",
                            "area_code": "421081",
                            "longitude": "112.40887",
                            "latitude": "29.716437"
                        },
                        {
                            "area_id": 10759,
                            "city_id": 9476,
                            "province_id": 6,
                            "name": "沙市区",
                            "whole_name": "沙市区，荆州市，湖北省",
                            "simple_py": "SSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0716",
                            "area_code": "421002",
                            "longitude": "112.257433",
                            "latitude": "30.315895"
                        },
                        {
                            "area_id": 10760,
                            "city_id": 9476,
                            "province_id": 6,
                            "name": "松滋市",
                            "whole_name": "松滋市，荆州市，湖北省",
                            "simple_py": "SZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0716",
                            "area_code": "421087",
                            "longitude": "111.77818",
                            "latitude": "30.176037"
                        }
                    ]
                },
                {
                    "city_id": 9470,
                    "province_id": 6,
                    "name": "潜江市",
                    "whole_name": "潜江市，湖北省",
                    "simple_py": "QJS",
                    "per_pin_yin": "Q",
                    "per_pin_yin2": "Q",
                    "city_code": "0728",
                    "area_code": "429005",
                    "longitude": "112.896866",
                    "latitude": "30.421215",
                    "children": [
                        {
                            "area_id": 10431,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "白鹭湖管理区",
                            "whole_name": "白鹭湖管理区，潜江市，湖北省",
                            "simple_py": "BLHGLQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.716",
                            "latitude": "30.1788"
                        },
                        {
                            "area_id": 10421,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "广华街道",
                            "whole_name": "广华街道，潜江市，湖北省",
                            "simple_py": "GHJD",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.666",
                            "latitude": "30.4633"
                        },
                        {
                            "area_id": 10427,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "高场街道",
                            "whole_name": "高场街道，潜江市，湖北省",
                            "simple_py": "GCJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.775",
                            "latitude": "30.4076"
                        },
                        {
                            "area_id": 10444,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "高石碑镇",
                            "whole_name": "高石碑镇，潜江市，湖北省",
                            "simple_py": "GSBZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.626",
                            "latitude": "30.6203"
                        },
                        {
                            "area_id": 10435,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "后湖管理区",
                            "whole_name": "后湖管理区，潜江市，湖北省",
                            "simple_py": "HHGLQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.768",
                            "latitude": "30.4049"
                        },
                        {
                            "area_id": 10442,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "浩口原种场",
                            "whole_name": "浩口原种场，潜江市，湖北省",
                            "simple_py": "HKYZC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.643",
                            "latitude": "30.3784"
                        },
                        {
                            "area_id": 10443,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "浩口镇",
                            "whole_name": "浩口镇，潜江市，湖北省",
                            "simple_py": "HKZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.65",
                            "latitude": "30.3695"
                        },
                        {
                            "area_id": 10420,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "积玉口镇",
                            "whole_name": "积玉口镇，潜江市，湖北省",
                            "simple_py": "JYKZ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.721",
                            "latitude": "30.4185"
                        },
                        {
                            "area_id": 10437,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "江汉石油管理局",
                            "whole_name": "江汉石油管理局，潜江市，湖北省",
                            "simple_py": "JHSYGLJ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.793",
                            "latitude": "30.4635"
                        },
                        {
                            "area_id": 10440,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "老新镇",
                            "whole_name": "老新镇，潜江市，湖北省",
                            "simple_py": "LXZ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.81",
                            "latitude": "30.2185"
                        },
                        {
                            "area_id": 10441,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "龙湾镇",
                            "whole_name": "龙湾镇，潜江市，湖北省",
                            "simple_py": "LWZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.69",
                            "latitude": "30.2848"
                        },
                        {
                            "area_id": 10423,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "潜江经济开发区",
                            "whole_name": "潜江经济开发区，潜江市，湖北省",
                            "simple_py": "QJJJKFQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.883",
                            "latitude": "30.4825"
                        },
                        {
                            "area_id": 10422,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "泰丰街道",
                            "whole_name": "泰丰街道，潜江市，湖北省",
                            "simple_py": "TFJD",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.981",
                            "latitude": "30.4167"
                        },
                        {
                            "area_id": 10428,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "王场镇",
                            "whole_name": "王场镇，潜江市，湖北省",
                            "simple_py": "WCZ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.819",
                            "latitude": "30.4906"
                        },
                        {
                            "area_id": 10434,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "熊口镇",
                            "whole_name": "熊口镇，潜江市，湖北省",
                            "simple_py": "XKZ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.724",
                            "latitude": "30.3404"
                        },
                        {
                            "area_id": 10436,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "熊口管理区",
                            "whole_name": "熊口管理区，潜江市，湖北省",
                            "simple_py": "XKGLQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.802",
                            "latitude": "30.195"
                        },
                        {
                            "area_id": 10429,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "运粮湖管理区",
                            "whole_name": "运粮湖管理区，潜江市，湖北省",
                            "simple_py": "YLHGLQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.582",
                            "latitude": "30.252"
                        },
                        {
                            "area_id": 10430,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "园林街道",
                            "whole_name": "园林街道，潜江市，湖北省",
                            "simple_py": "YLJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.91",
                            "latitude": "30.377"
                        },
                        {
                            "area_id": 10433,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "渔洋镇",
                            "whole_name": "渔洋镇，潜江市，湖北省",
                            "simple_py": "YYZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.966",
                            "latitude": "30.2392"
                        },
                        {
                            "area_id": 10439,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "杨市街道",
                            "whole_name": "杨市街道，潜江市，湖北省",
                            "simple_py": "YSJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.915",
                            "latitude": "30.3835"
                        },
                        {
                            "area_id": 10424,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "周矶管理区",
                            "whole_name": "周矶管理区，潜江市，湖北省",
                            "simple_py": "ZJGLQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.826",
                            "latitude": "30.4567"
                        },
                        {
                            "area_id": 10425,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "周矶街道",
                            "whole_name": "周矶街道，潜江市，湖北省",
                            "simple_py": "ZJJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.818",
                            "latitude": "30.4576"
                        },
                        {
                            "area_id": 10426,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "总口管理区",
                            "whole_name": "总口管理区，潜江市，湖北省",
                            "simple_py": "ZKGLQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.89",
                            "latitude": "30.2581"
                        },
                        {
                            "area_id": 10432,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "竹根滩镇",
                            "whole_name": "竹根滩镇，潜江市，湖北省",
                            "simple_py": "ZGTZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.979",
                            "latitude": "30.4716"
                        },
                        {
                            "area_id": 10438,
                            "city_id": 9470,
                            "province_id": 6,
                            "name": "张金镇",
                            "whole_name": "张金镇，潜江市，湖北省",
                            "simple_py": "ZJZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0728",
                            "area_code": "429005",
                            "longitude": "112.577",
                            "latitude": "30.2389"
                        }
                    ]
                },
                {
                    "city_id": 9463,
                    "province_id": 6,
                    "name": "十堰市",
                    "whole_name": "十堰市，湖北省",
                    "simple_py": "SYS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0719",
                    "area_code": "420300",
                    "longitude": "110.787916",
                    "latitude": "32.646907",
                    "children": [
                        {
                            "area_id": 9481,
                            "city_id": 9463,
                            "province_id": 6,
                            "name": "丹江口市",
                            "whole_name": "丹江口市，十堰市，湖北省",
                            "simple_py": "DJKS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0719",
                            "area_code": "420381",
                            "longitude": "111.513793",
                            "latitude": "32.538839"
                        },
                        {
                            "area_id": 9485,
                            "city_id": 9463,
                            "province_id": 6,
                            "name": "房县",
                            "whole_name": "房县，十堰市，湖北省",
                            "simple_py": "FX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0719",
                            "area_code": "420325",
                            "longitude": "110.741966",
                            "latitude": "32.055002"
                        },
                        {
                            "area_id": 9483,
                            "city_id": 9463,
                            "province_id": 6,
                            "name": "茅箭区",
                            "whole_name": "茅箭区，十堰市，湖北省",
                            "simple_py": "MJQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0719",
                            "area_code": "420302",
                            "longitude": "110.78621",
                            "latitude": "32.644463"
                        },
                        {
                            "area_id": 9480,
                            "city_id": 9463,
                            "province_id": 6,
                            "name": "郧阳区",
                            "whole_name": "郧阳区，十堰市，湖北省",
                            "simple_py": "YYQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0719",
                            "area_code": "420304",
                            "longitude": "110.812099",
                            "latitude": "32.838267"
                        },
                        {
                            "area_id": 9487,
                            "city_id": 9463,
                            "province_id": 6,
                            "name": "郧西县",
                            "whole_name": "郧西县，十堰市，湖北省",
                            "simple_py": "YXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0719",
                            "area_code": "420322",
                            "longitude": "110.426472",
                            "latitude": "32.991457"
                        },
                        {
                            "area_id": 9482,
                            "city_id": 9463,
                            "province_id": 6,
                            "name": "张湾区",
                            "whole_name": "张湾区，十堰市，湖北省",
                            "simple_py": "ZWQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0719",
                            "area_code": "420303",
                            "longitude": "110.772365",
                            "latitude": "32.652516"
                        },
                        {
                            "area_id": 9484,
                            "city_id": 9463,
                            "province_id": 6,
                            "name": "竹溪县",
                            "whole_name": "竹溪县，十堰市，湖北省",
                            "simple_py": "ZXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0719",
                            "area_code": "420324",
                            "longitude": "109.717196",
                            "latitude": "32.315342"
                        },
                        {
                            "area_id": 9486,
                            "city_id": 9463,
                            "province_id": 6,
                            "name": "竹山县",
                            "whole_name": "竹山县，十堰市，湖北省",
                            "simple_py": "ZSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0719",
                            "area_code": "420323",
                            "longitude": "110.2296",
                            "latitude": "32.22586"
                        }
                    ]
                },
                {
                    "city_id": 9474,
                    "province_id": 6,
                    "name": "神农架林区",
                    "whole_name": "神农架林区，湖北省",
                    "simple_py": "SNJLQ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "S",
                    "city_code": "0719",
                    "area_code": "429021",
                    "longitude": "110.671525",
                    "latitude": "31.744449",
                    "children": [
                        {
                            "area_id": 10699,
                            "city_id": 9474,
                            "province_id": 6,
                            "name": "红坪镇",
                            "whole_name": "红坪镇，神农架林区，湖北省",
                            "simple_py": "HPZ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0719",
                            "area_code": "429021",
                            "longitude": "110.196",
                            "latitude": "31.4718"
                        },
                        {
                            "area_id": 10696,
                            "city_id": 9474,
                            "province_id": 6,
                            "name": "九湖镇",
                            "whole_name": "九湖镇，神农架林区，湖北省",
                            "simple_py": "JHZ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0719",
                            "area_code": "429021",
                            "longitude": "110.062",
                            "latitude": "31.4095"
                        },
                        {
                            "area_id": 10694,
                            "city_id": 9474,
                            "province_id": 6,
                            "name": "木鱼镇",
                            "whole_name": "木鱼镇，神农架林区，湖北省",
                            "simple_py": "MYZ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0719",
                            "area_code": "429021",
                            "longitude": "110.312",
                            "latitude": "31.3933"
                        },
                        {
                            "area_id": 10697,
                            "city_id": 9474,
                            "province_id": 6,
                            "name": "宋洛乡",
                            "whole_name": "宋洛乡，神农架林区，湖北省",
                            "simple_py": "SLX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0719",
                            "area_code": "429021",
                            "longitude": "110.59",
                            "latitude": "31.7303"
                        },
                        {
                            "area_id": 10698,
                            "city_id": 9474,
                            "province_id": 6,
                            "name": "松柏镇",
                            "whole_name": "松柏镇，神农架林区，湖北省",
                            "simple_py": "SBZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0719",
                            "area_code": "429021",
                            "longitude": "110.609",
                            "latitude": "31.7041"
                        },
                        {
                            "area_id": 10693,
                            "city_id": 9474,
                            "province_id": 6,
                            "name": "下谷坪土家族乡",
                            "whole_name": "下谷坪土家族乡，神农架林区，湖北省",
                            "simple_py": "XGPTJZX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0719",
                            "area_code": "429021",
                            "longitude": "110.113",
                            "latitude": "31.4153"
                        },
                        {
                            "area_id": 10695,
                            "city_id": 9474,
                            "province_id": 6,
                            "name": "新华镇",
                            "whole_name": "新华镇，神农架林区，湖北省",
                            "simple_py": "XHZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0719",
                            "area_code": "429021",
                            "longitude": "110.842",
                            "latitude": "31.6218"
                        },
                        {
                            "area_id": 10700,
                            "city_id": 9474,
                            "province_id": 6,
                            "name": "阳日镇",
                            "whole_name": "阳日镇，神农架林区，湖北省",
                            "simple_py": "YRZ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0719",
                            "area_code": "429021",
                            "longitude": "110.763",
                            "latitude": "31.677"
                        }
                    ]
                },
                {
                    "city_id": 9475,
                    "province_id": 6,
                    "name": "随州市",
                    "whole_name": "随州市，湖北省",
                    "simple_py": "SZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "S",
                    "city_code": "0722",
                    "area_code": "421300",
                    "longitude": "113.37377",
                    "latitude": "31.717497",
                    "children": [
                        {
                            "area_id": 10702,
                            "city_id": 9475,
                            "province_id": 6,
                            "name": "曾都区",
                            "whole_name": "曾都区，随州市，湖北省",
                            "simple_py": "CDQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0722",
                            "area_code": "421303",
                            "longitude": "113.374519",
                            "latitude": "31.717521"
                        },
                        {
                            "area_id": 10701,
                            "city_id": 9475,
                            "province_id": 6,
                            "name": "广水市",
                            "whole_name": "广水市，随州市，湖北省",
                            "simple_py": "GSS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0722",
                            "area_code": "421381",
                            "longitude": "113.826601",
                            "latitude": "31.617731"
                        },
                        {
                            "area_id": 10703,
                            "city_id": 9475,
                            "province_id": 6,
                            "name": "随县",
                            "whole_name": "随县，随州市，湖北省",
                            "simple_py": "SX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0722",
                            "area_code": "421321",
                            "longitude": "113.301384",
                            "latitude": "31.854246"
                        }
                    ]
                },
                {
                    "city_id": 9468,
                    "province_id": 6,
                    "name": "天门市",
                    "whole_name": "天门市，湖北省",
                    "simple_py": "TMS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0728",
                    "area_code": "429006",
                    "longitude": "113.165862",
                    "latitude": "30.653061",
                    "children": [
                        {
                            "area_id": 10235,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "白茅湖农场",
                            "whole_name": "白茅湖农场，天门市，湖北省",
                            "simple_py": "BMHNC",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.063",
                            "latitude": "30.5868"
                        },
                        {
                            "area_id": 10218,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "沉湖管委会",
                            "whole_name": "沉湖管委会，天门市，湖北省",
                            "simple_py": "CHGWH",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.444",
                            "latitude": "30.4698"
                        },
                        {
                            "area_id": 10216,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "多祥镇",
                            "whole_name": "多祥镇，天门市，湖北省",
                            "simple_py": "DXZ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.331",
                            "latitude": "30.4446"
                        },
                        {
                            "area_id": 10224,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "多宝镇",
                            "whole_name": "多宝镇，天门市，湖北省",
                            "simple_py": "DBZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "112.614",
                            "latitude": "30.7034"
                        },
                        {
                            "area_id": 10231,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "佛子山镇",
                            "whole_name": "佛子山镇，天门市，湖北省",
                            "simple_py": "FZSZ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "112.974",
                            "latitude": "30.7608"
                        },
                        {
                            "area_id": 10221,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "干驿镇",
                            "whole_name": "干驿镇，天门市，湖北省",
                            "simple_py": "GYZ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.451",
                            "latitude": "30.503"
                        },
                        {
                            "area_id": 10215,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "胡市镇",
                            "whole_name": "胡市镇，天门市，湖北省",
                            "simple_py": "HSZ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.422",
                            "latitude": "30.802"
                        },
                        {
                            "area_id": 10217,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "黄潭镇",
                            "whole_name": "黄潭镇，天门市，湖北省",
                            "simple_py": "HTZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.039",
                            "latitude": "30.6922"
                        },
                        {
                            "area_id": 10219,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "横林镇",
                            "whole_name": "横林镇，天门市，湖北省",
                            "simple_py": "HLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.215",
                            "latitude": "30.5643"
                        },
                        {
                            "area_id": 10222,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "蒋湖农场",
                            "whole_name": "蒋湖农场，天门市，湖北省",
                            "simple_py": "JHNC",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "112.802",
                            "latitude": "30.6364"
                        },
                        {
                            "area_id": 10226,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "蒋场镇",
                            "whole_name": "蒋场镇，天门市，湖北省",
                            "simple_py": "JCZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "112.927",
                            "latitude": "30.646"
                        },
                        {
                            "area_id": 10229,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "竟陵街道",
                            "whole_name": "竟陵街道，天门市，湖北省",
                            "simple_py": "JLJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.183",
                            "latitude": "30.7066"
                        },
                        {
                            "area_id": 10230,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "九真镇",
                            "whole_name": "九真镇，天门市，湖北省",
                            "simple_py": "JZZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.206",
                            "latitude": "30.8245"
                        },
                        {
                            "area_id": 10238,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "净潭乡",
                            "whole_name": "净潭乡，天门市，湖北省",
                            "simple_py": "JTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.451",
                            "latitude": "30.6464"
                        },
                        {
                            "area_id": 10239,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "卢市镇",
                            "whole_name": "卢市镇，天门市，湖北省",
                            "simple_py": "LSZ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.397",
                            "latitude": "30.6596"
                        },
                        {
                            "area_id": 10220,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "马湾镇",
                            "whole_name": "马湾镇，天门市，湖北省",
                            "simple_py": "MWZ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.312",
                            "latitude": "30.5993"
                        },
                        {
                            "area_id": 10233,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "麻洋镇",
                            "whole_name": "麻洋镇，天门市，湖北省",
                            "simple_py": "MYZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.309",
                            "latitude": "30.5249"
                        },
                        {
                            "area_id": 10228,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "彭市镇",
                            "whole_name": "彭市镇，天门市，湖北省",
                            "simple_py": "PSZ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.157",
                            "latitude": "30.4315"
                        },
                        {
                            "area_id": 10232,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "侨乡街道开发区",
                            "whole_name": "侨乡街道开发区，天门市，湖北省",
                            "simple_py": "QXJDKFQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.134",
                            "latitude": "30.652"
                        },
                        {
                            "area_id": 10227,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "石家河镇",
                            "whole_name": "石家河镇，天门市，湖北省",
                            "simple_py": "SJHZ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.076",
                            "latitude": "30.8211"
                        },
                        {
                            "area_id": 10241,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "拖市镇",
                            "whole_name": "拖市镇，天门市，湖北省",
                            "simple_py": "TSZ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "112.856",
                            "latitude": "30.7135"
                        },
                        {
                            "area_id": 10236,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "汪场镇",
                            "whole_name": "汪场镇，天门市，湖北省",
                            "simple_py": "WCZ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "112.979",
                            "latitude": "30.638"
                        },
                        {
                            "area_id": 10223,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "小板镇",
                            "whole_name": "小板镇，天门市，湖北省",
                            "simple_py": "XBZ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.264",
                            "latitude": "30.6151"
                        },
                        {
                            "area_id": 10225,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "岳口镇",
                            "whole_name": "岳口镇，天门市，湖北省",
                            "simple_py": "YKZ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.105",
                            "latitude": "30.5868"
                        },
                        {
                            "area_id": 10234,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "杨林街道",
                            "whole_name": "杨林街道，天门市，湖北省",
                            "simple_py": "YLJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.265",
                            "latitude": "30.6856"
                        },
                        {
                            "area_id": 10237,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "渔薪镇",
                            "whole_name": "渔薪镇，天门市，湖北省",
                            "simple_py": "YXZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "112.879",
                            "latitude": "30.6744"
                        },
                        {
                            "area_id": 10240,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "皂市镇",
                            "whole_name": "皂市镇，天门市，湖北省",
                            "simple_py": "ZSZ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "113.223",
                            "latitude": "30.7957"
                        },
                        {
                            "area_id": 10242,
                            "city_id": 9468,
                            "province_id": 6,
                            "name": "张港镇",
                            "whole_name": "张港镇，天门市，湖北省",
                            "simple_py": "ZGZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0728",
                            "area_code": "429006",
                            "longitude": "112.801",
                            "latitude": "30.5529"
                        }
                    ]
                },
                {
                    "city_id": 9466,
                    "province_id": 6,
                    "name": "武汉市",
                    "whole_name": "武汉市，湖北省",
                    "simple_py": "WHS",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "027",
                    "area_code": "420100",
                    "longitude": "114.298572",
                    "latitude": "30.584355",
                    "children": [
                        {
                            "area_id": 9909,
                            "city_id": 9466,
                            "province_id": 6,
                            "name": "蔡甸区",
                            "whole_name": "蔡甸区，武汉市，湖北省",
                            "simple_py": "CDQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "027",
                            "area_code": "420114",
                            "longitude": "114.029341",
                            "latitude": "30.582186"
                        },
                        {
                            "area_id": 9907,
                            "city_id": 9466,
                            "province_id": 6,
                            "name": "东西湖区",
                            "whole_name": "东西湖区，武汉市，湖北省",
                            "simple_py": "DXHQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "027",
                            "area_code": "420112",
                            "longitude": "114.142483",
                            "latitude": "30.622467"
                        },
                        {
                            "area_id": 9905,
                            "city_id": 9466,
                            "province_id": 6,
                            "name": "黄陂区",
                            "whole_name": "黄陂区，武汉市，湖北省",
                            "simple_py": "HBQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "027",
                            "area_code": "420116",
                            "longitude": "114.374025",
                            "latitude": "30.874155"
                        },
                        {
                            "area_id": 9910,
                            "city_id": 9466,
                            "province_id": 6,
                            "name": "汉南区",
                            "whole_name": "汉南区，武汉市，湖北省",
                            "simple_py": "HNQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "027",
                            "area_code": "420113",
                            "longitude": "114.08124",
                            "latitude": "30.309637"
                        },
                        {
                            "area_id": 9911,
                            "city_id": 9466,
                            "province_id": 6,
                            "name": "汉阳区",
                            "whole_name": "汉阳区，武汉市，湖北省",
                            "simple_py": "HYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "027",
                            "area_code": "420105",
                            "longitude": "114.265807",
                            "latitude": "30.549326"
                        },
                        {
                            "area_id": 9916,
                            "city_id": 9466,
                            "province_id": 6,
                            "name": "洪山区",
                            "whole_name": "洪山区，武汉市，湖北省",
                            "simple_py": "HSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "027",
                            "area_code": "420111",
                            "longitude": "114.400718",
                            "latitude": "30.504259"
                        },
                        {
                            "area_id": 9908,
                            "city_id": 9466,
                            "province_id": 6,
                            "name": "江岸区",
                            "whole_name": "江岸区，武汉市，湖北省",
                            "simple_py": "JAQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "027",
                            "area_code": "420102",
                            "longitude": "114.30304",
                            "latitude": "30.594911"
                        },
                        {
                            "area_id": 9913,
                            "city_id": 9466,
                            "province_id": 6,
                            "name": "江汉区",
                            "whole_name": "江汉区，武汉市，湖北省",
                            "simple_py": "JHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "027",
                            "area_code": "420103",
                            "longitude": "114.283109",
                            "latitude": "30.578771"
                        },
                        {
                            "area_id": 9914,
                            "city_id": 9466,
                            "province_id": 6,
                            "name": "江夏区",
                            "whole_name": "江夏区，武汉市，湖北省",
                            "simple_py": "JXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "027",
                            "area_code": "420115",
                            "longitude": "114.313961",
                            "latitude": "30.349045"
                        },
                        {
                            "area_id": 9912,
                            "city_id": 9466,
                            "province_id": 6,
                            "name": "硚口区",
                            "whole_name": "硚口区，武汉市，湖北省",
                            "simple_py": "QKQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "027",
                            "area_code": "420104",
                            "longitude": "114.264568",
                            "latitude": "30.57061"
                        },
                        {
                            "area_id": 9915,
                            "city_id": 9466,
                            "province_id": 6,
                            "name": "青山区",
                            "whole_name": "青山区，武汉市，湖北省",
                            "simple_py": "QSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "027",
                            "area_code": "420107",
                            "longitude": "114.39707",
                            "latitude": "30.634215"
                        },
                        {
                            "area_id": 9917,
                            "city_id": 9466,
                            "province_id": 6,
                            "name": "武昌区",
                            "whole_name": "武昌区，武汉市，湖北省",
                            "simple_py": "WCQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "027",
                            "area_code": "420106",
                            "longitude": "114.307344",
                            "latitude": "30.546536"
                        },
                        {
                            "area_id": 9906,
                            "city_id": 9466,
                            "province_id": 6,
                            "name": "新洲区",
                            "whole_name": "新洲区，武汉市，湖北省",
                            "simple_py": "XZQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "027",
                            "area_code": "420117",
                            "longitude": "114.802108",
                            "latitude": "30.842149"
                        }
                    ]
                },
                {
                    "city_id": 9465,
                    "province_id": 6,
                    "name": "孝感市",
                    "whole_name": "孝感市，湖北省",
                    "simple_py": "XGS",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "0712",
                    "area_code": "420900",
                    "longitude": "113.926655",
                    "latitude": "30.926423",
                    "children": [
                        {
                            "area_id": 9774,
                            "city_id": 9465,
                            "province_id": 6,
                            "name": "安陆市",
                            "whole_name": "安陆市，孝感市，湖北省",
                            "simple_py": "ALS",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0712",
                            "area_code": "420982",
                            "longitude": "113.690401",
                            "latitude": "31.26174"
                        },
                        {
                            "area_id": 9772,
                            "city_id": 9465,
                            "province_id": 6,
                            "name": "大悟县",
                            "whole_name": "大悟县，孝感市，湖北省",
                            "simple_py": "DWX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0712",
                            "area_code": "420922",
                            "longitude": "114.126249",
                            "latitude": "31.565483"
                        },
                        {
                            "area_id": 9778,
                            "city_id": 9465,
                            "province_id": 6,
                            "name": "汉川市",
                            "whole_name": "汉川市，孝感市，湖北省",
                            "simple_py": "HCS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0712",
                            "area_code": "420984",
                            "longitude": "113.835301",
                            "latitude": "30.652165"
                        },
                        {
                            "area_id": 9773,
                            "city_id": 9465,
                            "province_id": 6,
                            "name": "孝昌县",
                            "whole_name": "孝昌县，孝感市，湖北省",
                            "simple_py": "XCX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0712",
                            "area_code": "420921",
                            "longitude": "113.988964",
                            "latitude": "31.251618"
                        },
                        {
                            "area_id": 9777,
                            "city_id": 9465,
                            "province_id": 6,
                            "name": "孝南区",
                            "whole_name": "孝南区，孝感市，湖北省",
                            "simple_py": "XNQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0712",
                            "area_code": "420902",
                            "longitude": "113.925849",
                            "latitude": "30.925966"
                        },
                        {
                            "area_id": 9775,
                            "city_id": 9465,
                            "province_id": 6,
                            "name": "云梦县",
                            "whole_name": "云梦县，孝感市，湖北省",
                            "simple_py": "YMX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0712",
                            "area_code": "420923",
                            "longitude": "113.750616",
                            "latitude": "31.021691"
                        },
                        {
                            "area_id": 9776,
                            "city_id": 9465,
                            "province_id": 6,
                            "name": "应城市",
                            "whole_name": "应城市，孝感市，湖北省",
                            "simple_py": "YCS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0712",
                            "area_code": "420981",
                            "longitude": "113.573842",
                            "latitude": "30.939038"
                        }
                    ]
                },
                {
                    "city_id": 9471,
                    "province_id": 6,
                    "name": "襄阳市",
                    "whole_name": "襄阳市，湖北省",
                    "simple_py": "XYS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "X",
                    "city_code": "0710",
                    "area_code": "420600",
                    "longitude": "112.144146",
                    "latitude": "32.042426",
                    "children": [
                        {
                            "area_id": 10451,
                            "city_id": 9471,
                            "province_id": 6,
                            "name": "保康县",
                            "whole_name": "保康县，襄阳市，湖北省",
                            "simple_py": "BKX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0710",
                            "area_code": "420626",
                            "longitude": "111.262235",
                            "latitude": "31.873507"
                        },
                        {
                            "area_id": 10452,
                            "city_id": 9471,
                            "province_id": 6,
                            "name": "樊城区",
                            "whole_name": "樊城区，襄阳市，湖北省",
                            "simple_py": "FCQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0710",
                            "area_code": "420606",
                            "longitude": "112.13957",
                            "latitude": "32.058589"
                        },
                        {
                            "area_id": 10446,
                            "city_id": 9471,
                            "province_id": 6,
                            "name": "谷城县",
                            "whole_name": "谷城县，襄阳市，湖北省",
                            "simple_py": "GCX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0710",
                            "area_code": "420625",
                            "longitude": "111.640147",
                            "latitude": "32.262676"
                        },
                        {
                            "area_id": 10445,
                            "city_id": 9471,
                            "province_id": 6,
                            "name": "老河口市",
                            "whole_name": "老河口市，襄阳市，湖北省",
                            "simple_py": "LHKS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0710",
                            "area_code": "420682",
                            "longitude": "111.675732",
                            "latitude": "32.385438"
                        },
                        {
                            "area_id": 10448,
                            "city_id": 9471,
                            "province_id": 6,
                            "name": "南漳县",
                            "whole_name": "南漳县，襄阳市，湖北省",
                            "simple_py": "NZX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0710",
                            "area_code": "420624",
                            "longitude": "111.844424",
                            "latitude": "31.77692"
                        },
                        {
                            "area_id": 10450,
                            "city_id": 9471,
                            "province_id": 6,
                            "name": "襄州区",
                            "whole_name": "襄州区，襄阳市，湖北省",
                            "simple_py": "XZQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0710",
                            "area_code": "420607",
                            "longitude": "112.197378",
                            "latitude": "32.085517"
                        },
                        {
                            "area_id": 10453,
                            "city_id": 9471,
                            "province_id": 6,
                            "name": "襄城区",
                            "whole_name": "襄城区，襄阳市，湖北省",
                            "simple_py": "XCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0710",
                            "area_code": "420602",
                            "longitude": "112.150327",
                            "latitude": "32.015088"
                        },
                        {
                            "area_id": 10449,
                            "city_id": 9471,
                            "province_id": 6,
                            "name": "宜城市",
                            "whole_name": "宜城市，襄阳市，湖北省",
                            "simple_py": "YCS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0710",
                            "area_code": "420684",
                            "longitude": "112.261441",
                            "latitude": "31.709203"
                        },
                        {
                            "area_id": 10447,
                            "city_id": 9471,
                            "province_id": 6,
                            "name": "枣阳市",
                            "whole_name": "枣阳市，襄阳市，湖北省",
                            "simple_py": "ZYS",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0710",
                            "area_code": "420683",
                            "longitude": "112.765268",
                            "latitude": "32.123083"
                        }
                    ]
                },
                {
                    "city_id": 9473,
                    "province_id": 6,
                    "name": "仙桃市",
                    "whole_name": "仙桃市，湖北省",
                    "simple_py": "XTS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "X",
                    "city_code": "0728",
                    "area_code": "429004",
                    "longitude": "113.453974",
                    "latitude": "30.364953",
                    "children": [
                        {
                            "area_id": 10670,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "畜禽良种场",
                            "whole_name": "畜禽良种场，仙桃市，湖北省",
                            "simple_py": "CQLZC",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.751",
                            "latitude": "30.1779"
                        },
                        {
                            "area_id": 10674,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "长倘口镇",
                            "whole_name": "长倘口镇，仙桃市，湖北省",
                            "simple_py": "CTKZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.611",
                            "latitude": "30.4752"
                        },
                        {
                            "area_id": 10685,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "陈场镇",
                            "whole_name": "陈场镇，仙桃市，湖北省",
                            "simple_py": "CCZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.111",
                            "latitude": "30.2879"
                        },
                        {
                            "area_id": 10671,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "豆河镇",
                            "whole_name": "豆河镇，仙桃市，湖北省",
                            "simple_py": "DHZ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113",
                            "latitude": "30.37"
                        },
                        {
                            "area_id": 10669,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "工业园区",
                            "whole_name": "工业园区，仙桃市，湖北省",
                            "simple_py": "GYYQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.413",
                            "latitude": "30.3233"
                        },
                        {
                            "area_id": 10677,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "干河街道",
                            "whole_name": "干河街道，仙桃市，湖北省",
                            "simple_py": "GHJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.451",
                            "latitude": "30.3772"
                        },
                        {
                            "area_id": 10686,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "郭河镇",
                            "whole_name": "郭河镇，仙桃市，湖北省",
                            "simple_py": "GHZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.304",
                            "latitude": "30.3027"
                        },
                        {
                            "area_id": 10673,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "胡场镇",
                            "whole_name": "胡场镇，仙桃市，湖北省",
                            "simple_py": "HCZ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.29",
                            "latitude": "30.4278"
                        },
                        {
                            "area_id": 10680,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "九合垸原种场",
                            "whole_name": "九合垸原种场，仙桃市，湖北省",
                            "simple_py": "JHYYZC",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.006",
                            "latitude": "30.2473"
                        },
                        {
                            "area_id": 10683,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "龙华山街道",
                            "whole_name": "龙华山街道，仙桃市，湖北省",
                            "simple_py": "LHSJD",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.46",
                            "latitude": "30.3649"
                        },
                        {
                            "area_id": 10682,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "沔城回族镇",
                            "whole_name": "沔城回族镇，仙桃市，湖北省",
                            "simple_py": "MCHZZ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.201",
                            "latitude": "30.1921"
                        },
                        {
                            "area_id": 10691,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "毛嘴镇",
                            "whole_name": "毛嘴镇，仙桃市，湖北省",
                            "simple_py": "MZZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.045",
                            "latitude": "30.4188"
                        },
                        {
                            "area_id": 10681,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "彭场镇",
                            "whole_name": "彭场镇，仙桃市，湖北省",
                            "simple_py": "PCZ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.446",
                            "latitude": "30.2518"
                        },
                        {
                            "area_id": 10687,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "排湖风景区",
                            "whole_name": "排湖风景区，仙桃市，湖北省",
                            "simple_py": "PHFJQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "P",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.223",
                            "latitude": "30.2987"
                        },
                        {
                            "area_id": 10668,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "沙湖镇",
                            "whole_name": "沙湖镇，仙桃市，湖北省",
                            "simple_py": "SHZ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.6",
                            "latitude": "30.1698"
                        },
                        {
                            "area_id": 10684,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "沙湖原种场",
                            "whole_name": "沙湖原种场，仙桃市，湖北省",
                            "simple_py": "SHYZC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.643",
                            "latitude": "30.1482"
                        },
                        {
                            "area_id": 10689,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "沙嘴街道",
                            "whole_name": "沙嘴街道，仙桃市，湖北省",
                            "simple_py": "SZJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.441",
                            "latitude": "30.3596"
                        },
                        {
                            "area_id": 10692,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "三伏潭镇",
                            "whole_name": "三伏潭镇，仙桃市，湖北省",
                            "simple_py": "SFTZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.207",
                            "latitude": "30.3395"
                        },
                        {
                            "area_id": 10672,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "通海口镇",
                            "whole_name": "通海口镇，仙桃市，湖北省",
                            "simple_py": "THKZ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.206",
                            "latitude": "30.2722"
                        },
                        {
                            "area_id": 10675,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "五湖渔场",
                            "whole_name": "五湖渔场，仙桃市，湖北省",
                            "simple_py": "WHYC",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.783",
                            "latitude": "30.161"
                        },
                        {
                            "area_id": 10678,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "西流河镇",
                            "whole_name": "西流河镇，仙桃市，湖北省",
                            "simple_py": "XLHZ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.761",
                            "latitude": "30.297"
                        },
                        {
                            "area_id": 10676,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "杨林尾镇",
                            "whole_name": "杨林尾镇，仙桃市，湖北省",
                            "simple_py": "YLWZ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.561",
                            "latitude": "30.2014"
                        },
                        {
                            "area_id": 10679,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "赵西垸林场",
                            "whole_name": "赵西垸林场，仙桃市，湖北省",
                            "simple_py": "ZXYLC",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.027",
                            "latitude": "30.285"
                        },
                        {
                            "area_id": 10688,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "郑场镇",
                            "whole_name": "郑场镇，仙桃市，湖北省",
                            "simple_py": "ZCZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "112.979",
                            "latitude": "30.4707"
                        },
                        {
                            "area_id": 10690,
                            "city_id": 9473,
                            "province_id": 6,
                            "name": "张沟镇",
                            "whole_name": "张沟镇，仙桃市，湖北省",
                            "simple_py": "ZGZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0728",
                            "area_code": "429004",
                            "longitude": "113.438",
                            "latitude": "30.2968"
                        }
                    ]
                },
                {
                    "city_id": 9477,
                    "province_id": 6,
                    "name": "咸宁市",
                    "whole_name": "咸宁市，湖北省",
                    "simple_py": "XNS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "X",
                    "city_code": "0715",
                    "area_code": "421200",
                    "longitude": "114.328963",
                    "latitude": "29.832798",
                    "children": [
                        {
                            "area_id": 10891,
                            "city_id": 9477,
                            "province_id": 6,
                            "name": "崇阳县",
                            "whole_name": "崇阳县，咸宁市，湖北省",
                            "simple_py": "CYX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0715",
                            "area_code": "421223",
                            "longitude": "114.049958",
                            "latitude": "29.54101"
                        },
                        {
                            "area_id": 10894,
                            "city_id": 9477,
                            "province_id": 6,
                            "name": "赤壁市",
                            "whole_name": "赤壁市，咸宁市，湖北省",
                            "simple_py": "CBS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0715",
                            "area_code": "421281",
                            "longitude": "113.88366",
                            "latitude": "29.716879"
                        },
                        {
                            "area_id": 10890,
                            "city_id": 9477,
                            "province_id": 6,
                            "name": "嘉鱼县",
                            "whole_name": "嘉鱼县，咸宁市，湖北省",
                            "simple_py": "JYX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0715",
                            "area_code": "421221",
                            "longitude": "113.921547",
                            "latitude": "29.973363"
                        },
                        {
                            "area_id": 10892,
                            "city_id": 9477,
                            "province_id": 6,
                            "name": "通山县",
                            "whole_name": "通山县，咸宁市，湖北省",
                            "simple_py": "TSX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0715",
                            "area_code": "421224",
                            "longitude": "114.493163",
                            "latitude": "29.604455"
                        },
                        {
                            "area_id": 10895,
                            "city_id": 9477,
                            "province_id": 6,
                            "name": "通城县",
                            "whole_name": "通城县，咸宁市，湖北省",
                            "simple_py": "TCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0715",
                            "area_code": "421222",
                            "longitude": "113.814131",
                            "latitude": "29.246076"
                        },
                        {
                            "area_id": 10893,
                            "city_id": 9477,
                            "province_id": 6,
                            "name": "咸安区",
                            "whole_name": "咸安区，咸宁市，湖北省",
                            "simple_py": "XAQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0715",
                            "area_code": "421202",
                            "longitude": "114.333894",
                            "latitude": "29.824716"
                        }
                    ]
                },
                {
                    "city_id": 9464,
                    "province_id": 6,
                    "name": "宜昌市",
                    "whole_name": "宜昌市，湖北省",
                    "simple_py": "YCS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0717",
                    "area_code": "420500",
                    "longitude": "111.290843",
                    "latitude": "30.702636",
                    "children": [
                        {
                            "area_id": 9650,
                            "city_id": 9464,
                            "province_id": 6,
                            "name": "长阳土家族自治县",
                            "whole_name": "长阳土家族自治县，宜昌市，湖北省",
                            "simple_py": "CYTJZZZX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0717",
                            "area_code": "420528",
                            "longitude": "111.198475",
                            "latitude": "30.466534"
                        },
                        {
                            "area_id": 9647,
                            "city_id": 9464,
                            "province_id": 6,
                            "name": "当阳市",
                            "whole_name": "当阳市，宜昌市，湖北省",
                            "simple_py": "DYS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0717",
                            "area_code": "420582",
                            "longitude": "111.793419",
                            "latitude": "30.824492"
                        },
                        {
                            "area_id": 9651,
                            "city_id": 9464,
                            "province_id": 6,
                            "name": "点军区",
                            "whole_name": "点军区，宜昌市，湖北省",
                            "simple_py": "DJQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0717",
                            "area_code": "420504",
                            "longitude": "111.268163",
                            "latitude": "30.692322"
                        },
                        {
                            "area_id": 9654,
                            "city_id": 9464,
                            "province_id": 6,
                            "name": "伍家岗区",
                            "whole_name": "伍家岗区，宜昌市，湖北省",
                            "simple_py": "WJGQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0717",
                            "area_code": "420503",
                            "longitude": "111.307215",
                            "latitude": "30.679053"
                        },
                        {
                            "area_id": 9656,
                            "city_id": 9464,
                            "province_id": 6,
                            "name": "五峰土家族自治县",
                            "whole_name": "五峰土家族自治县，宜昌市，湖北省",
                            "simple_py": "WFTJZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0717",
                            "area_code": "420529",
                            "longitude": "110.674938",
                            "latitude": "30.199252"
                        },
                        {
                            "area_id": 9644,
                            "city_id": 9464,
                            "province_id": 6,
                            "name": "兴山县",
                            "whole_name": "兴山县，宜昌市，湖北省",
                            "simple_py": "XSX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0717",
                            "area_code": "420526",
                            "longitude": "110.754499",
                            "latitude": "31.34795"
                        },
                        {
                            "area_id": 9649,
                            "city_id": 9464,
                            "province_id": 6,
                            "name": "西陵区",
                            "whole_name": "西陵区，宜昌市，湖北省",
                            "simple_py": "XLQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0717",
                            "area_code": "420502",
                            "longitude": "111.295468",
                            "latitude": "30.702476"
                        },
                        {
                            "area_id": 9652,
                            "city_id": 9464,
                            "province_id": 6,
                            "name": "猇亭区",
                            "whole_name": "猇亭区，宜昌市，湖北省",
                            "simple_py": "XTQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0717",
                            "area_code": "420505",
                            "longitude": "111.427642",
                            "latitude": "30.530744"
                        },
                        {
                            "area_id": 9645,
                            "city_id": 9464,
                            "province_id": 6,
                            "name": "远安县",
                            "whole_name": "远安县，宜昌市，湖北省",
                            "simple_py": "YAX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0717",
                            "area_code": "420525",
                            "longitude": "111.64331",
                            "latitude": "31.059626"
                        },
                        {
                            "area_id": 9646,
                            "city_id": 9464,
                            "province_id": 6,
                            "name": "夷陵区",
                            "whole_name": "夷陵区，宜昌市，湖北省",
                            "simple_py": "YLQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0717",
                            "area_code": "420506",
                            "longitude": "111.326747",
                            "latitude": "30.770199"
                        },
                        {
                            "area_id": 9655,
                            "city_id": 9464,
                            "province_id": 6,
                            "name": "宜都市",
                            "whole_name": "宜都市，宜昌市，湖北省",
                            "simple_py": "YDS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0717",
                            "area_code": "420581",
                            "longitude": "111.454367",
                            "latitude": "30.387234"
                        },
                        {
                            "area_id": 9648,
                            "city_id": 9464,
                            "province_id": 6,
                            "name": "秭归县",
                            "whole_name": "秭归县，宜昌市，湖北省",
                            "simple_py": "ZGX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0717",
                            "area_code": "420527",
                            "longitude": "110.976785",
                            "latitude": "30.823908"
                        },
                        {
                            "area_id": 9653,
                            "city_id": 9464,
                            "province_id": 6,
                            "name": "枝江市",
                            "whole_name": "枝江市，宜昌市，湖北省",
                            "simple_py": "ZJS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0717",
                            "area_code": "420583",
                            "longitude": "111.751799",
                            "latitude": "30.425364"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 16,
            "name": "湖南省",
            "whole_name": "湖南省",
            "simple_py": "HNS",
            "per_pin_yin": " ",
            "per_pin_yin2": "H",
            "city_code": "",
            "area_code": "430000",
            "longitude": "112.982279",
            "latitude": "28.19409",
            "children": [
                {
                    "city_id": 22907,
                    "province_id": 16,
                    "name": "长沙市",
                    "whole_name": "长沙市，湖南省",
                    "simple_py": "CSS",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0731",
                    "area_code": "430100",
                    "longitude": "112.982279",
                    "latitude": "28.19409",
                    "children": [
                        {
                            "area_id": 23557,
                            "city_id": 22907,
                            "province_id": 16,
                            "name": "长沙县",
                            "whole_name": "长沙县，长沙市，湖南省",
                            "simple_py": "CSX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0731",
                            "area_code": "430121",
                            "longitude": "113.080098",
                            "latitude": "28.237888"
                        },
                        {
                            "area_id": 23554,
                            "city_id": 22907,
                            "province_id": 16,
                            "name": "芙蓉区",
                            "whole_name": "芙蓉区，长沙市，湖南省",
                            "simple_py": "FRQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0731",
                            "area_code": "430102",
                            "longitude": "112.988094",
                            "latitude": "28.193106"
                        },
                        {
                            "area_id": 23555,
                            "city_id": 22907,
                            "province_id": 16,
                            "name": "开福区",
                            "whole_name": "开福区，长沙市，湖南省",
                            "simple_py": "KFQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0731",
                            "area_code": "430105",
                            "longitude": "112.985525",
                            "latitude": "28.201336"
                        },
                        {
                            "area_id": 23559,
                            "city_id": 22907,
                            "province_id": 16,
                            "name": "浏阳市",
                            "whole_name": "浏阳市，长沙市，湖南省",
                            "simple_py": "LYS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0731",
                            "area_code": "430181",
                            "longitude": "113.633301",
                            "latitude": "28.141112"
                        },
                        {
                            "area_id": 23561,
                            "city_id": 22907,
                            "province_id": 16,
                            "name": "宁乡市",
                            "whole_name": "宁乡市，长沙市，湖南省",
                            "simple_py": "NXS",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0731",
                            "area_code": "430182",
                            "longitude": "112.553182",
                            "latitude": "28.253928"
                        },
                        {
                            "area_id": 23558,
                            "city_id": 22907,
                            "province_id": 16,
                            "name": "天心区",
                            "whole_name": "天心区，长沙市，湖南省",
                            "simple_py": "TXQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0731",
                            "area_code": "430103",
                            "longitude": "112.97307",
                            "latitude": "28.192375"
                        },
                        {
                            "area_id": 23562,
                            "city_id": 22907,
                            "province_id": 16,
                            "name": "望城区",
                            "whole_name": "望城区，长沙市，湖南省",
                            "simple_py": "WCQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0731",
                            "area_code": "430112",
                            "longitude": "112.819549",
                            "latitude": "28.347458"
                        },
                        {
                            "area_id": 23556,
                            "city_id": 22907,
                            "province_id": 16,
                            "name": "岳麓区",
                            "whole_name": "岳麓区，长沙市，湖南省",
                            "simple_py": "YLQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0731",
                            "area_code": "430104",
                            "longitude": "112.911591",
                            "latitude": "28.213044"
                        },
                        {
                            "area_id": 23560,
                            "city_id": 22907,
                            "province_id": 16,
                            "name": "雨花区",
                            "whole_name": "雨花区，长沙市，湖南省",
                            "simple_py": "YHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0731",
                            "area_code": "430111",
                            "longitude": "113.016337",
                            "latitude": "28.109937"
                        }
                    ]
                },
                {
                    "city_id": 22908,
                    "province_id": 16,
                    "name": "常德市",
                    "whole_name": "常德市，湖南省",
                    "simple_py": "CDS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "C",
                    "city_code": "0736",
                    "area_code": "430700",
                    "longitude": "111.691347",
                    "latitude": "29.040225",
                    "children": [
                        {
                            "area_id": 23741,
                            "city_id": 22908,
                            "province_id": 16,
                            "name": "安乡县",
                            "whole_name": "安乡县，常德市，湖南省",
                            "simple_py": "AXX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0736",
                            "area_code": "430721",
                            "longitude": "112.172289",
                            "latitude": "29.414483"
                        },
                        {
                            "area_id": 23737,
                            "city_id": 22908,
                            "province_id": 16,
                            "name": "鼎城区",
                            "whole_name": "鼎城区，常德市，湖南省",
                            "simple_py": "DCQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0736",
                            "area_code": "430703",
                            "longitude": "111.685327",
                            "latitude": "29.014426"
                        },
                        {
                            "area_id": 23739,
                            "city_id": 22908,
                            "province_id": 16,
                            "name": "汉寿县",
                            "whole_name": "汉寿县，常德市，湖南省",
                            "simple_py": "HSX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0736",
                            "area_code": "430722",
                            "longitude": "111.968506",
                            "latitude": "28.907319"
                        },
                        {
                            "area_id": 23735,
                            "city_id": 22908,
                            "province_id": 16,
                            "name": "津市市",
                            "whole_name": "津市市，常德市，湖南省",
                            "simple_py": "JSS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0736",
                            "area_code": "430781",
                            "longitude": "111.879609",
                            "latitude": "29.630867"
                        },
                        {
                            "area_id": 23733,
                            "city_id": 22908,
                            "province_id": 16,
                            "name": "临澧县",
                            "whole_name": "临澧县，常德市，湖南省",
                            "simple_py": "LLX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0736",
                            "area_code": "430724",
                            "longitude": "111.645602",
                            "latitude": "29.443217"
                        },
                        {
                            "area_id": 23736,
                            "city_id": 22908,
                            "province_id": 16,
                            "name": "澧县",
                            "whole_name": "澧县，常德市，湖南省",
                            "simple_py": "LX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0736",
                            "area_code": "430723",
                            "longitude": "111.761682",
                            "latitude": "29.64264"
                        },
                        {
                            "area_id": 23734,
                            "city_id": 22908,
                            "province_id": 16,
                            "name": "石门县",
                            "whole_name": "石门县，常德市，湖南省",
                            "simple_py": "SMX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0736",
                            "area_code": "430726",
                            "longitude": "111.379087",
                            "latitude": "29.584703"
                        },
                        {
                            "area_id": 23740,
                            "city_id": 22908,
                            "province_id": 16,
                            "name": "桃源县",
                            "whole_name": "桃源县，常德市，湖南省",
                            "simple_py": "TYX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0736",
                            "area_code": "430725",
                            "longitude": "111.484503",
                            "latitude": "28.902734"
                        },
                        {
                            "area_id": 23738,
                            "city_id": 22908,
                            "province_id": 16,
                            "name": "武陵区",
                            "whole_name": "武陵区，常德市，湖南省",
                            "simple_py": "WLQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0736",
                            "area_code": "430702",
                            "longitude": "111.690718",
                            "latitude": "29.040477"
                        }
                    ]
                },
                {
                    "city_id": 22915,
                    "province_id": 16,
                    "name": "郴州市",
                    "whole_name": "郴州市，湖南省",
                    "simple_py": "CZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "C",
                    "city_code": "0735",
                    "area_code": "431000",
                    "longitude": "113.032067",
                    "latitude": "25.793589",
                    "children": [
                        {
                            "area_id": 24934,
                            "city_id": 22915,
                            "province_id": 16,
                            "name": "安仁县",
                            "whole_name": "安仁县，郴州市，湖南省",
                            "simple_py": "ARX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0735",
                            "area_code": "431028",
                            "longitude": "113.27217",
                            "latitude": "26.708625"
                        },
                        {
                            "area_id": 24941,
                            "city_id": 22915,
                            "province_id": 16,
                            "name": "北湖区",
                            "whole_name": "北湖区，郴州市，湖南省",
                            "simple_py": "BHQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0735",
                            "area_code": "431002",
                            "longitude": "113.032208",
                            "latitude": "25.792628"
                        },
                        {
                            "area_id": 24938,
                            "city_id": 22915,
                            "province_id": 16,
                            "name": "桂东县",
                            "whole_name": "桂东县，郴州市，湖南省",
                            "simple_py": "GDX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0735",
                            "area_code": "431027",
                            "longitude": "113.945879",
                            "latitude": "26.073917"
                        },
                        {
                            "area_id": 24943,
                            "city_id": 22915,
                            "province_id": 16,
                            "name": "桂阳县",
                            "whole_name": "桂阳县，郴州市，湖南省",
                            "simple_py": "GYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0735",
                            "area_code": "431021",
                            "longitude": "112.734466",
                            "latitude": "25.737447"
                        },
                        {
                            "area_id": 24940,
                            "city_id": 22915,
                            "province_id": 16,
                            "name": "嘉禾县",
                            "whole_name": "嘉禾县，郴州市，湖南省",
                            "simple_py": "JHX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0735",
                            "area_code": "431024",
                            "longitude": "112.370618",
                            "latitude": "25.587309"
                        },
                        {
                            "area_id": 24942,
                            "city_id": 22915,
                            "province_id": 16,
                            "name": "临武县",
                            "whole_name": "临武县，郴州市，湖南省",
                            "simple_py": "LWX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0735",
                            "area_code": "431025",
                            "longitude": "112.564589",
                            "latitude": "25.279119"
                        },
                        {
                            "area_id": 24939,
                            "city_id": 22915,
                            "province_id": 16,
                            "name": "汝城县",
                            "whole_name": "汝城县，郴州市，湖南省",
                            "simple_py": "RCX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0735",
                            "area_code": "431026",
                            "longitude": "113.685686",
                            "latitude": "25.553759"
                        },
                        {
                            "area_id": 24936,
                            "city_id": 22915,
                            "province_id": 16,
                            "name": "苏仙区",
                            "whole_name": "苏仙区，郴州市，湖南省",
                            "simple_py": "SXQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0735",
                            "area_code": "431003",
                            "longitude": "113.038698",
                            "latitude": "25.793157"
                        },
                        {
                            "area_id": 24935,
                            "city_id": 22915,
                            "province_id": 16,
                            "name": "永兴县",
                            "whole_name": "永兴县，郴州市，湖南省",
                            "simple_py": "YXX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0735",
                            "area_code": "431023",
                            "longitude": "113.114819",
                            "latitude": "26.129392"
                        },
                        {
                            "area_id": 24944,
                            "city_id": 22915,
                            "province_id": 16,
                            "name": "宜章县",
                            "whole_name": "宜章县，郴州市，湖南省",
                            "simple_py": "YZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0735",
                            "area_code": "431022",
                            "longitude": "112.947884",
                            "latitude": "25.394345"
                        },
                        {
                            "area_id": 24937,
                            "city_id": 22915,
                            "province_id": 16,
                            "name": "资兴市",
                            "whole_name": "资兴市，郴州市，湖南省",
                            "simple_py": "ZXS",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0735",
                            "area_code": "431081",
                            "longitude": "113.23682",
                            "latitude": "25.974152"
                        }
                    ]
                },
                {
                    "city_id": 22903,
                    "province_id": 16,
                    "name": "衡阳市",
                    "whole_name": "衡阳市，湖南省",
                    "simple_py": "HYS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0734",
                    "area_code": "430400",
                    "longitude": "112.607693",
                    "latitude": "26.900358",
                    "children": [
                        {
                            "area_id": 23078,
                            "city_id": 22903,
                            "province_id": 16,
                            "name": "常宁市",
                            "whole_name": "常宁市，衡阳市，湖南省",
                            "simple_py": "CNS",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0734",
                            "area_code": "430482",
                            "longitude": "112.396821",
                            "latitude": "26.406773"
                        },
                        {
                            "area_id": 23067,
                            "city_id": 22903,
                            "province_id": 16,
                            "name": "衡山县",
                            "whole_name": "衡山县，衡阳市，湖南省",
                            "simple_py": "HSX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0734",
                            "area_code": "430423",
                            "longitude": "112.86971",
                            "latitude": "27.234808"
                        },
                        {
                            "area_id": 23068,
                            "city_id": 22903,
                            "province_id": 16,
                            "name": "衡东县",
                            "whole_name": "衡东县，衡阳市，湖南省",
                            "simple_py": "HDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0734",
                            "area_code": "430424",
                            "longitude": "112.950412",
                            "latitude": "27.083531"
                        },
                        {
                            "area_id": 23070,
                            "city_id": 22903,
                            "province_id": 16,
                            "name": "衡阳县",
                            "whole_name": "衡阳县，衡阳市，湖南省",
                            "simple_py": "HYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0734",
                            "area_code": "430421",
                            "longitude": "112.379643",
                            "latitude": "26.962388"
                        },
                        {
                            "area_id": 23075,
                            "city_id": 22903,
                            "province_id": 16,
                            "name": "衡南县",
                            "whole_name": "衡南县，衡阳市，湖南省",
                            "simple_py": "HNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0734",
                            "area_code": "430422",
                            "longitude": "112.677459",
                            "latitude": "26.739973"
                        },
                        {
                            "area_id": 23076,
                            "city_id": 22903,
                            "province_id": 16,
                            "name": "耒阳市",
                            "whole_name": "耒阳市，衡阳市，湖南省",
                            "simple_py": "LYS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0734",
                            "area_code": "430481",
                            "longitude": "112.847215",
                            "latitude": "26.414162"
                        },
                        {
                            "area_id": 23069,
                            "city_id": 22903,
                            "province_id": 16,
                            "name": "南岳区",
                            "whole_name": "南岳区，衡阳市，湖南省",
                            "simple_py": "NYQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0734",
                            "area_code": "430412",
                            "longitude": "112.734147",
                            "latitude": "27.240536"
                        },
                        {
                            "area_id": 23074,
                            "city_id": 22903,
                            "province_id": 16,
                            "name": "祁东县",
                            "whole_name": "祁东县，衡阳市，湖南省",
                            "simple_py": "QDX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0734",
                            "area_code": "430426",
                            "longitude": "112.111192",
                            "latitude": "26.787109"
                        },
                        {
                            "area_id": 23073,
                            "city_id": 22903,
                            "province_id": 16,
                            "name": "石鼓区",
                            "whole_name": "石鼓区，衡阳市，湖南省",
                            "simple_py": "SGQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0734",
                            "area_code": "430407",
                            "longitude": "112.607635",
                            "latitude": "26.903908"
                        },
                        {
                            "area_id": 23071,
                            "city_id": 22903,
                            "province_id": 16,
                            "name": "雁峰区",
                            "whole_name": "雁峰区，衡阳市，湖南省",
                            "simple_py": "YFQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0734",
                            "area_code": "430406",
                            "longitude": "112.612241",
                            "latitude": "26.893694"
                        },
                        {
                            "area_id": 23072,
                            "city_id": 22903,
                            "province_id": 16,
                            "name": "珠晖区",
                            "whole_name": "珠晖区，衡阳市，湖南省",
                            "simple_py": "ZHQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0734",
                            "area_code": "430405",
                            "longitude": "112.626324",
                            "latitude": "26.891063"
                        },
                        {
                            "area_id": 23077,
                            "city_id": 22903,
                            "province_id": 16,
                            "name": "蒸湘区",
                            "whole_name": "蒸湘区，衡阳市，湖南省",
                            "simple_py": "ZXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0734",
                            "area_code": "430408",
                            "longitude": "112.570608",
                            "latitude": "26.89087"
                        }
                    ]
                },
                {
                    "city_id": 22909,
                    "province_id": 16,
                    "name": "怀化市",
                    "whole_name": "怀化市，湖南省",
                    "simple_py": "HHS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0745",
                    "area_code": "431200",
                    "longitude": "109.97824",
                    "latitude": "27.550082",
                    "children": [
                        {
                            "area_id": 23934,
                            "city_id": 22909,
                            "province_id": 16,
                            "name": "辰溪县",
                            "whole_name": "辰溪县，怀化市，湖南省",
                            "simple_py": "CXX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0745",
                            "area_code": "431223",
                            "longitude": "110.196953",
                            "latitude": "28.005474"
                        },
                        {
                            "area_id": 23930,
                            "city_id": 22909,
                            "province_id": 16,
                            "name": "洪江市",
                            "whole_name": "洪江市，怀化市，湖南省",
                            "simple_py": "HJS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0745",
                            "area_code": "431281",
                            "longitude": "109.831765",
                            "latitude": "27.201876"
                        },
                        {
                            "area_id": 23937,
                            "city_id": 22909,
                            "province_id": 16,
                            "name": "会同县",
                            "whole_name": "会同县，怀化市，湖南省",
                            "simple_py": "HTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0745",
                            "area_code": "431225",
                            "longitude": "109.720785",
                            "latitude": "26.870789"
                        },
                        {
                            "area_id": 23939,
                            "city_id": 22909,
                            "province_id": 16,
                            "name": "鹤城区",
                            "whole_name": "鹤城区，怀化市，湖南省",
                            "simple_py": "HCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0745",
                            "area_code": "431202",
                            "longitude": "109.982242",
                            "latitude": "27.548474"
                        },
                        {
                            "area_id": 23935,
                            "city_id": 22909,
                            "province_id": 16,
                            "name": "靖州苗族侗族自治县",
                            "whole_name": "靖州苗族侗族自治县，怀化市，湖南省",
                            "simple_py": "JZMZDZZZX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0745",
                            "area_code": "431229",
                            "longitude": "109.691159",
                            "latitude": "26.573511"
                        },
                        {
                            "area_id": 23936,
                            "city_id": 22909,
                            "province_id": 16,
                            "name": "麻阳苗族自治县",
                            "whole_name": "麻阳苗族自治县，怀化市，湖南省",
                            "simple_py": "MYMZZZX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0745",
                            "area_code": "431226",
                            "longitude": "109.802807",
                            "latitude": "27.865991"
                        },
                        {
                            "area_id": 23931,
                            "city_id": 22909,
                            "province_id": 16,
                            "name": "通道侗族自治县",
                            "whole_name": "通道侗族自治县，怀化市，湖南省",
                            "simple_py": "TDDZZZX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0745",
                            "area_code": "431230",
                            "longitude": "109.783359",
                            "latitude": "26.158349"
                        },
                        {
                            "area_id": 23933,
                            "city_id": 22909,
                            "province_id": 16,
                            "name": "溆浦县",
                            "whole_name": "溆浦县，怀化市，湖南省",
                            "simple_py": "XPX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0745",
                            "area_code": "431224",
                            "longitude": "110.593373",
                            "latitude": "27.903802"
                        },
                        {
                            "area_id": 23938,
                            "city_id": 22909,
                            "province_id": 16,
                            "name": "新晃侗族自治县",
                            "whole_name": "新晃侗族自治县，怀化市，湖南省",
                            "simple_py": "XHDZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0745",
                            "area_code": "431227",
                            "longitude": "109.174443",
                            "latitude": "27.359897"
                        },
                        {
                            "area_id": 23932,
                            "city_id": 22909,
                            "province_id": 16,
                            "name": "沅陵县",
                            "whole_name": "沅陵县，怀化市，湖南省",
                            "simple_py": "YLX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0745",
                            "area_code": "431222",
                            "longitude": "110.399161",
                            "latitude": "28.455554"
                        },
                        {
                            "area_id": 23929,
                            "city_id": 22909,
                            "province_id": 16,
                            "name": "芷江侗族自治县",
                            "whole_name": "芷江侗族自治县，怀化市，湖南省",
                            "simple_py": "ZJDZZZX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0745",
                            "area_code": "431228",
                            "longitude": "109.687777",
                            "latitude": "27.437996"
                        },
                        {
                            "area_id": 23940,
                            "city_id": 22909,
                            "province_id": 16,
                            "name": "中方县",
                            "whole_name": "中方县，怀化市，湖南省",
                            "simple_py": "ZFX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0745",
                            "area_code": "431221",
                            "longitude": "109.948061",
                            "latitude": "27.43736"
                        }
                    ]
                },
                {
                    "city_id": 22904,
                    "province_id": 16,
                    "name": "娄底市",
                    "whole_name": "娄底市，湖南省",
                    "simple_py": "LDS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0738",
                    "area_code": "431300",
                    "longitude": "112.008497",
                    "latitude": "27.728136",
                    "children": [
                        {
                            "area_id": 23271,
                            "city_id": 22904,
                            "province_id": 16,
                            "name": "冷水江市",
                            "whole_name": "冷水江市，娄底市，湖南省",
                            "simple_py": "LSJS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0738",
                            "area_code": "431381",
                            "longitude": "111.434674",
                            "latitude": "27.685759"
                        },
                        {
                            "area_id": 23274,
                            "city_id": 22904,
                            "province_id": 16,
                            "name": "娄星区",
                            "whole_name": "娄星区，娄底市，湖南省",
                            "simple_py": "LXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0738",
                            "area_code": "431302",
                            "longitude": "112.008486",
                            "latitude": "27.726643"
                        },
                        {
                            "area_id": 23275,
                            "city_id": 22904,
                            "province_id": 16,
                            "name": "涟源市",
                            "whole_name": "涟源市，娄底市，湖南省",
                            "simple_py": "LYS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0738",
                            "area_code": "431382",
                            "longitude": "111.670847",
                            "latitude": "27.692301"
                        },
                        {
                            "area_id": 23273,
                            "city_id": 22904,
                            "province_id": 16,
                            "name": "双峰县",
                            "whole_name": "双峰县，娄底市，湖南省",
                            "simple_py": "SFX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0738",
                            "area_code": "431321",
                            "longitude": "112.198245",
                            "latitude": "27.459126"
                        },
                        {
                            "area_id": 23272,
                            "city_id": 22904,
                            "province_id": 16,
                            "name": "新化县",
                            "whole_name": "新化县，娄底市，湖南省",
                            "simple_py": "XHX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0738",
                            "area_code": "431322",
                            "longitude": "111.306747",
                            "latitude": "27.737456"
                        }
                    ]
                },
                {
                    "city_id": 22910,
                    "province_id": 16,
                    "name": "邵阳市",
                    "whole_name": "邵阳市，湖南省",
                    "simple_py": "SYS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0739",
                    "area_code": "430500",
                    "longitude": "111.46923",
                    "latitude": "27.237842",
                    "children": [
                        {
                            "area_id": 24166,
                            "city_id": 22910,
                            "province_id": 16,
                            "name": "北塔区",
                            "whole_name": "北塔区，邵阳市，湖南省",
                            "simple_py": "BTQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0739",
                            "area_code": "430511",
                            "longitude": "111.452315",
                            "latitude": "27.245688"
                        },
                        {
                            "area_id": 24170,
                            "city_id": 22910,
                            "province_id": 16,
                            "name": "城步苗族自治县",
                            "whole_name": "城步苗族自治县，邵阳市，湖南省",
                            "simple_py": "CBMZZZX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0739",
                            "area_code": "430529",
                            "longitude": "110.313226",
                            "latitude": "26.363575"
                        },
                        {
                            "area_id": 24164,
                            "city_id": 22910,
                            "province_id": 16,
                            "name": "大祥区",
                            "whole_name": "大祥区，邵阳市，湖南省",
                            "simple_py": "DXQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0739",
                            "area_code": "430503",
                            "longitude": "111.462968",
                            "latitude": "27.233593"
                        },
                        {
                            "area_id": 24173,
                            "city_id": 22910,
                            "province_id": 16,
                            "name": "洞口县",
                            "whole_name": "洞口县，邵阳市，湖南省",
                            "simple_py": "DKX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0739",
                            "area_code": "430525",
                            "longitude": "110.579212",
                            "latitude": "27.062286"
                        },
                        {
                            "area_id": 24162,
                            "city_id": 22910,
                            "province_id": 16,
                            "name": "隆回县",
                            "whole_name": "隆回县，邵阳市，湖南省",
                            "simple_py": "LHX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0739",
                            "area_code": "430524",
                            "longitude": "111.038785",
                            "latitude": "27.116002"
                        },
                        {
                            "area_id": 24163,
                            "city_id": 22910,
                            "province_id": 16,
                            "name": "邵东县",
                            "whole_name": "邵东县，邵阳市，湖南省",
                            "simple_py": "SDX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0739",
                            "area_code": "430521",
                            "longitude": "111.743168",
                            "latitude": "27.257273"
                        },
                        {
                            "area_id": 24165,
                            "city_id": 22910,
                            "province_id": 16,
                            "name": "邵阳县",
                            "whole_name": "邵阳县，邵阳市，湖南省",
                            "simple_py": "SYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0739",
                            "area_code": "430523",
                            "longitude": "111.2757",
                            "latitude": "26.989713"
                        },
                        {
                            "area_id": 24167,
                            "city_id": 22910,
                            "province_id": 16,
                            "name": "绥宁县",
                            "whole_name": "绥宁县，邵阳市，湖南省",
                            "simple_py": "SNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0739",
                            "area_code": "430527",
                            "longitude": "110.155075",
                            "latitude": "26.580622"
                        },
                        {
                            "area_id": 24168,
                            "city_id": 22910,
                            "province_id": 16,
                            "name": "双清区",
                            "whole_name": "双清区，邵阳市，湖南省",
                            "simple_py": "SQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0739",
                            "area_code": "430502",
                            "longitude": "111.479756",
                            "latitude": "27.240001"
                        },
                        {
                            "area_id": 24172,
                            "city_id": 22910,
                            "province_id": 16,
                            "name": "武冈市",
                            "whole_name": "武冈市，邵阳市，湖南省",
                            "simple_py": "WGS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0739",
                            "area_code": "430581",
                            "longitude": "110.636804",
                            "latitude": "26.732086"
                        },
                        {
                            "area_id": 24169,
                            "city_id": 22910,
                            "province_id": 16,
                            "name": "新宁县",
                            "whole_name": "新宁县，邵阳市，湖南省",
                            "simple_py": "XNX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0739",
                            "area_code": "430528",
                            "longitude": "110.859115",
                            "latitude": "26.438912"
                        },
                        {
                            "area_id": 24171,
                            "city_id": 22910,
                            "province_id": 16,
                            "name": "新邵县",
                            "whole_name": "新邵县，邵阳市，湖南省",
                            "simple_py": "XSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0739",
                            "area_code": "430522",
                            "longitude": "111.459762",
                            "latitude": "27.311429"
                        }
                    ]
                },
                {
                    "city_id": 22905,
                    "province_id": 16,
                    "name": "湘潭市",
                    "whole_name": "湘潭市，湖南省",
                    "simple_py": "XTS",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "0731",
                    "area_code": "430300",
                    "longitude": "112.944052",
                    "latitude": "27.82973",
                    "children": [
                        {
                            "area_id": 23371,
                            "city_id": 22905,
                            "province_id": 16,
                            "name": "韶山市",
                            "whole_name": "韶山市，湘潭市，湖南省",
                            "simple_py": "SSS",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0731",
                            "area_code": "430382",
                            "longitude": "112.52848",
                            "latitude": "27.922682"
                        },
                        {
                            "area_id": 23369,
                            "city_id": 22905,
                            "province_id": 16,
                            "name": "湘潭县",
                            "whole_name": "湘潭县，湘潭市，湖南省",
                            "simple_py": "XTX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0731",
                            "area_code": "430321",
                            "longitude": "112.952829",
                            "latitude": "27.778601"
                        },
                        {
                            "area_id": 23372,
                            "city_id": 22905,
                            "province_id": 16,
                            "name": "湘乡市",
                            "whole_name": "湘乡市，湘潭市，湖南省",
                            "simple_py": "XXS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0731",
                            "area_code": "430381",
                            "longitude": "112.525217",
                            "latitude": "27.734918"
                        },
                        {
                            "area_id": 23368,
                            "city_id": 22905,
                            "province_id": 16,
                            "name": "岳塘区",
                            "whole_name": "岳塘区，湘潭市，湖南省",
                            "simple_py": "YTQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0731",
                            "area_code": "430304",
                            "longitude": "112.927707",
                            "latitude": "27.828854"
                        },
                        {
                            "area_id": 23370,
                            "city_id": 22905,
                            "province_id": 16,
                            "name": "雨湖区",
                            "whole_name": "雨湖区，湘潭市，湖南省",
                            "simple_py": "YHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0731",
                            "area_code": "430302",
                            "longitude": "112.907427",
                            "latitude": "27.86077"
                        }
                    ]
                },
                {
                    "city_id": 22912,
                    "province_id": 16,
                    "name": "湘西土家族苗族自治州",
                    "whole_name": "湘西土家族苗族自治州，湖南省",
                    "simple_py": "XXTJZMZZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "X",
                    "city_code": "0743",
                    "area_code": "433100",
                    "longitude": "109.739735",
                    "latitude": "28.314296",
                    "children": [
                        {
                            "area_id": 24478,
                            "city_id": 22912,
                            "province_id": 16,
                            "name": "保靖县",
                            "whole_name": "保靖县，湘西土家族苗族自治州，湖南省",
                            "simple_py": "BJX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0743",
                            "area_code": "433125",
                            "longitude": "109.651445",
                            "latitude": "28.709605"
                        },
                        {
                            "area_id": 24483,
                            "city_id": 22912,
                            "province_id": 16,
                            "name": "凤凰县",
                            "whole_name": "凤凰县，湘西土家族苗族自治州，湖南省",
                            "simple_py": "FHX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0743",
                            "area_code": "433123",
                            "longitude": "109.599191",
                            "latitude": "27.948308"
                        },
                        {
                            "area_id": 24480,
                            "city_id": 22912,
                            "province_id": 16,
                            "name": "古丈县",
                            "whole_name": "古丈县，湘西土家族苗族自治州，湖南省",
                            "simple_py": "GZX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0743",
                            "area_code": "433126",
                            "longitude": "109.949592",
                            "latitude": "28.616973"
                        },
                        {
                            "area_id": 24477,
                            "city_id": 22912,
                            "province_id": 16,
                            "name": "花垣县",
                            "whole_name": "花垣县，湘西土家族苗族自治州，湖南省",
                            "simple_py": "HYX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0743",
                            "area_code": "433124",
                            "longitude": "109.479063",
                            "latitude": "28.581352"
                        },
                        {
                            "area_id": 24479,
                            "city_id": 22912,
                            "province_id": 16,
                            "name": "吉首市",
                            "whole_name": "吉首市，湘西土家族苗族自治州，湖南省",
                            "simple_py": "JSS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0743",
                            "area_code": "433101",
                            "longitude": "109.738273",
                            "latitude": "28.314827"
                        },
                        {
                            "area_id": 24481,
                            "city_id": 22912,
                            "province_id": 16,
                            "name": "泸溪县",
                            "whole_name": "泸溪县，湘西土家族苗族自治州，湖南省",
                            "simple_py": "LXX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0743",
                            "area_code": "433122",
                            "longitude": "110.214428",
                            "latitude": "28.214516"
                        },
                        {
                            "area_id": 24482,
                            "city_id": 22912,
                            "province_id": 16,
                            "name": "龙山县",
                            "whole_name": "龙山县，湘西土家族苗族自治州，湖南省",
                            "simple_py": "LSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0743",
                            "area_code": "433130",
                            "longitude": "109.441189",
                            "latitude": "29.453438"
                        },
                        {
                            "area_id": 24476,
                            "city_id": 22912,
                            "province_id": 16,
                            "name": "永顺县",
                            "whole_name": "永顺县，湘西土家族苗族自治州，湖南省",
                            "simple_py": "YSX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0743",
                            "area_code": "433127",
                            "longitude": "109.853292",
                            "latitude": "28.998068"
                        }
                    ]
                },
                {
                    "city_id": 22902,
                    "province_id": 16,
                    "name": "岳阳市",
                    "whole_name": "岳阳市，湖南省",
                    "simple_py": "YYS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0730",
                    "area_code": "430600",
                    "longitude": "113.132855",
                    "latitude": "29.37029",
                    "children": [
                        {
                            "area_id": 22916,
                            "city_id": 22902,
                            "province_id": 16,
                            "name": "华容县",
                            "whole_name": "华容县，岳阳市，湖南省",
                            "simple_py": "HRX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0730",
                            "area_code": "430623",
                            "longitude": "112.559369",
                            "latitude": "29.524107"
                        },
                        {
                            "area_id": 22918,
                            "city_id": 22902,
                            "province_id": 16,
                            "name": "君山区",
                            "whole_name": "君山区，岳阳市，湖南省",
                            "simple_py": "JSQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0730",
                            "area_code": "430611",
                            "longitude": "113.004082",
                            "latitude": "29.438062"
                        },
                        {
                            "area_id": 22923,
                            "city_id": 22902,
                            "province_id": 16,
                            "name": "临湘市",
                            "whole_name": "临湘市，岳阳市，湖南省",
                            "simple_py": "LXS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0730",
                            "area_code": "430682",
                            "longitude": "113.450809",
                            "latitude": "29.471594"
                        },
                        {
                            "area_id": 22920,
                            "city_id": 22902,
                            "province_id": 16,
                            "name": "汨罗市",
                            "whole_name": "汨罗市，岳阳市，湖南省",
                            "simple_py": "MLS",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0730",
                            "area_code": "430681",
                            "longitude": "113.079419",
                            "latitude": "28.803149"
                        },
                        {
                            "area_id": 22924,
                            "city_id": 22902,
                            "province_id": 16,
                            "name": "平江县",
                            "whole_name": "平江县，岳阳市，湖南省",
                            "simple_py": "PJX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0730",
                            "area_code": "430626",
                            "longitude": "113.593751",
                            "latitude": "28.701523"
                        },
                        {
                            "area_id": 22921,
                            "city_id": 22902,
                            "province_id": 16,
                            "name": "湘阴县",
                            "whole_name": "湘阴县，岳阳市，湖南省",
                            "simple_py": "XYX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0730",
                            "area_code": "430624",
                            "longitude": "112.889748",
                            "latitude": "28.677498"
                        },
                        {
                            "area_id": 22917,
                            "city_id": 22902,
                            "province_id": 16,
                            "name": "岳阳楼区",
                            "whole_name": "岳阳楼区，岳阳市，湖南省",
                            "simple_py": "YYLQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0730",
                            "area_code": "430602",
                            "longitude": "113.120751",
                            "latitude": "29.366784"
                        },
                        {
                            "area_id": 22919,
                            "city_id": 22902,
                            "province_id": 16,
                            "name": "云溪区",
                            "whole_name": "云溪区，岳阳市，湖南省",
                            "simple_py": "YXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0730",
                            "area_code": "430603",
                            "longitude": "113.27387",
                            "latitude": "29.473395"
                        },
                        {
                            "area_id": 22922,
                            "city_id": 22902,
                            "province_id": 16,
                            "name": "岳阳县",
                            "whole_name": "岳阳县，岳阳市，湖南省",
                            "simple_py": "YYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0730",
                            "area_code": "430621",
                            "longitude": "113.116073",
                            "latitude": "29.144843"
                        }
                    ]
                },
                {
                    "city_id": 22906,
                    "province_id": 16,
                    "name": "益阳市",
                    "whole_name": "益阳市，湖南省",
                    "simple_py": "YYS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Y",
                    "city_code": "0737",
                    "area_code": "430900",
                    "longitude": "112.355042",
                    "latitude": "28.570066",
                    "children": [
                        {
                            "area_id": 23453,
                            "city_id": 22906,
                            "province_id": 16,
                            "name": "安化县",
                            "whole_name": "安化县，益阳市，湖南省",
                            "simple_py": "AHX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0737",
                            "area_code": "430923",
                            "longitude": "111.221824",
                            "latitude": "28.377421"
                        },
                        {
                            "area_id": 23452,
                            "city_id": 22906,
                            "province_id": 16,
                            "name": "赫山区",
                            "whole_name": "赫山区，益阳市，湖南省",
                            "simple_py": "HSQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0737",
                            "area_code": "430903",
                            "longitude": "112.360946",
                            "latitude": "28.568327"
                        },
                        {
                            "area_id": 23449,
                            "city_id": 22906,
                            "province_id": 16,
                            "name": "南县",
                            "whole_name": "南县，益阳市，湖南省",
                            "simple_py": "NX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0737",
                            "area_code": "430921",
                            "longitude": "112.410399",
                            "latitude": "29.372181"
                        },
                        {
                            "area_id": 23451,
                            "city_id": 22906,
                            "province_id": 16,
                            "name": "桃江县",
                            "whole_name": "桃江县，益阳市，湖南省",
                            "simple_py": "TJX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0737",
                            "area_code": "430922",
                            "longitude": "112.139732",
                            "latitude": "28.520993"
                        },
                        {
                            "area_id": 23448,
                            "city_id": 22906,
                            "province_id": 16,
                            "name": "沅江市",
                            "whole_name": "沅江市，益阳市，湖南省",
                            "simple_py": "YJS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0737",
                            "area_code": "430981",
                            "longitude": "112.361088",
                            "latitude": "28.839713"
                        },
                        {
                            "area_id": 23450,
                            "city_id": 22906,
                            "province_id": 16,
                            "name": "资阳区",
                            "whole_name": "资阳区，益阳市，湖南省",
                            "simple_py": "ZYQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0737",
                            "area_code": "430902",
                            "longitude": "112.33084",
                            "latitude": "28.592771"
                        }
                    ]
                },
                {
                    "city_id": 22914,
                    "province_id": 16,
                    "name": "永州市",
                    "whole_name": "永州市，湖南省",
                    "simple_py": "YZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Y",
                    "city_code": "0746",
                    "area_code": "431100",
                    "longitude": "111.608019",
                    "latitude": "26.434516",
                    "children": [
                        {
                            "area_id": 24735,
                            "city_id": 22914,
                            "province_id": 16,
                            "name": "东安县",
                            "whole_name": "东安县，永州市，湖南省",
                            "simple_py": "DAX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0746",
                            "area_code": "431122",
                            "longitude": "111.313035",
                            "latitude": "26.397278"
                        },
                        {
                            "area_id": 24740,
                            "city_id": 22914,
                            "province_id": 16,
                            "name": "道县",
                            "whole_name": "道县，永州市，湖南省",
                            "simple_py": "DX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0746",
                            "area_code": "431124",
                            "longitude": "111.591614",
                            "latitude": "25.518444"
                        },
                        {
                            "area_id": 24742,
                            "city_id": 22914,
                            "province_id": 16,
                            "name": "江华瑶族自治县",
                            "whole_name": "江华瑶族自治县，永州市，湖南省",
                            "simple_py": "JHYZZZX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0746",
                            "area_code": "431129",
                            "longitude": "111.577276",
                            "latitude": "25.182596"
                        },
                        {
                            "area_id": 24743,
                            "city_id": 22914,
                            "province_id": 16,
                            "name": "江永县",
                            "whole_name": "江永县，永州市，湖南省",
                            "simple_py": "JYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0746",
                            "area_code": "431125",
                            "longitude": "111.346803",
                            "latitude": "25.268154"
                        },
                        {
                            "area_id": 24734,
                            "city_id": 22914,
                            "province_id": 16,
                            "name": "冷水滩区",
                            "whole_name": "冷水滩区，永州市，湖南省",
                            "simple_py": "LSTQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0746",
                            "area_code": "431103",
                            "longitude": "111.607156",
                            "latitude": "26.434364"
                        },
                        {
                            "area_id": 24738,
                            "city_id": 22914,
                            "province_id": 16,
                            "name": "零陵区",
                            "whole_name": "零陵区，永州市，湖南省",
                            "simple_py": "LLQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0746",
                            "area_code": "431102",
                            "longitude": "111.626348",
                            "latitude": "26.223347"
                        },
                        {
                            "area_id": 24741,
                            "city_id": 22914,
                            "province_id": 16,
                            "name": "蓝山县",
                            "whole_name": "蓝山县，永州市，湖南省",
                            "simple_py": "LSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0746",
                            "area_code": "431127",
                            "longitude": "112.194195",
                            "latitude": "25.375255"
                        },
                        {
                            "area_id": 24739,
                            "city_id": 22914,
                            "province_id": 16,
                            "name": "宁远县",
                            "whole_name": "宁远县，永州市，湖南省",
                            "simple_py": "NYX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0746",
                            "area_code": "431126",
                            "longitude": "111.944529",
                            "latitude": "25.584112"
                        },
                        {
                            "area_id": 24736,
                            "city_id": 22914,
                            "province_id": 16,
                            "name": "祁阳县",
                            "whole_name": "祁阳县，永州市，湖南省",
                            "simple_py": "QYX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0746",
                            "area_code": "431121",
                            "longitude": "111.85734",
                            "latitude": "26.585929"
                        },
                        {
                            "area_id": 24744,
                            "city_id": 22914,
                            "province_id": 16,
                            "name": "双牌县",
                            "whole_name": "双牌县，永州市，湖南省",
                            "simple_py": "SPX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0746",
                            "area_code": "431123",
                            "longitude": "111.662146",
                            "latitude": "25.959397"
                        },
                        {
                            "area_id": 24737,
                            "city_id": 22914,
                            "province_id": 16,
                            "name": "新田县",
                            "whole_name": "新田县，永州市，湖南省",
                            "simple_py": "XTX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0746",
                            "area_code": "431128",
                            "longitude": "112.220341",
                            "latitude": "25.906927"
                        }
                    ]
                },
                {
                    "city_id": 22911,
                    "province_id": 16,
                    "name": "张家界市",
                    "whole_name": "张家界市，湖南省",
                    "simple_py": "ZJJS",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "0744",
                    "area_code": "430800",
                    "longitude": "110.479921",
                    "latitude": "29.127401",
                    "children": [
                        {
                            "area_id": 24389,
                            "city_id": 22911,
                            "province_id": 16,
                            "name": "慈利县",
                            "whole_name": "慈利县，张家界市，湖南省",
                            "simple_py": "CLX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0744",
                            "area_code": "430821",
                            "longitude": "111.132702",
                            "latitude": "29.423876"
                        },
                        {
                            "area_id": 24390,
                            "city_id": 22911,
                            "province_id": 16,
                            "name": "桑植县",
                            "whole_name": "桑植县，张家界市，湖南省",
                            "simple_py": "SZX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0744",
                            "area_code": "430822",
                            "longitude": "110.164039",
                            "latitude": "29.399939"
                        },
                        {
                            "area_id": 24388,
                            "city_id": 22911,
                            "province_id": 16,
                            "name": "武陵源区",
                            "whole_name": "武陵源区，张家界市，湖南省",
                            "simple_py": "WLYQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0744",
                            "area_code": "430811",
                            "longitude": "110.54758",
                            "latitude": "29.347827"
                        },
                        {
                            "area_id": 24391,
                            "city_id": 22911,
                            "province_id": 16,
                            "name": "永定区",
                            "whole_name": "永定区，张家界市，湖南省",
                            "simple_py": "YDQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0744",
                            "area_code": "430802",
                            "longitude": "110.484559",
                            "latitude": "29.125961"
                        }
                    ]
                },
                {
                    "city_id": 22913,
                    "province_id": 16,
                    "name": "株洲市",
                    "whole_name": "株洲市，湖南省",
                    "simple_py": "ZZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Z",
                    "city_code": "0731",
                    "area_code": "430200",
                    "longitude": "113.151737",
                    "latitude": "27.835806",
                    "children": [
                        {
                            "area_id": 24609,
                            "city_id": 22913,
                            "province_id": 16,
                            "name": "茶陵县",
                            "whole_name": "茶陵县，株洲市，湖南省",
                            "simple_py": "CLX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0731",
                            "area_code": "430224",
                            "longitude": "113.546509",
                            "latitude": "26.789534"
                        },
                        {
                            "area_id": 24608,
                            "city_id": 22913,
                            "province_id": 16,
                            "name": "荷塘区",
                            "whole_name": "荷塘区，株洲市，湖南省",
                            "simple_py": "HTQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0731",
                            "area_code": "430202",
                            "longitude": "113.162548",
                            "latitude": "27.833036"
                        },
                        {
                            "area_id": 24613,
                            "city_id": 22913,
                            "province_id": 16,
                            "name": "芦淞区",
                            "whole_name": "芦淞区，株洲市，湖南省",
                            "simple_py": "LSQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0731",
                            "area_code": "430203",
                            "longitude": "113.155169",
                            "latitude": "27.827246"
                        },
                        {
                            "area_id": 24616,
                            "city_id": 22913,
                            "province_id": 16,
                            "name": "醴陵市",
                            "whole_name": "醴陵市，株洲市，湖南省",
                            "simple_py": "LLS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0731",
                            "area_code": "430281",
                            "longitude": "113.507157",
                            "latitude": "27.657873"
                        },
                        {
                            "area_id": 24615,
                            "city_id": 22913,
                            "province_id": 16,
                            "name": "石峰区",
                            "whole_name": "石峰区，株洲市，湖南省",
                            "simple_py": "SFQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0731",
                            "area_code": "430204",
                            "longitude": "113.11295",
                            "latitude": "27.871945"
                        },
                        {
                            "area_id": 24612,
                            "city_id": 22913,
                            "province_id": 16,
                            "name": "天元区",
                            "whole_name": "天元区，株洲市，湖南省",
                            "simple_py": "TYQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0731",
                            "area_code": "430211",
                            "longitude": "113.136252",
                            "latitude": "27.826909"
                        },
                        {
                            "area_id": 24610,
                            "city_id": 22913,
                            "province_id": 16,
                            "name": "攸县",
                            "whole_name": "攸县，株洲市，湖南省",
                            "simple_py": "YX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0731",
                            "area_code": "430223",
                            "longitude": "113.345774",
                            "latitude": "27.000071"
                        },
                        {
                            "area_id": 24611,
                            "city_id": 22913,
                            "province_id": 16,
                            "name": "炎陵县",
                            "whole_name": "炎陵县，株洲市，湖南省",
                            "simple_py": "YLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0731",
                            "area_code": "430225",
                            "longitude": "113.776884",
                            "latitude": "26.489459"
                        },
                        {
                            "area_id": 24614,
                            "city_id": 22913,
                            "province_id": 16,
                            "name": "株洲县",
                            "whole_name": "株洲县，株洲市，湖南省",
                            "simple_py": "ZZX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0731",
                            "area_code": "430221",
                            "longitude": "113.146176",
                            "latitude": "27.705844"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 17,
            "name": "海南省",
            "whole_name": "海南省",
            "simple_py": "HNS",
            "per_pin_yin": " ",
            "per_pin_yin2": "H",
            "city_code": "",
            "area_code": "460000",
            "longitude": "110.33119",
            "latitude": "20.031971",
            "children": [
                {
                    "city_id": 25122,
                    "province_id": 17,
                    "name": "白沙黎族自治县",
                    "whole_name": "白沙黎族自治县，海南省",
                    "simple_py": "BSLZZZX",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "0898",
                    "area_code": "469025",
                    "longitude": "109.452606",
                    "latitude": "19.224584",
                    "children": [
                        {
                            "area_id": 25229,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "邦溪镇",
                            "whole_name": "邦溪镇，白沙黎族自治县，海南省",
                            "simple_py": "BXZ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.09",
                            "latitude": "19.3912"
                        },
                        {
                            "area_id": 25234,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "打安镇",
                            "whole_name": "打安镇，白沙黎族自治县，海南省",
                            "simple_py": "DAZ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.36",
                            "latitude": "19.3756"
                        },
                        {
                            "area_id": 25235,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "阜龙乡",
                            "whole_name": "阜龙乡，白沙黎族自治县，海南省",
                            "simple_py": "FLX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.436",
                            "latitude": "19.3316"
                        },
                        {
                            "area_id": 25228,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "国营龙江农场",
                            "whole_name": "国营龙江农场，白沙黎族自治县，海南省",
                            "simple_py": "GYLJNC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.178",
                            "latitude": "19.2369"
                        },
                        {
                            "area_id": 25231,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "国营白沙农场",
                            "whole_name": "国营白沙农场，白沙黎族自治县，海南省",
                            "simple_py": "GYBSNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.429",
                            "latitude": "19.2881"
                        },
                        {
                            "area_id": 25236,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "国营邦溪农场",
                            "whole_name": "国营邦溪农场，白沙黎族自治县，海南省",
                            "simple_py": "GYBXNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.18",
                            "latitude": "19.4104"
                        },
                        {
                            "area_id": 25224,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "金波乡",
                            "whole_name": "金波乡，白沙黎族自治县，海南省",
                            "simple_py": "JBX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.157",
                            "latitude": "19.2577"
                        },
                        {
                            "area_id": 25225,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "南开乡",
                            "whole_name": "南开乡，白沙黎族自治县，海南省",
                            "simple_py": "NKX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.293",
                            "latitude": "19.0596"
                        },
                        {
                            "area_id": 25223,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "七坊镇",
                            "whole_name": "七坊镇，白沙黎族自治县，海南省",
                            "simple_py": "QFZ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.298",
                            "latitude": "19.3459"
                        },
                        {
                            "area_id": 25227,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "青松乡",
                            "whole_name": "青松乡，白沙黎族自治县，海南省",
                            "simple_py": "QSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.302",
                            "latitude": "19.0689"
                        },
                        {
                            "area_id": 25226,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "荣邦乡",
                            "whole_name": "荣邦乡，白沙黎族自治县，海南省",
                            "simple_py": "RBX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.064",
                            "latitude": "19.4868"
                        },
                        {
                            "area_id": 25233,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "细水乡",
                            "whole_name": "细水乡，白沙黎族自治县，海南省",
                            "simple_py": "XSX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.523",
                            "latitude": "19.2096"
                        },
                        {
                            "area_id": 25230,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "元门乡",
                            "whole_name": "元门乡，白沙黎族自治县，海南省",
                            "simple_py": "YMX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.455",
                            "latitude": "19.0981"
                        },
                        {
                            "area_id": 25232,
                            "city_id": 25122,
                            "province_id": 17,
                            "name": "牙叉镇",
                            "whole_name": "牙叉镇，白沙黎族自治县，海南省",
                            "simple_py": "YCZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0898",
                            "area_code": "469025",
                            "longitude": "109.45",
                            "latitude": "19.3004"
                        }
                    ]
                },
                {
                    "city_id": 25125,
                    "province_id": 17,
                    "name": "保亭黎族苗族自治县",
                    "whole_name": "保亭黎族苗族自治县，海南省",
                    "simple_py": "BTLZMZZZX",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "B",
                    "city_code": "0898",
                    "area_code": "469029",
                    "longitude": "109.70245",
                    "latitude": "18.636371",
                    "children": [
                        {
                            "area_id": 25269,
                            "city_id": 25125,
                            "province_id": 17,
                            "name": "保城镇",
                            "whole_name": "保城镇，保亭黎族苗族自治县，海南省",
                            "simple_py": "BCZ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0898",
                            "area_code": "469029",
                            "longitude": "109.747",
                            "latitude": "18.6854"
                        },
                        {
                            "area_id": 25268,
                            "city_id": 25125,
                            "province_id": 17,
                            "name": "国营新星农场",
                            "whole_name": "国营新星农场，保亭黎族苗族自治县，海南省",
                            "simple_py": "GYXXNC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469029",
                            "longitude": "109.729",
                            "latitude": "18.6749"
                        },
                        {
                            "area_id": 25270,
                            "city_id": 25125,
                            "province_id": 17,
                            "name": "国营金江农场",
                            "whole_name": "国营金江农场，保亭黎族苗族自治县，海南省",
                            "simple_py": "GYJJNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469029",
                            "longitude": "109.682",
                            "latitude": "18.547"
                        },
                        {
                            "area_id": 25272,
                            "city_id": 25125,
                            "province_id": 17,
                            "name": "国营三道农场",
                            "whole_name": "国营三道农场，保亭黎族苗族自治县，海南省",
                            "simple_py": "GYSDNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469029",
                            "longitude": "109.649",
                            "latitude": "18.5179"
                        },
                        {
                            "area_id": 25265,
                            "city_id": 25125,
                            "province_id": 17,
                            "name": "海南保亭热带作物研究所",
                            "whole_name": "海南保亭热带作物研究所，保亭黎族苗族自治县，海南省",
                            "simple_py": "HNBTRDZWYJS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469029",
                            "longitude": "109.709",
                            "latitude": "18.6282"
                        },
                        {
                            "area_id": 25267,
                            "city_id": 25125,
                            "province_id": 17,
                            "name": "加茂镇",
                            "whole_name": "加茂镇，保亭黎族苗族自治县，海南省",
                            "simple_py": "JMZ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0898",
                            "area_code": "469029",
                            "longitude": "109.719",
                            "latitude": "18.5033"
                        },
                        {
                            "area_id": 25277,
                            "city_id": 25125,
                            "province_id": 17,
                            "name": "六弓乡",
                            "whole_name": "六弓乡，保亭黎族苗族自治县，海南省",
                            "simple_py": "LGX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469029",
                            "longitude": "109.803",
                            "latitude": "18.5393"
                        },
                        {
                            "area_id": 25273,
                            "city_id": 25125,
                            "province_id": 17,
                            "name": "毛感乡",
                            "whole_name": "毛感乡，保亭黎族苗族自治县，海南省",
                            "simple_py": "MGX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0898",
                            "area_code": "469029",
                            "longitude": "109.503",
                            "latitude": "18.5563"
                        },
                        {
                            "area_id": 25271,
                            "city_id": 25125,
                            "province_id": 17,
                            "name": "南林乡",
                            "whole_name": "南林乡，保亭黎族苗族自治县，海南省",
                            "simple_py": "NLX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0898",
                            "area_code": "469029",
                            "longitude": "109.577",
                            "latitude": "18.3893"
                        },
                        {
                            "area_id": 25275,
                            "city_id": 25125,
                            "province_id": 17,
                            "name": "什玲镇",
                            "whole_name": "什玲镇，保亭黎族苗族自治县，海南省",
                            "simple_py": "SLZ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "469029",
                            "longitude": "109.74",
                            "latitude": "18.6941"
                        },
                        {
                            "area_id": 25276,
                            "city_id": 25125,
                            "province_id": 17,
                            "name": "三道镇",
                            "whole_name": "三道镇，保亭黎族苗族自治县，海南省",
                            "simple_py": "SDZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "469029",
                            "longitude": "109.66",
                            "latitude": "18.5251"
                        },
                        {
                            "area_id": 25266,
                            "city_id": 25125,
                            "province_id": 17,
                            "name": "新政镇",
                            "whole_name": "新政镇，保亭黎族苗族自治县，海南省",
                            "simple_py": "XZZ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0898",
                            "area_code": "469029",
                            "longitude": "109.578",
                            "latitude": "18.5685"
                        },
                        {
                            "area_id": 25274,
                            "city_id": 25125,
                            "province_id": 17,
                            "name": "响水镇",
                            "whole_name": "响水镇，保亭黎族苗族自治县，海南省",
                            "simple_py": "XSZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0898",
                            "area_code": "469029",
                            "longitude": "109.565",
                            "latitude": "18.7404"
                        }
                    ]
                },
                {
                    "city_id": 25117,
                    "province_id": 17,
                    "name": "昌江黎族自治县",
                    "whole_name": "昌江黎族自治县，海南省",
                    "simple_py": "CJLZZZX",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0898",
                    "area_code": "469026",
                    "longitude": "109.053351",
                    "latitude": "19.260968",
                    "children": [
                        {
                            "area_id": 25166,
                            "city_id": 25117,
                            "province_id": 17,
                            "name": "叉河镇",
                            "whole_name": "叉河镇，昌江黎族自治县，海南省",
                            "simple_py": "CHZ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0898",
                            "area_code": "469026",
                            "longitude": "108.989",
                            "latitude": "19.2536"
                        },
                        {
                            "area_id": 25170,
                            "city_id": 25117,
                            "province_id": 17,
                            "name": "昌化镇",
                            "whole_name": "昌化镇，昌江黎族自治县，海南省",
                            "simple_py": "CHZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0898",
                            "area_code": "469026",
                            "longitude": "108.732",
                            "latitude": "19.3836"
                        },
                        {
                            "area_id": 25160,
                            "city_id": 25117,
                            "province_id": 17,
                            "name": "国营霸王岭林场",
                            "whole_name": "国营霸王岭林场，昌江黎族自治县，海南省",
                            "simple_py": "GYBWLLC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469026",
                            "longitude": "109.03",
                            "latitude": "19.1725"
                        },
                        {
                            "area_id": 25169,
                            "city_id": 25117,
                            "province_id": 17,
                            "name": "国营红林农场",
                            "whole_name": "国营红林农场，昌江黎族自治县，海南省",
                            "simple_py": "GYHLNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469026",
                            "longitude": "109.088",
                            "latitude": "19.2367"
                        },
                        {
                            "area_id": 25163,
                            "city_id": 25117,
                            "province_id": 17,
                            "name": "海南矿业联合有限公司",
                            "whole_name": "海南矿业联合有限公司，昌江黎族自治县，海南省",
                            "simple_py": "HNKYLHYXGS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469026",
                            "longitude": "108.989",
                            "latitude": "19.2538"
                        },
                        {
                            "area_id": 25168,
                            "city_id": 25117,
                            "province_id": 17,
                            "name": "海尾镇",
                            "whole_name": "海尾镇，昌江黎族自治县，海南省",
                            "simple_py": "HWZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469026",
                            "longitude": "108.952",
                            "latitude": "19.4945"
                        },
                        {
                            "area_id": 25164,
                            "city_id": 25117,
                            "province_id": 17,
                            "name": "七叉镇",
                            "whole_name": "七叉镇，昌江黎族自治县，海南省",
                            "simple_py": "QCZ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0898",
                            "area_code": "469026",
                            "longitude": "109.069",
                            "latitude": "19.1732"
                        },
                        {
                            "area_id": 25161,
                            "city_id": 25117,
                            "province_id": 17,
                            "name": "十月田镇",
                            "whole_name": "十月田镇，昌江黎族自治县，海南省",
                            "simple_py": "SYTZ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "469026",
                            "longitude": "108.989",
                            "latitude": "19.3818"
                        },
                        {
                            "area_id": 25162,
                            "city_id": 25117,
                            "province_id": 17,
                            "name": "石碌镇",
                            "whole_name": "石碌镇，昌江黎族自治县，海南省",
                            "simple_py": "SLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "469026",
                            "longitude": "109.05",
                            "latitude": "19.2444"
                        },
                        {
                            "area_id": 25165,
                            "city_id": 25117,
                            "province_id": 17,
                            "name": "乌烈镇",
                            "whole_name": "乌烈镇，昌江黎族自治县，海南省",
                            "simple_py": "WLZ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0898",
                            "area_code": "469026",
                            "longitude": "108.81",
                            "latitude": "19.3525"
                        },
                        {
                            "area_id": 25167,
                            "city_id": 25117,
                            "province_id": 17,
                            "name": "王下乡",
                            "whole_name": "王下乡，昌江黎族自治县，海南省",
                            "simple_py": "WXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0898",
                            "area_code": "469026",
                            "longitude": "109.094",
                            "latitude": "18.9052"
                        }
                    ]
                },
                {
                    "city_id": 25126,
                    "province_id": 17,
                    "name": "澄迈县",
                    "whole_name": "澄迈县，海南省",
                    "simple_py": "CMX",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "C",
                    "city_code": "0898",
                    "area_code": "469023",
                    "longitude": "110.007147",
                    "latitude": "19.737095",
                    "children": [
                        {
                            "area_id": 25288,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "大丰镇",
                            "whole_name": "大丰镇，澄迈县，海南省",
                            "simple_py": "DFZ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "109.989",
                            "latitude": "19.904"
                        },
                        {
                            "area_id": 25279,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "福山镇",
                            "whole_name": "福山镇，澄迈县，海南省",
                            "simple_py": "FSZ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "109.919",
                            "latitude": "19.7325"
                        },
                        {
                            "area_id": 25285,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "国营红岗农场",
                            "whole_name": "国营红岗农场，澄迈县，海南省",
                            "simple_py": "GYHGNC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "110.038",
                            "latitude": "19.5642"
                        },
                        {
                            "area_id": 25287,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "国营红光农场",
                            "whole_name": "国营红光农场，澄迈县，海南省",
                            "simple_py": "GYHGNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "109.957",
                            "latitude": "19.8731"
                        },
                        {
                            "area_id": 25290,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "国营昆仑农场",
                            "whole_name": "国营昆仑农场，澄迈县，海南省",
                            "simple_py": "GYKLNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "109.802",
                            "latitude": "19.5127"
                        },
                        {
                            "area_id": 25291,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "国营金安农场",
                            "whole_name": "国营金安农场，澄迈县，海南省",
                            "simple_py": "GYJANC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "110.123",
                            "latitude": "19.7367"
                        },
                        {
                            "area_id": 25292,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "国营西达农场",
                            "whole_name": "国营西达农场，澄迈县，海南省",
                            "simple_py": "GYXDNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "109.862",
                            "latitude": "19.4343"
                        },
                        {
                            "area_id": 25293,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "国营和岭农场",
                            "whole_name": "国营和岭农场，澄迈县，海南省",
                            "simple_py": "GYHLNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "109.814",
                            "latitude": "19.5367"
                        },
                        {
                            "area_id": 25282,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "金江镇",
                            "whole_name": "金江镇，澄迈县，海南省",
                            "simple_py": "JJZ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "109.987",
                            "latitude": "19.7817"
                        },
                        {
                            "area_id": 25289,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "加乐镇",
                            "whole_name": "加乐镇，澄迈县，海南省",
                            "simple_py": "JLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "110.042",
                            "latitude": "19.6276"
                        },
                        {
                            "area_id": 25283,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "老城镇",
                            "whole_name": "老城镇，澄迈县，海南省",
                            "simple_py": "LCZ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "110.159",
                            "latitude": "19.9529"
                        },
                        {
                            "area_id": 25281,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "桥头镇",
                            "whole_name": "桥头镇，澄迈县，海南省",
                            "simple_py": "QTZ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "109.931",
                            "latitude": "19.9171"
                        },
                        {
                            "area_id": 25286,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "瑞溪镇",
                            "whole_name": "瑞溪镇，澄迈县，海南省",
                            "simple_py": "RXZ",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "110.087",
                            "latitude": "19.7731"
                        },
                        {
                            "area_id": 25294,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "仁兴镇",
                            "whole_name": "仁兴镇，澄迈县，海南省",
                            "simple_py": "RXZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "R",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "109.916",
                            "latitude": "19.5062"
                        },
                        {
                            "area_id": 25284,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "文儒镇",
                            "whole_name": "文儒镇，澄迈县，海南省",
                            "simple_py": "WRZ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "110.121",
                            "latitude": "19.6454"
                        },
                        {
                            "area_id": 25278,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "永发镇",
                            "whole_name": "永发镇，澄迈县，海南省",
                            "simple_py": "YFZ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "110.186",
                            "latitude": "19.6424"
                        },
                        {
                            "area_id": 25280,
                            "city_id": 25126,
                            "province_id": 17,
                            "name": "中兴镇",
                            "whole_name": "中兴镇，澄迈县，海南省",
                            "simple_py": "ZXZ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0898",
                            "area_code": "469023",
                            "longitude": "109.938",
                            "latitude": "19.5697"
                        }
                    ]
                },
                {
                    "city_id": 25118,
                    "province_id": 17,
                    "name": "定安县",
                    "whole_name": "定安县，海南省",
                    "simple_py": "DAX",
                    "per_pin_yin": "D",
                    "per_pin_yin2": "D",
                    "city_code": "0898",
                    "area_code": "469021",
                    "longitude": "110.349235",
                    "latitude": "19.684966",
                    "children": [
                        {
                            "area_id": 25176,
                            "city_id": 25118,
                            "province_id": 17,
                            "name": "定城镇",
                            "whole_name": "定城镇，定安县，海南省",
                            "simple_py": "DCZ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469021",
                            "longitude": "110.317",
                            "latitude": "19.7017"
                        },
                        {
                            "area_id": 25174,
                            "city_id": 25118,
                            "province_id": 17,
                            "name": "富文镇",
                            "whole_name": "富文镇，定安县，海南省",
                            "simple_py": "FWZ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0898",
                            "area_code": "469021",
                            "longitude": "110.232",
                            "latitude": "19.521"
                        },
                        {
                            "area_id": 25173,
                            "city_id": 25118,
                            "province_id": 17,
                            "name": "国营中瑞农场",
                            "whole_name": "国营中瑞农场，定安县，海南省",
                            "simple_py": "GYZRNC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469021",
                            "longitude": "110.244",
                            "latitude": "19.3008"
                        },
                        {
                            "area_id": 25179,
                            "city_id": 25118,
                            "province_id": 17,
                            "name": "国营南海农场",
                            "whole_name": "国营南海农场，定安县，海南省",
                            "simple_py": "GYNHNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469021",
                            "longitude": "110.469",
                            "latitude": "19.4432"
                        },
                        {
                            "area_id": 25181,
                            "city_id": 25118,
                            "province_id": 17,
                            "name": "国营金鸡岭农场",
                            "whole_name": "国营金鸡岭农场，定安县，海南省",
                            "simple_py": "GYJJLNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469021",
                            "longitude": "110.252",
                            "latitude": "19.5171"
                        },
                        {
                            "area_id": 25171,
                            "city_id": 25118,
                            "province_id": 17,
                            "name": "黄竹镇",
                            "whole_name": "黄竹镇，定安县，海南省",
                            "simple_py": "HZZ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469021",
                            "longitude": "110.528",
                            "latitude": "19.4887"
                        },
                        {
                            "area_id": 25178,
                            "city_id": 25118,
                            "province_id": 17,
                            "name": "翰林镇",
                            "whole_name": "翰林镇，定安县，海南省",
                            "simple_py": "HLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469021",
                            "longitude": "110.24",
                            "latitude": "19.2982"
                        },
                        {
                            "area_id": 25175,
                            "city_id": 25118,
                            "province_id": 17,
                            "name": "岭口镇",
                            "whole_name": "岭口镇，定安县，海南省",
                            "simple_py": "LKZ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469021",
                            "longitude": "110.276",
                            "latitude": "19.3601"
                        },
                        {
                            "area_id": 25177,
                            "city_id": 25118,
                            "province_id": 17,
                            "name": "雷鸣镇",
                            "whole_name": "雷鸣镇，定安县，海南省",
                            "simple_py": "LMZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469021",
                            "longitude": "110.273",
                            "latitude": "19.5137"
                        },
                        {
                            "area_id": 25180,
                            "city_id": 25118,
                            "province_id": 17,
                            "name": "龙河镇",
                            "whole_name": "龙河镇，定安县，海南省",
                            "simple_py": "LHZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469021",
                            "longitude": "110.226",
                            "latitude": "19.4221"
                        },
                        {
                            "area_id": 25182,
                            "city_id": 25118,
                            "province_id": 17,
                            "name": "龙湖镇",
                            "whole_name": "龙湖镇，定安县，海南省",
                            "simple_py": "LHZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469021",
                            "longitude": "110.469",
                            "latitude": "19.5845"
                        },
                        {
                            "area_id": 25183,
                            "city_id": 25118,
                            "province_id": 17,
                            "name": "龙门镇",
                            "whole_name": "龙门镇，定安县，海南省",
                            "simple_py": "LMZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469021",
                            "longitude": "110.298",
                            "latitude": "19.4997"
                        },
                        {
                            "area_id": 25172,
                            "city_id": 25118,
                            "province_id": 17,
                            "name": "新竹镇",
                            "whole_name": "新竹镇，定安县，海南省",
                            "simple_py": "XZZ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0898",
                            "area_code": "469021",
                            "longitude": "110.159",
                            "latitude": "19.5843"
                        }
                    ]
                },
                {
                    "city_id": 25121,
                    "province_id": 17,
                    "name": "东方市",
                    "whole_name": "东方市，海南省",
                    "simple_py": "DFS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "D",
                    "city_code": "0898",
                    "area_code": "469007",
                    "longitude": "108.653789",
                    "latitude": "19.10198",
                    "children": [
                        {
                            "area_id": 25221,
                            "city_id": 25121,
                            "province_id": 17,
                            "name": "板桥镇",
                            "whole_name": "板桥镇，东方市，海南省",
                            "simple_py": "BQZ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0898",
                            "area_code": "469007",
                            "longitude": "108.87",
                            "latitude": "18.8744"
                        },
                        {
                            "area_id": 25222,
                            "city_id": 25121,
                            "province_id": 17,
                            "name": "八所镇",
                            "whole_name": "八所镇，东方市，海南省",
                            "simple_py": "BSZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0898",
                            "area_code": "469007",
                            "longitude": "108.622",
                            "latitude": "19.0927"
                        },
                        {
                            "area_id": 25211,
                            "city_id": 25121,
                            "province_id": 17,
                            "name": "东方华侨农场",
                            "whole_name": "东方华侨农场，东方市，海南省",
                            "simple_py": "DFHQNC",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469007",
                            "longitude": "108.696",
                            "latitude": "18.9726"
                        },
                        {
                            "area_id": 25216,
                            "city_id": 25121,
                            "province_id": 17,
                            "name": "东河镇",
                            "whole_name": "东河镇，东方市，海南省",
                            "simple_py": "DHZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469007",
                            "longitude": "108.991",
                            "latitude": "19.1321"
                        },
                        {
                            "area_id": 25220,
                            "city_id": 25121,
                            "province_id": 17,
                            "name": "大田镇",
                            "whole_name": "大田镇，东方市，海南省",
                            "simple_py": "DTZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469007",
                            "longitude": "108.976",
                            "latitude": "19.1314"
                        },
                        {
                            "area_id": 25214,
                            "city_id": 25121,
                            "province_id": 17,
                            "name": "国营广坝农场",
                            "whole_name": "国营广坝农场，东方市，海南省",
                            "simple_py": "GYGBNC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469007",
                            "longitude": "108.732",
                            "latitude": "18.8589"
                        },
                        {
                            "area_id": 25217,
                            "city_id": 25121,
                            "province_id": 17,
                            "name": "感城镇",
                            "whole_name": "感城镇，东方市，海南省",
                            "simple_py": "GCZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469007",
                            "longitude": "108.83",
                            "latitude": "18.8833"
                        },
                        {
                            "area_id": 25213,
                            "city_id": 25121,
                            "province_id": 17,
                            "name": "江边乡",
                            "whole_name": "江边乡，东方市，海南省",
                            "simple_py": "JBX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0898",
                            "area_code": "469007",
                            "longitude": "109.108",
                            "latitude": "18.8945"
                        },
                        {
                            "area_id": 25218,
                            "city_id": 25121,
                            "province_id": 17,
                            "name": "三家镇",
                            "whole_name": "三家镇，东方市，海南省",
                            "simple_py": "SJZ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "469007",
                            "longitude": "108.798",
                            "latitude": "19.2498"
                        },
                        {
                            "area_id": 25219,
                            "city_id": 25121,
                            "province_id": 17,
                            "name": "四更镇",
                            "whole_name": "四更镇，东方市，海南省",
                            "simple_py": "SGZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "469007",
                            "longitude": "108.606",
                            "latitude": "19.2646"
                        },
                        {
                            "area_id": 25215,
                            "city_id": 25121,
                            "province_id": 17,
                            "name": "天安乡",
                            "whole_name": "天安乡，东方市，海南省",
                            "simple_py": "TAX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0898",
                            "area_code": "469007",
                            "longitude": "108.817",
                            "latitude": "18.8803"
                        },
                        {
                            "area_id": 25212,
                            "city_id": 25121,
                            "province_id": 17,
                            "name": "新龙镇",
                            "whole_name": "新龙镇，东方市，海南省",
                            "simple_py": "XLZ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0898",
                            "area_code": "469007",
                            "longitude": "108.686",
                            "latitude": "18.9263"
                        }
                    ]
                },
                {
                    "city_id": 25132,
                    "province_id": 17,
                    "name": "儋州市",
                    "whole_name": "儋州市，海南省",
                    "simple_py": "DZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "D",
                    "city_code": "0898",
                    "area_code": "460400",
                    "longitude": "109.576782",
                    "latitude": "19.517486",
                    "children": [
                        {
                            "area_id": 25380,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "白马井镇",
                            "whole_name": "白马井镇，儋州市，海南省",
                            "simple_py": "BMJZ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.268",
                            "latitude": "19.7046"
                        },
                        {
                            "area_id": 25372,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "东成镇",
                            "whole_name": "东成镇，儋州市，海南省",
                            "simple_py": "DCZ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.579",
                            "latitude": "19.7102"
                        },
                        {
                            "area_id": 25383,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "大成镇",
                            "whole_name": "大成镇，儋州市，海南省",
                            "simple_py": "DCZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.345",
                            "latitude": "19.4765"
                        },
                        {
                            "area_id": 25382,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "峨蔓镇",
                            "whole_name": "峨蔓镇，儋州市，海南省",
                            "simple_py": "EMZ",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.333",
                            "latitude": "19.8438"
                        },
                        {
                            "area_id": 25363,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "光村镇",
                            "whole_name": "光村镇，儋州市，海南省",
                            "simple_py": "GCZ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.467",
                            "latitude": "19.9035"
                        },
                        {
                            "area_id": 25368,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "国营蓝洋农场",
                            "whole_name": "国营蓝洋农场，儋州市，海南省",
                            "simple_py": "GYLYNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.618",
                            "latitude": "19.5107"
                        },
                        {
                            "area_id": 25376,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "国营西培农场",
                            "whole_name": "国营西培农场，儋州市，海南省",
                            "simple_py": "GYXPNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.31",
                            "latitude": "19.4969"
                        },
                        {
                            "area_id": 25378,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "国营八一农场",
                            "whole_name": "国营八一农场，儋州市，海南省",
                            "simple_py": "GYBYNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.23",
                            "latitude": "19.3915"
                        },
                        {
                            "area_id": 25379,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "国营西联农场",
                            "whole_name": "国营西联农场，儋州市，海南省",
                            "simple_py": "GYXLNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.537",
                            "latitude": "19.6556"
                        },
                        {
                            "area_id": 25365,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "海头镇",
                            "whole_name": "海头镇，儋州市，海南省",
                            "simple_py": "HTZ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "108.948",
                            "latitude": "19.4939"
                        },
                        {
                            "area_id": 25366,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "和庆镇",
                            "whole_name": "和庆镇，儋州市，海南省",
                            "simple_py": "HQZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.677",
                            "latitude": "19.5887"
                        },
                        {
                            "area_id": 25367,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "华南热作学院",
                            "whole_name": "华南热作学院，儋州市，海南省",
                            "simple_py": "HNRZXY",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.505",
                            "latitude": "19.573"
                        },
                        {
                            "area_id": 25364,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "兰洋镇",
                            "whole_name": "兰洋镇，儋州市，海南省",
                            "simple_py": "LYZ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.682",
                            "latitude": "19.4833"
                        },
                        {
                            "area_id": 25371,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "木棠镇",
                            "whole_name": "木棠镇，儋州市，海南省",
                            "simple_py": "MTZ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.33",
                            "latitude": "19.8594"
                        },
                        {
                            "area_id": 25374,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "南丰镇",
                            "whole_name": "南丰镇，儋州市，海南省",
                            "simple_py": "NFZ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.532",
                            "latitude": "19.4981"
                        },
                        {
                            "area_id": 25381,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "那大镇",
                            "whole_name": "那大镇，儋州市，海南省",
                            "simple_py": "NDZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.573",
                            "latitude": "19.5907"
                        },
                        {
                            "area_id": 25375,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "排浦镇",
                            "whole_name": "排浦镇，儋州市，海南省",
                            "simple_py": "PPZ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.196",
                            "latitude": "19.65"
                        },
                        {
                            "area_id": 25384,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "三都镇",
                            "whole_name": "三都镇，儋州市，海南省",
                            "simple_py": "SDZ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.176",
                            "latitude": "19.7946"
                        },
                        {
                            "area_id": 25370,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "王五镇",
                            "whole_name": "王五镇，儋州市，海南省",
                            "simple_py": "WWZ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.258",
                            "latitude": "19.6415"
                        },
                        {
                            "area_id": 25373,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "新州镇",
                            "whole_name": "新州镇，儋州市，海南省",
                            "simple_py": "XZZ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.321",
                            "latitude": "19.7523"
                        },
                        {
                            "area_id": 25362,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "洋浦经济开发区",
                            "whole_name": "洋浦经济开发区，儋州市，海南省",
                            "simple_py": "YPJJKFQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.162",
                            "latitude": "19.7962"
                        },
                        {
                            "area_id": 25377,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "雅星镇",
                            "whole_name": "雅星镇，儋州市，海南省",
                            "simple_py": "YXZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.156",
                            "latitude": "19.4695"
                        },
                        {
                            "area_id": 25369,
                            "city_id": 25132,
                            "province_id": 17,
                            "name": "中和镇",
                            "whole_name": "中和镇，儋州市，海南省",
                            "simple_py": "ZHZ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0898",
                            "area_code": "460400",
                            "longitude": "109.351",
                            "latitude": "19.7747"
                        }
                    ]
                },
                {
                    "city_id": 25133,
                    "province_id": 17,
                    "name": "海口市",
                    "whole_name": "海口市，海南省",
                    "simple_py": "HKS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0898",
                    "area_code": "460100",
                    "longitude": "110.33119",
                    "latitude": "20.031971",
                    "children": [
                        {
                            "area_id": 25385,
                            "city_id": 25133,
                            "province_id": 17,
                            "name": "龙华区",
                            "whole_name": "龙华区，海口市，海南省",
                            "simple_py": "LHQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "460106",
                            "longitude": "110.330373",
                            "latitude": "20.031026"
                        },
                        {
                            "area_id": 25386,
                            "city_id": 25133,
                            "province_id": 17,
                            "name": "美兰区",
                            "whole_name": "美兰区，海口市，海南省",
                            "simple_py": "MLQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0898",
                            "area_code": "460108",
                            "longitude": "110.356566",
                            "latitude": "20.03074"
                        },
                        {
                            "area_id": 25387,
                            "city_id": 25133,
                            "province_id": 17,
                            "name": "琼山区",
                            "whole_name": "琼山区，海口市，海南省",
                            "simple_py": "QSQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0898",
                            "area_code": "460107",
                            "longitude": "110.354722",
                            "latitude": "20.001051"
                        },
                        {
                            "area_id": 25388,
                            "city_id": 25133,
                            "province_id": 17,
                            "name": "秀英区",
                            "whole_name": "秀英区，海口市，海南省",
                            "simple_py": "XYQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0898",
                            "area_code": "460105",
                            "longitude": "110.282393",
                            "latitude": "20.008145"
                        }
                    ]
                },
                {
                    "city_id": 25120,
                    "province_id": 17,
                    "name": "临高县",
                    "whole_name": "临高县，海南省",
                    "simple_py": "LGX",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0898",
                    "area_code": "469024",
                    "longitude": "109.687697",
                    "latitude": "19.908293",
                    "children": [
                        {
                            "area_id": 25200,
                            "city_id": 25120,
                            "province_id": 17,
                            "name": "博厚镇",
                            "whole_name": "博厚镇，临高县，海南省",
                            "simple_py": "BHZ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0898",
                            "area_code": "469024",
                            "longitude": "109.716",
                            "latitude": "19.893"
                        },
                        {
                            "area_id": 25204,
                            "city_id": 25120,
                            "province_id": 17,
                            "name": "波莲镇",
                            "whole_name": "波莲镇，临高县，海南省",
                            "simple_py": "BLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0898",
                            "area_code": "469024",
                            "longitude": "109.615",
                            "latitude": "19.8555"
                        },
                        {
                            "area_id": 25202,
                            "city_id": 25120,
                            "province_id": 17,
                            "name": "东英镇",
                            "whole_name": "东英镇，临高县，海南省",
                            "simple_py": "DYZ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469024",
                            "longitude": "109.613",
                            "latitude": "19.9349"
                        },
                        {
                            "area_id": 25205,
                            "city_id": 25120,
                            "province_id": 17,
                            "name": "多文镇",
                            "whole_name": "多文镇，临高县，海南省",
                            "simple_py": "DWZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469024",
                            "longitude": "109.802",
                            "latitude": "19.7418"
                        },
                        {
                            "area_id": 25206,
                            "city_id": 25120,
                            "province_id": 17,
                            "name": "国营加来农场",
                            "whole_name": "国营加来农场，临高县，海南省",
                            "simple_py": "GYJLNC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469024",
                            "longitude": "109.651",
                            "latitude": "19.7591"
                        },
                        {
                            "area_id": 25210,
                            "city_id": 25120,
                            "province_id": 17,
                            "name": "国营红华农场",
                            "whole_name": "国营红华农场，临高县，海南省",
                            "simple_py": "GYHHNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469024",
                            "longitude": "109.764",
                            "latitude": "19.8244"
                        },
                        {
                            "area_id": 25201,
                            "city_id": 25120,
                            "province_id": 17,
                            "name": "和舍镇",
                            "whole_name": "和舍镇，临高县，海南省",
                            "simple_py": "HSZ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469024",
                            "longitude": "109.715",
                            "latitude": "19.6717"
                        },
                        {
                            "area_id": 25209,
                            "city_id": 25120,
                            "province_id": 17,
                            "name": "皇桐镇",
                            "whole_name": "皇桐镇，临高县，海南省",
                            "simple_py": "HTZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469024",
                            "longitude": "109.816",
                            "latitude": "19.8743"
                        },
                        {
                            "area_id": 25208,
                            "city_id": 25120,
                            "province_id": 17,
                            "name": "临城镇",
                            "whole_name": "临城镇，临高县，海南省",
                            "simple_py": "LCZ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469024",
                            "longitude": "109.673",
                            "latitude": "19.8932"
                        },
                        {
                            "area_id": 25199,
                            "city_id": 25120,
                            "province_id": 17,
                            "name": "南宝镇",
                            "whole_name": "南宝镇，临高县，海南省",
                            "simple_py": "NBZ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0898",
                            "area_code": "469024",
                            "longitude": "109.638",
                            "latitude": "19.7516"
                        },
                        {
                            "area_id": 25203,
                            "city_id": 25120,
                            "province_id": 17,
                            "name": "调楼镇",
                            "whole_name": "调楼镇，临高县，海南省",
                            "simple_py": "TLZ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0898",
                            "area_code": "469024",
                            "longitude": "109.61",
                            "latitude": "19.9231"
                        },
                        {
                            "area_id": 25207,
                            "city_id": 25120,
                            "province_id": 17,
                            "name": "新盈镇",
                            "whole_name": "新盈镇，临高县，海南省",
                            "simple_py": "XYZ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0898",
                            "area_code": "469024",
                            "longitude": "109.624",
                            "latitude": "19.8719"
                        }
                    ]
                },
                {
                    "city_id": 25128,
                    "province_id": 17,
                    "name": "陵水黎族自治县",
                    "whole_name": "陵水黎族自治县，海南省",
                    "simple_py": "LSLZZZX",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "L",
                    "city_code": "0898",
                    "area_code": "469028",
                    "longitude": "110.037218",
                    "latitude": "18.505006",
                    "children": [
                        {
                            "area_id": 25304,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "本号镇",
                            "whole_name": "本号镇，陵水黎族自治县，海南省",
                            "simple_py": "BHZ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "109.856",
                            "latitude": "18.6617"
                        },
                        {
                            "area_id": 25303,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "国营吊罗山林业公司",
                            "whole_name": "国营吊罗山林业公司，陵水黎族自治县，海南省",
                            "simple_py": "GYDLSLYGS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "109.948",
                            "latitude": "18.6553"
                        },
                        {
                            "area_id": 25305,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "光坡镇",
                            "whole_name": "光坡镇，陵水黎族自治县，海南省",
                            "simple_py": "GPZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "110.04",
                            "latitude": "18.5564"
                        },
                        {
                            "area_id": 25307,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "国营南平农场",
                            "whole_name": "国营南平农场，陵水黎族自治县，海南省",
                            "simple_py": "GYNPNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "109.833",
                            "latitude": "18.6336"
                        },
                        {
                            "area_id": 25311,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "国营岭门农场",
                            "whole_name": "国营岭门农场，陵水黎族自治县，海南省",
                            "simple_py": "GYLMNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "110.046",
                            "latitude": "18.6244"
                        },
                        {
                            "area_id": 25300,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "黎安镇",
                            "whole_name": "黎安镇，陵水黎族自治县，海南省",
                            "simple_py": "LAZ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "110.146",
                            "latitude": "18.4342"
                        },
                        {
                            "area_id": 25308,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "隆广镇",
                            "whole_name": "隆广镇，陵水黎族自治县，海南省",
                            "simple_py": "LGZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "109.858",
                            "latitude": "18.4802"
                        },
                        {
                            "area_id": 25301,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "群英乡",
                            "whole_name": "群英乡，陵水黎族自治县，海南省",
                            "simple_py": "QYX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "109.847",
                            "latitude": "18.5697"
                        },
                        {
                            "area_id": 25310,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "三才镇",
                            "whole_name": "三才镇，陵水黎族自治县，海南省",
                            "simple_py": "SCZ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "109.963",
                            "latitude": "18.4915"
                        },
                        {
                            "area_id": 25309,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "提蒙乡",
                            "whole_name": "提蒙乡，陵水黎族自治县，海南省",
                            "simple_py": "TMX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "110.013",
                            "latitude": "18.6404"
                        },
                        {
                            "area_id": 25306,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "文罗镇",
                            "whole_name": "文罗镇，陵水黎族自治县，海南省",
                            "simple_py": "WLZ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "109.914",
                            "latitude": "18.5734"
                        },
                        {
                            "area_id": 25302,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "新村镇",
                            "whole_name": "新村镇，陵水黎族自治县，海南省",
                            "simple_py": "XCZ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "110.026",
                            "latitude": "18.446"
                        },
                        {
                            "area_id": 25299,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "椰林镇",
                            "whole_name": "椰林镇，陵水黎族自治县，海南省",
                            "simple_py": "YLZ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "110.02",
                            "latitude": "18.4825"
                        },
                        {
                            "area_id": 25312,
                            "city_id": 25128,
                            "province_id": 17,
                            "name": "英州镇",
                            "whole_name": "英州镇，陵水黎族自治县，海南省",
                            "simple_py": "YZZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0898",
                            "area_code": "469028",
                            "longitude": "109.876",
                            "latitude": "18.4739"
                        }
                    ]
                },
                {
                    "city_id": 25131,
                    "province_id": 17,
                    "name": "乐东黎族自治县",
                    "whole_name": "乐东黎族自治县，海南省",
                    "simple_py": "LDLZZZX",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "L",
                    "city_code": "0898",
                    "area_code": "469027",
                    "longitude": "109.175444",
                    "latitude": "18.74758",
                    "children": [
                        {
                            "area_id": 25352,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "抱由镇",
                            "whole_name": "抱由镇，乐东黎族自治县，海南省",
                            "simple_py": "BYZ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "109.138",
                            "latitude": "18.8948"
                        },
                        {
                            "area_id": 25356,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "大安镇",
                            "whole_name": "大安镇，乐东黎族自治县，海南省",
                            "simple_py": "DAZ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "109.225",
                            "latitude": "18.5876"
                        },
                        {
                            "area_id": 25357,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "佛罗镇",
                            "whole_name": "佛罗镇，乐东黎族自治县，海南省",
                            "simple_py": "FLZ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "108.792",
                            "latitude": "18.5833"
                        },
                        {
                            "area_id": 25346,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "国营山荣农场",
                            "whole_name": "国营山荣农场，乐东黎族自治县，海南省",
                            "simple_py": "GYSRNC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "109.223",
                            "latitude": "18.7507"
                        },
                        {
                            "area_id": 25348,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "国营乐光农场",
                            "whole_name": "国营乐光农场，乐东黎族自治县，海南省",
                            "simple_py": "GYLGNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "109.192",
                            "latitude": "18.5331"
                        },
                        {
                            "area_id": 25351,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "国营保国农场",
                            "whole_name": "国营保国农场，乐东黎族自治县，海南省",
                            "simple_py": "GYBGNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "109.245",
                            "latitude": "18.6612"
                        },
                        {
                            "area_id": 25354,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "国营莺歌海盐场",
                            "whole_name": "国营莺歌海盐场，乐东黎族自治县，海南省",
                            "simple_py": "GYYGHYC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "108.729",
                            "latitude": "18.5523"
                        },
                        {
                            "area_id": 25361,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "国营尖峰岭林业公司",
                            "whole_name": "国营尖峰岭林业公司，乐东黎族自治县，海南省",
                            "simple_py": "GYJFLLYGS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "109.027",
                            "latitude": "18.726"
                        },
                        {
                            "area_id": 25355,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "黄流镇",
                            "whole_name": "黄流镇，乐东黎族自治县，海南省",
                            "simple_py": "HLZ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "108.808",
                            "latitude": "18.597"
                        },
                        {
                            "area_id": 25353,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "九所镇",
                            "whole_name": "九所镇，乐东黎族自治县，海南省",
                            "simple_py": "JSZ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "108.927",
                            "latitude": "18.5276"
                        },
                        {
                            "area_id": 25358,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "尖峰镇",
                            "whole_name": "尖峰镇，乐东黎族自治县，海南省",
                            "simple_py": "JFZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "108.7",
                            "latitude": "18.7124"
                        },
                        {
                            "area_id": 25350,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "利国镇",
                            "whole_name": "利国镇，乐东黎族自治县，海南省",
                            "simple_py": "LGZ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "108.965",
                            "latitude": "18.529"
                        },
                        {
                            "area_id": 25359,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "千家镇",
                            "whole_name": "千家镇，乐东黎族自治县，海南省",
                            "simple_py": "QJZ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "109.15",
                            "latitude": "18.6353"
                        },
                        {
                            "area_id": 25349,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "万冲镇",
                            "whole_name": "万冲镇，乐东黎族自治县，海南省",
                            "simple_py": "WCZ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "109.339",
                            "latitude": "18.7838"
                        },
                        {
                            "area_id": 25347,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "莺歌海镇",
                            "whole_name": "莺歌海镇，乐东黎族自治县，海南省",
                            "simple_py": "YGHZ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "108.728",
                            "latitude": "18.4959"
                        },
                        {
                            "area_id": 25360,
                            "city_id": 25131,
                            "province_id": 17,
                            "name": "志仲镇",
                            "whole_name": "志仲镇，乐东黎族自治县，海南省",
                            "simple_py": "ZZZ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0898",
                            "area_code": "469027",
                            "longitude": "109.224",
                            "latitude": "18.5932"
                        }
                    ]
                },
                {
                    "city_id": 25116,
                    "province_id": 17,
                    "name": "琼海市",
                    "whole_name": "琼海市，海南省",
                    "simple_py": "QHS",
                    "per_pin_yin": "Q",
                    "per_pin_yin2": "Q",
                    "city_code": "0898",
                    "area_code": "469002",
                    "longitude": "110.466785",
                    "latitude": "19.246011",
                    "children": [
                        {
                            "area_id": 25148,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "彬村山华侨农场",
                            "whole_name": "彬村山华侨农场，琼海市，海南省",
                            "simple_py": "BCSHQNC",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.623",
                            "latitude": "19.3022"
                        },
                        {
                            "area_id": 25157,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "博鳌镇",
                            "whole_name": "博鳌镇，琼海市，海南省",
                            "simple_py": "BAZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.5",
                            "latitude": "19.1754"
                        },
                        {
                            "area_id": 25154,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "长坡镇",
                            "whole_name": "长坡镇，琼海市，海南省",
                            "simple_py": "CPZ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.594",
                            "latitude": "19.3213"
                        },
                        {
                            "area_id": 25150,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "大路镇",
                            "whole_name": "大路镇，琼海市，海南省",
                            "simple_py": "DLZ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.424",
                            "latitude": "19.354"
                        },
                        {
                            "area_id": 25146,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "国营东升农场",
                            "whole_name": "国营东升农场，琼海市，海南省",
                            "simple_py": "GYDSNC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.413",
                            "latitude": "19.284"
                        },
                        {
                            "area_id": 25147,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "国营东太农场",
                            "whole_name": "国营东太农场，琼海市，海南省",
                            "simple_py": "GYDTNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.367",
                            "latitude": "19.1372"
                        },
                        {
                            "area_id": 25152,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "国营东红农场",
                            "whole_name": "国营东红农场，琼海市，海南省",
                            "simple_py": "GYDHNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.509",
                            "latitude": "19.364"
                        },
                        {
                            "area_id": 25145,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "会山镇",
                            "whole_name": "会山镇，琼海市，海南省",
                            "simple_py": "HSZ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.302",
                            "latitude": "19.0792"
                        },
                        {
                            "area_id": 25144,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "嘉积镇",
                            "whole_name": "嘉积镇，琼海市，海南省",
                            "simple_py": "JJZ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.441",
                            "latitude": "19.3208"
                        },
                        {
                            "area_id": 25155,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "龙江镇",
                            "whole_name": "龙江镇，琼海市，海南省",
                            "simple_py": "LJZ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.36",
                            "latitude": "19.1595"
                        },
                        {
                            "area_id": 25159,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "石壁镇",
                            "whole_name": "石壁镇，琼海市，海南省",
                            "simple_py": "SBZ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.168",
                            "latitude": "19.167"
                        },
                        {
                            "area_id": 25151,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "潭门镇",
                            "whole_name": "潭门镇，琼海市，海南省",
                            "simple_py": "TMZ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.546",
                            "latitude": "19.2013"
                        },
                        {
                            "area_id": 25156,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "塔洋镇",
                            "whole_name": "塔洋镇，琼海市，海南省",
                            "simple_py": "TYZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.475",
                            "latitude": "19.3404"
                        },
                        {
                            "area_id": 25149,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "万泉镇",
                            "whole_name": "万泉镇，琼海市，海南省",
                            "simple_py": "WQZ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.364",
                            "latitude": "19.2516"
                        },
                        {
                            "area_id": 25158,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "阳江镇",
                            "whole_name": "阳江镇，琼海市，海南省",
                            "simple_py": "YJZ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.334",
                            "latitude": "19.0558"
                        },
                        {
                            "area_id": 25153,
                            "city_id": 25116,
                            "province_id": 17,
                            "name": "中原镇",
                            "whole_name": "中原镇，琼海市，海南省",
                            "simple_py": "ZYZ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0898",
                            "area_code": "469002",
                            "longitude": "110.419",
                            "latitude": "19.1765"
                        }
                    ]
                },
                {
                    "city_id": 25119,
                    "province_id": 17,
                    "name": "琼中黎族苗族自治县",
                    "whole_name": "琼中黎族苗族自治县，海南省",
                    "simple_py": "QZLZMZZZX",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Q",
                    "city_code": "0898",
                    "area_code": "469030",
                    "longitude": "109.839996",
                    "latitude": "19.03557",
                    "children": [
                        {
                            "area_id": 25198,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "长征镇",
                            "whole_name": "长征镇，琼中黎族苗族自治县，海南省",
                            "simple_py": "CZZ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.799",
                            "latitude": "18.8976"
                        },
                        {
                            "area_id": 25184,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "吊罗山乡",
                            "whole_name": "吊罗山乡，琼中黎族苗族自治县，海南省",
                            "simple_py": "DLSX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.917",
                            "latitude": "18.8198"
                        },
                        {
                            "area_id": 25185,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "国营加钗农场",
                            "whole_name": "国营加钗农场，琼中黎族苗族自治县，海南省",
                            "simple_py": "GYJCNC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.783",
                            "latitude": "19.0265"
                        },
                        {
                            "area_id": 25187,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "国营乌石农场",
                            "whole_name": "国营乌石农场，琼中黎族苗族自治县，海南省",
                            "simple_py": "GYWSNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.937",
                            "latitude": "19.0977"
                        },
                        {
                            "area_id": 25190,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "国营阳江农场",
                            "whole_name": "国营阳江农场，琼中黎族苗族自治县，海南省",
                            "simple_py": "GYYJNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.823",
                            "latitude": "19.2127"
                        },
                        {
                            "area_id": 25191,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "国营黎母山林业公司",
                            "whole_name": "国营黎母山林业公司，琼中黎族苗族自治县，海南省",
                            "simple_py": "GYLMSLYGS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.703",
                            "latitude": "19.1542"
                        },
                        {
                            "area_id": 25196,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "国营长征农场",
                            "whole_name": "国营长征农场，琼中黎族苗族自治县，海南省",
                            "simple_py": "GYCZNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.899",
                            "latitude": "18.9965"
                        },
                        {
                            "area_id": 25186,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "和平镇",
                            "whole_name": "和平镇，琼中黎族苗族自治县，海南省",
                            "simple_py": "HPZ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.894",
                            "latitude": "18.899"
                        },
                        {
                            "area_id": 25197,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "红毛镇",
                            "whole_name": "红毛镇，琼中黎族苗族自治县，海南省",
                            "simple_py": "HMZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.734",
                            "latitude": "19.0657"
                        },
                        {
                            "area_id": 25195,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "黎母山镇",
                            "whole_name": "黎母山镇，琼中黎族苗族自治县，海南省",
                            "simple_py": "LMSZ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.704",
                            "latitude": "19.2577"
                        },
                        {
                            "area_id": 25188,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "什运乡",
                            "whole_name": "什运乡，琼中黎族苗族自治县，海南省",
                            "simple_py": "SYX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.583",
                            "latitude": "18.9237"
                        },
                        {
                            "area_id": 25193,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "上安乡",
                            "whole_name": "上安乡，琼中黎族苗族自治县，海南省",
                            "simple_py": "SAX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.731",
                            "latitude": "18.9133"
                        },
                        {
                            "area_id": 25189,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "湾岭镇",
                            "whole_name": "湾岭镇，琼中黎族苗族自治县，海南省",
                            "simple_py": "WLZ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.9",
                            "latitude": "19.1334"
                        },
                        {
                            "area_id": 25192,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "营根镇",
                            "whole_name": "营根镇，琼中黎族苗族自治县，海南省",
                            "simple_py": "YGZ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "109.733",
                            "latitude": "18.9748"
                        },
                        {
                            "area_id": 25194,
                            "city_id": 25119,
                            "province_id": 17,
                            "name": "中平镇",
                            "whole_name": "中平镇，琼中黎族苗族自治县，海南省",
                            "simple_py": "ZPZ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0898",
                            "area_code": "469030",
                            "longitude": "110.107",
                            "latitude": "19.0716"
                        }
                    ]
                },
                {
                    "city_id": 25127,
                    "province_id": 17,
                    "name": "三沙市",
                    "whole_name": "三沙市，海南省",
                    "simple_py": "SSS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0898",
                    "area_code": "460300",
                    "longitude": "112.34882",
                    "latitude": "16.831039",
                    "children": [
                        {
                            "area_id": 25296,
                            "city_id": 25127,
                            "province_id": 17,
                            "name": "南沙群岛",
                            "whole_name": "南沙群岛，三沙市，海南省",
                            "simple_py": "NSQD",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0898",
                            "area_code": "460322",
                            "longitude": "116.749998",
                            "latitude": "11.471888"
                        },
                        {
                            "area_id": 25295,
                            "city_id": 25127,
                            "province_id": 17,
                            "name": "西沙群岛",
                            "whole_name": "西沙群岛，三沙市，海南省",
                            "simple_py": "XSQD",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0898",
                            "area_code": "460321",
                            "longitude": "111.792944",
                            "latitude": "16.204546"
                        },
                        {
                            "area_id": 25297,
                            "city_id": 25127,
                            "province_id": 17,
                            "name": "中沙群岛的岛礁及其海域",
                            "whole_name": "中沙群岛的岛礁及其海域，三沙市，海南省",
                            "simple_py": "ZSQDDDJJQHY",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0898",
                            "area_code": "460323",
                            "longitude": "117.740071",
                            "latitude": "15.112856"
                        }
                    ]
                },
                {
                    "city_id": 25129,
                    "province_id": 17,
                    "name": "三亚市",
                    "whole_name": "三亚市，海南省",
                    "simple_py": "SYS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "S",
                    "city_code": "0898",
                    "area_code": "460200",
                    "longitude": "109.508268",
                    "latitude": "18.247872",
                    "children": [
                        {
                            "area_id": 25315,
                            "city_id": 25129,
                            "province_id": 17,
                            "name": "海棠区",
                            "whole_name": "海棠区，三亚市，海南省",
                            "simple_py": "HTQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "460202",
                            "longitude": "109.760778",
                            "latitude": "18.407516"
                        },
                        {
                            "area_id": 25316,
                            "city_id": 25129,
                            "province_id": 17,
                            "name": "吉阳区",
                            "whole_name": "吉阳区，三亚市，海南省",
                            "simple_py": "JYQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0898",
                            "area_code": "460203",
                            "longitude": "109.512081",
                            "latitude": "18.247436"
                        },
                        {
                            "area_id": 25314,
                            "city_id": 25129,
                            "province_id": 17,
                            "name": "天涯区",
                            "whole_name": "天涯区，三亚市，海南省",
                            "simple_py": "TYQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0898",
                            "area_code": "460204",
                            "longitude": "109.506357",
                            "latitude": "18.24734"
                        },
                        {
                            "area_id": 25313,
                            "city_id": 25129,
                            "province_id": 17,
                            "name": "崖州区",
                            "whole_name": "崖州区，三亚市，海南省",
                            "simple_py": "YZQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0898",
                            "area_code": "460205",
                            "longitude": "109.174306",
                            "latitude": "18.352192"
                        }
                    ]
                },
                {
                    "city_id": 25115,
                    "province_id": 17,
                    "name": "屯昌县",
                    "whole_name": "屯昌县，海南省",
                    "simple_py": "TCX",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0898",
                    "area_code": "469022",
                    "longitude": "110.102773",
                    "latitude": "19.362916",
                    "children": [
                        {
                            "area_id": 25141,
                            "city_id": 25115,
                            "province_id": 17,
                            "name": "枫木镇",
                            "whole_name": "枫木镇，屯昌县，海南省",
                            "simple_py": "FMZ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0898",
                            "area_code": "469022",
                            "longitude": "109.994",
                            "latitude": "19.1901"
                        },
                        {
                            "area_id": 25134,
                            "city_id": 25115,
                            "province_id": 17,
                            "name": "国营中建农场",
                            "whole_name": "国营中建农场，屯昌县，海南省",
                            "simple_py": "GYZJNC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469022",
                            "longitude": "109.966",
                            "latitude": "19.2466"
                        },
                        {
                            "area_id": 25139,
                            "city_id": 25115,
                            "province_id": 17,
                            "name": "国营中坤农场",
                            "whole_name": "国营中坤农场，屯昌县，海南省",
                            "simple_py": "GYZKNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469022",
                            "longitude": "109.855",
                            "latitude": "19.2944"
                        },
                        {
                            "area_id": 25136,
                            "city_id": 25115,
                            "province_id": 17,
                            "name": "南吕镇",
                            "whole_name": "南吕镇，屯昌县，海南省",
                            "simple_py": "NLZ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0898",
                            "area_code": "469022",
                            "longitude": "110.05",
                            "latitude": "19.2222"
                        },
                        {
                            "area_id": 25142,
                            "city_id": 25115,
                            "province_id": 17,
                            "name": "南坤镇",
                            "whole_name": "南坤镇，屯昌县，海南省",
                            "simple_py": "NKZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0898",
                            "area_code": "469022",
                            "longitude": "109.857",
                            "latitude": "19.2939"
                        },
                        {
                            "area_id": 25137,
                            "city_id": 25115,
                            "province_id": 17,
                            "name": "坡心镇",
                            "whole_name": "坡心镇，屯昌县，海南省",
                            "simple_py": "PXZ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0898",
                            "area_code": "469022",
                            "longitude": "110.11",
                            "latitude": "19.3302"
                        },
                        {
                            "area_id": 25135,
                            "city_id": 25115,
                            "province_id": 17,
                            "name": "屯城镇",
                            "whole_name": "屯城镇，屯昌县，海南省",
                            "simple_py": "TCZ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0898",
                            "area_code": "469022",
                            "longitude": "110.161",
                            "latitude": "19.4468"
                        },
                        {
                            "area_id": 25143,
                            "city_id": 25115,
                            "province_id": 17,
                            "name": "乌坡镇",
                            "whole_name": "乌坡镇，屯昌县，海南省",
                            "simple_py": "WPZ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0898",
                            "area_code": "469022",
                            "longitude": "110.093",
                            "latitude": "19.1953"
                        },
                        {
                            "area_id": 25138,
                            "city_id": 25115,
                            "province_id": 17,
                            "name": "新兴镇",
                            "whole_name": "新兴镇，屯昌县，海南省",
                            "simple_py": "XXZ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0898",
                            "area_code": "469022",
                            "longitude": "110.154",
                            "latitude": "19.5707"
                        },
                        {
                            "area_id": 25140,
                            "city_id": 25115,
                            "province_id": 17,
                            "name": "西昌镇",
                            "whole_name": "西昌镇，屯昌县，海南省",
                            "simple_py": "XCZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0898",
                            "area_code": "469022",
                            "longitude": "110.024",
                            "latitude": "19.4428"
                        }
                    ]
                },
                {
                    "city_id": 25123,
                    "province_id": 17,
                    "name": "文昌市",
                    "whole_name": "文昌市，海南省",
                    "simple_py": "WCS",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "0898",
                    "area_code": "469005",
                    "longitude": "110.753975",
                    "latitude": "19.612986",
                    "children": [
                        {
                            "area_id": 25252,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "抱罗镇",
                            "whole_name": "抱罗镇，文昌市，海南省",
                            "simple_py": "BLZ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.73",
                            "latitude": "19.889"
                        },
                        {
                            "area_id": 25249,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "昌洒镇",
                            "whole_name": "昌洒镇，文昌市，海南省",
                            "simple_py": "CSZ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "111.26",
                            "latitude": "19.9626"
                        },
                        {
                            "area_id": 25237,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "东阁镇",
                            "whole_name": "东阁镇，文昌市，海南省",
                            "simple_py": "DGZ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.799",
                            "latitude": "19.7566"
                        },
                        {
                            "area_id": 25243,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "东郊镇",
                            "whole_name": "东郊镇，文昌市，海南省",
                            "simple_py": "DJZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.91",
                            "latitude": "19.6291"
                        },
                        {
                            "area_id": 25254,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "东路镇",
                            "whole_name": "东路镇，文昌市，海南省",
                            "simple_py": "DLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.658",
                            "latitude": "19.8051"
                        },
                        {
                            "area_id": 25247,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "冯坡镇",
                            "whole_name": "冯坡镇，文昌市，海南省",
                            "simple_py": "FPZ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.774",
                            "latitude": "20.0176"
                        },
                        {
                            "area_id": 25238,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "国营罗豆农场",
                            "whole_name": "国营罗豆农场，文昌市，海南省",
                            "simple_py": "GYLDNC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.624",
                            "latitude": "19.9713"
                        },
                        {
                            "area_id": 25244,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "国营东路农场",
                            "whole_name": "国营东路农场，文昌市，海南省",
                            "simple_py": "GYDLNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.714",
                            "latitude": "19.8524"
                        },
                        {
                            "area_id": 25248,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "国营南阳农场",
                            "whole_name": "国营南阳农场，文昌市，海南省",
                            "simple_py": "GYNYNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.556",
                            "latitude": "19.4727"
                        },
                        {
                            "area_id": 25250,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "公坡镇",
                            "whole_name": "公坡镇，文昌市，海南省",
                            "simple_py": "GPZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.836",
                            "latitude": "19.8543"
                        },
                        {
                            "area_id": 25240,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "会文镇",
                            "whole_name": "会文镇，文昌市，海南省",
                            "simple_py": "HWZ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.708",
                            "latitude": "19.4957"
                        },
                        {
                            "area_id": 25241,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "锦山镇",
                            "whole_name": "锦山镇，文昌市，海南省",
                            "simple_py": "JSZ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.67",
                            "latitude": "20.0418"
                        },
                        {
                            "area_id": 25246,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "龙楼镇",
                            "whole_name": "龙楼镇，文昌市，海南省",
                            "simple_py": "LLZ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.938",
                            "latitude": "19.6606"
                        },
                        {
                            "area_id": 25245,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "铺前镇",
                            "whole_name": "铺前镇，文昌市，海南省",
                            "simple_py": "PQZ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.675",
                            "latitude": "20.0377"
                        },
                        {
                            "area_id": 25251,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "蓬莱镇",
                            "whole_name": "蓬莱镇，文昌市，海南省",
                            "simple_py": "PLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "P",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.638",
                            "latitude": "19.5164"
                        },
                        {
                            "area_id": 25253,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "潭牛镇",
                            "whole_name": "潭牛镇，文昌市，海南省",
                            "simple_py": "TNZ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.623",
                            "latitude": "19.6785"
                        },
                        {
                            "area_id": 25239,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "文教镇",
                            "whole_name": "文教镇，文昌市，海南省",
                            "simple_py": "WJZ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.856",
                            "latitude": "19.7083"
                        },
                        {
                            "area_id": 25242,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "翁田镇",
                            "whole_name": "翁田镇，文昌市，海南省",
                            "simple_py": "WTZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.813",
                            "latitude": "19.9295"
                        },
                        {
                            "area_id": 25255,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "文城镇",
                            "whole_name": "文城镇，文昌市，海南省",
                            "simple_py": "WCZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.708",
                            "latitude": "19.4982"
                        },
                        {
                            "area_id": 25256,
                            "city_id": 25123,
                            "province_id": 17,
                            "name": "重兴镇",
                            "whole_name": "重兴镇，文昌市，海南省",
                            "simple_py": "ZXZ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0898",
                            "area_code": "469005",
                            "longitude": "110.654",
                            "latitude": "19.4341"
                        }
                    ]
                },
                {
                    "city_id": 25124,
                    "province_id": 17,
                    "name": "五指山市",
                    "whole_name": "五指山市，海南省",
                    "simple_py": "WZSS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "W",
                    "city_code": "0898",
                    "area_code": "469001",
                    "longitude": "109.516662",
                    "latitude": "18.776921",
                    "children": [
                        {
                            "area_id": 25263,
                            "city_id": 25124,
                            "province_id": 17,
                            "name": "畅好乡",
                            "whole_name": "畅好乡，五指山市，海南省",
                            "simple_py": "CHX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0898",
                            "area_code": "469001",
                            "longitude": "109.407",
                            "latitude": "18.6294"
                        },
                        {
                            "area_id": 25260,
                            "city_id": 25124,
                            "province_id": 17,
                            "name": "番阳镇",
                            "whole_name": "番阳镇，五指山市，海南省",
                            "simple_py": "FYZ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0898",
                            "area_code": "469001",
                            "longitude": "109.334",
                            "latitude": "18.9132"
                        },
                        {
                            "area_id": 25259,
                            "city_id": 25124,
                            "province_id": 17,
                            "name": "国营畅好农场",
                            "whole_name": "国营畅好农场，五指山市，海南省",
                            "simple_py": "GYCHNC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469001",
                            "longitude": "109.541",
                            "latitude": "18.7112"
                        },
                        {
                            "area_id": 25258,
                            "city_id": 25124,
                            "province_id": 17,
                            "name": "毛阳镇",
                            "whole_name": "毛阳镇，五指山市，海南省",
                            "simple_py": "MYZ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0898",
                            "area_code": "469001",
                            "longitude": "109.45",
                            "latitude": "18.8811"
                        },
                        {
                            "area_id": 25264,
                            "city_id": 25124,
                            "province_id": 17,
                            "name": "毛道乡",
                            "whole_name": "毛道乡，五指山市，海南省",
                            "simple_py": "MDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0898",
                            "area_code": "469001",
                            "longitude": "109.356",
                            "latitude": "18.7134"
                        },
                        {
                            "area_id": 25257,
                            "city_id": 25124,
                            "province_id": 17,
                            "name": "南圣镇",
                            "whole_name": "南圣镇，五指山市，海南省",
                            "simple_py": "NSZ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0898",
                            "area_code": "469001",
                            "longitude": "109.659",
                            "latitude": "18.841"
                        },
                        {
                            "area_id": 25261,
                            "city_id": 25124,
                            "province_id": 17,
                            "name": "水满乡",
                            "whole_name": "水满乡，五指山市，海南省",
                            "simple_py": "SMX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "469001",
                            "longitude": "109.601",
                            "latitude": "18.8995"
                        },
                        {
                            "area_id": 25262,
                            "city_id": 25124,
                            "province_id": 17,
                            "name": "通什镇",
                            "whole_name": "通什镇，五指山市，海南省",
                            "simple_py": "TSZ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0898",
                            "area_code": "469001",
                            "longitude": "109.614",
                            "latitude": "18.8418"
                        }
                    ]
                },
                {
                    "city_id": 25130,
                    "province_id": 17,
                    "name": "万宁市",
                    "whole_name": "万宁市，海南省",
                    "simple_py": "WNS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "W",
                    "city_code": "0898",
                    "area_code": "469006",
                    "longitude": "110.388793",
                    "latitude": "18.796216",
                    "children": [
                        {
                            "area_id": 25340,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "北大镇",
                            "whole_name": "北大镇，万宁市，海南省",
                            "simple_py": "BDZ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.24",
                            "latitude": "18.9316"
                        },
                        {
                            "area_id": 25341,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "长丰镇",
                            "whole_name": "长丰镇，万宁市，海南省",
                            "simple_py": "CFZ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.321",
                            "latitude": "18.7876"
                        },
                        {
                            "area_id": 25335,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "大茂镇",
                            "whole_name": "大茂镇，万宁市，海南省",
                            "simple_py": "DMZ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.39",
                            "latitude": "18.8759"
                        },
                        {
                            "area_id": 25342,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "地方国营六连林场",
                            "whole_name": "地方国营六连林场，万宁市，海南省",
                            "simple_py": "DFGYLLLC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.505",
                            "latitude": "18.9899"
                        },
                        {
                            "area_id": 25345,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "东澳镇",
                            "whole_name": "东澳镇，万宁市，海南省",
                            "simple_py": "DAZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.429",
                            "latitude": "18.6408"
                        },
                        {
                            "area_id": 25330,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "国营东兴农场",
                            "whole_name": "国营东兴农场，万宁市，海南省",
                            "simple_py": "GYDXNC",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.375",
                            "latitude": "18.894"
                        },
                        {
                            "area_id": 25332,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "国营东和农场",
                            "whole_name": "国营东和农场，万宁市，海南省",
                            "simple_py": "GYDHNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.217",
                            "latitude": "18.7629"
                        },
                        {
                            "area_id": 25343,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "国营新中农场",
                            "whole_name": "国营新中农场，万宁市，海南省",
                            "simple_py": "GYXZNC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.17",
                            "latitude": "18.6967"
                        },
                        {
                            "area_id": 25331,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "后安镇",
                            "whole_name": "后安镇，万宁市，海南省",
                            "simple_py": "HAZ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.374",
                            "latitude": "18.9087"
                        },
                        {
                            "area_id": 25334,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "和乐镇",
                            "whole_name": "和乐镇，万宁市，海南省",
                            "simple_py": "HLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.416",
                            "latitude": "18.9625"
                        },
                        {
                            "area_id": 25329,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "礼纪镇",
                            "whole_name": "礼纪镇，万宁市，海南省",
                            "simple_py": "LJZ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.269",
                            "latitude": "18.7354"
                        },
                        {
                            "area_id": 25337,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "龙滚镇",
                            "whole_name": "龙滚镇，万宁市，海南省",
                            "simple_py": "LGZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.451",
                            "latitude": "19.0536"
                        },
                        {
                            "area_id": 25344,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "南桥镇",
                            "whole_name": "南桥镇，万宁市，海南省",
                            "simple_py": "NQZ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.196",
                            "latitude": "18.7201"
                        },
                        {
                            "area_id": 25336,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "山根镇",
                            "whole_name": "山根镇，万宁市，海南省",
                            "simple_py": "SGZ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.483",
                            "latitude": "18.9946"
                        },
                        {
                            "area_id": 25339,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "三更罗镇",
                            "whole_name": "三更罗镇，万宁市，海南省",
                            "simple_py": "SGLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.214",
                            "latitude": "18.9979"
                        },
                        {
                            "area_id": 25333,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "万城镇",
                            "whole_name": "万城镇，万宁市，海南省",
                            "simple_py": "WCZ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.414",
                            "latitude": "18.8276"
                        },
                        {
                            "area_id": 25338,
                            "city_id": 25130,
                            "province_id": 17,
                            "name": "兴隆华侨农场",
                            "whole_name": "兴隆华侨农场，万宁市，海南省",
                            "simple_py": "XLHQNC",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0898",
                            "area_code": "469006",
                            "longitude": "110.106",
                            "latitude": "18.8195"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 24,
            "name": "河北省",
            "whole_name": "河北省",
            "simple_py": "HBS",
            "per_pin_yin": " ",
            "per_pin_yin2": "H",
            "city_code": "",
            "area_code": "130000",
            "longitude": "114.502461",
            "latitude": "38.045474",
            "children": [
                {
                    "city_id": 32528,
                    "province_id": 24,
                    "name": "保定市",
                    "whole_name": "保定市，河北省",
                    "simple_py": "BDS",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "0312",
                    "area_code": "130600",
                    "longitude": "115.482331",
                    "latitude": "38.867657",
                    "children": [
                        {
                            "area_id": 34343,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "安新县",
                            "whole_name": "安新县，保定市，河北省",
                            "simple_py": "AXX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0312",
                            "area_code": "130632",
                            "longitude": "115.931979",
                            "latitude": "38.929912"
                        },
                        {
                            "area_id": 34361,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "安国市",
                            "whole_name": "安国市，保定市，河北省",
                            "simple_py": "AGS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "A",
                            "city_code": "0312",
                            "area_code": "130683",
                            "longitude": "115.33141",
                            "latitude": "38.421367"
                        },
                        {
                            "area_id": 34352,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "博野县",
                            "whole_name": "博野县，保定市，河北省",
                            "simple_py": "BYX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0312",
                            "area_code": "130637",
                            "longitude": "115.461798",
                            "latitude": "38.458271"
                        },
                        {
                            "area_id": 34348,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "定兴县",
                            "whole_name": "定兴县，保定市，河北省",
                            "simple_py": "DXX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0312",
                            "area_code": "130626",
                            "longitude": "115.796895",
                            "latitude": "39.266195"
                        },
                        {
                            "area_id": 34362,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "定州市",
                            "whole_name": "定州市，保定市，河北省",
                            "simple_py": "DZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0312",
                            "area_code": "130682",
                            "longitude": "114.991389",
                            "latitude": "38.517602"
                        },
                        {
                            "area_id": 34340,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "阜平县",
                            "whole_name": "阜平县，保定市，河北省",
                            "simple_py": "FPX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0312",
                            "area_code": "130624",
                            "longitude": "114.198801",
                            "latitude": "38.847276"
                        },
                        {
                            "area_id": 34345,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "高阳县",
                            "whole_name": "高阳县，保定市，河北省",
                            "simple_py": "GYX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0312",
                            "area_code": "130628",
                            "longitude": "115.778878",
                            "latitude": "38.690092"
                        },
                        {
                            "area_id": 34357,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "高碑店市",
                            "whole_name": "高碑店市，保定市，河北省",
                            "simple_py": "GBDS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0312",
                            "area_code": "130684",
                            "longitude": "115.882704",
                            "latitude": "39.327689"
                        },
                        {
                            "area_id": 34353,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "竞秀区",
                            "whole_name": "竞秀区，保定市，河北省",
                            "simple_py": "JXQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0312",
                            "area_code": "130602",
                            "longitude": "115.470659",
                            "latitude": "38.88662"
                        },
                        {
                            "area_id": 34342,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "涞源县",
                            "whole_name": "涞源县，保定市，河北省",
                            "simple_py": "LYX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0312",
                            "area_code": "130630",
                            "longitude": "114.692567",
                            "latitude": "39.35755"
                        },
                        {
                            "area_id": 34350,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "莲池区",
                            "whole_name": "莲池区，保定市，河北省",
                            "simple_py": "LCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0312",
                            "area_code": "130606",
                            "longitude": "115.500934",
                            "latitude": "38.865005"
                        },
                        {
                            "area_id": 34351,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "蠡县",
                            "whole_name": "蠡县，保定市，河北省",
                            "simple_py": "LX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0312",
                            "area_code": "130635",
                            "longitude": "115.583631",
                            "latitude": "38.496429"
                        },
                        {
                            "area_id": 34355,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "涞水县",
                            "whole_name": "涞水县，保定市，河北省",
                            "simple_py": "LSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0312",
                            "area_code": "130623",
                            "longitude": "115.711985",
                            "latitude": "39.393148"
                        },
                        {
                            "area_id": 34359,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "满城区",
                            "whole_name": "满城区，保定市，河北省",
                            "simple_py": "MCQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0312",
                            "area_code": "130607",
                            "longitude": "115.32442",
                            "latitude": "38.95138"
                        },
                        {
                            "area_id": 34358,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "曲阳县",
                            "whole_name": "曲阳县，保定市，河北省",
                            "simple_py": "QYX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0312",
                            "area_code": "130634",
                            "longitude": "114.704055",
                            "latitude": "38.619992"
                        },
                        {
                            "area_id": 34360,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "清苑区",
                            "whole_name": "清苑区，保定市，河北省",
                            "simple_py": "QYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0312",
                            "area_code": "130608",
                            "longitude": "115.492221",
                            "latitude": "38.771012"
                        },
                        {
                            "area_id": 34341,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "容城县",
                            "whole_name": "容城县，保定市，河北省",
                            "simple_py": "RCX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0312",
                            "area_code": "130629",
                            "longitude": "115.866247",
                            "latitude": "39.05282"
                        },
                        {
                            "area_id": 34339,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "顺平县",
                            "whole_name": "顺平县，保定市，河北省",
                            "simple_py": "SPX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0312",
                            "area_code": "130636",
                            "longitude": "115.132749",
                            "latitude": "38.845127"
                        },
                        {
                            "area_id": 34354,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "唐县",
                            "whole_name": "唐县，保定市，河北省",
                            "simple_py": "TX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0312",
                            "area_code": "130627",
                            "longitude": "114.981241",
                            "latitude": "38.748542"
                        },
                        {
                            "area_id": 34344,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "望都县",
                            "whole_name": "望都县，保定市，河北省",
                            "simple_py": "WDX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0312",
                            "area_code": "130631",
                            "longitude": "115.154009",
                            "latitude": "38.707448"
                        },
                        {
                            "area_id": 34346,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "雄县",
                            "whole_name": "雄县，保定市，河北省",
                            "simple_py": "XX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0312",
                            "area_code": "130638",
                            "longitude": "116.107474",
                            "latitude": "38.990819"
                        },
                        {
                            "area_id": 34347,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "徐水区",
                            "whole_name": "徐水区，保定市，河北省",
                            "simple_py": "XSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0312",
                            "area_code": "130609",
                            "longitude": "115.64941",
                            "latitude": "39.020395"
                        },
                        {
                            "area_id": 34349,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "易县",
                            "whole_name": "易县，保定市，河北省",
                            "simple_py": "YX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0312",
                            "area_code": "130633",
                            "longitude": "115.501146",
                            "latitude": "39.35297"
                        },
                        {
                            "area_id": 34356,
                            "city_id": 32528,
                            "province_id": 24,
                            "name": "涿州市",
                            "whole_name": "涿州市，保定市，河北省",
                            "simple_py": "ZZS",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0312",
                            "area_code": "130681",
                            "longitude": "115.973409",
                            "latitude": "39.485765"
                        }
                    ]
                },
                {
                    "city_id": 32522,
                    "province_id": 24,
                    "name": "承德市",
                    "whole_name": "承德市，河北省",
                    "simple_py": "CDS",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0314",
                    "area_code": "130800",
                    "longitude": "117.939152",
                    "latitude": "40.976204",
                    "children": [
                        {
                            "area_id": 33270,
                            "city_id": 32522,
                            "province_id": 24,
                            "name": "承德县",
                            "whole_name": "承德县，承德市，河北省",
                            "simple_py": "CDX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0314",
                            "area_code": "130821",
                            "longitude": "118.172496",
                            "latitude": "40.768637"
                        },
                        {
                            "area_id": 33265,
                            "city_id": 32522,
                            "province_id": 24,
                            "name": "丰宁满族自治县",
                            "whole_name": "丰宁满族自治县，承德市，河北省",
                            "simple_py": "FNMZZZX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0314",
                            "area_code": "130826",
                            "longitude": "116.65121",
                            "latitude": "41.209903"
                        },
                        {
                            "area_id": 33262,
                            "city_id": 32522,
                            "province_id": 24,
                            "name": "宽城满族自治县",
                            "whole_name": "宽城满族自治县，承德市，河北省",
                            "simple_py": "KCMZZZX",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0314",
                            "area_code": "130827",
                            "longitude": "118.488642",
                            "latitude": "40.607981"
                        },
                        {
                            "area_id": 33263,
                            "city_id": 32522,
                            "province_id": 24,
                            "name": "隆化县",
                            "whole_name": "隆化县，承德市，河北省",
                            "simple_py": "LHX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0314",
                            "area_code": "130825",
                            "longitude": "117.736343",
                            "latitude": "41.316667"
                        },
                        {
                            "area_id": 33269,
                            "city_id": 32522,
                            "province_id": 24,
                            "name": "滦平县",
                            "whole_name": "滦平县，承德市，河北省",
                            "simple_py": "LPX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0314",
                            "area_code": "130824",
                            "longitude": "117.337124",
                            "latitude": "40.936644"
                        },
                        {
                            "area_id": 33266,
                            "city_id": 32522,
                            "province_id": 24,
                            "name": "平泉市",
                            "whole_name": "平泉市，承德市，河北省",
                            "simple_py": "PQS",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0314",
                            "area_code": "130881",
                            "longitude": "118.690238",
                            "latitude": "41.00561"
                        },
                        {
                            "area_id": 33268,
                            "city_id": 32522,
                            "province_id": 24,
                            "name": "双滦区",
                            "whole_name": "双滦区，承德市，河北省",
                            "simple_py": "SLQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0314",
                            "area_code": "130803",
                            "longitude": "117.797485",
                            "latitude": "40.959756"
                        },
                        {
                            "area_id": 33271,
                            "city_id": 32522,
                            "province_id": 24,
                            "name": "双桥区",
                            "whole_name": "双桥区，承德市，河北省",
                            "simple_py": "SQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0314",
                            "area_code": "130802",
                            "longitude": "117.939152",
                            "latitude": "40.976204"
                        },
                        {
                            "area_id": 33261,
                            "city_id": 32522,
                            "province_id": 24,
                            "name": "围场满族蒙古族自治县",
                            "whole_name": "围场满族蒙古族自治县，承德市，河北省",
                            "simple_py": "WCMZMGZZZX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0314",
                            "area_code": "130828",
                            "longitude": "117.764086",
                            "latitude": "41.949404"
                        },
                        {
                            "area_id": 33267,
                            "city_id": 32522,
                            "province_id": 24,
                            "name": "兴隆县",
                            "whole_name": "兴隆县，承德市，河北省",
                            "simple_py": "XLX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0314",
                            "area_code": "130822",
                            "longitude": "117.507098",
                            "latitude": "40.418525"
                        },
                        {
                            "area_id": 33264,
                            "city_id": 32522,
                            "province_id": 24,
                            "name": "鹰手营子矿区",
                            "whole_name": "鹰手营子矿区，承德市，河北省",
                            "simple_py": "YSYZKQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0314",
                            "area_code": "130804",
                            "longitude": "117.661154",
                            "latitude": "40.546956"
                        }
                    ]
                },
                {
                    "city_id": 32525,
                    "province_id": 24,
                    "name": "沧州市",
                    "whole_name": "沧州市，河北省",
                    "simple_py": "CZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "C",
                    "city_code": "0317",
                    "area_code": "130900",
                    "longitude": "116.857461",
                    "latitude": "38.310582",
                    "children": [
                        {
                            "area_id": 33884,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "泊头市",
                            "whole_name": "泊头市，沧州市，河北省",
                            "simple_py": "BTS",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0317",
                            "area_code": "130981",
                            "longitude": "116.570163",
                            "latitude": "38.073479"
                        },
                        {
                            "area_id": 33880,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "沧县",
                            "whole_name": "沧县，沧州市，河北省",
                            "simple_py": "CX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0317",
                            "area_code": "130921",
                            "longitude": "117.007478",
                            "latitude": "38.219856"
                        },
                        {
                            "area_id": 33878,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "东光县",
                            "whole_name": "东光县，沧州市，河北省",
                            "simple_py": "DGX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0317",
                            "area_code": "130923",
                            "longitude": "116.542062",
                            "latitude": "37.88655"
                        },
                        {
                            "area_id": 33874,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "河间市",
                            "whole_name": "河间市，沧州市，河北省",
                            "simple_py": "HJS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0317",
                            "area_code": "130984",
                            "longitude": "116.089452",
                            "latitude": "38.44149"
                        },
                        {
                            "area_id": 33875,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "海兴县",
                            "whole_name": "海兴县，沧州市，河北省",
                            "simple_py": "HXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0317",
                            "area_code": "130924",
                            "longitude": "117.496606",
                            "latitude": "38.141582"
                        },
                        {
                            "area_id": 33883,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "黄骅市",
                            "whole_name": "黄骅市，沧州市，河北省",
                            "simple_py": "HHS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0317",
                            "area_code": "130983",
                            "longitude": "117.343803",
                            "latitude": "38.369238"
                        },
                        {
                            "area_id": 33871,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "孟村回族自治县",
                            "whole_name": "孟村回族自治县，沧州市，河北省",
                            "simple_py": "MCHZZZX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0317",
                            "area_code": "130930",
                            "longitude": "117.105104",
                            "latitude": "38.057953"
                        },
                        {
                            "area_id": 33877,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "南皮县",
                            "whole_name": "南皮县，沧州市，河北省",
                            "simple_py": "NPX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0317",
                            "area_code": "130927",
                            "longitude": "116.709171",
                            "latitude": "38.042439"
                        },
                        {
                            "area_id": 33873,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "青县",
                            "whole_name": "青县，沧州市，河北省",
                            "simple_py": "QX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0317",
                            "area_code": "130922",
                            "longitude": "116.838384",
                            "latitude": "38.569646"
                        },
                        {
                            "area_id": 33870,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "任丘市",
                            "whole_name": "任丘市，沧州市，河北省",
                            "simple_py": "RQS",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0317",
                            "area_code": "130982",
                            "longitude": "116.106764",
                            "latitude": "38.706513"
                        },
                        {
                            "area_id": 33881,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "肃宁县",
                            "whole_name": "肃宁县，沧州市，河北省",
                            "simple_py": "SNX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0317",
                            "area_code": "130926",
                            "longitude": "115.835856",
                            "latitude": "38.427102"
                        },
                        {
                            "area_id": 33882,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "吴桥县",
                            "whole_name": "吴桥县，沧州市，河北省",
                            "simple_py": "WQX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0317",
                            "area_code": "130928",
                            "longitude": "116.391512",
                            "latitude": "37.628182"
                        },
                        {
                            "area_id": 33872,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "新华区",
                            "whole_name": "新华区，沧州市，河北省",
                            "simple_py": "XHQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0317",
                            "area_code": "130902",
                            "longitude": "116.873049",
                            "latitude": "38.308273"
                        },
                        {
                            "area_id": 33879,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "献县",
                            "whole_name": "献县，沧州市，河北省",
                            "simple_py": "XX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0317",
                            "area_code": "130929",
                            "longitude": "116.123844",
                            "latitude": "38.189661"
                        },
                        {
                            "area_id": 33869,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "运河区",
                            "whole_name": "运河区，沧州市，河北省",
                            "simple_py": "YHQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0317",
                            "area_code": "130903",
                            "longitude": "116.840063",
                            "latitude": "38.307405"
                        },
                        {
                            "area_id": 33876,
                            "city_id": 32525,
                            "province_id": 24,
                            "name": "盐山县",
                            "whole_name": "盐山县，沧州市，河北省",
                            "simple_py": "YSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0317",
                            "area_code": "130925",
                            "longitude": "117.229814",
                            "latitude": "38.056141"
                        }
                    ]
                },
                {
                    "city_id": 32520,
                    "province_id": 24,
                    "name": "邯郸市",
                    "whole_name": "邯郸市，河北省",
                    "simple_py": "HDS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0310",
                    "area_code": "130400",
                    "longitude": "114.490686",
                    "latitude": "36.612273",
                    "children": [
                        {
                            "area_id": 32758,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "磁县",
                            "whole_name": "磁县，邯郸市，河北省",
                            "simple_py": "CX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0310",
                            "area_code": "130427",
                            "longitude": "114.38208",
                            "latitude": "36.367673"
                        },
                        {
                            "area_id": 32759,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "丛台区",
                            "whole_name": "丛台区，邯郸市，河北省",
                            "simple_py": "CTQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0310",
                            "area_code": "130403",
                            "longitude": "114.494703",
                            "latitude": "36.611082"
                        },
                        {
                            "area_id": 32763,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "成安县",
                            "whole_name": "成安县，邯郸市，河北省",
                            "simple_py": "CAX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0310",
                            "area_code": "130424",
                            "longitude": "114.680356",
                            "latitude": "36.443832"
                        },
                        {
                            "area_id": 32754,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "大名县",
                            "whole_name": "大名县，邯郸市，河北省",
                            "simple_py": "DMX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0310",
                            "area_code": "130425",
                            "longitude": "115.152586",
                            "latitude": "36.283316"
                        },
                        {
                            "area_id": 32751,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "肥乡区",
                            "whole_name": "肥乡区，邯郸市，河北省",
                            "simple_py": "FXQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0310",
                            "area_code": "130407",
                            "longitude": "114.805154",
                            "latitude": "36.555778"
                        },
                        {
                            "area_id": 32752,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "峰峰矿区",
                            "whole_name": "峰峰矿区，邯郸市，河北省",
                            "simple_py": "FFKQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0310",
                            "area_code": "130406",
                            "longitude": "114.209936",
                            "latitude": "36.420487"
                        },
                        {
                            "area_id": 32760,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "复兴区",
                            "whole_name": "复兴区，邯郸市，河北省",
                            "simple_py": "FXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0310",
                            "area_code": "130404",
                            "longitude": "114.458242",
                            "latitude": "36.615484"
                        },
                        {
                            "area_id": 32746,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "广平县",
                            "whole_name": "广平县，邯郸市，河北省",
                            "simple_py": "GPX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0310",
                            "area_code": "130432",
                            "longitude": "114.950859",
                            "latitude": "36.483603"
                        },
                        {
                            "area_id": 32747,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "馆陶县",
                            "whole_name": "馆陶县，邯郸市，河北省",
                            "simple_py": "GTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0310",
                            "area_code": "130433",
                            "longitude": "115.289057",
                            "latitude": "36.539461"
                        },
                        {
                            "area_id": 32762,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "邯山区",
                            "whole_name": "邯山区，邯郸市，河北省",
                            "simple_py": "HSQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0310",
                            "area_code": "130402",
                            "longitude": "114.484989",
                            "latitude": "36.603196"
                        },
                        {
                            "area_id": 32757,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "鸡泽县",
                            "whole_name": "鸡泽县，邯郸市，河北省",
                            "simple_py": "JZX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0310",
                            "area_code": "130431",
                            "longitude": "114.878517",
                            "latitude": "36.914908"
                        },
                        {
                            "area_id": 32749,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "临漳县",
                            "whole_name": "临漳县，邯郸市，河北省",
                            "simple_py": "LZX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0310",
                            "area_code": "130423",
                            "longitude": "114.610703",
                            "latitude": "36.337604"
                        },
                        {
                            "area_id": 32755,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "邱县",
                            "whole_name": "邱县，邯郸市，河北省",
                            "simple_py": "QX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0310",
                            "area_code": "130430",
                            "longitude": "115.168584",
                            "latitude": "36.81325"
                        },
                        {
                            "area_id": 32756,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "曲周县",
                            "whole_name": "曲周县，邯郸市，河北省",
                            "simple_py": "QZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0310",
                            "area_code": "130435",
                            "longitude": "114.957588",
                            "latitude": "36.773398"
                        },
                        {
                            "area_id": 32753,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "涉县",
                            "whole_name": "涉县，邯郸市，河北省",
                            "simple_py": "SX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0310",
                            "area_code": "130426",
                            "longitude": "113.673297",
                            "latitude": "36.563143"
                        },
                        {
                            "area_id": 32748,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "武安市",
                            "whole_name": "武安市，邯郸市，河北省",
                            "simple_py": "WAS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0310",
                            "area_code": "130481",
                            "longitude": "114.194581",
                            "latitude": "36.696115"
                        },
                        {
                            "area_id": 32750,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "魏县",
                            "whole_name": "魏县，邯郸市，河北省",
                            "simple_py": "WX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0310",
                            "area_code": "130434",
                            "longitude": "114.93411",
                            "latitude": "36.354248"
                        },
                        {
                            "area_id": 32761,
                            "city_id": 32520,
                            "province_id": 24,
                            "name": "永年区",
                            "whole_name": "永年区，邯郸市，河北省",
                            "simple_py": "YNQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0310",
                            "area_code": "130408",
                            "longitude": "114.496162",
                            "latitude": "36.776413"
                        }
                    ]
                },
                {
                    "city_id": 32526,
                    "province_id": 24,
                    "name": "衡水市",
                    "whole_name": "衡水市，河北省",
                    "simple_py": "HSS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0318",
                    "area_code": "131100",
                    "longitude": "115.665993",
                    "latitude": "37.735097",
                    "children": [
                        {
                            "area_id": 34093,
                            "city_id": 32526,
                            "province_id": 24,
                            "name": "安平县",
                            "whole_name": "安平县，衡水市，河北省",
                            "simple_py": "APX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0318",
                            "area_code": "131125",
                            "longitude": "115.519627",
                            "latitude": "38.233511"
                        },
                        {
                            "area_id": 34103,
                            "city_id": 32526,
                            "province_id": 24,
                            "name": "阜城县",
                            "whole_name": "阜城县，衡水市，河北省",
                            "simple_py": "FCX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0318",
                            "area_code": "131128",
                            "longitude": "116.164727",
                            "latitude": "37.869945"
                        },
                        {
                            "area_id": 34102,
                            "city_id": 32526,
                            "province_id": 24,
                            "name": "故城县",
                            "whole_name": "故城县，衡水市，河北省",
                            "simple_py": "GCX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0318",
                            "area_code": "131126",
                            "longitude": "115.966747",
                            "latitude": "37.350981"
                        },
                        {
                            "area_id": 34100,
                            "city_id": 32526,
                            "province_id": 24,
                            "name": "冀州区",
                            "whole_name": "冀州区，衡水市，河北省",
                            "simple_py": "JZQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0318",
                            "area_code": "131103",
                            "longitude": "115.579173",
                            "latitude": "37.542788"
                        },
                        {
                            "area_id": 34101,
                            "city_id": 32526,
                            "province_id": 24,
                            "name": "景县",
                            "whole_name": "景县，衡水市，河北省",
                            "simple_py": "JX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0318",
                            "area_code": "131127",
                            "longitude": "116.258446",
                            "latitude": "37.686622"
                        },
                        {
                            "area_id": 34099,
                            "city_id": 32526,
                            "province_id": 24,
                            "name": "饶阳县",
                            "whole_name": "饶阳县，衡水市，河北省",
                            "simple_py": "RYX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0318",
                            "area_code": "131124",
                            "longitude": "115.726577",
                            "latitude": "38.232671"
                        },
                        {
                            "area_id": 34098,
                            "city_id": 32526,
                            "province_id": 24,
                            "name": "深州市",
                            "whole_name": "深州市，衡水市，河北省",
                            "simple_py": "SZS",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0318",
                            "area_code": "131182",
                            "longitude": "115.554596",
                            "latitude": "38.00347"
                        },
                        {
                            "area_id": 34097,
                            "city_id": 32526,
                            "province_id": 24,
                            "name": "桃城区",
                            "whole_name": "桃城区，衡水市，河北省",
                            "simple_py": "TCQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0318",
                            "area_code": "131102",
                            "longitude": "115.694945",
                            "latitude": "37.732237"
                        },
                        {
                            "area_id": 34095,
                            "city_id": 32526,
                            "province_id": 24,
                            "name": "武邑县",
                            "whole_name": "武邑县，衡水市，河北省",
                            "simple_py": "WYX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0318",
                            "area_code": "131122",
                            "longitude": "115.892415",
                            "latitude": "37.803774"
                        },
                        {
                            "area_id": 34096,
                            "city_id": 32526,
                            "province_id": 24,
                            "name": "武强县",
                            "whole_name": "武强县，衡水市，河北省",
                            "simple_py": "WQX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0318",
                            "area_code": "131123",
                            "longitude": "115.970236",
                            "latitude": "38.03698"
                        },
                        {
                            "area_id": 34094,
                            "city_id": 32526,
                            "province_id": 24,
                            "name": "枣强县",
                            "whole_name": "枣强县，衡水市，河北省",
                            "simple_py": "ZQX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0318",
                            "area_code": "131121",
                            "longitude": "115.726499",
                            "latitude": "37.511512"
                        }
                    ]
                },
                {
                    "city_id": 32524,
                    "province_id": 24,
                    "name": "廊坊市",
                    "whole_name": "廊坊市，河北省",
                    "simple_py": "LFS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0316",
                    "area_code": "131000",
                    "longitude": "116.704441",
                    "latitude": "39.523927",
                    "children": [
                        {
                            "area_id": 33755,
                            "city_id": 32524,
                            "province_id": 24,
                            "name": "安次区",
                            "whole_name": "安次区，廊坊市，河北省",
                            "simple_py": "ACQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0316",
                            "area_code": "131002",
                            "longitude": "116.694544",
                            "latitude": "39.502569"
                        },
                        {
                            "area_id": 33748,
                            "city_id": 32524,
                            "province_id": 24,
                            "name": "霸州市",
                            "whole_name": "霸州市，廊坊市，河北省",
                            "simple_py": "BZS",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0316",
                            "area_code": "131081",
                            "longitude": "116.392021",
                            "latitude": "39.117331"
                        },
                        {
                            "area_id": 33747,
                            "city_id": 32524,
                            "province_id": 24,
                            "name": "大厂回族自治县",
                            "whole_name": "大厂回族自治县，廊坊市，河北省",
                            "simple_py": "DCHZZZX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0316",
                            "area_code": "131028",
                            "longitude": "116.986501",
                            "latitude": "39.889266"
                        },
                        {
                            "area_id": 33749,
                            "city_id": 32524,
                            "province_id": 24,
                            "name": "大城县",
                            "whole_name": "大城县，廊坊市，河北省",
                            "simple_py": "DCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0316",
                            "area_code": "131025",
                            "longitude": "116.640735",
                            "latitude": "38.699215"
                        },
                        {
                            "area_id": 33752,
                            "city_id": 32524,
                            "province_id": 24,
                            "name": "固安县",
                            "whole_name": "固安县，廊坊市，河北省",
                            "simple_py": "GAX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0316",
                            "area_code": "131022",
                            "longitude": "116.299894",
                            "latitude": "39.436468"
                        },
                        {
                            "area_id": 33754,
                            "city_id": 32524,
                            "province_id": 24,
                            "name": "广阳区",
                            "whole_name": "广阳区，廊坊市，河北省",
                            "simple_py": "GYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0316",
                            "area_code": "131003",
                            "longitude": "116.713708",
                            "latitude": "39.521931"
                        },
                        {
                            "area_id": 33756,
                            "city_id": 32524,
                            "province_id": 24,
                            "name": "三河市",
                            "whole_name": "三河市，廊坊市，河北省",
                            "simple_py": "SHS",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0316",
                            "area_code": "131082",
                            "longitude": "117.077018",
                            "latitude": "39.982778"
                        },
                        {
                            "area_id": 33753,
                            "city_id": 32524,
                            "province_id": 24,
                            "name": "文安县",
                            "whole_name": "文安县，廊坊市，河北省",
                            "simple_py": "WAX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0316",
                            "area_code": "131026",
                            "longitude": "116.460107",
                            "latitude": "38.866801"
                        },
                        {
                            "area_id": 33751,
                            "city_id": 32524,
                            "province_id": 24,
                            "name": "香河县",
                            "whole_name": "香河县，廊坊市，河北省",
                            "simple_py": "XHX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0316",
                            "area_code": "131024",
                            "longitude": "117.007161",
                            "latitude": "39.757212"
                        },
                        {
                            "area_id": 33750,
                            "city_id": 32524,
                            "province_id": 24,
                            "name": "永清县",
                            "whole_name": "永清县，廊坊市，河北省",
                            "simple_py": "YQX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0316",
                            "area_code": "131023",
                            "longitude": "116.498089",
                            "latitude": "39.319717"
                        }
                    ]
                },
                {
                    "city_id": 32527,
                    "province_id": 24,
                    "name": "秦皇岛市",
                    "whole_name": "秦皇岛市，河北省",
                    "simple_py": "QHDS",
                    "per_pin_yin": "Q",
                    "per_pin_yin2": "Q",
                    "city_code": "0335",
                    "area_code": "130300",
                    "longitude": "119.586579",
                    "latitude": "39.942531",
                    "children": [
                        {
                            "area_id": 34231,
                            "city_id": 32527,
                            "province_id": 24,
                            "name": "北戴河区",
                            "whole_name": "北戴河区，秦皇岛市，河北省",
                            "simple_py": "BDHQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0335",
                            "area_code": "130304",
                            "longitude": "119.486286",
                            "latitude": "39.825121"
                        },
                        {
                            "area_id": 34233,
                            "city_id": 32527,
                            "province_id": 24,
                            "name": "昌黎县",
                            "whole_name": "昌黎县，秦皇岛市，河北省",
                            "simple_py": "CLX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0335",
                            "area_code": "130322",
                            "longitude": "119.164541",
                            "latitude": "39.709729"
                        },
                        {
                            "area_id": 34232,
                            "city_id": 32527,
                            "province_id": 24,
                            "name": "抚宁区",
                            "whole_name": "抚宁区，秦皇岛市，河北省",
                            "simple_py": "FNQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0335",
                            "area_code": "130306",
                            "longitude": "119.240651",
                            "latitude": "39.887053"
                        },
                        {
                            "area_id": 34230,
                            "city_id": 32527,
                            "province_id": 24,
                            "name": "海港区",
                            "whole_name": "海港区，秦皇岛市，河北省",
                            "simple_py": "HGQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0335",
                            "area_code": "130302",
                            "longitude": "119.596224",
                            "latitude": "39.943458"
                        },
                        {
                            "area_id": 34227,
                            "city_id": 32527,
                            "province_id": 24,
                            "name": "卢龙县",
                            "whole_name": "卢龙县，秦皇岛市，河北省",
                            "simple_py": "LLX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0335",
                            "area_code": "130324",
                            "longitude": "118.881809",
                            "latitude": "39.891639"
                        },
                        {
                            "area_id": 34228,
                            "city_id": 32527,
                            "province_id": 24,
                            "name": "青龙满族自治县",
                            "whole_name": "青龙满族自治县，秦皇岛市，河北省",
                            "simple_py": "QLMZZZX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0335",
                            "area_code": "130321",
                            "longitude": "118.954555",
                            "latitude": "40.406023"
                        },
                        {
                            "area_id": 34229,
                            "city_id": 32527,
                            "province_id": 24,
                            "name": "山海关区",
                            "whole_name": "山海关区，秦皇岛市，河北省",
                            "simple_py": "SHGQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0335",
                            "area_code": "130303",
                            "longitude": "119.753591",
                            "latitude": "39.998023"
                        }
                    ]
                },
                {
                    "city_id": 32529,
                    "province_id": 24,
                    "name": "石家庄市",
                    "whole_name": "石家庄市，河北省",
                    "simple_py": "SJZS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0311",
                    "area_code": "130100",
                    "longitude": "114.502461",
                    "latitude": "38.045474",
                    "children": [
                        {
                            "area_id": 34723,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "长安区",
                            "whole_name": "长安区，石家庄市，河北省",
                            "simple_py": "CAQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0311",
                            "area_code": "130102",
                            "longitude": "114.548151",
                            "latitude": "38.047501"
                        },
                        {
                            "area_id": 34712,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "高邑县",
                            "whole_name": "高邑县，石家庄市，河北省",
                            "simple_py": "GYX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0311",
                            "area_code": "130127",
                            "longitude": "114.610699",
                            "latitude": "37.605714"
                        },
                        {
                            "area_id": 34714,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "藁城区",
                            "whole_name": "藁城区，石家庄市，河北省",
                            "simple_py": "GCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0311",
                            "area_code": "130109",
                            "longitude": "114.849647",
                            "latitude": "38.033767"
                        },
                        {
                            "area_id": 34706,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "晋州市",
                            "whole_name": "晋州市，石家庄市，河北省",
                            "simple_py": "JZS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0311",
                            "area_code": "130183",
                            "longitude": "115.044886",
                            "latitude": "38.027478"
                        },
                        {
                            "area_id": 34720,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "井陉县",
                            "whole_name": "井陉县，石家庄市，河北省",
                            "simple_py": "JXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0311",
                            "area_code": "130121",
                            "longitude": "114.144488",
                            "latitude": "38.033614"
                        },
                        {
                            "area_id": 34721,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "井陉矿区",
                            "whole_name": "井陉矿区，石家庄市，河北省",
                            "simple_py": "JXKQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0311",
                            "area_code": "130107",
                            "longitude": "114.058178",
                            "latitude": "38.069748"
                        },
                        {
                            "area_id": 34709,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "灵寿县",
                            "whole_name": "灵寿县，石家庄市，河北省",
                            "simple_py": "LSX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0311",
                            "area_code": "130126",
                            "longitude": "114.37946",
                            "latitude": "38.306546"
                        },
                        {
                            "area_id": 34713,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "鹿泉区",
                            "whole_name": "鹿泉区，石家庄市，河北省",
                            "simple_py": "LQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0311",
                            "area_code": "130110",
                            "longitude": "114.321023",
                            "latitude": "38.093994"
                        },
                        {
                            "area_id": 34718,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "栾城区",
                            "whole_name": "栾城区，石家庄市，河北省",
                            "simple_py": "LCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0311",
                            "area_code": "130111",
                            "longitude": "114.654281",
                            "latitude": "37.886911"
                        },
                        {
                            "area_id": 34715,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "平山县",
                            "whole_name": "平山县，石家庄市，河北省",
                            "simple_py": "PSX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0311",
                            "area_code": "130131",
                            "longitude": "114.184144",
                            "latitude": "38.259311"
                        },
                        {
                            "area_id": 34724,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "桥西区",
                            "whole_name": "桥西区，石家庄市，河北省",
                            "simple_py": "QXQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0311",
                            "area_code": "130104",
                            "longitude": "114.462931",
                            "latitude": "38.028383"
                        },
                        {
                            "area_id": 34727,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "深泽县",
                            "whole_name": "深泽县，石家庄市，河北省",
                            "simple_py": "SZX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0311",
                            "area_code": "130128",
                            "longitude": "115.200207",
                            "latitude": "38.18454"
                        },
                        {
                            "area_id": 34711,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "无极县",
                            "whole_name": "无极县，石家庄市，河北省",
                            "simple_py": "WJX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0311",
                            "area_code": "130130",
                            "longitude": "114.977845",
                            "latitude": "38.176376"
                        },
                        {
                            "area_id": 34716,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "行唐县",
                            "whole_name": "行唐县，石家庄市，河北省",
                            "simple_py": "XTX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0311",
                            "area_code": "130125",
                            "longitude": "114.552734",
                            "latitude": "38.437422"
                        },
                        {
                            "area_id": 34722,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "辛集市",
                            "whole_name": "辛集市，石家庄市，河北省",
                            "simple_py": "XJS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0311",
                            "area_code": "130181",
                            "longitude": "115.217451",
                            "latitude": "37.92904"
                        },
                        {
                            "area_id": 34725,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "新华区",
                            "whole_name": "新华区，石家庄市，河北省",
                            "simple_py": "XHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0311",
                            "area_code": "130105",
                            "longitude": "114.465974",
                            "latitude": "38.067142"
                        },
                        {
                            "area_id": 34726,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "新乐市",
                            "whole_name": "新乐市，石家庄市，河北省",
                            "simple_py": "XLS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0311",
                            "area_code": "130184",
                            "longitude": "114.68578",
                            "latitude": "38.344768"
                        },
                        {
                            "area_id": 34707,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "元氏县",
                            "whole_name": "元氏县，石家庄市，河北省",
                            "simple_py": "YSX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0311",
                            "area_code": "130132",
                            "longitude": "114.52618",
                            "latitude": "37.762514"
                        },
                        {
                            "area_id": 34719,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "裕华区",
                            "whole_name": "裕华区，石家庄市，河北省",
                            "simple_py": "YHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0311",
                            "area_code": "130108",
                            "longitude": "114.533257",
                            "latitude": "38.027696"
                        },
                        {
                            "area_id": 34708,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "赵县",
                            "whole_name": "赵县，石家庄市，河北省",
                            "simple_py": "ZX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0311",
                            "area_code": "130133",
                            "longitude": "114.775362",
                            "latitude": "37.754341"
                        },
                        {
                            "area_id": 34710,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "赞皇县",
                            "whole_name": "赞皇县，石家庄市，河北省",
                            "simple_py": "ZHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0311",
                            "area_code": "130129",
                            "longitude": "114.387756",
                            "latitude": "37.660199"
                        },
                        {
                            "area_id": 34717,
                            "city_id": 32529,
                            "province_id": 24,
                            "name": "正定县",
                            "whole_name": "正定县，石家庄市，河北省",
                            "simple_py": "ZDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0311",
                            "area_code": "130123",
                            "longitude": "114.569887",
                            "latitude": "38.147835"
                        }
                    ]
                },
                {
                    "city_id": 32521,
                    "province_id": 24,
                    "name": "唐山市",
                    "whole_name": "唐山市，河北省",
                    "simple_py": "TSS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0315",
                    "area_code": "130200",
                    "longitude": "118.175393",
                    "latitude": "39.635113",
                    "children": [
                        {
                            "area_id": 33011,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "曹妃甸区",
                            "whole_name": "曹妃甸区，唐山市，河北省",
                            "simple_py": "CFDQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0315",
                            "area_code": "130209",
                            "longitude": "118.446585",
                            "latitude": "39.278277"
                        },
                        {
                            "area_id": 33014,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "丰南区",
                            "whole_name": "丰南区，唐山市，河北省",
                            "simple_py": "FNQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0315",
                            "area_code": "130207",
                            "longitude": "118.110793",
                            "latitude": "39.56303"
                        },
                        {
                            "area_id": 33016,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "丰润区",
                            "whole_name": "丰润区，唐山市，河北省",
                            "simple_py": "FRQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0315",
                            "area_code": "130208",
                            "longitude": "118.155779",
                            "latitude": "39.831363"
                        },
                        {
                            "area_id": 33017,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "古冶区",
                            "whole_name": "古冶区，唐山市，河北省",
                            "simple_py": "GYQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0315",
                            "area_code": "130204",
                            "longitude": "118.45429",
                            "latitude": "39.715736"
                        },
                        {
                            "area_id": 33018,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "开平区",
                            "whole_name": "开平区，唐山市，河北省",
                            "simple_py": "KPQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0315",
                            "area_code": "130205",
                            "longitude": "118.264425",
                            "latitude": "39.676171"
                        },
                        {
                            "area_id": 33005,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "滦南县",
                            "whole_name": "滦南县，唐山市，河北省",
                            "simple_py": "LNX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0315",
                            "area_code": "130224",
                            "longitude": "118.681552",
                            "latitude": "39.506201"
                        },
                        {
                            "area_id": 33006,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "乐亭县",
                            "whole_name": "乐亭县，唐山市，河北省",
                            "simple_py": "LTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0315",
                            "area_code": "130225",
                            "longitude": "118.905341",
                            "latitude": "39.42813"
                        },
                        {
                            "area_id": 33010,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "滦县",
                            "whole_name": "滦县，唐山市，河北省",
                            "simple_py": "LX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0315",
                            "area_code": "130223",
                            "longitude": "118.699547",
                            "latitude": "39.744851"
                        },
                        {
                            "area_id": 33013,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "路南区",
                            "whole_name": "路南区，唐山市，河北省",
                            "simple_py": "LNQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0315",
                            "area_code": "130202",
                            "longitude": "118.210821",
                            "latitude": "39.615162"
                        },
                        {
                            "area_id": 33015,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "路北区",
                            "whole_name": "路北区，唐山市，河北省",
                            "simple_py": "LBQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0315",
                            "area_code": "130203",
                            "longitude": "118.174736",
                            "latitude": "39.628538"
                        },
                        {
                            "area_id": 33007,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "迁西县",
                            "whole_name": "迁西县，唐山市，河北省",
                            "simple_py": "QXX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0315",
                            "area_code": "130227",
                            "longitude": "118.305139",
                            "latitude": "40.146238"
                        },
                        {
                            "area_id": 33009,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "迁安市",
                            "whole_name": "迁安市，唐山市，河北省",
                            "simple_py": "QAS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0315",
                            "area_code": "130283",
                            "longitude": "118.701933",
                            "latitude": "40.012108"
                        },
                        {
                            "area_id": 33012,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "玉田县",
                            "whole_name": "玉田县，唐山市，河北省",
                            "simple_py": "YTX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0315",
                            "area_code": "130229",
                            "longitude": "117.753665",
                            "latitude": "39.887323"
                        },
                        {
                            "area_id": 33008,
                            "city_id": 32521,
                            "province_id": 24,
                            "name": "遵化市",
                            "whole_name": "遵化市，唐山市，河北省",
                            "simple_py": "ZHS",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0315",
                            "area_code": "130281",
                            "longitude": "117.965875",
                            "latitude": "40.188616"
                        }
                    ]
                },
                {
                    "city_id": 32519,
                    "province_id": 24,
                    "name": "邢台市",
                    "whole_name": "邢台市，河北省",
                    "simple_py": "XTS",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "0319",
                    "area_code": "130500",
                    "longitude": "114.508851",
                    "latitude": "37.0682",
                    "children": [
                        {
                            "area_id": 32531,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "柏乡县",
                            "whole_name": "柏乡县，邢台市，河北省",
                            "simple_py": "BXX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0319",
                            "area_code": "130524",
                            "longitude": "114.693382",
                            "latitude": "37.483596"
                        },
                        {
                            "area_id": 32544,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "广宗县",
                            "whole_name": "广宗县，邢台市，河北省",
                            "simple_py": "GZX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0319",
                            "area_code": "130531",
                            "longitude": "115.142797",
                            "latitude": "37.075548"
                        },
                        {
                            "area_id": 32542,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "巨鹿县",
                            "whole_name": "巨鹿县，邢台市，河北省",
                            "simple_py": "JLX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0319",
                            "area_code": "130529",
                            "longitude": "115.038782",
                            "latitude": "37.21768"
                        },
                        {
                            "area_id": 32533,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "隆尧县",
                            "whole_name": "隆尧县，邢台市，河北省",
                            "simple_py": "LYX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0319",
                            "area_code": "130525",
                            "longitude": "114.776348",
                            "latitude": "37.350925"
                        },
                        {
                            "area_id": 32534,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "临城县",
                            "whole_name": "临城县，邢台市，河北省",
                            "simple_py": "LCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0319",
                            "area_code": "130522",
                            "longitude": "114.506873",
                            "latitude": "37.444009"
                        },
                        {
                            "area_id": 32541,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "临西县",
                            "whole_name": "临西县，邢台市，河北省",
                            "simple_py": "LXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0319",
                            "area_code": "130535",
                            "longitude": "115.498684",
                            "latitude": "36.8642"
                        },
                        {
                            "area_id": 32530,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "内丘县",
                            "whole_name": "内丘县，邢台市，河北省",
                            "simple_py": "NQX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0319",
                            "area_code": "130523",
                            "longitude": "114.511523",
                            "latitude": "37.287663"
                        },
                        {
                            "area_id": 32535,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "南宫市",
                            "whole_name": "南宫市，邢台市，河北省",
                            "simple_py": "NGS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0319",
                            "area_code": "130581",
                            "longitude": "115.398102",
                            "latitude": "37.359668"
                        },
                        {
                            "area_id": 32536,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "宁晋县",
                            "whole_name": "宁晋县，邢台市，河北省",
                            "simple_py": "NJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0319",
                            "area_code": "130528",
                            "longitude": "114.921027",
                            "latitude": "37.618956"
                        },
                        {
                            "area_id": 32539,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "南和县",
                            "whole_name": "南和县，邢台市，河北省",
                            "simple_py": "NHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0319",
                            "area_code": "130527",
                            "longitude": "114.691377",
                            "latitude": "37.003812"
                        },
                        {
                            "area_id": 32537,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "平乡县",
                            "whole_name": "平乡县，邢台市，河北省",
                            "simple_py": "PXX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0319",
                            "area_code": "130532",
                            "longitude": "115.029218",
                            "latitude": "37.069404"
                        },
                        {
                            "area_id": 32538,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "桥西区",
                            "whole_name": "桥西区，邢台市，河北省",
                            "simple_py": "QXQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0319",
                            "area_code": "130503",
                            "longitude": "114.473687",
                            "latitude": "37.068009"
                        },
                        {
                            "area_id": 32545,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "清河县",
                            "whole_name": "清河县，邢台市，河北省",
                            "simple_py": "QHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0319",
                            "area_code": "130534",
                            "longitude": "115.668999",
                            "latitude": "37.059991"
                        },
                        {
                            "area_id": 32547,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "桥东区",
                            "whole_name": "桥东区，邢台市，河北省",
                            "simple_py": "QDQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0319",
                            "area_code": "130502",
                            "longitude": "114.507131",
                            "latitude": "37.064125"
                        },
                        {
                            "area_id": 32546,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "任县",
                            "whole_name": "任县，邢台市，河北省",
                            "simple_py": "RX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0319",
                            "area_code": "130526",
                            "longitude": "114.684469",
                            "latitude": "37.129952"
                        },
                        {
                            "area_id": 32540,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "沙河市",
                            "whole_name": "沙河市，邢台市，河北省",
                            "simple_py": "SHS",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0319",
                            "area_code": "130582",
                            "longitude": "114.504902",
                            "latitude": "36.861903"
                        },
                        {
                            "area_id": 32543,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "威县",
                            "whole_name": "威县，邢台市，河北省",
                            "simple_py": "WX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0319",
                            "area_code": "130533",
                            "longitude": "115.272749",
                            "latitude": "36.983272"
                        },
                        {
                            "area_id": 32532,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "新河县",
                            "whole_name": "新河县，邢台市，河北省",
                            "simple_py": "XHX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0319",
                            "area_code": "130530",
                            "longitude": "115.247537",
                            "latitude": "37.526216"
                        },
                        {
                            "area_id": 32548,
                            "city_id": 32519,
                            "province_id": 24,
                            "name": "邢台县",
                            "whole_name": "邢台县，邢台市，河北省",
                            "simple_py": "XTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0319",
                            "area_code": "130521",
                            "longitude": "114.561132",
                            "latitude": "37.05073"
                        }
                    ]
                },
                {
                    "city_id": 32523,
                    "province_id": 24,
                    "name": "张家口市",
                    "whole_name": "张家口市，河北省",
                    "simple_py": "ZJKS",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "0313",
                    "area_code": "130700",
                    "longitude": "114.884091",
                    "latitude": "40.811901",
                    "children": [
                        {
                            "area_id": 33495,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "崇礼区",
                            "whole_name": "崇礼区，张家口市，河北省",
                            "simple_py": "CLQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0313",
                            "area_code": "130709",
                            "longitude": "115.281652",
                            "latitude": "40.971302"
                        },
                        {
                            "area_id": 33502,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "赤城县",
                            "whole_name": "赤城县，张家口市，河北省",
                            "simple_py": "CCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0313",
                            "area_code": "130732",
                            "longitude": "115.832708",
                            "latitude": "40.912081"
                        },
                        {
                            "area_id": 33492,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "沽源县",
                            "whole_name": "沽源县，张家口市，河北省",
                            "simple_py": "GYX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0313",
                            "area_code": "130724",
                            "longitude": "115.684836",
                            "latitude": "41.667419"
                        },
                        {
                            "area_id": 33493,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "怀安县",
                            "whole_name": "怀安县，张家口市，河北省",
                            "simple_py": "HAX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0313",
                            "area_code": "130728",
                            "longitude": "114.422364",
                            "latitude": "40.671274"
                        },
                        {
                            "area_id": 33496,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "怀来县",
                            "whole_name": "怀来县，张家口市，河北省",
                            "simple_py": "HLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0313",
                            "area_code": "130730",
                            "longitude": "115.520846",
                            "latitude": "40.405405"
                        },
                        {
                            "area_id": 33498,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "康保县",
                            "whole_name": "康保县，张家口市，河北省",
                            "simple_py": "KBX",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0313",
                            "area_code": "130723",
                            "longitude": "114.615809",
                            "latitude": "41.850046"
                        },
                        {
                            "area_id": 33504,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "桥东区",
                            "whole_name": "桥东区，张家口市，河北省",
                            "simple_py": "QDQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0313",
                            "area_code": "130702",
                            "longitude": "114.885658",
                            "latitude": "40.813875"
                        },
                        {
                            "area_id": 33505,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "桥西区",
                            "whole_name": "桥西区，张家口市，河北省",
                            "simple_py": "QXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0313",
                            "area_code": "130703",
                            "longitude": "114.882127",
                            "latitude": "40.824385"
                        },
                        {
                            "area_id": 33499,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "尚义县",
                            "whole_name": "尚义县，张家口市，河北省",
                            "simple_py": "SYX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0313",
                            "area_code": "130725",
                            "longitude": "113.977713",
                            "latitude": "41.080091"
                        },
                        {
                            "area_id": 33503,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "万全区",
                            "whole_name": "万全区，张家口市，河北省",
                            "simple_py": "WQQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0313",
                            "area_code": "130708",
                            "longitude": "114.736131",
                            "latitude": "40.765136"
                        },
                        {
                            "area_id": 33500,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "下花园区",
                            "whole_name": "下花园区，张家口市，河北省",
                            "simple_py": "XHYQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0313",
                            "area_code": "130706",
                            "longitude": "115.281002",
                            "latitude": "40.488645"
                        },
                        {
                            "area_id": 33506,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "宣化区",
                            "whole_name": "宣化区，张家口市，河北省",
                            "simple_py": "XHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0313",
                            "area_code": "130705",
                            "longitude": "115.0632",
                            "latitude": "40.609368"
                        },
                        {
                            "area_id": 33491,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "阳原县",
                            "whole_name": "阳原县，张家口市，河北省",
                            "simple_py": "YYX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0313",
                            "area_code": "130727",
                            "longitude": "114.167343",
                            "latitude": "40.113419"
                        },
                        {
                            "area_id": 33494,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "蔚县",
                            "whole_name": "蔚县，张家口市，河北省",
                            "simple_py": "YX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0313",
                            "area_code": "130726",
                            "longitude": "114.582695",
                            "latitude": "39.837181"
                        },
                        {
                            "area_id": 33497,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "张北县",
                            "whole_name": "张北县，张家口市，河北省",
                            "simple_py": "ZBX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0313",
                            "area_code": "130722",
                            "longitude": "114.715951",
                            "latitude": "41.151713"
                        },
                        {
                            "area_id": 33501,
                            "city_id": 32523,
                            "province_id": 24,
                            "name": "涿鹿县",
                            "whole_name": "涿鹿县，张家口市，河北省",
                            "simple_py": "ZLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0313",
                            "area_code": "130731",
                            "longitude": "115.219246",
                            "latitude": "40.378701"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 18,
            "name": "江苏省",
            "whole_name": "江苏省",
            "simple_py": "JSS",
            "per_pin_yin": "J",
            "per_pin_yin2": "J",
            "city_code": "",
            "area_code": "320000",
            "longitude": "118.767413",
            "latitude": "32.041544",
            "children": [
                {
                    "city_id": 25450,
                    "province_id": 18,
                    "name": "常州市",
                    "whole_name": "常州市，江苏省",
                    "simple_py": "CZS",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0519",
                    "area_code": "320400",
                    "longitude": "119.946973",
                    "latitude": "31.772752",
                    "children": [
                        {
                            "area_id": 26781,
                            "city_id": 25450,
                            "province_id": 18,
                            "name": "金坛区",
                            "whole_name": "金坛区，常州市，江苏省",
                            "simple_py": "JTQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0519",
                            "area_code": "320413",
                            "longitude": "119.573395",
                            "latitude": "31.744399"
                        },
                        {
                            "area_id": 26786,
                            "city_id": 25450,
                            "province_id": 18,
                            "name": "溧阳市",
                            "whole_name": "溧阳市，常州市，江苏省",
                            "simple_py": "LYS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0519",
                            "area_code": "320481",
                            "longitude": "119.487816",
                            "latitude": "31.427081"
                        },
                        {
                            "area_id": 26784,
                            "city_id": 25450,
                            "province_id": 18,
                            "name": "天宁区",
                            "whole_name": "天宁区，常州市，江苏省",
                            "simple_py": "TNQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0519",
                            "area_code": "320402",
                            "longitude": "119.963783",
                            "latitude": "31.779632"
                        },
                        {
                            "area_id": 26782,
                            "city_id": 25450,
                            "province_id": 18,
                            "name": "武进区",
                            "whole_name": "武进区，常州市，江苏省",
                            "simple_py": "WJQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0519",
                            "area_code": "320412",
                            "longitude": "119.958773",
                            "latitude": "31.718566"
                        },
                        {
                            "area_id": 26785,
                            "city_id": 25450,
                            "province_id": 18,
                            "name": "新北区",
                            "whole_name": "新北区，常州市，江苏省",
                            "simple_py": "XBQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0519",
                            "area_code": "320411",
                            "longitude": "119.974654",
                            "latitude": "31.824664"
                        },
                        {
                            "area_id": 26783,
                            "city_id": 25450,
                            "province_id": 18,
                            "name": "钟楼区",
                            "whole_name": "钟楼区，常州市，江苏省",
                            "simple_py": "ZLQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0519",
                            "area_code": "320404",
                            "longitude": "119.948388",
                            "latitude": "31.78096"
                        }
                    ]
                },
                {
                    "city_id": 25446,
                    "province_id": 18,
                    "name": "淮安市",
                    "whole_name": "淮安市，江苏省",
                    "simple_py": "HAS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0517",
                    "area_code": "320800",
                    "longitude": "119.021265",
                    "latitude": "33.597506",
                    "children": [
                        {
                            "area_id": 26223,
                            "city_id": 25446,
                            "province_id": 18,
                            "name": "洪泽区",
                            "whole_name": "洪泽区，淮安市，江苏省",
                            "simple_py": "HZQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0517",
                            "area_code": "320813",
                            "longitude": "118.867875",
                            "latitude": "33.294975"
                        },
                        {
                            "area_id": 26225,
                            "city_id": 25446,
                            "province_id": 18,
                            "name": "淮安区",
                            "whole_name": "淮安区，淮安市，江苏省",
                            "simple_py": "HAQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0517",
                            "area_code": "320803",
                            "longitude": "119.14634",
                            "latitude": "33.507499"
                        },
                        {
                            "area_id": 26226,
                            "city_id": 25446,
                            "province_id": 18,
                            "name": "淮阴区",
                            "whole_name": "淮阴区，淮安市，江苏省",
                            "simple_py": "HYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0517",
                            "area_code": "320804",
                            "longitude": "119.020817",
                            "latitude": "33.622452"
                        },
                        {
                            "area_id": 26224,
                            "city_id": 25446,
                            "province_id": 18,
                            "name": "金湖县",
                            "whole_name": "金湖县，淮安市，江苏省",
                            "simple_py": "JHX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0517",
                            "area_code": "320831",
                            "longitude": "119.016936",
                            "latitude": "33.018162"
                        },
                        {
                            "area_id": 26222,
                            "city_id": 25446,
                            "province_id": 18,
                            "name": "涟水县",
                            "whole_name": "涟水县，淮安市，江苏省",
                            "simple_py": "LSX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0517",
                            "area_code": "320826",
                            "longitude": "119.266078",
                            "latitude": "33.771308"
                        },
                        {
                            "area_id": 26228,
                            "city_id": 25446,
                            "province_id": 18,
                            "name": "清江浦区",
                            "whole_name": "清江浦区，淮安市，江苏省",
                            "simple_py": "QJPQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0517",
                            "area_code": "320812",
                            "longitude": "119.019454",
                            "latitude": "33.603234"
                        },
                        {
                            "area_id": 26227,
                            "city_id": 25446,
                            "province_id": 18,
                            "name": "盱眙县",
                            "whole_name": "盱眙县，淮安市，江苏省",
                            "simple_py": "XYX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0517",
                            "area_code": "320830",
                            "longitude": "118.493823",
                            "latitude": "33.00439"
                        }
                    ]
                },
                {
                    "city_id": 25440,
                    "province_id": 18,
                    "name": "连云港市",
                    "whole_name": "连云港市，江苏省",
                    "simple_py": "LYGS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0518",
                    "area_code": "320700",
                    "longitude": "119.178821",
                    "latitude": "34.600018",
                    "children": [
                        {
                            "area_id": 25586,
                            "city_id": 25440,
                            "province_id": 18,
                            "name": "东海县",
                            "whole_name": "东海县，连云港市，江苏省",
                            "simple_py": "DHX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0518",
                            "area_code": "320722",
                            "longitude": "118.766489",
                            "latitude": "34.522859"
                        },
                        {
                            "area_id": 25588,
                            "city_id": 25440,
                            "province_id": 18,
                            "name": "灌云县",
                            "whole_name": "灌云县，连云港市，江苏省",
                            "simple_py": "GYX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0518",
                            "area_code": "320723",
                            "longitude": "119.255741",
                            "latitude": "34.298436"
                        },
                        {
                            "area_id": 25589,
                            "city_id": 25440,
                            "province_id": 18,
                            "name": "灌南县",
                            "whole_name": "灌南县，连云港市，江苏省",
                            "simple_py": "GNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0518",
                            "area_code": "320724",
                            "longitude": "119.352331",
                            "latitude": "34.092553"
                        },
                        {
                            "area_id": 25590,
                            "city_id": 25440,
                            "province_id": 18,
                            "name": "赣榆区",
                            "whole_name": "赣榆区，连云港市，江苏省",
                            "simple_py": "GYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0518",
                            "area_code": "320707",
                            "longitude": "119.128774",
                            "latitude": "34.839154"
                        },
                        {
                            "area_id": 25591,
                            "city_id": 25440,
                            "province_id": 18,
                            "name": "海州区",
                            "whole_name": "海州区，连云港市，江苏省",
                            "simple_py": "HZQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0518",
                            "area_code": "320706",
                            "longitude": "119.179793",
                            "latitude": "34.601584"
                        },
                        {
                            "area_id": 25587,
                            "city_id": 25440,
                            "province_id": 18,
                            "name": "连云区",
                            "whole_name": "连云区，连云港市，江苏省",
                            "simple_py": "LYQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0518",
                            "area_code": "320703",
                            "longitude": "119.366487",
                            "latitude": "34.739529"
                        }
                    ]
                },
                {
                    "city_id": 25442,
                    "province_id": 18,
                    "name": "南京市",
                    "whole_name": "南京市，江苏省",
                    "simple_py": "NJS",
                    "per_pin_yin": "N",
                    "per_pin_yin2": "N",
                    "city_code": "025",
                    "area_code": "320100",
                    "longitude": "118.767413",
                    "latitude": "32.041544",
                    "children": [
                        {
                            "area_id": 25808,
                            "city_id": 25442,
                            "province_id": 18,
                            "name": "高淳区",
                            "whole_name": "高淳区，南京市，江苏省",
                            "simple_py": "GCQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "025",
                            "area_code": "320118",
                            "longitude": "118.87589",
                            "latitude": "31.327132"
                        },
                        {
                            "area_id": 25811,
                            "city_id": 25442,
                            "province_id": 18,
                            "name": "鼓楼区",
                            "whole_name": "鼓楼区，南京市，江苏省",
                            "simple_py": "GLQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "025",
                            "area_code": "320106",
                            "longitude": "118.769739",
                            "latitude": "32.066966"
                        },
                        {
                            "area_id": 25804,
                            "city_id": 25442,
                            "province_id": 18,
                            "name": "江宁区",
                            "whole_name": "江宁区，南京市，江苏省",
                            "simple_py": "JNQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "025",
                            "area_code": "320115",
                            "longitude": "118.850621",
                            "latitude": "31.953418"
                        },
                        {
                            "area_id": 25810,
                            "city_id": 25442,
                            "province_id": 18,
                            "name": "建邺区",
                            "whole_name": "建邺区，南京市，江苏省",
                            "simple_py": "JYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "025",
                            "area_code": "320105",
                            "longitude": "118.732688",
                            "latitude": "32.004538"
                        },
                        {
                            "area_id": 25803,
                            "city_id": 25442,
                            "province_id": 18,
                            "name": "溧水区",
                            "whole_name": "溧水区，南京市，江苏省",
                            "simple_py": "LSQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "025",
                            "area_code": "320117",
                            "longitude": "119.028732",
                            "latitude": "31.653061"
                        },
                        {
                            "area_id": 25809,
                            "city_id": 25442,
                            "province_id": 18,
                            "name": "六合区",
                            "whole_name": "六合区，南京市，江苏省",
                            "simple_py": "LHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "025",
                            "area_code": "320116",
                            "longitude": "118.85065",
                            "latitude": "32.340655"
                        },
                        {
                            "area_id": 25801,
                            "city_id": 25442,
                            "province_id": 18,
                            "name": "浦口区",
                            "whole_name": "浦口区，南京市，江苏省",
                            "simple_py": "PKQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "025",
                            "area_code": "320111",
                            "longitude": "118.625307",
                            "latitude": "32.05839"
                        },
                        {
                            "area_id": 25806,
                            "city_id": 25442,
                            "province_id": 18,
                            "name": "栖霞区",
                            "whole_name": "栖霞区，南京市，江苏省",
                            "simple_py": "QXQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "025",
                            "area_code": "320113",
                            "longitude": "118.808702",
                            "latitude": "32.102147"
                        },
                        {
                            "area_id": 25807,
                            "city_id": 25442,
                            "province_id": 18,
                            "name": "秦淮区",
                            "whole_name": "秦淮区，南京市，江苏省",
                            "simple_py": "QHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "025",
                            "area_code": "320104",
                            "longitude": "118.786088",
                            "latitude": "32.033818"
                        },
                        {
                            "area_id": 25805,
                            "city_id": 25442,
                            "province_id": 18,
                            "name": "玄武区",
                            "whole_name": "玄武区，南京市，江苏省",
                            "simple_py": "XWQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "025",
                            "area_code": "320102",
                            "longitude": "118.792199",
                            "latitude": "32.050678"
                        },
                        {
                            "area_id": 25802,
                            "city_id": 25442,
                            "province_id": 18,
                            "name": "雨花台区",
                            "whole_name": "雨花台区，南京市，江苏省",
                            "simple_py": "YHTQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "025",
                            "area_code": "320114",
                            "longitude": "118.77207",
                            "latitude": "31.995946"
                        }
                    ]
                },
                {
                    "city_id": 25443,
                    "province_id": 18,
                    "name": "南通市",
                    "whole_name": "南通市，江苏省",
                    "simple_py": "NTS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "N",
                    "city_code": "0513",
                    "area_code": "320600",
                    "longitude": "120.864608",
                    "latitude": "32.016212",
                    "children": [
                        {
                            "area_id": 25948,
                            "city_id": 25443,
                            "province_id": 18,
                            "name": "崇川区",
                            "whole_name": "崇川区，南通市，江苏省",
                            "simple_py": "CCQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0513",
                            "area_code": "320602",
                            "longitude": "120.86635",
                            "latitude": "32.015278"
                        },
                        {
                            "area_id": 25949,
                            "city_id": 25443,
                            "province_id": 18,
                            "name": "港闸区",
                            "whole_name": "港闸区，南通市，江苏省",
                            "simple_py": "GZQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0513",
                            "area_code": "320611",
                            "longitude": "120.8339",
                            "latitude": "32.040299"
                        },
                        {
                            "area_id": 25943,
                            "city_id": 25443,
                            "province_id": 18,
                            "name": "海门市",
                            "whole_name": "海门市，南通市，江苏省",
                            "simple_py": "HMS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0513",
                            "area_code": "320684",
                            "longitude": "121.176609",
                            "latitude": "31.893528"
                        },
                        {
                            "area_id": 25944,
                            "city_id": 25443,
                            "province_id": 18,
                            "name": "海安县",
                            "whole_name": "海安县，南通市，江苏省",
                            "simple_py": "HAX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0513",
                            "area_code": "320621",
                            "longitude": "120.465995",
                            "latitude": "32.540289"
                        },
                        {
                            "area_id": 25945,
                            "city_id": 25443,
                            "province_id": 18,
                            "name": "启东市",
                            "whole_name": "启东市，南通市，江苏省",
                            "simple_py": "QDS",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0513",
                            "area_code": "320681",
                            "longitude": "121.659724",
                            "latitude": "31.810158"
                        },
                        {
                            "area_id": 25942,
                            "city_id": 25443,
                            "province_id": 18,
                            "name": "如皋市",
                            "whole_name": "如皋市，南通市，江苏省",
                            "simple_py": "RGS",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0513",
                            "area_code": "320682",
                            "longitude": "120.566324",
                            "latitude": "32.391591"
                        },
                        {
                            "area_id": 25946,
                            "city_id": 25443,
                            "province_id": 18,
                            "name": "如东县",
                            "whole_name": "如东县，南通市，江苏省",
                            "simple_py": "RDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "R",
                            "city_code": "0513",
                            "area_code": "320623",
                            "longitude": "121.186088",
                            "latitude": "32.311832"
                        },
                        {
                            "area_id": 25947,
                            "city_id": 25443,
                            "province_id": 18,
                            "name": "通州区",
                            "whole_name": "通州区，南通市，江苏省",
                            "simple_py": "TZQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0513",
                            "area_code": "320612",
                            "longitude": "121.073171",
                            "latitude": "32.084287"
                        }
                    ]
                },
                {
                    "city_id": 25439,
                    "province_id": 18,
                    "name": "宿迁市",
                    "whole_name": "宿迁市，江苏省",
                    "simple_py": "SQS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0527",
                    "area_code": "321300",
                    "longitude": "118.275162",
                    "latitude": "33.963008",
                    "children": [
                        {
                            "area_id": 25452,
                            "city_id": 25439,
                            "province_id": 18,
                            "name": "沭阳县",
                            "whole_name": "沭阳县，宿迁市，江苏省",
                            "simple_py": "SYX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0527",
                            "area_code": "321322",
                            "longitude": "118.775889",
                            "latitude": "34.129097"
                        },
                        {
                            "area_id": 25453,
                            "city_id": 25439,
                            "province_id": 18,
                            "name": "泗阳县",
                            "whole_name": "泗阳县，宿迁市，江苏省",
                            "simple_py": "SYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0527",
                            "area_code": "321323",
                            "longitude": "118.681284",
                            "latitude": "33.711433"
                        },
                        {
                            "area_id": 25454,
                            "city_id": 25439,
                            "province_id": 18,
                            "name": "泗洪县",
                            "whole_name": "泗洪县，宿迁市，江苏省",
                            "simple_py": "SHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0527",
                            "area_code": "321324",
                            "longitude": "118.211824",
                            "latitude": "33.456538"
                        },
                        {
                            "area_id": 25455,
                            "city_id": 25439,
                            "province_id": 18,
                            "name": "宿城区",
                            "whole_name": "宿城区，宿迁市，江苏省",
                            "simple_py": "SCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0527",
                            "area_code": "321302",
                            "longitude": "118.278984",
                            "latitude": "33.937726"
                        },
                        {
                            "area_id": 25456,
                            "city_id": 25439,
                            "province_id": 18,
                            "name": "宿豫区",
                            "whole_name": "宿豫区，宿迁市，江苏省",
                            "simple_py": "SYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0527",
                            "area_code": "321311",
                            "longitude": "118.330012",
                            "latitude": "33.941071"
                        }
                    ]
                },
                {
                    "city_id": 25449,
                    "province_id": 18,
                    "name": "苏州市",
                    "whole_name": "苏州市，江苏省",
                    "simple_py": "SZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "S",
                    "city_code": "0512",
                    "area_code": "320500",
                    "longitude": "120.619585",
                    "latitude": "31.299379",
                    "children": [
                        {
                            "area_id": 26670,
                            "city_id": 25449,
                            "province_id": 18,
                            "name": "常熟市",
                            "whole_name": "常熟市，苏州市，江苏省",
                            "simple_py": "CSS",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0512",
                            "area_code": "320581",
                            "longitude": "120.74852",
                            "latitude": "31.658156"
                        },
                        {
                            "area_id": 26673,
                            "city_id": 25449,
                            "province_id": 18,
                            "name": "姑苏区",
                            "whole_name": "姑苏区，苏州市，江苏省",
                            "simple_py": "GSQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0512",
                            "area_code": "320508",
                            "longitude": "120.622249",
                            "latitude": "31.311414"
                        },
                        {
                            "area_id": 26669,
                            "city_id": 25449,
                            "province_id": 18,
                            "name": "虎丘区",
                            "whole_name": "虎丘区，苏州市，江苏省",
                            "simple_py": "HQQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0512",
                            "area_code": "320505",
                            "longitude": "120.566833",
                            "latitude": "31.294845"
                        },
                        {
                            "area_id": 26672,
                            "city_id": 25449,
                            "province_id": 18,
                            "name": "昆山市",
                            "whole_name": "昆山市，苏州市，江苏省",
                            "simple_py": "KSS",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0512",
                            "area_code": "320583",
                            "longitude": "120.958137",
                            "latitude": "31.381925"
                        },
                        {
                            "area_id": 26671,
                            "city_id": 25449,
                            "province_id": 18,
                            "name": "太仓市",
                            "whole_name": "太仓市，苏州市，江苏省",
                            "simple_py": "TCS",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0512",
                            "area_code": "320585",
                            "longitude": "121.112275",
                            "latitude": "31.452568"
                        },
                        {
                            "area_id": 26675,
                            "city_id": 25449,
                            "province_id": 18,
                            "name": "吴江区",
                            "whole_name": "吴江区，苏州市，江苏省",
                            "simple_py": "WJQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0512",
                            "area_code": "320509",
                            "longitude": "120.641601",
                            "latitude": "31.160404"
                        },
                        {
                            "area_id": 26676,
                            "city_id": 25449,
                            "province_id": 18,
                            "name": "吴中区",
                            "whole_name": "吴中区，苏州市，江苏省",
                            "simple_py": "WZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0512",
                            "area_code": "320506",
                            "longitude": "120.624621",
                            "latitude": "31.270839"
                        },
                        {
                            "area_id": 26674,
                            "city_id": 25449,
                            "province_id": 18,
                            "name": "相城区",
                            "whole_name": "相城区，苏州市，江苏省",
                            "simple_py": "XCQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0512",
                            "area_code": "320507",
                            "longitude": "120.618956",
                            "latitude": "31.396684"
                        },
                        {
                            "area_id": 26668,
                            "city_id": 25449,
                            "province_id": 18,
                            "name": "张家港市",
                            "whole_name": "张家港市，苏州市，江苏省",
                            "simple_py": "ZJGS",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0512",
                            "area_code": "320582",
                            "longitude": "120.543441",
                            "latitude": "31.865553"
                        }
                    ]
                },
                {
                    "city_id": 25447,
                    "province_id": 18,
                    "name": "泰州市",
                    "whole_name": "泰州市，江苏省",
                    "simple_py": "TZS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0523",
                    "area_code": "321200",
                    "longitude": "119.915176",
                    "latitude": "32.484882",
                    "children": [
                        {
                            "area_id": 26384,
                            "city_id": 25447,
                            "province_id": 18,
                            "name": "高港区",
                            "whole_name": "高港区，泰州市，江苏省",
                            "simple_py": "GGQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0523",
                            "area_code": "321203",
                            "longitude": "119.88166",
                            "latitude": "32.315701"
                        },
                        {
                            "area_id": 26382,
                            "city_id": 25447,
                            "province_id": 18,
                            "name": "海陵区",
                            "whole_name": "海陵区，泰州市，江苏省",
                            "simple_py": "HLQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0523",
                            "area_code": "321202",
                            "longitude": "119.920187",
                            "latitude": "32.488406"
                        },
                        {
                            "area_id": 26381,
                            "city_id": 25447,
                            "province_id": 18,
                            "name": "靖江市",
                            "whole_name": "靖江市，泰州市，江苏省",
                            "simple_py": "JJS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0523",
                            "area_code": "321282",
                            "longitude": "120.26825",
                            "latitude": "32.018168"
                        },
                        {
                            "area_id": 26385,
                            "city_id": 25447,
                            "province_id": 18,
                            "name": "姜堰区",
                            "whole_name": "姜堰区，泰州市，江苏省",
                            "simple_py": "JYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0523",
                            "area_code": "321204",
                            "longitude": "120.148208",
                            "latitude": "32.508483"
                        },
                        {
                            "area_id": 26383,
                            "city_id": 25447,
                            "province_id": 18,
                            "name": "泰兴市",
                            "whole_name": "泰兴市，泰州市，江苏省",
                            "simple_py": "TXS",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0523",
                            "area_code": "321283",
                            "longitude": "120.020228",
                            "latitude": "32.168784"
                        },
                        {
                            "area_id": 26380,
                            "city_id": 25447,
                            "province_id": 18,
                            "name": "兴化市",
                            "whole_name": "兴化市，泰州市，江苏省",
                            "simple_py": "XHS",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0523",
                            "area_code": "321281",
                            "longitude": "119.840162",
                            "latitude": "32.938065"
                        }
                    ]
                },
                {
                    "city_id": 25444,
                    "province_id": 18,
                    "name": "无锡市",
                    "whole_name": "无锡市，江苏省",
                    "simple_py": "WXS",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "0510",
                    "area_code": "320200",
                    "longitude": "120.301663",
                    "latitude": "31.574729",
                    "children": [
                        {
                            "area_id": 26069,
                            "city_id": 25444,
                            "province_id": 18,
                            "name": "滨湖区",
                            "whole_name": "滨湖区，无锡市，江苏省",
                            "simple_py": "BHQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0510",
                            "area_code": "320211",
                            "longitude": "120.266053",
                            "latitude": "31.550228"
                        },
                        {
                            "area_id": 26064,
                            "city_id": 25444,
                            "province_id": 18,
                            "name": "惠山区",
                            "whole_name": "惠山区，无锡市，江苏省",
                            "simple_py": "HSQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0510",
                            "area_code": "320206",
                            "longitude": "120.303543",
                            "latitude": "31.681019"
                        },
                        {
                            "area_id": 26065,
                            "city_id": 25444,
                            "province_id": 18,
                            "name": "江阴市",
                            "whole_name": "江阴市，无锡市，江苏省",
                            "simple_py": "JYS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0510",
                            "area_code": "320281",
                            "longitude": "120.275891",
                            "latitude": "31.910984"
                        },
                        {
                            "area_id": 26066,
                            "city_id": 25444,
                            "province_id": 18,
                            "name": "梁溪区",
                            "whole_name": "梁溪区，无锡市，江苏省",
                            "simple_py": "LXQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0510",
                            "area_code": "320213",
                            "longitude": "120.296595",
                            "latitude": "31.575706"
                        },
                        {
                            "area_id": 26067,
                            "city_id": 25444,
                            "province_id": 18,
                            "name": "锡山区",
                            "whole_name": "锡山区，无锡市，江苏省",
                            "simple_py": "XSQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0510",
                            "area_code": "320205",
                            "longitude": "120.357298",
                            "latitude": "31.585559"
                        },
                        {
                            "area_id": 26068,
                            "city_id": 25444,
                            "province_id": 18,
                            "name": "新吴区",
                            "whole_name": "新吴区，无锡市，江苏省",
                            "simple_py": "XWQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0510",
                            "area_code": "320214",
                            "longitude": "120.352782",
                            "latitude": "31.550966"
                        },
                        {
                            "area_id": 26063,
                            "city_id": 25444,
                            "province_id": 18,
                            "name": "宜兴市",
                            "whole_name": "宜兴市，无锡市，江苏省",
                            "simple_py": "YXS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0510",
                            "area_code": "320282",
                            "longitude": "119.820538",
                            "latitude": "31.364384"
                        }
                    ]
                },
                {
                    "city_id": 25448,
                    "province_id": 18,
                    "name": "徐州市",
                    "whole_name": "徐州市，江苏省",
                    "simple_py": "XZS",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "0516",
                    "area_code": "320300",
                    "longitude": "117.184811",
                    "latitude": "34.261792",
                    "children": [
                        {
                            "area_id": 26488,
                            "city_id": 25448,
                            "province_id": 18,
                            "name": "丰县",
                            "whole_name": "丰县，徐州市，江苏省",
                            "simple_py": "FX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0516",
                            "area_code": "320321",
                            "longitude": "116.592888",
                            "latitude": "34.696946"
                        },
                        {
                            "area_id": 26494,
                            "city_id": 25448,
                            "province_id": 18,
                            "name": "鼓楼区",
                            "whole_name": "鼓楼区，徐州市，江苏省",
                            "simple_py": "GLQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0516",
                            "area_code": "320302",
                            "longitude": "117.192941",
                            "latitude": "34.269397"
                        },
                        {
                            "area_id": 26493,
                            "city_id": 25448,
                            "province_id": 18,
                            "name": "睢宁县",
                            "whole_name": "睢宁县，徐州市，江苏省",
                            "simple_py": "HNX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0516",
                            "area_code": "320324",
                            "longitude": "117.95066",
                            "latitude": "33.899222"
                        },
                        {
                            "area_id": 26495,
                            "city_id": 25448,
                            "province_id": 18,
                            "name": "贾汪区",
                            "whole_name": "贾汪区，徐州市，江苏省",
                            "simple_py": "JWQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0516",
                            "area_code": "320305",
                            "longitude": "117.450212",
                            "latitude": "34.441642"
                        },
                        {
                            "area_id": 26489,
                            "city_id": 25448,
                            "province_id": 18,
                            "name": "邳州市",
                            "whole_name": "邳州市，徐州市，江苏省",
                            "simple_py": "PZS",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0516",
                            "area_code": "320382",
                            "longitude": "117.963923",
                            "latitude": "34.314708"
                        },
                        {
                            "area_id": 26497,
                            "city_id": 25448,
                            "province_id": 18,
                            "name": "沛县",
                            "whole_name": "沛县，徐州市，江苏省",
                            "simple_py": "PX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "P",
                            "city_code": "0516",
                            "area_code": "320322",
                            "longitude": "116.937182",
                            "latitude": "34.729044"
                        },
                        {
                            "area_id": 26491,
                            "city_id": 25448,
                            "province_id": 18,
                            "name": "泉山区",
                            "whole_name": "泉山区，徐州市，江苏省",
                            "simple_py": "QSQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0516",
                            "area_code": "320311",
                            "longitude": "117.182225",
                            "latitude": "34.262249"
                        },
                        {
                            "area_id": 26492,
                            "city_id": 25448,
                            "province_id": 18,
                            "name": "铜山区",
                            "whole_name": "铜山区，徐州市，江苏省",
                            "simple_py": "TSQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0516",
                            "area_code": "320312",
                            "longitude": "117.183894",
                            "latitude": "34.19288"
                        },
                        {
                            "area_id": 26490,
                            "city_id": 25448,
                            "province_id": 18,
                            "name": "新沂市",
                            "whole_name": "新沂市，徐州市，江苏省",
                            "simple_py": "XYS",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0516",
                            "area_code": "320381",
                            "longitude": "118.345828",
                            "latitude": "34.368779"
                        },
                        {
                            "area_id": 26496,
                            "city_id": 25448,
                            "province_id": 18,
                            "name": "云龙区",
                            "whole_name": "云龙区，徐州市，江苏省",
                            "simple_py": "YLQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0516",
                            "area_code": "320303",
                            "longitude": "117.194589",
                            "latitude": "34.254805"
                        }
                    ]
                },
                {
                    "city_id": 25441,
                    "province_id": 18,
                    "name": "扬州市",
                    "whole_name": "扬州市，江苏省",
                    "simple_py": "YZS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0514",
                    "area_code": "321000",
                    "longitude": "119.421003",
                    "latitude": "32.393159",
                    "children": [
                        {
                            "area_id": 25696,
                            "city_id": 25441,
                            "province_id": 18,
                            "name": "宝应县",
                            "whole_name": "宝应县，扬州市，江苏省",
                            "simple_py": "BYX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0514",
                            "area_code": "321023",
                            "longitude": "119.321284",
                            "latitude": "33.23694"
                        },
                        {
                            "area_id": 25698,
                            "city_id": 25441,
                            "province_id": 18,
                            "name": "广陵区",
                            "whole_name": "广陵区，扬州市，江苏省",
                            "simple_py": "GLQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0514",
                            "area_code": "321002",
                            "longitude": "119.442267",
                            "latitude": "32.392154"
                        },
                        {
                            "area_id": 25700,
                            "city_id": 25441,
                            "province_id": 18,
                            "name": "高邮市",
                            "whole_name": "高邮市，扬州市，江苏省",
                            "simple_py": "GYS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0514",
                            "area_code": "321084",
                            "longitude": "119.443842",
                            "latitude": "32.785164"
                        },
                        {
                            "area_id": 25699,
                            "city_id": 25441,
                            "province_id": 18,
                            "name": "邗江区",
                            "whole_name": "邗江区，扬州市，江苏省",
                            "simple_py": "HJQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0514",
                            "area_code": "321003",
                            "longitude": "119.397777",
                            "latitude": "32.377899"
                        },
                        {
                            "area_id": 25697,
                            "city_id": 25441,
                            "province_id": 18,
                            "name": "江都区",
                            "whole_name": "江都区，扬州市，江苏省",
                            "simple_py": "JDQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0514",
                            "area_code": "321012",
                            "longitude": "119.567481",
                            "latitude": "32.426564"
                        },
                        {
                            "area_id": 25701,
                            "city_id": 25441,
                            "province_id": 18,
                            "name": "仪征市",
                            "whole_name": "仪征市，扬州市，江苏省",
                            "simple_py": "YZS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0514",
                            "area_code": "321081",
                            "longitude": "119.182443",
                            "latitude": "32.271965"
                        }
                    ]
                },
                {
                    "city_id": 25451,
                    "province_id": 18,
                    "name": "盐城市",
                    "whole_name": "盐城市，江苏省",
                    "simple_py": "YCS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Y",
                    "city_code": "0515",
                    "area_code": "320900",
                    "longitude": "120.139998",
                    "latitude": "33.377631",
                    "children": [
                        {
                            "area_id": 26851,
                            "city_id": 25451,
                            "province_id": 18,
                            "name": "滨海县",
                            "whole_name": "滨海县，盐城市，江苏省",
                            "simple_py": "BHX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0515",
                            "area_code": "320922",
                            "longitude": "119.828434",
                            "latitude": "33.989888"
                        },
                        {
                            "area_id": 26857,
                            "city_id": 25451,
                            "province_id": 18,
                            "name": "大丰区",
                            "whole_name": "大丰区，盐城市，江苏省",
                            "simple_py": "DFQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0515",
                            "area_code": "320904",
                            "longitude": "120.470324",
                            "latitude": "33.199531"
                        },
                        {
                            "area_id": 26858,
                            "city_id": 25451,
                            "province_id": 18,
                            "name": "东台市",
                            "whole_name": "东台市，盐城市，江苏省",
                            "simple_py": "DTS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0515",
                            "area_code": "320981",
                            "longitude": "120.314101",
                            "latitude": "32.853174"
                        },
                        {
                            "area_id": 26853,
                            "city_id": 25451,
                            "province_id": 18,
                            "name": "阜宁县",
                            "whole_name": "阜宁县，盐城市，江苏省",
                            "simple_py": "FNX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0515",
                            "area_code": "320923",
                            "longitude": "119.805338",
                            "latitude": "33.78573"
                        },
                        {
                            "area_id": 26854,
                            "city_id": 25451,
                            "province_id": 18,
                            "name": "建湖县",
                            "whole_name": "建湖县，盐城市，江苏省",
                            "simple_py": "JHX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0515",
                            "area_code": "320925",
                            "longitude": "119.793105",
                            "latitude": "33.472621"
                        },
                        {
                            "area_id": 26852,
                            "city_id": 25451,
                            "province_id": 18,
                            "name": "射阳县",
                            "whole_name": "射阳县，盐城市，江苏省",
                            "simple_py": "SYX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0515",
                            "area_code": "320924",
                            "longitude": "120.257444",
                            "latitude": "33.773779"
                        },
                        {
                            "area_id": 26855,
                            "city_id": 25451,
                            "province_id": 18,
                            "name": "亭湖区",
                            "whole_name": "亭湖区，盐城市，江苏省",
                            "simple_py": "THQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0515",
                            "area_code": "320902",
                            "longitude": "120.136078",
                            "latitude": "33.383912"
                        },
                        {
                            "area_id": 26850,
                            "city_id": 25451,
                            "province_id": 18,
                            "name": "响水县",
                            "whole_name": "响水县，盐城市，江苏省",
                            "simple_py": "XSX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0515",
                            "area_code": "320921",
                            "longitude": "119.579573",
                            "latitude": "34.19996"
                        },
                        {
                            "area_id": 26856,
                            "city_id": 25451,
                            "province_id": 18,
                            "name": "盐都区",
                            "whole_name": "盐都区，盐城市，江苏省",
                            "simple_py": "YDQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0515",
                            "area_code": "320903",
                            "longitude": "120.139753",
                            "latitude": "33.341288"
                        }
                    ]
                },
                {
                    "city_id": 25445,
                    "province_id": 18,
                    "name": "镇江市",
                    "whole_name": "镇江市，江苏省",
                    "simple_py": "ZJS",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "0511",
                    "area_code": "321100",
                    "longitude": "119.452753",
                    "latitude": "32.204402",
                    "children": [
                        {
                            "area_id": 26155,
                            "city_id": 25445,
                            "province_id": 18,
                            "name": "丹阳市",
                            "whole_name": "丹阳市，镇江市，江苏省",
                            "simple_py": "DYS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0511",
                            "area_code": "321181",
                            "longitude": "119.581911",
                            "latitude": "31.991459"
                        },
                        {
                            "area_id": 26158,
                            "city_id": 25445,
                            "province_id": 18,
                            "name": "丹徒区",
                            "whole_name": "丹徒区，镇江市，江苏省",
                            "simple_py": "DTQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0511",
                            "area_code": "321112",
                            "longitude": "119.433883",
                            "latitude": "32.128972"
                        },
                        {
                            "area_id": 26157,
                            "city_id": 25445,
                            "province_id": 18,
                            "name": "句容市",
                            "whole_name": "句容市，镇江市，江苏省",
                            "simple_py": "JRS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0511",
                            "area_code": "321183",
                            "longitude": "119.167135",
                            "latitude": "31.947355"
                        },
                        {
                            "area_id": 26159,
                            "city_id": 25445,
                            "province_id": 18,
                            "name": "京口区",
                            "whole_name": "京口区，镇江市，江苏省",
                            "simple_py": "JKQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0511",
                            "area_code": "321102",
                            "longitude": "119.454571",
                            "latitude": "32.206191"
                        },
                        {
                            "area_id": 26156,
                            "city_id": 25445,
                            "province_id": 18,
                            "name": "润州区",
                            "whole_name": "润州区，镇江市，江苏省",
                            "simple_py": "RZQ",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0511",
                            "area_code": "321111",
                            "longitude": "119.414877",
                            "latitude": "32.213501"
                        },
                        {
                            "area_id": 26154,
                            "city_id": 25445,
                            "province_id": 18,
                            "name": "扬中市",
                            "whole_name": "扬中市，镇江市，江苏省",
                            "simple_py": "YZS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0511",
                            "area_code": "321182",
                            "longitude": "119.828054",
                            "latitude": "32.237266"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 22,
            "name": "江西省",
            "whole_name": "江西省",
            "simple_py": "JXS",
            "per_pin_yin": " ",
            "per_pin_yin2": "J",
            "city_code": "",
            "area_code": "360000",
            "longitude": "115.892151",
            "latitude": "28.676493",
            "children": [
                {
                    "city_id": 29184,
                    "province_id": 22,
                    "name": "抚州市",
                    "whole_name": "抚州市，江西省",
                    "simple_py": "FZS",
                    "per_pin_yin": "F",
                    "per_pin_yin2": "F",
                    "city_code": "0794",
                    "area_code": "361000",
                    "longitude": "116.358351",
                    "latitude": "27.98385",
                    "children": [
                        {
                            "area_id": 29510,
                            "city_id": 29184,
                            "province_id": 22,
                            "name": "崇仁县",
                            "whole_name": "崇仁县，抚州市，江西省",
                            "simple_py": "CRX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0794",
                            "area_code": "361024",
                            "longitude": "116.059109",
                            "latitude": "27.760907"
                        },
                        {
                            "area_id": 29503,
                            "city_id": 29184,
                            "province_id": 22,
                            "name": "东乡区",
                            "whole_name": "东乡区，抚州市，江西省",
                            "simple_py": "DXQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0794",
                            "area_code": "361003",
                            "longitude": "116.605341",
                            "latitude": "28.2325"
                        },
                        {
                            "area_id": 29509,
                            "city_id": 29184,
                            "province_id": 22,
                            "name": "广昌县",
                            "whole_name": "广昌县，抚州市，江西省",
                            "simple_py": "GCX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0794",
                            "area_code": "361030",
                            "longitude": "116.327291",
                            "latitude": "26.838426"
                        },
                        {
                            "area_id": 29504,
                            "city_id": 29184,
                            "province_id": 22,
                            "name": "金溪县",
                            "whole_name": "金溪县，抚州市，江西省",
                            "simple_py": "JXX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0794",
                            "area_code": "361027",
                            "longitude": "116.778751",
                            "latitude": "27.907387"
                        },
                        {
                            "area_id": 29508,
                            "city_id": 29184,
                            "province_id": 22,
                            "name": "乐安县",
                            "whole_name": "乐安县，抚州市，江西省",
                            "simple_py": "LAX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0794",
                            "area_code": "361025",
                            "longitude": "115.838432",
                            "latitude": "27.420101"
                        },
                        {
                            "area_id": 29512,
                            "city_id": 29184,
                            "province_id": 22,
                            "name": "临川区",
                            "whole_name": "临川区，抚州市，江西省",
                            "simple_py": "LCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0794",
                            "area_code": "361002",
                            "longitude": "116.361404",
                            "latitude": "27.981919"
                        },
                        {
                            "area_id": 29513,
                            "city_id": 29184,
                            "province_id": 22,
                            "name": "黎川县",
                            "whole_name": "黎川县，抚州市，江西省",
                            "simple_py": "LCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0794",
                            "area_code": "361022",
                            "longitude": "116.91457",
                            "latitude": "27.292561"
                        },
                        {
                            "area_id": 29506,
                            "city_id": 29184,
                            "province_id": 22,
                            "name": "南丰县",
                            "whole_name": "南丰县，抚州市，江西省",
                            "simple_py": "NFX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0794",
                            "area_code": "361023",
                            "longitude": "116.532994",
                            "latitude": "27.210132"
                        },
                        {
                            "area_id": 29507,
                            "city_id": 29184,
                            "province_id": 22,
                            "name": "南城县",
                            "whole_name": "南城县，抚州市，江西省",
                            "simple_py": "NCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0794",
                            "area_code": "361021",
                            "longitude": "116.63945",
                            "latitude": "27.55531"
                        },
                        {
                            "area_id": 29511,
                            "city_id": 29184,
                            "province_id": 22,
                            "name": "宜黄县",
                            "whole_name": "宜黄县，抚州市，江西省",
                            "simple_py": "YHX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0794",
                            "area_code": "361026",
                            "longitude": "116.223023",
                            "latitude": "27.546512"
                        },
                        {
                            "area_id": 29505,
                            "city_id": 29184,
                            "province_id": 22,
                            "name": "资溪县",
                            "whole_name": "资溪县，抚州市，江西省",
                            "simple_py": "ZXX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0794",
                            "area_code": "361028",
                            "longitude": "117.066095",
                            "latitude": "27.70653"
                        }
                    ]
                },
                {
                    "city_id": 29187,
                    "province_id": 22,
                    "name": "赣州市",
                    "whole_name": "赣州市，江西省",
                    "simple_py": "GZS",
                    "per_pin_yin": "G",
                    "per_pin_yin2": "G",
                    "city_code": "0797",
                    "area_code": "360700",
                    "longitude": "114.940278",
                    "latitude": "25.85097",
                    "children": [
                        {
                            "area_id": 29983,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "安远县",
                            "whole_name": "安远县，赣州市，江西省",
                            "simple_py": "AYX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0797",
                            "area_code": "360726",
                            "longitude": "115.392328",
                            "latitude": "25.134591"
                        },
                        {
                            "area_id": 29982,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "崇义县",
                            "whole_name": "崇义县，赣州市，江西省",
                            "simple_py": "CYX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0797",
                            "area_code": "360725",
                            "longitude": "114.307348",
                            "latitude": "25.687911"
                        },
                        {
                            "area_id": 29984,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "大余县",
                            "whole_name": "大余县，赣州市，江西省",
                            "simple_py": "DYX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0797",
                            "area_code": "360723",
                            "longitude": "114.362243",
                            "latitude": "25.395937"
                        },
                        {
                            "area_id": 29988,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "定南县",
                            "whole_name": "定南县，赣州市，江西省",
                            "simple_py": "DNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0797",
                            "area_code": "360728",
                            "longitude": "115.03267",
                            "latitude": "24.774277"
                        },
                        {
                            "area_id": 29992,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "赣县区",
                            "whole_name": "赣县区，赣州市，江西省",
                            "simple_py": "GXQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0797",
                            "area_code": "360704",
                            "longitude": "115.018461",
                            "latitude": "25.865432"
                        },
                        {
                            "area_id": 29981,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "会昌县",
                            "whole_name": "会昌县，赣州市，江西省",
                            "simple_py": "HCX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0797",
                            "area_code": "360733",
                            "longitude": "115.791158",
                            "latitude": "25.599125"
                        },
                        {
                            "area_id": 29989,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "龙南县",
                            "whole_name": "龙南县，赣州市，江西省",
                            "simple_py": "LNX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0797",
                            "area_code": "360727",
                            "longitude": "114.792657",
                            "latitude": "24.90476"
                        },
                        {
                            "area_id": 29975,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "宁都县",
                            "whole_name": "宁都县，赣州市，江西省",
                            "simple_py": "NDX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0797",
                            "area_code": "360730",
                            "longitude": "116.018782",
                            "latitude": "26.472054"
                        },
                        {
                            "area_id": 29991,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "南康区",
                            "whole_name": "南康区，赣州市，江西省",
                            "simple_py": "NKQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0797",
                            "area_code": "360703",
                            "longitude": "114.756933",
                            "latitude": "25.661721"
                        },
                        {
                            "area_id": 29987,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "全南县",
                            "whole_name": "全南县，赣州市，江西省",
                            "simple_py": "QNX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0797",
                            "area_code": "360729",
                            "longitude": "114.531589",
                            "latitude": "24.742651"
                        },
                        {
                            "area_id": 29979,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "瑞金市",
                            "whole_name": "瑞金市，赣州市，江西省",
                            "simple_py": "RJS",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0797",
                            "area_code": "360781",
                            "longitude": "116.034854",
                            "latitude": "25.875278"
                        },
                        {
                            "area_id": 29977,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "石城县",
                            "whole_name": "石城县，赣州市，江西省",
                            "simple_py": "SCX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0797",
                            "area_code": "360735",
                            "longitude": "116.342249",
                            "latitude": "26.326582"
                        },
                        {
                            "area_id": 29980,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "上犹县",
                            "whole_name": "上犹县，赣州市，江西省",
                            "simple_py": "SYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0797",
                            "area_code": "360724",
                            "longitude": "114.540537",
                            "latitude": "25.794284"
                        },
                        {
                            "area_id": 29976,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "兴国县",
                            "whole_name": "兴国县，赣州市，江西省",
                            "simple_py": "XGX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0797",
                            "area_code": "360732",
                            "longitude": "115.351896",
                            "latitude": "26.330489"
                        },
                        {
                            "area_id": 29985,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "信丰县",
                            "whole_name": "信丰县，赣州市，江西省",
                            "simple_py": "XFX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0797",
                            "area_code": "360722",
                            "longitude": "114.930893",
                            "latitude": "25.38023"
                        },
                        {
                            "area_id": 29986,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "寻乌县",
                            "whole_name": "寻乌县，赣州市，江西省",
                            "simple_py": "XWX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0797",
                            "area_code": "360734",
                            "longitude": "115.651399",
                            "latitude": "24.954136"
                        },
                        {
                            "area_id": 29978,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "于都县",
                            "whole_name": "于都县，赣州市，江西省",
                            "simple_py": "YDX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0797",
                            "area_code": "360731",
                            "longitude": "115.411198",
                            "latitude": "25.955033"
                        },
                        {
                            "area_id": 29990,
                            "city_id": 29187,
                            "province_id": 22,
                            "name": "章贡区",
                            "whole_name": "章贡区，赣州市，江西省",
                            "simple_py": "ZGQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0797",
                            "area_code": "360702",
                            "longitude": "114.93872",
                            "latitude": "25.851367"
                        }
                    ]
                },
                {
                    "city_id": 29182,
                    "province_id": 22,
                    "name": "景德镇市",
                    "whole_name": "景德镇市，江西省",
                    "simple_py": "JDZS",
                    "per_pin_yin": "J",
                    "per_pin_yin2": "J",
                    "city_code": "0798",
                    "area_code": "360200",
                    "longitude": "117.214664",
                    "latitude": "29.29256",
                    "children": [
                        {
                            "area_id": 29194,
                            "city_id": 29182,
                            "province_id": 22,
                            "name": "昌江区",
                            "whole_name": "昌江区，景德镇市，江西省",
                            "simple_py": "CJQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0798",
                            "area_code": "360202",
                            "longitude": "117.195023",
                            "latitude": "29.288465"
                        },
                        {
                            "area_id": 29195,
                            "city_id": 29182,
                            "province_id": 22,
                            "name": "浮梁县",
                            "whole_name": "浮梁县，景德镇市，江西省",
                            "simple_py": "FLX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0798",
                            "area_code": "360222",
                            "longitude": "117.217611",
                            "latitude": "29.352251"
                        },
                        {
                            "area_id": 29193,
                            "city_id": 29182,
                            "province_id": 22,
                            "name": "乐平市",
                            "whole_name": "乐平市，景德镇市，江西省",
                            "simple_py": "LPS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0798",
                            "area_code": "360281",
                            "longitude": "117.129376",
                            "latitude": "28.967361"
                        },
                        {
                            "area_id": 29196,
                            "city_id": 29182,
                            "province_id": 22,
                            "name": "珠山区",
                            "whole_name": "珠山区，景德镇市，江西省",
                            "simple_py": "ZSQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0798",
                            "area_code": "360203",
                            "longitude": "117.214814",
                            "latitude": "29.292812"
                        }
                    ]
                },
                {
                    "city_id": 29183,
                    "province_id": 22,
                    "name": "九江市",
                    "whole_name": "九江市，江西省",
                    "simple_py": "JJS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "J",
                    "city_code": "0792",
                    "area_code": "360400",
                    "longitude": "115.992811",
                    "latitude": "29.712034",
                    "children": [
                        {
                            "area_id": 29260,
                            "city_id": 29183,
                            "province_id": 22,
                            "name": "柴桑区",
                            "whole_name": "柴桑区，九江市，江西省",
                            "simple_py": "CSQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0792",
                            "area_code": "360404",
                            "longitude": "115.892977",
                            "latitude": "29.610264"
                        },
                        {
                            "area_id": 29263,
                            "city_id": 29183,
                            "province_id": 22,
                            "name": "都昌县",
                            "whole_name": "都昌县，九江市，江西省",
                            "simple_py": "DCX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0792",
                            "area_code": "360428",
                            "longitude": "116.205114",
                            "latitude": "29.275105"
                        },
                        {
                            "area_id": 29268,
                            "city_id": 29183,
                            "province_id": 22,
                            "name": "德安县",
                            "whole_name": "德安县，九江市，江西省",
                            "simple_py": "DAX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0792",
                            "area_code": "360426",
                            "longitude": "115.762611",
                            "latitude": "29.327474"
                        },
                        {
                            "area_id": 29270,
                            "city_id": 29183,
                            "province_id": 22,
                            "name": "共青城市",
                            "whole_name": "共青城市，九江市，江西省",
                            "simple_py": "GQCS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0792",
                            "area_code": "360482",
                            "longitude": "115.805712",
                            "latitude": "29.247884"
                        },
                        {
                            "area_id": 29261,
                            "city_id": 29183,
                            "province_id": 22,
                            "name": "湖口县",
                            "whole_name": "湖口县，九江市，江西省",
                            "simple_py": "HKX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0792",
                            "area_code": "360429",
                            "longitude": "116.244313",
                            "latitude": "29.7263"
                        },
                        {
                            "area_id": 29265,
                            "city_id": 29183,
                            "province_id": 22,
                            "name": "庐山市",
                            "whole_name": "庐山市，九江市，江西省",
                            "simple_py": "LSS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0792",
                            "area_code": "360483",
                            "longitude": "116.043743",
                            "latitude": "29.456169"
                        },
                        {
                            "area_id": 29266,
                            "city_id": 29183,
                            "province_id": 22,
                            "name": "濂溪区",
                            "whole_name": "濂溪区，九江市，江西省",
                            "simple_py": "LXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0792",
                            "area_code": "360402",
                            "longitude": "115.99012",
                            "latitude": "29.676175"
                        },
                        {
                            "area_id": 29258,
                            "city_id": 29183,
                            "province_id": 22,
                            "name": "彭泽县",
                            "whole_name": "彭泽县，九江市，江西省",
                            "simple_py": "PZX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0792",
                            "area_code": "360430",
                            "longitude": "116.55584",
                            "latitude": "29.898865"
                        },
                        {
                            "area_id": 29262,
                            "city_id": 29183,
                            "province_id": 22,
                            "name": "瑞昌市",
                            "whole_name": "瑞昌市，九江市，江西省",
                            "simple_py": "RCS",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0792",
                            "area_code": "360481",
                            "longitude": "115.669081",
                            "latitude": "29.676599"
                        },
                        {
                            "area_id": 29259,
                            "city_id": 29183,
                            "province_id": 22,
                            "name": "武宁县",
                            "whole_name": "武宁县，九江市，江西省",
                            "simple_py": "WNX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0792",
                            "area_code": "360423",
                            "longitude": "115.105646",
                            "latitude": "29.260182"
                        },
                        {
                            "area_id": 29264,
                            "city_id": 29183,
                            "province_id": 22,
                            "name": "修水县",
                            "whole_name": "修水县，九江市，江西省",
                            "simple_py": "XSX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0792",
                            "area_code": "360424",
                            "longitude": "114.573428",
                            "latitude": "29.032729"
                        },
                        {
                            "area_id": 29267,
                            "city_id": 29183,
                            "province_id": 22,
                            "name": "浔阳区",
                            "whole_name": "浔阳区，九江市，江西省",
                            "simple_py": "XYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0792",
                            "area_code": "360403",
                            "longitude": "115.995947",
                            "latitude": "29.72465"
                        },
                        {
                            "area_id": 29269,
                            "city_id": 29183,
                            "province_id": 22,
                            "name": "永修县",
                            "whole_name": "永修县，九江市，江西省",
                            "simple_py": "YXX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0792",
                            "area_code": "360425",
                            "longitude": "115.809055",
                            "latitude": "29.018212"
                        }
                    ]
                },
                {
                    "city_id": 29190,
                    "province_id": 22,
                    "name": "吉安市",
                    "whole_name": "吉安市，江西省",
                    "simple_py": "JAS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "J",
                    "city_code": "0796",
                    "area_code": "360800",
                    "longitude": "114.986373",
                    "latitude": "27.111699",
                    "children": [
                        {
                            "area_id": 30525,
                            "city_id": 29190,
                            "province_id": 22,
                            "name": "安福县",
                            "whole_name": "安福县，吉安市，江西省",
                            "simple_py": "AFX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0796",
                            "area_code": "360829",
                            "longitude": "114.61384",
                            "latitude": "27.382746"
                        },
                        {
                            "area_id": 30513,
                            "city_id": 29190,
                            "province_id": 22,
                            "name": "吉水县",
                            "whole_name": "吉水县，吉安市，江西省",
                            "simple_py": "JSX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0796",
                            "area_code": "360822",
                            "longitude": "115.134569",
                            "latitude": "27.213445"
                        },
                        {
                            "area_id": 30517,
                            "city_id": 29190,
                            "province_id": 22,
                            "name": "吉州区",
                            "whole_name": "吉州区，吉安市，江西省",
                            "simple_py": "JZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0796",
                            "area_code": "360802",
                            "longitude": "114.987331",
                            "latitude": "27.112367"
                        },
                        {
                            "area_id": 30519,
                            "city_id": 29190,
                            "province_id": 22,
                            "name": "吉安县",
                            "whole_name": "吉安县，吉安市，江西省",
                            "simple_py": "JAX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0796",
                            "area_code": "360821",
                            "longitude": "114.905117",
                            "latitude": "27.040042"
                        },
                        {
                            "area_id": 30523,
                            "city_id": 29190,
                            "province_id": 22,
                            "name": "井冈山市",
                            "whole_name": "井冈山市，吉安市，江西省",
                            "simple_py": "JGSS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0796",
                            "area_code": "360881",
                            "longitude": "114.284421",
                            "latitude": "26.745919"
                        },
                        {
                            "area_id": 30518,
                            "city_id": 29190,
                            "province_id": 22,
                            "name": "青原区",
                            "whole_name": "青原区，吉安市，江西省",
                            "simple_py": "QYQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0796",
                            "area_code": "360803",
                            "longitude": "115.016306",
                            "latitude": "27.105879"
                        },
                        {
                            "area_id": 30514,
                            "city_id": 29190,
                            "province_id": 22,
                            "name": "遂川县",
                            "whole_name": "遂川县，吉安市，江西省",
                            "simple_py": "SCX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0796",
                            "area_code": "360827",
                            "longitude": "114.51689",
                            "latitude": "26.323705"
                        },
                        {
                            "area_id": 30522,
                            "city_id": 29190,
                            "province_id": 22,
                            "name": "泰和县",
                            "whole_name": "泰和县，吉安市，江西省",
                            "simple_py": "THX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0796",
                            "area_code": "360826",
                            "longitude": "114.901393",
                            "latitude": "26.790164"
                        },
                        {
                            "area_id": 30520,
                            "city_id": 29190,
                            "province_id": 22,
                            "name": "万安县",
                            "whole_name": "万安县，吉安市，江西省",
                            "simple_py": "WAX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0796",
                            "area_code": "360828",
                            "longitude": "114.784694",
                            "latitude": "26.462085"
                        },
                        {
                            "area_id": 30521,
                            "city_id": 29190,
                            "province_id": 22,
                            "name": "峡江县",
                            "whole_name": "峡江县，吉安市，江西省",
                            "simple_py": "XJX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0796",
                            "area_code": "360823",
                            "longitude": "115.319331",
                            "latitude": "27.580862"
                        },
                        {
                            "area_id": 30524,
                            "city_id": 29190,
                            "province_id": 22,
                            "name": "新干县",
                            "whole_name": "新干县，吉安市，江西省",
                            "simple_py": "XGX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0796",
                            "area_code": "360824",
                            "longitude": "115.399294",
                            "latitude": "27.755758"
                        },
                        {
                            "area_id": 30515,
                            "city_id": 29190,
                            "province_id": 22,
                            "name": "永新县",
                            "whole_name": "永新县，吉安市，江西省",
                            "simple_py": "YXX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0796",
                            "area_code": "360830",
                            "longitude": "114.242534",
                            "latitude": "26.944721"
                        },
                        {
                            "area_id": 30516,
                            "city_id": 29190,
                            "province_id": 22,
                            "name": "永丰县",
                            "whole_name": "永丰县，吉安市，江西省",
                            "simple_py": "YFX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0796",
                            "area_code": "360825",
                            "longitude": "115.435559",
                            "latitude": "27.321087"
                        }
                    ]
                },
                {
                    "city_id": 29189,
                    "province_id": 22,
                    "name": "南昌市",
                    "whole_name": "南昌市，江西省",
                    "simple_py": "NCS",
                    "per_pin_yin": "N",
                    "per_pin_yin2": "N",
                    "city_code": "0791",
                    "area_code": "360100",
                    "longitude": "115.892151",
                    "latitude": "28.676493",
                    "children": [
                        {
                            "area_id": 30367,
                            "city_id": 29189,
                            "province_id": 22,
                            "name": "安义县",
                            "whole_name": "安义县，南昌市，江西省",
                            "simple_py": "AYX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0791",
                            "area_code": "360123",
                            "longitude": "115.553109",
                            "latitude": "28.841334"
                        },
                        {
                            "area_id": 30375,
                            "city_id": 29189,
                            "province_id": 22,
                            "name": "东湖区",
                            "whole_name": "东湖区，南昌市，江西省",
                            "simple_py": "DHQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0791",
                            "area_code": "360102",
                            "longitude": "115.889675",
                            "latitude": "28.682988"
                        },
                        {
                            "area_id": 30368,
                            "city_id": 29189,
                            "province_id": 22,
                            "name": "进贤县",
                            "whole_name": "进贤县，南昌市，江西省",
                            "simple_py": "JXX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0791",
                            "area_code": "360124",
                            "longitude": "116.267671",
                            "latitude": "28.365681"
                        },
                        {
                            "area_id": 30370,
                            "city_id": 29189,
                            "province_id": 22,
                            "name": "南昌县",
                            "whole_name": "南昌县，南昌市，江西省",
                            "simple_py": "NCX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0791",
                            "area_code": "360121",
                            "longitude": "115.942465",
                            "latitude": "28.543781"
                        },
                        {
                            "area_id": 30369,
                            "city_id": 29189,
                            "province_id": 22,
                            "name": "青云谱区",
                            "whole_name": "青云谱区，南昌市，江西省",
                            "simple_py": "QYPQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0791",
                            "area_code": "360104",
                            "longitude": "115.907292",
                            "latitude": "28.635724"
                        },
                        {
                            "area_id": 30371,
                            "city_id": 29189,
                            "province_id": 22,
                            "name": "青山湖区",
                            "whole_name": "青山湖区，南昌市，江西省",
                            "simple_py": "QSHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0791",
                            "area_code": "360111",
                            "longitude": "115.949044",
                            "latitude": "28.689292"
                        },
                        {
                            "area_id": 30372,
                            "city_id": 29189,
                            "province_id": 22,
                            "name": "湾里区",
                            "whole_name": "湾里区，南昌市，江西省",
                            "simple_py": "WLQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0791",
                            "area_code": "360105",
                            "longitude": "115.731324",
                            "latitude": "28.714803"
                        },
                        {
                            "area_id": 30373,
                            "city_id": 29189,
                            "province_id": 22,
                            "name": "新建区",
                            "whole_name": "新建区，南昌市，江西省",
                            "simple_py": "XJQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0791",
                            "area_code": "360112",
                            "longitude": "115.820806",
                            "latitude": "28.690788"
                        },
                        {
                            "area_id": 30374,
                            "city_id": 29189,
                            "province_id": 22,
                            "name": "西湖区",
                            "whole_name": "西湖区，南昌市，江西省",
                            "simple_py": "XHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0791",
                            "area_code": "360103",
                            "longitude": "115.91065",
                            "latitude": "28.662901"
                        }
                    ]
                },
                {
                    "city_id": 29191,
                    "province_id": 22,
                    "name": "萍乡市",
                    "whole_name": "萍乡市，江西省",
                    "simple_py": "PXS",
                    "per_pin_yin": "P",
                    "per_pin_yin2": "P",
                    "city_code": "0799",
                    "area_code": "360300",
                    "longitude": "113.852186",
                    "latitude": "27.622946",
                    "children": [
                        {
                            "area_id": 30782,
                            "city_id": 29191,
                            "province_id": 22,
                            "name": "安源区",
                            "whole_name": "安源区，萍乡市，江西省",
                            "simple_py": "AYQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0799",
                            "area_code": "360302",
                            "longitude": "113.855044",
                            "latitude": "27.625826"
                        },
                        {
                            "area_id": 30784,
                            "city_id": 29191,
                            "province_id": 22,
                            "name": "芦溪县",
                            "whole_name": "芦溪县，萍乡市，江西省",
                            "simple_py": "LXX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0799",
                            "area_code": "360323",
                            "longitude": "114.041206",
                            "latitude": "27.633633"
                        },
                        {
                            "area_id": 30785,
                            "city_id": 29191,
                            "province_id": 22,
                            "name": "莲花县",
                            "whole_name": "莲花县，萍乡市，江西省",
                            "simple_py": "LHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0799",
                            "area_code": "360321",
                            "longitude": "113.955582",
                            "latitude": "27.127807"
                        },
                        {
                            "area_id": 30783,
                            "city_id": 29191,
                            "province_id": 22,
                            "name": "上栗县",
                            "whole_name": "上栗县，萍乡市，江西省",
                            "simple_py": "SLX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0799",
                            "area_code": "360322",
                            "longitude": "113.800525",
                            "latitude": "27.877041"
                        },
                        {
                            "area_id": 30781,
                            "city_id": 29191,
                            "province_id": 22,
                            "name": "湘东区",
                            "whole_name": "湘东区，萍乡市，江西省",
                            "simple_py": "XDQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0799",
                            "area_code": "360313",
                            "longitude": "113.7456",
                            "latitude": "27.639319"
                        }
                    ]
                },
                {
                    "city_id": 29185,
                    "province_id": 22,
                    "name": "上饶市",
                    "whole_name": "上饶市，江西省",
                    "simple_py": "SRS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0793",
                    "area_code": "361100",
                    "longitude": "117.971185",
                    "latitude": "28.44442",
                    "children": [
                        {
                            "area_id": 29695,
                            "city_id": 29185,
                            "province_id": 22,
                            "name": "德兴市",
                            "whole_name": "德兴市，上饶市，江西省",
                            "simple_py": "DXS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0793",
                            "area_code": "361181",
                            "longitude": "117.578732",
                            "latitude": "28.945034"
                        },
                        {
                            "area_id": 29700,
                            "city_id": 29185,
                            "province_id": 22,
                            "name": "上饶县",
                            "whole_name": "上饶县，上饶市，江西省",
                            "simple_py": "GXQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0793",
                            "area_code": "361121",
                            "longitude": "117.90612",
                            "latitude": "28.453897"
                        },
                        {
                            "area_id": 29701,
                            "city_id": 29185,
                            "province_id": 22,
                            "name": "广丰区",
                            "whole_name": "广丰区，上饶市，江西省",
                            "simple_py": "GFQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0793",
                            "area_code": "361103",
                            "longitude": "118.189852",
                            "latitude": "28.440285"
                        },
                        {
                            "area_id": 29705,
                            "city_id": 29185,
                            "province_id": 22,
                            "name": "横峰县",
                            "whole_name": "横峰县，上饶市，江西省",
                            "simple_py": "HFX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0793",
                            "area_code": "361125",
                            "longitude": "117.608247",
                            "latitude": "28.415103"
                        },
                        {
                            "area_id": 29697,
                            "city_id": 29185,
                            "province_id": 22,
                            "name": "鄱阳县",
                            "whole_name": "鄱阳县，上饶市，江西省",
                            "simple_py": "PYX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0793",
                            "area_code": "361128",
                            "longitude": "116.673748",
                            "latitude": "28.993374"
                        },
                        {
                            "area_id": 29696,
                            "city_id": 29185,
                            "province_id": 22,
                            "name": "铅山县",
                            "whole_name": "铅山县，上饶市，江西省",
                            "simple_py": "QSX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0793",
                            "area_code": "361124",
                            "longitude": "117.711906",
                            "latitude": "28.310892"
                        },
                        {
                            "area_id": 29698,
                            "city_id": 29185,
                            "province_id": 22,
                            "name": "婺源县",
                            "whole_name": "婺源县，上饶市，江西省",
                            "simple_py": "WYX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0793",
                            "area_code": "361130",
                            "longitude": "117.86219",
                            "latitude": "29.254015"
                        },
                        {
                            "area_id": 29703,
                            "city_id": 29185,
                            "province_id": 22,
                            "name": "万年县",
                            "whole_name": "万年县，上饶市，江西省",
                            "simple_py": "WNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0793",
                            "area_code": "361129",
                            "longitude": "117.07015",
                            "latitude": "28.692589"
                        },
                        {
                            "area_id": 29699,
                            "city_id": 29185,
                            "province_id": 22,
                            "name": "信州区",
                            "whole_name": "信州区，上饶市，江西省",
                            "simple_py": "XZQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0793",
                            "area_code": "361102",
                            "longitude": "117.970522",
                            "latitude": "28.445378"
                        },
                        {
                            "area_id": 29702,
                            "city_id": 29185,
                            "province_id": 22,
                            "name": "弋阳县",
                            "whole_name": "弋阳县，上饶市，江西省",
                            "simple_py": "YYX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0793",
                            "area_code": "361126",
                            "longitude": "117.435002",
                            "latitude": "28.402391"
                        },
                        {
                            "area_id": 29704,
                            "city_id": 29185,
                            "province_id": 22,
                            "name": "余干县",
                            "whole_name": "余干县，上饶市，江西省",
                            "simple_py": "YGX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0793",
                            "area_code": "361127",
                            "longitude": "116.691072",
                            "latitude": "28.69173"
                        },
                        {
                            "area_id": 29706,
                            "city_id": 29185,
                            "province_id": 22,
                            "name": "玉山县",
                            "whole_name": "玉山县，上饶市，江西省",
                            "simple_py": "YSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0793",
                            "area_code": "361123",
                            "longitude": "118.244408",
                            "latitude": "28.673479"
                        }
                    ]
                },
                {
                    "city_id": 29186,
                    "province_id": 22,
                    "name": "新余市",
                    "whole_name": "新余市，江西省",
                    "simple_py": "XYS",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "0790",
                    "area_code": "360500",
                    "longitude": "114.930835",
                    "latitude": "27.810834",
                    "children": [
                        {
                            "area_id": 29934,
                            "city_id": 29186,
                            "province_id": 22,
                            "name": "分宜县",
                            "whole_name": "分宜县，新余市，江西省",
                            "simple_py": "FYX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0790",
                            "area_code": "360521",
                            "longitude": "114.675262",
                            "latitude": "27.811301"
                        },
                        {
                            "area_id": 29935,
                            "city_id": 29186,
                            "province_id": 22,
                            "name": "渝水区",
                            "whole_name": "渝水区，新余市，江西省",
                            "simple_py": "YSQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0790",
                            "area_code": "360502",
                            "longitude": "114.923923",
                            "latitude": "27.819171"
                        }
                    ]
                },
                {
                    "city_id": 29188,
                    "province_id": 22,
                    "name": "鹰潭市",
                    "whole_name": "鹰潭市，江西省",
                    "simple_py": "YTS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0701",
                    "area_code": "360600",
                    "longitude": "117.033838",
                    "latitude": "28.238638",
                    "children": [
                        {
                            "area_id": 30302,
                            "city_id": 29188,
                            "province_id": 22,
                            "name": "贵溪市",
                            "whole_name": "贵溪市，鹰潭市，江西省",
                            "simple_py": "GXS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0701",
                            "area_code": "360681",
                            "longitude": "117.212103",
                            "latitude": "28.283693"
                        },
                        {
                            "area_id": 30303,
                            "city_id": 29188,
                            "province_id": 22,
                            "name": "余江县",
                            "whole_name": "余江县，鹰潭市，江西省",
                            "simple_py": "YJX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0701",
                            "area_code": "360622",
                            "longitude": "116.822763",
                            "latitude": "28.206177"
                        },
                        {
                            "area_id": 30304,
                            "city_id": 29188,
                            "province_id": 22,
                            "name": "月湖区",
                            "whole_name": "月湖区，鹰潭市，江西省",
                            "simple_py": "YHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0701",
                            "area_code": "360602",
                            "longitude": "117.034112",
                            "latitude": "28.239076"
                        }
                    ]
                },
                {
                    "city_id": 29192,
                    "province_id": 22,
                    "name": "宜春市",
                    "whole_name": "宜春市，江西省",
                    "simple_py": "YCS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Y",
                    "city_code": "0795",
                    "area_code": "360900",
                    "longitude": "114.391136",
                    "latitude": "27.8043",
                    "children": [
                        {
                            "area_id": 30843,
                            "city_id": 29192,
                            "province_id": 22,
                            "name": "丰城市",
                            "whole_name": "丰城市，宜春市，江西省",
                            "simple_py": "FCS",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0795",
                            "area_code": "360981",
                            "longitude": "115.786005",
                            "latitude": "28.191584"
                        },
                        {
                            "area_id": 30847,
                            "city_id": 29192,
                            "province_id": 22,
                            "name": "奉新县",
                            "whole_name": "奉新县，宜春市，江西省",
                            "simple_py": "FXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0795",
                            "area_code": "360921",
                            "longitude": "115.389899",
                            "latitude": "28.700672"
                        },
                        {
                            "area_id": 30846,
                            "city_id": 29192,
                            "province_id": 22,
                            "name": "高安市",
                            "whole_name": "高安市，宜春市，江西省",
                            "simple_py": "GAS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0795",
                            "area_code": "360983",
                            "longitude": "115.381527",
                            "latitude": "28.420951"
                        },
                        {
                            "area_id": 30845,
                            "city_id": 29192,
                            "province_id": 22,
                            "name": "靖安县",
                            "whole_name": "靖安县，宜春市，江西省",
                            "simple_py": "JAX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0795",
                            "area_code": "360925",
                            "longitude": "115.361744",
                            "latitude": "28.86054"
                        },
                        {
                            "area_id": 30842,
                            "city_id": 29192,
                            "province_id": 22,
                            "name": "上高县",
                            "whole_name": "上高县，宜春市，江西省",
                            "simple_py": "SGX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0795",
                            "area_code": "360923",
                            "longitude": "114.932653",
                            "latitude": "28.234789"
                        },
                        {
                            "area_id": 30849,
                            "city_id": 29192,
                            "province_id": 22,
                            "name": "铜鼓县",
                            "whole_name": "铜鼓县，宜春市，江西省",
                            "simple_py": "TGX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0795",
                            "area_code": "360926",
                            "longitude": "114.37014",
                            "latitude": "28.520956"
                        },
                        {
                            "area_id": 30848,
                            "city_id": 29192,
                            "province_id": 22,
                            "name": "万载县",
                            "whole_name": "万载县，宜春市，江西省",
                            "simple_py": "WZX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0795",
                            "area_code": "360922",
                            "longitude": "114.449012",
                            "latitude": "28.104528"
                        },
                        {
                            "area_id": 30844,
                            "city_id": 29192,
                            "province_id": 22,
                            "name": "宜丰县",
                            "whole_name": "宜丰县，宜春市，江西省",
                            "simple_py": "YFX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0795",
                            "area_code": "360924",
                            "longitude": "114.787381",
                            "latitude": "28.388289"
                        },
                        {
                            "area_id": 30850,
                            "city_id": 29192,
                            "province_id": 22,
                            "name": "袁州区",
                            "whole_name": "袁州区，宜春市，江西省",
                            "simple_py": "YZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0795",
                            "area_code": "360902",
                            "longitude": "114.387379",
                            "latitude": "27.800117"
                        },
                        {
                            "area_id": 30851,
                            "city_id": 29192,
                            "province_id": 22,
                            "name": "樟树市",
                            "whole_name": "樟树市，宜春市，江西省",
                            "simple_py": "ZSS",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0795",
                            "area_code": "360982",
                            "longitude": "115.543388",
                            "latitude": "28.055898"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 34,
            "name": "吉林省",
            "whole_name": "吉林省",
            "simple_py": "JLS",
            "per_pin_yin": " ",
            "per_pin_yin2": "J",
            "city_code": "",
            "area_code": "220000",
            "longitude": "125.3245",
            "latitude": "43.886841",
            "children": [
                {
                    "city_id": 45210,
                    "province_id": 34,
                    "name": "白城市",
                    "whole_name": "白城市，吉林省",
                    "simple_py": "BCS",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "0436",
                    "area_code": "220800",
                    "longitude": "122.841114",
                    "latitude": "45.619026",
                    "children": [
                        {
                            "area_id": 45587,
                            "city_id": 45210,
                            "province_id": 34,
                            "name": "大安市",
                            "whole_name": "大安市，白城市，吉林省",
                            "simple_py": "DAS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0436",
                            "area_code": "220882",
                            "longitude": "124.291512",
                            "latitude": "45.507648"
                        },
                        {
                            "area_id": 45588,
                            "city_id": 45210,
                            "province_id": 34,
                            "name": "洮南市",
                            "whole_name": "洮南市，白城市，吉林省",
                            "simple_py": "TNS",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0436",
                            "area_code": "220881",
                            "longitude": "122.783779",
                            "latitude": "45.339113"
                        },
                        {
                            "area_id": 45589,
                            "city_id": 45210,
                            "province_id": 34,
                            "name": "通榆县",
                            "whole_name": "通榆县，白城市，吉林省",
                            "simple_py": "TYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0436",
                            "area_code": "220822",
                            "longitude": "123.088543",
                            "latitude": "44.80915"
                        },
                        {
                            "area_id": 45590,
                            "city_id": 45210,
                            "province_id": 34,
                            "name": "洮北区",
                            "whole_name": "洮北区，白城市，吉林省",
                            "simple_py": "TBQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0436",
                            "area_code": "220802",
                            "longitude": "122.842499",
                            "latitude": "45.619253"
                        },
                        {
                            "area_id": 45591,
                            "city_id": 45210,
                            "province_id": 34,
                            "name": "镇赉县",
                            "whole_name": "镇赉县，白城市，吉林省",
                            "simple_py": "ZLX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0436",
                            "area_code": "220821",
                            "longitude": "123.202246",
                            "latitude": "45.846089"
                        }
                    ]
                },
                {
                    "city_id": 45214,
                    "province_id": 34,
                    "name": "白山市",
                    "whole_name": "白山市，吉林省",
                    "simple_py": "BSS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "B",
                    "city_code": "0439",
                    "area_code": "220600",
                    "longitude": "126.427839",
                    "latitude": "41.942505",
                    "children": [
                        {
                            "area_id": 46122,
                            "city_id": 45214,
                            "province_id": 34,
                            "name": "长白朝鲜族自治县",
                            "whole_name": "长白朝鲜族自治县，白山市，吉林省",
                            "simple_py": "CBCXZZZX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0439",
                            "area_code": "220623",
                            "longitude": "128.203384",
                            "latitude": "41.419361"
                        },
                        {
                            "area_id": 46124,
                            "city_id": 45214,
                            "province_id": 34,
                            "name": "抚松县",
                            "whole_name": "抚松县，白山市，吉林省",
                            "simple_py": "FSX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0439",
                            "area_code": "220621",
                            "longitude": "127.273796",
                            "latitude": "42.332643"
                        },
                        {
                            "area_id": 46125,
                            "city_id": 45214,
                            "province_id": 34,
                            "name": "浑江区",
                            "whole_name": "浑江区，白山市，吉林省",
                            "simple_py": "HJQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0439",
                            "area_code": "220602",
                            "longitude": "126.428035",
                            "latitude": "41.943065"
                        },
                        {
                            "area_id": 46121,
                            "city_id": 45214,
                            "province_id": 34,
                            "name": "靖宇县",
                            "whole_name": "靖宇县，白山市，吉林省",
                            "simple_py": "JYX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0439",
                            "area_code": "220622",
                            "longitude": "126.808386",
                            "latitude": "42.389689"
                        },
                        {
                            "area_id": 46123,
                            "city_id": 45214,
                            "province_id": 34,
                            "name": "江源区",
                            "whole_name": "江源区，白山市，吉林省",
                            "simple_py": "JYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0439",
                            "area_code": "220605",
                            "longitude": "126.584229",
                            "latitude": "42.048109"
                        },
                        {
                            "area_id": 46126,
                            "city_id": 45214,
                            "province_id": 34,
                            "name": "临江市",
                            "whole_name": "临江市，白山市，吉林省",
                            "simple_py": "LJS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0439",
                            "area_code": "220681",
                            "longitude": "126.919296",
                            "latitude": "41.810689"
                        }
                    ]
                },
                {
                    "city_id": 45207,
                    "province_id": 34,
                    "name": "长春市",
                    "whole_name": "长春市，吉林省",
                    "simple_py": "CCS",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0431",
                    "area_code": "220100",
                    "longitude": "125.3245",
                    "latitude": "43.886841",
                    "children": [
                        {
                            "area_id": 45220,
                            "city_id": 45207,
                            "province_id": 34,
                            "name": "朝阳区",
                            "whole_name": "朝阳区，长春市，吉林省",
                            "simple_py": "CYQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0431",
                            "area_code": "220104",
                            "longitude": "125.318042",
                            "latitude": "43.86491"
                        },
                        {
                            "area_id": 45217,
                            "city_id": 45207,
                            "province_id": 34,
                            "name": "德惠市",
                            "whole_name": "德惠市，长春市，吉林省",
                            "simple_py": "DHS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0431",
                            "area_code": "220183",
                            "longitude": "125.703327",
                            "latitude": "44.533909"
                        },
                        {
                            "area_id": 45222,
                            "city_id": 45207,
                            "province_id": 34,
                            "name": "二道区",
                            "whole_name": "二道区，长春市，吉林省",
                            "simple_py": "EDQ",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0431",
                            "area_code": "220105",
                            "longitude": "125.384727",
                            "latitude": "43.870824"
                        },
                        {
                            "area_id": 45223,
                            "city_id": 45207,
                            "province_id": 34,
                            "name": "九台区",
                            "whole_name": "九台区，长春市，吉林省",
                            "simple_py": "JTQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0431",
                            "area_code": "220113",
                            "longitude": "125.844682",
                            "latitude": "44.157155"
                        },
                        {
                            "area_id": 45225,
                            "city_id": 45207,
                            "province_id": 34,
                            "name": "宽城区",
                            "whole_name": "宽城区，长春市，吉林省",
                            "simple_py": "KCQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0431",
                            "area_code": "220103",
                            "longitude": "125.342828",
                            "latitude": "43.903823"
                        },
                        {
                            "area_id": 45221,
                            "city_id": 45207,
                            "province_id": 34,
                            "name": "绿园区",
                            "whole_name": "绿园区，长春市，吉林省",
                            "simple_py": "LYQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0431",
                            "area_code": "220106",
                            "longitude": "125.272467",
                            "latitude": "43.892177"
                        },
                        {
                            "area_id": 45219,
                            "city_id": 45207,
                            "province_id": 34,
                            "name": "农安县",
                            "whole_name": "农安县，长春市，吉林省",
                            "simple_py": "NAX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0431",
                            "area_code": "220122",
                            "longitude": "125.175287",
                            "latitude": "44.431258"
                        },
                        {
                            "area_id": 45224,
                            "city_id": 45207,
                            "province_id": 34,
                            "name": "南关区",
                            "whole_name": "南关区，长春市，吉林省",
                            "simple_py": "NGQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0431",
                            "area_code": "220102",
                            "longitude": "125.337237",
                            "latitude": "43.890235"
                        },
                        {
                            "area_id": 45218,
                            "city_id": 45207,
                            "province_id": 34,
                            "name": "双阳区",
                            "whole_name": "双阳区，长春市，吉林省",
                            "simple_py": "SYQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0431",
                            "area_code": "220112",
                            "longitude": "125.659018",
                            "latitude": "43.525168"
                        },
                        {
                            "area_id": 45216,
                            "city_id": 45207,
                            "province_id": 34,
                            "name": "榆树市",
                            "whole_name": "榆树市，长春市，吉林省",
                            "simple_py": "YSS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0431",
                            "area_code": "220182",
                            "longitude": "126.550107",
                            "latitude": "44.827642"
                        }
                    ]
                },
                {
                    "city_id": 45209,
                    "province_id": 34,
                    "name": "吉林市",
                    "whole_name": "吉林市，吉林省",
                    "simple_py": "JLS",
                    "per_pin_yin": "J",
                    "per_pin_yin2": "J",
                    "city_code": "0432",
                    "area_code": "220200",
                    "longitude": "126.55302",
                    "latitude": "43.843577",
                    "children": [
                        {
                            "area_id": 45431,
                            "city_id": 45209,
                            "province_id": 34,
                            "name": "船营区",
                            "whole_name": "船营区，吉林市，吉林省",
                            "simple_py": "CYQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0432",
                            "area_code": "220204",
                            "longitude": "126.55239",
                            "latitude": "43.843804"
                        },
                        {
                            "area_id": 45434,
                            "city_id": 45209,
                            "province_id": 34,
                            "name": "昌邑区",
                            "whole_name": "昌邑区，吉林市，吉林省",
                            "simple_py": "CYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0432",
                            "area_code": "220202",
                            "longitude": "126.570766",
                            "latitude": "43.851118"
                        },
                        {
                            "area_id": 45432,
                            "city_id": 45209,
                            "province_id": 34,
                            "name": "丰满区",
                            "whole_name": "丰满区，吉林市，吉林省",
                            "simple_py": "FMQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0432",
                            "area_code": "220211",
                            "longitude": "126.560759",
                            "latitude": "43.816594"
                        },
                        {
                            "area_id": 45433,
                            "city_id": 45209,
                            "province_id": 34,
                            "name": "桦甸市",
                            "whole_name": "桦甸市，吉林市，吉林省",
                            "simple_py": "HDS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0432",
                            "area_code": "220282",
                            "longitude": "126.745445",
                            "latitude": "42.972093"
                        },
                        {
                            "area_id": 45435,
                            "city_id": 45209,
                            "province_id": 34,
                            "name": "蛟河市",
                            "whole_name": "蛟河市，吉林市，吉林省",
                            "simple_py": "JHS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0432",
                            "area_code": "220281",
                            "longitude": "127.342739",
                            "latitude": "43.720579"
                        },
                        {
                            "area_id": 45436,
                            "city_id": 45209,
                            "province_id": 34,
                            "name": "龙潭区",
                            "whole_name": "龙潭区，吉林市，吉林省",
                            "simple_py": "LTQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0432",
                            "area_code": "220203",
                            "longitude": "126.561429",
                            "latitude": "43.909755"
                        },
                        {
                            "area_id": 45438,
                            "city_id": 45209,
                            "province_id": 34,
                            "name": "磐石市",
                            "whole_name": "磐石市，吉林市，吉林省",
                            "simple_py": "PSS",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0432",
                            "area_code": "220284",
                            "longitude": "126.059929",
                            "latitude": "42.942476"
                        },
                        {
                            "area_id": 45430,
                            "city_id": 45209,
                            "province_id": 34,
                            "name": "舒兰市",
                            "whole_name": "舒兰市，吉林市，吉林省",
                            "simple_py": "SLS",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0432",
                            "area_code": "220283",
                            "longitude": "126.947813",
                            "latitude": "44.410906"
                        },
                        {
                            "area_id": 45437,
                            "city_id": 45209,
                            "province_id": 34,
                            "name": "永吉县",
                            "whole_name": "永吉县，吉林市，吉林省",
                            "simple_py": "YJX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0432",
                            "area_code": "220221",
                            "longitude": "126.501622",
                            "latitude": "43.667416"
                        }
                    ]
                },
                {
                    "city_id": 45208,
                    "province_id": 34,
                    "name": "辽源市",
                    "whole_name": "辽源市，吉林省",
                    "simple_py": "LYS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0437",
                    "area_code": "220400",
                    "longitude": "125.145349",
                    "latitude": "42.902692",
                    "children": [
                        {
                            "area_id": 45394,
                            "city_id": 45208,
                            "province_id": 34,
                            "name": "东辽县",
                            "whole_name": "东辽县，辽源市，吉林省",
                            "simple_py": "DLX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0437",
                            "area_code": "220422",
                            "longitude": "124.991995",
                            "latitude": "42.927724"
                        },
                        {
                            "area_id": 45395,
                            "city_id": 45208,
                            "province_id": 34,
                            "name": "东丰县",
                            "whole_name": "东丰县，辽源市，吉林省",
                            "simple_py": "DFX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0437",
                            "area_code": "220421",
                            "longitude": "125.529623",
                            "latitude": "42.675228"
                        },
                        {
                            "area_id": 45393,
                            "city_id": 45208,
                            "province_id": 34,
                            "name": "龙山区",
                            "whole_name": "龙山区，辽源市，吉林省",
                            "simple_py": "LSQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0437",
                            "area_code": "220402",
                            "longitude": "125.145164",
                            "latitude": "42.902702"
                        },
                        {
                            "area_id": 45392,
                            "city_id": 45208,
                            "province_id": 34,
                            "name": "西安区",
                            "whole_name": "西安区，辽源市，吉林省",
                            "simple_py": "XAQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0437",
                            "area_code": "220403",
                            "longitude": "125.151424",
                            "latitude": "42.920415"
                        }
                    ]
                },
                {
                    "city_id": 45211,
                    "province_id": 34,
                    "name": "松原市",
                    "whole_name": "松原市，吉林省",
                    "simple_py": "SYS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0438",
                    "area_code": "220700",
                    "longitude": "124.823608",
                    "latitude": "45.118243",
                    "children": [
                        {
                            "area_id": 45727,
                            "city_id": 45211,
                            "province_id": 34,
                            "name": "长岭县",
                            "whole_name": "长岭县，松原市，吉林省",
                            "simple_py": "CLX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0438",
                            "area_code": "220722",
                            "longitude": "123.985184",
                            "latitude": "44.276579"
                        },
                        {
                            "area_id": 45723,
                            "city_id": 45211,
                            "province_id": 34,
                            "name": "扶余市",
                            "whole_name": "扶余市，松原市，吉林省",
                            "simple_py": "FYS",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0438",
                            "area_code": "220781",
                            "longitude": "126.042758",
                            "latitude": "44.986199"
                        },
                        {
                            "area_id": 45724,
                            "city_id": 45211,
                            "province_id": 34,
                            "name": "宁江区",
                            "whole_name": "宁江区，松原市，吉林省",
                            "simple_py": "NJQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0438",
                            "area_code": "220702",
                            "longitude": "124.827851",
                            "latitude": "45.176498"
                        },
                        {
                            "area_id": 45725,
                            "city_id": 45211,
                            "province_id": 34,
                            "name": "前郭尔罗斯蒙古族自治县",
                            "whole_name": "前郭尔罗斯蒙古族自治县，松原市，吉林省",
                            "simple_py": "QGELSMGZZZX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0438",
                            "area_code": "220721",
                            "longitude": "124.826808",
                            "latitude": "45.116288"
                        },
                        {
                            "area_id": 45726,
                            "city_id": 45211,
                            "province_id": 34,
                            "name": "乾安县",
                            "whole_name": "乾安县，松原市，吉林省",
                            "simple_py": "QAX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0438",
                            "area_code": "220723",
                            "longitude": "124.024361",
                            "latitude": "45.006846"
                        }
                    ]
                },
                {
                    "city_id": 45212,
                    "province_id": 34,
                    "name": "四平市",
                    "whole_name": "四平市，吉林省",
                    "simple_py": "SPS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "S",
                    "city_code": "0434",
                    "area_code": "220300",
                    "longitude": "124.370785",
                    "latitude": "43.170344",
                    "children": [
                        {
                            "area_id": 45867,
                            "city_id": 45212,
                            "province_id": 34,
                            "name": "公主岭市",
                            "whole_name": "公主岭市，四平市，吉林省",
                            "simple_py": "GZLS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0434",
                            "area_code": "220381",
                            "longitude": "124.817588",
                            "latitude": "43.509474"
                        },
                        {
                            "area_id": 45870,
                            "city_id": 45212,
                            "province_id": 34,
                            "name": "梨树县",
                            "whole_name": "梨树县，四平市，吉林省",
                            "simple_py": "LSX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0434",
                            "area_code": "220322",
                            "longitude": "124.335802",
                            "latitude": "43.30831"
                        },
                        {
                            "area_id": 45866,
                            "city_id": 45212,
                            "province_id": 34,
                            "name": "双辽市",
                            "whole_name": "双辽市，四平市，吉林省",
                            "simple_py": "SLS",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0434",
                            "area_code": "220382",
                            "longitude": "123.505283",
                            "latitude": "43.518275"
                        },
                        {
                            "area_id": 45865,
                            "city_id": 45212,
                            "province_id": 34,
                            "name": "铁东区",
                            "whole_name": "铁东区，四平市，吉林省",
                            "simple_py": "TDQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0434",
                            "area_code": "220303",
                            "longitude": "124.388464",
                            "latitude": "43.16726"
                        },
                        {
                            "area_id": 45869,
                            "city_id": 45212,
                            "province_id": 34,
                            "name": "铁西区",
                            "whole_name": "铁西区，四平市，吉林省",
                            "simple_py": "TXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0434",
                            "area_code": "220302",
                            "longitude": "124.360894",
                            "latitude": "43.176263"
                        },
                        {
                            "area_id": 45868,
                            "city_id": 45212,
                            "province_id": 34,
                            "name": "伊通满族自治县",
                            "whole_name": "伊通满族自治县，四平市，吉林省",
                            "simple_py": "YTMZZZX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0434",
                            "area_code": "220323",
                            "longitude": "125.303124",
                            "latitude": "43.345464"
                        }
                    ]
                },
                {
                    "city_id": 45215,
                    "province_id": 34,
                    "name": "通化市",
                    "whole_name": "通化市，吉林省",
                    "simple_py": "THS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0435",
                    "area_code": "220500",
                    "longitude": "125.936501",
                    "latitude": "41.721177",
                    "children": [
                        {
                            "area_id": 46197,
                            "city_id": 45215,
                            "province_id": 34,
                            "name": "东昌区",
                            "whole_name": "东昌区，通化市，吉林省",
                            "simple_py": "DCQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0435",
                            "area_code": "220502",
                            "longitude": "125.936716",
                            "latitude": "41.721233"
                        },
                        {
                            "area_id": 46198,
                            "city_id": 45215,
                            "province_id": 34,
                            "name": "二道江区",
                            "whole_name": "二道江区，通化市，吉林省",
                            "simple_py": "EDJQ",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0435",
                            "area_code": "220503",
                            "longitude": "126.045987",
                            "latitude": "41.777564"
                        },
                        {
                            "area_id": 46202,
                            "city_id": 45215,
                            "province_id": 34,
                            "name": "辉南县",
                            "whole_name": "辉南县，通化市，吉林省",
                            "simple_py": "HNX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0435",
                            "area_code": "220523",
                            "longitude": "126.042821",
                            "latitude": "42.683459"
                        },
                        {
                            "area_id": 46203,
                            "city_id": 45215,
                            "province_id": 34,
                            "name": "集安市",
                            "whole_name": "集安市，通化市，吉林省",
                            "simple_py": "JAS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0435",
                            "area_code": "220582",
                            "longitude": "126.186204",
                            "latitude": "41.126276"
                        },
                        {
                            "area_id": 46200,
                            "city_id": 45215,
                            "province_id": 34,
                            "name": "柳河县",
                            "whole_name": "柳河县，通化市，吉林省",
                            "simple_py": "LHX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0435",
                            "area_code": "220524",
                            "longitude": "125.740536",
                            "latitude": "42.281484"
                        },
                        {
                            "area_id": 46201,
                            "city_id": 45215,
                            "province_id": 34,
                            "name": "梅河口市",
                            "whole_name": "梅河口市，通化市，吉林省",
                            "simple_py": "MHKS",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0435",
                            "area_code": "220581",
                            "longitude": "125.687336",
                            "latitude": "42.530002"
                        },
                        {
                            "area_id": 46199,
                            "city_id": 45215,
                            "province_id": 34,
                            "name": "通化县",
                            "whole_name": "通化县，通化市，吉林省",
                            "simple_py": "THX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0435",
                            "area_code": "220521",
                            "longitude": "125.753121",
                            "latitude": "41.677918"
                        }
                    ]
                },
                {
                    "city_id": 45213,
                    "province_id": 34,
                    "name": "延边朝鲜族自治州",
                    "whole_name": "延边朝鲜族自治州，吉林省",
                    "simple_py": "YBCXZZZZ",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0433",
                    "area_code": "222400",
                    "longitude": "129.513228",
                    "latitude": "42.904823",
                    "children": [
                        {
                            "area_id": 45995,
                            "city_id": 45213,
                            "province_id": 34,
                            "name": "安图县",
                            "whole_name": "安图县，延边朝鲜族自治州，吉林省",
                            "simple_py": "ATX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0433",
                            "area_code": "222426",
                            "longitude": "128.901865",
                            "latitude": "43.110994"
                        },
                        {
                            "area_id": 45988,
                            "city_id": 45213,
                            "province_id": 34,
                            "name": "敦化市",
                            "whole_name": "敦化市，延边朝鲜族自治州，吉林省",
                            "simple_py": "DHS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0433",
                            "area_code": "222403",
                            "longitude": "128.22986",
                            "latitude": "43.366921"
                        },
                        {
                            "area_id": 45990,
                            "city_id": 45213,
                            "province_id": 34,
                            "name": "珲春市",
                            "whole_name": "珲春市，延边朝鲜族自治州，吉林省",
                            "simple_py": "HCS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0433",
                            "area_code": "222404",
                            "longitude": "130.365787",
                            "latitude": "42.871057"
                        },
                        {
                            "area_id": 45991,
                            "city_id": 45213,
                            "province_id": 34,
                            "name": "和龙市",
                            "whole_name": "和龙市，延边朝鲜族自治州，吉林省",
                            "simple_py": "HLS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0433",
                            "area_code": "222406",
                            "longitude": "129.008748",
                            "latitude": "42.547004"
                        },
                        {
                            "area_id": 45994,
                            "city_id": 45213,
                            "province_id": 34,
                            "name": "龙井市",
                            "whole_name": "龙井市，延边朝鲜族自治州，吉林省",
                            "simple_py": "LJS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0433",
                            "area_code": "222405",
                            "longitude": "129.425747",
                            "latitude": "42.771029"
                        },
                        {
                            "area_id": 45989,
                            "city_id": 45213,
                            "province_id": 34,
                            "name": "图们市",
                            "whole_name": "图们市，延边朝鲜族自治州，吉林省",
                            "simple_py": "TMS",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0433",
                            "area_code": "222402",
                            "longitude": "129.846701",
                            "latitude": "42.966621"
                        },
                        {
                            "area_id": 45992,
                            "city_id": 45213,
                            "province_id": 34,
                            "name": "汪清县",
                            "whole_name": "汪清县，延边朝鲜族自治州，吉林省",
                            "simple_py": "WQX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0433",
                            "area_code": "222424",
                            "longitude": "129.766161",
                            "latitude": "43.315426"
                        },
                        {
                            "area_id": 45993,
                            "city_id": 45213,
                            "province_id": 34,
                            "name": "延吉市",
                            "whole_name": "延吉市，延边朝鲜族自治州，吉林省",
                            "simple_py": "YJS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0433",
                            "area_code": "222401",
                            "longitude": "129.51579",
                            "latitude": "42.906964"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 7,
            "name": "辽宁省",
            "whole_name": "辽宁省",
            "simple_py": "LNS",
            "per_pin_yin": "L",
            "per_pin_yin2": "L",
            "city_code": "",
            "area_code": "210000",
            "longitude": "123.429096",
            "latitude": "41.796767",
            "children": [
                {
                    "city_id": 11074,
                    "province_id": 7,
                    "name": "鞍山市",
                    "whole_name": "鞍山市，辽宁省",
                    "simple_py": "ASS",
                    "per_pin_yin": "A",
                    "per_pin_yin2": "A",
                    "city_code": "0412",
                    "area_code": "210300",
                    "longitude": "122.995632",
                    "latitude": "41.110626",
                    "children": [
                        {
                            "area_id": 11942,
                            "city_id": 11074,
                            "province_id": 7,
                            "name": "海城市",
                            "whole_name": "海城市，鞍山市，辽宁省",
                            "simple_py": "HCS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0412",
                            "area_code": "210381",
                            "longitude": "122.752199",
                            "latitude": "40.852533"
                        },
                        {
                            "area_id": 11944,
                            "city_id": 11074,
                            "province_id": 7,
                            "name": "立山区",
                            "whole_name": "立山区，鞍山市，辽宁省",
                            "simple_py": "LSQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0412",
                            "area_code": "210304",
                            "longitude": "123.024806",
                            "latitude": "41.150622"
                        },
                        {
                            "area_id": 11946,
                            "city_id": 11074,
                            "province_id": 7,
                            "name": "千山区",
                            "whole_name": "千山区，鞍山市，辽宁省",
                            "simple_py": "QSQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0412",
                            "area_code": "210311",
                            "longitude": "122.949298",
                            "latitude": "41.068909"
                        },
                        {
                            "area_id": 11940,
                            "city_id": 11074,
                            "province_id": 7,
                            "name": "台安县",
                            "whole_name": "台安县，鞍山市，辽宁省",
                            "simple_py": "TAX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0412",
                            "area_code": "210321",
                            "longitude": "122.429736",
                            "latitude": "41.38686"
                        },
                        {
                            "area_id": 11943,
                            "city_id": 11074,
                            "province_id": 7,
                            "name": "铁东区",
                            "whole_name": "铁东区，鞍山市，辽宁省",
                            "simple_py": "TDQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0412",
                            "area_code": "210302",
                            "longitude": "122.994475",
                            "latitude": "41.110344"
                        },
                        {
                            "area_id": 11945,
                            "city_id": 11074,
                            "province_id": 7,
                            "name": "铁西区",
                            "whole_name": "铁西区，鞍山市，辽宁省",
                            "simple_py": "TXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0412",
                            "area_code": "210303",
                            "longitude": "122.971834",
                            "latitude": "41.11069"
                        },
                        {
                            "area_id": 11941,
                            "city_id": 11074,
                            "province_id": 7,
                            "name": "岫岩满族自治县",
                            "whole_name": "岫岩满族自治县，鞍山市，辽宁省",
                            "simple_py": "XYMZZZX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0412",
                            "area_code": "210323",
                            "longitude": "123.28833",
                            "latitude": "40.281509"
                        }
                    ]
                },
                {
                    "city_id": 11081,
                    "province_id": 7,
                    "name": "本溪市",
                    "whole_name": "本溪市，辽宁省",
                    "simple_py": "BXS",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "024",
                    "area_code": "210500",
                    "longitude": "123.770519",
                    "latitude": "41.297909",
                    "children": [
                        {
                            "area_id": 12689,
                            "city_id": 11081,
                            "province_id": 7,
                            "name": "本溪满族自治县",
                            "whole_name": "本溪满族自治县，本溪市，辽宁省",
                            "simple_py": "BXMZZZX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "024",
                            "area_code": "210521",
                            "longitude": "124.126156",
                            "latitude": "41.300344"
                        },
                        {
                            "area_id": 12685,
                            "city_id": 11081,
                            "province_id": 7,
                            "name": "桓仁满族自治县",
                            "whole_name": "桓仁满族自治县，本溪市，辽宁省",
                            "simple_py": "HRMZZZX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "024",
                            "area_code": "210522",
                            "longitude": "125.359195",
                            "latitude": "41.268997"
                        },
                        {
                            "area_id": 12688,
                            "city_id": 11081,
                            "province_id": 7,
                            "name": "明山区",
                            "whole_name": "明山区，本溪市，辽宁省",
                            "simple_py": "MSQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "024",
                            "area_code": "210504",
                            "longitude": "123.763288",
                            "latitude": "41.302429"
                        },
                        {
                            "area_id": 12686,
                            "city_id": 11081,
                            "province_id": 7,
                            "name": "南芬区",
                            "whole_name": "南芬区，本溪市，辽宁省",
                            "simple_py": "NFQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "024",
                            "area_code": "210505",
                            "longitude": "123.748381",
                            "latitude": "41.104093"
                        },
                        {
                            "area_id": 12687,
                            "city_id": 11081,
                            "province_id": 7,
                            "name": "平山区",
                            "whole_name": "平山区，本溪市，辽宁省",
                            "simple_py": "PSQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "024",
                            "area_code": "210502",
                            "longitude": "123.761231",
                            "latitude": "41.291581"
                        },
                        {
                            "area_id": 12684,
                            "city_id": 11081,
                            "province_id": 7,
                            "name": "溪湖区",
                            "whole_name": "溪湖区，本溪市，辽宁省",
                            "simple_py": "XHQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "024",
                            "area_code": "210503",
                            "longitude": "123.765226",
                            "latitude": "41.330056"
                        }
                    ]
                },
                {
                    "city_id": 11079,
                    "province_id": 7,
                    "name": "朝阳市",
                    "whole_name": "朝阳市，辽宁省",
                    "simple_py": "CYS",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0421",
                    "area_code": "211300",
                    "longitude": "120.451176",
                    "latitude": "41.576758",
                    "children": [
                        {
                            "area_id": 12400,
                            "city_id": 11079,
                            "province_id": 7,
                            "name": "北票市",
                            "whole_name": "北票市，朝阳市，辽宁省",
                            "simple_py": "BPS",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0421",
                            "area_code": "211381",
                            "longitude": "120.766951",
                            "latitude": "41.803286"
                        },
                        {
                            "area_id": 12401,
                            "city_id": 11079,
                            "province_id": 7,
                            "name": "朝阳县",
                            "whole_name": "朝阳县，朝阳市，辽宁省",
                            "simple_py": "CYX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0421",
                            "area_code": "211321",
                            "longitude": "120.404217",
                            "latitude": "41.526342"
                        },
                        {
                            "area_id": 12399,
                            "city_id": 11079,
                            "province_id": 7,
                            "name": "建平县",
                            "whole_name": "建平县，朝阳市，辽宁省",
                            "simple_py": "JPX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0421",
                            "area_code": "211322",
                            "longitude": "119.642363",
                            "latitude": "41.402576"
                        },
                        {
                            "area_id": 12405,
                            "city_id": 11079,
                            "province_id": 7,
                            "name": "喀喇沁左翼蒙古族自治县",
                            "whole_name": "喀喇沁左翼蒙古族自治县，朝阳市，辽宁省",
                            "simple_py": "KLQZYMGZZZX",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0421",
                            "area_code": "211324",
                            "longitude": "119.744883",
                            "latitude": "41.125428"
                        },
                        {
                            "area_id": 12403,
                            "city_id": 11079,
                            "province_id": 7,
                            "name": "龙城区",
                            "whole_name": "龙城区，朝阳市，辽宁省",
                            "simple_py": "LCQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0421",
                            "area_code": "211303",
                            "longitude": "120.413376",
                            "latitude": "41.576749"
                        },
                        {
                            "area_id": 12404,
                            "city_id": 11079,
                            "province_id": 7,
                            "name": "凌源市",
                            "whole_name": "凌源市，朝阳市，辽宁省",
                            "simple_py": "LYS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0421",
                            "area_code": "211382",
                            "longitude": "119.404789",
                            "latitude": "41.243086"
                        },
                        {
                            "area_id": 12402,
                            "city_id": 11079,
                            "province_id": 7,
                            "name": "双塔区",
                            "whole_name": "双塔区，朝阳市，辽宁省",
                            "simple_py": "STQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0421",
                            "area_code": "211302",
                            "longitude": "120.44877",
                            "latitude": "41.579389"
                        }
                    ]
                },
                {
                    "city_id": 11068,
                    "province_id": 7,
                    "name": "大连市",
                    "whole_name": "大连市，辽宁省",
                    "simple_py": "DLS",
                    "per_pin_yin": "D",
                    "per_pin_yin2": "D",
                    "city_code": "0411",
                    "area_code": "210200",
                    "longitude": "121.618622",
                    "latitude": "38.91459",
                    "children": [
                        {
                            "area_id": 11085,
                            "city_id": 11068,
                            "province_id": 7,
                            "name": "长海县",
                            "whole_name": "长海县，大连市，辽宁省",
                            "simple_py": "CHX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0411",
                            "area_code": "210224",
                            "longitude": "122.587824",
                            "latitude": "39.272399"
                        },
                        {
                            "area_id": 11087,
                            "city_id": 11068,
                            "province_id": 7,
                            "name": "甘井子区",
                            "whole_name": "甘井子区，大连市，辽宁省",
                            "simple_py": "GJZQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0411",
                            "area_code": "210211",
                            "longitude": "121.582614",
                            "latitude": "38.975148"
                        },
                        {
                            "area_id": 11084,
                            "city_id": 11068,
                            "province_id": 7,
                            "name": "金州区",
                            "whole_name": "金州区，大连市，辽宁省",
                            "simple_py": "JZQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0411",
                            "area_code": "210213",
                            "longitude": "121.789413",
                            "latitude": "39.052745"
                        },
                        {
                            "area_id": 11089,
                            "city_id": 11068,
                            "province_id": 7,
                            "name": "旅顺口区",
                            "whole_name": "旅顺口区，大连市，辽宁省",
                            "simple_py": "LSKQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0411",
                            "area_code": "210212",
                            "longitude": "121.26713",
                            "latitude": "38.812043"
                        },
                        {
                            "area_id": 11083,
                            "city_id": 11068,
                            "province_id": 7,
                            "name": "普兰店区",
                            "whole_name": "普兰店区，大连市，辽宁省",
                            "simple_py": "PLDQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0411",
                            "area_code": "210214",
                            "longitude": "121.9705",
                            "latitude": "39.401555"
                        },
                        {
                            "area_id": 11091,
                            "city_id": 11068,
                            "province_id": 7,
                            "name": "沙河口区",
                            "whole_name": "沙河口区，大连市，辽宁省",
                            "simple_py": "SHKQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0411",
                            "area_code": "210204",
                            "longitude": "121.593702",
                            "latitude": "38.912859"
                        },
                        {
                            "area_id": 11082,
                            "city_id": 11068,
                            "province_id": 7,
                            "name": "瓦房店市",
                            "whole_name": "瓦房店市，大连市，辽宁省",
                            "simple_py": "WFDS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0411",
                            "area_code": "210281",
                            "longitude": "122.002656",
                            "latitude": "39.63065"
                        },
                        {
                            "area_id": 11090,
                            "city_id": 11068,
                            "province_id": 7,
                            "name": "西岗区",
                            "whole_name": "西岗区，大连市，辽宁省",
                            "simple_py": "XGQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0411",
                            "area_code": "210203",
                            "longitude": "121.616112",
                            "latitude": "38.914266"
                        },
                        {
                            "area_id": 11086,
                            "city_id": 11068,
                            "province_id": 7,
                            "name": "中山区",
                            "whole_name": "中山区，大连市，辽宁省",
                            "simple_py": "ZSQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0411",
                            "area_code": "210202",
                            "longitude": "121.64376",
                            "latitude": "38.921553"
                        },
                        {
                            "area_id": 11088,
                            "city_id": 11068,
                            "province_id": 7,
                            "name": "庄河市",
                            "whole_name": "庄河市，大连市，辽宁省",
                            "simple_py": "ZHS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0411",
                            "area_code": "210283",
                            "longitude": "122.970612",
                            "latitude": "39.69829"
                        }
                    ]
                },
                {
                    "city_id": 11071,
                    "province_id": 7,
                    "name": "丹东市",
                    "whole_name": "丹东市，辽宁省",
                    "simple_py": "DDS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "D",
                    "city_code": "0415",
                    "area_code": "210600",
                    "longitude": "124.383044",
                    "latitude": "40.124296",
                    "children": [
                        {
                            "area_id": 11522,
                            "city_id": 11071,
                            "province_id": 7,
                            "name": "东港市",
                            "whole_name": "东港市，丹东市，辽宁省",
                            "simple_py": "DGS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0415",
                            "area_code": "210681",
                            "longitude": "124.149437",
                            "latitude": "39.883467"
                        },
                        {
                            "area_id": 11521,
                            "city_id": 11071,
                            "province_id": 7,
                            "name": "凤城市",
                            "whole_name": "凤城市，丹东市，辽宁省",
                            "simple_py": "FCS",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0415",
                            "area_code": "210682",
                            "longitude": "124.071067",
                            "latitude": "40.457567"
                        },
                        {
                            "area_id": 11525,
                            "city_id": 11071,
                            "province_id": 7,
                            "name": "宽甸满族自治县",
                            "whole_name": "宽甸满族自治县，丹东市，辽宁省",
                            "simple_py": "KDMZZZX",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0415",
                            "area_code": "210624",
                            "longitude": "124.784867",
                            "latitude": "40.730412"
                        },
                        {
                            "area_id": 11524,
                            "city_id": 11071,
                            "province_id": 7,
                            "name": "元宝区",
                            "whole_name": "元宝区，丹东市，辽宁省",
                            "simple_py": "YBQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0415",
                            "area_code": "210602",
                            "longitude": "124.397814",
                            "latitude": "40.136483"
                        },
                        {
                            "area_id": 11520,
                            "city_id": 11071,
                            "province_id": 7,
                            "name": "振安区",
                            "whole_name": "振安区，丹东市，辽宁省",
                            "simple_py": "ZAQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0415",
                            "area_code": "210604",
                            "longitude": "124.427709",
                            "latitude": "40.158557"
                        },
                        {
                            "area_id": 11523,
                            "city_id": 11071,
                            "province_id": 7,
                            "name": "振兴区",
                            "whole_name": "振兴区，丹东市，辽宁省",
                            "simple_py": "ZXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0415",
                            "area_code": "210603",
                            "longitude": "124.361153",
                            "latitude": "40.102801"
                        }
                    ]
                },
                {
                    "city_id": 11072,
                    "province_id": 7,
                    "name": "抚顺市",
                    "whole_name": "抚顺市，辽宁省",
                    "simple_py": "FSS",
                    "per_pin_yin": "F",
                    "per_pin_yin2": "F",
                    "city_code": "024",
                    "area_code": "210400",
                    "longitude": "123.921109",
                    "latitude": "41.875956",
                    "children": [
                        {
                            "area_id": 11623,
                            "city_id": 11072,
                            "province_id": 7,
                            "name": "东洲区",
                            "whole_name": "东洲区，抚顺市，辽宁省",
                            "simple_py": "DZQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "024",
                            "area_code": "210403",
                            "longitude": "124.047219",
                            "latitude": "41.866829"
                        },
                        {
                            "area_id": 11626,
                            "city_id": 11072,
                            "province_id": 7,
                            "name": "抚顺县",
                            "whole_name": "抚顺县，抚顺市，辽宁省",
                            "simple_py": "FSX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "024",
                            "area_code": "210421",
                            "longitude": "124.097979",
                            "latitude": "41.922644"
                        },
                        {
                            "area_id": 11621,
                            "city_id": 11072,
                            "province_id": 7,
                            "name": "清原满族自治县",
                            "whole_name": "清原满族自治县，抚顺市，辽宁省",
                            "simple_py": "QYMZZZX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "024",
                            "area_code": "210423",
                            "longitude": "124.927192",
                            "latitude": "42.10135"
                        },
                        {
                            "area_id": 11627,
                            "city_id": 11072,
                            "province_id": 7,
                            "name": "顺城区",
                            "whole_name": "顺城区，抚顺市，辽宁省",
                            "simple_py": "SCQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "024",
                            "area_code": "210411",
                            "longitude": "123.917165",
                            "latitude": "41.881132"
                        },
                        {
                            "area_id": 11624,
                            "city_id": 11072,
                            "province_id": 7,
                            "name": "望花区",
                            "whole_name": "望花区，抚顺市，辽宁省",
                            "simple_py": "WHQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "024",
                            "area_code": "210404",
                            "longitude": "123.801509",
                            "latitude": "41.851803"
                        },
                        {
                            "area_id": 11622,
                            "city_id": 11072,
                            "province_id": 7,
                            "name": "新宾满族自治县",
                            "whole_name": "新宾满族自治县，抚顺市，辽宁省",
                            "simple_py": "XBMZZZX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "024",
                            "area_code": "210422",
                            "longitude": "125.037547",
                            "latitude": "41.732456"
                        },
                        {
                            "area_id": 11625,
                            "city_id": 11072,
                            "province_id": 7,
                            "name": "新抚区",
                            "whole_name": "新抚区，抚顺市，辽宁省",
                            "simple_py": "XFQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "024",
                            "area_code": "210402",
                            "longitude": "123.902858",
                            "latitude": "41.86082"
                        }
                    ]
                },
                {
                    "city_id": 11080,
                    "province_id": 7,
                    "name": "阜新市",
                    "whole_name": "阜新市，辽宁省",
                    "simple_py": "FXS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "F",
                    "city_code": "0418",
                    "area_code": "210900",
                    "longitude": "121.648962",
                    "latitude": "42.011796",
                    "children": [
                        {
                            "area_id": 12586,
                            "city_id": 11080,
                            "province_id": 7,
                            "name": "阜新蒙古族自治县",
                            "whole_name": "阜新蒙古族自治县，阜新市，辽宁省",
                            "simple_py": "FXMGZZZX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0418",
                            "area_code": "210921",
                            "longitude": "121.743125",
                            "latitude": "42.058607"
                        },
                        {
                            "area_id": 12582,
                            "city_id": 11080,
                            "province_id": 7,
                            "name": "海州区",
                            "whole_name": "海州区，阜新市，辽宁省",
                            "simple_py": "HZQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0418",
                            "area_code": "210902",
                            "longitude": "121.657639",
                            "latitude": "42.011162"
                        },
                        {
                            "area_id": 12585,
                            "city_id": 11080,
                            "province_id": 7,
                            "name": "清河门区",
                            "whole_name": "清河门区，阜新市，辽宁省",
                            "simple_py": "QHMQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0418",
                            "area_code": "210905",
                            "longitude": "121.42018",
                            "latitude": "41.780477"
                        },
                        {
                            "area_id": 12584,
                            "city_id": 11080,
                            "province_id": 7,
                            "name": "太平区",
                            "whole_name": "太平区，阜新市，辽宁省",
                            "simple_py": "TPQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0418",
                            "area_code": "210904",
                            "longitude": "121.677575",
                            "latitude": "42.011145"
                        },
                        {
                            "area_id": 12583,
                            "city_id": 11080,
                            "province_id": 7,
                            "name": "细河区",
                            "whole_name": "细河区，阜新市，辽宁省",
                            "simple_py": "XHQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0418",
                            "area_code": "210911",
                            "longitude": "121.654791",
                            "latitude": "42.019218"
                        },
                        {
                            "area_id": 12587,
                            "city_id": 11080,
                            "province_id": 7,
                            "name": "新邱区",
                            "whole_name": "新邱区，阜新市，辽宁省",
                            "simple_py": "XQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0418",
                            "area_code": "210903",
                            "longitude": "121.790541",
                            "latitude": "42.086603"
                        },
                        {
                            "area_id": 12588,
                            "city_id": 11080,
                            "province_id": 7,
                            "name": "彰武县",
                            "whole_name": "彰武县，阜新市，辽宁省",
                            "simple_py": "ZWX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0418",
                            "area_code": "210922",
                            "longitude": "122.537444",
                            "latitude": "42.384823"
                        }
                    ]
                },
                {
                    "city_id": 11069,
                    "province_id": 7,
                    "name": "葫芦岛市",
                    "whole_name": "葫芦岛市，辽宁省",
                    "simple_py": "HLDS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0429",
                    "area_code": "211400",
                    "longitude": "120.856394",
                    "latitude": "40.755572",
                    "children": [
                        {
                            "area_id": 11256,
                            "city_id": 11069,
                            "province_id": 7,
                            "name": "建昌县",
                            "whole_name": "建昌县，葫芦岛市，辽宁省",
                            "simple_py": "JCX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0429",
                            "area_code": "211422",
                            "longitude": "119.807776",
                            "latitude": "40.812871"
                        },
                        {
                            "area_id": 11258,
                            "city_id": 11069,
                            "province_id": 7,
                            "name": "龙港区",
                            "whole_name": "龙港区，葫芦岛市，辽宁省",
                            "simple_py": "LGQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0429",
                            "area_code": "211403",
                            "longitude": "120.838569",
                            "latitude": "40.709991"
                        },
                        {
                            "area_id": 11261,
                            "city_id": 11069,
                            "province_id": 7,
                            "name": "连山区",
                            "whole_name": "连山区，葫芦岛市，辽宁省",
                            "simple_py": "LSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0429",
                            "area_code": "211402",
                            "longitude": "120.85937",
                            "latitude": "40.755143"
                        },
                        {
                            "area_id": 11260,
                            "city_id": 11069,
                            "province_id": 7,
                            "name": "南票区",
                            "whole_name": "南票区，葫芦岛市，辽宁省",
                            "simple_py": "NPQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0429",
                            "area_code": "211404",
                            "longitude": "120.752314",
                            "latitude": "41.098813"
                        },
                        {
                            "area_id": 11259,
                            "city_id": 11069,
                            "province_id": 7,
                            "name": "绥中县",
                            "whole_name": "绥中县，葫芦岛市，辽宁省",
                            "simple_py": "SZX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0429",
                            "area_code": "211421",
                            "longitude": "120.342112",
                            "latitude": "40.328407"
                        },
                        {
                            "area_id": 11257,
                            "city_id": 11069,
                            "province_id": 7,
                            "name": "兴城市",
                            "whole_name": "兴城市，葫芦岛市，辽宁省",
                            "simple_py": "XCS",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0429",
                            "area_code": "211481",
                            "longitude": "120.729365",
                            "latitude": "40.619413"
                        }
                    ]
                },
                {
                    "city_id": 11070,
                    "province_id": 7,
                    "name": "锦州市",
                    "whole_name": "锦州市，辽宁省",
                    "simple_py": "JZS",
                    "per_pin_yin": "J",
                    "per_pin_yin2": "J",
                    "city_code": "0416",
                    "area_code": "210700",
                    "longitude": "121.135742",
                    "latitude": "41.119269",
                    "children": [
                        {
                            "area_id": 11397,
                            "city_id": 11070,
                            "province_id": 7,
                            "name": "北镇市",
                            "whole_name": "北镇市，锦州市，辽宁省",
                            "simple_py": "BZS",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0416",
                            "area_code": "210782",
                            "longitude": "121.795962",
                            "latitude": "41.598764"
                        },
                        {
                            "area_id": 11399,
                            "city_id": 11070,
                            "province_id": 7,
                            "name": "古塔区",
                            "whole_name": "古塔区，锦州市，辽宁省",
                            "simple_py": "GTQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0416",
                            "area_code": "210702",
                            "longitude": "121.130085",
                            "latitude": "41.115719"
                        },
                        {
                            "area_id": 11393,
                            "city_id": 11070,
                            "province_id": 7,
                            "name": "黑山县",
                            "whole_name": "黑山县，锦州市，辽宁省",
                            "simple_py": "HSX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0416",
                            "area_code": "210726",
                            "longitude": "122.117915",
                            "latitude": "41.691804"
                        },
                        {
                            "area_id": 11394,
                            "city_id": 11070,
                            "province_id": 7,
                            "name": "凌海市",
                            "whole_name": "凌海市，锦州市，辽宁省",
                            "simple_py": "LHS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0416",
                            "area_code": "210781",
                            "longitude": "121.364236",
                            "latitude": "41.171738"
                        },
                        {
                            "area_id": 11398,
                            "city_id": 11070,
                            "province_id": 7,
                            "name": "凌河区",
                            "whole_name": "凌河区，锦州市，辽宁省",
                            "simple_py": "LHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0416",
                            "area_code": "210703",
                            "longitude": "121.151304",
                            "latitude": "41.114662"
                        },
                        {
                            "area_id": 11396,
                            "city_id": 11070,
                            "province_id": 7,
                            "name": "太和区",
                            "whole_name": "太和区，锦州市，辽宁省",
                            "simple_py": "THQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0416",
                            "area_code": "210711",
                            "longitude": "121.107297",
                            "latitude": "41.105378"
                        },
                        {
                            "area_id": 11395,
                            "city_id": 11070,
                            "province_id": 7,
                            "name": "义县",
                            "whole_name": "义县，锦州市，辽宁省",
                            "simple_py": "YX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0416",
                            "area_code": "210727",
                            "longitude": "121.242831",
                            "latitude": "41.537224"
                        }
                    ]
                },
                {
                    "city_id": 11076,
                    "province_id": 7,
                    "name": "辽阳市",
                    "whole_name": "辽阳市，辽宁省",
                    "simple_py": "LYS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0419",
                    "area_code": "211000",
                    "longitude": "123.18152",
                    "latitude": "41.269402",
                    "children": [
                        {
                            "area_id": 12188,
                            "city_id": 11076,
                            "province_id": 7,
                            "name": "白塔区",
                            "whole_name": "白塔区，辽阳市，辽宁省",
                            "simple_py": "BTQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0419",
                            "area_code": "211002",
                            "longitude": "123.172611",
                            "latitude": "41.26745"
                        },
                        {
                            "area_id": 12193,
                            "city_id": 11076,
                            "province_id": 7,
                            "name": "灯塔市",
                            "whole_name": "灯塔市，辽阳市，辽宁省",
                            "simple_py": "DTS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0419",
                            "area_code": "211081",
                            "longitude": "123.325864",
                            "latitude": "41.427836"
                        },
                        {
                            "area_id": 12189,
                            "city_id": 11076,
                            "province_id": 7,
                            "name": "弓长岭区",
                            "whole_name": "弓长岭区，辽阳市，辽宁省",
                            "simple_py": "GCLQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0419",
                            "area_code": "211005",
                            "longitude": "123.431633",
                            "latitude": "41.157831"
                        },
                        {
                            "area_id": 12191,
                            "city_id": 11076,
                            "province_id": 7,
                            "name": "宏伟区",
                            "whole_name": "宏伟区，辽阳市，辽宁省",
                            "simple_py": "HWQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0419",
                            "area_code": "211004",
                            "longitude": "123.200461",
                            "latitude": "41.205747"
                        },
                        {
                            "area_id": 12187,
                            "city_id": 11076,
                            "province_id": 7,
                            "name": "辽阳县",
                            "whole_name": "辽阳县，辽阳市，辽宁省",
                            "simple_py": "LYX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0419",
                            "area_code": "211021",
                            "longitude": "123.079674",
                            "latitude": "41.216479"
                        },
                        {
                            "area_id": 12192,
                            "city_id": 11076,
                            "province_id": 7,
                            "name": "太子河区",
                            "whole_name": "太子河区，辽阳市，辽宁省",
                            "simple_py": "TZHQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0419",
                            "area_code": "211011",
                            "longitude": "123.185336",
                            "latitude": "41.251682"
                        },
                        {
                            "area_id": 12190,
                            "city_id": 11076,
                            "province_id": 7,
                            "name": "文圣区",
                            "whole_name": "文圣区，辽阳市，辽宁省",
                            "simple_py": "WSQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0419",
                            "area_code": "211003",
                            "longitude": "123.188227",
                            "latitude": "41.266765"
                        }
                    ]
                },
                {
                    "city_id": 11077,
                    "province_id": 7,
                    "name": "盘锦市",
                    "whole_name": "盘锦市，辽宁省",
                    "simple_py": "PJS",
                    "per_pin_yin": "P",
                    "per_pin_yin2": "P",
                    "city_code": "0427",
                    "area_code": "211100",
                    "longitude": "122.06957",
                    "latitude": "41.124484",
                    "children": [
                        {
                            "area_id": 12256,
                            "city_id": 11077,
                            "province_id": 7,
                            "name": "大洼区",
                            "whole_name": "大洼区，盘锦市，辽宁省",
                            "simple_py": "DWQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0427",
                            "area_code": "211104",
                            "longitude": "122.071708",
                            "latitude": "40.994428"
                        },
                        {
                            "area_id": 12257,
                            "city_id": 11077,
                            "province_id": 7,
                            "name": "盘山县",
                            "whole_name": "盘山县，盘锦市，辽宁省",
                            "simple_py": "PSX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0427",
                            "area_code": "211122",
                            "longitude": "121.98528",
                            "latitude": "41.240701"
                        },
                        {
                            "area_id": 12258,
                            "city_id": 11077,
                            "province_id": 7,
                            "name": "双台子区",
                            "whole_name": "双台子区，盘锦市，辽宁省",
                            "simple_py": "STZQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0427",
                            "area_code": "211102",
                            "longitude": "122.055733",
                            "latitude": "41.190365"
                        },
                        {
                            "area_id": 12255,
                            "city_id": 11077,
                            "province_id": 7,
                            "name": "兴隆台区",
                            "whole_name": "兴隆台区，盘锦市，辽宁省",
                            "simple_py": "XLTQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0427",
                            "area_code": "211103",
                            "longitude": "122.071624",
                            "latitude": "41.122423"
                        }
                    ]
                },
                {
                    "city_id": 11073,
                    "province_id": 7,
                    "name": "沈阳市",
                    "whole_name": "沈阳市，辽宁省",
                    "simple_py": "SYS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "024",
                    "area_code": "210100",
                    "longitude": "123.429096",
                    "latitude": "41.796767",
                    "children": [
                        {
                            "area_id": 11723,
                            "city_id": 11073,
                            "province_id": 7,
                            "name": "大东区",
                            "whole_name": "大东区，沈阳市，辽宁省",
                            "simple_py": "DDQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "024",
                            "area_code": "210104",
                            "longitude": "123.469956",
                            "latitude": "41.808503"
                        },
                        {
                            "area_id": 11722,
                            "city_id": 11073,
                            "province_id": 7,
                            "name": "法库县",
                            "whole_name": "法库县，沈阳市，辽宁省",
                            "simple_py": "FKX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "024",
                            "area_code": "210124",
                            "longitude": "123.416722",
                            "latitude": "42.507045"
                        },
                        {
                            "area_id": 11714,
                            "city_id": 11073,
                            "province_id": 7,
                            "name": "浑南区",
                            "whole_name": "浑南区，沈阳市，辽宁省",
                            "simple_py": "HNQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "024",
                            "area_code": "210112",
                            "longitude": "123.458981",
                            "latitude": "41.741946"
                        },
                        {
                            "area_id": 11717,
                            "city_id": 11073,
                            "province_id": 7,
                            "name": "皇姑区",
                            "whole_name": "皇姑区，沈阳市，辽宁省",
                            "simple_py": "HGQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "024",
                            "area_code": "210105",
                            "longitude": "123.405677",
                            "latitude": "41.822336"
                        },
                        {
                            "area_id": 11718,
                            "city_id": 11073,
                            "province_id": 7,
                            "name": "和平区",
                            "whole_name": "和平区，沈阳市，辽宁省",
                            "simple_py": "HPQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "024",
                            "area_code": "210102",
                            "longitude": "123.406664",
                            "latitude": "41.788074"
                        },
                        {
                            "area_id": 11721,
                            "city_id": 11073,
                            "province_id": 7,
                            "name": "康平县",
                            "whole_name": "康平县，沈阳市，辽宁省",
                            "simple_py": "KPX",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "024",
                            "area_code": "210123",
                            "longitude": "123.352703",
                            "latitude": "42.741533"
                        },
                        {
                            "area_id": 11715,
                            "city_id": 11073,
                            "province_id": 7,
                            "name": "辽中区",
                            "whole_name": "辽中区，沈阳市，辽宁省",
                            "simple_py": "LZQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "024",
                            "area_code": "210115",
                            "longitude": "122.731269",
                            "latitude": "41.512725"
                        },
                        {
                            "area_id": 11713,
                            "city_id": 11073,
                            "province_id": 7,
                            "name": "沈北新区",
                            "whole_name": "沈北新区，沈阳市，辽宁省",
                            "simple_py": "SBXQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "024",
                            "area_code": "210113",
                            "longitude": "123.521471",
                            "latitude": "42.052312"
                        },
                        {
                            "area_id": 11720,
                            "city_id": 11073,
                            "province_id": 7,
                            "name": "苏家屯区",
                            "whole_name": "苏家屯区，沈阳市，辽宁省",
                            "simple_py": "SJTQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "024",
                            "area_code": "210111",
                            "longitude": "123.341604",
                            "latitude": "41.665904"
                        },
                        {
                            "area_id": 11724,
                            "city_id": 11073,
                            "province_id": 7,
                            "name": "沈河区",
                            "whole_name": "沈河区，沈阳市，辽宁省",
                            "simple_py": "SHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "024",
                            "area_code": "210103",
                            "longitude": "123.445696",
                            "latitude": "41.795591"
                        },
                        {
                            "area_id": 11719,
                            "city_id": 11073,
                            "province_id": 7,
                            "name": "铁西区",
                            "whole_name": "铁西区，沈阳市，辽宁省",
                            "simple_py": "TXQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "024",
                            "area_code": "210106",
                            "longitude": "123.350664",
                            "latitude": "41.787808"
                        },
                        {
                            "area_id": 11712,
                            "city_id": 11073,
                            "province_id": 7,
                            "name": "新民市",
                            "whole_name": "新民市，沈阳市，辽宁省",
                            "simple_py": "XMS",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "024",
                            "area_code": "210181",
                            "longitude": "122.828868",
                            "latitude": "41.996508"
                        },
                        {
                            "area_id": 11716,
                            "city_id": 11073,
                            "province_id": 7,
                            "name": "于洪区",
                            "whole_name": "于洪区，沈阳市，辽宁省",
                            "simple_py": "YHQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "024",
                            "area_code": "210114",
                            "longitude": "123.310829",
                            "latitude": "41.795833"
                        }
                    ]
                },
                {
                    "city_id": 11075,
                    "province_id": 7,
                    "name": "铁岭市",
                    "whole_name": "铁岭市，辽宁省",
                    "simple_py": "TLS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "024",
                    "area_code": "211200",
                    "longitude": "123.844279",
                    "latitude": "42.290585",
                    "children": [
                        {
                            "area_id": 12074,
                            "city_id": 11075,
                            "province_id": 7,
                            "name": "昌图县",
                            "whole_name": "昌图县，铁岭市，辽宁省",
                            "simple_py": "CTX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "024",
                            "area_code": "211224",
                            "longitude": "124.11017",
                            "latitude": "42.784441"
                        },
                        {
                            "area_id": 12069,
                            "city_id": 11075,
                            "province_id": 7,
                            "name": "开原市",
                            "whole_name": "开原市，铁岭市，辽宁省",
                            "simple_py": "KYS",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "024",
                            "area_code": "211282",
                            "longitude": "124.045551",
                            "latitude": "42.542141"
                        },
                        {
                            "area_id": 12070,
                            "city_id": 11075,
                            "province_id": 7,
                            "name": "清河区",
                            "whole_name": "清河区，铁岭市，辽宁省",
                            "simple_py": "QHQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "024",
                            "area_code": "211204",
                            "longitude": "124.14896",
                            "latitude": "42.542978"
                        },
                        {
                            "area_id": 12068,
                            "city_id": 11075,
                            "province_id": 7,
                            "name": "调兵山市",
                            "whole_name": "调兵山市，铁岭市，辽宁省",
                            "simple_py": "TBSS",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "024",
                            "area_code": "211281",
                            "longitude": "123.545366",
                            "latitude": "42.450734"
                        },
                        {
                            "area_id": 12073,
                            "city_id": 11075,
                            "province_id": 7,
                            "name": "铁岭县",
                            "whole_name": "铁岭县，铁岭市，辽宁省",
                            "simple_py": "TLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "024",
                            "area_code": "211221",
                            "longitude": "123.725669",
                            "latitude": "42.223316"
                        },
                        {
                            "area_id": 12072,
                            "city_id": 11075,
                            "province_id": 7,
                            "name": "西丰县",
                            "whole_name": "西丰县，铁岭市，辽宁省",
                            "simple_py": "XFX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "024",
                            "area_code": "211223",
                            "longitude": "124.72332",
                            "latitude": "42.738091"
                        },
                        {
                            "area_id": 12071,
                            "city_id": 11075,
                            "province_id": 7,
                            "name": "银州区",
                            "whole_name": "银州区，铁岭市，辽宁省",
                            "simple_py": "YZQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "024",
                            "area_code": "211202",
                            "longitude": "123.844877",
                            "latitude": "42.292278"
                        }
                    ]
                },
                {
                    "city_id": 11078,
                    "province_id": 7,
                    "name": "营口市",
                    "whole_name": "营口市，辽宁省",
                    "simple_py": "YKS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0417",
                    "area_code": "210800",
                    "longitude": "122.235151",
                    "latitude": "40.667432",
                    "children": [
                        {
                            "area_id": 12318,
                            "city_id": 11078,
                            "province_id": 7,
                            "name": "鲅鱼圈区",
                            "whole_name": "鲅鱼圈区，营口市，辽宁省",
                            "simple_py": "BYQQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0417",
                            "area_code": "210804",
                            "longitude": "122.127242",
                            "latitude": "40.263646"
                        },
                        {
                            "area_id": 12319,
                            "city_id": 11078,
                            "province_id": 7,
                            "name": "大石桥市",
                            "whole_name": "大石桥市，营口市，辽宁省",
                            "simple_py": "DSQS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0417",
                            "area_code": "210882",
                            "longitude": "122.505894",
                            "latitude": "40.633973"
                        },
                        {
                            "area_id": 12321,
                            "city_id": 11078,
                            "province_id": 7,
                            "name": "盖州市",
                            "whole_name": "盖州市，营口市，辽宁省",
                            "simple_py": "GZS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0417",
                            "area_code": "210881",
                            "longitude": "122.355534",
                            "latitude": "40.405234"
                        },
                        {
                            "area_id": 12323,
                            "city_id": 11078,
                            "province_id": 7,
                            "name": "老边区",
                            "whole_name": "老边区，营口市，辽宁省",
                            "simple_py": "LBQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0417",
                            "area_code": "210811",
                            "longitude": "122.382584",
                            "latitude": "40.682723"
                        },
                        {
                            "area_id": 12320,
                            "city_id": 11078,
                            "province_id": 7,
                            "name": "西市区",
                            "whole_name": "西市区，营口市，辽宁省",
                            "simple_py": "XSQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0417",
                            "area_code": "210803",
                            "longitude": "122.210067",
                            "latitude": "40.663086"
                        },
                        {
                            "area_id": 12322,
                            "city_id": 11078,
                            "province_id": 7,
                            "name": "站前区",
                            "whole_name": "站前区，营口市，辽宁省",
                            "simple_py": "ZQQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0417",
                            "area_code": "210802",
                            "longitude": "122.253235",
                            "latitude": "40.669949"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 3,
            "name": "内蒙古自治区",
            "whole_name": "内蒙古自治区",
            "simple_py": "NMGZZQ",
            "per_pin_yin": "N",
            "per_pin_yin2": "N",
            "city_code": "",
            "area_code": "150000",
            "longitude": "111.670801",
            "latitude": "40.818311",
            "children": [
                {
                    "city_id": 4636,
                    "province_id": 3,
                    "name": "阿拉善盟",
                    "whole_name": "阿拉善盟，内蒙古自治区",
                    "simple_py": "ALSM",
                    "per_pin_yin": "A",
                    "per_pin_yin2": "A",
                    "city_code": "0483",
                    "area_code": "152900",
                    "longitude": "105.706422",
                    "latitude": "38.844814",
                    "children": [
                        {
                            "area_id": 5599,
                            "city_id": 4636,
                            "province_id": 3,
                            "name": "阿拉善右旗",
                            "whole_name": "阿拉善右旗，阿拉善盟，内蒙古自治区",
                            "simple_py": "ALSYQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0483",
                            "area_code": "152922",
                            "longitude": "101.671984",
                            "latitude": "39.21159"
                        },
                        {
                            "area_id": 5600,
                            "city_id": 4636,
                            "province_id": 3,
                            "name": "阿拉善左旗",
                            "whole_name": "阿拉善左旗，阿拉善盟，内蒙古自治区",
                            "simple_py": "ALSZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "A",
                            "city_code": "0483",
                            "area_code": "152921",
                            "longitude": "105.70192",
                            "latitude": "38.847241"
                        },
                        {
                            "area_id": 5598,
                            "city_id": 4636,
                            "province_id": 3,
                            "name": "额济纳旗",
                            "whole_name": "额济纳旗，阿拉善盟，内蒙古自治区",
                            "simple_py": "EJNQ",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0483",
                            "area_code": "152923",
                            "longitude": "101.06944",
                            "latitude": "41.958813"
                        }
                    ]
                },
                {
                    "city_id": 4629,
                    "province_id": 3,
                    "name": "巴彦淖尔市",
                    "whole_name": "巴彦淖尔市，内蒙古自治区",
                    "simple_py": "BYNES",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "0478",
                    "area_code": "150800",
                    "longitude": "107.416959",
                    "latitude": "40.757402",
                    "children": [
                        {
                            "area_id": 4668,
                            "city_id": 4629,
                            "province_id": 3,
                            "name": "磴口县",
                            "whole_name": "磴口县，巴彦淖尔市，内蒙古自治区",
                            "simple_py": "DKX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0478",
                            "area_code": "150822",
                            "longitude": "107.006056",
                            "latitude": "40.330479"
                        },
                        {
                            "area_id": 4669,
                            "city_id": 4629,
                            "province_id": 3,
                            "name": "杭锦后旗",
                            "whole_name": "杭锦后旗，巴彦淖尔市，内蒙古自治区",
                            "simple_py": "HJHQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0478",
                            "area_code": "150826",
                            "longitude": "107.147682",
                            "latitude": "40.888797"
                        },
                        {
                            "area_id": 4667,
                            "city_id": 4629,
                            "province_id": 3,
                            "name": "临河区",
                            "whole_name": "临河区，巴彦淖尔市，内蒙古自治区",
                            "simple_py": "LHQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0478",
                            "area_code": "150802",
                            "longitude": "107.417018",
                            "latitude": "40.757092"
                        },
                        {
                            "area_id": 4665,
                            "city_id": 4629,
                            "province_id": 3,
                            "name": "乌拉特中旗",
                            "whole_name": "乌拉特中旗，巴彦淖尔市，内蒙古自治区",
                            "simple_py": "WLTZQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0478",
                            "area_code": "150824",
                            "longitude": "108.515255",
                            "latitude": "41.57254"
                        },
                        {
                            "area_id": 4666,
                            "city_id": 4629,
                            "province_id": 3,
                            "name": "五原县",
                            "whole_name": "五原县，巴彦淖尔市，内蒙古自治区",
                            "simple_py": "WYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0478",
                            "area_code": "150821",
                            "longitude": "108.270658",
                            "latitude": "41.097639"
                        },
                        {
                            "area_id": 4670,
                            "city_id": 4629,
                            "province_id": 3,
                            "name": "乌拉特后旗",
                            "whole_name": "乌拉特后旗，巴彦淖尔市，内蒙古自治区",
                            "simple_py": "WLTHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0478",
                            "area_code": "150825",
                            "longitude": "107.074941",
                            "latitude": "41.084307"
                        },
                        {
                            "area_id": 4671,
                            "city_id": 4629,
                            "province_id": 3,
                            "name": "乌拉特前旗",
                            "whole_name": "乌拉特前旗，巴彦淖尔市，内蒙古自治区",
                            "simple_py": "WLTQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0478",
                            "area_code": "150823",
                            "longitude": "108.656816",
                            "latitude": "40.725209"
                        }
                    ]
                },
                {
                    "city_id": 4632,
                    "province_id": 3,
                    "name": "包头市",
                    "whole_name": "包头市，内蒙古自治区",
                    "simple_py": "BTS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "B",
                    "city_code": "0472",
                    "area_code": "150200",
                    "longitude": "109.840405",
                    "latitude": "40.658168",
                    "children": [
                        {
                            "area_id": 5058,
                            "city_id": 4632,
                            "province_id": 3,
                            "name": "白云鄂博矿区",
                            "whole_name": "白云鄂博矿区，包头市，内蒙古自治区",
                            "simple_py": "BYEBKQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0472",
                            "area_code": "150206",
                            "longitude": "109.97016",
                            "latitude": "41.769246"
                        },
                        {
                            "area_id": 5057,
                            "city_id": 4632,
                            "province_id": 3,
                            "name": "达尔罕茂明安联合旗",
                            "whole_name": "达尔罕茂明安联合旗，包头市，内蒙古自治区",
                            "simple_py": "DEHMMALHQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0472",
                            "area_code": "150223",
                            "longitude": "110.438452",
                            "latitude": "41.702836"
                        },
                        {
                            "area_id": 5059,
                            "city_id": 4632,
                            "province_id": 3,
                            "name": "东河区",
                            "whole_name": "东河区，包头市，内蒙古自治区",
                            "simple_py": "DHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0472",
                            "area_code": "150202",
                            "longitude": "110.026895",
                            "latitude": "40.587056"
                        },
                        {
                            "area_id": 5061,
                            "city_id": 4632,
                            "province_id": 3,
                            "name": "固阳县",
                            "whole_name": "固阳县，包头市，内蒙古自治区",
                            "simple_py": "GYX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0472",
                            "area_code": "150222",
                            "longitude": "110.063421",
                            "latitude": "41.030004"
                        },
                        {
                            "area_id": 5060,
                            "city_id": 4632,
                            "province_id": 3,
                            "name": "九原区",
                            "whole_name": "九原区，包头市，内蒙古自治区",
                            "simple_py": "JYQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0472",
                            "area_code": "150207",
                            "longitude": "109.968122",
                            "latitude": "40.600581"
                        },
                        {
                            "area_id": 5062,
                            "city_id": 4632,
                            "province_id": 3,
                            "name": "昆都仑区",
                            "whole_name": "昆都仑区，包头市，内蒙古自治区",
                            "simple_py": "KDLQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0472",
                            "area_code": "150203",
                            "longitude": "109.822932",
                            "latitude": "40.661345"
                        },
                        {
                            "area_id": 5064,
                            "city_id": 4632,
                            "province_id": 3,
                            "name": "青山区",
                            "whole_name": "青山区，包头市，内蒙古自治区",
                            "simple_py": "QSQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0472",
                            "area_code": "150204",
                            "longitude": "109.880049",
                            "latitude": "40.668558"
                        },
                        {
                            "area_id": 5063,
                            "city_id": 4632,
                            "province_id": 3,
                            "name": "石拐区",
                            "whole_name": "石拐区，包头市，内蒙古自治区",
                            "simple_py": "SGQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0472",
                            "area_code": "150205",
                            "longitude": "110.272565",
                            "latitude": "40.672094"
                        },
                        {
                            "area_id": 5056,
                            "city_id": 4632,
                            "province_id": 3,
                            "name": "土默特右旗",
                            "whole_name": "土默特右旗，包头市，内蒙古自治区",
                            "simple_py": "TMTYQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0472",
                            "area_code": "150221",
                            "longitude": "110.526766",
                            "latitude": "40.566434"
                        }
                    ]
                },
                {
                    "city_id": 4635,
                    "province_id": 3,
                    "name": "赤峰市",
                    "whole_name": "赤峰市，内蒙古自治区",
                    "simple_py": "CFS",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0476",
                    "area_code": "150400",
                    "longitude": "118.956806",
                    "latitude": "42.275317",
                    "children": [
                        {
                            "area_id": 5403,
                            "city_id": 4635,
                            "province_id": 3,
                            "name": "阿鲁科尔沁旗",
                            "whole_name": "阿鲁科尔沁旗，赤峰市，内蒙古自治区",
                            "simple_py": "ALKEQQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0476",
                            "area_code": "150421",
                            "longitude": "120.094969",
                            "latitude": "43.87877"
                        },
                        {
                            "area_id": 5414,
                            "city_id": 4635,
                            "province_id": 3,
                            "name": "敖汉旗",
                            "whole_name": "敖汉旗，赤峰市，内蒙古自治区",
                            "simple_py": "AHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "A",
                            "city_code": "0476",
                            "area_code": "150430",
                            "longitude": "119.906486",
                            "latitude": "42.287012"
                        },
                        {
                            "area_id": 5405,
                            "city_id": 4635,
                            "province_id": 3,
                            "name": "巴林左旗",
                            "whole_name": "巴林左旗，赤峰市，内蒙古自治区",
                            "simple_py": "BLZQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0476",
                            "area_code": "150422",
                            "longitude": "119.391737",
                            "latitude": "43.980715"
                        },
                        {
                            "area_id": 5406,
                            "city_id": 4635,
                            "province_id": 3,
                            "name": "巴林右旗",
                            "whole_name": "巴林右旗，赤峰市，内蒙古自治区",
                            "simple_py": "BLYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0476",
                            "area_code": "150423",
                            "longitude": "118.678347",
                            "latitude": "43.528963"
                        },
                        {
                            "area_id": 5411,
                            "city_id": 4635,
                            "province_id": 3,
                            "name": "红山区",
                            "whole_name": "红山区，赤峰市，内蒙古自治区",
                            "simple_py": "HSQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0476",
                            "area_code": "150402",
                            "longitude": "118.961087",
                            "latitude": "42.269732"
                        },
                        {
                            "area_id": 5407,
                            "city_id": 4635,
                            "province_id": 3,
                            "name": "克什克腾旗",
                            "whole_name": "克什克腾旗，赤峰市，内蒙古自治区",
                            "simple_py": "KSKTQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0476",
                            "area_code": "150425",
                            "longitude": "117.542465",
                            "latitude": "43.256233"
                        },
                        {
                            "area_id": 5413,
                            "city_id": 4635,
                            "province_id": 3,
                            "name": "喀喇沁旗",
                            "whole_name": "喀喇沁旗，赤峰市，内蒙古自治区",
                            "simple_py": "KLQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "K",
                            "city_code": "0476",
                            "area_code": "150428",
                            "longitude": "118.708572",
                            "latitude": "41.92778"
                        },
                        {
                            "area_id": 5404,
                            "city_id": 4635,
                            "province_id": 3,
                            "name": "林西县",
                            "whole_name": "林西县，赤峰市，内蒙古自治区",
                            "simple_py": "LXX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0476",
                            "area_code": "150424",
                            "longitude": "118.05775",
                            "latitude": "43.605326"
                        },
                        {
                            "area_id": 5410,
                            "city_id": 4635,
                            "province_id": 3,
                            "name": "宁城县",
                            "whole_name": "宁城县，赤峰市，内蒙古自治区",
                            "simple_py": "NCX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0476",
                            "area_code": "150429",
                            "longitude": "119.339242",
                            "latitude": "41.598692"
                        },
                        {
                            "area_id": 5409,
                            "city_id": 4635,
                            "province_id": 3,
                            "name": "松山区",
                            "whole_name": "松山区，赤峰市，内蒙古自治区",
                            "simple_py": "SSQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0476",
                            "area_code": "150404",
                            "longitude": "118.938958",
                            "latitude": "42.281046"
                        },
                        {
                            "area_id": 5408,
                            "city_id": 4635,
                            "province_id": 3,
                            "name": "翁牛特旗",
                            "whole_name": "翁牛特旗，赤峰市，内蒙古自治区",
                            "simple_py": "WNTQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0476",
                            "area_code": "150426",
                            "longitude": "119.022619",
                            "latitude": "42.937128"
                        },
                        {
                            "area_id": 5412,
                            "city_id": 4635,
                            "province_id": 3,
                            "name": "元宝山区",
                            "whole_name": "元宝山区，赤峰市，内蒙古自治区",
                            "simple_py": "YBSQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0476",
                            "area_code": "150403",
                            "longitude": "119.289877",
                            "latitude": "42.041168"
                        }
                    ]
                },
                {
                    "city_id": 4631,
                    "province_id": 3,
                    "name": "鄂尔多斯市",
                    "whole_name": "鄂尔多斯市，内蒙古自治区",
                    "simple_py": "EEDSS",
                    "per_pin_yin": "E",
                    "per_pin_yin2": "E",
                    "city_code": "0477",
                    "area_code": "150600",
                    "longitude": "109.99029",
                    "latitude": "39.817179",
                    "children": [
                        {
                            "area_id": 4965,
                            "city_id": 4631,
                            "province_id": 3,
                            "name": "达拉特旗",
                            "whole_name": "达拉特旗，鄂尔多斯市，内蒙古自治区",
                            "simple_py": "DLTQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0477",
                            "area_code": "150621",
                            "longitude": "110.040281",
                            "latitude": "40.404076"
                        },
                        {
                            "area_id": 4969,
                            "city_id": 4631,
                            "province_id": 3,
                            "name": "东胜区",
                            "whole_name": "东胜区，鄂尔多斯市，内蒙古自治区",
                            "simple_py": "DSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0477",
                            "area_code": "150602",
                            "longitude": "109.98945",
                            "latitude": "39.81788"
                        },
                        {
                            "area_id": 4963,
                            "city_id": 4631,
                            "province_id": 3,
                            "name": "鄂托克旗",
                            "whole_name": "鄂托克旗，鄂尔多斯市，内蒙古自治区",
                            "simple_py": "ETKQ",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0477",
                            "area_code": "150624",
                            "longitude": "107.982604",
                            "latitude": "39.095752"
                        },
                        {
                            "area_id": 4967,
                            "city_id": 4631,
                            "province_id": 3,
                            "name": "鄂托克前旗",
                            "whole_name": "鄂托克前旗，鄂尔多斯市，内蒙古自治区",
                            "simple_py": "ETKQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "E",
                            "city_code": "0477",
                            "area_code": "150623",
                            "longitude": "107.48172",
                            "latitude": "38.183257"
                        },
                        {
                            "area_id": 4964,
                            "city_id": 4631,
                            "province_id": 3,
                            "name": "杭锦旗",
                            "whole_name": "杭锦旗，鄂尔多斯市，内蒙古自治区",
                            "simple_py": "HJQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0477",
                            "area_code": "150625",
                            "longitude": "108.736324",
                            "latitude": "39.831789"
                        },
                        {
                            "area_id": 4968,
                            "city_id": 4631,
                            "province_id": 3,
                            "name": "康巴什区",
                            "whole_name": "康巴什区，鄂尔多斯市，内蒙古自治区",
                            "simple_py": "KBSQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0477",
                            "area_code": "150603",
                            "longitude": "109.790076",
                            "latitude": "39.607472"
                        },
                        {
                            "area_id": 4966,
                            "city_id": 4631,
                            "province_id": 3,
                            "name": "乌审旗",
                            "whole_name": "乌审旗，鄂尔多斯市，内蒙古自治区",
                            "simple_py": "WSQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0477",
                            "area_code": "150626",
                            "longitude": "108.842454",
                            "latitude": "38.596611"
                        },
                        {
                            "area_id": 4970,
                            "city_id": 4631,
                            "province_id": 3,
                            "name": "伊金霍洛旗",
                            "whole_name": "伊金霍洛旗，鄂尔多斯市，内蒙古自治区",
                            "simple_py": "YJHLQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0477",
                            "area_code": "150627",
                            "longitude": "109.787402",
                            "latitude": "39.604312"
                        },
                        {
                            "area_id": 4962,
                            "city_id": 4631,
                            "province_id": 3,
                            "name": "准格尔旗",
                            "whole_name": "准格尔旗，鄂尔多斯市，内蒙古自治区",
                            "simple_py": "ZGEQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0477",
                            "area_code": "150622",
                            "longitude": "111.238332",
                            "latitude": "39.865221"
                        }
                    ]
                },
                {
                    "city_id": 4630,
                    "province_id": 3,
                    "name": "呼伦贝尔市",
                    "whole_name": "呼伦贝尔市，内蒙古自治区",
                    "simple_py": "HLBES",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0470",
                    "area_code": "150700",
                    "longitude": "119.758168",
                    "latitude": "49.215333",
                    "children": [
                        {
                            "area_id": 4764,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "阿荣旗",
                            "whole_name": "阿荣旗，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "ARQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0470",
                            "area_code": "150721",
                            "longitude": "123.464615",
                            "latitude": "48.130503"
                        },
                        {
                            "area_id": 4763,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "陈巴尔虎旗",
                            "whole_name": "陈巴尔虎旗，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "CBEHQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0470",
                            "area_code": "150725",
                            "longitude": "119.437609",
                            "latitude": "49.328422"
                        },
                        {
                            "area_id": 4761,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "额尔古纳市",
                            "whole_name": "额尔古纳市，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "EEGNS",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0470",
                            "area_code": "150784",
                            "longitude": "120.178636",
                            "latitude": "50.2439"
                        },
                        {
                            "area_id": 4765,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "鄂温克族自治旗",
                            "whole_name": "鄂温克族自治旗，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "EWKZZZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "E",
                            "city_code": "0470",
                            "area_code": "150724",
                            "longitude": "119.754041",
                            "latitude": "49.143293"
                        },
                        {
                            "area_id": 4774,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "鄂伦春自治旗",
                            "whole_name": "鄂伦春自治旗，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "ELCZZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "E",
                            "city_code": "0470",
                            "area_code": "150723",
                            "longitude": "123.725684",
                            "latitude": "50.590177"
                        },
                        {
                            "area_id": 4766,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "根河市",
                            "whole_name": "根河市，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "GHS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0470",
                            "area_code": "150785",
                            "longitude": "121.532724",
                            "latitude": "50.780454"
                        },
                        {
                            "area_id": 4762,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "海拉尔区",
                            "whole_name": "海拉尔区，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "HLEQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0470",
                            "area_code": "150702",
                            "longitude": "119.764923",
                            "latitude": "49.213889"
                        },
                        {
                            "area_id": 4769,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "莫力达瓦达斡尔族自治旗",
                            "whole_name": "莫力达瓦达斡尔族自治旗，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "MLDWDWEZZZQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0470",
                            "area_code": "150722",
                            "longitude": "124.507401",
                            "latitude": "48.478385"
                        },
                        {
                            "area_id": 4770,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "满洲里市",
                            "whole_name": "满洲里市，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "MZLS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0470",
                            "area_code": "150781",
                            "longitude": "117.455561",
                            "latitude": "49.590788"
                        },
                        {
                            "area_id": 4771,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "新巴尔虎左旗",
                            "whole_name": "新巴尔虎左旗，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "XBEHZQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0470",
                            "area_code": "150726",
                            "longitude": "118.267454",
                            "latitude": "48.216571"
                        },
                        {
                            "area_id": 4773,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "新巴尔虎右旗",
                            "whole_name": "新巴尔虎右旗，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "XBEHYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0470",
                            "area_code": "150727",
                            "longitude": "116.825991",
                            "latitude": "48.669134"
                        },
                        {
                            "area_id": 4767,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "牙克石市",
                            "whole_name": "牙克石市，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "YKSS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0470",
                            "area_code": "150782",
                            "longitude": "120.729005",
                            "latitude": "49.287024"
                        },
                        {
                            "area_id": 4768,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "扎兰屯市",
                            "whole_name": "扎兰屯市，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "ZLTS",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0470",
                            "area_code": "150783",
                            "longitude": "122.744401",
                            "latitude": "48.007412"
                        },
                        {
                            "area_id": 4772,
                            "city_id": 4630,
                            "province_id": 3,
                            "name": "扎赉诺尔区",
                            "whole_name": "扎赉诺尔区，呼伦贝尔市，内蒙古自治区",
                            "simple_py": "ZLNEQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0470",
                            "area_code": "150703",
                            "longitude": "117.716373",
                            "latitude": "49.456567"
                        }
                    ]
                },
                {
                    "city_id": 4633,
                    "province_id": 3,
                    "name": "呼和浩特市",
                    "whole_name": "呼和浩特市，内蒙古自治区",
                    "simple_py": "HHHTS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0471",
                    "area_code": "150100",
                    "longitude": "111.670801",
                    "latitude": "40.818311",
                    "children": [
                        {
                            "area_id": 5156,
                            "city_id": 4633,
                            "province_id": 3,
                            "name": "和林格尔县",
                            "whole_name": "和林格尔县，呼和浩特市，内蒙古自治区",
                            "simple_py": "HLGEX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0471",
                            "area_code": "150123",
                            "longitude": "111.824143",
                            "latitude": "40.380288"
                        },
                        {
                            "area_id": 5159,
                            "city_id": 4633,
                            "province_id": 3,
                            "name": "回民区",
                            "whole_name": "回民区，呼和浩特市，内蒙古自治区",
                            "simple_py": "HMQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0471",
                            "area_code": "150103",
                            "longitude": "111.662162",
                            "latitude": "40.815149"
                        },
                        {
                            "area_id": 5158,
                            "city_id": 4633,
                            "province_id": 3,
                            "name": "清水河县",
                            "whole_name": "清水河县，呼和浩特市，内蒙古自治区",
                            "simple_py": "QSHX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0471",
                            "area_code": "150124",
                            "longitude": "111.67222",
                            "latitude": "39.912479"
                        },
                        {
                            "area_id": 5164,
                            "city_id": 4633,
                            "province_id": 3,
                            "name": "赛罕区",
                            "whole_name": "赛罕区，呼和浩特市，内蒙古自治区",
                            "simple_py": "SHQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0471",
                            "area_code": "150105",
                            "longitude": "111.698463",
                            "latitude": "40.807834"
                        },
                        {
                            "area_id": 5160,
                            "city_id": 4633,
                            "province_id": 3,
                            "name": "托克托县",
                            "whole_name": "托克托县，呼和浩特市，内蒙古自治区",
                            "simple_py": "TKTX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0471",
                            "area_code": "150122",
                            "longitude": "111.197317",
                            "latitude": "40.276729"
                        },
                        {
                            "area_id": 5162,
                            "city_id": 4633,
                            "province_id": 3,
                            "name": "土默特左旗",
                            "whole_name": "土默特左旗，呼和浩特市，内蒙古自治区",
                            "simple_py": "TMTZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0471",
                            "area_code": "150121",
                            "longitude": "111.133615",
                            "latitude": "40.720416"
                        },
                        {
                            "area_id": 5161,
                            "city_id": 4633,
                            "province_id": 3,
                            "name": "武川县",
                            "whole_name": "武川县，呼和浩特市，内蒙古自治区",
                            "simple_py": "WCX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0471",
                            "area_code": "150125",
                            "longitude": "111.456563",
                            "latitude": "41.094483"
                        },
                        {
                            "area_id": 5163,
                            "city_id": 4633,
                            "province_id": 3,
                            "name": "新城区",
                            "whole_name": "新城区，呼和浩特市，内蒙古自治区",
                            "simple_py": "XCQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0471",
                            "area_code": "150102",
                            "longitude": "111.685964",
                            "latitude": "40.826225"
                        },
                        {
                            "area_id": 5157,
                            "city_id": 4633,
                            "province_id": 3,
                            "name": "玉泉区",
                            "whole_name": "玉泉区，呼和浩特市，内蒙古自治区",
                            "simple_py": "YQQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0471",
                            "area_code": "150104",
                            "longitude": "111.66543",
                            "latitude": "40.799421"
                        }
                    ]
                },
                {
                    "city_id": 4634,
                    "province_id": 3,
                    "name": "通辽市",
                    "whole_name": "通辽市，内蒙古自治区",
                    "simple_py": "TLS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0475",
                    "area_code": "150500",
                    "longitude": "122.263119",
                    "latitude": "43.617429",
                    "children": [
                        {
                            "area_id": 5254,
                            "city_id": 4634,
                            "province_id": 3,
                            "name": "霍林郭勒市",
                            "whole_name": "霍林郭勒市，通辽市，内蒙古自治区",
                            "simple_py": "HLGLS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0475",
                            "area_code": "150581",
                            "longitude": "119.657862",
                            "latitude": "45.532361"
                        },
                        {
                            "area_id": 5256,
                            "city_id": 4634,
                            "province_id": 3,
                            "name": "科尔沁左翼中旗",
                            "whole_name": "科尔沁左翼中旗，通辽市，内蒙古自治区",
                            "simple_py": "KEQZYZQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0475",
                            "area_code": "150521",
                            "longitude": "123.313873",
                            "latitude": "44.127166"
                        },
                        {
                            "area_id": 5257,
                            "city_id": 4634,
                            "province_id": 3,
                            "name": "科尔沁区",
                            "whole_name": "科尔沁区，通辽市，内蒙古自治区",
                            "simple_py": "KEQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "K",
                            "city_code": "0475",
                            "area_code": "150502",
                            "longitude": "122.264042",
                            "latitude": "43.617422"
                        },
                        {
                            "area_id": 5259,
                            "city_id": 4634,
                            "province_id": 3,
                            "name": "开鲁县",
                            "whole_name": "开鲁县，通辽市，内蒙古自治区",
                            "simple_py": "KLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "K",
                            "city_code": "0475",
                            "area_code": "150523",
                            "longitude": "121.308797",
                            "latitude": "43.602432"
                        },
                        {
                            "area_id": 5260,
                            "city_id": 4634,
                            "province_id": 3,
                            "name": "库伦旗",
                            "whole_name": "库伦旗，通辽市，内蒙古自治区",
                            "simple_py": "KLQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "K",
                            "city_code": "0475",
                            "area_code": "150524",
                            "longitude": "121.774886",
                            "latitude": "42.734692"
                        },
                        {
                            "area_id": 5261,
                            "city_id": 4634,
                            "province_id": 3,
                            "name": "科尔沁左翼后旗",
                            "whole_name": "科尔沁左翼后旗，通辽市，内蒙古自治区",
                            "simple_py": "KEQZYHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "K",
                            "city_code": "0475",
                            "area_code": "150522",
                            "longitude": "122.355155",
                            "latitude": "42.954564"
                        },
                        {
                            "area_id": 5258,
                            "city_id": 4634,
                            "province_id": 3,
                            "name": "奈曼旗",
                            "whole_name": "奈曼旗，通辽市，内蒙古自治区",
                            "simple_py": "NMQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0475",
                            "area_code": "150525",
                            "longitude": "120.662543",
                            "latitude": "42.84685"
                        },
                        {
                            "area_id": 5255,
                            "city_id": 4634,
                            "province_id": 3,
                            "name": "扎鲁特旗",
                            "whole_name": "扎鲁特旗，通辽市，内蒙古自治区",
                            "simple_py": "ZLTQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0475",
                            "area_code": "150526",
                            "longitude": "120.905275",
                            "latitude": "44.555294"
                        }
                    ]
                },
                {
                    "city_id": 4628,
                    "province_id": 3,
                    "name": "乌海市",
                    "whole_name": "乌海市，内蒙古自治区",
                    "simple_py": "WHS",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "0473",
                    "area_code": "150300",
                    "longitude": "106.825563",
                    "latitude": "39.673734",
                    "children": [
                        {
                            "area_id": 4641,
                            "city_id": 4628,
                            "province_id": 3,
                            "name": "海勃湾区",
                            "whole_name": "海勃湾区，乌海市，内蒙古自治区",
                            "simple_py": "HBWQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0473",
                            "area_code": "150302",
                            "longitude": "106.817762",
                            "latitude": "39.673527"
                        },
                        {
                            "area_id": 4642,
                            "city_id": 4628,
                            "province_id": 3,
                            "name": "海南区",
                            "whole_name": "海南区，乌海市，内蒙古自治区",
                            "simple_py": "HNQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0473",
                            "area_code": "150303",
                            "longitude": "106.884789",
                            "latitude": "39.44153"
                        },
                        {
                            "area_id": 4640,
                            "city_id": 4628,
                            "province_id": 3,
                            "name": "乌达区",
                            "whole_name": "乌达区，乌海市，内蒙古自治区",
                            "simple_py": "WDQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0473",
                            "area_code": "150304",
                            "longitude": "106.722711",
                            "latitude": "39.502288"
                        }
                    ]
                },
                {
                    "city_id": 4639,
                    "province_id": 3,
                    "name": "乌兰察布市",
                    "whole_name": "乌兰察布市，内蒙古自治区",
                    "simple_py": "WLCBS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "W",
                    "city_code": "0474",
                    "area_code": "150900",
                    "longitude": "113.114543",
                    "latitude": "41.034126",
                    "children": [
                        {
                            "area_id": 5847,
                            "city_id": 4639,
                            "province_id": 3,
                            "name": "察哈尔右翼后旗",
                            "whole_name": "察哈尔右翼后旗，乌兰察布市，内蒙古自治区",
                            "simple_py": "CHEYYHQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0474",
                            "area_code": "150928",
                            "longitude": "113.1906",
                            "latitude": "41.447213"
                        },
                        {
                            "area_id": 5849,
                            "city_id": 4639,
                            "province_id": 3,
                            "name": "察哈尔右翼中旗",
                            "whole_name": "察哈尔右翼中旗，乌兰察布市，内蒙古自治区",
                            "simple_py": "CHEYYZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0474",
                            "area_code": "150927",
                            "longitude": "112.633563",
                            "latitude": "41.274212"
                        },
                        {
                            "area_id": 5856,
                            "city_id": 4639,
                            "province_id": 3,
                            "name": "察哈尔右翼前旗",
                            "whole_name": "察哈尔右翼前旗，乌兰察布市，内蒙古自治区",
                            "simple_py": "CHEYYQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0474",
                            "area_code": "150926",
                            "longitude": "113.211958",
                            "latitude": "40.786859"
                        },
                        {
                            "area_id": 5854,
                            "city_id": 4639,
                            "province_id": 3,
                            "name": "丰镇市",
                            "whole_name": "丰镇市，乌兰察布市，内蒙古自治区",
                            "simple_py": "FZS",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0474",
                            "area_code": "150981",
                            "longitude": "113.163462",
                            "latitude": "40.437534"
                        },
                        {
                            "area_id": 5850,
                            "city_id": 4639,
                            "province_id": 3,
                            "name": "化德县",
                            "whole_name": "化德县，乌兰察布市，内蒙古自治区",
                            "simple_py": "HDX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0474",
                            "area_code": "150922",
                            "longitude": "114.01008",
                            "latitude": "41.899335"
                        },
                        {
                            "area_id": 5855,
                            "city_id": 4639,
                            "province_id": 3,
                            "name": "集宁区",
                            "whole_name": "集宁区，乌兰察布市，内蒙古自治区",
                            "simple_py": "JNQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0474",
                            "area_code": "150902",
                            "longitude": "113.116453",
                            "latitude": "41.034134"
                        },
                        {
                            "area_id": 5853,
                            "city_id": 4639,
                            "province_id": 3,
                            "name": "凉城县",
                            "whole_name": "凉城县，乌兰察布市，内蒙古自治区",
                            "simple_py": "LCX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0474",
                            "area_code": "150925",
                            "longitude": "112.500911",
                            "latitude": "40.531627"
                        },
                        {
                            "area_id": 5846,
                            "city_id": 4639,
                            "province_id": 3,
                            "name": "四子王旗",
                            "whole_name": "四子王旗，乌兰察布市，内蒙古自治区",
                            "simple_py": "SZWQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0474",
                            "area_code": "150929",
                            "longitude": "111.70123",
                            "latitude": "41.528114"
                        },
                        {
                            "area_id": 5848,
                            "city_id": 4639,
                            "province_id": 3,
                            "name": "商都县",
                            "whole_name": "商都县，乌兰察布市，内蒙古自治区",
                            "simple_py": "SDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0474",
                            "area_code": "150923",
                            "longitude": "113.560643",
                            "latitude": "41.560163"
                        },
                        {
                            "area_id": 5851,
                            "city_id": 4639,
                            "province_id": 3,
                            "name": "兴和县",
                            "whole_name": "兴和县，乌兰察布市，内蒙古自治区",
                            "simple_py": "XHX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0474",
                            "area_code": "150924",
                            "longitude": "113.834009",
                            "latitude": "40.872437"
                        },
                        {
                            "area_id": 5852,
                            "city_id": 4639,
                            "province_id": 3,
                            "name": "卓资县",
                            "whole_name": "卓资县，乌兰察布市，内蒙古自治区",
                            "simple_py": "ZZX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0474",
                            "area_code": "150921",
                            "longitude": "112.577702",
                            "latitude": "40.89576"
                        }
                    ]
                },
                {
                    "city_id": 4637,
                    "province_id": 3,
                    "name": "兴安盟",
                    "whole_name": "兴安盟，内蒙古自治区",
                    "simple_py": "XAM",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "0482",
                    "area_code": "152200",
                    "longitude": "122.070317",
                    "latitude": "46.076268",
                    "children": [
                        {
                            "area_id": 5635,
                            "city_id": 4637,
                            "province_id": 3,
                            "name": "阿尔山市",
                            "whole_name": "阿尔山市，兴安盟，内蒙古自治区",
                            "simple_py": "AESS",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0482",
                            "area_code": "152202",
                            "longitude": "119.943656",
                            "latitude": "47.177"
                        },
                        {
                            "area_id": 5638,
                            "city_id": 4637,
                            "province_id": 3,
                            "name": "科尔沁右翼中旗",
                            "whole_name": "科尔沁右翼中旗，兴安盟，内蒙古自治区",
                            "simple_py": "KEQYYZQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0482",
                            "area_code": "152222",
                            "longitude": "121.472818",
                            "latitude": "45.059645"
                        },
                        {
                            "area_id": 5640,
                            "city_id": 4637,
                            "province_id": 3,
                            "name": "科尔沁右翼前旗",
                            "whole_name": "科尔沁右翼前旗，兴安盟，内蒙古自治区",
                            "simple_py": "KEQYYQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "K",
                            "city_code": "0482",
                            "area_code": "152221",
                            "longitude": "121.957544",
                            "latitude": "46.076497"
                        },
                        {
                            "area_id": 5637,
                            "city_id": 4637,
                            "province_id": 3,
                            "name": "突泉县",
                            "whole_name": "突泉县，兴安盟，内蒙古自治区",
                            "simple_py": "TQX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0482",
                            "area_code": "152224",
                            "longitude": "121.564856",
                            "latitude": "45.380986"
                        },
                        {
                            "area_id": 5639,
                            "city_id": 4637,
                            "province_id": 3,
                            "name": "乌兰浩特市",
                            "whole_name": "乌兰浩特市，兴安盟，内蒙古自治区",
                            "simple_py": "WLHTS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0482",
                            "area_code": "152201",
                            "longitude": "122.068975",
                            "latitude": "46.077238"
                        },
                        {
                            "area_id": 5636,
                            "city_id": 4637,
                            "province_id": 3,
                            "name": "扎赉特旗",
                            "whole_name": "扎赉特旗，兴安盟，内蒙古自治区",
                            "simple_py": "ZLTQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0482",
                            "area_code": "152223",
                            "longitude": "122.909332",
                            "latitude": "46.725136"
                        }
                    ]
                },
                {
                    "city_id": 4638,
                    "province_id": 3,
                    "name": "锡林郭勒盟",
                    "whole_name": "锡林郭勒盟，内蒙古自治区",
                    "simple_py": "XLGLM",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "X",
                    "city_code": "0479",
                    "area_code": "152500",
                    "longitude": "116.090996",
                    "latitude": "43.944018",
                    "children": [
                        {
                            "area_id": 5732,
                            "city_id": 4638,
                            "province_id": 3,
                            "name": "阿巴嘎旗",
                            "whole_name": "阿巴嘎旗，锡林郭勒盟，内蒙古自治区",
                            "simple_py": "ABGQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0479",
                            "area_code": "152522",
                            "longitude": "114.970618",
                            "latitude": "44.022728"
                        },
                        {
                            "area_id": 5731,
                            "city_id": 4638,
                            "province_id": 3,
                            "name": "东乌珠穆沁旗",
                            "whole_name": "东乌珠穆沁旗，锡林郭勒盟，内蒙古自治区",
                            "simple_py": "DWZMQQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0479",
                            "area_code": "152525",
                            "longitude": "116.980022",
                            "latitude": "45.510307"
                        },
                        {
                            "area_id": 5741,
                            "city_id": 4638,
                            "province_id": 3,
                            "name": "多伦县",
                            "whole_name": "多伦县，锡林郭勒盟，内蒙古自治区",
                            "simple_py": "DLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0479",
                            "area_code": "152531",
                            "longitude": "116.477288",
                            "latitude": "42.197962"
                        },
                        {
                            "area_id": 5737,
                            "city_id": 4638,
                            "province_id": 3,
                            "name": "二连浩特市",
                            "whole_name": "二连浩特市，锡林郭勒盟，内蒙古自治区",
                            "simple_py": "ELHTS",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0479",
                            "area_code": "152501",
                            "longitude": "111.97981",
                            "latitude": "43.652895"
                        },
                        {
                            "area_id": 5735,
                            "city_id": 4638,
                            "province_id": 3,
                            "name": "苏尼特左旗",
                            "whole_name": "苏尼特左旗，锡林郭勒盟，内蒙古自治区",
                            "simple_py": "SNTZQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0479",
                            "area_code": "152523",
                            "longitude": "113.653412",
                            "latitude": "43.854108"
                        },
                        {
                            "area_id": 5736,
                            "city_id": 4638,
                            "province_id": 3,
                            "name": "苏尼特右旗",
                            "whole_name": "苏尼特右旗，锡林郭勒盟，内蒙古自治区",
                            "simple_py": "SNTYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0479",
                            "area_code": "152524",
                            "longitude": "112.65539",
                            "latitude": "42.746662"
                        },
                        {
                            "area_id": 5742,
                            "city_id": 4638,
                            "province_id": 3,
                            "name": "太仆寺旗",
                            "whole_name": "太仆寺旗，锡林郭勒盟，内蒙古自治区",
                            "simple_py": "TPSQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0479",
                            "area_code": "152527",
                            "longitude": "115.28728",
                            "latitude": "41.895199"
                        },
                        {
                            "area_id": 5733,
                            "city_id": 4638,
                            "province_id": 3,
                            "name": "西乌珠穆沁旗",
                            "whole_name": "西乌珠穆沁旗，锡林郭勒盟，内蒙古自治区",
                            "simple_py": "XWZMQQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0479",
                            "area_code": "152526",
                            "longitude": "117.615249",
                            "latitude": "44.586147"
                        },
                        {
                            "area_id": 5734,
                            "city_id": 4638,
                            "province_id": 3,
                            "name": "锡林浩特市",
                            "whole_name": "锡林浩特市，锡林郭勒盟，内蒙古自治区",
                            "simple_py": "XLHTS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0479",
                            "area_code": "152502",
                            "longitude": "116.091903",
                            "latitude": "43.944301"
                        },
                        {
                            "area_id": 5738,
                            "city_id": 4638,
                            "province_id": 3,
                            "name": "镶黄旗",
                            "whole_name": "镶黄旗，锡林郭勒盟，内蒙古自治区",
                            "simple_py": "XHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0479",
                            "area_code": "152528",
                            "longitude": "113.843869",
                            "latitude": "42.239229"
                        },
                        {
                            "area_id": 5739,
                            "city_id": 4638,
                            "province_id": 3,
                            "name": "正蓝旗",
                            "whole_name": "正蓝旗，锡林郭勒盟，内蒙古自治区",
                            "simple_py": "ZLQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0479",
                            "area_code": "152530",
                            "longitude": "116.003311",
                            "latitude": "42.245895"
                        },
                        {
                            "area_id": 5740,
                            "city_id": 4638,
                            "province_id": 3,
                            "name": "正镶白旗",
                            "whole_name": "正镶白旗，锡林郭勒盟，内蒙古自治区",
                            "simple_py": "ZXBQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0479",
                            "area_code": "152529",
                            "longitude": "115.031423",
                            "latitude": "42.286807"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 21,
            "name": "宁夏回族自治区",
            "whole_name": "宁夏回族自治区",
            "simple_py": "NXHZZZQ",
            "per_pin_yin": " ",
            "per_pin_yin2": "N",
            "city_code": "",
            "area_code": "640000",
            "longitude": "106.278179",
            "latitude": "38.46637",
            "children": [
                {
                    "city_id": 28892,
                    "province_id": 21,
                    "name": "固原市",
                    "whole_name": "固原市，宁夏回族自治区",
                    "simple_py": "GYS",
                    "per_pin_yin": "G",
                    "per_pin_yin2": "G",
                    "city_code": "0954",
                    "area_code": "640400",
                    "longitude": "106.285241",
                    "latitude": "36.004561",
                    "children": [
                        {
                            "area_id": 28897,
                            "city_id": 28892,
                            "province_id": 21,
                            "name": "泾源县",
                            "whole_name": "泾源县，固原市，宁夏回族自治区",
                            "simple_py": "JYX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0954",
                            "area_code": "640424",
                            "longitude": "106.338674",
                            "latitude": "35.49344"
                        },
                        {
                            "area_id": 28898,
                            "city_id": 28892,
                            "province_id": 21,
                            "name": "隆德县",
                            "whole_name": "隆德县，固原市，宁夏回族自治区",
                            "simple_py": "LDX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0954",
                            "area_code": "640423",
                            "longitude": "106.12344",
                            "latitude": "35.618234"
                        },
                        {
                            "area_id": 28900,
                            "city_id": 28892,
                            "province_id": 21,
                            "name": "彭阳县",
                            "whole_name": "彭阳县，固原市，宁夏回族自治区",
                            "simple_py": "PYX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0954",
                            "area_code": "640425",
                            "longitude": "106.641512",
                            "latitude": "35.849975"
                        },
                        {
                            "area_id": 28901,
                            "city_id": 28892,
                            "province_id": 21,
                            "name": "西吉县",
                            "whole_name": "西吉县，固原市，宁夏回族自治区",
                            "simple_py": "XJX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0954",
                            "area_code": "640422",
                            "longitude": "105.731801",
                            "latitude": "35.965384"
                        },
                        {
                            "area_id": 28899,
                            "city_id": 28892,
                            "province_id": 21,
                            "name": "原州区",
                            "whole_name": "原州区，固原市，宁夏回族自治区",
                            "simple_py": "YZQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0954",
                            "area_code": "640402",
                            "longitude": "106.28477",
                            "latitude": "36.005337"
                        }
                    ]
                },
                {
                    "city_id": 28895,
                    "province_id": 21,
                    "name": "石嘴山市",
                    "whole_name": "石嘴山市，宁夏回族自治区",
                    "simple_py": "SZSS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0952",
                    "area_code": "640200",
                    "longitude": "106.376173",
                    "latitude": "39.01333",
                    "children": [
                        {
                            "area_id": 29085,
                            "city_id": 28895,
                            "province_id": 21,
                            "name": "大武口区",
                            "whole_name": "大武口区，石嘴山市，宁夏回族自治区",
                            "simple_py": "DWKQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0952",
                            "area_code": "640202",
                            "longitude": "106.376651",
                            "latitude": "39.014158"
                        },
                        {
                            "area_id": 29086,
                            "city_id": 28895,
                            "province_id": 21,
                            "name": "惠农区",
                            "whole_name": "惠农区，石嘴山市，宁夏回族自治区",
                            "simple_py": "HNQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0952",
                            "area_code": "640205",
                            "longitude": "106.775513",
                            "latitude": "39.230094"
                        },
                        {
                            "area_id": 29084,
                            "city_id": 28895,
                            "province_id": 21,
                            "name": "平罗县",
                            "whole_name": "平罗县，石嘴山市，宁夏回族自治区",
                            "simple_py": "PLX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0952",
                            "area_code": "640221",
                            "longitude": "106.54489",
                            "latitude": "38.90674"
                        }
                    ]
                },
                {
                    "city_id": 28896,
                    "province_id": 21,
                    "name": "吴忠市",
                    "whole_name": "吴忠市，宁夏回族自治区",
                    "simple_py": "WZS",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "0953",
                    "area_code": "640300",
                    "longitude": "106.199409",
                    "latitude": "37.986165",
                    "children": [
                        {
                            "area_id": 29130,
                            "city_id": 28896,
                            "province_id": 21,
                            "name": "红寺堡区",
                            "whole_name": "红寺堡区，吴忠市，宁夏回族自治区",
                            "simple_py": "HSBQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0953",
                            "area_code": "640303",
                            "longitude": "106.067315",
                            "latitude": "37.421616"
                        },
                        {
                            "area_id": 29129,
                            "city_id": 28896,
                            "province_id": 21,
                            "name": "利通区",
                            "whole_name": "利通区，吴忠市，宁夏回族自治区",
                            "simple_py": "LTQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0953",
                            "area_code": "640302",
                            "longitude": "106.199419",
                            "latitude": "37.985967"
                        },
                        {
                            "area_id": 29131,
                            "city_id": 28896,
                            "province_id": 21,
                            "name": "青铜峡市",
                            "whole_name": "青铜峡市，吴忠市，宁夏回族自治区",
                            "simple_py": "QTXS",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0953",
                            "area_code": "640381",
                            "longitude": "106.075395",
                            "latitude": "38.021509"
                        },
                        {
                            "area_id": 29127,
                            "city_id": 28896,
                            "province_id": 21,
                            "name": "同心县",
                            "whole_name": "同心县，吴忠市，宁夏回族自治区",
                            "simple_py": "TXX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0953",
                            "area_code": "640324",
                            "longitude": "105.914764",
                            "latitude": "36.9829"
                        },
                        {
                            "area_id": 29128,
                            "city_id": 28896,
                            "province_id": 21,
                            "name": "盐池县",
                            "whole_name": "盐池县，吴忠市，宁夏回族自治区",
                            "simple_py": "YCX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0953",
                            "area_code": "640323",
                            "longitude": "107.40541",
                            "latitude": "37.784222"
                        }
                    ]
                },
                {
                    "city_id": 28894,
                    "province_id": 21,
                    "name": "银川市",
                    "whole_name": "银川市，宁夏回族自治区",
                    "simple_py": "YCS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0951",
                    "area_code": "640100",
                    "longitude": "106.278179",
                    "latitude": "38.46637",
                    "children": [
                        {
                            "area_id": 29019,
                            "city_id": 28894,
                            "province_id": 21,
                            "name": "贺兰县",
                            "whole_name": "贺兰县，银川市，宁夏回族自治区",
                            "simple_py": "HLX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0951",
                            "area_code": "640122",
                            "longitude": "106.345904",
                            "latitude": "38.554563"
                        },
                        {
                            "area_id": 29022,
                            "city_id": 28894,
                            "province_id": 21,
                            "name": "金凤区",
                            "whole_name": "金凤区，银川市，宁夏回族自治区",
                            "simple_py": "JFQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0951",
                            "area_code": "640106",
                            "longitude": "106.228486",
                            "latitude": "38.477353"
                        },
                        {
                            "area_id": 29024,
                            "city_id": 28894,
                            "province_id": 21,
                            "name": "灵武市",
                            "whole_name": "灵武市，银川市，宁夏回族自治区",
                            "simple_py": "LWS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0951",
                            "area_code": "640181",
                            "longitude": "106.334701",
                            "latitude": "38.094058"
                        },
                        {
                            "area_id": 29020,
                            "city_id": 28894,
                            "province_id": 21,
                            "name": "西夏区",
                            "whole_name": "西夏区，银川市，宁夏回族自治区",
                            "simple_py": "XXQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0951",
                            "area_code": "640105",
                            "longitude": "106.132116",
                            "latitude": "38.492424"
                        },
                        {
                            "area_id": 29021,
                            "city_id": 28894,
                            "province_id": 21,
                            "name": "兴庆区",
                            "whole_name": "兴庆区，银川市，宁夏回族自治区",
                            "simple_py": "XQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0951",
                            "area_code": "640104",
                            "longitude": "106.278393",
                            "latitude": "38.46747"
                        },
                        {
                            "area_id": 29023,
                            "city_id": 28894,
                            "province_id": 21,
                            "name": "永宁县",
                            "whole_name": "永宁县，银川市，宁夏回族自治区",
                            "simple_py": "YNX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0951",
                            "area_code": "640121",
                            "longitude": "106.253781",
                            "latitude": "38.28043"
                        }
                    ]
                },
                {
                    "city_id": 28893,
                    "province_id": 21,
                    "name": "中卫市",
                    "whole_name": "中卫市，宁夏回族自治区",
                    "simple_py": "ZWS",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "0955",
                    "area_code": "640500",
                    "longitude": "105.189568",
                    "latitude": "37.514951",
                    "children": [
                        {
                            "area_id": 28968,
                            "city_id": 28893,
                            "province_id": 21,
                            "name": "海原县",
                            "whole_name": "海原县，中卫市，宁夏回族自治区",
                            "simple_py": "HYX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0955",
                            "area_code": "640522",
                            "longitude": "105.647323",
                            "latitude": "36.562007"
                        },
                        {
                            "area_id": 28969,
                            "city_id": 28893,
                            "province_id": 21,
                            "name": "沙坡头区",
                            "whole_name": "沙坡头区，中卫市，宁夏回族自治区",
                            "simple_py": "SPTQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0955",
                            "area_code": "640502",
                            "longitude": "105.190536",
                            "latitude": "37.514564"
                        },
                        {
                            "area_id": 28970,
                            "city_id": 28893,
                            "province_id": 21,
                            "name": "中宁县",
                            "whole_name": "中宁县，中卫市，宁夏回族自治区",
                            "simple_py": "ZNX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0955",
                            "area_code": "640521",
                            "longitude": "105.675784",
                            "latitude": "37.489736"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 19,
            "name": "青海省",
            "whole_name": "青海省",
            "simple_py": "QHS",
            "per_pin_yin": "Q",
            "per_pin_yin2": "Q",
            "city_code": "",
            "area_code": "630000",
            "longitude": "101.778916",
            "latitude": "36.623178",
            "children": [
                {
                    "city_id": 27021,
                    "province_id": 19,
                    "name": "果洛藏族自治州",
                    "whole_name": "果洛藏族自治州，青海省",
                    "simple_py": "GLCZZZZ",
                    "per_pin_yin": "G",
                    "per_pin_yin2": "G",
                    "city_code": "0975",
                    "area_code": "632600",
                    "longitude": "100.242143",
                    "latitude": "34.4736",
                    "children": [
                        {
                            "area_id": 27318,
                            "city_id": 27021,
                            "province_id": 19,
                            "name": "班玛县",
                            "whole_name": "班玛县，果洛藏族自治州，青海省",
                            "simple_py": "BMX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0975",
                            "area_code": "632622",
                            "longitude": "100.737955",
                            "latitude": "32.931589"
                        },
                        {
                            "area_id": 27314,
                            "city_id": 27021,
                            "province_id": 19,
                            "name": "达日县",
                            "whole_name": "达日县，果洛藏族自治州，青海省",
                            "simple_py": "DRX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0975",
                            "area_code": "632624",
                            "longitude": "99.651715",
                            "latitude": "33.753259"
                        },
                        {
                            "area_id": 27316,
                            "city_id": 27021,
                            "province_id": 19,
                            "name": "甘德县",
                            "whole_name": "甘德县，果洛藏族自治州，青海省",
                            "simple_py": "GDX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0975",
                            "area_code": "632623",
                            "longitude": "99.902589",
                            "latitude": "33.966987"
                        },
                        {
                            "area_id": 27315,
                            "city_id": 27021,
                            "province_id": 19,
                            "name": "久治县",
                            "whole_name": "久治县，果洛藏族自治州，青海省",
                            "simple_py": "JZX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0975",
                            "area_code": "632625",
                            "longitude": "101.484884",
                            "latitude": "33.430217"
                        },
                        {
                            "area_id": 27317,
                            "city_id": 27021,
                            "province_id": 19,
                            "name": "玛沁县",
                            "whole_name": "玛沁县，果洛藏族自治州，青海省",
                            "simple_py": "MQX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0975",
                            "area_code": "632621",
                            "longitude": "100.243531",
                            "latitude": "34.473386"
                        },
                        {
                            "area_id": 27319,
                            "city_id": 27021,
                            "province_id": 19,
                            "name": "玛多县",
                            "whole_name": "玛多县，果洛藏族自治州，青海省",
                            "simple_py": "MDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0975",
                            "area_code": "632626",
                            "longitude": "98.211343",
                            "latitude": "34.91528"
                        }
                    ]
                },
                {
                    "city_id": 27016,
                    "province_id": 19,
                    "name": "海东市",
                    "whole_name": "海东市，青海省",
                    "simple_py": "HDS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0972",
                    "area_code": "630200",
                    "longitude": "102.10327",
                    "latitude": "36.502916",
                    "children": [
                        {
                            "area_id": 27024,
                            "city_id": 27016,
                            "province_id": 19,
                            "name": "化隆回族自治县",
                            "whole_name": "化隆回族自治县，海东市，青海省",
                            "simple_py": "HLHZZZX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0972",
                            "area_code": "630224",
                            "longitude": "102.262329",
                            "latitude": "36.098322"
                        },
                        {
                            "area_id": 27029,
                            "city_id": 27016,
                            "province_id": 19,
                            "name": "互助土族自治县",
                            "whole_name": "互助土族自治县，海东市，青海省",
                            "simple_py": "HZTZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0972",
                            "area_code": "630223",
                            "longitude": "101.956734",
                            "latitude": "36.83994"
                        },
                        {
                            "area_id": 27027,
                            "city_id": 27016,
                            "province_id": 19,
                            "name": "乐都区",
                            "whole_name": "乐都区，海东市，青海省",
                            "simple_py": "LDQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0972",
                            "area_code": "630202",
                            "longitude": "102.402431",
                            "latitude": "36.480291"
                        },
                        {
                            "area_id": 27028,
                            "city_id": 27016,
                            "province_id": 19,
                            "name": "民和回族土族自治县",
                            "whole_name": "民和回族土族自治县，海东市，青海省",
                            "simple_py": "MHHZTZZZX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0972",
                            "area_code": "630222",
                            "longitude": "102.804209",
                            "latitude": "36.329451"
                        },
                        {
                            "area_id": 27026,
                            "city_id": 27016,
                            "province_id": 19,
                            "name": "平安区",
                            "whole_name": "平安区，海东市，青海省",
                            "simple_py": "PAQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0972",
                            "area_code": "630203",
                            "longitude": "102.104295",
                            "latitude": "36.502714"
                        },
                        {
                            "area_id": 27025,
                            "city_id": 27016,
                            "province_id": 19,
                            "name": "循化撒拉族自治县",
                            "whole_name": "循化撒拉族自治县，海东市，青海省",
                            "simple_py": "XHSLZZZX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0972",
                            "area_code": "630225",
                            "longitude": "102.486534",
                            "latitude": "35.847247"
                        }
                    ]
                },
                {
                    "city_id": 27017,
                    "province_id": 19,
                    "name": "海南藏族自治州",
                    "whole_name": "海南藏族自治州，青海省",
                    "simple_py": "HNCZZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0974",
                    "area_code": "632500",
                    "longitude": "100.619542",
                    "latitude": "36.280353",
                    "children": [
                        {
                            "area_id": 27126,
                            "city_id": 27017,
                            "province_id": 19,
                            "name": "贵南县",
                            "whole_name": "贵南县，海南藏族自治州，青海省",
                            "simple_py": "GNX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0974",
                            "area_code": "632525",
                            "longitude": "100.74792",
                            "latitude": "35.587085"
                        },
                        {
                            "area_id": 27129,
                            "city_id": 27017,
                            "province_id": 19,
                            "name": "贵德县",
                            "whole_name": "贵德县，海南藏族自治州，青海省",
                            "simple_py": "GDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0974",
                            "area_code": "632523",
                            "longitude": "101.431856",
                            "latitude": "36.040456"
                        },
                        {
                            "area_id": 27130,
                            "city_id": 27017,
                            "province_id": 19,
                            "name": "共和县",
                            "whole_name": "共和县，海南藏族自治州，青海省",
                            "simple_py": "GHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0974",
                            "area_code": "632521",
                            "longitude": "100.619597",
                            "latitude": "36.280286"
                        },
                        {
                            "area_id": 27127,
                            "city_id": 27017,
                            "province_id": 19,
                            "name": "同德县",
                            "whole_name": "同德县，海南藏族自治州，青海省",
                            "simple_py": "TDX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0974",
                            "area_code": "632522",
                            "longitude": "100.579465",
                            "latitude": "35.254492"
                        },
                        {
                            "area_id": 27128,
                            "city_id": 27017,
                            "province_id": 19,
                            "name": "兴海县",
                            "whole_name": "兴海县，海南藏族自治州，青海省",
                            "simple_py": "XHX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0974",
                            "area_code": "632524",
                            "longitude": "99.986963",
                            "latitude": "35.58909"
                        }
                    ]
                },
                {
                    "city_id": 27018,
                    "province_id": 19,
                    "name": "海西蒙古族藏族自治州",
                    "whole_name": "海西蒙古族藏族自治州，青海省",
                    "simple_py": "HXMGZCZZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0977",
                    "area_code": "632800",
                    "longitude": "97.370785",
                    "latitude": "37.374663",
                    "children": [
                        {
                            "area_id": 27174,
                            "city_id": 27018,
                            "province_id": 19,
                            "name": "德令哈市",
                            "whole_name": "德令哈市，海西蒙古族藏族自治州，青海省",
                            "simple_py": "DLHS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0977",
                            "area_code": "632802",
                            "longitude": "97.370143",
                            "latitude": "37.374555"
                        },
                        {
                            "area_id": 27178,
                            "city_id": 27018,
                            "province_id": 19,
                            "name": "都兰县",
                            "whole_name": "都兰县，海西蒙古族藏族自治州，青海省",
                            "simple_py": "DLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0977",
                            "area_code": "632822",
                            "longitude": "98.089161",
                            "latitude": "36.298553"
                        },
                        {
                            "area_id": 27175,
                            "city_id": 27018,
                            "province_id": 19,
                            "name": "格尔木市",
                            "whole_name": "格尔木市，海西蒙古族藏族自治州，青海省",
                            "simple_py": "GEMS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0979",
                            "area_code": "632801",
                            "longitude": "94.905777",
                            "latitude": "36.401541"
                        },
                        {
                            "area_id": 27177,
                            "city_id": 27018,
                            "province_id": 19,
                            "name": "海西蒙古族藏族自治州直辖",
                            "whole_name": "海西蒙古族藏族自治州直辖，海西蒙古族藏族自治州，青海省",
                            "simple_py": "HXMGZCZZZZZX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0977",
                            "area_code": "632825",
                            "longitude": "95.357233",
                            "latitude": "37.853631"
                        },
                        {
                            "area_id": 27176,
                            "city_id": 27018,
                            "province_id": 19,
                            "name": "天峻县",
                            "whole_name": "天峻县，海西蒙古族藏族自治州，青海省",
                            "simple_py": "TJX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0977",
                            "area_code": "632823",
                            "longitude": "99.02078",
                            "latitude": "37.29906"
                        },
                        {
                            "area_id": 27179,
                            "city_id": 27018,
                            "province_id": 19,
                            "name": "乌兰县",
                            "whole_name": "乌兰县，海西蒙古族藏族自治州，青海省",
                            "simple_py": "WLX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0977",
                            "area_code": "632821",
                            "longitude": "98.479852",
                            "latitude": "36.930389"
                        }
                    ]
                },
                {
                    "city_id": 27020,
                    "province_id": 19,
                    "name": "黄南藏族自治州",
                    "whole_name": "黄南藏族自治州，青海省",
                    "simple_py": "HNCZZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0973",
                    "area_code": "632300",
                    "longitude": "102.019988",
                    "latitude": "35.517744",
                    "children": [
                        {
                            "area_id": 27281,
                            "city_id": 27020,
                            "province_id": 19,
                            "name": "河南蒙古族自治县",
                            "whole_name": "河南蒙古族自治县，黄南藏族自治州，青海省",
                            "simple_py": "HNMGZZZX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0973",
                            "area_code": "632324",
                            "longitude": "101.611877",
                            "latitude": "34.734522"
                        },
                        {
                            "area_id": 27278,
                            "city_id": 27020,
                            "province_id": 19,
                            "name": "尖扎县",
                            "whole_name": "尖扎县，黄南藏族自治州，青海省",
                            "simple_py": "JZX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0973",
                            "area_code": "632322",
                            "longitude": "102.031953",
                            "latitude": "35.938205"
                        },
                        {
                            "area_id": 27280,
                            "city_id": 27020,
                            "province_id": 19,
                            "name": "同仁县",
                            "whole_name": "同仁县，黄南藏族自治州，青海省",
                            "simple_py": "TRX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0973",
                            "area_code": "632321",
                            "longitude": "102.017604",
                            "latitude": "35.516337"
                        },
                        {
                            "area_id": 27279,
                            "city_id": 27020,
                            "province_id": 19,
                            "name": "泽库县",
                            "whole_name": "泽库县，黄南藏族自治州，青海省",
                            "simple_py": "ZKX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0973",
                            "area_code": "632323",
                            "longitude": "101.469343",
                            "latitude": "35.036842"
                        }
                    ]
                },
                {
                    "city_id": 27022,
                    "province_id": 19,
                    "name": "海北藏族自治州",
                    "whole_name": "海北藏族自治州，青海省",
                    "simple_py": "HBCZZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0970",
                    "area_code": "632200",
                    "longitude": "100.901059",
                    "latitude": "36.959435",
                    "children": [
                        {
                            "area_id": 27367,
                            "city_id": 27022,
                            "province_id": 19,
                            "name": "刚察县",
                            "whole_name": "刚察县，海北藏族自治州，青海省",
                            "simple_py": "GCX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0970",
                            "area_code": "632224",
                            "longitude": "100.138417",
                            "latitude": "37.326263"
                        },
                        {
                            "area_id": 27364,
                            "city_id": 27022,
                            "province_id": 19,
                            "name": "海晏县",
                            "whole_name": "海晏县，海北藏族自治州，青海省",
                            "simple_py": "HYX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0970",
                            "area_code": "632223",
                            "longitude": "100.90049",
                            "latitude": "36.959542"
                        },
                        {
                            "area_id": 27365,
                            "city_id": 27022,
                            "province_id": 19,
                            "name": "门源回族自治县",
                            "whole_name": "门源回族自治县，海北藏族自治州，青海省",
                            "simple_py": "MYHZZZX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0970",
                            "area_code": "632221",
                            "longitude": "101.618461",
                            "latitude": "37.376627"
                        },
                        {
                            "area_id": 27366,
                            "city_id": 27022,
                            "province_id": 19,
                            "name": "祁连县",
                            "whole_name": "祁连县，海北藏族自治州，青海省",
                            "simple_py": "QLX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0970",
                            "area_code": "632222",
                            "longitude": "100.249778",
                            "latitude": "38.175409"
                        }
                    ]
                },
                {
                    "city_id": 27023,
                    "province_id": 19,
                    "name": "西宁市",
                    "whole_name": "西宁市，青海省",
                    "simple_py": "XNS",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "0971",
                    "area_code": "630100",
                    "longitude": "101.778916",
                    "latitude": "36.623178",
                    "children": [
                        {
                            "area_id": 27404,
                            "city_id": 27023,
                            "province_id": 19,
                            "name": "城东区",
                            "whole_name": "城东区，西宁市，青海省",
                            "simple_py": "CDQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0971",
                            "area_code": "630102",
                            "longitude": "101.796095",
                            "latitude": "36.616043"
                        },
                        {
                            "area_id": 27405,
                            "city_id": 27023,
                            "province_id": 19,
                            "name": "城西区",
                            "whole_name": "城西区，西宁市，青海省",
                            "simple_py": "CXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0971",
                            "area_code": "630104",
                            "longitude": "101.763649",
                            "latitude": "36.628323"
                        },
                        {
                            "area_id": 27406,
                            "city_id": 27023,
                            "province_id": 19,
                            "name": "城中区",
                            "whole_name": "城中区，西宁市，青海省",
                            "simple_py": "CZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0971",
                            "area_code": "630103",
                            "longitude": "101.784554",
                            "latitude": "36.621181"
                        },
                        {
                            "area_id": 27408,
                            "city_id": 27023,
                            "province_id": 19,
                            "name": "城北区",
                            "whole_name": "城北区，西宁市，青海省",
                            "simple_py": "CBQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0971",
                            "area_code": "630105",
                            "longitude": "101.761297",
                            "latitude": "36.648448"
                        },
                        {
                            "area_id": 27402,
                            "city_id": 27023,
                            "province_id": 19,
                            "name": "大通回族土族自治县",
                            "whole_name": "大通回族土族自治县，西宁市，青海省",
                            "simple_py": "DTHZTZZZX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0971",
                            "area_code": "630121",
                            "longitude": "101.684183",
                            "latitude": "36.931343"
                        },
                        {
                            "area_id": 27403,
                            "city_id": 27023,
                            "province_id": 19,
                            "name": "湟源县",
                            "whole_name": "湟源县，西宁市，青海省",
                            "simple_py": "HYX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0971",
                            "area_code": "630123",
                            "longitude": "101.263435",
                            "latitude": "36.684818"
                        },
                        {
                            "area_id": 27407,
                            "city_id": 27023,
                            "province_id": 19,
                            "name": "湟中县",
                            "whole_name": "湟中县，西宁市，青海省",
                            "simple_py": "HZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0971",
                            "area_code": "630122",
                            "longitude": "101.569475",
                            "latitude": "36.500419"
                        }
                    ]
                },
                {
                    "city_id": 27019,
                    "province_id": 19,
                    "name": "玉树藏族自治州",
                    "whole_name": "玉树藏族自治州，青海省",
                    "simple_py": "YSCZZZZ",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0976",
                    "area_code": "632700",
                    "longitude": "97.008522",
                    "latitude": "33.004049",
                    "children": [
                        {
                            "area_id": 27228,
                            "city_id": 27019,
                            "province_id": 19,
                            "name": "称多县",
                            "whole_name": "称多县，玉树藏族自治州，青海省",
                            "simple_py": "CDX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0976",
                            "area_code": "632723",
                            "longitude": "97.110893",
                            "latitude": "33.367884"
                        },
                        {
                            "area_id": 27231,
                            "city_id": 27019,
                            "province_id": 19,
                            "name": "囊谦县",
                            "whole_name": "囊谦县，玉树藏族自治州，青海省",
                            "simple_py": "NQX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0976",
                            "area_code": "632725",
                            "longitude": "96.479797",
                            "latitude": "32.203206"
                        },
                        {
                            "area_id": 27226,
                            "city_id": 27019,
                            "province_id": 19,
                            "name": "曲麻莱县",
                            "whole_name": "曲麻莱县，玉树藏族自治州，青海省",
                            "simple_py": "QMLX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0976",
                            "area_code": "632726",
                            "longitude": "95.800674",
                            "latitude": "34.12654"
                        },
                        {
                            "area_id": 27229,
                            "city_id": 27019,
                            "province_id": 19,
                            "name": "玉树市",
                            "whole_name": "玉树市，玉树藏族自治州，青海省",
                            "simple_py": "YSS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0976",
                            "area_code": "632701",
                            "longitude": "97.008762",
                            "latitude": "33.00393"
                        },
                        {
                            "area_id": 27227,
                            "city_id": 27019,
                            "province_id": 19,
                            "name": "治多县",
                            "whole_name": "治多县，玉树藏族自治州，青海省",
                            "simple_py": "ZDX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0976",
                            "area_code": "632724",
                            "longitude": "95.616843",
                            "latitude": "33.852322"
                        },
                        {
                            "area_id": 27230,
                            "city_id": 27019,
                            "province_id": 19,
                            "name": "杂多县",
                            "whole_name": "杂多县，玉树藏族自治州，青海省",
                            "simple_py": "ZDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0976",
                            "area_code": "632722",
                            "longitude": "95.293423",
                            "latitude": "32.891886"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 8,
            "name": "山东省",
            "whole_name": "山东省",
            "simple_py": "SDS",
            "per_pin_yin": "S",
            "per_pin_yin2": "S",
            "city_code": "",
            "area_code": "370000",
            "longitude": "117.000923",
            "latitude": "36.675807",
            "children": [
                {
                    "city_id": 12750,
                    "province_id": 8,
                    "name": "滨州市",
                    "whole_name": "滨州市，山东省",
                    "simple_py": "BZS",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "0543",
                    "area_code": "371600",
                    "longitude": "118.016974",
                    "latitude": "37.383542",
                    "children": [
                        {
                            "area_id": 13011,
                            "city_id": 12750,
                            "province_id": 8,
                            "name": "滨城区",
                            "whole_name": "滨城区，滨州市，山东省",
                            "simple_py": "BCQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0543",
                            "area_code": "371602",
                            "longitude": "118.020149",
                            "latitude": "37.384842"
                        },
                        {
                            "area_id": 13013,
                            "city_id": 12750,
                            "province_id": 8,
                            "name": "博兴县",
                            "whole_name": "博兴县，滨州市，山东省",
                            "simple_py": "BXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0543",
                            "area_code": "371625",
                            "longitude": "118.123096",
                            "latitude": "37.147002"
                        },
                        {
                            "area_id": 13016,
                            "city_id": 12750,
                            "province_id": 8,
                            "name": "惠民县",
                            "whole_name": "惠民县，滨州市，山东省",
                            "simple_py": "HMX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0543",
                            "area_code": "371621",
                            "longitude": "117.508941",
                            "latitude": "37.483876"
                        },
                        {
                            "area_id": 13014,
                            "city_id": 12750,
                            "province_id": 8,
                            "name": "无棣县",
                            "whole_name": "无棣县，滨州市，山东省",
                            "simple_py": "WDX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0543",
                            "area_code": "371623",
                            "longitude": "117.616325",
                            "latitude": "37.740848"
                        },
                        {
                            "area_id": 13015,
                            "city_id": 12750,
                            "province_id": 8,
                            "name": "阳信县",
                            "whole_name": "阳信县，滨州市，山东省",
                            "simple_py": "YXX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0543",
                            "area_code": "371622",
                            "longitude": "117.581326",
                            "latitude": "37.640492"
                        },
                        {
                            "area_id": 13010,
                            "city_id": 12750,
                            "province_id": 8,
                            "name": "沾化区",
                            "whole_name": "沾化区，滨州市，山东省",
                            "simple_py": "ZHQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0543",
                            "area_code": "371603",
                            "longitude": "118.129902",
                            "latitude": "37.698456"
                        },
                        {
                            "area_id": 13012,
                            "city_id": 12750,
                            "province_id": 8,
                            "name": "邹平县",
                            "whole_name": "邹平县，滨州市，山东省",
                            "simple_py": "ZPX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0543",
                            "area_code": "371626",
                            "longitude": "117.736807",
                            "latitude": "36.87803"
                        }
                    ]
                },
                {
                    "city_id": 12756,
                    "province_id": 8,
                    "name": "德州市",
                    "whole_name": "德州市，山东省",
                    "simple_py": "DZS",
                    "per_pin_yin": "D",
                    "per_pin_yin2": "D",
                    "city_code": "0534",
                    "area_code": "371400",
                    "longitude": "116.307428",
                    "latitude": "37.453968",
                    "children": [
                        {
                            "area_id": 13687,
                            "city_id": 12756,
                            "province_id": 8,
                            "name": "德城区",
                            "whole_name": "德城区，德州市，山东省",
                            "simple_py": "DCQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0534",
                            "area_code": "371402",
                            "longitude": "116.307076",
                            "latitude": "37.453923"
                        },
                        {
                            "area_id": 13684,
                            "city_id": 12756,
                            "province_id": 8,
                            "name": "陵城区",
                            "whole_name": "陵城区，德州市，山东省",
                            "simple_py": "LCQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0534",
                            "area_code": "371403",
                            "longitude": "116.574929",
                            "latitude": "37.332848"
                        },
                        {
                            "area_id": 13685,
                            "city_id": 12756,
                            "province_id": 8,
                            "name": "乐陵市",
                            "whole_name": "乐陵市，德州市，山东省",
                            "simple_py": "LLS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0534",
                            "area_code": "371481",
                            "longitude": "117.216657",
                            "latitude": "37.729115"
                        },
                        {
                            "area_id": 13688,
                            "city_id": 12756,
                            "province_id": 8,
                            "name": "临邑县",
                            "whole_name": "临邑县，德州市，山东省",
                            "simple_py": "LYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0534",
                            "area_code": "371424",
                            "longitude": "116.867028",
                            "latitude": "37.192044"
                        },
                        {
                            "area_id": 13683,
                            "city_id": 12756,
                            "province_id": 8,
                            "name": "宁津县",
                            "whole_name": "宁津县，德州市，山东省",
                            "simple_py": "NJX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0534",
                            "area_code": "371422",
                            "longitude": "116.79372",
                            "latitude": "37.649619"
                        },
                        {
                            "area_id": 13691,
                            "city_id": 12756,
                            "province_id": 8,
                            "name": "平原县",
                            "whole_name": "平原县，德州市，山东省",
                            "simple_py": "PYX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0534",
                            "area_code": "371426",
                            "longitude": "116.433904",
                            "latitude": "37.164465"
                        },
                        {
                            "area_id": 13686,
                            "city_id": 12756,
                            "province_id": 8,
                            "name": "庆云县",
                            "whole_name": "庆云县，德州市，山东省",
                            "simple_py": "QYX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0534",
                            "area_code": "371423",
                            "longitude": "117.390507",
                            "latitude": "37.777724"
                        },
                        {
                            "area_id": 13693,
                            "city_id": 12756,
                            "province_id": 8,
                            "name": "齐河县",
                            "whole_name": "齐河县，德州市，山东省",
                            "simple_py": "QHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0534",
                            "area_code": "371425",
                            "longitude": "116.758394",
                            "latitude": "36.795497"
                        },
                        {
                            "area_id": 13689,
                            "city_id": 12756,
                            "province_id": 8,
                            "name": "武城县",
                            "whole_name": "武城县，德州市，山东省",
                            "simple_py": "WCX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0534",
                            "area_code": "371428",
                            "longitude": "116.078627",
                            "latitude": "37.209527"
                        },
                        {
                            "area_id": 13692,
                            "city_id": 12756,
                            "province_id": 8,
                            "name": "夏津县",
                            "whole_name": "夏津县，德州市，山东省",
                            "simple_py": "XJX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0534",
                            "area_code": "371427",
                            "longitude": "116.003816",
                            "latitude": "36.950501"
                        },
                        {
                            "area_id": 13690,
                            "city_id": 12756,
                            "province_id": 8,
                            "name": "禹城市",
                            "whole_name": "禹城市，德州市，山东省",
                            "simple_py": "YCS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0534",
                            "area_code": "371482",
                            "longitude": "116.642554",
                            "latitude": "36.934485"
                        }
                    ]
                },
                {
                    "city_id": 12762,
                    "province_id": 8,
                    "name": "东营市",
                    "whole_name": "东营市，山东省",
                    "simple_py": "DYS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "D",
                    "city_code": "0546",
                    "area_code": "370500",
                    "longitude": "118.66471",
                    "latitude": "37.434564",
                    "children": [
                        {
                            "area_id": 14448,
                            "city_id": 12762,
                            "province_id": 8,
                            "name": "东营区",
                            "whole_name": "东营区，东营市，山东省",
                            "simple_py": "DYQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0546",
                            "area_code": "370502",
                            "longitude": "118.507543",
                            "latitude": "37.461567"
                        },
                        {
                            "area_id": 14447,
                            "city_id": 12762,
                            "province_id": 8,
                            "name": "广饶县",
                            "whole_name": "广饶县，东营市，山东省",
                            "simple_py": "GRX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0546",
                            "area_code": "370523",
                            "longitude": "118.407522",
                            "latitude": "37.05161"
                        },
                        {
                            "area_id": 14450,
                            "city_id": 12762,
                            "province_id": 8,
                            "name": "河口区",
                            "whole_name": "河口区，东营市，山东省",
                            "simple_py": "HKQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0546",
                            "area_code": "370503",
                            "longitude": "118.529613",
                            "latitude": "37.886015"
                        },
                        {
                            "area_id": 14449,
                            "city_id": 12762,
                            "province_id": 8,
                            "name": "垦利区",
                            "whole_name": "垦利区，东营市，山东省",
                            "simple_py": "KLQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0546",
                            "area_code": "370505",
                            "longitude": "118.551314",
                            "latitude": "37.588679"
                        },
                        {
                            "area_id": 14446,
                            "city_id": 12762,
                            "province_id": 8,
                            "name": "利津县",
                            "whole_name": "利津县，东营市，山东省",
                            "simple_py": "LJX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0546",
                            "area_code": "370522",
                            "longitude": "118.248854",
                            "latitude": "37.493365"
                        }
                    ]
                },
                {
                    "city_id": 12758,
                    "province_id": 8,
                    "name": "菏泽市",
                    "whole_name": "菏泽市，山东省",
                    "simple_py": "HZS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0530",
                    "area_code": "371700",
                    "longitude": "115.469381",
                    "latitude": "35.246531",
                    "children": [
                        {
                            "area_id": 13892,
                            "city_id": 12758,
                            "province_id": 8,
                            "name": "曹县",
                            "whole_name": "曹县，菏泽市，山东省",
                            "simple_py": "CX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0530",
                            "area_code": "371721",
                            "longitude": "115.549482",
                            "latitude": "34.823253"
                        },
                        {
                            "area_id": 13893,
                            "city_id": 12758,
                            "province_id": 8,
                            "name": "成武县",
                            "whole_name": "成武县，菏泽市，山东省",
                            "simple_py": "CWX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0530",
                            "area_code": "371723",
                            "longitude": "115.897349",
                            "latitude": "34.947366"
                        },
                        {
                            "area_id": 13890,
                            "city_id": 12758,
                            "province_id": 8,
                            "name": "定陶区",
                            "whole_name": "定陶区，菏泽市，山东省",
                            "simple_py": "DTQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0530",
                            "area_code": "371703",
                            "longitude": "115.569601",
                            "latitude": "35.072701"
                        },
                        {
                            "area_id": 13891,
                            "city_id": 12758,
                            "province_id": 8,
                            "name": "东明县",
                            "whole_name": "东明县，菏泽市，山东省",
                            "simple_py": "DMX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0530",
                            "area_code": "371728",
                            "longitude": "115.098412",
                            "latitude": "35.289637"
                        },
                        {
                            "area_id": 13894,
                            "city_id": 12758,
                            "province_id": 8,
                            "name": "单县",
                            "whole_name": "单县，菏泽市，山东省",
                            "simple_py": "DX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0530",
                            "area_code": "371722",
                            "longitude": "116.08262",
                            "latitude": "34.790851"
                        },
                        {
                            "area_id": 13889,
                            "city_id": 12758,
                            "province_id": 8,
                            "name": "鄄城县",
                            "whole_name": "鄄城县，菏泽市，山东省",
                            "simple_py": "JCX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0530",
                            "area_code": "371726",
                            "longitude": "115.51434",
                            "latitude": "35.560257"
                        },
                        {
                            "area_id": 13895,
                            "city_id": 12758,
                            "province_id": 8,
                            "name": "巨野县",
                            "whole_name": "巨野县，菏泽市，山东省",
                            "simple_py": "JYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0530",
                            "area_code": "371724",
                            "longitude": "116.089341",
                            "latitude": "35.390999"
                        },
                        {
                            "area_id": 13888,
                            "city_id": 12758,
                            "province_id": 8,
                            "name": "牡丹区",
                            "whole_name": "牡丹区，菏泽市，山东省",
                            "simple_py": "MDQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0530",
                            "area_code": "371702",
                            "longitude": "115.470946",
                            "latitude": "35.24311"
                        },
                        {
                            "area_id": 13896,
                            "city_id": 12758,
                            "province_id": 8,
                            "name": "郓城县",
                            "whole_name": "郓城县，菏泽市，山东省",
                            "simple_py": "YCX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0530",
                            "area_code": "371725",
                            "longitude": "115.93885",
                            "latitude": "35.594773"
                        }
                    ]
                },
                {
                    "city_id": 12760,
                    "province_id": 8,
                    "name": "济南市",
                    "whole_name": "济南市，山东省",
                    "simple_py": "JNS",
                    "per_pin_yin": "J",
                    "per_pin_yin2": "J",
                    "city_code": "0531",
                    "area_code": "370100",
                    "longitude": "117.000923",
                    "latitude": "36.675807",
                    "children": [
                        {
                            "area_id": 14203,
                            "city_id": 12760,
                            "province_id": 8,
                            "name": "长清区",
                            "whole_name": "长清区，济南市，山东省",
                            "simple_py": "CQQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0531",
                            "area_code": "370113",
                            "longitude": "116.74588",
                            "latitude": "36.561049"
                        },
                        {
                            "area_id": 14206,
                            "city_id": 12760,
                            "province_id": 8,
                            "name": "槐荫区",
                            "whole_name": "槐荫区，济南市，山东省",
                            "simple_py": "HYQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0531",
                            "area_code": "370104",
                            "longitude": "116.947921",
                            "latitude": "36.668205"
                        },
                        {
                            "area_id": 14201,
                            "city_id": 12760,
                            "province_id": 8,
                            "name": "济阳县",
                            "whole_name": "济阳县，济南市，山东省",
                            "simple_py": "JYX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0531",
                            "area_code": "370125",
                            "longitude": "117.176035",
                            "latitude": "36.976772"
                        },
                        {
                            "area_id": 14208,
                            "city_id": 12760,
                            "province_id": 8,
                            "name": "历城区",
                            "whole_name": "历城区，济南市，山东省",
                            "simple_py": "LCQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0531",
                            "area_code": "370112",
                            "longitude": "117.063744",
                            "latitude": "36.681744"
                        },
                        {
                            "area_id": 14209,
                            "city_id": 12760,
                            "province_id": 8,
                            "name": "历下区",
                            "whole_name": "历下区，济南市，山东省",
                            "simple_py": "LXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0531",
                            "area_code": "370102",
                            "longitude": "117.03862",
                            "latitude": "36.664169"
                        },
                        {
                            "area_id": 14207,
                            "city_id": 12760,
                            "province_id": 8,
                            "name": "平阴县",
                            "whole_name": "平阴县，济南市，山东省",
                            "simple_py": "PYX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0531",
                            "area_code": "370124",
                            "longitude": "116.455054",
                            "latitude": "36.286923"
                        },
                        {
                            "area_id": 14200,
                            "city_id": 12760,
                            "province_id": 8,
                            "name": "商河县",
                            "whole_name": "商河县，济南市，山东省",
                            "simple_py": "SHX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0531",
                            "area_code": "370126",
                            "longitude": "117.156369",
                            "latitude": "37.310544"
                        },
                        {
                            "area_id": 14204,
                            "city_id": 12760,
                            "province_id": 8,
                            "name": "市中区",
                            "whole_name": "市中区，济南市，山东省",
                            "simple_py": "SZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0531",
                            "area_code": "370103",
                            "longitude": "116.99898",
                            "latitude": "36.657354"
                        },
                        {
                            "area_id": 14205,
                            "city_id": 12760,
                            "province_id": 8,
                            "name": "天桥区",
                            "whole_name": "天桥区，济南市，山东省",
                            "simple_py": "TQQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0531",
                            "area_code": "370105",
                            "longitude": "116.996086",
                            "latitude": "36.693374"
                        },
                        {
                            "area_id": 14202,
                            "city_id": 12760,
                            "province_id": 8,
                            "name": "章丘区",
                            "whole_name": "章丘区，济南市，山东省",
                            "simple_py": "ZQQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0531",
                            "area_code": "370114",
                            "longitude": "117.54069",
                            "latitude": "36.71209"
                        }
                    ]
                },
                {
                    "city_id": 12763,
                    "province_id": 8,
                    "name": "济宁市",
                    "whole_name": "济宁市，山东省",
                    "simple_py": "JNS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "J",
                    "city_code": "0537",
                    "area_code": "370800",
                    "longitude": "116.587245",
                    "latitude": "35.415393",
                    "children": [
                        {
                            "area_id": 14509,
                            "city_id": 12763,
                            "province_id": 8,
                            "name": "金乡县",
                            "whole_name": "金乡县，济宁市，山东省",
                            "simple_py": "JXX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0537",
                            "area_code": "370828",
                            "longitude": "116.310364",
                            "latitude": "35.06977"
                        },
                        {
                            "area_id": 14511,
                            "city_id": 12763,
                            "province_id": 8,
                            "name": "嘉祥县",
                            "whole_name": "嘉祥县，济宁市，山东省",
                            "simple_py": "JXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0537",
                            "area_code": "370829",
                            "longitude": "116.342885",
                            "latitude": "35.398098"
                        },
                        {
                            "area_id": 14502,
                            "city_id": 12763,
                            "province_id": 8,
                            "name": "梁山县",
                            "whole_name": "梁山县，济宁市，山东省",
                            "simple_py": "LSX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0537",
                            "area_code": "370832",
                            "longitude": "116.08963",
                            "latitude": "35.801843"
                        },
                        {
                            "area_id": 14503,
                            "city_id": 12763,
                            "province_id": 8,
                            "name": "曲阜市",
                            "whole_name": "曲阜市，济宁市，山东省",
                            "simple_py": "QFS",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0537",
                            "area_code": "370881",
                            "longitude": "116.991885",
                            "latitude": "35.592788"
                        },
                        {
                            "area_id": 14510,
                            "city_id": 12763,
                            "province_id": 8,
                            "name": "任城区",
                            "whole_name": "任城区，济宁市，山东省",
                            "simple_py": "RCQ",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0537",
                            "area_code": "370811",
                            "longitude": "116.595261",
                            "latitude": "35.414828"
                        },
                        {
                            "area_id": 14507,
                            "city_id": 12763,
                            "province_id": 8,
                            "name": "泗水县",
                            "whole_name": "泗水县，济宁市，山东省",
                            "simple_py": "SSX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0537",
                            "area_code": "370831",
                            "longitude": "117.273605",
                            "latitude": "35.653216"
                        },
                        {
                            "area_id": 14506,
                            "city_id": 12763,
                            "province_id": 8,
                            "name": "汶上县",
                            "whole_name": "汶上县，济宁市，山东省",
                            "simple_py": "WSX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0537",
                            "area_code": "370830",
                            "longitude": "116.487146",
                            "latitude": "35.721746"
                        },
                        {
                            "area_id": 14512,
                            "city_id": 12763,
                            "province_id": 8,
                            "name": "微山县",
                            "whole_name": "微山县，济宁市，山东省",
                            "simple_py": "WSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0537",
                            "area_code": "370826",
                            "longitude": "117.12861",
                            "latitude": "34.809525"
                        },
                        {
                            "area_id": 14504,
                            "city_id": 12763,
                            "province_id": 8,
                            "name": "兖州区",
                            "whole_name": "兖州区，济宁市，山东省",
                            "simple_py": "YZQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0537",
                            "area_code": "370812",
                            "longitude": "116.828996",
                            "latitude": "35.556445"
                        },
                        {
                            "area_id": 14508,
                            "city_id": 12763,
                            "province_id": 8,
                            "name": "鱼台县",
                            "whole_name": "鱼台县，济宁市，山东省",
                            "simple_py": "YTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0537",
                            "area_code": "370827",
                            "longitude": "116.650023",
                            "latitude": "34.997706"
                        },
                        {
                            "area_id": 14505,
                            "city_id": 12763,
                            "province_id": 8,
                            "name": "邹城市",
                            "whole_name": "邹城市，济宁市，山东省",
                            "simple_py": "ZCS",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0537",
                            "area_code": "370883",
                            "longitude": "116.96673",
                            "latitude": "35.405259"
                        }
                    ]
                },
                {
                    "city_id": 12751,
                    "province_id": 8,
                    "name": "临沂市",
                    "whole_name": "临沂市，山东省",
                    "simple_py": "LYS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0539",
                    "area_code": "371300",
                    "longitude": "118.326443",
                    "latitude": "35.065282",
                    "children": [
                        {
                            "area_id": 13113,
                            "city_id": 12751,
                            "province_id": 8,
                            "name": "费县",
                            "whole_name": "费县，临沂市，山东省",
                            "simple_py": "FX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0539",
                            "area_code": "371325",
                            "longitude": "117.968869",
                            "latitude": "35.269174"
                        },
                        {
                            "area_id": 13119,
                            "city_id": 12751,
                            "province_id": 8,
                            "name": "河东区",
                            "whole_name": "河东区，临沂市，山东省",
                            "simple_py": "HDQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0539",
                            "area_code": "371312",
                            "longitude": "118.398296",
                            "latitude": "35.085004"
                        },
                        {
                            "area_id": 13116,
                            "city_id": 12751,
                            "province_id": 8,
                            "name": "莒南县",
                            "whole_name": "莒南县，临沂市，山东省",
                            "simple_py": "JNX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0539",
                            "area_code": "371327",
                            "longitude": "118.838322",
                            "latitude": "35.175911"
                        },
                        {
                            "area_id": 13111,
                            "city_id": 12751,
                            "province_id": 8,
                            "name": "兰山区",
                            "whole_name": "兰山区，临沂市，山东省",
                            "simple_py": "LSQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0539",
                            "area_code": "371302",
                            "longitude": "118.327667",
                            "latitude": "35.061631"
                        },
                        {
                            "area_id": 13115,
                            "city_id": 12751,
                            "province_id": 8,
                            "name": "兰陵县",
                            "whole_name": "兰陵县，临沂市，山东省",
                            "simple_py": "LLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0539",
                            "area_code": "371324",
                            "longitude": "118.049968",
                            "latitude": "34.855573"
                        },
                        {
                            "area_id": 13117,
                            "city_id": 12751,
                            "province_id": 8,
                            "name": "罗庄区",
                            "whole_name": "罗庄区，临沂市，山东省",
                            "simple_py": "LZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0539",
                            "area_code": "371311",
                            "longitude": "118.284795",
                            "latitude": "34.997204"
                        },
                        {
                            "area_id": 13118,
                            "city_id": 12751,
                            "province_id": 8,
                            "name": "临沭县",
                            "whole_name": "临沭县，临沂市，山东省",
                            "simple_py": "LSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0539",
                            "area_code": "371329",
                            "longitude": "118.648379",
                            "latitude": "34.917062"
                        },
                        {
                            "area_id": 13108,
                            "city_id": 12751,
                            "province_id": 8,
                            "name": "蒙阴县",
                            "whole_name": "蒙阴县，临沂市，山东省",
                            "simple_py": "MYX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0539",
                            "area_code": "371328",
                            "longitude": "117.943271",
                            "latitude": "35.712435"
                        },
                        {
                            "area_id": 13110,
                            "city_id": 12751,
                            "province_id": 8,
                            "name": "平邑县",
                            "whole_name": "平邑县，临沂市，山东省",
                            "simple_py": "PYX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0539",
                            "area_code": "371326",
                            "longitude": "117.631884",
                            "latitude": "35.511519"
                        },
                        {
                            "area_id": 13114,
                            "city_id": 12751,
                            "province_id": 8,
                            "name": "郯城县",
                            "whole_name": "郯城县，临沂市，山东省",
                            "simple_py": "TCX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0539",
                            "area_code": "371322",
                            "longitude": "118.342963",
                            "latitude": "34.614741"
                        },
                        {
                            "area_id": 13109,
                            "city_id": 12751,
                            "province_id": 8,
                            "name": "沂水县",
                            "whole_name": "沂水县，临沂市，山东省",
                            "simple_py": "YSX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0539",
                            "area_code": "371323",
                            "longitude": "118.634543",
                            "latitude": "35.787029"
                        },
                        {
                            "area_id": 13112,
                            "city_id": 12751,
                            "province_id": 8,
                            "name": "沂南县",
                            "whole_name": "沂南县，临沂市，山东省",
                            "simple_py": "YNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0539",
                            "area_code": "371321",
                            "longitude": "118.455395",
                            "latitude": "35.547002"
                        }
                    ]
                },
                {
                    "city_id": 12752,
                    "province_id": 8,
                    "name": "莱芜市",
                    "whole_name": "莱芜市，山东省",
                    "simple_py": "LWS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "L",
                    "city_code": "0634",
                    "area_code": "371200",
                    "longitude": "117.677736",
                    "latitude": "36.214397",
                    "children": [
                        {
                            "area_id": 13278,
                            "city_id": 12752,
                            "province_id": 8,
                            "name": "钢城区",
                            "whole_name": "钢城区，莱芜市，山东省",
                            "simple_py": "GCQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0634",
                            "area_code": "371203",
                            "longitude": "117.82033",
                            "latitude": "36.058038"
                        },
                        {
                            "area_id": 13277,
                            "city_id": 12752,
                            "province_id": 8,
                            "name": "莱城区",
                            "whole_name": "莱城区，莱芜市，山东省",
                            "simple_py": "LCQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0634",
                            "area_code": "371202",
                            "longitude": "117.678351",
                            "latitude": "36.213662"
                        }
                    ]
                },
                {
                    "city_id": 12755,
                    "province_id": 8,
                    "name": "聊城市",
                    "whole_name": "聊城市，山东省",
                    "simple_py": "LCS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "L",
                    "city_code": "0635",
                    "area_code": "371500",
                    "longitude": "115.980367",
                    "latitude": "36.456013",
                    "children": [
                        {
                            "area_id": 13540,
                            "city_id": 12755,
                            "province_id": 8,
                            "name": "茌平县",
                            "whole_name": "茌平县，聊城市，山东省",
                            "simple_py": "CPX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0635",
                            "area_code": "371523",
                            "longitude": "116.25335",
                            "latitude": "36.591934"
                        },
                        {
                            "area_id": 13542,
                            "city_id": 12755,
                            "province_id": 8,
                            "name": "东昌府区",
                            "whole_name": "东昌府区，聊城市，山东省",
                            "simple_py": "DCFQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0635",
                            "area_code": "371502",
                            "longitude": "115.980023",
                            "latitude": "36.45606"
                        },
                        {
                            "area_id": 13543,
                            "city_id": 12755,
                            "province_id": 8,
                            "name": "东阿县",
                            "whole_name": "东阿县，聊城市，山东省",
                            "simple_py": "DEX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0635",
                            "area_code": "371524",
                            "longitude": "116.248855",
                            "latitude": "36.336004"
                        },
                        {
                            "area_id": 13541,
                            "city_id": 12755,
                            "province_id": 8,
                            "name": "冠县",
                            "whole_name": "冠县，聊城市，山东省",
                            "simple_py": "GX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0635",
                            "area_code": "371525",
                            "longitude": "115.444808",
                            "latitude": "36.483753"
                        },
                        {
                            "area_id": 13544,
                            "city_id": 12755,
                            "province_id": 8,
                            "name": "高唐县",
                            "whole_name": "高唐县，聊城市，山东省",
                            "simple_py": "GTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0635",
                            "area_code": "371526",
                            "longitude": "116.229662",
                            "latitude": "36.859755"
                        },
                        {
                            "area_id": 13539,
                            "city_id": 12755,
                            "province_id": 8,
                            "name": "临清市",
                            "whole_name": "临清市，聊城市，山东省",
                            "simple_py": "LQS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0635",
                            "area_code": "371581",
                            "longitude": "115.713462",
                            "latitude": "36.842598"
                        },
                        {
                            "area_id": 13545,
                            "city_id": 12755,
                            "province_id": 8,
                            "name": "莘县",
                            "whole_name": "莘县，聊城市，山东省",
                            "simple_py": "SX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0635",
                            "area_code": "371522",
                            "longitude": "115.667291",
                            "latitude": "36.237597"
                        },
                        {
                            "area_id": 13546,
                            "city_id": 12755,
                            "province_id": 8,
                            "name": "阳谷县",
                            "whole_name": "阳谷县，聊城市，山东省",
                            "simple_py": "YGX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0635",
                            "area_code": "371521",
                            "longitude": "115.784287",
                            "latitude": "36.113708"
                        }
                    ]
                },
                {
                    "city_id": 12754,
                    "province_id": 8,
                    "name": "青岛市",
                    "whole_name": "青岛市，山东省",
                    "simple_py": "QDS",
                    "per_pin_yin": "Q",
                    "per_pin_yin2": "Q",
                    "city_code": "0532",
                    "area_code": "370200",
                    "longitude": "120.355173",
                    "latitude": "36.082982",
                    "children": [
                        {
                            "area_id": 13399,
                            "city_id": 12754,
                            "province_id": 8,
                            "name": "城阳区",
                            "whole_name": "城阳区，青岛市，山东省",
                            "simple_py": "CYQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0532",
                            "area_code": "370214",
                            "longitude": "120.389135",
                            "latitude": "36.306833"
                        },
                        {
                            "area_id": 13401,
                            "city_id": 12754,
                            "province_id": 8,
                            "name": "黄岛区",
                            "whole_name": "黄岛区，青岛市，山东省",
                            "simple_py": "HDQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0532",
                            "area_code": "370211",
                            "longitude": "119.995518",
                            "latitude": "35.875138"
                        },
                        {
                            "area_id": 13397,
                            "city_id": 12754,
                            "province_id": 8,
                            "name": "即墨区",
                            "whole_name": "即墨区，青岛市，山东省",
                            "simple_py": "JMQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0532",
                            "area_code": "370215",
                            "longitude": "120.447352",
                            "latitude": "36.390847"
                        },
                        {
                            "area_id": 13403,
                            "city_id": 12754,
                            "province_id": 8,
                            "name": "胶州市",
                            "whole_name": "胶州市，青岛市，山东省",
                            "simple_py": "JZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0532",
                            "area_code": "370281",
                            "longitude": "120.006202",
                            "latitude": "36.285878"
                        },
                        {
                            "area_id": 13395,
                            "city_id": 12754,
                            "province_id": 8,
                            "name": "莱西市",
                            "whole_name": "莱西市，青岛市，山东省",
                            "simple_py": "LXS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0532",
                            "area_code": "370285",
                            "longitude": "120.526226",
                            "latitude": "36.86509"
                        },
                        {
                            "area_id": 13398,
                            "city_id": 12754,
                            "province_id": 8,
                            "name": "崂山区",
                            "whole_name": "崂山区，青岛市，山东省",
                            "simple_py": "LSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0532",
                            "area_code": "370212",
                            "longitude": "120.467393",
                            "latitude": "36.102569"
                        },
                        {
                            "area_id": 13400,
                            "city_id": 12754,
                            "province_id": 8,
                            "name": "李沧区",
                            "whole_name": "李沧区，青岛市，山东省",
                            "simple_py": "LCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0532",
                            "area_code": "370213",
                            "longitude": "120.421236",
                            "latitude": "36.160023"
                        },
                        {
                            "area_id": 13396,
                            "city_id": 12754,
                            "province_id": 8,
                            "name": "平度市",
                            "whole_name": "平度市，青岛市，山东省",
                            "simple_py": "PDS",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0532",
                            "area_code": "370283",
                            "longitude": "119.959012",
                            "latitude": "36.788828"
                        },
                        {
                            "area_id": 13402,
                            "city_id": 12754,
                            "province_id": 8,
                            "name": "市南区",
                            "whole_name": "市南区，青岛市，山东省",
                            "simple_py": "SNQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0532",
                            "area_code": "370202",
                            "longitude": "120.395966",
                            "latitude": "36.070892"
                        },
                        {
                            "area_id": 13404,
                            "city_id": 12754,
                            "province_id": 8,
                            "name": "市北区",
                            "whole_name": "市北区，青岛市，山东省",
                            "simple_py": "SBQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0532",
                            "area_code": "370203",
                            "longitude": "120.355026",
                            "latitude": "36.083819"
                        }
                    ]
                },
                {
                    "city_id": 12757,
                    "province_id": 8,
                    "name": "日照市",
                    "whole_name": "日照市，山东省",
                    "simple_py": "RZS",
                    "per_pin_yin": "R",
                    "per_pin_yin2": "R",
                    "city_code": "0633",
                    "area_code": "371100",
                    "longitude": "119.461208",
                    "latitude": "35.428588",
                    "children": [
                        {
                            "area_id": 13831,
                            "city_id": 12757,
                            "province_id": 8,
                            "name": "东港区",
                            "whole_name": "东港区，日照市，山东省",
                            "simple_py": "DGQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0633",
                            "area_code": "371102",
                            "longitude": "119.457703",
                            "latitude": "35.426152"
                        },
                        {
                            "area_id": 13830,
                            "city_id": 12757,
                            "province_id": 8,
                            "name": "莒县",
                            "whole_name": "莒县，日照市，山东省",
                            "simple_py": "JX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0633",
                            "area_code": "371122",
                            "longitude": "118.832859",
                            "latitude": "35.588115"
                        },
                        {
                            "area_id": 13829,
                            "city_id": 12757,
                            "province_id": 8,
                            "name": "岚山区",
                            "whole_name": "岚山区，日照市，山东省",
                            "simple_py": "LSQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0633",
                            "area_code": "371103",
                            "longitude": "119.315844",
                            "latitude": "35.119794"
                        },
                        {
                            "area_id": 13828,
                            "city_id": 12757,
                            "province_id": 8,
                            "name": "五莲县",
                            "whole_name": "五莲县，日照市，山东省",
                            "simple_py": "WLX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0633",
                            "area_code": "371121",
                            "longitude": "119.206745",
                            "latitude": "35.751936"
                        }
                    ]
                },
                {
                    "city_id": 12761,
                    "province_id": 8,
                    "name": "泰安市",
                    "whole_name": "泰安市，山东省",
                    "simple_py": "TAS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0538",
                    "area_code": "370900",
                    "longitude": "117.129063",
                    "latitude": "36.194968",
                    "children": [
                        {
                            "area_id": 14353,
                            "city_id": 12761,
                            "province_id": 8,
                            "name": "岱岳区",
                            "whole_name": "岱岳区，泰安市，山东省",
                            "simple_py": "DYQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0538",
                            "area_code": "370911",
                            "longitude": "117.04353",
                            "latitude": "36.1841"
                        },
                        {
                            "area_id": 14354,
                            "city_id": 12761,
                            "province_id": 8,
                            "name": "东平县",
                            "whole_name": "东平县，泰安市，山东省",
                            "simple_py": "DPX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0538",
                            "area_code": "370923",
                            "longitude": "116.461052",
                            "latitude": "35.930467"
                        },
                        {
                            "area_id": 14357,
                            "city_id": 12761,
                            "province_id": 8,
                            "name": "肥城市",
                            "whole_name": "肥城市，泰安市，山东省",
                            "simple_py": "FCS",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0538",
                            "area_code": "370983",
                            "longitude": "116.763703",
                            "latitude": "36.1856"
                        },
                        {
                            "area_id": 14358,
                            "city_id": 12761,
                            "province_id": 8,
                            "name": "宁阳县",
                            "whole_name": "宁阳县，泰安市，山东省",
                            "simple_py": "NYX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0538",
                            "area_code": "370921",
                            "longitude": "116.799297",
                            "latitude": "35.76754"
                        },
                        {
                            "area_id": 14356,
                            "city_id": 12761,
                            "province_id": 8,
                            "name": "泰山区",
                            "whole_name": "泰山区，泰安市，山东省",
                            "simple_py": "TSQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0538",
                            "area_code": "370902",
                            "longitude": "117.129984",
                            "latitude": "36.189313"
                        },
                        {
                            "area_id": 14355,
                            "city_id": 12761,
                            "province_id": 8,
                            "name": "新泰市",
                            "whole_name": "新泰市，泰安市，山东省",
                            "simple_py": "XTS",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0538",
                            "area_code": "370982",
                            "longitude": "117.766092",
                            "latitude": "35.910387"
                        }
                    ]
                },
                {
                    "city_id": 12748,
                    "province_id": 8,
                    "name": "威海市",
                    "whole_name": "威海市，山东省",
                    "simple_py": "WHS",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "0631",
                    "area_code": "371000",
                    "longitude": "122.116394",
                    "latitude": "37.509691",
                    "children": [
                        {
                            "area_id": 12765,
                            "city_id": 12748,
                            "province_id": 8,
                            "name": "环翠区",
                            "whole_name": "环翠区，威海市，山东省",
                            "simple_py": "HCQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0631",
                            "area_code": "371002",
                            "longitude": "122.116189",
                            "latitude": "37.510754"
                        },
                        {
                            "area_id": 12766,
                            "city_id": 12748,
                            "province_id": 8,
                            "name": "荣成市",
                            "whole_name": "荣成市，威海市，山东省",
                            "simple_py": "RCS",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0631",
                            "area_code": "371082",
                            "longitude": "122.422896",
                            "latitude": "37.160134"
                        },
                        {
                            "area_id": 12768,
                            "city_id": 12748,
                            "province_id": 8,
                            "name": "乳山市",
                            "whole_name": "乳山市，威海市，山东省",
                            "simple_py": "RSS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "R",
                            "city_code": "0631",
                            "area_code": "371083",
                            "longitude": "121.536346",
                            "latitude": "36.919622"
                        },
                        {
                            "area_id": 12767,
                            "city_id": 12748,
                            "province_id": 8,
                            "name": "文登区",
                            "whole_name": "文登区，威海市，山东省",
                            "simple_py": "WDQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0631",
                            "area_code": "371003",
                            "longitude": "122.057139",
                            "latitude": "37.196211"
                        }
                    ]
                },
                {
                    "city_id": 12759,
                    "province_id": 8,
                    "name": "潍坊市",
                    "whole_name": "潍坊市，山东省",
                    "simple_py": "WFS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "W",
                    "city_code": "0536",
                    "area_code": "370700",
                    "longitude": "119.107078",
                    "latitude": "36.70925",
                    "children": [
                        {
                            "area_id": 14072,
                            "city_id": 12759,
                            "province_id": 8,
                            "name": "安丘市",
                            "whole_name": "安丘市，潍坊市，山东省",
                            "simple_py": "AQS",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0536",
                            "area_code": "370784",
                            "longitude": "119.206886",
                            "latitude": "36.427417"
                        },
                        {
                            "area_id": 14068,
                            "city_id": 12759,
                            "province_id": 8,
                            "name": "昌乐县",
                            "whole_name": "昌乐县，潍坊市，山东省",
                            "simple_py": "CLX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0536",
                            "area_code": "370725",
                            "longitude": "118.839995",
                            "latitude": "36.703253"
                        },
                        {
                            "area_id": 14076,
                            "city_id": 12759,
                            "province_id": 8,
                            "name": "昌邑市",
                            "whole_name": "昌邑市，潍坊市，山东省",
                            "simple_py": "CYS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0536",
                            "area_code": "370786",
                            "longitude": "119.394502",
                            "latitude": "36.854937"
                        },
                        {
                            "area_id": 14069,
                            "city_id": 12759,
                            "province_id": 8,
                            "name": "坊子区",
                            "whole_name": "坊子区，潍坊市，山东省",
                            "simple_py": "FZQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0536",
                            "area_code": "370704",
                            "longitude": "119.166326",
                            "latitude": "36.654616"
                        },
                        {
                            "area_id": 14071,
                            "city_id": 12759,
                            "province_id": 8,
                            "name": "高密市",
                            "whole_name": "高密市，潍坊市，山东省",
                            "simple_py": "GMS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0536",
                            "area_code": "370785",
                            "longitude": "119.757033",
                            "latitude": "36.37754"
                        },
                        {
                            "area_id": 14075,
                            "city_id": 12759,
                            "province_id": 8,
                            "name": "寒亭区",
                            "whole_name": "寒亭区，潍坊市，山东省",
                            "simple_py": "HTQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0536",
                            "area_code": "370703",
                            "longitude": "119.207866",
                            "latitude": "36.772103"
                        },
                        {
                            "area_id": 14066,
                            "city_id": 12759,
                            "province_id": 8,
                            "name": "奎文区",
                            "whole_name": "奎文区，潍坊市，山东省",
                            "simple_py": "KWQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0536",
                            "area_code": "370705",
                            "longitude": "119.137357",
                            "latitude": "36.709494"
                        },
                        {
                            "area_id": 14070,
                            "city_id": 12759,
                            "province_id": 8,
                            "name": "临朐县",
                            "whole_name": "临朐县，潍坊市，山东省",
                            "simple_py": "LQX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0536",
                            "area_code": "370724",
                            "longitude": "118.539876",
                            "latitude": "36.516371"
                        },
                        {
                            "area_id": 14065,
                            "city_id": 12759,
                            "province_id": 8,
                            "name": "青州市",
                            "whole_name": "青州市，潍坊市，山东省",
                            "simple_py": "QZS",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0536",
                            "area_code": "370781",
                            "longitude": "118.484693",
                            "latitude": "36.697855"
                        },
                        {
                            "area_id": 14074,
                            "city_id": 12759,
                            "province_id": 8,
                            "name": "寿光市",
                            "whole_name": "寿光市，潍坊市，山东省",
                            "simple_py": "SGS",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0536",
                            "area_code": "370783",
                            "longitude": "118.736451",
                            "latitude": "36.874411"
                        },
                        {
                            "area_id": 14067,
                            "city_id": 12759,
                            "province_id": 8,
                            "name": "潍城区",
                            "whole_name": "潍城区，潍坊市，山东省",
                            "simple_py": "WCQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0536",
                            "area_code": "370702",
                            "longitude": "119.103784",
                            "latitude": "36.710062"
                        },
                        {
                            "area_id": 14073,
                            "city_id": 12759,
                            "province_id": 8,
                            "name": "诸城市",
                            "whole_name": "诸城市，潍坊市，山东省",
                            "simple_py": "ZCS",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0536",
                            "area_code": "370782",
                            "longitude": "119.403182",
                            "latitude": "35.997093"
                        }
                    ]
                },
                {
                    "city_id": 12749,
                    "province_id": 8,
                    "name": "烟台市",
                    "whole_name": "烟台市，山东省",
                    "simple_py": "YTS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0535",
                    "area_code": "370600",
                    "longitude": "121.391382",
                    "latitude": "37.539297",
                    "children": [
                        {
                            "area_id": 12843,
                            "city_id": 12749,
                            "province_id": 8,
                            "name": "长岛县",
                            "whole_name": "长岛县，烟台市，山东省",
                            "simple_py": "CDX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0535",
                            "area_code": "370634",
                            "longitude": "120.738345",
                            "latitude": "37.916194"
                        },
                        {
                            "area_id": 12844,
                            "city_id": 12749,
                            "province_id": 8,
                            "name": "福山区",
                            "whole_name": "福山区，烟台市，山东省",
                            "simple_py": "FSQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0535",
                            "area_code": "370611",
                            "longitude": "121.264741",
                            "latitude": "37.496875"
                        },
                        {
                            "area_id": 12849,
                            "city_id": 12749,
                            "province_id": 8,
                            "name": "海阳市",
                            "whole_name": "海阳市，烟台市，山东省",
                            "simple_py": "HYS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0535",
                            "area_code": "370687",
                            "longitude": "121.168392",
                            "latitude": "36.780657"
                        },
                        {
                            "area_id": 12842,
                            "city_id": 12749,
                            "province_id": 8,
                            "name": "龙口市",
                            "whole_name": "龙口市，烟台市，山东省",
                            "simple_py": "LKS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0535",
                            "area_code": "370681",
                            "longitude": "120.528328",
                            "latitude": "37.648446"
                        },
                        {
                            "area_id": 12848,
                            "city_id": 12749,
                            "province_id": 8,
                            "name": "莱州市",
                            "whole_name": "莱州市，烟台市，山东省",
                            "simple_py": "LZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0535",
                            "area_code": "370683",
                            "longitude": "119.942135",
                            "latitude": "37.182725"
                        },
                        {
                            "area_id": 12851,
                            "city_id": 12749,
                            "province_id": 8,
                            "name": "莱山区",
                            "whole_name": "莱山区，烟台市，山东省",
                            "simple_py": "LSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0535",
                            "area_code": "370613",
                            "longitude": "121.448866",
                            "latitude": "37.473549"
                        },
                        {
                            "area_id": 12852,
                            "city_id": 12749,
                            "province_id": 8,
                            "name": "莱阳市",
                            "whole_name": "莱阳市，烟台市，山东省",
                            "simple_py": "LYS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0535",
                            "area_code": "370682",
                            "longitude": "120.711151",
                            "latitude": "36.977037"
                        },
                        {
                            "area_id": 12850,
                            "city_id": 12749,
                            "province_id": 8,
                            "name": "牟平区",
                            "whole_name": "牟平区，烟台市，山东省",
                            "simple_py": "MPQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0535",
                            "area_code": "370612",
                            "longitude": "121.60151",
                            "latitude": "37.388356"
                        },
                        {
                            "area_id": 12853,
                            "city_id": 12749,
                            "province_id": 8,
                            "name": "蓬莱市",
                            "whole_name": "蓬莱市，烟台市，山东省",
                            "simple_py": "PLS",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0535",
                            "area_code": "370684",
                            "longitude": "120.762689",
                            "latitude": "37.811168"
                        },
                        {
                            "area_id": 12847,
                            "city_id": 12749,
                            "province_id": 8,
                            "name": "栖霞市",
                            "whole_name": "栖霞市，烟台市，山东省",
                            "simple_py": "QXS",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0535",
                            "area_code": "370686",
                            "longitude": "120.834097",
                            "latitude": "37.305854"
                        },
                        {
                            "area_id": 12845,
                            "city_id": 12749,
                            "province_id": 8,
                            "name": "芝罘区",
                            "whole_name": "芝罘区，烟台市，山东省",
                            "simple_py": "ZFQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0535",
                            "area_code": "370602",
                            "longitude": "121.385877",
                            "latitude": "37.540925"
                        },
                        {
                            "area_id": 12846,
                            "city_id": 12749,
                            "province_id": 8,
                            "name": "招远市",
                            "whole_name": "招远市，烟台市，山东省",
                            "simple_py": "ZYS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0535",
                            "area_code": "370685",
                            "longitude": "120.403142",
                            "latitude": "37.364919"
                        }
                    ]
                },
                {
                    "city_id": 12753,
                    "province_id": 8,
                    "name": "淄博市",
                    "whole_name": "淄博市，山东省",
                    "simple_py": "ZBS",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "0533",
                    "area_code": "370300",
                    "longitude": "118.047648",
                    "latitude": "36.814939",
                    "children": [
                        {
                            "area_id": 13306,
                            "city_id": 12753,
                            "province_id": 8,
                            "name": "博山区",
                            "whole_name": "博山区，淄博市，山东省",
                            "simple_py": "BSQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0533",
                            "area_code": "370304",
                            "longitude": "117.85823",
                            "latitude": "36.497567"
                        },
                        {
                            "area_id": 13299,
                            "city_id": 12753,
                            "province_id": 8,
                            "name": "高青县",
                            "whole_name": "高青县，淄博市，山东省",
                            "simple_py": "GQX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0533",
                            "area_code": "370322",
                            "longitude": "117.829839",
                            "latitude": "37.169581"
                        },
                        {
                            "area_id": 13301,
                            "city_id": 12753,
                            "province_id": 8,
                            "name": "桓台县",
                            "whole_name": "桓台县，淄博市，山东省",
                            "simple_py": "HTX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0533",
                            "area_code": "370321",
                            "longitude": "118.101556",
                            "latitude": "36.959773"
                        },
                        {
                            "area_id": 13302,
                            "city_id": 12753,
                            "province_id": 8,
                            "name": "临淄区",
                            "whole_name": "临淄区，淄博市，山东省",
                            "simple_py": "LZQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0533",
                            "area_code": "370305",
                            "longitude": "118.306018",
                            "latitude": "36.816657"
                        },
                        {
                            "area_id": 13305,
                            "city_id": 12753,
                            "province_id": 8,
                            "name": "沂源县",
                            "whole_name": "沂源县，淄博市，山东省",
                            "simple_py": "YYX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0533",
                            "area_code": "370323",
                            "longitude": "118.166161",
                            "latitude": "36.186282"
                        },
                        {
                            "area_id": 13300,
                            "city_id": 12753,
                            "province_id": 8,
                            "name": "张店区",
                            "whole_name": "张店区，淄博市，山东省",
                            "simple_py": "ZDQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0533",
                            "area_code": "370303",
                            "longitude": "118.053521",
                            "latitude": "36.807049"
                        },
                        {
                            "area_id": 13303,
                            "city_id": 12753,
                            "province_id": 8,
                            "name": "周村区",
                            "whole_name": "周村区，淄博市，山东省",
                            "simple_py": "ZCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0533",
                            "area_code": "370306",
                            "longitude": "117.851036",
                            "latitude": "36.803699"
                        },
                        {
                            "area_id": 13304,
                            "city_id": 12753,
                            "province_id": 8,
                            "name": "淄川区",
                            "whole_name": "淄川区，淄博市，山东省",
                            "simple_py": "ZCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0533",
                            "area_code": "370302",
                            "longitude": "117.967696",
                            "latitude": "36.647272"
                        }
                    ]
                },
                {
                    "city_id": 12764,
                    "province_id": 8,
                    "name": "枣庄市",
                    "whole_name": "枣庄市，山东省",
                    "simple_py": "ZZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Z",
                    "city_code": "0632",
                    "area_code": "370400",
                    "longitude": "117.557964",
                    "latitude": "34.856424",
                    "children": [
                        {
                            "area_id": 14672,
                            "city_id": 12764,
                            "province_id": 8,
                            "name": "市中区",
                            "whole_name": "市中区，枣庄市，山东省",
                            "simple_py": "SZQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0632",
                            "area_code": "370402",
                            "longitude": "117.557281",
                            "latitude": "34.856651"
                        },
                        {
                            "area_id": 14674,
                            "city_id": 12764,
                            "province_id": 8,
                            "name": "山亭区",
                            "whole_name": "山亭区，枣庄市，山东省",
                            "simple_py": "STQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0632",
                            "area_code": "370406",
                            "longitude": "117.458968",
                            "latitude": "35.096077"
                        },
                        {
                            "area_id": 14676,
                            "city_id": 12764,
                            "province_id": 8,
                            "name": "台儿庄区",
                            "whole_name": "台儿庄区，枣庄市，山东省",
                            "simple_py": "TEZQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0632",
                            "area_code": "370405",
                            "longitude": "117.734747",
                            "latitude": "34.564815"
                        },
                        {
                            "area_id": 14677,
                            "city_id": 12764,
                            "province_id": 8,
                            "name": "滕州市",
                            "whole_name": "滕州市，枣庄市，山东省",
                            "simple_py": "TZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0632",
                            "area_code": "370481",
                            "longitude": "117.162098",
                            "latitude": "35.088498"
                        },
                        {
                            "area_id": 14673,
                            "city_id": 12764,
                            "province_id": 8,
                            "name": "薛城区",
                            "whole_name": "薛城区，枣庄市，山东省",
                            "simple_py": "XCQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0632",
                            "area_code": "370403",
                            "longitude": "117.265293",
                            "latitude": "34.79789"
                        },
                        {
                            "area_id": 14675,
                            "city_id": 12764,
                            "province_id": 8,
                            "name": "峄城区",
                            "whole_name": "峄城区，枣庄市，山东省",
                            "simple_py": "YCQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0632",
                            "area_code": "370404",
                            "longitude": "117.586316",
                            "latitude": "34.767713"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 9,
            "name": "陕西省",
            "whole_name": "陕西省",
            "simple_py": "SXS",
            "per_pin_yin": " ",
            "per_pin_yin2": "S",
            "city_code": "",
            "area_code": "610000",
            "longitude": "108.948024",
            "latitude": "34.263161",
            "children": [
                {
                    "city_id": 14745,
                    "province_id": 9,
                    "name": "安康市",
                    "whole_name": "安康市，陕西省",
                    "simple_py": "AKS",
                    "per_pin_yin": "A",
                    "per_pin_yin2": "A",
                    "city_code": "0915",
                    "area_code": "610900",
                    "longitude": "109.029273",
                    "latitude": "32.6903",
                    "children": [
                        {
                            "area_id": 15246,
                            "city_id": 14745,
                            "province_id": 9,
                            "name": "白河县",
                            "whole_name": "白河县，安康市，陕西省",
                            "simple_py": "BHX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0915",
                            "area_code": "610929",
                            "longitude": "110.114186",
                            "latitude": "32.809484"
                        },
                        {
                            "area_id": 15243,
                            "city_id": 14745,
                            "province_id": 9,
                            "name": "汉滨区",
                            "whole_name": "汉滨区，安康市，陕西省",
                            "simple_py": "HBQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0915",
                            "area_code": "610902",
                            "longitude": "109.029098",
                            "latitude": "32.690817"
                        },
                        {
                            "area_id": 15244,
                            "city_id": 14745,
                            "province_id": 9,
                            "name": "汉阴县",
                            "whole_name": "汉阴县，安康市，陕西省",
                            "simple_py": "HYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0915",
                            "area_code": "610921",
                            "longitude": "108.510946",
                            "latitude": "32.891121"
                        },
                        {
                            "area_id": 15249,
                            "city_id": 14745,
                            "province_id": 9,
                            "name": "岚皋县",
                            "whole_name": "岚皋县，安康市，陕西省",
                            "simple_py": "LGX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0915",
                            "area_code": "610925",
                            "longitude": "108.900663",
                            "latitude": "32.31069"
                        },
                        {
                            "area_id": 15240,
                            "city_id": 14745,
                            "province_id": 9,
                            "name": "宁陕县",
                            "whole_name": "宁陕县，安康市，陕西省",
                            "simple_py": "NSX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0915",
                            "area_code": "610923",
                            "longitude": "108.313714",
                            "latitude": "33.312184"
                        },
                        {
                            "area_id": 15247,
                            "city_id": 14745,
                            "province_id": 9,
                            "name": "平利县",
                            "whole_name": "平利县，安康市，陕西省",
                            "simple_py": "PLX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0915",
                            "area_code": "610926",
                            "longitude": "109.361865",
                            "latitude": "32.387933"
                        },
                        {
                            "area_id": 15241,
                            "city_id": 14745,
                            "province_id": 9,
                            "name": "石泉县",
                            "whole_name": "石泉县，安康市，陕西省",
                            "simple_py": "SQX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0915",
                            "area_code": "610922",
                            "longitude": "108.250512",
                            "latitude": "33.038512"
                        },
                        {
                            "area_id": 15242,
                            "city_id": 14745,
                            "province_id": 9,
                            "name": "旬阳县",
                            "whole_name": "旬阳县，安康市，陕西省",
                            "simple_py": "XYX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0915",
                            "area_code": "610928",
                            "longitude": "109.368149",
                            "latitude": "32.833567"
                        },
                        {
                            "area_id": 15245,
                            "city_id": 14745,
                            "province_id": 9,
                            "name": "紫阳县",
                            "whole_name": "紫阳县，安康市，陕西省",
                            "simple_py": "ZYX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0915",
                            "area_code": "610924",
                            "longitude": "108.537788",
                            "latitude": "32.520176"
                        },
                        {
                            "area_id": 15248,
                            "city_id": 14745,
                            "province_id": 9,
                            "name": "镇坪县",
                            "whole_name": "镇坪县，安康市，陕西省",
                            "simple_py": "ZPX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0915",
                            "area_code": "610927",
                            "longitude": "109.526437",
                            "latitude": "31.883395"
                        }
                    ]
                },
                {
                    "city_id": 14749,
                    "province_id": 9,
                    "name": "宝鸡市",
                    "whole_name": "宝鸡市，陕西省",
                    "simple_py": "BJS",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "0917",
                    "area_code": "610300",
                    "longitude": "107.14487",
                    "latitude": "34.369315",
                    "children": [
                        {
                            "area_id": 15780,
                            "city_id": 14749,
                            "province_id": 9,
                            "name": "陈仓区",
                            "whole_name": "陈仓区，宝鸡市，陕西省",
                            "simple_py": "CCQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0917",
                            "area_code": "610304",
                            "longitude": "107.383645",
                            "latitude": "34.352747"
                        },
                        {
                            "area_id": 15776,
                            "city_id": 14749,
                            "province_id": 9,
                            "name": "凤县",
                            "whole_name": "凤县，宝鸡市，陕西省",
                            "simple_py": "FX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0917",
                            "area_code": "610330",
                            "longitude": "106.525212",
                            "latitude": "33.912464"
                        },
                        {
                            "area_id": 15778,
                            "city_id": 14749,
                            "province_id": 9,
                            "name": "扶风县",
                            "whole_name": "扶风县，宝鸡市，陕西省",
                            "simple_py": "FFX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0917",
                            "area_code": "610324",
                            "longitude": "107.891419",
                            "latitude": "34.375497"
                        },
                        {
                            "area_id": 15781,
                            "city_id": 14749,
                            "province_id": 9,
                            "name": "凤翔县",
                            "whole_name": "凤翔县，宝鸡市，陕西省",
                            "simple_py": "FXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0917",
                            "area_code": "610322",
                            "longitude": "107.400577",
                            "latitude": "34.521668"
                        },
                        {
                            "area_id": 15774,
                            "city_id": 14749,
                            "province_id": 9,
                            "name": "金台区",
                            "whole_name": "金台区，宝鸡市，陕西省",
                            "simple_py": "JTQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0917",
                            "area_code": "610303",
                            "longitude": "107.149943",
                            "latitude": "34.375192"
                        },
                        {
                            "area_id": 15770,
                            "city_id": 14749,
                            "province_id": 9,
                            "name": "陇县",
                            "whole_name": "陇县，宝鸡市，陕西省",
                            "simple_py": "LX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0917",
                            "area_code": "610327",
                            "longitude": "106.857066",
                            "latitude": "34.893262"
                        },
                        {
                            "area_id": 15771,
                            "city_id": 14749,
                            "province_id": 9,
                            "name": "麟游县",
                            "whole_name": "麟游县，宝鸡市，陕西省",
                            "simple_py": "LYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0917",
                            "area_code": "610329",
                            "longitude": "107.796608",
                            "latitude": "34.677714"
                        },
                        {
                            "area_id": 15777,
                            "city_id": 14749,
                            "province_id": 9,
                            "name": "眉县",
                            "whole_name": "眉县，宝鸡市，陕西省",
                            "simple_py": "MX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0917",
                            "area_code": "610326",
                            "longitude": "107.752371",
                            "latitude": "34.272137"
                        },
                        {
                            "area_id": 15772,
                            "city_id": 14749,
                            "province_id": 9,
                            "name": "千阳县",
                            "whole_name": "千阳县，宝鸡市，陕西省",
                            "simple_py": "QYX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0917",
                            "area_code": "610328",
                            "longitude": "107.132987",
                            "latitude": "34.642584"
                        },
                        {
                            "area_id": 15775,
                            "city_id": 14749,
                            "province_id": 9,
                            "name": "岐山县",
                            "whole_name": "岐山县，宝鸡市，陕西省",
                            "simple_py": "QSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0917",
                            "area_code": "610323",
                            "longitude": "107.624464",
                            "latitude": "34.44296"
                        },
                        {
                            "area_id": 15779,
                            "city_id": 14749,
                            "province_id": 9,
                            "name": "太白县",
                            "whole_name": "太白县，宝鸡市，陕西省",
                            "simple_py": "TBX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0917",
                            "area_code": "610331",
                            "longitude": "107.316533",
                            "latitude": "34.059215"
                        },
                        {
                            "area_id": 15773,
                            "city_id": 14749,
                            "province_id": 9,
                            "name": "渭滨区",
                            "whole_name": "渭滨区，宝鸡市，陕西省",
                            "simple_py": "WBQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0917",
                            "area_code": "610302",
                            "longitude": "107.144467",
                            "latitude": "34.371008"
                        }
                    ]
                },
                {
                    "city_id": 14744,
                    "province_id": 9,
                    "name": "汉中市",
                    "whole_name": "汉中市，陕西省",
                    "simple_py": "HZS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0916",
                    "area_code": "610700",
                    "longitude": "107.028621",
                    "latitude": "33.077668",
                    "children": [
                        {
                            "area_id": 15055,
                            "city_id": 14744,
                            "province_id": 9,
                            "name": "城固县",
                            "whole_name": "城固县，汉中市，陕西省",
                            "simple_py": "CGX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0916",
                            "area_code": "610722",
                            "longitude": "107.329887",
                            "latitude": "33.153098"
                        },
                        {
                            "area_id": 15056,
                            "city_id": 14744,
                            "province_id": 9,
                            "name": "佛坪县",
                            "whole_name": "佛坪县，汉中市，陕西省",
                            "simple_py": "FPX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0916",
                            "area_code": "610730",
                            "longitude": "107.988582",
                            "latitude": "33.520745"
                        },
                        {
                            "area_id": 15053,
                            "city_id": 14744,
                            "province_id": 9,
                            "name": "汉台区",
                            "whole_name": "汉台区，汉中市，陕西省",
                            "simple_py": "HTQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0916",
                            "area_code": "610702",
                            "longitude": "107.028233",
                            "latitude": "33.077674"
                        },
                        {
                            "area_id": 15052,
                            "city_id": 14744,
                            "province_id": 9,
                            "name": "留坝县",
                            "whole_name": "留坝县，汉中市，陕西省",
                            "simple_py": "LBX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0916",
                            "area_code": "610729",
                            "longitude": "106.924377",
                            "latitude": "33.61334"
                        },
                        {
                            "area_id": 15058,
                            "city_id": 14744,
                            "province_id": 9,
                            "name": "略阳县",
                            "whole_name": "略阳县，汉中市，陕西省",
                            "simple_py": "LYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0916",
                            "area_code": "610727",
                            "longitude": "106.153899",
                            "latitude": "33.329638"
                        },
                        {
                            "area_id": 15057,
                            "city_id": 14744,
                            "province_id": 9,
                            "name": "勉县",
                            "whole_name": "勉县，汉中市，陕西省",
                            "simple_py": "MX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0916",
                            "area_code": "610725",
                            "longitude": "106.680175",
                            "latitude": "33.155618"
                        },
                        {
                            "area_id": 15059,
                            "city_id": 14744,
                            "province_id": 9,
                            "name": "南郑区",
                            "whole_name": "南郑区，汉中市，陕西省",
                            "simple_py": "NZQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0916",
                            "area_code": "610703",
                            "longitude": "106.942393",
                            "latitude": "33.003341"
                        },
                        {
                            "area_id": 15062,
                            "city_id": 14744,
                            "province_id": 9,
                            "name": "宁强县",
                            "whole_name": "宁强县，汉中市，陕西省",
                            "simple_py": "NQX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0916",
                            "area_code": "610726",
                            "longitude": "106.25739",
                            "latitude": "32.830806"
                        },
                        {
                            "area_id": 15060,
                            "city_id": 14744,
                            "province_id": 9,
                            "name": "西乡县",
                            "whole_name": "西乡县，汉中市，陕西省",
                            "simple_py": "XXX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0916",
                            "area_code": "610724",
                            "longitude": "107.765858",
                            "latitude": "32.987961"
                        },
                        {
                            "area_id": 15054,
                            "city_id": 14744,
                            "province_id": 9,
                            "name": "洋县",
                            "whole_name": "洋县，汉中市，陕西省",
                            "simple_py": "YX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0916",
                            "area_code": "610723",
                            "longitude": "107.549962",
                            "latitude": "33.223283"
                        },
                        {
                            "area_id": 15061,
                            "city_id": 14744,
                            "province_id": 9,
                            "name": "镇巴县",
                            "whole_name": "镇巴县，汉中市，陕西省",
                            "simple_py": "ZBX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0916",
                            "area_code": "610728",
                            "longitude": "107.89531",
                            "latitude": "32.535854"
                        }
                    ]
                },
                {
                    "city_id": 14742,
                    "province_id": 9,
                    "name": "商洛市",
                    "whole_name": "商洛市，陕西省",
                    "simple_py": "SLS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0914",
                    "area_code": "611000",
                    "longitude": "109.939776",
                    "latitude": "33.868319",
                    "children": [
                        {
                            "area_id": 14755,
                            "city_id": 14742,
                            "province_id": 9,
                            "name": "丹凤县",
                            "whole_name": "丹凤县，商洛市，陕西省",
                            "simple_py": "DFX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0914",
                            "area_code": "611022",
                            "longitude": "110.33191",
                            "latitude": "33.694711"
                        },
                        {
                            "area_id": 14753,
                            "city_id": 14742,
                            "province_id": 9,
                            "name": "洛南县",
                            "whole_name": "洛南县，商洛市，陕西省",
                            "simple_py": "LNX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0914",
                            "area_code": "611021",
                            "longitude": "110.145716",
                            "latitude": "34.088502"
                        },
                        {
                            "area_id": 14754,
                            "city_id": 14742,
                            "province_id": 9,
                            "name": "商州区",
                            "whole_name": "商州区，商洛市，陕西省",
                            "simple_py": "SZQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0914",
                            "area_code": "611002",
                            "longitude": "109.937685",
                            "latitude": "33.869208"
                        },
                        {
                            "area_id": 14756,
                            "city_id": 14742,
                            "province_id": 9,
                            "name": "商南县",
                            "whole_name": "商南县，商洛市，陕西省",
                            "simple_py": "SNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0914",
                            "area_code": "611023",
                            "longitude": "110.885437",
                            "latitude": "33.526367"
                        },
                        {
                            "area_id": 14757,
                            "city_id": 14742,
                            "province_id": 9,
                            "name": "山阳县",
                            "whole_name": "山阳县，商洛市，陕西省",
                            "simple_py": "SYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0914",
                            "area_code": "611024",
                            "longitude": "109.880435",
                            "latitude": "33.530411"
                        },
                        {
                            "area_id": 14752,
                            "city_id": 14742,
                            "province_id": 9,
                            "name": "柞水县",
                            "whole_name": "柞水县，商洛市，陕西省",
                            "simple_py": "ZSX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0914",
                            "area_code": "611026",
                            "longitude": "109.111249",
                            "latitude": "33.682773"
                        },
                        {
                            "area_id": 14758,
                            "city_id": 14742,
                            "province_id": 9,
                            "name": "镇安县",
                            "whole_name": "镇安县，商洛市，陕西省",
                            "simple_py": "ZAX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0914",
                            "area_code": "611025",
                            "longitude": "109.151075",
                            "latitude": "33.423981"
                        }
                    ]
                },
                {
                    "city_id": 14747,
                    "province_id": 9,
                    "name": "铜川市",
                    "whole_name": "铜川市，陕西省",
                    "simple_py": "TCS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0919",
                    "area_code": "610200",
                    "longitude": "108.979608",
                    "latitude": "34.916582",
                    "children": [
                        {
                            "area_id": 15576,
                            "city_id": 14747,
                            "province_id": 9,
                            "name": "王益区",
                            "whole_name": "王益区，铜川市，陕西省",
                            "simple_py": "WYQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0919",
                            "area_code": "610202",
                            "longitude": "109.075862",
                            "latitude": "35.069098"
                        },
                        {
                            "area_id": 15573,
                            "city_id": 14747,
                            "province_id": 9,
                            "name": "耀州区",
                            "whole_name": "耀州区，铜川市，陕西省",
                            "simple_py": "YZQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0919",
                            "area_code": "610204",
                            "longitude": "108.962538",
                            "latitude": "34.910206"
                        },
                        {
                            "area_id": 15574,
                            "city_id": 14747,
                            "province_id": 9,
                            "name": "宜君县",
                            "whole_name": "宜君县，铜川市，陕西省",
                            "simple_py": "YJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0919",
                            "area_code": "610222",
                            "longitude": "109.118278",
                            "latitude": "35.398766"
                        },
                        {
                            "area_id": 15575,
                            "city_id": 14747,
                            "province_id": 9,
                            "name": "印台区",
                            "whole_name": "印台区，铜川市，陕西省",
                            "simple_py": "YTQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0919",
                            "area_code": "610203",
                            "longitude": "109.100814",
                            "latitude": "35.111927"
                        }
                    ]
                },
                {
                    "city_id": 14751,
                    "province_id": 9,
                    "name": "渭南市",
                    "whole_name": "渭南市，陕西省",
                    "simple_py": "WNS",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "0913",
                    "area_code": "610500",
                    "longitude": "109.502882",
                    "latitude": "34.499381",
                    "children": [
                        {
                            "area_id": 16026,
                            "city_id": 14751,
                            "province_id": 9,
                            "name": "白水县",
                            "whole_name": "白水县，渭南市，陕西省",
                            "simple_py": "BSX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0913",
                            "area_code": "610527",
                            "longitude": "109.594309",
                            "latitude": "35.177291"
                        },
                        {
                            "area_id": 16034,
                            "city_id": 14751,
                            "province_id": 9,
                            "name": "澄城县",
                            "whole_name": "澄城县，渭南市，陕西省",
                            "simple_py": "CCX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0913",
                            "area_code": "610525",
                            "longitude": "109.937609",
                            "latitude": "35.184"
                        },
                        {
                            "area_id": 16028,
                            "city_id": 14751,
                            "province_id": 9,
                            "name": "大荔县",
                            "whole_name": "大荔县，渭南市，陕西省",
                            "simple_py": "DLX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0913",
                            "area_code": "610523",
                            "longitude": "109.943123",
                            "latitude": "34.795011"
                        },
                        {
                            "area_id": 16027,
                            "city_id": 14751,
                            "province_id": 9,
                            "name": "富平县",
                            "whole_name": "富平县，渭南市，陕西省",
                            "simple_py": "FPX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0913",
                            "area_code": "610528",
                            "longitude": "109.187174",
                            "latitude": "34.746679"
                        },
                        {
                            "area_id": 16025,
                            "city_id": 14751,
                            "province_id": 9,
                            "name": "韩城市",
                            "whole_name": "韩城市，渭南市，陕西省",
                            "simple_py": "HCS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0913",
                            "area_code": "610581",
                            "longitude": "110.452391",
                            "latitude": "35.475238"
                        },
                        {
                            "area_id": 16030,
                            "city_id": 14751,
                            "province_id": 9,
                            "name": "华州区",
                            "whole_name": "华州区，渭南市，陕西省",
                            "simple_py": "HZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0913",
                            "area_code": "610503",
                            "longitude": "109.76141",
                            "latitude": "34.511958"
                        },
                        {
                            "area_id": 16031,
                            "city_id": 14751,
                            "province_id": 9,
                            "name": "华阴市",
                            "whole_name": "华阴市，渭南市，陕西省",
                            "simple_py": "HYS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0913",
                            "area_code": "610582",
                            "longitude": "110.08952",
                            "latitude": "34.565359"
                        },
                        {
                            "area_id": 16033,
                            "city_id": 14751,
                            "province_id": 9,
                            "name": "合阳县",
                            "whole_name": "合阳县，渭南市，陕西省",
                            "simple_py": "HYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0913",
                            "area_code": "610524",
                            "longitude": "110.147979",
                            "latitude": "35.237098"
                        },
                        {
                            "area_id": 16029,
                            "city_id": 14751,
                            "province_id": 9,
                            "name": "临渭区",
                            "whole_name": "临渭区，渭南市，陕西省",
                            "simple_py": "LWQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0913",
                            "area_code": "610502",
                            "longitude": "109.503299",
                            "latitude": "34.501271"
                        },
                        {
                            "area_id": 16035,
                            "city_id": 14751,
                            "province_id": 9,
                            "name": "蒲城县",
                            "whole_name": "蒲城县，渭南市，陕西省",
                            "simple_py": "PCX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0913",
                            "area_code": "610526",
                            "longitude": "109.589653",
                            "latitude": "34.956034"
                        },
                        {
                            "area_id": 16032,
                            "city_id": 14751,
                            "province_id": 9,
                            "name": "潼关县",
                            "whole_name": "潼关县，渭南市，陕西省",
                            "simple_py": "TGX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0913",
                            "area_code": "610522",
                            "longitude": "110.24726",
                            "latitude": "34.544515"
                        }
                    ]
                },
                {
                    "city_id": 14743,
                    "province_id": 9,
                    "name": "西安市",
                    "whole_name": "西安市，陕西省",
                    "simple_py": "XAS",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "029",
                    "area_code": "610100",
                    "longitude": "108.948024",
                    "latitude": "34.263161",
                    "children": [
                        {
                            "area_id": 14877,
                            "city_id": 14743,
                            "province_id": 9,
                            "name": "碑林区",
                            "whole_name": "碑林区，西安市，陕西省",
                            "simple_py": "BLQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "029",
                            "area_code": "610103",
                            "longitude": "108.946994",
                            "latitude": "34.251061"
                        },
                        {
                            "area_id": 14882,
                            "city_id": 14743,
                            "province_id": 9,
                            "name": "灞桥区",
                            "whole_name": "灞桥区，西安市，陕西省",
                            "simple_py": "BQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "029",
                            "area_code": "610111",
                            "longitude": "109.067261",
                            "latitude": "34.267453"
                        },
                        {
                            "area_id": 14873,
                            "city_id": 14743,
                            "province_id": 9,
                            "name": "长安区",
                            "whole_name": "长安区，西安市，陕西省",
                            "simple_py": "CAQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "029",
                            "area_code": "610116",
                            "longitude": "108.941579",
                            "latitude": "34.157097"
                        },
                        {
                            "area_id": 14870,
                            "city_id": 14743,
                            "province_id": 9,
                            "name": "高陵区",
                            "whole_name": "高陵区，西安市，陕西省",
                            "simple_py": "GLQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "029",
                            "area_code": "610117",
                            "longitude": "109.088896",
                            "latitude": "34.535065"
                        },
                        {
                            "area_id": 14874,
                            "city_id": 14743,
                            "province_id": 9,
                            "name": "鄠邑区",
                            "whole_name": "鄠邑区，西安市，陕西省",
                            "simple_py": "HYQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "029",
                            "area_code": "610118",
                            "longitude": "108.607385",
                            "latitude": "34.108668"
                        },
                        {
                            "area_id": 14871,
                            "city_id": 14743,
                            "province_id": 9,
                            "name": "临潼区",
                            "whole_name": "临潼区，西安市，陕西省",
                            "simple_py": "LTQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "029",
                            "area_code": "610115",
                            "longitude": "109.213986",
                            "latitude": "34.372065"
                        },
                        {
                            "area_id": 14875,
                            "city_id": 14743,
                            "province_id": 9,
                            "name": "蓝田县",
                            "whole_name": "蓝田县，西安市，陕西省",
                            "simple_py": "LTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "029",
                            "area_code": "610122",
                            "longitude": "109.317634",
                            "latitude": "34.156189"
                        },
                        {
                            "area_id": 14878,
                            "city_id": 14743,
                            "province_id": 9,
                            "name": "莲湖区",
                            "whole_name": "莲湖区，西安市，陕西省",
                            "simple_py": "LHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "029",
                            "area_code": "610104",
                            "longitude": "108.933194",
                            "latitude": "34.2656"
                        },
                        {
                            "area_id": 14876,
                            "city_id": 14743,
                            "province_id": 9,
                            "name": "未央区",
                            "whole_name": "未央区，西安市，陕西省",
                            "simple_py": "WYQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "029",
                            "area_code": "610112",
                            "longitude": "108.946022",
                            "latitude": "34.30823"
                        },
                        {
                            "area_id": 14881,
                            "city_id": 14743,
                            "province_id": 9,
                            "name": "新城区",
                            "whole_name": "新城区，西安市，陕西省",
                            "simple_py": "XCQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "029",
                            "area_code": "610102",
                            "longitude": "108.959903",
                            "latitude": "34.26927"
                        },
                        {
                            "area_id": 14872,
                            "city_id": 14743,
                            "province_id": 9,
                            "name": "阎良区",
                            "whole_name": "阎良区，西安市，陕西省",
                            "simple_py": "YLQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "029",
                            "area_code": "610114",
                            "longitude": "109.22802",
                            "latitude": "34.662141"
                        },
                        {
                            "area_id": 14879,
                            "city_id": 14743,
                            "province_id": 9,
                            "name": "雁塔区",
                            "whole_name": "雁塔区，西安市，陕西省",
                            "simple_py": "YTQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "029",
                            "area_code": "610113",
                            "longitude": "108.926593",
                            "latitude": "34.213389"
                        },
                        {
                            "area_id": 14880,
                            "city_id": 14743,
                            "province_id": 9,
                            "name": "周至县",
                            "whole_name": "周至县，西安市，陕西省",
                            "simple_py": "ZZX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "029",
                            "area_code": "610124",
                            "longitude": "108.216465",
                            "latitude": "34.161532"
                        }
                    ]
                },
                {
                    "city_id": 14748,
                    "province_id": 9,
                    "name": "咸阳市",
                    "whole_name": "咸阳市，陕西省",
                    "simple_py": "XYS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "X",
                    "city_code": "029",
                    "area_code": "610400",
                    "longitude": "108.705117",
                    "latitude": "34.333439",
                    "children": [
                        {
                            "area_id": 15617,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "彬县",
                            "whole_name": "彬县，咸阳市，陕西省",
                            "simple_py": "BX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "029",
                            "area_code": "610427",
                            "longitude": "108.083674",
                            "latitude": "35.034233"
                        },
                        {
                            "area_id": 15616,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "长武县",
                            "whole_name": "长武县，咸阳市，陕西省",
                            "simple_py": "CWX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "029",
                            "area_code": "610428",
                            "longitude": "107.795835",
                            "latitude": "35.206122"
                        },
                        {
                            "area_id": 15619,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "淳化县",
                            "whole_name": "淳化县，咸阳市，陕西省",
                            "simple_py": "CHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "029",
                            "area_code": "610430",
                            "longitude": "108.581173",
                            "latitude": "34.79797"
                        },
                        {
                            "area_id": 15628,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "泾阳县",
                            "whole_name": "泾阳县，咸阳市，陕西省",
                            "simple_py": "JYX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "029",
                            "area_code": "610423",
                            "longitude": "108.83784",
                            "latitude": "34.528493"
                        },
                        {
                            "area_id": 15621,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "礼泉县",
                            "whole_name": "礼泉县，咸阳市，陕西省",
                            "simple_py": "LQX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "029",
                            "area_code": "610425",
                            "longitude": "108.428317",
                            "latitude": "34.482583"
                        },
                        {
                            "area_id": 15620,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "乾县",
                            "whole_name": "乾县，咸阳市，陕西省",
                            "simple_py": "QX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "029",
                            "area_code": "610424",
                            "longitude": "108.247406",
                            "latitude": "34.527261"
                        },
                        {
                            "area_id": 15623,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "秦都区",
                            "whole_name": "秦都区，咸阳市，陕西省",
                            "simple_py": "QDQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "029",
                            "area_code": "610402",
                            "longitude": "108.698636",
                            "latitude": "34.329801"
                        },
                        {
                            "area_id": 15622,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "三原县",
                            "whole_name": "三原县，咸阳市，陕西省",
                            "simple_py": "SYX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "029",
                            "area_code": "610422",
                            "longitude": "108.943481",
                            "latitude": "34.613996"
                        },
                        {
                            "area_id": 15624,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "渭城区",
                            "whole_name": "渭城区，咸阳市，陕西省",
                            "simple_py": "WCQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "029",
                            "area_code": "610404",
                            "longitude": "108.730957",
                            "latitude": "34.336847"
                        },
                        {
                            "area_id": 15626,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "武功县",
                            "whole_name": "武功县，咸阳市，陕西省",
                            "simple_py": "WGX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "029",
                            "area_code": "610431",
                            "longitude": "108.212857",
                            "latitude": "34.259732"
                        },
                        {
                            "area_id": 15615,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "旬邑县",
                            "whole_name": "旬邑县，咸阳市，陕西省",
                            "simple_py": "XYX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "029",
                            "area_code": "610429",
                            "longitude": "108.337231",
                            "latitude": "35.112234"
                        },
                        {
                            "area_id": 15625,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "兴平市",
                            "whole_name": "兴平市，咸阳市，陕西省",
                            "simple_py": "XPS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "029",
                            "area_code": "610481",
                            "longitude": "108.488493",
                            "latitude": "34.297134"
                        },
                        {
                            "area_id": 15618,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "永寿县",
                            "whole_name": "永寿县，咸阳市，陕西省",
                            "simple_py": "YSX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "029",
                            "area_code": "610426",
                            "longitude": "108.143129",
                            "latitude": "34.692619"
                        },
                        {
                            "area_id": 15627,
                            "city_id": 14748,
                            "province_id": 9,
                            "name": "杨陵区",
                            "whole_name": "杨陵区，咸阳市，陕西省",
                            "simple_py": "YLQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "029",
                            "area_code": "610403",
                            "longitude": "108.086348",
                            "latitude": "34.27135"
                        }
                    ]
                },
                {
                    "city_id": 14746,
                    "province_id": 9,
                    "name": "榆林市",
                    "whole_name": "榆林市，陕西省",
                    "simple_py": "YLS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0912",
                    "area_code": "610800",
                    "longitude": "109.741193",
                    "latitude": "38.290162",
                    "children": [
                        {
                            "area_id": 15401,
                            "city_id": 14746,
                            "province_id": 9,
                            "name": "定边县",
                            "whole_name": "定边县，榆林市，陕西省",
                            "simple_py": "DBX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0912",
                            "area_code": "610825",
                            "longitude": "107.601284",
                            "latitude": "37.59523"
                        },
                        {
                            "area_id": 15392,
                            "city_id": 14746,
                            "province_id": 9,
                            "name": "府谷县",
                            "whole_name": "府谷县，榆林市，陕西省",
                            "simple_py": "FGX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0912",
                            "area_code": "610822",
                            "longitude": "111.069645",
                            "latitude": "39.029243"
                        },
                        {
                            "area_id": 15394,
                            "city_id": 14746,
                            "province_id": 9,
                            "name": "横山区",
                            "whole_name": "横山区，榆林市，陕西省",
                            "simple_py": "HSQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0912",
                            "area_code": "610803",
                            "longitude": "109.292596",
                            "latitude": "37.964048"
                        },
                        {
                            "area_id": 15395,
                            "city_id": 14746,
                            "province_id": 9,
                            "name": "佳县",
                            "whole_name": "佳县，榆林市，陕西省",
                            "simple_py": "JX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0912",
                            "area_code": "610828",
                            "longitude": "110.493367",
                            "latitude": "38.021597"
                        },
                        {
                            "area_id": 15396,
                            "city_id": 14746,
                            "province_id": 9,
                            "name": "靖边县",
                            "whole_name": "靖边县，榆林市，陕西省",
                            "simple_py": "JBX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0912",
                            "area_code": "610824",
                            "longitude": "108.80567",
                            "latitude": "37.596084"
                        },
                        {
                            "area_id": 15400,
                            "city_id": 14746,
                            "province_id": 9,
                            "name": "米脂县",
                            "whole_name": "米脂县，榆林市，陕西省",
                            "simple_py": "MZX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0912",
                            "area_code": "610827",
                            "longitude": "110.178683",
                            "latitude": "37.759081"
                        },
                        {
                            "area_id": 15397,
                            "city_id": 14746,
                            "province_id": 9,
                            "name": "清涧县",
                            "whole_name": "清涧县，榆林市，陕西省",
                            "simple_py": "QJX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0912",
                            "area_code": "610830",
                            "longitude": "110.12146",
                            "latitude": "37.087702"
                        },
                        {
                            "area_id": 15390,
                            "city_id": 14746,
                            "province_id": 9,
                            "name": "神木市",
                            "whole_name": "神木市，榆林市，陕西省",
                            "simple_py": "SMS",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0912",
                            "area_code": "610881",
                            "longitude": "110.497005",
                            "latitude": "38.835641"
                        },
                        {
                            "area_id": 15398,
                            "city_id": 14746,
                            "province_id": 9,
                            "name": "绥德县",
                            "whole_name": "绥德县，榆林市，陕西省",
                            "simple_py": "SDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0912",
                            "area_code": "610826",
                            "longitude": "110.265377",
                            "latitude": "37.507701"
                        },
                        {
                            "area_id": 15399,
                            "city_id": 14746,
                            "province_id": 9,
                            "name": "吴堡县",
                            "whole_name": "吴堡县，榆林市，陕西省",
                            "simple_py": "WBX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0912",
                            "area_code": "610829",
                            "longitude": "110.739315",
                            "latitude": "37.451925"
                        },
                        {
                            "area_id": 15391,
                            "city_id": 14746,
                            "province_id": 9,
                            "name": "榆阳区",
                            "whole_name": "榆阳区，榆林市，陕西省",
                            "simple_py": "YYQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0912",
                            "area_code": "610802",
                            "longitude": "109.74791",
                            "latitude": "38.299267"
                        },
                        {
                            "area_id": 15393,
                            "city_id": 14746,
                            "province_id": 9,
                            "name": "子洲县",
                            "whole_name": "子洲县，榆林市，陕西省",
                            "simple_py": "ZZX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0912",
                            "area_code": "610831",
                            "longitude": "110.03457",
                            "latitude": "37.611573"
                        }
                    ]
                },
                {
                    "city_id": 14750,
                    "province_id": 9,
                    "name": "延安市",
                    "whole_name": "延安市，陕西省",
                    "simple_py": "YAS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Y",
                    "city_code": "0911",
                    "area_code": "610600",
                    "longitude": "109.49081",
                    "latitude": "36.596537",
                    "children": [
                        {
                            "area_id": 15904,
                            "city_id": 14750,
                            "province_id": 9,
                            "name": "安塞区",
                            "whole_name": "安塞区，延安市，陕西省",
                            "simple_py": "ASQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0911",
                            "area_code": "610603",
                            "longitude": "109.325341",
                            "latitude": "36.86441"
                        },
                        {
                            "area_id": 15903,
                            "city_id": 14750,
                            "province_id": 9,
                            "name": "宝塔区",
                            "whole_name": "宝塔区，延安市，陕西省",
                            "simple_py": "BTQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0911",
                            "area_code": "610602",
                            "longitude": "109.49069",
                            "latitude": "36.596291"
                        },
                        {
                            "area_id": 15910,
                            "city_id": 14750,
                            "province_id": 9,
                            "name": "富县",
                            "whole_name": "富县，延安市，陕西省",
                            "simple_py": "FX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0911",
                            "area_code": "610628",
                            "longitude": "109.384136",
                            "latitude": "35.996495"
                        },
                        {
                            "area_id": 15908,
                            "city_id": 14750,
                            "province_id": 9,
                            "name": "甘泉县",
                            "whole_name": "甘泉县，延安市，陕西省",
                            "simple_py": "GQX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0911",
                            "area_code": "610627",
                            "longitude": "109.34961",
                            "latitude": "36.277729"
                        },
                        {
                            "area_id": 15911,
                            "city_id": 14750,
                            "province_id": 9,
                            "name": "黄陵县",
                            "whole_name": "黄陵县，延安市，陕西省",
                            "simple_py": "HLX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0911",
                            "area_code": "610632",
                            "longitude": "109.262469",
                            "latitude": "35.580165"
                        },
                        {
                            "area_id": 15912,
                            "city_id": 14750,
                            "province_id": 9,
                            "name": "黄龙县",
                            "whole_name": "黄龙县，延安市，陕西省",
                            "simple_py": "HLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0911",
                            "area_code": "610631",
                            "longitude": "109.83502",
                            "latitude": "35.583276"
                        },
                        {
                            "area_id": 15909,
                            "city_id": 14750,
                            "province_id": 9,
                            "name": "洛川县",
                            "whole_name": "洛川县，延安市，陕西省",
                            "simple_py": "LCX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0911",
                            "area_code": "610629",
                            "longitude": "109.435712",
                            "latitude": "35.762133"
                        },
                        {
                            "area_id": 15900,
                            "city_id": 14750,
                            "province_id": 9,
                            "name": "吴起县",
                            "whole_name": "吴起县，延安市，陕西省",
                            "simple_py": "WQX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0911",
                            "area_code": "610626",
                            "longitude": "108.176976",
                            "latitude": "36.924852"
                        },
                        {
                            "area_id": 15902,
                            "city_id": 14750,
                            "province_id": 9,
                            "name": "延长县",
                            "whole_name": "延长县，延安市，陕西省",
                            "simple_py": "YCX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0911",
                            "area_code": "610621",
                            "longitude": "110.012961",
                            "latitude": "36.578306"
                        },
                        {
                            "area_id": 15905,
                            "city_id": 14750,
                            "province_id": 9,
                            "name": "宜川县",
                            "whole_name": "宜川县，延安市，陕西省",
                            "simple_py": "YCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0911",
                            "area_code": "610630",
                            "longitude": "110.175537",
                            "latitude": "36.050391"
                        },
                        {
                            "area_id": 15906,
                            "city_id": 14750,
                            "province_id": 9,
                            "name": "延川县",
                            "whole_name": "延川县，延安市，陕西省",
                            "simple_py": "YCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0911",
                            "area_code": "610622",
                            "longitude": "110.190314",
                            "latitude": "36.882066"
                        },
                        {
                            "area_id": 15901,
                            "city_id": 14750,
                            "province_id": 9,
                            "name": "子长县",
                            "whole_name": "子长县，延安市，陕西省",
                            "simple_py": "ZCX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0911",
                            "area_code": "610623",
                            "longitude": "109.675968",
                            "latitude": "37.14207"
                        },
                        {
                            "area_id": 15907,
                            "city_id": 14750,
                            "province_id": 9,
                            "name": "志丹县",
                            "whole_name": "志丹县，延安市，陕西省",
                            "simple_py": "ZDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0911",
                            "area_code": "610625",
                            "longitude": "108.768898",
                            "latitude": "36.823031"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 10,
            "name": "上海市",
            "whole_name": "上海市",
            "simple_py": "SHS",
            "per_pin_yin": " ",
            "per_pin_yin2": "S",
            "city_code": "",
            "area_code": "310000",
            "longitude": "121.472644",
            "latitude": "31.231706",
            "children": [
                {
                    "city_id": 16170,
                    "province_id": 10,
                    "name": "上海城区",
                    "whole_name": "上海城区，上海市",
                    "simple_py": "SHCQ",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "",
                    "area_code": "310100",
                    "longitude": "121.472644",
                    "latitude": "31.231706",
                    "children": [
                        {
                            "area_id": 16175,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "宝山区",
                            "whole_name": "宝山区，上海城区，上海市",
                            "simple_py": "BSQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "021",
                            "area_code": "310113",
                            "longitude": "121.489934",
                            "latitude": "31.398896"
                        },
                        {
                            "area_id": 16171,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "崇明区",
                            "whole_name": "崇明区，上海城区，上海市",
                            "simple_py": "CMQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "021",
                            "area_code": "310151",
                            "longitude": "121.397516",
                            "latitude": "31.626946"
                        },
                        {
                            "area_id": 16184,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "长宁区",
                            "whole_name": "长宁区，上海城区，上海市",
                            "simple_py": "CNQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "021",
                            "area_code": "310105",
                            "longitude": "121.4222",
                            "latitude": "31.218123"
                        },
                        {
                            "area_id": 16172,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "奉贤区",
                            "whole_name": "奉贤区，上海城区，上海市",
                            "simple_py": "FXQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "021",
                            "area_code": "310120",
                            "longitude": "121.458472",
                            "latitude": "30.912345"
                        },
                        {
                            "area_id": 16176,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "黄浦区",
                            "whole_name": "黄浦区，上海城区，上海市",
                            "simple_py": "HPQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "021",
                            "area_code": "310101",
                            "longitude": "121.490317",
                            "latitude": "31.222771"
                        },
                        {
                            "area_id": 16185,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "虹口区",
                            "whole_name": "虹口区，上海城区，上海市",
                            "simple_py": "HKQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "021",
                            "area_code": "310109",
                            "longitude": "121.491832",
                            "latitude": "31.26097"
                        },
                        {
                            "area_id": 16174,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "金山区",
                            "whole_name": "金山区，上海城区，上海市",
                            "simple_py": "JSQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "021",
                            "area_code": "310116",
                            "longitude": "121.330736",
                            "latitude": "30.724697"
                        },
                        {
                            "area_id": 16177,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "嘉定区",
                            "whole_name": "嘉定区，上海城区，上海市",
                            "simple_py": "JDQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "021",
                            "area_code": "310114",
                            "longitude": "121.250333",
                            "latitude": "31.383524"
                        },
                        {
                            "area_id": 16186,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "静安区",
                            "whole_name": "静安区，上海城区，上海市",
                            "simple_py": "JAQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "021",
                            "area_code": "310106",
                            "longitude": "121.448224",
                            "latitude": "31.229003"
                        },
                        {
                            "area_id": 16180,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "闵行区",
                            "whole_name": "闵行区，上海城区，上海市",
                            "simple_py": "MXQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "021",
                            "area_code": "310112",
                            "longitude": "121.375972",
                            "latitude": "31.111658"
                        },
                        {
                            "area_id": 16173,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "浦东新区",
                            "whole_name": "浦东新区，上海城区，上海市",
                            "simple_py": "PDXQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "021",
                            "area_code": "310115",
                            "longitude": "121.567706",
                            "latitude": "31.245944"
                        },
                        {
                            "area_id": 16179,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "普陀区",
                            "whole_name": "普陀区，上海城区，上海市",
                            "simple_py": "PTQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "P",
                            "city_code": "021",
                            "area_code": "310107",
                            "longitude": "121.392499",
                            "latitude": "31.241701"
                        },
                        {
                            "area_id": 16182,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "青浦区",
                            "whole_name": "青浦区，上海城区，上海市",
                            "simple_py": "QPQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "021",
                            "area_code": "310118",
                            "longitude": "121.113021",
                            "latitude": "31.151209"
                        },
                        {
                            "area_id": 16183,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "松江区",
                            "whole_name": "松江区，上海城区，上海市",
                            "simple_py": "SJQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "021",
                            "area_code": "310117",
                            "longitude": "121.223543",
                            "latitude": "31.03047"
                        },
                        {
                            "area_id": 16178,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "徐汇区",
                            "whole_name": "徐汇区，上海城区，上海市",
                            "simple_py": "XHQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "021",
                            "area_code": "310104",
                            "longitude": "121.43752",
                            "latitude": "31.179973"
                        },
                        {
                            "area_id": 16181,
                            "city_id": 16170,
                            "province_id": 10,
                            "name": "杨浦区",
                            "whole_name": "杨浦区，上海城区，上海市",
                            "simple_py": "YPQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "021",
                            "area_code": "310110",
                            "longitude": "121.522797",
                            "latitude": "31.270755"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 26,
            "name": "山西省",
            "whole_name": "山西省",
            "simple_py": "SXS",
            "per_pin_yin": " ",
            "per_pin_yin2": "S",
            "city_code": "",
            "area_code": "140000",
            "longitude": "112.549248",
            "latitude": "37.857014",
            "children": [
                {
                    "city_id": 35031,
                    "province_id": 26,
                    "name": "长治市",
                    "whole_name": "长治市，山西省",
                    "simple_py": "CZS",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0355",
                    "area_code": "140400",
                    "longitude": "113.113556",
                    "latitude": "36.191112",
                    "children": [
                        {
                            "area_id": 35842,
                            "city_id": 35031,
                            "province_id": 26,
                            "name": "城区",
                            "whole_name": "城区，长治市，山西省",
                            "simple_py": "CQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0355",
                            "area_code": "140402",
                            "longitude": "113.114107",
                            "latitude": "36.187896"
                        },
                        {
                            "area_id": 35844,
                            "city_id": 35031,
                            "province_id": 26,
                            "name": "长治县",
                            "whole_name": "长治县，长治市，山西省",
                            "simple_py": "CZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0355",
                            "area_code": "140421",
                            "longitude": "113.056679",
                            "latitude": "36.052438"
                        },
                        {
                            "area_id": 35847,
                            "city_id": 35031,
                            "province_id": 26,
                            "name": "长子县",
                            "whole_name": "长子县，长治市，山西省",
                            "simple_py": "CZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0355",
                            "area_code": "140428",
                            "longitude": "112.884656",
                            "latitude": "36.119484"
                        },
                        {
                            "area_id": 35846,
                            "city_id": 35031,
                            "province_id": 26,
                            "name": "壶关县",
                            "whole_name": "壶关县，长治市，山西省",
                            "simple_py": "HGX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0355",
                            "area_code": "140427",
                            "longitude": "113.206138",
                            "latitude": "36.110938"
                        },
                        {
                            "area_id": 35841,
                            "city_id": 35031,
                            "province_id": 26,
                            "name": "郊区",
                            "whole_name": "郊区，长治市，山西省",
                            "simple_py": "JQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0355",
                            "area_code": "140411",
                            "longitude": "113.101211",
                            "latitude": "36.218388"
                        },
                        {
                            "area_id": 35840,
                            "city_id": 35031,
                            "province_id": 26,
                            "name": "黎城县",
                            "whole_name": "黎城县，长治市，山西省",
                            "simple_py": "LCX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0355",
                            "area_code": "140426",
                            "longitude": "113.387366",
                            "latitude": "36.502971"
                        },
                        {
                            "area_id": 35843,
                            "city_id": 35031,
                            "province_id": 26,
                            "name": "潞城市",
                            "whole_name": "潞城市，长治市，山西省",
                            "simple_py": "LCS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0355",
                            "area_code": "140481",
                            "longitude": "113.223245",
                            "latitude": "36.332233"
                        },
                        {
                            "area_id": 35851,
                            "city_id": 35031,
                            "province_id": 26,
                            "name": "平顺县",
                            "whole_name": "平顺县，长治市，山西省",
                            "simple_py": "PSX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0355",
                            "area_code": "140425",
                            "longitude": "113.438791",
                            "latitude": "36.200202"
                        },
                        {
                            "area_id": 35845,
                            "city_id": 35031,
                            "province_id": 26,
                            "name": "沁县",
                            "whole_name": "沁县，长治市，山西省",
                            "simple_py": "QX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0355",
                            "area_code": "140430",
                            "longitude": "112.70138",
                            "latitude": "36.757123"
                        },
                        {
                            "area_id": 35850,
                            "city_id": 35031,
                            "province_id": 26,
                            "name": "沁源县",
                            "whole_name": "沁源县，长治市，山西省",
                            "simple_py": "QYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0355",
                            "area_code": "140431",
                            "longitude": "112.340878",
                            "latitude": "36.500777"
                        },
                        {
                            "area_id": 35848,
                            "city_id": 35031,
                            "province_id": 26,
                            "name": "屯留县",
                            "whole_name": "屯留县，长治市，山西省",
                            "simple_py": "TLX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0355",
                            "area_code": "140424",
                            "longitude": "112.892741",
                            "latitude": "36.314072"
                        },
                        {
                            "area_id": 35849,
                            "city_id": 35031,
                            "province_id": 26,
                            "name": "武乡县",
                            "whole_name": "武乡县，长治市，山西省",
                            "simple_py": "WXX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0355",
                            "area_code": "140429",
                            "longitude": "112.8653",
                            "latitude": "36.834315"
                        },
                        {
                            "area_id": 35852,
                            "city_id": 35031,
                            "province_id": 26,
                            "name": "襄垣县",
                            "whole_name": "襄垣县，长治市，山西省",
                            "simple_py": "XYX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0355",
                            "area_code": "140423",
                            "longitude": "113.050094",
                            "latitude": "36.532854"
                        }
                    ]
                },
                {
                    "city_id": 35028,
                    "province_id": 26,
                    "name": "大同市",
                    "whole_name": "大同市，山西省",
                    "simple_py": "DTS",
                    "per_pin_yin": "D",
                    "per_pin_yin2": "D",
                    "city_code": "0352",
                    "area_code": "140200",
                    "longitude": "113.295259",
                    "latitude": "40.09031",
                    "children": [
                        {
                            "area_id": 35401,
                            "city_id": 35028,
                            "province_id": 26,
                            "name": "城区",
                            "whole_name": "城区，大同市，山西省",
                            "simple_py": "CQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0352",
                            "area_code": "140202",
                            "longitude": "113.301438",
                            "latitude": "40.090511"
                        },
                        {
                            "area_id": 35405,
                            "city_id": 35028,
                            "province_id": 26,
                            "name": "大同县",
                            "whole_name": "大同县，大同市，山西省",
                            "simple_py": "DTX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0352",
                            "area_code": "140227",
                            "longitude": "113.611306",
                            "latitude": "40.039345"
                        },
                        {
                            "area_id": 35395,
                            "city_id": 35028,
                            "province_id": 26,
                            "name": "广灵县",
                            "whole_name": "广灵县，大同市，山西省",
                            "simple_py": "GLX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0352",
                            "area_code": "140223",
                            "longitude": "114.279252",
                            "latitude": "39.763051"
                        },
                        {
                            "area_id": 35400,
                            "city_id": 35028,
                            "province_id": 26,
                            "name": "浑源县",
                            "whole_name": "浑源县，大同市，山西省",
                            "simple_py": "HYX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0352",
                            "area_code": "140225",
                            "longitude": "113.698091",
                            "latitude": "39.699099"
                        },
                        {
                            "area_id": 35404,
                            "city_id": 35028,
                            "province_id": 26,
                            "name": "矿区",
                            "whole_name": "矿区，大同市，山西省",
                            "simple_py": "KQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0352",
                            "area_code": "140203",
                            "longitude": "113.168656",
                            "latitude": "40.03626"
                        },
                        {
                            "area_id": 35398,
                            "city_id": 35028,
                            "province_id": 26,
                            "name": "灵丘县",
                            "whole_name": "灵丘县，大同市，山西省",
                            "simple_py": "LQX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0352",
                            "area_code": "140224",
                            "longitude": "114.23576",
                            "latitude": "39.438867"
                        },
                        {
                            "area_id": 35403,
                            "city_id": 35028,
                            "province_id": 26,
                            "name": "南郊区",
                            "whole_name": "南郊区，大同市，山西省",
                            "simple_py": "NJQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0352",
                            "area_code": "140211",
                            "longitude": "113.16892",
                            "latitude": "40.01802"
                        },
                        {
                            "area_id": 35399,
                            "city_id": 35028,
                            "province_id": 26,
                            "name": "天镇县",
                            "whole_name": "天镇县，大同市，山西省",
                            "simple_py": "TZX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0352",
                            "area_code": "140222",
                            "longitude": "114.09112",
                            "latitude": "40.421336"
                        },
                        {
                            "area_id": 35397,
                            "city_id": 35028,
                            "province_id": 26,
                            "name": "新荣区",
                            "whole_name": "新荣区，大同市，山西省",
                            "simple_py": "XRQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0352",
                            "area_code": "140212",
                            "longitude": "113.141044",
                            "latitude": "40.258269"
                        },
                        {
                            "area_id": 35396,
                            "city_id": 35028,
                            "province_id": 26,
                            "name": "阳高县",
                            "whole_name": "阳高县，大同市，山西省",
                            "simple_py": "YGX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0352",
                            "area_code": "140221",
                            "longitude": "113.749871",
                            "latitude": "40.364927"
                        },
                        {
                            "area_id": 35402,
                            "city_id": 35028,
                            "province_id": 26,
                            "name": "左云县",
                            "whole_name": "左云县，大同市，山西省",
                            "simple_py": "ZYX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0352",
                            "area_code": "140226",
                            "longitude": "112.70641",
                            "latitude": "40.012873"
                        }
                    ]
                },
                {
                    "city_id": 35029,
                    "province_id": 26,
                    "name": "晋城市",
                    "whole_name": "晋城市，山西省",
                    "simple_py": "JCS",
                    "per_pin_yin": "J",
                    "per_pin_yin2": "J",
                    "city_code": "0356",
                    "area_code": "140500",
                    "longitude": "112.851274",
                    "latitude": "35.497553",
                    "children": [
                        {
                            "area_id": 35539,
                            "city_id": 35029,
                            "province_id": 26,
                            "name": "城区",
                            "whole_name": "城区，晋城市，山西省",
                            "simple_py": "CQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0356",
                            "area_code": "140502",
                            "longitude": "112.853106",
                            "latitude": "35.496641"
                        },
                        {
                            "area_id": 35537,
                            "city_id": 35029,
                            "province_id": 26,
                            "name": "高平市",
                            "whole_name": "高平市，晋城市，山西省",
                            "simple_py": "GPS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0356",
                            "area_code": "140581",
                            "longitude": "112.930691",
                            "latitude": "35.791355"
                        },
                        {
                            "area_id": 35540,
                            "city_id": 35029,
                            "province_id": 26,
                            "name": "陵川县",
                            "whole_name": "陵川县，晋城市，山西省",
                            "simple_py": "LCX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0356",
                            "area_code": "140524",
                            "longitude": "113.278877",
                            "latitude": "35.775614"
                        },
                        {
                            "area_id": 35541,
                            "city_id": 35029,
                            "province_id": 26,
                            "name": "沁水县",
                            "whole_name": "沁水县，晋城市，山西省",
                            "simple_py": "QSX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0356",
                            "area_code": "140521",
                            "longitude": "112.187213",
                            "latitude": "35.689472"
                        },
                        {
                            "area_id": 35542,
                            "city_id": 35029,
                            "province_id": 26,
                            "name": "阳城县",
                            "whole_name": "阳城县，晋城市，山西省",
                            "simple_py": "YCX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0356",
                            "area_code": "140522",
                            "longitude": "112.422014",
                            "latitude": "35.482177"
                        },
                        {
                            "area_id": 35538,
                            "city_id": 35029,
                            "province_id": 26,
                            "name": "泽州县",
                            "whole_name": "泽州县，晋城市，山西省",
                            "simple_py": "ZZX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0356",
                            "area_code": "140525",
                            "longitude": "112.899137",
                            "latitude": "35.617221"
                        }
                    ]
                },
                {
                    "city_id": 35034,
                    "province_id": 26,
                    "name": "晋中市",
                    "whole_name": "晋中市，山西省",
                    "simple_py": "JZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "J",
                    "city_code": "0354",
                    "area_code": "140700",
                    "longitude": "112.736465",
                    "latitude": "37.696495",
                    "children": [
                        {
                            "area_id": 36269,
                            "city_id": 35034,
                            "province_id": 26,
                            "name": "和顺县",
                            "whole_name": "和顺县，晋中市，山西省",
                            "simple_py": "HSX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0354",
                            "area_code": "140723",
                            "longitude": "113.572919",
                            "latitude": "37.327027"
                        },
                        {
                            "area_id": 36271,
                            "city_id": 35034,
                            "province_id": 26,
                            "name": "介休市",
                            "whole_name": "介休市，晋中市，山西省",
                            "simple_py": "JXS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0354",
                            "area_code": "140781",
                            "longitude": "111.913857",
                            "latitude": "37.027616"
                        },
                        {
                            "area_id": 36273,
                            "city_id": 35034,
                            "province_id": 26,
                            "name": "灵石县",
                            "whole_name": "灵石县，晋中市，山西省",
                            "simple_py": "LSX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0354",
                            "area_code": "140729",
                            "longitude": "111.772759",
                            "latitude": "36.847469"
                        },
                        {
                            "area_id": 36267,
                            "city_id": 35034,
                            "province_id": 26,
                            "name": "平遥县",
                            "whole_name": "平遥县，晋中市，山西省",
                            "simple_py": "PYX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0354",
                            "area_code": "140728",
                            "longitude": "112.174059",
                            "latitude": "37.195474"
                        },
                        {
                            "area_id": 36277,
                            "city_id": 35034,
                            "province_id": 26,
                            "name": "祁县",
                            "whole_name": "祁县，晋中市，山西省",
                            "simple_py": "QX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0354",
                            "area_code": "140727",
                            "longitude": "112.330532",
                            "latitude": "37.358739"
                        },
                        {
                            "area_id": 36274,
                            "city_id": 35034,
                            "province_id": 26,
                            "name": "寿阳县",
                            "whole_name": "寿阳县，晋中市，山西省",
                            "simple_py": "SYX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0354",
                            "area_code": "140725",
                            "longitude": "113.177708",
                            "latitude": "37.891136"
                        },
                        {
                            "area_id": 36270,
                            "city_id": 35034,
                            "province_id": 26,
                            "name": "太谷县",
                            "whole_name": "太谷县，晋中市，山西省",
                            "simple_py": "TGX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0354",
                            "area_code": "140726",
                            "longitude": "112.554103",
                            "latitude": "37.424595"
                        },
                        {
                            "area_id": 36268,
                            "city_id": 35034,
                            "province_id": 26,
                            "name": "昔阳县",
                            "whole_name": "昔阳县，晋中市，山西省",
                            "simple_py": "XYX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0354",
                            "area_code": "140724",
                            "longitude": "113.706166",
                            "latitude": "37.60437"
                        },
                        {
                            "area_id": 36275,
                            "city_id": 35034,
                            "province_id": 26,
                            "name": "榆社县",
                            "whole_name": "榆社县，晋中市，山西省",
                            "simple_py": "YSX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0354",
                            "area_code": "140721",
                            "longitude": "112.973521",
                            "latitude": "37.069019"
                        },
                        {
                            "area_id": 36276,
                            "city_id": 35034,
                            "province_id": 26,
                            "name": "榆次区",
                            "whole_name": "榆次区，晋中市，山西省",
                            "simple_py": "YCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0354",
                            "area_code": "140702",
                            "longitude": "112.740056",
                            "latitude": "37.6976"
                        },
                        {
                            "area_id": 36272,
                            "city_id": 35034,
                            "province_id": 26,
                            "name": "左权县",
                            "whole_name": "左权县，晋中市，山西省",
                            "simple_py": "ZQX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0354",
                            "area_code": "140722",
                            "longitude": "113.377834",
                            "latitude": "37.079672"
                        }
                    ]
                },
                {
                    "city_id": 35027,
                    "province_id": 26,
                    "name": "临汾市",
                    "whole_name": "临汾市，山西省",
                    "simple_py": "LFS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0357",
                    "area_code": "141000",
                    "longitude": "111.517973",
                    "latitude": "36.08415",
                    "children": [
                        {
                            "area_id": 35211,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "安泽县",
                            "whole_name": "安泽县，临汾市，山西省",
                            "simple_py": "AZX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0357",
                            "area_code": "141026",
                            "longitude": "112.251372",
                            "latitude": "36.146032"
                        },
                        {
                            "area_id": 35210,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "大宁县",
                            "whole_name": "大宁县，临汾市，山西省",
                            "simple_py": "DNX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0357",
                            "area_code": "141030",
                            "longitude": "110.751283",
                            "latitude": "36.46383"
                        },
                        {
                            "area_id": 35212,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "汾西县",
                            "whole_name": "汾西县，临汾市，山西省",
                            "simple_py": "FXX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0357",
                            "area_code": "141034",
                            "longitude": "111.563021",
                            "latitude": "36.653368"
                        },
                        {
                            "area_id": 35216,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "浮山县",
                            "whole_name": "浮山县，临汾市，山西省",
                            "simple_py": "FSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0357",
                            "area_code": "141027",
                            "longitude": "111.850039",
                            "latitude": "35.971359"
                        },
                        {
                            "area_id": 35213,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "古县",
                            "whole_name": "古县，临汾市，山西省",
                            "simple_py": "GX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0357",
                            "area_code": "141025",
                            "longitude": "111.920207",
                            "latitude": "36.26855"
                        },
                        {
                            "area_id": 35209,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "洪洞县",
                            "whole_name": "洪洞县，临汾市，山西省",
                            "simple_py": "HDX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0357",
                            "area_code": "141024",
                            "longitude": "111.673692",
                            "latitude": "36.255742"
                        },
                        {
                            "area_id": 35218,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "霍州市",
                            "whole_name": "霍州市，临汾市，山西省",
                            "simple_py": "HZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0357",
                            "area_code": "141082",
                            "longitude": "111.723103",
                            "latitude": "36.57202"
                        },
                        {
                            "area_id": 35220,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "侯马市",
                            "whole_name": "侯马市，临汾市，山西省",
                            "simple_py": "HMS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0357",
                            "area_code": "141081",
                            "longitude": "111.371272",
                            "latitude": "35.620302"
                        },
                        {
                            "area_id": 35214,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "吉县",
                            "whole_name": "吉县，临汾市，山西省",
                            "simple_py": "JX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0357",
                            "area_code": "141028",
                            "longitude": "110.682853",
                            "latitude": "36.099355"
                        },
                        {
                            "area_id": 35207,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "蒲县",
                            "whole_name": "蒲县，临汾市，山西省",
                            "simple_py": "PX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0357",
                            "area_code": "141033",
                            "longitude": "111.09733",
                            "latitude": "36.411682"
                        },
                        {
                            "area_id": 35215,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "曲沃县",
                            "whole_name": "曲沃县，临汾市，山西省",
                            "simple_py": "QWX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0357",
                            "area_code": "141021",
                            "longitude": "111.475529",
                            "latitude": "35.641387"
                        },
                        {
                            "area_id": 35206,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "隰县",
                            "whole_name": "隰县，临汾市，山西省",
                            "simple_py": "XX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0357",
                            "area_code": "141031",
                            "longitude": "110.935809",
                            "latitude": "36.692675"
                        },
                        {
                            "area_id": 35217,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "襄汾县",
                            "whole_name": "襄汾县，临汾市，山西省",
                            "simple_py": "XFX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0357",
                            "area_code": "141023",
                            "longitude": "111.442932",
                            "latitude": "35.876139"
                        },
                        {
                            "area_id": 35221,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "乡宁县",
                            "whole_name": "乡宁县，临汾市，山西省",
                            "simple_py": "XNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0357",
                            "area_code": "141029",
                            "longitude": "110.857365",
                            "latitude": "35.975402"
                        },
                        {
                            "area_id": 35208,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "尧都区",
                            "whole_name": "尧都区，临汾市，山西省",
                            "simple_py": "YDQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0357",
                            "area_code": "141002",
                            "longitude": "111.522945",
                            "latitude": "36.080366"
                        },
                        {
                            "area_id": 35219,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "翼城县",
                            "whole_name": "翼城县，临汾市，山西省",
                            "simple_py": "YCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0357",
                            "area_code": "141022",
                            "longitude": "111.713508",
                            "latitude": "35.738621"
                        },
                        {
                            "area_id": 35222,
                            "city_id": 35027,
                            "province_id": 26,
                            "name": "永和县",
                            "whole_name": "永和县，临汾市，山西省",
                            "simple_py": "YHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0357",
                            "area_code": "141032",
                            "longitude": "110.631276",
                            "latitude": "36.760614"
                        }
                    ]
                },
                {
                    "city_id": 35035,
                    "province_id": 26,
                    "name": "吕梁市",
                    "whole_name": "吕梁市，山西省",
                    "simple_py": "LLS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "L",
                    "city_code": "0358",
                    "area_code": "141100",
                    "longitude": "111.134335",
                    "latitude": "37.524366",
                    "children": [
                        {
                            "area_id": 36426,
                            "city_id": 35035,
                            "province_id": 26,
                            "name": "汾阳市",
                            "whole_name": "汾阳市，吕梁市，山西省",
                            "simple_py": "FYS",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0358",
                            "area_code": "141182",
                            "longitude": "111.785273",
                            "latitude": "37.267742"
                        },
                        {
                            "area_id": 36431,
                            "city_id": 35035,
                            "province_id": 26,
                            "name": "方山县",
                            "whole_name": "方山县，吕梁市，山西省",
                            "simple_py": "FSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0358",
                            "area_code": "141128",
                            "longitude": "111.238885",
                            "latitude": "37.892632"
                        },
                        {
                            "area_id": 36433,
                            "city_id": 35035,
                            "province_id": 26,
                            "name": "交口县",
                            "whole_name": "交口县，吕梁市，山西省",
                            "simple_py": "JKX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0358",
                            "area_code": "141130",
                            "longitude": "111.183188",
                            "latitude": "36.983068"
                        },
                        {
                            "area_id": 36436,
                            "city_id": 35035,
                            "province_id": 26,
                            "name": "交城县",
                            "whole_name": "交城县，吕梁市，山西省",
                            "simple_py": "JCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0358",
                            "area_code": "141122",
                            "longitude": "112.159154",
                            "latitude": "37.555155"
                        },
                        {
                            "area_id": 36427,
                            "city_id": 35035,
                            "province_id": 26,
                            "name": "离石区",
                            "whole_name": "离石区，吕梁市，山西省",
                            "simple_py": "LSQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0358",
                            "area_code": "141102",
                            "longitude": "111.134462",
                            "latitude": "37.524037"
                        },
                        {
                            "area_id": 36429,
                            "city_id": 35035,
                            "province_id": 26,
                            "name": "柳林县",
                            "whole_name": "柳林县，吕梁市，山西省",
                            "simple_py": "LLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0358",
                            "area_code": "141125",
                            "longitude": "110.89613",
                            "latitude": "37.431664"
                        },
                        {
                            "area_id": 36430,
                            "city_id": 35035,
                            "province_id": 26,
                            "name": "临县",
                            "whole_name": "临县，吕梁市，山西省",
                            "simple_py": "LX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0358",
                            "area_code": "141124",
                            "longitude": "110.995963",
                            "latitude": "37.960806"
                        },
                        {
                            "area_id": 36432,
                            "city_id": 35035,
                            "province_id": 26,
                            "name": "岚县",
                            "whole_name": "岚县，吕梁市，山西省",
                            "simple_py": "LX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0358",
                            "area_code": "141127",
                            "longitude": "111.671555",
                            "latitude": "38.278654"
                        },
                        {
                            "area_id": 36435,
                            "city_id": 35035,
                            "province_id": 26,
                            "name": "石楼县",
                            "whole_name": "石楼县，吕梁市，山西省",
                            "simple_py": "SLX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0358",
                            "area_code": "141126",
                            "longitude": "110.837119",
                            "latitude": "36.999426"
                        },
                        {
                            "area_id": 36438,
                            "city_id": 35035,
                            "province_id": 26,
                            "name": "文水县",
                            "whole_name": "文水县，吕梁市，山西省",
                            "simple_py": "WSX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0358",
                            "area_code": "141121",
                            "longitude": "112.032595",
                            "latitude": "37.436314"
                        },
                        {
                            "area_id": 36434,
                            "city_id": 35035,
                            "province_id": 26,
                            "name": "孝义市",
                            "whole_name": "孝义市，吕梁市，山西省",
                            "simple_py": "XYS",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0358",
                            "area_code": "141181",
                            "longitude": "111.781568",
                            "latitude": "37.144474"
                        },
                        {
                            "area_id": 36437,
                            "city_id": 35035,
                            "province_id": 26,
                            "name": "兴县",
                            "whole_name": "兴县，吕梁市，山西省",
                            "simple_py": "XX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0358",
                            "area_code": "141123",
                            "longitude": "111.124816",
                            "latitude": "38.464136"
                        },
                        {
                            "area_id": 36428,
                            "city_id": 35035,
                            "province_id": 26,
                            "name": "中阳县",
                            "whole_name": "中阳县，吕梁市，山西省",
                            "simple_py": "ZYX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0358",
                            "area_code": "141129",
                            "longitude": "111.193319",
                            "latitude": "37.342054"
                        }
                    ]
                },
                {
                    "city_id": 35033,
                    "province_id": 26,
                    "name": "朔州市",
                    "whole_name": "朔州市，山西省",
                    "simple_py": "SZS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0349",
                    "area_code": "140600",
                    "longitude": "112.433387",
                    "latitude": "39.331261",
                    "children": [
                        {
                            "area_id": 36186,
                            "city_id": 35033,
                            "province_id": 26,
                            "name": "怀仁县",
                            "whole_name": "怀仁县，朔州市，山西省",
                            "simple_py": "HRX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0349",
                            "area_code": "140624",
                            "longitude": "113.100512",
                            "latitude": "39.82079"
                        },
                        {
                            "area_id": 36182,
                            "city_id": 35033,
                            "province_id": 26,
                            "name": "平鲁区",
                            "whole_name": "平鲁区，朔州市，山西省",
                            "simple_py": "PLQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0349",
                            "area_code": "140603",
                            "longitude": "112.295227",
                            "latitude": "39.515603"
                        },
                        {
                            "area_id": 36184,
                            "city_id": 35033,
                            "province_id": 26,
                            "name": "山阴县",
                            "whole_name": "山阴县，朔州市，山西省",
                            "simple_py": "SYX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0349",
                            "area_code": "140621",
                            "longitude": "112.816396",
                            "latitude": "39.52677"
                        },
                        {
                            "area_id": 36185,
                            "city_id": 35033,
                            "province_id": 26,
                            "name": "朔城区",
                            "whole_name": "朔城区，朔州市，山西省",
                            "simple_py": "SCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0349",
                            "area_code": "140602",
                            "longitude": "112.428676",
                            "latitude": "39.324525"
                        },
                        {
                            "area_id": 36183,
                            "city_id": 35033,
                            "province_id": 26,
                            "name": "右玉县",
                            "whole_name": "右玉县，朔州市，山西省",
                            "simple_py": "YYX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0349",
                            "area_code": "140623",
                            "longitude": "112.465588",
                            "latitude": "39.988812"
                        },
                        {
                            "area_id": 36187,
                            "city_id": 35033,
                            "province_id": 26,
                            "name": "应县",
                            "whole_name": "应县，朔州市，山西省",
                            "simple_py": "YX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0349",
                            "area_code": "140622",
                            "longitude": "113.187505",
                            "latitude": "39.559187"
                        }
                    ]
                },
                {
                    "city_id": 35026,
                    "province_id": 26,
                    "name": "太原市",
                    "whole_name": "太原市，山西省",
                    "simple_py": "TYS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0351",
                    "area_code": "140100",
                    "longitude": "112.549248",
                    "latitude": "37.857014",
                    "children": [
                        {
                            "area_id": 35089,
                            "city_id": 35026,
                            "province_id": 26,
                            "name": "古交市",
                            "whole_name": "古交市，太原市，山西省",
                            "simple_py": "GJS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0351",
                            "area_code": "140181",
                            "longitude": "112.174353",
                            "latitude": "37.908534"
                        },
                        {
                            "area_id": 35085,
                            "city_id": 35026,
                            "province_id": 26,
                            "name": "尖草坪区",
                            "whole_name": "尖草坪区，太原市，山西省",
                            "simple_py": "JCPQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0351",
                            "area_code": "140108",
                            "longitude": "112.487122",
                            "latitude": "37.939893"
                        },
                        {
                            "area_id": 35087,
                            "city_id": 35026,
                            "province_id": 26,
                            "name": "晋源区",
                            "whole_name": "晋源区，太原市，山西省",
                            "simple_py": "JYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0351",
                            "area_code": "140110",
                            "longitude": "112.477849",
                            "latitude": "37.715619"
                        },
                        {
                            "area_id": 35086,
                            "city_id": 35026,
                            "province_id": 26,
                            "name": "娄烦县",
                            "whole_name": "娄烦县，太原市，山西省",
                            "simple_py": "LFX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0351",
                            "area_code": "140123",
                            "longitude": "111.793798",
                            "latitude": "38.066035"
                        },
                        {
                            "area_id": 35090,
                            "city_id": 35026,
                            "province_id": 26,
                            "name": "清徐县",
                            "whole_name": "清徐县，太原市，山西省",
                            "simple_py": "QXX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0351",
                            "area_code": "140121",
                            "longitude": "112.357961",
                            "latitude": "37.60729"
                        },
                        {
                            "area_id": 35084,
                            "city_id": 35026,
                            "province_id": 26,
                            "name": "万柏林区",
                            "whole_name": "万柏林区，太原市，山西省",
                            "simple_py": "WBLQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0351",
                            "area_code": "140109",
                            "longitude": "112.522258",
                            "latitude": "37.862653"
                        },
                        {
                            "area_id": 35091,
                            "city_id": 35026,
                            "province_id": 26,
                            "name": "杏花岭区",
                            "whole_name": "杏花岭区，太原市，山西省",
                            "simple_py": "XHLQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0351",
                            "area_code": "140107",
                            "longitude": "112.560743",
                            "latitude": "37.879291"
                        },
                        {
                            "area_id": 35092,
                            "city_id": 35026,
                            "province_id": 26,
                            "name": "小店区",
                            "whole_name": "小店区，太原市，山西省",
                            "simple_py": "XDQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0351",
                            "area_code": "140105",
                            "longitude": "112.564273",
                            "latitude": "37.817974"
                        },
                        {
                            "area_id": 35088,
                            "city_id": 35026,
                            "province_id": 26,
                            "name": "阳曲县",
                            "whole_name": "阳曲县，太原市，山西省",
                            "simple_py": "YQX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0351",
                            "area_code": "140122",
                            "longitude": "112.673818",
                            "latitude": "38.058797"
                        },
                        {
                            "area_id": 35093,
                            "city_id": 35026,
                            "province_id": 26,
                            "name": "迎泽区",
                            "whole_name": "迎泽区，太原市，山西省",
                            "simple_py": "YZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0351",
                            "area_code": "140106",
                            "longitude": "112.558851",
                            "latitude": "37.855804"
                        }
                    ]
                },
                {
                    "city_id": 35030,
                    "province_id": 26,
                    "name": "忻州市",
                    "whole_name": "忻州市，山西省",
                    "simple_py": "XZS",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "0350",
                    "area_code": "140900",
                    "longitude": "112.733538",
                    "latitude": "38.41769",
                    "children": [
                        {
                            "area_id": 35642,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "保德县",
                            "whole_name": "保德县，忻州市，山西省",
                            "simple_py": "BDX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0350",
                            "area_code": "140931",
                            "longitude": "111.085688",
                            "latitude": "39.022576"
                        },
                        {
                            "area_id": 35631,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "代县",
                            "whole_name": "代县，忻州市，山西省",
                            "simple_py": "DX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0350",
                            "area_code": "140923",
                            "longitude": "112.962519",
                            "latitude": "39.065138"
                        },
                        {
                            "area_id": 35640,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "定襄县",
                            "whole_name": "定襄县，忻州市，山西省",
                            "simple_py": "DXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0350",
                            "area_code": "140921",
                            "longitude": "112.963231",
                            "latitude": "38.484948"
                        },
                        {
                            "area_id": 35643,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "繁峙县",
                            "whole_name": "繁峙县，忻州市，山西省",
                            "simple_py": "FZX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0350",
                            "area_code": "140924",
                            "longitude": "113.267707",
                            "latitude": "39.188104"
                        },
                        {
                            "area_id": 35634,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "河曲县",
                            "whole_name": "河曲县，忻州市，山西省",
                            "simple_py": "HQX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0350",
                            "area_code": "140930",
                            "longitude": "111.146609",
                            "latitude": "39.381895"
                        },
                        {
                            "area_id": 35639,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "静乐县",
                            "whole_name": "静乐县，忻州市，山西省",
                            "simple_py": "JLX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0350",
                            "area_code": "140926",
                            "longitude": "111.940231",
                            "latitude": "38.355947"
                        },
                        {
                            "area_id": 35638,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "岢岚县",
                            "whole_name": "岢岚县，忻州市，山西省",
                            "simple_py": "KLX",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0350",
                            "area_code": "140929",
                            "longitude": "111.56981",
                            "latitude": "38.705625"
                        },
                        {
                            "area_id": 35632,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "宁武县",
                            "whole_name": "宁武县，忻州市，山西省",
                            "simple_py": "NWX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0350",
                            "area_code": "140925",
                            "longitude": "112.307936",
                            "latitude": "39.001718"
                        },
                        {
                            "area_id": 35635,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "偏关县",
                            "whole_name": "偏关县，忻州市，山西省",
                            "simple_py": "PGX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0350",
                            "area_code": "140932",
                            "longitude": "111.500477",
                            "latitude": "39.442153"
                        },
                        {
                            "area_id": 35641,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "神池县",
                            "whole_name": "神池县，忻州市，山西省",
                            "simple_py": "SCX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0350",
                            "area_code": "140927",
                            "longitude": "112.200438",
                            "latitude": "39.088467"
                        },
                        {
                            "area_id": 35630,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "五寨县",
                            "whole_name": "五寨县，忻州市，山西省",
                            "simple_py": "WZX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0350",
                            "area_code": "140928",
                            "longitude": "111.841015",
                            "latitude": "38.912761"
                        },
                        {
                            "area_id": 35637,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "五台县",
                            "whole_name": "五台县，忻州市，山西省",
                            "simple_py": "WTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0350",
                            "area_code": "140922",
                            "longitude": "113.259012",
                            "latitude": "38.725711"
                        },
                        {
                            "area_id": 35633,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "忻府区",
                            "whole_name": "忻府区，忻州市，山西省",
                            "simple_py": "XFQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0350",
                            "area_code": "140902",
                            "longitude": "112.734112",
                            "latitude": "38.417743"
                        },
                        {
                            "area_id": 35636,
                            "city_id": 35030,
                            "province_id": 26,
                            "name": "原平市",
                            "whole_name": "原平市，忻州市，山西省",
                            "simple_py": "YPS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0350",
                            "area_code": "140981",
                            "longitude": "112.713132",
                            "latitude": "38.729186"
                        }
                    ]
                },
                {
                    "city_id": 35025,
                    "province_id": 26,
                    "name": "阳泉市",
                    "whole_name": "阳泉市，山西省",
                    "simple_py": "YQS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0353",
                    "area_code": "140300",
                    "longitude": "113.583285",
                    "latitude": "37.861188",
                    "children": [
                        {
                            "area_id": 35040,
                            "city_id": 35025,
                            "province_id": 26,
                            "name": "城区",
                            "whole_name": "城区，阳泉市，山西省",
                            "simple_py": "CQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0353",
                            "area_code": "140302",
                            "longitude": "113.586513",
                            "latitude": "37.860938"
                        },
                        {
                            "area_id": 35038,
                            "city_id": 35025,
                            "province_id": 26,
                            "name": "郊区",
                            "whole_name": "郊区，阳泉市，山西省",
                            "simple_py": "JQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0353",
                            "area_code": "140311",
                            "longitude": "113.58664",
                            "latitude": "37.94096"
                        },
                        {
                            "area_id": 35039,
                            "city_id": 35025,
                            "province_id": 26,
                            "name": "矿区",
                            "whole_name": "矿区，阳泉市，山西省",
                            "simple_py": "KQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0353",
                            "area_code": "140303",
                            "longitude": "113.559066",
                            "latitude": "37.870085"
                        },
                        {
                            "area_id": 35036,
                            "city_id": 35025,
                            "province_id": 26,
                            "name": "平定县",
                            "whole_name": "平定县，阳泉市，山西省",
                            "simple_py": "PDX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0353",
                            "area_code": "140321",
                            "longitude": "113.631049",
                            "latitude": "37.800289"
                        },
                        {
                            "area_id": 35037,
                            "city_id": 35025,
                            "province_id": 26,
                            "name": "盂县",
                            "whole_name": "盂县，阳泉市，山西省",
                            "simple_py": "YX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0353",
                            "area_code": "140322",
                            "longitude": "113.41223",
                            "latitude": "38.086131"
                        }
                    ]
                },
                {
                    "city_id": 35032,
                    "province_id": 26,
                    "name": "运城市",
                    "whole_name": "运城市，山西省",
                    "simple_py": "YCS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Y",
                    "city_code": "0359",
                    "area_code": "140800",
                    "longitude": "111.003957",
                    "latitude": "35.022778",
                    "children": [
                        {
                            "area_id": 36020,
                            "city_id": 35032,
                            "province_id": 26,
                            "name": "河津市",
                            "whole_name": "河津市，运城市，山西省",
                            "simple_py": "HJS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0359",
                            "area_code": "140882",
                            "longitude": "110.710268",
                            "latitude": "35.59715"
                        },
                        {
                            "area_id": 36016,
                            "city_id": 35032,
                            "province_id": 26,
                            "name": "绛县",
                            "whole_name": "绛县，运城市，山西省",
                            "simple_py": "JX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0359",
                            "area_code": "140826",
                            "longitude": "111.576182",
                            "latitude": "35.49045"
                        },
                        {
                            "area_id": 36019,
                            "city_id": 35032,
                            "province_id": 26,
                            "name": "稷山县",
                            "whole_name": "稷山县，运城市，山西省",
                            "simple_py": "JSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0359",
                            "area_code": "140824",
                            "longitude": "110.978996",
                            "latitude": "35.600412"
                        },
                        {
                            "area_id": 36009,
                            "city_id": 35032,
                            "province_id": 26,
                            "name": "临猗县",
                            "whole_name": "临猗县，运城市，山西省",
                            "simple_py": "LYX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0359",
                            "area_code": "140821",
                            "longitude": "110.77493",
                            "latitude": "35.141883"
                        },
                        {
                            "area_id": 36012,
                            "city_id": 35032,
                            "province_id": 26,
                            "name": "平陆县",
                            "whole_name": "平陆县，运城市，山西省",
                            "simple_py": "PLX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0359",
                            "area_code": "140829",
                            "longitude": "111.212377",
                            "latitude": "34.837256"
                        },
                        {
                            "area_id": 36015,
                            "city_id": 35032,
                            "province_id": 26,
                            "name": "芮城县",
                            "whole_name": "芮城县，运城市，山西省",
                            "simple_py": "RCX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0359",
                            "area_code": "140830",
                            "longitude": "110.69114",
                            "latitude": "34.694769"
                        },
                        {
                            "area_id": 36011,
                            "city_id": 35032,
                            "province_id": 26,
                            "name": "闻喜县",
                            "whole_name": "闻喜县，运城市，山西省",
                            "simple_py": "WXX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0359",
                            "area_code": "140823",
                            "longitude": "111.220306",
                            "latitude": "35.353839"
                        },
                        {
                            "area_id": 36014,
                            "city_id": 35032,
                            "province_id": 26,
                            "name": "万荣县",
                            "whole_name": "万荣县，运城市，山西省",
                            "simple_py": "WRX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0359",
                            "area_code": "140822",
                            "longitude": "110.843561",
                            "latitude": "35.417042"
                        },
                        {
                            "area_id": 36008,
                            "city_id": 35032,
                            "province_id": 26,
                            "name": "夏县",
                            "whole_name": "夏县，运城市，山西省",
                            "simple_py": "XX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0359",
                            "area_code": "140828",
                            "longitude": "111.223174",
                            "latitude": "35.140441"
                        },
                        {
                            "area_id": 36018,
                            "city_id": 35032,
                            "province_id": 26,
                            "name": "新绛县",
                            "whole_name": "新绛县，运城市，山西省",
                            "simple_py": "XJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0359",
                            "area_code": "140825",
                            "longitude": "111.225205",
                            "latitude": "35.613697"
                        },
                        {
                            "area_id": 36010,
                            "city_id": 35032,
                            "province_id": 26,
                            "name": "盐湖区",
                            "whole_name": "盐湖区，运城市，山西省",
                            "simple_py": "YHQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0359",
                            "area_code": "140802",
                            "longitude": "111.000627",
                            "latitude": "35.025643"
                        },
                        {
                            "area_id": 36013,
                            "city_id": 35032,
                            "province_id": 26,
                            "name": "永济市",
                            "whole_name": "永济市，运城市，山西省",
                            "simple_py": "YJS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0359",
                            "area_code": "140881",
                            "longitude": "110.447984",
                            "latitude": "34.865125"
                        },
                        {
                            "area_id": 36017,
                            "city_id": 35032,
                            "province_id": 26,
                            "name": "垣曲县",
                            "whole_name": "垣曲县，运城市，山西省",
                            "simple_py": "YQX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0359",
                            "area_code": "140827",
                            "longitude": "111.67099",
                            "latitude": "35.298293"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 30,
            "name": "四川省",
            "whole_name": "四川省",
            "simple_py": "SCS",
            "per_pin_yin": " ",
            "per_pin_yin2": "S",
            "city_code": "",
            "area_code": "510000",
            "longitude": "104.065735",
            "latitude": "30.659462",
            "children": [
                {
                    "city_id": 38148,
                    "province_id": 30,
                    "name": "阿坝藏族羌族自治州",
                    "whole_name": "阿坝藏族羌族自治州，四川省",
                    "simple_py": "ABCZQZZZZ",
                    "per_pin_yin": "A",
                    "per_pin_yin2": "A",
                    "city_code": "0837",
                    "area_code": "513200",
                    "longitude": "102.221374",
                    "latitude": "31.899792",
                    "children": [
                        {
                            "area_id": 42149,
                            "city_id": 38148,
                            "province_id": 30,
                            "name": "阿坝县",
                            "whole_name": "阿坝县，阿坝藏族羌族自治州，四川省",
                            "simple_py": "ABX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0837",
                            "area_code": "513231",
                            "longitude": "101.700985",
                            "latitude": "32.904223"
                        },
                        {
                            "area_id": 42151,
                            "city_id": 38148,
                            "province_id": 30,
                            "name": "红原县",
                            "whole_name": "红原县，阿坝藏族羌族自治州，四川省",
                            "simple_py": "HYX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0837",
                            "area_code": "513233",
                            "longitude": "102.544906",
                            "latitude": "32.793902"
                        },
                        {
                            "area_id": 42153,
                            "city_id": 38148,
                            "province_id": 30,
                            "name": "黑水县",
                            "whole_name": "黑水县，阿坝藏族羌族自治州，四川省",
                            "simple_py": "HSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0837",
                            "area_code": "513228",
                            "longitude": "102.990805",
                            "latitude": "32.061721"
                        },
                        {
                            "area_id": 42150,
                            "city_id": 38148,
                            "province_id": 30,
                            "name": "九寨沟县",
                            "whole_name": "九寨沟县，阿坝藏族羌族自治州，四川省",
                            "simple_py": "JZGS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0837",
                            "area_code": "513225",
                            "longitude": "104.236344",
                            "latitude": "33.262097"
                        },
                        {
                            "area_id": 42157,
                            "city_id": 38148,
                            "province_id": 30,
                            "name": "金川县",
                            "whole_name": "金川县，阿坝藏族羌族自治州，四川省",
                            "simple_py": "JCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0837",
                            "area_code": "513226",
                            "longitude": "102.064647",
                            "latitude": "31.476356"
                        },
                        {
                            "area_id": 42154,
                            "city_id": 38148,
                            "province_id": 30,
                            "name": "理县",
                            "whole_name": "理县，阿坝藏族羌族自治州，四川省",
                            "simple_py": "LX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0837",
                            "area_code": "513222",
                            "longitude": "103.165486",
                            "latitude": "31.436764"
                        },
                        {
                            "area_id": 42155,
                            "city_id": 38148,
                            "province_id": 30,
                            "name": "马尔康市",
                            "whole_name": "马尔康市，阿坝藏族羌族自治州，四川省",
                            "simple_py": "MEKS",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0837",
                            "area_code": "513201",
                            "longitude": "102.221187",
                            "latitude": "31.899761"
                        },
                        {
                            "area_id": 42158,
                            "city_id": 38148,
                            "province_id": 30,
                            "name": "茂县",
                            "whole_name": "茂县，阿坝藏族羌族自治州，四川省",
                            "simple_py": "MX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0837",
                            "area_code": "513223",
                            "longitude": "103.850684",
                            "latitude": "31.680407"
                        },
                        {
                            "area_id": 42152,
                            "city_id": 38148,
                            "province_id": 30,
                            "name": "若尔盖县",
                            "whole_name": "若尔盖县，阿坝藏族羌族自治州，四川省",
                            "simple_py": "REGX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0837",
                            "area_code": "513232",
                            "longitude": "102.963726",
                            "latitude": "33.575934"
                        },
                        {
                            "area_id": 42160,
                            "city_id": 38148,
                            "province_id": 30,
                            "name": "壤塘县",
                            "whole_name": "壤塘县，阿坝藏族羌族自治州，四川省",
                            "simple_py": "RTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "R",
                            "city_code": "0837",
                            "area_code": "513230",
                            "longitude": "100.979136",
                            "latitude": "32.264887"
                        },
                        {
                            "area_id": 42159,
                            "city_id": 38148,
                            "province_id": 30,
                            "name": "松潘县",
                            "whole_name": "松潘县，阿坝藏族羌族自治州，四川省",
                            "simple_py": "SPX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0837",
                            "area_code": "513224",
                            "longitude": "103.599177",
                            "latitude": "32.63838"
                        },
                        {
                            "area_id": 42156,
                            "city_id": 38148,
                            "province_id": 30,
                            "name": "汶川县",
                            "whole_name": "汶川县，阿坝藏族羌族自治州，四川省",
                            "simple_py": "WCX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0837",
                            "area_code": "513221",
                            "longitude": "103.580675",
                            "latitude": "31.47463"
                        },
                        {
                            "area_id": 42161,
                            "city_id": 38148,
                            "province_id": 30,
                            "name": "小金县",
                            "whole_name": "小金县，阿坝藏族羌族自治州，四川省",
                            "simple_py": "XJX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0837",
                            "area_code": "513227",
                            "longitude": "102.363193",
                            "latitude": "30.999016"
                        }
                    ]
                },
                {
                    "city_id": 38135,
                    "province_id": 30,
                    "name": "巴中市",
                    "whole_name": "巴中市，四川省",
                    "simple_py": "BZS",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "0827",
                    "area_code": "511900",
                    "longitude": "106.753669",
                    "latitude": "31.858809",
                    "children": [
                        {
                            "area_id": 39566,
                            "city_id": 38135,
                            "province_id": 30,
                            "name": "巴州区",
                            "whole_name": "巴州区，巴中市，四川省",
                            "simple_py": "BZQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0827",
                            "area_code": "511902",
                            "longitude": "106.753671",
                            "latitude": "31.858366"
                        },
                        {
                            "area_id": 39567,
                            "city_id": 38135,
                            "province_id": 30,
                            "name": "恩阳区",
                            "whole_name": "恩阳区，巴中市，四川省",
                            "simple_py": "EYQ",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0827",
                            "area_code": "511903",
                            "longitude": "106.486515",
                            "latitude": "31.816336"
                        },
                        {
                            "area_id": 39563,
                            "city_id": 38135,
                            "province_id": 30,
                            "name": "南江县",
                            "whole_name": "南江县，巴中市，四川省",
                            "simple_py": "NJX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0827",
                            "area_code": "511922",
                            "longitude": "106.843418",
                            "latitude": "32.353164"
                        },
                        {
                            "area_id": 39565,
                            "city_id": 38135,
                            "province_id": 30,
                            "name": "平昌县",
                            "whole_name": "平昌县，巴中市，四川省",
                            "simple_py": "PCX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0827",
                            "area_code": "511923",
                            "longitude": "107.101937",
                            "latitude": "31.562814"
                        },
                        {
                            "area_id": 39564,
                            "city_id": 38135,
                            "province_id": 30,
                            "name": "通江县",
                            "whole_name": "通江县，巴中市，四川省",
                            "simple_py": "TJX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0827",
                            "area_code": "511921",
                            "longitude": "107.247621",
                            "latitude": "31.91212"
                        }
                    ]
                },
                {
                    "city_id": 38138,
                    "province_id": 30,
                    "name": "成都市",
                    "whole_name": "成都市，四川省",
                    "simple_py": "CDS",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "028",
                    "area_code": "510100",
                    "longitude": "104.065735",
                    "latitude": "30.659462",
                    "children": [
                        {
                            "area_id": 40080,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "崇州市",
                            "whole_name": "崇州市，成都市，四川省",
                            "simple_py": "CZS",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "028",
                            "area_code": "510184",
                            "longitude": "103.671049",
                            "latitude": "30.631478"
                        },
                        {
                            "area_id": 40082,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "成华区",
                            "whole_name": "成华区，成都市，四川省",
                            "simple_py": "CHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "028",
                            "area_code": "510108",
                            "longitude": "104.103077",
                            "latitude": "30.660275"
                        },
                        {
                            "area_id": 40075,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "都江堰市",
                            "whole_name": "都江堰市，成都市，四川省",
                            "simple_py": "DJYS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "028",
                            "area_code": "510181",
                            "longitude": "103.627898",
                            "latitude": "30.99114"
                        },
                        {
                            "area_id": 40081,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "大邑县",
                            "whole_name": "大邑县，成都市，四川省",
                            "simple_py": "DYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "028",
                            "area_code": "510129",
                            "longitude": "103.522397",
                            "latitude": "30.586602"
                        },
                        {
                            "area_id": 40078,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "简阳市",
                            "whole_name": "简阳市，成都市，四川省",
                            "simple_py": "JYS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "028",
                            "area_code": "510185",
                            "longitude": "104.550339",
                            "latitude": "30.390666"
                        },
                        {
                            "area_id": 40083,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "金堂县",
                            "whole_name": "金堂县，成都市，四川省",
                            "simple_py": "JTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "028",
                            "area_code": "510121",
                            "longitude": "104.415604",
                            "latitude": "30.858417"
                        },
                        {
                            "area_id": 40087,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "锦江区",
                            "whole_name": "锦江区，成都市，四川省",
                            "simple_py": "JJQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "028",
                            "area_code": "510104",
                            "longitude": "104.080989",
                            "latitude": "30.657689"
                        },
                        {
                            "area_id": 40090,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "金牛区",
                            "whole_name": "金牛区，成都市，四川省",
                            "simple_py": "JNQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "028",
                            "area_code": "510106",
                            "longitude": "104.043487",
                            "latitude": "30.692058"
                        },
                        {
                            "area_id": 40086,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "龙泉驿区",
                            "whole_name": "龙泉驿区，成都市，四川省",
                            "simple_py": "LQYQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "028",
                            "area_code": "510112",
                            "longitude": "104.269181",
                            "latitude": "30.56065"
                        },
                        {
                            "area_id": 40074,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "彭州市",
                            "whole_name": "彭州市，成都市，四川省",
                            "simple_py": "PZS",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "028",
                            "area_code": "510182",
                            "longitude": "103.941173",
                            "latitude": "30.985161"
                        },
                        {
                            "area_id": 40079,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "蒲江县",
                            "whole_name": "蒲江县，成都市，四川省",
                            "simple_py": "PJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "P",
                            "city_code": "028",
                            "area_code": "510131",
                            "longitude": "103.511541",
                            "latitude": "30.194359"
                        },
                        {
                            "area_id": 40091,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "郫都区",
                            "whole_name": "郫都区，成都市，四川省",
                            "simple_py": "PDQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "P",
                            "city_code": "028",
                            "area_code": "510117",
                            "longitude": "103.887842",
                            "latitude": "30.808752"
                        },
                        {
                            "area_id": 40077,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "青白江区",
                            "whole_name": "青白江区，成都市，四川省",
                            "simple_py": "QBJQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "028",
                            "area_code": "510113",
                            "longitude": "104.25494",
                            "latitude": "30.883438"
                        },
                        {
                            "area_id": 40084,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "邛崃市",
                            "whole_name": "邛崃市，成都市，四川省",
                            "simple_py": "QLS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "028",
                            "area_code": "510183",
                            "longitude": "103.46143",
                            "latitude": "30.413271"
                        },
                        {
                            "area_id": 40088,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "青羊区",
                            "whole_name": "青羊区，成都市，四川省",
                            "simple_py": "QYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "028",
                            "area_code": "510105",
                            "longitude": "104.055731",
                            "latitude": "30.667648"
                        },
                        {
                            "area_id": 40093,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "双流区",
                            "whole_name": "双流区，成都市，四川省",
                            "simple_py": "SLQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "028",
                            "area_code": "510116",
                            "longitude": "103.922706",
                            "latitude": "30.573243"
                        },
                        {
                            "area_id": 40089,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "温江区",
                            "whole_name": "温江区，成都市，四川省",
                            "simple_py": "WJQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "028",
                            "area_code": "510115",
                            "longitude": "103.836776",
                            "latitude": "30.697996"
                        },
                        {
                            "area_id": 40092,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "武侯区",
                            "whole_name": "武侯区，成都市，四川省",
                            "simple_py": "WHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "028",
                            "area_code": "510107",
                            "longitude": "104.05167",
                            "latitude": "30.630862"
                        },
                        {
                            "area_id": 40076,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "新都区",
                            "whole_name": "新都区，成都市，四川省",
                            "simple_py": "XDQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "028",
                            "area_code": "510114",
                            "longitude": "104.16022",
                            "latitude": "30.824223"
                        },
                        {
                            "area_id": 40085,
                            "city_id": 38138,
                            "province_id": 30,
                            "name": "新津县",
                            "whole_name": "新津县，成都市，四川省",
                            "simple_py": "XJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "028",
                            "area_code": "510132",
                            "longitude": "103.812449",
                            "latitude": "30.414284"
                        }
                    ]
                },
                {
                    "city_id": 38131,
                    "province_id": 30,
                    "name": "达州市",
                    "whole_name": "达州市，四川省",
                    "simple_py": "DZS",
                    "per_pin_yin": "D",
                    "per_pin_yin2": "D",
                    "city_code": "0818",
                    "area_code": "511700",
                    "longitude": "107.502262",
                    "latitude": "31.209484",
                    "children": [
                        {
                            "area_id": 38838,
                            "city_id": 38131,
                            "province_id": 30,
                            "name": "大竹县",
                            "whole_name": "大竹县，达州市，四川省",
                            "simple_py": "DZX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0818",
                            "area_code": "511724",
                            "longitude": "107.20742",
                            "latitude": "30.736289"
                        },
                        {
                            "area_id": 38839,
                            "city_id": 38131,
                            "province_id": 30,
                            "name": "达川区",
                            "whole_name": "达川区，达州市，四川省",
                            "simple_py": "DCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0818",
                            "area_code": "511703",
                            "longitude": "107.507926",
                            "latitude": "31.199062"
                        },
                        {
                            "area_id": 38843,
                            "city_id": 38131,
                            "province_id": 30,
                            "name": "开江县",
                            "whole_name": "开江县，达州市，四川省",
                            "simple_py": "KJX",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0818",
                            "area_code": "511723",
                            "longitude": "107.864135",
                            "latitude": "31.085537"
                        },
                        {
                            "area_id": 38841,
                            "city_id": 38131,
                            "province_id": 30,
                            "name": "渠县",
                            "whole_name": "渠县，达州市，四川省",
                            "simple_py": "QX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0818",
                            "area_code": "511725",
                            "longitude": "106.970746",
                            "latitude": "30.836348"
                        },
                        {
                            "area_id": 38840,
                            "city_id": 38131,
                            "province_id": 30,
                            "name": "通川区",
                            "whole_name": "通川区，达州市，四川省",
                            "simple_py": "TCQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0818",
                            "area_code": "511702",
                            "longitude": "107.501062",
                            "latitude": "31.213522"
                        },
                        {
                            "area_id": 38842,
                            "city_id": 38131,
                            "province_id": 30,
                            "name": "万源市",
                            "whole_name": "万源市，达州市，四川省",
                            "simple_py": "WYS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0818",
                            "area_code": "511781",
                            "longitude": "108.037548",
                            "latitude": "32.06777"
                        },
                        {
                            "area_id": 38837,
                            "city_id": 38131,
                            "province_id": 30,
                            "name": "宣汉县",
                            "whole_name": "宣汉县，达州市，四川省",
                            "simple_py": "XHX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0818",
                            "area_code": "511722",
                            "longitude": "107.722254",
                            "latitude": "31.355025"
                        }
                    ]
                },
                {
                    "city_id": 38133,
                    "province_id": 30,
                    "name": "德阳市",
                    "whole_name": "德阳市，四川省",
                    "simple_py": "DYS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "D",
                    "city_code": "0838",
                    "area_code": "510600",
                    "longitude": "104.398651",
                    "latitude": "31.127991",
                    "children": [
                        {
                            "area_id": 39298,
                            "city_id": 38133,
                            "province_id": 30,
                            "name": "广汉市",
                            "whole_name": "广汉市，德阳市，四川省",
                            "simple_py": "GHS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0838",
                            "area_code": "510681",
                            "longitude": "104.281903",
                            "latitude": "30.97715"
                        },
                        {
                            "area_id": 39295,
                            "city_id": 38133,
                            "province_id": 30,
                            "name": "旌阳区",
                            "whole_name": "旌阳区，德阳市，四川省",
                            "simple_py": "JYQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0838",
                            "area_code": "510603",
                            "longitude": "104.389648",
                            "latitude": "31.130428"
                        },
                        {
                            "area_id": 39299,
                            "city_id": 38133,
                            "province_id": 30,
                            "name": "罗江区",
                            "whole_name": "罗江区，德阳市，四川省",
                            "simple_py": "LJQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0838",
                            "area_code": "510626",
                            "longitude": "104.507126",
                            "latitude": "31.303281"
                        },
                        {
                            "area_id": 39300,
                            "city_id": 38133,
                            "province_id": 30,
                            "name": "绵竹市",
                            "whole_name": "绵竹市，德阳市，四川省",
                            "simple_py": "MZS",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0838",
                            "area_code": "510683",
                            "longitude": "104.200162",
                            "latitude": "31.343084"
                        },
                        {
                            "area_id": 39297,
                            "city_id": 38133,
                            "province_id": 30,
                            "name": "什邡市",
                            "whole_name": "什邡市，德阳市，四川省",
                            "simple_py": "SFS",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0838",
                            "area_code": "510682",
                            "longitude": "104.173653",
                            "latitude": "31.126881"
                        },
                        {
                            "area_id": 39296,
                            "city_id": 38133,
                            "province_id": 30,
                            "name": "中江县",
                            "whole_name": "中江县，德阳市，四川省",
                            "simple_py": "ZJX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0838",
                            "area_code": "510623",
                            "longitude": "104.677831",
                            "latitude": "31.03681"
                        }
                    ]
                },
                {
                    "city_id": 38129,
                    "province_id": 30,
                    "name": "广元市",
                    "whole_name": "广元市，四川省",
                    "simple_py": "GYS",
                    "per_pin_yin": "G",
                    "per_pin_yin2": "G",
                    "city_code": "0839",
                    "area_code": "510800",
                    "longitude": "105.829757",
                    "latitude": "32.433668",
                    "children": [
                        {
                            "area_id": 38150,
                            "city_id": 38129,
                            "province_id": 30,
                            "name": "朝天区",
                            "whole_name": "朝天区，广元市，四川省",
                            "simple_py": "CTQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0839",
                            "area_code": "510812",
                            "longitude": "105.88917",
                            "latitude": "32.642632"
                        },
                        {
                            "area_id": 38153,
                            "city_id": 38129,
                            "province_id": 30,
                            "name": "苍溪县",
                            "whole_name": "苍溪县，广元市，四川省",
                            "simple_py": "CXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0839",
                            "area_code": "510824",
                            "longitude": "105.939706",
                            "latitude": "31.732251"
                        },
                        {
                            "area_id": 38152,
                            "city_id": 38129,
                            "province_id": 30,
                            "name": "剑阁县",
                            "whole_name": "剑阁县，广元市，四川省",
                            "simple_py": "JGX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0839",
                            "area_code": "510823",
                            "longitude": "105.527035",
                            "latitude": "32.286517"
                        },
                        {
                            "area_id": 38156,
                            "city_id": 38129,
                            "province_id": 30,
                            "name": "利州区",
                            "whole_name": "利州区，广元市，四川省",
                            "simple_py": "LZQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0839",
                            "area_code": "510802",
                            "longitude": "105.826194",
                            "latitude": "32.432276"
                        },
                        {
                            "area_id": 38155,
                            "city_id": 38129,
                            "province_id": 30,
                            "name": "青川县",
                            "whole_name": "青川县，广元市，四川省",
                            "simple_py": "QCX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0839",
                            "area_code": "510822",
                            "longitude": "105.238847",
                            "latitude": "32.585655"
                        },
                        {
                            "area_id": 38154,
                            "city_id": 38129,
                            "province_id": 30,
                            "name": "旺苍县",
                            "whole_name": "旺苍县，广元市，四川省",
                            "simple_py": "WCX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0839",
                            "area_code": "510821",
                            "longitude": "106.290426",
                            "latitude": "32.22833"
                        },
                        {
                            "area_id": 38151,
                            "city_id": 38129,
                            "province_id": 30,
                            "name": "昭化区",
                            "whole_name": "昭化区，广元市，四川省",
                            "simple_py": "ZHQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0839",
                            "area_code": "510811",
                            "longitude": "105.964121",
                            "latitude": "32.322788"
                        }
                    ]
                },
                {
                    "city_id": 38136,
                    "province_id": 30,
                    "name": "广安市",
                    "whole_name": "广安市，四川省",
                    "simple_py": "GAS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "G",
                    "city_code": "0826",
                    "area_code": "511600",
                    "longitude": "106.633369",
                    "latitude": "30.456398",
                    "children": [
                        {
                            "area_id": 39765,
                            "city_id": 38136,
                            "province_id": 30,
                            "name": "广安区",
                            "whole_name": "广安区，广安市，四川省",
                            "simple_py": "GAQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0826",
                            "area_code": "511602",
                            "longitude": "106.632907",
                            "latitude": "30.456462"
                        },
                        {
                            "area_id": 39768,
                            "city_id": 38136,
                            "province_id": 30,
                            "name": "华蓥市",
                            "whole_name": "华蓥市，广安市，四川省",
                            "simple_py": "HYS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0826",
                            "area_code": "511681",
                            "longitude": "106.777882",
                            "latitude": "30.380574"
                        },
                        {
                            "area_id": 39763,
                            "city_id": 38136,
                            "province_id": 30,
                            "name": "邻水县",
                            "whole_name": "邻水县，广安市，四川省",
                            "simple_py": "LSX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0826",
                            "area_code": "511623",
                            "longitude": "106.934968",
                            "latitude": "30.334323"
                        },
                        {
                            "area_id": 39767,
                            "city_id": 38136,
                            "province_id": 30,
                            "name": "前锋区",
                            "whole_name": "前锋区，广安市，四川省",
                            "simple_py": "QFQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0826",
                            "area_code": "511603",
                            "longitude": "106.893277",
                            "latitude": "30.4963"
                        },
                        {
                            "area_id": 39764,
                            "city_id": 38136,
                            "province_id": 30,
                            "name": "武胜县",
                            "whole_name": "武胜县，广安市，四川省",
                            "simple_py": "WSX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0826",
                            "area_code": "511622",
                            "longitude": "106.292473",
                            "latitude": "30.344291"
                        },
                        {
                            "area_id": 39766,
                            "city_id": 38136,
                            "province_id": 30,
                            "name": "岳池县",
                            "whole_name": "岳池县，广安市，四川省",
                            "simple_py": "YCX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0826",
                            "area_code": "511621",
                            "longitude": "106.444451",
                            "latitude": "30.533538"
                        }
                    ]
                },
                {
                    "city_id": 38146,
                    "province_id": 30,
                    "name": "甘孜藏族自治州",
                    "whole_name": "甘孜藏族自治州，四川省",
                    "simple_py": "GZCZZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "G",
                    "city_code": "0836",
                    "area_code": "513300",
                    "longitude": "101.963815",
                    "latitude": "30.050663",
                    "children": [
                        {
                            "area_id": 41656,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "白玉县",
                            "whole_name": "白玉县，甘孜藏族自治州，四川省",
                            "simple_py": "BYX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0836",
                            "area_code": "513331",
                            "longitude": "98.824343",
                            "latitude": "31.208805"
                        },
                        {
                            "area_id": 41660,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "巴塘县",
                            "whole_name": "巴塘县，甘孜藏族自治州，四川省",
                            "simple_py": "BTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0836",
                            "area_code": "513335",
                            "longitude": "99.109037",
                            "latitude": "30.005723"
                        },
                        {
                            "area_id": 41651,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "德格县",
                            "whole_name": "德格县，甘孜藏族自治州，四川省",
                            "simple_py": "DGX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0836",
                            "area_code": "513330",
                            "longitude": "98.57999",
                            "latitude": "31.806729"
                        },
                        {
                            "area_id": 41654,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "道孚县",
                            "whole_name": "道孚县，甘孜藏族自治州，四川省",
                            "simple_py": "DFX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0836",
                            "area_code": "513326",
                            "longitude": "101.123327",
                            "latitude": "30.978767"
                        },
                        {
                            "area_id": 41664,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "稻城县",
                            "whole_name": "稻城县，甘孜藏族自治州，四川省",
                            "simple_py": "DCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0836",
                            "area_code": "513337",
                            "longitude": "100.296689",
                            "latitude": "29.037544"
                        },
                        {
                            "area_id": 41665,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "得荣县",
                            "whole_name": "得荣县，甘孜藏族自治州，四川省",
                            "simple_py": "DRX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0836",
                            "area_code": "513338",
                            "longitude": "99.288036",
                            "latitude": "28.71134"
                        },
                        {
                            "area_id": 41666,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "丹巴县",
                            "whole_name": "丹巴县，甘孜藏族自治州，四川省",
                            "simple_py": "DBX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0836",
                            "area_code": "513323",
                            "longitude": "101.886125",
                            "latitude": "30.877083"
                        },
                        {
                            "area_id": 41650,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "甘孜县",
                            "whole_name": "甘孜县，甘孜藏族自治州，四川省",
                            "simple_py": "GZX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0836",
                            "area_code": "513328",
                            "longitude": "99.991753",
                            "latitude": "31.61975"
                        },
                        {
                            "area_id": 41659,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "九龙县",
                            "whole_name": "九龙县，甘孜藏族自治州，四川省",
                            "simple_py": "JLX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0836",
                            "area_code": "513324",
                            "longitude": "101.506942",
                            "latitude": "29.001975"
                        },
                        {
                            "area_id": 41661,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "康定市",
                            "whole_name": "康定市，甘孜藏族自治州，四川省",
                            "simple_py": "KDS",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0836",
                            "area_code": "513301",
                            "longitude": "101.964057",
                            "latitude": "30.050738"
                        },
                        {
                            "area_id": 41653,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "炉霍县",
                            "whole_name": "炉霍县，甘孜藏族自治州，四川省",
                            "simple_py": "LHX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0836",
                            "area_code": "513327",
                            "longitude": "100.679495",
                            "latitude": "31.392674"
                        },
                        {
                            "area_id": 41658,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "理塘县",
                            "whole_name": "理塘县，甘孜藏族自治州，四川省",
                            "simple_py": "LTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0836",
                            "area_code": "513334",
                            "longitude": "100.269862",
                            "latitude": "29.991807"
                        },
                        {
                            "area_id": 41662,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "泸定县",
                            "whole_name": "泸定县，甘孜藏族自治州，四川省",
                            "simple_py": "LDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0836",
                            "area_code": "513322",
                            "longitude": "102.233225",
                            "latitude": "29.912482"
                        },
                        {
                            "area_id": 41652,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "石渠县",
                            "whole_name": "石渠县，甘孜藏族自治州，四川省",
                            "simple_py": "SQX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0836",
                            "area_code": "513332",
                            "longitude": "98.100887",
                            "latitude": "32.975302"
                        },
                        {
                            "area_id": 41667,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "色达县",
                            "whole_name": "色达县，甘孜藏族自治州，四川省",
                            "simple_py": "SDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0836",
                            "area_code": "513333",
                            "longitude": "100.331657",
                            "latitude": "32.268777"
                        },
                        {
                            "area_id": 41655,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "新龙县",
                            "whole_name": "新龙县，甘孜藏族自治州，四川省",
                            "simple_py": "XLX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0836",
                            "area_code": "513329",
                            "longitude": "100.312094",
                            "latitude": "30.93896"
                        },
                        {
                            "area_id": 41663,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "乡城县",
                            "whole_name": "乡城县，甘孜藏族自治州，四川省",
                            "simple_py": "XCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0836",
                            "area_code": "513336",
                            "longitude": "99.799943",
                            "latitude": "28.930855"
                        },
                        {
                            "area_id": 41657,
                            "city_id": 38146,
                            "province_id": 30,
                            "name": "雅江县",
                            "whole_name": "雅江县，甘孜藏族自治州，四川省",
                            "simple_py": "YJX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0836",
                            "area_code": "513325",
                            "longitude": "101.015735",
                            "latitude": "30.03225"
                        }
                    ]
                },
                {
                    "city_id": 38145,
                    "province_id": 30,
                    "name": "乐山市",
                    "whole_name": "乐山市，四川省",
                    "simple_py": "LSS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0833",
                    "area_code": "511100",
                    "longitude": "103.761263",
                    "latitude": "29.582024",
                    "children": [
                        {
                            "area_id": 41424,
                            "city_id": 38145,
                            "province_id": 30,
                            "name": "峨边彝族自治县",
                            "whole_name": "峨边彝族自治县，乐山市，四川省",
                            "simple_py": "EBYZZZX",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0833",
                            "area_code": "511132",
                            "longitude": "103.262148",
                            "latitude": "29.230271"
                        },
                        {
                            "area_id": 41430,
                            "city_id": 38145,
                            "province_id": 30,
                            "name": "峨眉山市",
                            "whole_name": "峨眉山市，乐山市，四川省",
                            "simple_py": "EMSS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "E",
                            "city_code": "0833",
                            "area_code": "511181",
                            "longitude": "103.492488",
                            "latitude": "29.597478"
                        },
                        {
                            "area_id": 41422,
                            "city_id": 38145,
                            "province_id": 30,
                            "name": "井研县",
                            "whole_name": "井研县，乐山市，四川省",
                            "simple_py": "JYX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0833",
                            "area_code": "511124",
                            "longitude": "104.06885",
                            "latitude": "29.651645"
                        },
                        {
                            "area_id": 41423,
                            "city_id": 38145,
                            "province_id": 30,
                            "name": "金口河区",
                            "whole_name": "金口河区，乐山市，四川省",
                            "simple_py": "JKHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0833",
                            "area_code": "511113",
                            "longitude": "103.077831",
                            "latitude": "29.24602"
                        },
                        {
                            "area_id": 41425,
                            "city_id": 38145,
                            "province_id": 30,
                            "name": "犍为县",
                            "whole_name": "犍为县，乐山市，四川省",
                            "simple_py": "JWX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0833",
                            "area_code": "511123",
                            "longitude": "103.944266",
                            "latitude": "29.209782"
                        },
                        {
                            "area_id": 41426,
                            "city_id": 38145,
                            "province_id": 30,
                            "name": "夹江县",
                            "whole_name": "夹江县，乐山市，四川省",
                            "simple_py": "JJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0833",
                            "area_code": "511126",
                            "longitude": "103.578862",
                            "latitude": "29.741019"
                        },
                        {
                            "area_id": 41427,
                            "city_id": 38145,
                            "province_id": 30,
                            "name": "沐川县",
                            "whole_name": "沐川县，乐山市，四川省",
                            "simple_py": "MCX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0833",
                            "area_code": "511129",
                            "longitude": "103.90211",
                            "latitude": "28.956338"
                        },
                        {
                            "area_id": 41428,
                            "city_id": 38145,
                            "province_id": 30,
                            "name": "马边彝族自治县",
                            "whole_name": "马边彝族自治县，乐山市，四川省",
                            "simple_py": "MBYZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0833",
                            "area_code": "511133",
                            "longitude": "103.546851",
                            "latitude": "28.838933"
                        },
                        {
                            "area_id": 41421,
                            "city_id": 38145,
                            "province_id": 30,
                            "name": "沙湾区",
                            "whole_name": "沙湾区，乐山市，四川省",
                            "simple_py": "SWQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0833",
                            "area_code": "511111",
                            "longitude": "103.549961",
                            "latitude": "29.416536"
                        },
                        {
                            "area_id": 41429,
                            "city_id": 38145,
                            "province_id": 30,
                            "name": "市中区",
                            "whole_name": "市中区，乐山市，四川省",
                            "simple_py": "SZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0833",
                            "area_code": "511102",
                            "longitude": "103.75539",
                            "latitude": "29.588327"
                        },
                        {
                            "area_id": 41420,
                            "city_id": 38145,
                            "province_id": 30,
                            "name": "五通桥区",
                            "whole_name": "五通桥区，乐山市，四川省",
                            "simple_py": "WTQQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0833",
                            "area_code": "511112",
                            "longitude": "103.816837",
                            "latitude": "29.406186"
                        }
                    ]
                },
                {
                    "city_id": 38147,
                    "province_id": 30,
                    "name": "泸州市",
                    "whole_name": "泸州市，四川省",
                    "simple_py": "LZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "L",
                    "city_code": "0830",
                    "area_code": "510500",
                    "longitude": "105.443348",
                    "latitude": "28.889138",
                    "children": [
                        {
                            "area_id": 41996,
                            "city_id": 38147,
                            "province_id": 30,
                            "name": "古蔺县",
                            "whole_name": "古蔺县，泸州市，四川省",
                            "simple_py": "GLX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0830",
                            "area_code": "510525",
                            "longitude": "105.813359",
                            "latitude": "28.03948"
                        },
                        {
                            "area_id": 41998,
                            "city_id": 38147,
                            "province_id": 30,
                            "name": "合江县",
                            "whole_name": "合江县，泸州市，四川省",
                            "simple_py": "HJX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0830",
                            "area_code": "510522",
                            "longitude": "105.834098",
                            "latitude": "28.810325"
                        },
                        {
                            "area_id": 41997,
                            "city_id": 38147,
                            "province_id": 30,
                            "name": "江阳区",
                            "whole_name": "江阳区，泸州市，四川省",
                            "simple_py": "JYQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0830",
                            "area_code": "510502",
                            "longitude": "105.445131",
                            "latitude": "28.882889"
                        },
                        {
                            "area_id": 41992,
                            "city_id": 38147,
                            "province_id": 30,
                            "name": "龙马潭区",
                            "whole_name": "龙马潭区，泸州市，四川省",
                            "simple_py": "LMTQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0830",
                            "area_code": "510504",
                            "longitude": "105.435228",
                            "latitude": "28.897572"
                        },
                        {
                            "area_id": 41994,
                            "city_id": 38147,
                            "province_id": 30,
                            "name": "泸县",
                            "whole_name": "泸县，泸州市，四川省",
                            "simple_py": "LX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0830",
                            "area_code": "510521",
                            "longitude": "105.376335",
                            "latitude": "29.151288"
                        },
                        {
                            "area_id": 41995,
                            "city_id": 38147,
                            "province_id": 30,
                            "name": "纳溪区",
                            "whole_name": "纳溪区，泸州市，四川省",
                            "simple_py": "NXQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0830",
                            "area_code": "510503",
                            "longitude": "105.37721",
                            "latitude": "28.77631"
                        },
                        {
                            "area_id": 41993,
                            "city_id": 38147,
                            "province_id": 30,
                            "name": "叙永县",
                            "whole_name": "叙永县，泸州市，四川省",
                            "simple_py": "XYX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0830",
                            "area_code": "510524",
                            "longitude": "105.437775",
                            "latitude": "28.167919"
                        }
                    ]
                },
                {
                    "city_id": 38149,
                    "province_id": 30,
                    "name": "凉山彝族自治州",
                    "whole_name": "凉山彝族自治州，四川省",
                    "simple_py": "LSYZZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "L",
                    "city_code": "0834",
                    "area_code": "513400",
                    "longitude": "102.258746",
                    "latitude": "27.886762",
                    "children": [
                        {
                            "area_id": 42392,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "布拖县",
                            "whole_name": "布拖县，凉山彝族自治州，四川省",
                            "simple_py": "BTX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0834",
                            "area_code": "513429",
                            "longitude": "102.808801",
                            "latitude": "27.709062"
                        },
                        {
                            "area_id": 42404,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "德昌县",
                            "whole_name": "德昌县，凉山彝族自治州，四川省",
                            "simple_py": "DCX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0834",
                            "area_code": "513424",
                            "longitude": "102.178845",
                            "latitude": "27.403827"
                        },
                        {
                            "area_id": 42393,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "甘洛县",
                            "whole_name": "甘洛县，凉山彝族自治州，四川省",
                            "simple_py": "GLX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0834",
                            "area_code": "513435",
                            "longitude": "102.775924",
                            "latitude": "28.977094"
                        },
                        {
                            "area_id": 42391,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "会理县",
                            "whole_name": "会理县，凉山彝族自治州，四川省",
                            "simple_py": "HLX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0834",
                            "area_code": "513425",
                            "longitude": "102.249548",
                            "latitude": "26.658702"
                        },
                        {
                            "area_id": 42400,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "会东县",
                            "whole_name": "会东县，凉山彝族自治州，四川省",
                            "simple_py": "HDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0834",
                            "area_code": "513426",
                            "longitude": "102.578985",
                            "latitude": "26.630713"
                        },
                        {
                            "area_id": 42396,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "金阳县",
                            "whole_name": "金阳县，凉山彝族自治州，四川省",
                            "simple_py": "JYX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0834",
                            "area_code": "513430",
                            "longitude": "103.248704",
                            "latitude": "27.695916"
                        },
                        {
                            "area_id": 42402,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "雷波县",
                            "whole_name": "雷波县，凉山彝族自治州，四川省",
                            "simple_py": "LBX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0834",
                            "area_code": "513437",
                            "longitude": "103.571584",
                            "latitude": "28.262946"
                        },
                        {
                            "area_id": 42388,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "木里藏族自治县",
                            "whole_name": "木里藏族自治县，凉山彝族自治州，四川省",
                            "simple_py": "MLCZZZX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0834",
                            "area_code": "513422",
                            "longitude": "101.280184",
                            "latitude": "27.926859"
                        },
                        {
                            "area_id": 42394,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "美姑县",
                            "whole_name": "美姑县，凉山彝族自治州，四川省",
                            "simple_py": "MGX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0834",
                            "area_code": "513436",
                            "longitude": "103.132007",
                            "latitude": "28.327946"
                        },
                        {
                            "area_id": 42398,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "冕宁县",
                            "whole_name": "冕宁县，凉山彝族自治州，四川省",
                            "simple_py": "MNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0834",
                            "area_code": "513433",
                            "longitude": "102.170046",
                            "latitude": "28.550844"
                        },
                        {
                            "area_id": 42403,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "宁南县",
                            "whole_name": "宁南县，凉山彝族自治州，四川省",
                            "simple_py": "NNX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0834",
                            "area_code": "513427",
                            "longitude": "102.757374",
                            "latitude": "27.065205"
                        },
                        {
                            "area_id": 42401,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "普格县",
                            "whole_name": "普格县，凉山彝族自治州，四川省",
                            "simple_py": "PGX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0834",
                            "area_code": "513428",
                            "longitude": "102.541082",
                            "latitude": "27.376828"
                        },
                        {
                            "area_id": 42389,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "喜德县",
                            "whole_name": "喜德县，凉山彝族自治州，四川省",
                            "simple_py": "XDX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0834",
                            "area_code": "513432",
                            "longitude": "102.412342",
                            "latitude": "28.305486"
                        },
                        {
                            "area_id": 42390,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "西昌市",
                            "whole_name": "西昌市，凉山彝族自治州，四川省",
                            "simple_py": "XCS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0834",
                            "area_code": "513401",
                            "longitude": "102.258758",
                            "latitude": "27.885786"
                        },
                        {
                            "area_id": 42397,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "盐源县",
                            "whole_name": "盐源县，凉山彝族自治州，四川省",
                            "simple_py": "YYX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0834",
                            "area_code": "513423",
                            "longitude": "101.508909",
                            "latitude": "27.423415"
                        },
                        {
                            "area_id": 42399,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "越西县",
                            "whole_name": "越西县，凉山彝族自治州，四川省",
                            "simple_py": "YXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0834",
                            "area_code": "513434",
                            "longitude": "102.508875",
                            "latitude": "28.639632"
                        },
                        {
                            "area_id": 42395,
                            "city_id": 38149,
                            "province_id": 30,
                            "name": "昭觉县",
                            "whole_name": "昭觉县，凉山彝族自治州，四川省",
                            "simple_py": "ZJX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0834",
                            "area_code": "513431",
                            "longitude": "102.843991",
                            "latitude": "28.010554"
                        }
                    ]
                },
                {
                    "city_id": 38132,
                    "province_id": 30,
                    "name": "眉山市",
                    "whole_name": "眉山市，四川省",
                    "simple_py": "MSS",
                    "per_pin_yin": "M",
                    "per_pin_yin2": "M",
                    "city_code": "028",
                    "area_code": "511400",
                    "longitude": "103.831788",
                    "latitude": "30.048318",
                    "children": [
                        {
                            "area_id": 39158,
                            "city_id": 38132,
                            "province_id": 30,
                            "name": "丹棱县",
                            "whole_name": "丹棱县，眉山市，四川省",
                            "simple_py": "DLX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "028",
                            "area_code": "511424",
                            "longitude": "103.518333",
                            "latitude": "30.012751"
                        },
                        {
                            "area_id": 39162,
                            "city_id": 38132,
                            "province_id": 30,
                            "name": "东坡区",
                            "whole_name": "东坡区，眉山市，四川省",
                            "simple_py": "DPQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "028",
                            "area_code": "511402",
                            "longitude": "103.831553",
                            "latitude": "30.048128"
                        },
                        {
                            "area_id": 39160,
                            "city_id": 38132,
                            "province_id": 30,
                            "name": "洪雅县",
                            "whole_name": "洪雅县，眉山市，四川省",
                            "simple_py": "HYX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "028",
                            "area_code": "511423",
                            "longitude": "103.375006",
                            "latitude": "29.904867"
                        },
                        {
                            "area_id": 39163,
                            "city_id": 38132,
                            "province_id": 30,
                            "name": "彭山区",
                            "whole_name": "彭山区，眉山市，四川省",
                            "simple_py": "PSQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "028",
                            "area_code": "511403",
                            "longitude": "103.8701",
                            "latitude": "30.192298"
                        },
                        {
                            "area_id": 39161,
                            "city_id": 38132,
                            "province_id": 30,
                            "name": "青神县",
                            "whole_name": "青神县，眉山市，四川省",
                            "simple_py": "QSX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "028",
                            "area_code": "511425",
                            "longitude": "103.846131",
                            "latitude": "29.831469"
                        },
                        {
                            "area_id": 39159,
                            "city_id": 38132,
                            "province_id": 30,
                            "name": "仁寿县",
                            "whole_name": "仁寿县，眉山市，四川省",
                            "simple_py": "RSX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "028",
                            "area_code": "511421",
                            "longitude": "104.147646",
                            "latitude": "29.996721"
                        }
                    ]
                },
                {
                    "city_id": 38139,
                    "province_id": 30,
                    "name": "绵阳市",
                    "whole_name": "绵阳市，四川省",
                    "simple_py": "MYS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "M",
                    "city_code": "0816",
                    "area_code": "510700",
                    "longitude": "104.741722",
                    "latitude": "31.46402",
                    "children": [
                        {
                            "area_id": 40468,
                            "city_id": 38139,
                            "province_id": 30,
                            "name": "安州区",
                            "whole_name": "安州区，绵阳市，四川省",
                            "simple_py": "AZQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0816",
                            "area_code": "510705",
                            "longitude": "104.560341",
                            "latitude": "31.53894"
                        },
                        {
                            "area_id": 40469,
                            "city_id": 38139,
                            "province_id": 30,
                            "name": "北川羌族自治县",
                            "whole_name": "北川羌族自治县，绵阳市，四川省",
                            "simple_py": "BCQZZZX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0816",
                            "area_code": "510726",
                            "longitude": "104.468069",
                            "latitude": "31.615863"
                        },
                        {
                            "area_id": 40471,
                            "city_id": 38139,
                            "province_id": 30,
                            "name": "涪城区",
                            "whole_name": "涪城区，绵阳市，四川省",
                            "simple_py": "FCQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0816",
                            "area_code": "510703",
                            "longitude": "104.740971",
                            "latitude": "31.463557"
                        },
                        {
                            "area_id": 40466,
                            "city_id": 38139,
                            "province_id": 30,
                            "name": "江油市",
                            "whole_name": "江油市，绵阳市，四川省",
                            "simple_py": "JYS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0816",
                            "area_code": "510781",
                            "longitude": "104.744431",
                            "latitude": "31.776386"
                        },
                        {
                            "area_id": 40472,
                            "city_id": 38139,
                            "province_id": 30,
                            "name": "平武县",
                            "whole_name": "平武县，绵阳市，四川省",
                            "simple_py": "PWX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0816",
                            "area_code": "510727",
                            "longitude": "104.530555",
                            "latitude": "32.407588"
                        },
                        {
                            "area_id": 40464,
                            "city_id": 38139,
                            "province_id": 30,
                            "name": "三台县",
                            "whole_name": "三台县，绵阳市，四川省",
                            "simple_py": "STX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0816",
                            "area_code": "510722",
                            "longitude": "105.090316",
                            "latitude": "31.090909"
                        },
                        {
                            "area_id": 40467,
                            "city_id": 38139,
                            "province_id": 30,
                            "name": "游仙区",
                            "whole_name": "游仙区，绵阳市，四川省",
                            "simple_py": "YXQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0816",
                            "area_code": "510704",
                            "longitude": "104.770006",
                            "latitude": "31.484772"
                        },
                        {
                            "area_id": 40470,
                            "city_id": 38139,
                            "province_id": 30,
                            "name": "盐亭县",
                            "whole_name": "盐亭县，绵阳市，四川省",
                            "simple_py": "YTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0816",
                            "area_code": "510723",
                            "longitude": "105.391991",
                            "latitude": "31.22318"
                        },
                        {
                            "area_id": 40465,
                            "city_id": 38139,
                            "province_id": 30,
                            "name": "梓潼县",
                            "whole_name": "梓潼县，绵阳市，四川省",
                            "simple_py": "ZTX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0816",
                            "area_code": "510725",
                            "longitude": "105.16353",
                            "latitude": "31.635225"
                        }
                    ]
                },
                {
                    "city_id": 38130,
                    "province_id": 30,
                    "name": "南充市",
                    "whole_name": "南充市，四川省",
                    "simple_py": "NCS",
                    "per_pin_yin": "N",
                    "per_pin_yin2": "N",
                    "city_code": "0817",
                    "area_code": "511300",
                    "longitude": "106.082974",
                    "latitude": "30.795281",
                    "children": [
                        {
                            "area_id": 38413,
                            "city_id": 38130,
                            "province_id": 30,
                            "name": "高坪区",
                            "whole_name": "高坪区，南充市，四川省",
                            "simple_py": "GPQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0817",
                            "area_code": "511303",
                            "longitude": "106.108996",
                            "latitude": "30.781809"
                        },
                        {
                            "area_id": 38406,
                            "city_id": 38130,
                            "province_id": 30,
                            "name": "嘉陵区",
                            "whole_name": "嘉陵区，南充市，四川省",
                            "simple_py": "JLQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0817",
                            "area_code": "511304",
                            "longitude": "106.067027",
                            "latitude": "30.762976"
                        },
                        {
                            "area_id": 38412,
                            "city_id": 38130,
                            "province_id": 30,
                            "name": "阆中市",
                            "whole_name": "阆中市，南充市，四川省",
                            "simple_py": "LZS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0817",
                            "area_code": "511381",
                            "longitude": "105.975266",
                            "latitude": "31.580466"
                        },
                        {
                            "area_id": 38407,
                            "city_id": 38130,
                            "province_id": 30,
                            "name": "南部县",
                            "whole_name": "南部县，南充市，四川省",
                            "simple_py": "NBX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0817",
                            "area_code": "511321",
                            "longitude": "106.061138",
                            "latitude": "31.349407"
                        },
                        {
                            "area_id": 38408,
                            "city_id": 38130,
                            "province_id": 30,
                            "name": "蓬安县",
                            "whole_name": "蓬安县，南充市，四川省",
                            "simple_py": "PAX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0817",
                            "area_code": "511323",
                            "longitude": "106.413488",
                            "latitude": "31.027978"
                        },
                        {
                            "area_id": 38405,
                            "city_id": 38130,
                            "province_id": 30,
                            "name": "顺庆区",
                            "whole_name": "顺庆区，南充市，四川省",
                            "simple_py": "SQQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0817",
                            "area_code": "511302",
                            "longitude": "106.084091",
                            "latitude": "30.795572"
                        },
                        {
                            "area_id": 38410,
                            "city_id": 38130,
                            "province_id": 30,
                            "name": "西充县",
                            "whole_name": "西充县，南充市，四川省",
                            "simple_py": "XCX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0817",
                            "area_code": "511325",
                            "longitude": "105.893021",
                            "latitude": "30.994616"
                        },
                        {
                            "area_id": 38409,
                            "city_id": 38130,
                            "province_id": 30,
                            "name": "营山县",
                            "whole_name": "营山县，南充市，四川省",
                            "simple_py": "YSX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0817",
                            "area_code": "511322",
                            "longitude": "106.564893",
                            "latitude": "31.075907"
                        },
                        {
                            "area_id": 38411,
                            "city_id": 38130,
                            "province_id": 30,
                            "name": "仪陇县",
                            "whole_name": "仪陇县，南充市，四川省",
                            "simple_py": "YLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0817",
                            "area_code": "511324",
                            "longitude": "106.297083",
                            "latitude": "31.271261"
                        }
                    ]
                },
                {
                    "city_id": 38140,
                    "province_id": 30,
                    "name": "内江市",
                    "whole_name": "内江市，四川省",
                    "simple_py": "NJS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "N",
                    "city_code": "0832",
                    "area_code": "511000",
                    "longitude": "105.066138",
                    "latitude": "29.58708",
                    "children": [
                        {
                            "area_id": 40770,
                            "city_id": 38140,
                            "province_id": 30,
                            "name": "东兴区",
                            "whole_name": "东兴区，内江市，四川省",
                            "simple_py": "DXQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0832",
                            "area_code": "511011",
                            "longitude": "105.067203",
                            "latitude": "29.600107"
                        },
                        {
                            "area_id": 40771,
                            "city_id": 38140,
                            "province_id": 30,
                            "name": "隆昌市",
                            "whole_name": "隆昌市，内江市，四川省",
                            "simple_py": "LCS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0832",
                            "area_code": "511083",
                            "longitude": "105.288074",
                            "latitude": "29.338162"
                        },
                        {
                            "area_id": 40772,
                            "city_id": 38140,
                            "province_id": 30,
                            "name": "市中区",
                            "whole_name": "市中区，内江市，四川省",
                            "simple_py": "SZQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0832",
                            "area_code": "511002",
                            "longitude": "105.065467",
                            "latitude": "29.585265"
                        },
                        {
                            "area_id": 40769,
                            "city_id": 38140,
                            "province_id": 30,
                            "name": "威远县",
                            "whole_name": "威远县，内江市，四川省",
                            "simple_py": "WYX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0832",
                            "area_code": "511024",
                            "longitude": "104.668327",
                            "latitude": "29.52686"
                        },
                        {
                            "area_id": 40768,
                            "city_id": 38140,
                            "province_id": 30,
                            "name": "资中县",
                            "whole_name": "资中县，内江市，四川省",
                            "simple_py": "ZZX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0832",
                            "area_code": "511025",
                            "longitude": "104.852463",
                            "latitude": "29.775295"
                        }
                    ]
                },
                {
                    "city_id": 38144,
                    "province_id": 30,
                    "name": "攀枝花市",
                    "whole_name": "攀枝花市，四川省",
                    "simple_py": "PZHS",
                    "per_pin_yin": "P",
                    "per_pin_yin2": "P",
                    "city_code": "0812",
                    "area_code": "510400",
                    "longitude": "101.716007",
                    "latitude": "26.580446",
                    "children": [
                        {
                            "area_id": 41357,
                            "city_id": 38144,
                            "province_id": 30,
                            "name": "东区",
                            "whole_name": "东区，攀枝花市，四川省",
                            "simple_py": "DQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0812",
                            "area_code": "510402",
                            "longitude": "101.715134",
                            "latitude": "26.580887"
                        },
                        {
                            "area_id": 41355,
                            "city_id": 38144,
                            "province_id": 30,
                            "name": "米易县",
                            "whole_name": "米易县，攀枝花市，四川省",
                            "simple_py": "MYX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0812",
                            "area_code": "510421",
                            "longitude": "102.109877",
                            "latitude": "26.887474"
                        },
                        {
                            "area_id": 41358,
                            "city_id": 38144,
                            "province_id": 30,
                            "name": "仁和区",
                            "whole_name": "仁和区，攀枝花市，四川省",
                            "simple_py": "RHQ",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0812",
                            "area_code": "510411",
                            "longitude": "101.737916",
                            "latitude": "26.497185"
                        },
                        {
                            "area_id": 41356,
                            "city_id": 38144,
                            "province_id": 30,
                            "name": "西区",
                            "whole_name": "西区，攀枝花市，四川省",
                            "simple_py": "XQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0812",
                            "area_code": "510403",
                            "longitude": "101.637969",
                            "latitude": "26.596776"
                        },
                        {
                            "area_id": 41359,
                            "city_id": 38144,
                            "province_id": 30,
                            "name": "盐边县",
                            "whole_name": "盐边县，攀枝花市，四川省",
                            "simple_py": "YBX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0812",
                            "area_code": "510422",
                            "longitude": "101.851848",
                            "latitude": "26.677619"
                        }
                    ]
                },
                {
                    "city_id": 38134,
                    "province_id": 30,
                    "name": "遂宁市",
                    "whole_name": "遂宁市，四川省",
                    "simple_py": "SNS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0825",
                    "area_code": "510900",
                    "longitude": "105.571331",
                    "latitude": "30.513311",
                    "children": [
                        {
                            "area_id": 39433,
                            "city_id": 38134,
                            "province_id": 30,
                            "name": "安居区",
                            "whole_name": "安居区，遂宁市，四川省",
                            "simple_py": "AJQ",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0825",
                            "area_code": "510904",
                            "longitude": "105.459383",
                            "latitude": "30.346121"
                        },
                        {
                            "area_id": 39429,
                            "city_id": 38134,
                            "province_id": 30,
                            "name": "船山区",
                            "whole_name": "船山区，遂宁市，四川省",
                            "simple_py": "CSQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0825",
                            "area_code": "510903",
                            "longitude": "105.582215",
                            "latitude": "30.502647"
                        },
                        {
                            "area_id": 39430,
                            "city_id": 38134,
                            "province_id": 30,
                            "name": "大英县",
                            "whole_name": "大英县，遂宁市，四川省",
                            "simple_py": "DYX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0825",
                            "area_code": "510923",
                            "longitude": "105.252187",
                            "latitude": "30.581571"
                        },
                        {
                            "area_id": 39431,
                            "city_id": 38134,
                            "province_id": 30,
                            "name": "蓬溪县",
                            "whole_name": "蓬溪县，遂宁市，四川省",
                            "simple_py": "PXX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0825",
                            "area_code": "510921",
                            "longitude": "105.713699",
                            "latitude": "30.774883"
                        },
                        {
                            "area_id": 39432,
                            "city_id": 38134,
                            "province_id": 30,
                            "name": "射洪县",
                            "whole_name": "射洪县，遂宁市，四川省",
                            "simple_py": "SHX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0825",
                            "area_code": "510922",
                            "longitude": "105.381849",
                            "latitude": "30.868752"
                        }
                    ]
                },
                {
                    "city_id": 38141,
                    "province_id": 30,
                    "name": "宜宾市",
                    "whole_name": "宜宾市，四川省",
                    "simple_py": "YBS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0831",
                    "area_code": "511500",
                    "longitude": "104.630825",
                    "latitude": "28.760189",
                    "children": [
                        {
                            "area_id": 40895,
                            "city_id": 38141,
                            "province_id": 30,
                            "name": "长宁县",
                            "whole_name": "长宁县，宜宾市，四川省",
                            "simple_py": "CNX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0831",
                            "area_code": "511524",
                            "longitude": "104.921116",
                            "latitude": "28.577271"
                        },
                        {
                            "area_id": 40897,
                            "city_id": 38141,
                            "province_id": 30,
                            "name": "翠屏区",
                            "whole_name": "翠屏区，宜宾市，四川省",
                            "simple_py": "CPQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0831",
                            "area_code": "511502",
                            "longitude": "104.630231",
                            "latitude": "28.760179"
                        },
                        {
                            "area_id": 40896,
                            "city_id": 38141,
                            "province_id": 30,
                            "name": "珙县",
                            "whole_name": "珙县，宜宾市，四川省",
                            "simple_py": "GX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0831",
                            "area_code": "511526",
                            "longitude": "104.712268",
                            "latitude": "28.449041"
                        },
                        {
                            "area_id": 40900,
                            "city_id": 38141,
                            "province_id": 30,
                            "name": "高县",
                            "whole_name": "高县，宜宾市，四川省",
                            "simple_py": "GX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0831",
                            "area_code": "511525",
                            "longitude": "104.519187",
                            "latitude": "28.435676"
                        },
                        {
                            "area_id": 40898,
                            "city_id": 38141,
                            "province_id": 30,
                            "name": "江安县",
                            "whole_name": "江安县，宜宾市，四川省",
                            "simple_py": "JAX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0831",
                            "area_code": "511523",
                            "longitude": "105.068697",
                            "latitude": "28.728102"
                        },
                        {
                            "area_id": 40899,
                            "city_id": 38141,
                            "province_id": 30,
                            "name": "南溪区",
                            "whole_name": "南溪区，宜宾市，四川省",
                            "simple_py": "NXQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0831",
                            "area_code": "511503",
                            "longitude": "104.981133",
                            "latitude": "28.839806"
                        },
                        {
                            "area_id": 40903,
                            "city_id": 38141,
                            "province_id": 30,
                            "name": "屏山县",
                            "whole_name": "屏山县，宜宾市，四川省",
                            "simple_py": "PSX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0831",
                            "area_code": "511529",
                            "longitude": "104.162617",
                            "latitude": "28.64237"
                        },
                        {
                            "area_id": 40902,
                            "city_id": 38141,
                            "province_id": 30,
                            "name": "兴文县",
                            "whole_name": "兴文县，宜宾市，四川省",
                            "simple_py": "XWX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0831",
                            "area_code": "511528",
                            "longitude": "105.236549",
                            "latitude": "28.302988"
                        },
                        {
                            "area_id": 40901,
                            "city_id": 38141,
                            "province_id": 30,
                            "name": "筠连县",
                            "whole_name": "筠连县，宜宾市，四川省",
                            "simple_py": "YLX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0831",
                            "area_code": "511527",
                            "longitude": "104.507848",
                            "latitude": "28.162017"
                        },
                        {
                            "area_id": 40904,
                            "city_id": 38141,
                            "province_id": 30,
                            "name": "宜宾县",
                            "whole_name": "宜宾县，宜宾市，四川省",
                            "simple_py": "YBX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0831",
                            "area_code": "511521",
                            "longitude": "104.541489",
                            "latitude": "28.695678"
                        }
                    ]
                },
                {
                    "city_id": 38143,
                    "province_id": 30,
                    "name": "雅安市",
                    "whole_name": "雅安市，四川省",
                    "simple_py": "YAS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Y",
                    "city_code": "0835",
                    "area_code": "511800",
                    "longitude": "103.001033",
                    "latitude": "29.987722",
                    "children": [
                        {
                            "area_id": 41204,
                            "city_id": 38143,
                            "province_id": 30,
                            "name": "宝兴县",
                            "whole_name": "宝兴县，雅安市，四川省",
                            "simple_py": "BXX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0835",
                            "area_code": "511827",
                            "longitude": "102.813377",
                            "latitude": "30.369026"
                        },
                        {
                            "area_id": 41207,
                            "city_id": 38143,
                            "province_id": 30,
                            "name": "汉源县",
                            "whole_name": "汉源县，雅安市，四川省",
                            "simple_py": "HYX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0835",
                            "area_code": "511823",
                            "longitude": "102.677145",
                            "latitude": "29.349915"
                        },
                        {
                            "area_id": 41208,
                            "city_id": 38143,
                            "province_id": 30,
                            "name": "芦山县",
                            "whole_name": "芦山县，雅安市，四川省",
                            "simple_py": "LSX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0835",
                            "area_code": "511826",
                            "longitude": "102.924016",
                            "latitude": "30.152907"
                        },
                        {
                            "area_id": 41211,
                            "city_id": 38143,
                            "province_id": 30,
                            "name": "名山区",
                            "whole_name": "名山区，雅安市，四川省",
                            "simple_py": "MSQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0835",
                            "area_code": "511803",
                            "longitude": "103.112214",
                            "latitude": "30.084718"
                        },
                        {
                            "area_id": 41206,
                            "city_id": 38143,
                            "province_id": 30,
                            "name": "石棉县",
                            "whole_name": "石棉县，雅安市，四川省",
                            "simple_py": "SMX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0835",
                            "area_code": "511824",
                            "longitude": "102.35962",
                            "latitude": "29.234063"
                        },
                        {
                            "area_id": 41209,
                            "city_id": 38143,
                            "province_id": 30,
                            "name": "天全县",
                            "whole_name": "天全县，雅安市，四川省",
                            "simple_py": "TQX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0835",
                            "area_code": "511825",
                            "longitude": "102.763462",
                            "latitude": "30.059955"
                        },
                        {
                            "area_id": 41210,
                            "city_id": 38143,
                            "province_id": 30,
                            "name": "荥经县",
                            "whole_name": "荥经县，雅安市，四川省",
                            "simple_py": "XJX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0835",
                            "area_code": "511822",
                            "longitude": "102.844674",
                            "latitude": "29.795529"
                        },
                        {
                            "area_id": 41205,
                            "city_id": 38143,
                            "province_id": 30,
                            "name": "雨城区",
                            "whole_name": "雨城区，雅安市，四川省",
                            "simple_py": "YCQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0835",
                            "area_code": "511802",
                            "longitude": "103.003398",
                            "latitude": "29.981831"
                        }
                    ]
                },
                {
                    "city_id": 38137,
                    "province_id": 30,
                    "name": "资阳市",
                    "whole_name": "资阳市，四川省",
                    "simple_py": "ZYS",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "028",
                    "area_code": "512000",
                    "longitude": "104.641917",
                    "latitude": "30.122211",
                    "children": [
                        {
                            "area_id": 39952,
                            "city_id": 38137,
                            "province_id": 30,
                            "name": "安岳县",
                            "whole_name": "安岳县，资阳市，四川省",
                            "simple_py": "AYX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "028",
                            "area_code": "512021",
                            "longitude": "105.336764",
                            "latitude": "30.099206"
                        },
                        {
                            "area_id": 39951,
                            "city_id": 38137,
                            "province_id": 30,
                            "name": "乐至县",
                            "whole_name": "乐至县，资阳市，四川省",
                            "simple_py": "LZX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "028",
                            "area_code": "512022",
                            "longitude": "105.031142",
                            "latitude": "30.275619"
                        },
                        {
                            "area_id": 39950,
                            "city_id": 38137,
                            "province_id": 30,
                            "name": "雁江区",
                            "whole_name": "雁江区，资阳市，四川省",
                            "simple_py": "YJQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "028",
                            "area_code": "512002",
                            "longitude": "104.642338",
                            "latitude": "30.121686"
                        }
                    ]
                },
                {
                    "city_id": 38142,
                    "province_id": 30,
                    "name": "自贡市",
                    "whole_name": "自贡市，四川省",
                    "simple_py": "ZGS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Z",
                    "city_code": "0813",
                    "area_code": "510300",
                    "longitude": "104.773447",
                    "latitude": "29.352765",
                    "children": [
                        {
                            "area_id": 41094,
                            "city_id": 38142,
                            "province_id": 30,
                            "name": "大安区",
                            "whole_name": "大安区，自贡市，四川省",
                            "simple_py": "DAQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0813",
                            "area_code": "510304",
                            "longitude": "104.783229",
                            "latitude": "29.367136"
                        },
                        {
                            "area_id": 41093,
                            "city_id": 38142,
                            "province_id": 30,
                            "name": "富顺县",
                            "whole_name": "富顺县，自贡市，四川省",
                            "simple_py": "FSX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0813",
                            "area_code": "510322",
                            "longitude": "104.984256",
                            "latitude": "29.181282"
                        },
                        {
                            "area_id": 41091,
                            "city_id": 38142,
                            "province_id": 30,
                            "name": "贡井区",
                            "whole_name": "贡井区，自贡市，四川省",
                            "simple_py": "GJQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0813",
                            "area_code": "510303",
                            "longitude": "104.714372",
                            "latitude": "29.345675"
                        },
                        {
                            "area_id": 41090,
                            "city_id": 38142,
                            "province_id": 30,
                            "name": "荣县",
                            "whole_name": "荣县，自贡市，四川省",
                            "simple_py": "RX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0813",
                            "area_code": "510321",
                            "longitude": "104.423932",
                            "latitude": "29.454851"
                        },
                        {
                            "area_id": 41092,
                            "city_id": 38142,
                            "province_id": 30,
                            "name": "沿滩区",
                            "whole_name": "沿滩区，自贡市，四川省",
                            "simple_py": "YTQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0813",
                            "area_code": "510311",
                            "longitude": "104.876417",
                            "latitude": "29.272521"
                        },
                        {
                            "area_id": 41095,
                            "city_id": 38142,
                            "province_id": 30,
                            "name": "自流井区",
                            "whole_name": "自流井区，自贡市，四川省",
                            "simple_py": "ZLJQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0813",
                            "area_code": "510302",
                            "longitude": "104.778188",
                            "latitude": "29.343231"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 27,
            "name": "台湾省",
            "whole_name": "台湾省",
            "simple_py": "TWS",
            "per_pin_yin": "T",
            "per_pin_yin2": "T",
            "city_code": "",
            "area_code": "710000",
            "longitude": "121.509062",
            "latitude": "25.044332",
            "children": []
        },
        {
            "province_id": 33,
            "name": "天津市",
            "whole_name": "天津市",
            "simple_py": "TJS",
            "per_pin_yin": " ",
            "per_pin_yin2": "T",
            "city_code": "",
            "area_code": "120000",
            "longitude": "117.190182",
            "latitude": "39.125596",
            "children": [
                {
                    "city_id": 44886,
                    "province_id": 33,
                    "name": "天津城区",
                    "whole_name": "天津城区，天津市",
                    "simple_py": "TJCQ",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "",
                    "area_code": "120100",
                    "longitude": "117.190182",
                    "latitude": "39.125596",
                    "children": [
                        {
                            "area_id": 44891,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "宝坻区",
                            "whole_name": "宝坻区，天津城区，天津市",
                            "simple_py": "BDQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "022",
                            "area_code": "120115",
                            "longitude": "117.308094",
                            "latitude": "39.716965"
                        },
                        {
                            "area_id": 44897,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "滨海新区",
                            "whole_name": "滨海新区，天津城区，天津市",
                            "simple_py": "BHXQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "022",
                            "area_code": "120116",
                            "longitude": "117.654173",
                            "latitude": "39.032846"
                        },
                        {
                            "area_id": 44898,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "北辰区",
                            "whole_name": "北辰区，天津城区，天津市",
                            "simple_py": "BCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "022",
                            "area_code": "120113",
                            "longitude": "117.13482",
                            "latitude": "39.225555"
                        },
                        {
                            "area_id": 44893,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "东丽区",
                            "whole_name": "东丽区，天津城区，天津市",
                            "simple_py": "DLQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "022",
                            "area_code": "120110",
                            "longitude": "117.313967",
                            "latitude": "39.087764"
                        },
                        {
                            "area_id": 44887,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "河西区",
                            "whole_name": "河西区，天津城区，天津市",
                            "simple_py": "HXQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "022",
                            "area_code": "120103",
                            "longitude": "117.217536",
                            "latitude": "39.101897"
                        },
                        {
                            "area_id": 44888,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "河东区",
                            "whole_name": "河东区，天津城区，天津市",
                            "simple_py": "HDQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "022",
                            "area_code": "120102",
                            "longitude": "117.226568",
                            "latitude": "39.122125"
                        },
                        {
                            "area_id": 44889,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "河北区",
                            "whole_name": "河北区，天津城区，天津市",
                            "simple_py": "HBQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "022",
                            "area_code": "120105",
                            "longitude": "117.201569",
                            "latitude": "39.156632"
                        },
                        {
                            "area_id": 44890,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "和平区",
                            "whole_name": "和平区，天津城区，天津市",
                            "simple_py": "HPQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "022",
                            "area_code": "120101",
                            "longitude": "117.195907",
                            "latitude": "39.118327"
                        },
                        {
                            "area_id": 44900,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "红桥区",
                            "whole_name": "红桥区，天津城区，天津市",
                            "simple_py": "HQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "022",
                            "area_code": "120106",
                            "longitude": "117.163301",
                            "latitude": "39.175066"
                        },
                        {
                            "area_id": 44892,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "津南区",
                            "whole_name": "津南区，天津城区，天津市",
                            "simple_py": "JNQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "022",
                            "area_code": "120112",
                            "longitude": "117.382549",
                            "latitude": "38.989577"
                        },
                        {
                            "area_id": 44894,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "静海区",
                            "whole_name": "静海区，天津城区，天津市",
                            "simple_py": "JHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "022",
                            "area_code": "120118",
                            "longitude": "116.925304",
                            "latitude": "38.935671"
                        },
                        {
                            "area_id": 44896,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "蓟州区",
                            "whole_name": "蓟州区，天津城区，天津市",
                            "simple_py": "JZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "022",
                            "area_code": "120119",
                            "longitude": "117.407449",
                            "latitude": "40.045342"
                        },
                        {
                            "area_id": 44895,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "宁河区",
                            "whole_name": "宁河区，天津城区，天津市",
                            "simple_py": "NHQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "022",
                            "area_code": "120117",
                            "longitude": "117.82828",
                            "latitude": "39.328886"
                        },
                        {
                            "area_id": 44902,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "南开区",
                            "whole_name": "南开区，天津城区，天津市",
                            "simple_py": "NKQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "022",
                            "area_code": "120104",
                            "longitude": "117.164143",
                            "latitude": "39.120474"
                        },
                        {
                            "area_id": 44899,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "武清区",
                            "whole_name": "武清区，天津城区，天津市",
                            "simple_py": "WQQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "022",
                            "area_code": "120114",
                            "longitude": "117.057959",
                            "latitude": "39.376925"
                        },
                        {
                            "area_id": 44901,
                            "city_id": 44886,
                            "province_id": 33,
                            "name": "西青区",
                            "whole_name": "西青区，天津城区，天津市",
                            "simple_py": "XQQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "022",
                            "area_code": "120111",
                            "longitude": "117.012247",
                            "latitude": "39.139446"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 5,
            "name": "新疆维吾尔自治区",
            "whole_name": "新疆维吾尔自治区",
            "simple_py": "XJWWEZZQ",
            "per_pin_yin": "X",
            "per_pin_yin2": "X",
            "city_code": "",
            "area_code": "650000",
            "longitude": "87.617733",
            "latitude": "43.792818",
            "children": [
                {
                    "city_id": 7946,
                    "province_id": 5,
                    "name": "阿勒泰地区",
                    "whole_name": "阿勒泰地区，新疆维吾尔自治区",
                    "simple_py": "ALTDQ",
                    "per_pin_yin": "A",
                    "per_pin_yin2": "A",
                    "city_code": "0906",
                    "area_code": "654300",
                    "longitude": "88.13963",
                    "latitude": "47.848393",
                    "children": [
                        {
                            "area_id": 8286,
                            "city_id": 7946,
                            "province_id": 5,
                            "name": "阿勒泰市",
                            "whole_name": "阿勒泰市，阿勒泰地区，新疆维吾尔自治区",
                            "simple_py": "ALTS",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0906",
                            "area_code": "654301",
                            "longitude": "88.138743",
                            "latitude": "47.848911"
                        },
                        {
                            "area_id": 8283,
                            "city_id": 7946,
                            "province_id": 5,
                            "name": "布尔津县",
                            "whole_name": "布尔津县，阿勒泰地区，新疆维吾尔自治区",
                            "simple_py": "BEJX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0906",
                            "area_code": "654321",
                            "longitude": "86.86186",
                            "latitude": "47.70453"
                        },
                        {
                            "area_id": 8284,
                            "city_id": 7946,
                            "province_id": 5,
                            "name": "富蕴县",
                            "whole_name": "富蕴县，阿勒泰地区，新疆维吾尔自治区",
                            "simple_py": "FYX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0906",
                            "area_code": "654322",
                            "longitude": "89.524993",
                            "latitude": "46.993106"
                        },
                        {
                            "area_id": 8287,
                            "city_id": 7946,
                            "province_id": 5,
                            "name": "福海县",
                            "whole_name": "福海县，阿勒泰地区，新疆维吾尔自治区",
                            "simple_py": "FHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "F",
                            "city_code": "0906",
                            "area_code": "654323",
                            "longitude": "87.494569",
                            "latitude": "47.113128"
                        },
                        {
                            "area_id": 8281,
                            "city_id": 7946,
                            "province_id": 5,
                            "name": "哈巴河县",
                            "whole_name": "哈巴河县，阿勒泰地区，新疆维吾尔自治区",
                            "simple_py": "HBHX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0906",
                            "area_code": "654324",
                            "longitude": "86.418964",
                            "latitude": "48.059284"
                        },
                        {
                            "area_id": 8282,
                            "city_id": 7946,
                            "province_id": 5,
                            "name": "吉木乃县",
                            "whole_name": "吉木乃县，阿勒泰地区，新疆维吾尔自治区",
                            "simple_py": "JMNX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0906",
                            "area_code": "654326",
                            "longitude": "85.876064",
                            "latitude": "47.434633"
                        },
                        {
                            "area_id": 8285,
                            "city_id": 7946,
                            "province_id": 5,
                            "name": "青河县",
                            "whole_name": "青河县，阿勒泰地区，新疆维吾尔自治区",
                            "simple_py": "QHX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0906",
                            "area_code": "654325",
                            "longitude": "90.381561",
                            "latitude": "46.672446"
                        }
                    ]
                },
                {
                    "city_id": 7951,
                    "province_id": 5,
                    "name": "阿拉尔市",
                    "whole_name": "阿拉尔市，新疆维吾尔自治区",
                    "simple_py": "ALES",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "A",
                    "city_code": "0997",
                    "area_code": "659002",
                    "longitude": "81.285884",
                    "latitude": "40.541914",
                    "children": [
                        {
                            "area_id": 8622,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "阿拉尔农场",
                            "whole_name": "阿拉尔农场，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "ALENC",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.0627",
                            "latitude": "40.5567"
                        },
                        {
                            "area_id": 8624,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "兵团第一师幸福农场",
                            "whole_name": "兵团第一师幸福农场，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "BTDYSXFNC",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "80.9904",
                            "latitude": "40.7025"
                        },
                        {
                            "area_id": 8626,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "兵团七团",
                            "whole_name": "兵团七团，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "BTQT",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "80.6543",
                            "latitude": "40.6569"
                        },
                        {
                            "area_id": 8627,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "兵团十一团",
                            "whole_name": "兵团十一团，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "BTSYT",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.5619",
                            "latitude": "40.6277"
                        },
                        {
                            "area_id": 8628,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "兵团第一师水利水电工程处",
                            "whole_name": "兵团第一师水利水电工程处，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "BTDYSSLSDGCC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.2858",
                            "latitude": "40.5496"
                        },
                        {
                            "area_id": 8631,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "兵团八团",
                            "whole_name": "兵团八团，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "BTBT",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "80.7996",
                            "latitude": "40.5973"
                        },
                        {
                            "area_id": 8633,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "兵团第一师塔里木灌区水利管理处",
                            "whole_name": "兵团第一师塔里木灌区水利管理处，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "BTDYSTLMGQSLGLC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.2876",
                            "latitude": "40.5454"
                        },
                        {
                            "area_id": 8634,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "兵团十四团",
                            "whole_name": "兵团十四团，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "BTSST",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.8688",
                            "latitude": "40.9423"
                        },
                        {
                            "area_id": 8635,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "兵团十二团",
                            "whole_name": "兵团十二团，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "BTSET",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.1109",
                            "latitude": "40.4977"
                        },
                        {
                            "area_id": 8636,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "兵团十三团",
                            "whole_name": "兵团十三团，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "BTSST",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.4734",
                            "latitude": "40.5742"
                        },
                        {
                            "area_id": 8638,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "兵团十六团",
                            "whole_name": "兵团十六团，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "BTSLT",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "80.7871",
                            "latitude": "40.4163"
                        },
                        {
                            "area_id": 8639,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "兵团十团",
                            "whole_name": "兵团十团，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "BTST",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.259",
                            "latitude": "40.6387"
                        },
                        {
                            "area_id": 8625,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "工业园区",
                            "whole_name": "工业园区，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "GYYQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.2448",
                            "latitude": "40.5461"
                        },
                        {
                            "area_id": 8637,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "金银川路街道",
                            "whole_name": "金银川路街道，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "JYCLJD",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.2613",
                            "latitude": "40.5355"
                        },
                        {
                            "area_id": 8640,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "南口街道",
                            "whole_name": "南口街道，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "NKJD",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.2988",
                            "latitude": "40.5154"
                        },
                        {
                            "area_id": 8629,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "青松路街道",
                            "whole_name": "青松路街道，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "QSLJD",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.2545",
                            "latitude": "40.542"
                        },
                        {
                            "area_id": 8630,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "托喀依乡",
                            "whole_name": "托喀依乡，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "TKYX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.3541",
                            "latitude": "40.5818"
                        },
                        {
                            "area_id": 8623,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "幸福路街道",
                            "whole_name": "幸福路街道，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "XFLJD",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.2681",
                            "latitude": "40.577"
                        },
                        {
                            "area_id": 8632,
                            "city_id": 7951,
                            "province_id": 5,
                            "name": "中心监狱",
                            "whole_name": "中心监狱，阿拉尔市，新疆维吾尔自治区",
                            "simple_py": "ZXJY",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0997",
                            "area_code": "659002",
                            "longitude": "81.2766",
                            "latitude": "40.6692"
                        }
                    ]
                },
                {
                    "city_id": 7956,
                    "province_id": 5,
                    "name": "阿克苏地区",
                    "whole_name": "阿克苏地区，新疆维吾尔自治区",
                    "simple_py": "AKSDQ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "A",
                    "city_code": "0997",
                    "area_code": "652900",
                    "longitude": "80.265068",
                    "latitude": "41.170712",
                    "children": [
                        {
                            "area_id": 9167,
                            "city_id": 7956,
                            "province_id": 5,
                            "name": "阿克苏市",
                            "whole_name": "阿克苏市，阿克苏地区，新疆维吾尔自治区",
                            "simple_py": "AKSS",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0997",
                            "area_code": "652901",
                            "longitude": "80.2629",
                            "latitude": "41.171272"
                        },
                        {
                            "area_id": 9169,
                            "city_id": 7956,
                            "province_id": 5,
                            "name": "阿瓦提县",
                            "whole_name": "阿瓦提县，阿克苏地区，新疆维吾尔自治区",
                            "simple_py": "AWTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "A",
                            "city_code": "0997",
                            "area_code": "652928",
                            "longitude": "80.378426",
                            "latitude": "40.638422"
                        },
                        {
                            "area_id": 9164,
                            "city_id": 7956,
                            "province_id": 5,
                            "name": "拜城县",
                            "whole_name": "拜城县，阿克苏地区，新疆维吾尔自治区",
                            "simple_py": "BCX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0997",
                            "area_code": "652926",
                            "longitude": "81.869881",
                            "latitude": "41.796101"
                        },
                        {
                            "area_id": 9166,
                            "city_id": 7956,
                            "province_id": 5,
                            "name": "库车县",
                            "whole_name": "库车县，阿克苏地区，新疆维吾尔自治区",
                            "simple_py": "KCX",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0997",
                            "area_code": "652923",
                            "longitude": "82.96304",
                            "latitude": "41.717141"
                        },
                        {
                            "area_id": 9168,
                            "city_id": 7956,
                            "province_id": 5,
                            "name": "柯坪县",
                            "whole_name": "柯坪县，阿克苏地区，新疆维吾尔自治区",
                            "simple_py": "KPX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "K",
                            "city_code": "0997",
                            "area_code": "652929",
                            "longitude": "79.04785",
                            "latitude": "40.50624"
                        },
                        {
                            "area_id": 9162,
                            "city_id": 7956,
                            "province_id": 5,
                            "name": "沙雅县",
                            "whole_name": "沙雅县，阿克苏地区，新疆维吾尔自治区",
                            "simple_py": "SYX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0997",
                            "area_code": "652924",
                            "longitude": "82.78077",
                            "latitude": "41.226268"
                        },
                        {
                            "area_id": 9163,
                            "city_id": 7956,
                            "province_id": 5,
                            "name": "温宿县",
                            "whole_name": "温宿县，阿克苏地区，新疆维吾尔自治区",
                            "simple_py": "WSX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0997",
                            "area_code": "652922",
                            "longitude": "80.243273",
                            "latitude": "41.272995"
                        },
                        {
                            "area_id": 9170,
                            "city_id": 7956,
                            "province_id": 5,
                            "name": "乌什县",
                            "whole_name": "乌什县，阿克苏地区，新疆维吾尔自治区",
                            "simple_py": "WSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0997",
                            "area_code": "652927",
                            "longitude": "79.230805",
                            "latitude": "41.21587"
                        },
                        {
                            "area_id": 9165,
                            "city_id": 7956,
                            "province_id": 5,
                            "name": "新和县",
                            "whole_name": "新和县，阿克苏地区，新疆维吾尔自治区",
                            "simple_py": "XHX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0997",
                            "area_code": "652925",
                            "longitude": "82.610828",
                            "latitude": "41.551176"
                        }
                    ]
                },
                {
                    "city_id": 7937,
                    "province_id": 5,
                    "name": "北屯市",
                    "whole_name": "北屯市，新疆维吾尔自治区",
                    "simple_py": "BTS",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "0906",
                    "area_code": "659005",
                    "longitude": "87.824932",
                    "latitude": "47.353177",
                    "children": [
                        {
                            "area_id": 7960,
                            "city_id": 7937,
                            "province_id": 5,
                            "name": "北屯镇",
                            "whole_name": "北屯镇，北屯市，新疆维吾尔自治区",
                            "simple_py": "BTZ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0906",
                            "area_code": "659005",
                            "longitude": "87.7224",
                            "latitude": "47.4017"
                        },
                        {
                            "area_id": 7961,
                            "city_id": 7937,
                            "province_id": 5,
                            "name": "兵团一八八团",
                            "whole_name": "兵团一八八团，北屯市，新疆维吾尔自治区",
                            "simple_py": "BTYBBT",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0906",
                            "area_code": "659005",
                            "longitude": "87.5186",
                            "latitude": "47.4099"
                        },
                        {
                            "area_id": 7962,
                            "city_id": 7937,
                            "province_id": 5,
                            "name": "兵团一八三团",
                            "whole_name": "兵团一八三团，北屯市，新疆维吾尔自治区",
                            "simple_py": "BTYBST",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0906",
                            "area_code": "659005",
                            "longitude": "88.1187",
                            "latitude": "47.1285"
                        },
                        {
                            "area_id": 7963,
                            "city_id": 7937,
                            "province_id": 5,
                            "name": "兵团一八七团",
                            "whole_name": "兵团一八七团，北屯市，新疆维吾尔自治区",
                            "simple_py": "BTYBQT",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0906",
                            "area_code": "659005",
                            "longitude": "87.761",
                            "latitude": "47.1948"
                        }
                    ]
                },
                {
                    "city_id": 7940,
                    "province_id": 5,
                    "name": "博尔塔拉蒙古自治州",
                    "whole_name": "博尔塔拉蒙古自治州，新疆维吾尔自治区",
                    "simple_py": "BETLMGZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "B",
                    "city_code": "0909",
                    "area_code": "652700",
                    "longitude": "82.074778",
                    "latitude": "44.903258",
                    "children": [
                        {
                            "area_id": 7972,
                            "city_id": 7940,
                            "province_id": 5,
                            "name": "阿拉山口市",
                            "whole_name": "阿拉山口市，博尔塔拉蒙古自治州，新疆维吾尔自治区",
                            "simple_py": "ALSKS",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0909",
                            "area_code": "652702",
                            "longitude": "82.569389",
                            "latitude": "45.16777"
                        },
                        {
                            "area_id": 7973,
                            "city_id": 7940,
                            "province_id": 5,
                            "name": "博乐市",
                            "whole_name": "博乐市，博尔塔拉蒙古自治州，新疆维吾尔自治区",
                            "simple_py": "BLS",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0909",
                            "area_code": "652701",
                            "longitude": "82.072237",
                            "latitude": "44.903087"
                        },
                        {
                            "area_id": 7974,
                            "city_id": 7940,
                            "province_id": 5,
                            "name": "精河县",
                            "whole_name": "精河县，博尔塔拉蒙古自治州，新疆维吾尔自治区",
                            "simple_py": "JHX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0909",
                            "area_code": "652722",
                            "longitude": "82.892938",
                            "latitude": "44.605645"
                        },
                        {
                            "area_id": 7971,
                            "city_id": 7940,
                            "province_id": 5,
                            "name": "温泉县",
                            "whole_name": "温泉县，博尔塔拉蒙古自治州，新疆维吾尔自治区",
                            "simple_py": "WQX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0909",
                            "area_code": "652723",
                            "longitude": "81.03099",
                            "latitude": "44.973751"
                        }
                    ]
                },
                {
                    "city_id": 7950,
                    "province_id": 5,
                    "name": "巴音郭楞蒙古自治州",
                    "whole_name": "巴音郭楞蒙古自治州，新疆维吾尔自治区",
                    "simple_py": "BYGLMGZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "B",
                    "city_code": "0996",
                    "area_code": "652800",
                    "longitude": "86.150969",
                    "latitude": "41.768552",
                    "children": [
                        {
                            "area_id": 8499,
                            "city_id": 7950,
                            "province_id": 5,
                            "name": "博湖县",
                            "whole_name": "博湖县，巴音郭楞蒙古自治州，新疆维吾尔自治区",
                            "simple_py": "BHX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0996",
                            "area_code": "652829",
                            "longitude": "86.631576",
                            "latitude": "41.980166"
                        },
                        {
                            "area_id": 8495,
                            "city_id": 7950,
                            "province_id": 5,
                            "name": "和硕县",
                            "whole_name": "和硕县，巴音郭楞蒙古自治州，新疆维吾尔自治区",
                            "simple_py": "HSX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0996",
                            "area_code": "652828",
                            "longitude": "86.864947",
                            "latitude": "42.268863"
                        },
                        {
                            "area_id": 8496,
                            "city_id": 7950,
                            "province_id": 5,
                            "name": "和静县",
                            "whole_name": "和静县，巴音郭楞蒙古自治州，新疆维吾尔自治区",
                            "simple_py": "HJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0996",
                            "area_code": "652827",
                            "longitude": "86.391067",
                            "latitude": "42.31716"
                        },
                        {
                            "area_id": 8502,
                            "city_id": 7950,
                            "province_id": 5,
                            "name": "库尔勒市",
                            "whole_name": "库尔勒市，巴音郭楞蒙古自治州，新疆维吾尔自治区",
                            "simple_py": "KELS",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0996",
                            "area_code": "652801",
                            "longitude": "86.145948",
                            "latitude": "41.763122"
                        },
                        {
                            "area_id": 8503,
                            "city_id": 7950,
                            "province_id": 5,
                            "name": "轮台县",
                            "whole_name": "轮台县，巴音郭楞蒙古自治州，新疆维吾尔自治区",
                            "simple_py": "LTX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0996",
                            "area_code": "652822",
                            "longitude": "84.248542",
                            "latitude": "41.781266"
                        },
                        {
                            "area_id": 8501,
                            "city_id": 7950,
                            "province_id": 5,
                            "name": "且末县",
                            "whole_name": "且末县，巴音郭楞蒙古自治州，新疆维吾尔自治区",
                            "simple_py": "QMX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0996",
                            "area_code": "652825",
                            "longitude": "85.532629",
                            "latitude": "38.138562"
                        },
                        {
                            "area_id": 8498,
                            "city_id": 7950,
                            "province_id": 5,
                            "name": "若羌县",
                            "whole_name": "若羌县，巴音郭楞蒙古自治州，新疆维吾尔自治区",
                            "simple_py": "RQX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0996",
                            "area_code": "652824",
                            "longitude": "88.168807",
                            "latitude": "39.023807"
                        },
                        {
                            "area_id": 8497,
                            "city_id": 7950,
                            "province_id": 5,
                            "name": "尉犁县",
                            "whole_name": "尉犁县，巴音郭楞蒙古自治州，新疆维吾尔自治区",
                            "simple_py": "YLX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0996",
                            "area_code": "652823",
                            "longitude": "86.263412",
                            "latitude": "41.337428"
                        },
                        {
                            "area_id": 8500,
                            "city_id": 7950,
                            "province_id": 5,
                            "name": "焉耆回族自治县",
                            "whole_name": "焉耆回族自治县，巴音郭楞蒙古自治州，新疆维吾尔自治区",
                            "simple_py": "YQHZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0996",
                            "area_code": "652826",
                            "longitude": "86.5698",
                            "latitude": "42.064349"
                        }
                    ]
                },
                {
                    "city_id": 7948,
                    "province_id": 5,
                    "name": "昌吉回族自治州",
                    "whole_name": "昌吉回族自治州，新疆维吾尔自治区",
                    "simple_py": "CJHZZZZ",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0994",
                    "area_code": "652300",
                    "longitude": "87.304012",
                    "latitude": "44.014577",
                    "children": [
                        {
                            "area_id": 8380,
                            "city_id": 7948,
                            "province_id": 5,
                            "name": "昌吉市",
                            "whole_name": "昌吉市，昌吉回族自治州，新疆维吾尔自治区",
                            "simple_py": "CJS",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0994",
                            "area_code": "652301",
                            "longitude": "87.304112",
                            "latitude": "44.013183"
                        },
                        {
                            "area_id": 8379,
                            "city_id": 7948,
                            "province_id": 5,
                            "name": "阜康市",
                            "whole_name": "阜康市，昌吉回族自治州，新疆维吾尔自治区",
                            "simple_py": "FKS",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0994",
                            "area_code": "652302",
                            "longitude": "87.98384",
                            "latitude": "44.152153"
                        },
                        {
                            "area_id": 8378,
                            "city_id": 7948,
                            "province_id": 5,
                            "name": "呼图壁县",
                            "whole_name": "呼图壁县，昌吉回族自治州，新疆维吾尔自治区",
                            "simple_py": "HTBX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0994",
                            "area_code": "652323",
                            "longitude": "86.888613",
                            "latitude": "44.189342"
                        },
                        {
                            "area_id": 8381,
                            "city_id": 7948,
                            "province_id": 5,
                            "name": "吉木萨尔县",
                            "whole_name": "吉木萨尔县，昌吉回族自治州，新疆维吾尔自治区",
                            "simple_py": "JMSEX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0994",
                            "area_code": "652327",
                            "longitude": "89.181288",
                            "latitude": "43.997162"
                        },
                        {
                            "area_id": 8376,
                            "city_id": 7948,
                            "province_id": 5,
                            "name": "木垒哈萨克自治县",
                            "whole_name": "木垒哈萨克自治县，昌吉回族自治州，新疆维吾尔自治区",
                            "simple_py": "MLHSKZZX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0994",
                            "area_code": "652328",
                            "longitude": "90.282833",
                            "latitude": "43.832442"
                        },
                        {
                            "area_id": 8377,
                            "city_id": 7948,
                            "province_id": 5,
                            "name": "玛纳斯县",
                            "whole_name": "玛纳斯县，昌吉回族自治州，新疆维吾尔自治区",
                            "simple_py": "MNSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0994",
                            "area_code": "652324",
                            "longitude": "86.217687",
                            "latitude": "44.305625"
                        },
                        {
                            "area_id": 8375,
                            "city_id": 7948,
                            "province_id": 5,
                            "name": "奇台县",
                            "whole_name": "奇台县，昌吉回族自治州，新疆维吾尔自治区",
                            "simple_py": "QTX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0994",
                            "area_code": "652325",
                            "longitude": "89.591437",
                            "latitude": "44.021996"
                        }
                    ]
                },
                {
                    "city_id": 7941,
                    "province_id": 5,
                    "name": "和田地区",
                    "whole_name": "和田地区，新疆维吾尔自治区",
                    "simple_py": "HTDQ",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0903",
                    "area_code": "653200",
                    "longitude": "79.92533",
                    "latitude": "37.110687",
                    "children": [
                        {
                            "area_id": 8015,
                            "city_id": 7941,
                            "province_id": 5,
                            "name": "策勒县",
                            "whole_name": "策勒县，和田地区，新疆维吾尔自治区",
                            "simple_py": "CLX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0903",
                            "area_code": "653225",
                            "longitude": "80.803572",
                            "latitude": "37.001672"
                        },
                        {
                            "area_id": 8010,
                            "city_id": 7941,
                            "province_id": 5,
                            "name": "和田市",
                            "whole_name": "和田市，和田地区，新疆维吾尔自治区",
                            "simple_py": "HTS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0903",
                            "area_code": "653201",
                            "longitude": "79.927542",
                            "latitude": "37.108944"
                        },
                        {
                            "area_id": 8013,
                            "city_id": 7941,
                            "province_id": 5,
                            "name": "和田县",
                            "whole_name": "和田县，和田地区，新疆维吾尔自治区",
                            "simple_py": "HTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0903",
                            "area_code": "653221",
                            "longitude": "79.81907",
                            "latitude": "37.120031"
                        },
                        {
                            "area_id": 8011,
                            "city_id": 7941,
                            "province_id": 5,
                            "name": "洛浦县",
                            "whole_name": "洛浦县，和田地区，新疆维吾尔自治区",
                            "simple_py": "LPX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0903",
                            "area_code": "653224",
                            "longitude": "80.184038",
                            "latitude": "37.074377"
                        },
                        {
                            "area_id": 8008,
                            "city_id": 7941,
                            "province_id": 5,
                            "name": "民丰县",
                            "whole_name": "民丰县，和田地区，新疆维吾尔自治区",
                            "simple_py": "MFX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0903",
                            "area_code": "653227",
                            "longitude": "82.692354",
                            "latitude": "37.064909"
                        },
                        {
                            "area_id": 8014,
                            "city_id": 7941,
                            "province_id": 5,
                            "name": "墨玉县",
                            "whole_name": "墨玉县，和田地区，新疆维吾尔自治区",
                            "simple_py": "MYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0903",
                            "area_code": "653222",
                            "longitude": "79.736629",
                            "latitude": "37.271511"
                        },
                        {
                            "area_id": 8012,
                            "city_id": 7941,
                            "province_id": 5,
                            "name": "皮山县",
                            "whole_name": "皮山县，和田地区，新疆维吾尔自治区",
                            "simple_py": "PSX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0903",
                            "area_code": "653223",
                            "longitude": "78.282301",
                            "latitude": "37.616332"
                        },
                        {
                            "area_id": 8009,
                            "city_id": 7941,
                            "province_id": 5,
                            "name": "于田县",
                            "whole_name": "于田县，和田地区，新疆维吾尔自治区",
                            "simple_py": "YTX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0903",
                            "area_code": "653226",
                            "longitude": "81.667845",
                            "latitude": "36.854628"
                        }
                    ]
                },
                {
                    "city_id": 7958,
                    "province_id": 5,
                    "name": "哈密市",
                    "whole_name": "哈密市，新疆维吾尔自治区",
                    "simple_py": "HMS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0902",
                    "area_code": "650500",
                    "longitude": "93.51316",
                    "latitude": "42.833248",
                    "children": [
                        {
                            "area_id": 9365,
                            "city_id": 7958,
                            "province_id": 5,
                            "name": "巴里坤哈萨克自治县",
                            "whole_name": "巴里坤哈萨克自治县，哈密市，新疆维吾尔自治区",
                            "simple_py": "BLKHSKZZX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0902",
                            "area_code": "650521",
                            "longitude": "93.021795",
                            "latitude": "43.599032"
                        },
                        {
                            "area_id": 9364,
                            "city_id": 7958,
                            "province_id": 5,
                            "name": "伊吾县",
                            "whole_name": "伊吾县，哈密市，新疆维吾尔自治区",
                            "simple_py": "YWX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0902",
                            "area_code": "650522",
                            "longitude": "94.692773",
                            "latitude": "43.252012"
                        },
                        {
                            "area_id": 9366,
                            "city_id": 7958,
                            "province_id": 5,
                            "name": "伊州区",
                            "whole_name": "伊州区，哈密市，新疆维吾尔自治区",
                            "simple_py": "YZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0902",
                            "area_code": "650502",
                            "longitude": "93.509174",
                            "latitude": "42.833888"
                        }
                    ]
                },
                {
                    "city_id": 7943,
                    "province_id": 5,
                    "name": "昆玉市",
                    "whole_name": "昆玉市，新疆维吾尔自治区",
                    "simple_py": "KYS",
                    "per_pin_yin": "K",
                    "per_pin_yin2": "K",
                    "city_code": "0903",
                    "area_code": "659009",
                    "longitude": "79.287372",
                    "latitude": "37.207994",
                    "children": [
                        {
                            "area_id": 8258,
                            "city_id": 7943,
                            "province_id": 5,
                            "name": "兵团皮山农场",
                            "whole_name": "兵团皮山农场，昆玉市，新疆维吾尔自治区",
                            "simple_py": "BTPSNC",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0903",
                            "area_code": "659009",
                            "longitude": "78.5171",
                            "latitude": "37.563"
                        },
                        {
                            "area_id": 8259,
                            "city_id": 7943,
                            "province_id": 5,
                            "name": "兵团二二四团",
                            "whole_name": "兵团二二四团，昆玉市，新疆维吾尔自治区",
                            "simple_py": "BTEEST",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0903",
                            "area_code": "659009",
                            "longitude": "79.3499",
                            "latitude": "37.3602"
                        },
                        {
                            "area_id": 8260,
                            "city_id": 7943,
                            "province_id": 5,
                            "name": "兵团四十七团",
                            "whole_name": "兵团四十七团，昆玉市，新疆维吾尔自治区",
                            "simple_py": "BTSSQT",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0903",
                            "area_code": "659009",
                            "longitude": "79.6039",
                            "latitude": "37.3666"
                        },
                        {
                            "area_id": 8261,
                            "city_id": 7943,
                            "province_id": 5,
                            "name": "博斯坦乡",
                            "whole_name": "博斯坦乡，昆玉市，新疆维吾尔自治区",
                            "simple_py": "BSTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0903",
                            "area_code": "659009",
                            "longitude": "81.3298",
                            "latitude": "36.4124"
                        },
                        {
                            "area_id": 8264,
                            "city_id": 7943,
                            "province_id": 5,
                            "name": "兵团一牧场",
                            "whole_name": "兵团一牧场，昆玉市，新疆维吾尔自治区",
                            "simple_py": "BTYMC",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0903",
                            "area_code": "659009",
                            "longitude": "81.0295",
                            "latitude": "36.3152"
                        },
                        {
                            "area_id": 8262,
                            "city_id": 7943,
                            "province_id": 5,
                            "name": "喀拉喀什镇",
                            "whole_name": "喀拉喀什镇，昆玉市，新疆维吾尔自治区",
                            "simple_py": "KLKSZ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0903",
                            "area_code": "659009",
                            "longitude": "79.7678",
                            "latitude": "37.2867"
                        },
                        {
                            "area_id": 8263,
                            "city_id": 7943,
                            "province_id": 5,
                            "name": "阔依其乡",
                            "whole_name": "阔依其乡，昆玉市，新疆维吾尔自治区",
                            "simple_py": "KYQX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "K",
                            "city_code": "0903",
                            "area_code": "659009",
                            "longitude": "79.6876",
                            "latitude": "37.3691"
                        },
                        {
                            "area_id": 8266,
                            "city_id": 7943,
                            "province_id": 5,
                            "name": "奴尔乡",
                            "whole_name": "奴尔乡，昆玉市，新疆维吾尔自治区",
                            "simple_py": "NEX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0903",
                            "area_code": "659009",
                            "longitude": "81.0072",
                            "latitude": "36.2605"
                        },
                        {
                            "area_id": 8257,
                            "city_id": 7943,
                            "province_id": 5,
                            "name": "普恰克其乡",
                            "whole_name": "普恰克其乡，昆玉市，新疆维吾尔自治区",
                            "simple_py": "PQKQX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0903",
                            "area_code": "659009",
                            "longitude": "79.783",
                            "latitude": "37.5805"
                        },
                        {
                            "area_id": 8256,
                            "city_id": 7943,
                            "province_id": 5,
                            "name": "乌尔其乡",
                            "whole_name": "乌尔其乡，昆玉市，新疆维吾尔自治区",
                            "simple_py": "WEQX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0903",
                            "area_code": "659009",
                            "longitude": "79.5866",
                            "latitude": "37.332"
                        },
                        {
                            "area_id": 8265,
                            "city_id": 7943,
                            "province_id": 5,
                            "name": "乌鲁克萨依乡",
                            "whole_name": "乌鲁克萨依乡，昆玉市，新疆维吾尔自治区",
                            "simple_py": "WLKSYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0903",
                            "area_code": "659009",
                            "longitude": "80.8148",
                            "latitude": "36.2925"
                        }
                    ]
                },
                {
                    "city_id": 7944,
                    "province_id": 5,
                    "name": "可克达拉市",
                    "whole_name": "可克达拉市，新疆维吾尔自治区",
                    "simple_py": "KKDLS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "K",
                    "city_code": "0999",
                    "area_code": "659008",
                    "longitude": "80.63579",
                    "latitude": "43.6832",
                    "children": [
                        {
                            "area_id": 8267,
                            "city_id": 7944,
                            "province_id": 5,
                            "name": "兵团六十八团",
                            "whole_name": "兵团六十八团，可克达拉市，新疆维吾尔自治区",
                            "simple_py": "BTLSBT",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0999",
                            "area_code": "659008",
                            "longitude": "80.9903",
                            "latitude": "43.8897"
                        },
                        {
                            "area_id": 8269,
                            "city_id": 7944,
                            "province_id": 5,
                            "name": "兵团六十六团",
                            "whole_name": "兵团六十六团，可克达拉市，新疆维吾尔自治区",
                            "simple_py": "BTLSLT",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0999",
                            "area_code": "659008",
                            "longitude": "81.086",
                            "latitude": "43.9599"
                        },
                        {
                            "area_id": 8270,
                            "city_id": 7944,
                            "province_id": 5,
                            "name": "兵团六十三团",
                            "whole_name": "兵团六十三团，可克达拉市，新疆维吾尔自治区",
                            "simple_py": "BTLSST",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0999",
                            "area_code": "659008",
                            "longitude": "80.484",
                            "latitude": "43.9314"
                        },
                        {
                            "area_id": 8271,
                            "city_id": 7944,
                            "province_id": 5,
                            "name": "兵团六十七团",
                            "whole_name": "兵团六十七团，可克达拉市，新疆维吾尔自治区",
                            "simple_py": "BTLSQT",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0999",
                            "area_code": "659008",
                            "longitude": "80.6068",
                            "latitude": "43.7652"
                        },
                        {
                            "area_id": 8272,
                            "city_id": 7944,
                            "province_id": 5,
                            "name": "兵团六十四团",
                            "whole_name": "兵团六十四团，可克达拉市，新疆维吾尔自治区",
                            "simple_py": "BTLSST",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0999",
                            "area_code": "659008",
                            "longitude": "80.6749",
                            "latitude": "44.0986"
                        },
                        {
                            "area_id": 8268,
                            "city_id": 7944,
                            "province_id": 5,
                            "name": "都拉塔口岸",
                            "whole_name": "都拉塔口岸，可克达拉市，新疆维吾尔自治区",
                            "simple_py": "DLTKA",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0999",
                            "area_code": "659008",
                            "longitude": "80.6882",
                            "latitude": "43.7131"
                        }
                    ]
                },
                {
                    "city_id": 7947,
                    "province_id": 5,
                    "name": "克拉玛依市",
                    "whole_name": "克拉玛依市，新疆维吾尔自治区",
                    "simple_py": "KLMYS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "K",
                    "city_code": "0990",
                    "area_code": "650200",
                    "longitude": "84.873946",
                    "latitude": "45.595886",
                    "children": [
                        {
                            "area_id": 8355,
                            "city_id": 7947,
                            "province_id": 5,
                            "name": "白碱滩区",
                            "whole_name": "白碱滩区，克拉玛依市，新疆维吾尔自治区",
                            "simple_py": "BJTQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0990",
                            "area_code": "650204",
                            "longitude": "85.129882",
                            "latitude": "45.689021"
                        },
                        {
                            "area_id": 8356,
                            "city_id": 7947,
                            "province_id": 5,
                            "name": "独山子区",
                            "whole_name": "独山子区，克拉玛依市，新疆维吾尔自治区",
                            "simple_py": "DSZQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0992",
                            "area_code": "650202",
                            "longitude": "84.882267",
                            "latitude": "44.327207"
                        },
                        {
                            "area_id": 8354,
                            "city_id": 7947,
                            "province_id": 5,
                            "name": "克拉玛依区",
                            "whole_name": "克拉玛依区，克拉玛依市，新疆维吾尔自治区",
                            "simple_py": "KLMYQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0990",
                            "area_code": "650203",
                            "longitude": "84.868918",
                            "latitude": "45.600477"
                        },
                        {
                            "area_id": 8353,
                            "city_id": 7947,
                            "province_id": 5,
                            "name": "乌尔禾区",
                            "whole_name": "乌尔禾区，克拉玛依市，新疆维吾尔自治区",
                            "simple_py": "WEHQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0990",
                            "area_code": "650205",
                            "longitude": "85.697767",
                            "latitude": "46.08776"
                        }
                    ]
                },
                {
                    "city_id": 7953,
                    "province_id": 5,
                    "name": "喀什地区",
                    "whole_name": "喀什地区，新疆维吾尔自治区",
                    "simple_py": "KSDQ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "K",
                    "city_code": "0998",
                    "area_code": "653100",
                    "longitude": "75.989138",
                    "latitude": "39.467664",
                    "children": [
                        {
                            "area_id": 8659,
                            "city_id": 7953,
                            "province_id": 5,
                            "name": "巴楚县",
                            "whole_name": "巴楚县，喀什地区，新疆维吾尔自治区",
                            "simple_py": "BCX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0998",
                            "area_code": "653130",
                            "longitude": "78.55041",
                            "latitude": "39.783479"
                        },
                        {
                            "area_id": 8652,
                            "city_id": 7953,
                            "province_id": 5,
                            "name": "伽师县",
                            "whole_name": "伽师县，喀什地区，新疆维吾尔自治区",
                            "simple_py": "JSX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0998",
                            "area_code": "653129",
                            "longitude": "76.741982",
                            "latitude": "39.494325"
                        },
                        {
                            "area_id": 8662,
                            "city_id": 7953,
                            "province_id": 5,
                            "name": "喀什市",
                            "whole_name": "喀什市，喀什地区，新疆维吾尔自治区",
                            "simple_py": "KSS",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0998",
                            "area_code": "653101",
                            "longitude": "75.98838",
                            "latitude": "39.467861"
                        },
                        {
                            "area_id": 8653,
                            "city_id": 7953,
                            "province_id": 5,
                            "name": "麦盖提县",
                            "whole_name": "麦盖提县，喀什地区，新疆维吾尔自治区",
                            "simple_py": "MGTX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0998",
                            "area_code": "653127",
                            "longitude": "77.651538",
                            "latitude": "38.903384"
                        },
                        {
                            "area_id": 8651,
                            "city_id": 7953,
                            "province_id": 5,
                            "name": "疏勒县",
                            "whole_name": "疏勒县，喀什地区，新疆维吾尔自治区",
                            "simple_py": "SLX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0998",
                            "area_code": "653122",
                            "longitude": "76.053653",
                            "latitude": "39.399461"
                        },
                        {
                            "area_id": 8658,
                            "city_id": 7953,
                            "province_id": 5,
                            "name": "莎车县",
                            "whole_name": "莎车县，喀什地区，新疆维吾尔自治区",
                            "simple_py": "SCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0998",
                            "area_code": "653125",
                            "longitude": "77.248884",
                            "latitude": "38.414499"
                        },
                        {
                            "area_id": 8661,
                            "city_id": 7953,
                            "province_id": 5,
                            "name": "疏附县",
                            "whole_name": "疏附县，喀什地区，新疆维吾尔自治区",
                            "simple_py": "SFX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0998",
                            "area_code": "653121",
                            "longitude": "75.863075",
                            "latitude": "39.378306"
                        },
                        {
                            "area_id": 8655,
                            "city_id": 7953,
                            "province_id": 5,
                            "name": "塔什库尔干塔吉克自治县",
                            "whole_name": "塔什库尔干塔吉克自治县，喀什地区，新疆维吾尔自治区",
                            "simple_py": "TSKEGTJKZZX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0998",
                            "area_code": "653131",
                            "longitude": "75.228068",
                            "latitude": "37.775437"
                        },
                        {
                            "area_id": 8654,
                            "city_id": 7953,
                            "province_id": 5,
                            "name": "叶城县",
                            "whole_name": "叶城县，喀什地区，新疆维吾尔自治区",
                            "simple_py": "YCX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0998",
                            "area_code": "653126",
                            "longitude": "77.420353",
                            "latitude": "37.884679"
                        },
                        {
                            "area_id": 8656,
                            "city_id": 7953,
                            "province_id": 5,
                            "name": "岳普湖县",
                            "whole_name": "岳普湖县，喀什地区，新疆维吾尔自治区",
                            "simple_py": "YPHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0998",
                            "area_code": "653128",
                            "longitude": "76.7724",
                            "latitude": "39.235248"
                        },
                        {
                            "area_id": 8660,
                            "city_id": 7953,
                            "province_id": 5,
                            "name": "英吉沙县",
                            "whole_name": "英吉沙县，喀什地区，新疆维吾尔自治区",
                            "simple_py": "YJSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0998",
                            "area_code": "653123",
                            "longitude": "76.174292",
                            "latitude": "38.929839"
                        },
                        {
                            "area_id": 8657,
                            "city_id": 7953,
                            "province_id": 5,
                            "name": "泽普县",
                            "whole_name": "泽普县，喀什地区，新疆维吾尔自治区",
                            "simple_py": "ZPX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0998",
                            "area_code": "653124",
                            "longitude": "77.273593",
                            "latitude": "38.191217"
                        }
                    ]
                },
                {
                    "city_id": 7957,
                    "province_id": 5,
                    "name": "克孜勒苏柯尔克孜自治州",
                    "whole_name": "克孜勒苏柯尔克孜自治州，新疆维吾尔自治区",
                    "simple_py": "KZLSKEKZZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "K",
                    "city_code": "0908",
                    "area_code": "653000",
                    "longitude": "76.172825",
                    "latitude": "39.713431",
                    "children": [
                        {
                            "area_id": 9314,
                            "city_id": 7957,
                            "province_id": 5,
                            "name": "阿图什市",
                            "whole_name": "阿图什市，克孜勒苏柯尔克孜自治州，新疆维吾尔自治区",
                            "simple_py": "ATSS",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0908",
                            "area_code": "653001",
                            "longitude": "76.173939",
                            "latitude": "39.712898"
                        },
                        {
                            "area_id": 9316,
                            "city_id": 7957,
                            "province_id": 5,
                            "name": "阿合奇县",
                            "whole_name": "阿合奇县，克孜勒苏柯尔克孜自治州，新疆维吾尔自治区",
                            "simple_py": "AHQX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "A",
                            "city_code": "0997",
                            "area_code": "653023",
                            "longitude": "78.450164",
                            "latitude": "40.937567"
                        },
                        {
                            "area_id": 9317,
                            "city_id": 7957,
                            "province_id": 5,
                            "name": "阿克陶县",
                            "whole_name": "阿克陶县，克孜勒苏柯尔克孜自治州，新疆维吾尔自治区",
                            "simple_py": "AKTX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "A",
                            "city_code": "0908",
                            "area_code": "653022",
                            "longitude": "75.945159",
                            "latitude": "39.147079"
                        },
                        {
                            "area_id": 9315,
                            "city_id": 7957,
                            "province_id": 5,
                            "name": "乌恰县",
                            "whole_name": "乌恰县，克孜勒苏柯尔克孜自治州，新疆维吾尔自治区",
                            "simple_py": "WQX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0908",
                            "area_code": "653024",
                            "longitude": "75.25969",
                            "latitude": "39.716633"
                        }
                    ]
                },
                {
                    "city_id": 7938,
                    "province_id": 5,
                    "name": "双河市",
                    "whole_name": "双河市，新疆维吾尔自治区",
                    "simple_py": "SHS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0909",
                    "area_code": "659007",
                    "longitude": "82.353656",
                    "latitude": "44.840524",
                    "children": [
                        {
                            "area_id": 7964,
                            "city_id": 7938,
                            "province_id": 5,
                            "name": "兵团八十九团",
                            "whole_name": "兵团八十九团，双河市，新疆维吾尔自治区",
                            "simple_py": "BTBSJT",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0909",
                            "area_code": "659007",
                            "longitude": "82.2853",
                            "latitude": "45.0582"
                        },
                        {
                            "area_id": 7965,
                            "city_id": 7938,
                            "province_id": 5,
                            "name": "兵团八十六团",
                            "whole_name": "兵团八十六团，双河市，新疆维吾尔自治区",
                            "simple_py": "BTBSLT",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0909",
                            "area_code": "659007",
                            "longitude": "82.1787",
                            "latitude": "44.8089"
                        },
                        {
                            "area_id": 7966,
                            "city_id": 7938,
                            "province_id": 5,
                            "name": "兵团八十四团",
                            "whole_name": "兵团八十四团，双河市，新疆维吾尔自治区",
                            "simple_py": "BTBSST",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0909",
                            "area_code": "659007",
                            "longitude": "82.215",
                            "latitude": "45.1246"
                        },
                        {
                            "area_id": 7967,
                            "city_id": 7938,
                            "province_id": 5,
                            "name": "兵团九十团",
                            "whole_name": "兵团九十团，双河市，新疆维吾尔自治区",
                            "simple_py": "BTJST",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0909",
                            "area_code": "659007",
                            "longitude": "82.6473",
                            "latitude": "44.7651"
                        },
                        {
                            "area_id": 7968,
                            "city_id": 7938,
                            "province_id": 5,
                            "name": "兵团八十一团",
                            "whole_name": "兵团八十一团，双河市，新疆维吾尔自治区",
                            "simple_py": "BTBSYT",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0909",
                            "area_code": "659007",
                            "longitude": "82.4908",
                            "latitude": "44.7469"
                        }
                    ]
                },
                {
                    "city_id": 7945,
                    "province_id": 5,
                    "name": "石河子市",
                    "whole_name": "石河子市，新疆维吾尔自治区",
                    "simple_py": "SHZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "S",
                    "city_code": "0993",
                    "area_code": "659001",
                    "longitude": "86.041075",
                    "latitude": "44.305886",
                    "children": [
                        {
                            "area_id": 8273,
                            "city_id": 7945,
                            "province_id": 5,
                            "name": "兵团一五二团",
                            "whole_name": "兵团一五二团，石河子市，新疆维吾尔自治区",
                            "simple_py": "BTYWET",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0993",
                            "area_code": "659001",
                            "longitude": "86.0704",
                            "latitude": "44.2827"
                        },
                        {
                            "area_id": 8279,
                            "city_id": 7945,
                            "province_id": 5,
                            "name": "北泉镇",
                            "whole_name": "北泉镇，石河子市，新疆维吾尔自治区",
                            "simple_py": "BQZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0993",
                            "area_code": "659001",
                            "longitude": "86.0983",
                            "latitude": "44.4346"
                        },
                        {
                            "area_id": 8276,
                            "city_id": 7945,
                            "province_id": 5,
                            "name": "东城街道",
                            "whole_name": "东城街道，石河子市，新疆维吾尔自治区",
                            "simple_py": "DCJD",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0993",
                            "area_code": "659001",
                            "longitude": "86.0687",
                            "latitude": "44.2873"
                        },
                        {
                            "area_id": 8275,
                            "city_id": 7945,
                            "province_id": 5,
                            "name": "红山街道",
                            "whole_name": "红山街道，石河子市，新疆维吾尔自治区",
                            "simple_py": "HSJD",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0993",
                            "area_code": "659001",
                            "longitude": "86.048",
                            "latitude": "44.2682"
                        },
                        {
                            "area_id": 8278,
                            "city_id": 7945,
                            "province_id": 5,
                            "name": "老街街道",
                            "whole_name": "老街街道，石河子市，新疆维吾尔自治区",
                            "simple_py": "LJJD",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0993",
                            "area_code": "659001",
                            "longitude": "85.9909",
                            "latitude": "44.3496"
                        },
                        {
                            "area_id": 8277,
                            "city_id": 7945,
                            "province_id": 5,
                            "name": "石河子乡",
                            "whole_name": "石河子乡，石河子市，新疆维吾尔自治区",
                            "simple_py": "SHZX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0993",
                            "area_code": "659001",
                            "longitude": "86.1022",
                            "latitude": "44.1352"
                        },
                        {
                            "area_id": 8274,
                            "city_id": 7945,
                            "province_id": 5,
                            "name": "向阳街道",
                            "whole_name": "向阳街道，石河子市，新疆维吾尔自治区",
                            "simple_py": "XYJD",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0993",
                            "area_code": "659001",
                            "longitude": "86.0397",
                            "latitude": "44.3429"
                        },
                        {
                            "area_id": 8280,
                            "city_id": 7945,
                            "province_id": 5,
                            "name": "新城街道",
                            "whole_name": "新城街道，石河子市，新疆维吾尔自治区",
                            "simple_py": "XCJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0993",
                            "area_code": "659001",
                            "longitude": "85.9823",
                            "latitude": "44.2893"
                        }
                    ]
                },
                {
                    "city_id": 7939,
                    "province_id": 5,
                    "name": "铁门关市",
                    "whole_name": "铁门关市，新疆维吾尔自治区",
                    "simple_py": "TMGS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0906",
                    "area_code": "659006",
                    "longitude": "85.501218",
                    "latitude": "41.827251",
                    "children": [
                        {
                            "area_id": 7969,
                            "city_id": 7939,
                            "province_id": 5,
                            "name": "兵团二十九团",
                            "whole_name": "兵团二十九团，铁门关市，新疆维吾尔自治区",
                            "simple_py": "BTESJT",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0906",
                            "area_code": "659006",
                            "longitude": "85.5849",
                            "latitude": "41.8825"
                        },
                        {
                            "area_id": 7970,
                            "city_id": 7939,
                            "province_id": 5,
                            "name": "农二师三十团",
                            "whole_name": "农二师三十团，铁门关市，新疆维吾尔自治区",
                            "simple_py": "NESSST",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0906",
                            "area_code": "659006",
                            "longitude": "85.5849",
                            "latitude": "41.8825"
                        }
                    ]
                },
                {
                    "city_id": 7942,
                    "province_id": 5,
                    "name": "塔城地区",
                    "whole_name": "塔城地区，新疆维吾尔自治区",
                    "simple_py": "TCDQ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "T",
                    "city_code": "0901",
                    "area_code": "654200",
                    "longitude": "82.985732",
                    "latitude": "46.746301",
                    "children": [
                        {
                            "area_id": 8128,
                            "city_id": 7942,
                            "province_id": 5,
                            "name": "额敏县",
                            "whole_name": "额敏县，塔城地区，新疆维吾尔自治区",
                            "simple_py": "EMX",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0901",
                            "area_code": "654221",
                            "longitude": "83.622118",
                            "latitude": "46.522555"
                        },
                        {
                            "area_id": 8126,
                            "city_id": 7942,
                            "province_id": 5,
                            "name": "和布克赛尔蒙古自治县",
                            "whole_name": "和布克赛尔蒙古自治县，塔城地区，新疆维吾尔自治区",
                            "simple_py": "HBKSEMGZZX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0990",
                            "area_code": "654226",
                            "longitude": "85.733551",
                            "latitude": "46.793001"
                        },
                        {
                            "area_id": 8130,
                            "city_id": 7942,
                            "province_id": 5,
                            "name": "沙湾县",
                            "whole_name": "沙湾县，塔城地区，新疆维吾尔自治区",
                            "simple_py": "SWX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0993",
                            "area_code": "654223",
                            "longitude": "85.622508",
                            "latitude": "44.329544"
                        },
                        {
                            "area_id": 8124,
                            "city_id": 7942,
                            "province_id": 5,
                            "name": "塔城市",
                            "whole_name": "塔城市，塔城地区，新疆维吾尔自治区",
                            "simple_py": "TCS",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0901",
                            "area_code": "654201",
                            "longitude": "82.983988",
                            "latitude": "46.746281"
                        },
                        {
                            "area_id": 8125,
                            "city_id": 7942,
                            "province_id": 5,
                            "name": "托里县",
                            "whole_name": "托里县，塔城地区，新疆维吾尔自治区",
                            "simple_py": "TLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0901",
                            "area_code": "654224",
                            "longitude": "83.60469",
                            "latitude": "45.935863"
                        },
                        {
                            "area_id": 8129,
                            "city_id": 7942,
                            "province_id": 5,
                            "name": "乌苏市",
                            "whole_name": "乌苏市，塔城地区，新疆维吾尔自治区",
                            "simple_py": "WSS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0992",
                            "area_code": "654202",
                            "longitude": "84.677624",
                            "latitude": "44.430115"
                        },
                        {
                            "area_id": 8127,
                            "city_id": 7942,
                            "province_id": 5,
                            "name": "裕民县",
                            "whole_name": "裕民县，塔城地区，新疆维吾尔自治区",
                            "simple_py": "YMX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0901",
                            "area_code": "654225",
                            "longitude": "82.982157",
                            "latitude": "46.202781"
                        }
                    ]
                },
                {
                    "city_id": 7952,
                    "province_id": 5,
                    "name": "图木舒克市",
                    "whole_name": "图木舒克市，新疆维吾尔自治区",
                    "simple_py": "TMSKS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "T",
                    "city_code": "0998",
                    "area_code": "659003",
                    "longitude": "79.077978",
                    "latitude": "39.867316",
                    "children": [
                        {
                            "area_id": 8641,
                            "city_id": 7952,
                            "province_id": 5,
                            "name": "兵团四十九团",
                            "whole_name": "兵团四十九团，图木舒克市，新疆维吾尔自治区",
                            "simple_py": "BTSSJT",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0998",
                            "area_code": "659003",
                            "longitude": "78.756",
                            "latitude": "39.8224"
                        },
                        {
                            "area_id": 8642,
                            "city_id": 7952,
                            "province_id": 5,
                            "name": "兵团图木舒克市永安坝",
                            "whole_name": "兵团图木舒克市永安坝，图木舒克市，新疆维吾尔自治区",
                            "simple_py": "BTTMSKSYAB",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0998",
                            "area_code": "659003",
                            "longitude": "79.0133",
                            "latitude": "39.8385"
                        },
                        {
                            "area_id": 8643,
                            "city_id": 7952,
                            "province_id": 5,
                            "name": "兵团五十一团",
                            "whole_name": "兵团五十一团，图木舒克市，新疆维吾尔自治区",
                            "simple_py": "BTWSYT",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0998",
                            "area_code": "659003",
                            "longitude": "79.2902",
                            "latitude": "39.9888"
                        },
                        {
                            "area_id": 8645,
                            "city_id": 7952,
                            "province_id": 5,
                            "name": "兵团图木舒克市喀拉拜勒镇",
                            "whole_name": "兵团图木舒克市喀拉拜勒镇，图木舒克市，新疆维吾尔自治区",
                            "simple_py": "BTTMSKSKLBLZ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0998",
                            "area_code": "659003",
                            "longitude": "79.0112",
                            "latitude": "39.8526"
                        },
                        {
                            "area_id": 8648,
                            "city_id": 7952,
                            "province_id": 5,
                            "name": "兵团五十团",
                            "whole_name": "兵团五十团，图木舒克市，新疆维吾尔自治区",
                            "simple_py": "BTWST",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0998",
                            "area_code": "659003",
                            "longitude": "79.2315",
                            "latitude": "39.9549"
                        },
                        {
                            "area_id": 8649,
                            "city_id": 7952,
                            "province_id": 5,
                            "name": "兵团五十三团",
                            "whole_name": "兵团五十三团，图木舒克市，新疆维吾尔自治区",
                            "simple_py": "BTWSST",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0998",
                            "area_code": "659003",
                            "longitude": "79.3214",
                            "latitude": "40.0318"
                        },
                        {
                            "area_id": 8650,
                            "city_id": 7952,
                            "province_id": 5,
                            "name": "兵团四十四团",
                            "whole_name": "兵团四十四团，图木舒克市，新疆维吾尔自治区",
                            "simple_py": "BTSSST",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0998",
                            "area_code": "659003",
                            "longitude": "79.1926",
                            "latitude": "39.9168"
                        },
                        {
                            "area_id": 8644,
                            "city_id": 7952,
                            "province_id": 5,
                            "name": "前海街道",
                            "whole_name": "前海街道，图木舒克市，新疆维吾尔自治区",
                            "simple_py": "QHJD",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0998",
                            "area_code": "659003",
                            "longitude": "79.0778",
                            "latitude": "39.855"
                        },
                        {
                            "area_id": 8647,
                            "city_id": 7952,
                            "province_id": 5,
                            "name": "齐干却勒街道",
                            "whole_name": "齐干却勒街道，图木舒克市，新疆维吾尔自治区",
                            "simple_py": "QGQLJD",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0998",
                            "area_code": "659003",
                            "longitude": "79.0906",
                            "latitude": "39.8753"
                        },
                        {
                            "area_id": 8646,
                            "city_id": 7952,
                            "province_id": 5,
                            "name": "永安坝街道",
                            "whole_name": "永安坝街道，图木舒克市，新疆维吾尔自治区",
                            "simple_py": "YABJD",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0998",
                            "area_code": "659003",
                            "longitude": "79.0229",
                            "latitude": "39.8507"
                        }
                    ]
                },
                {
                    "city_id": 7959,
                    "province_id": 5,
                    "name": "吐鲁番市",
                    "whole_name": "吐鲁番市，新疆维吾尔自治区",
                    "simple_py": "TLFS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "T",
                    "city_code": "0995",
                    "area_code": "650400",
                    "longitude": "89.184078",
                    "latitude": "42.947613",
                    "children": [
                        {
                            "area_id": 9425,
                            "city_id": 7959,
                            "province_id": 5,
                            "name": "高昌区",
                            "whole_name": "高昌区，吐鲁番市，新疆维吾尔自治区",
                            "simple_py": "GCQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0995",
                            "area_code": "650402",
                            "longitude": "89.182324",
                            "latitude": "42.947627"
                        },
                        {
                            "area_id": 9426,
                            "city_id": 7959,
                            "province_id": 5,
                            "name": "鄯善县",
                            "whole_name": "鄯善县，吐鲁番市，新疆维吾尔自治区",
                            "simple_py": "SSX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0995",
                            "area_code": "650421",
                            "longitude": "90.212692",
                            "latitude": "42.865503"
                        },
                        {
                            "area_id": 9427,
                            "city_id": 7959,
                            "province_id": 5,
                            "name": "托克逊县",
                            "whole_name": "托克逊县，吐鲁番市，新疆维吾尔自治区",
                            "simple_py": "TKXX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0995",
                            "area_code": "650422",
                            "longitude": "88.655771",
                            "latitude": "42.793536"
                        }
                    ]
                },
                {
                    "city_id": 7949,
                    "province_id": 5,
                    "name": "五家渠市",
                    "whole_name": "五家渠市，新疆维吾尔自治区",
                    "simple_py": "WJQS",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "0994",
                    "area_code": "659004",
                    "longitude": "87.526884",
                    "latitude": "44.167401",
                    "children": [
                        {
                            "area_id": 8489,
                            "city_id": 7949,
                            "province_id": 5,
                            "name": "兵团一零二团",
                            "whole_name": "兵团一零二团，五家渠市，新疆维吾尔自治区",
                            "simple_py": "BTYLET",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0994",
                            "area_code": "659004",
                            "longitude": "87.5925",
                            "latitude": "44.2694"
                        },
                        {
                            "area_id": 8492,
                            "city_id": 7949,
                            "province_id": 5,
                            "name": "兵团一零一团",
                            "whole_name": "兵团一零一团，五家渠市，新疆维吾尔自治区",
                            "simple_py": "BTYLYT",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0994",
                            "area_code": "659004",
                            "longitude": "87.5562",
                            "latitude": "44.1752"
                        },
                        {
                            "area_id": 8493,
                            "city_id": 7949,
                            "province_id": 5,
                            "name": "兵团一零三团",
                            "whole_name": "兵团一零三团，五家渠市，新疆维吾尔自治区",
                            "simple_py": "BTYLST",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0994",
                            "area_code": "659004",
                            "longitude": "87.4075",
                            "latitude": "44.5317"
                        },
                        {
                            "area_id": 8490,
                            "city_id": 7949,
                            "province_id": 5,
                            "name": "军垦路街道",
                            "whole_name": "军垦路街道，五家渠市，新疆维吾尔自治区",
                            "simple_py": "JKLJD",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0994",
                            "area_code": "659004",
                            "longitude": "87.5084",
                            "latitude": "44.1889"
                        },
                        {
                            "area_id": 8494,
                            "city_id": 7949,
                            "province_id": 5,
                            "name": "青湖路街道",
                            "whole_name": "青湖路街道，五家渠市，新疆维吾尔自治区",
                            "simple_py": "QHLJD",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0994",
                            "area_code": "659004",
                            "longitude": "87.5245",
                            "latitude": "44.1764"
                        },
                        {
                            "area_id": 8491,
                            "city_id": 7949,
                            "province_id": 5,
                            "name": "人民路街道",
                            "whole_name": "人民路街道，五家渠市，新疆维吾尔自治区",
                            "simple_py": "RMLJD",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0994",
                            "area_code": "659004",
                            "longitude": "87.5728",
                            "latitude": "44.1822"
                        }
                    ]
                },
                {
                    "city_id": 7955,
                    "province_id": 5,
                    "name": "乌鲁木齐市",
                    "whole_name": "乌鲁木齐市，新疆维吾尔自治区",
                    "simple_py": "WLMQS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "W",
                    "city_code": "0991",
                    "area_code": "650100",
                    "longitude": "87.617733",
                    "latitude": "43.792818",
                    "children": [
                        {
                            "area_id": 9058,
                            "city_id": 7955,
                            "province_id": 5,
                            "name": "达坂城区",
                            "whole_name": "达坂城区，乌鲁木齐市，新疆维吾尔自治区",
                            "simple_py": "DBCQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0991",
                            "area_code": "650107",
                            "longitude": "88.30994",
                            "latitude": "43.36181"
                        },
                        {
                            "area_id": 9063,
                            "city_id": 7955,
                            "province_id": 5,
                            "name": "米东区",
                            "whole_name": "米东区，乌鲁木齐市，新疆维吾尔自治区",
                            "simple_py": "MDQ",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0991",
                            "area_code": "650109",
                            "longitude": "87.691801",
                            "latitude": "43.960982"
                        },
                        {
                            "area_id": 9060,
                            "city_id": 7955,
                            "province_id": 5,
                            "name": "沙依巴克区",
                            "whole_name": "沙依巴克区，乌鲁木齐市，新疆维吾尔自治区",
                            "simple_py": "SYBKQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0991",
                            "area_code": "650103",
                            "longitude": "87.596639",
                            "latitude": "43.788872"
                        },
                        {
                            "area_id": 9064,
                            "city_id": 7955,
                            "province_id": 5,
                            "name": "水磨沟区",
                            "whole_name": "水磨沟区，乌鲁木齐市，新疆维吾尔自治区",
                            "simple_py": "SMGQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0991",
                            "area_code": "650105",
                            "longitude": "87.613093",
                            "latitude": "43.816747"
                        },
                        {
                            "area_id": 9059,
                            "city_id": 7955,
                            "province_id": 5,
                            "name": "天山区",
                            "whole_name": "天山区，乌鲁木齐市，新疆维吾尔自治区",
                            "simple_py": "TSQ",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0991",
                            "area_code": "650102",
                            "longitude": "87.620116",
                            "latitude": "43.796428"
                        },
                        {
                            "area_id": 9061,
                            "city_id": 7955,
                            "province_id": 5,
                            "name": "头屯河区",
                            "whole_name": "头屯河区，乌鲁木齐市，新疆维吾尔自治区",
                            "simple_py": "TTHQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "T",
                            "city_code": "0991",
                            "area_code": "650106",
                            "longitude": "87.425823",
                            "latitude": "43.876053"
                        },
                        {
                            "area_id": 9057,
                            "city_id": 7955,
                            "province_id": 5,
                            "name": "乌鲁木齐县",
                            "whole_name": "乌鲁木齐县，乌鲁木齐市，新疆维吾尔自治区",
                            "simple_py": "WLMQX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0991",
                            "area_code": "650121",
                            "longitude": "87.505603",
                            "latitude": "43.982546"
                        },
                        {
                            "area_id": 9062,
                            "city_id": 7955,
                            "province_id": 5,
                            "name": "新市区",
                            "whole_name": "新市区，乌鲁木齐市，新疆维吾尔自治区",
                            "simple_py": "XSQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0991",
                            "area_code": "650104",
                            "longitude": "87.560653",
                            "latitude": "43.870882"
                        }
                    ]
                },
                {
                    "city_id": 7954,
                    "province_id": 5,
                    "name": "伊犁哈萨克自治州",
                    "whole_name": "伊犁哈萨克自治州，新疆维吾尔自治区",
                    "simple_py": "YLHSKZZZ",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0999",
                    "area_code": "654000",
                    "longitude": "81.317946",
                    "latitude": "43.92186",
                    "children": [
                        {
                            "area_id": 8891,
                            "city_id": 7954,
                            "province_id": 5,
                            "name": "察布查尔锡伯自治县",
                            "whole_name": "察布查尔锡伯自治县，伊犁哈萨克自治州，新疆维吾尔自治区",
                            "simple_py": "CBCEXBZZX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0999",
                            "area_code": "654022",
                            "longitude": "81.150874",
                            "latitude": "43.838883"
                        },
                        {
                            "area_id": 8886,
                            "city_id": 7954,
                            "province_id": 5,
                            "name": "巩留县",
                            "whole_name": "巩留县，伊犁哈萨克自治州，新疆维吾尔自治区",
                            "simple_py": "GLX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0999",
                            "area_code": "654024",
                            "longitude": "82.227044",
                            "latitude": "43.481618"
                        },
                        {
                            "area_id": 8893,
                            "city_id": 7954,
                            "province_id": 5,
                            "name": "霍城县",
                            "whole_name": "霍城县，伊犁哈萨克自治州，新疆维吾尔自治区",
                            "simple_py": "HCX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0999",
                            "area_code": "654023",
                            "longitude": "80.872508",
                            "latitude": "44.049912"
                        },
                        {
                            "area_id": 8894,
                            "city_id": 7954,
                            "province_id": 5,
                            "name": "霍尔果斯市",
                            "whole_name": "霍尔果斯市，伊犁哈萨克自治州，新疆维吾尔自治区",
                            "simple_py": "HEGSS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0999",
                            "area_code": "654004",
                            "longitude": "80.420759",
                            "latitude": "44.201669"
                        },
                        {
                            "area_id": 8884,
                            "city_id": 7954,
                            "province_id": 5,
                            "name": "奎屯市",
                            "whole_name": "奎屯市，伊犁哈萨克自治州，新疆维吾尔自治区",
                            "simple_py": "KTS",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0999",
                            "area_code": "654003",
                            "longitude": "84.901602",
                            "latitude": "44.423445"
                        },
                        {
                            "area_id": 8885,
                            "city_id": 7954,
                            "province_id": 5,
                            "name": "尼勒克县",
                            "whole_name": "尼勒克县，伊犁哈萨克自治州，新疆维吾尔自治区",
                            "simple_py": "NLKX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0999",
                            "area_code": "654028",
                            "longitude": "82.504119",
                            "latitude": "43.789737"
                        },
                        {
                            "area_id": 8888,
                            "city_id": 7954,
                            "province_id": 5,
                            "name": "特克斯县",
                            "whole_name": "特克斯县，伊犁哈萨克自治州，新疆维吾尔自治区",
                            "simple_py": "TKSX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0999",
                            "area_code": "654027",
                            "longitude": "81.840058",
                            "latitude": "43.214861"
                        },
                        {
                            "area_id": 8889,
                            "city_id": 7954,
                            "province_id": 5,
                            "name": "新源县",
                            "whole_name": "新源县，伊犁哈萨克自治州，新疆维吾尔自治区",
                            "simple_py": "XYX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0999",
                            "area_code": "654025",
                            "longitude": "83.258493",
                            "latitude": "43.434249"
                        },
                        {
                            "area_id": 8887,
                            "city_id": 7954,
                            "province_id": 5,
                            "name": "伊宁县",
                            "whole_name": "伊宁县，伊犁哈萨克自治州，新疆维吾尔自治区",
                            "simple_py": "YNX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0999",
                            "area_code": "654021",
                            "longitude": "81.524671",
                            "latitude": "43.977876"
                        },
                        {
                            "area_id": 8892,
                            "city_id": 7954,
                            "province_id": 5,
                            "name": "伊宁市",
                            "whole_name": "伊宁市，伊犁哈萨克自治州，新疆维吾尔自治区",
                            "simple_py": "YNS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0999",
                            "area_code": "654002",
                            "longitude": "81.316343",
                            "latitude": "43.922209"
                        },
                        {
                            "area_id": 8890,
                            "city_id": 7954,
                            "province_id": 5,
                            "name": "昭苏县",
                            "whole_name": "昭苏县，伊犁哈萨克自治州，新疆维吾尔自治区",
                            "simple_py": "ZSX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0999",
                            "area_code": "654026",
                            "longitude": "81.126029",
                            "latitude": "43.157765"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 13,
            "name": "西藏自治区",
            "whole_name": "西藏自治区",
            "simple_py": "XCZZQ",
            "per_pin_yin": " ",
            "per_pin_yin2": "X",
            "city_code": "",
            "area_code": "540000",
            "longitude": "91.132212",
            "latitude": "29.660361",
            "children": [
                {
                    "city_id": 19108,
                    "province_id": 13,
                    "name": "阿里地区",
                    "whole_name": "阿里地区，西藏自治区",
                    "simple_py": "ALDQ",
                    "per_pin_yin": "A",
                    "per_pin_yin2": "A",
                    "city_code": "0897",
                    "area_code": "542500",
                    "longitude": "80.105498",
                    "latitude": "32.503187",
                    "children": [
                        {
                            "area_id": 19830,
                            "city_id": 19108,
                            "province_id": 13,
                            "name": "措勤县",
                            "whole_name": "措勤县，阿里地区，西藏自治区",
                            "simple_py": "CQX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0897",
                            "area_code": "542527",
                            "longitude": "85.159254",
                            "latitude": "31.016774"
                        },
                        {
                            "area_id": 19829,
                            "city_id": 19108,
                            "province_id": 13,
                            "name": "改则县",
                            "whole_name": "改则县，阿里地区，西藏自治区",
                            "simple_py": "GZX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0897",
                            "area_code": "542526",
                            "longitude": "84.062384",
                            "latitude": "32.302076"
                        },
                        {
                            "area_id": 19832,
                            "city_id": 19108,
                            "province_id": 13,
                            "name": "噶尔县",
                            "whole_name": "噶尔县，阿里地区，西藏自治区",
                            "simple_py": "GEX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0897",
                            "area_code": "542523",
                            "longitude": "80.105005",
                            "latitude": "32.503373"
                        },
                        {
                            "area_id": 19834,
                            "city_id": 19108,
                            "province_id": 13,
                            "name": "革吉县",
                            "whole_name": "革吉县，阿里地区，西藏自治区",
                            "simple_py": "GJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "G",
                            "city_code": "0897",
                            "area_code": "542525",
                            "longitude": "81.142896",
                            "latitude": "32.389192"
                        },
                        {
                            "area_id": 19831,
                            "city_id": 19108,
                            "province_id": 13,
                            "name": "普兰县",
                            "whole_name": "普兰县，阿里地区，西藏自治区",
                            "simple_py": "PLX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0897",
                            "area_code": "542521",
                            "longitude": "81.177588",
                            "latitude": "30.291896"
                        },
                        {
                            "area_id": 19833,
                            "city_id": 19108,
                            "province_id": 13,
                            "name": "日土县",
                            "whole_name": "日土县，阿里地区，西藏自治区",
                            "simple_py": "RTX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0897",
                            "area_code": "542524",
                            "longitude": "79.731937",
                            "latitude": "33.382454"
                        },
                        {
                            "area_id": 19828,
                            "city_id": 19108,
                            "province_id": 13,
                            "name": "札达县",
                            "whole_name": "札达县，阿里地区，西藏自治区",
                            "simple_py": "ZDX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0897",
                            "area_code": "542522",
                            "longitude": "79.803191",
                            "latitude": "31.478587"
                        }
                    ]
                },
                {
                    "city_id": 19102,
                    "province_id": 13,
                    "name": "昌都市",
                    "whole_name": "昌都市，西藏自治区",
                    "simple_py": "CDS",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0895",
                    "area_code": "540300",
                    "longitude": "97.178452",
                    "latitude": "31.136875",
                    "children": [
                        {
                            "area_id": 19113,
                            "city_id": 19102,
                            "province_id": 13,
                            "name": "边坝县",
                            "whole_name": "边坝县，昌都市，西藏自治区",
                            "simple_py": "BBX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0895",
                            "area_code": "540330",
                            "longitude": "94.707504",
                            "latitude": "30.933849"
                        },
                        {
                            "area_id": 19115,
                            "city_id": 19102,
                            "province_id": 13,
                            "name": "八宿县",
                            "whole_name": "八宿县，昌都市，西藏自治区",
                            "simple_py": "BSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0895",
                            "area_code": "540326",
                            "longitude": "96.917893",
                            "latitude": "30.053408"
                        },
                        {
                            "area_id": 19117,
                            "city_id": 19102,
                            "province_id": 13,
                            "name": "察雅县",
                            "whole_name": "察雅县，昌都市，西藏自治区",
                            "simple_py": "CYX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0895",
                            "area_code": "540325",
                            "longitude": "97.565701",
                            "latitude": "30.653038"
                        },
                        {
                            "area_id": 19111,
                            "city_id": 19102,
                            "province_id": 13,
                            "name": "丁青县",
                            "whole_name": "丁青县，昌都市，西藏自治区",
                            "simple_py": "DQX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0895",
                            "area_code": "540324",
                            "longitude": "95.597748",
                            "latitude": "31.410681"
                        },
                        {
                            "area_id": 19116,
                            "city_id": 19102,
                            "province_id": 13,
                            "name": "贡觉县",
                            "whole_name": "贡觉县，昌都市，西藏自治区",
                            "simple_py": "GJX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0895",
                            "area_code": "540322",
                            "longitude": "98.271191",
                            "latitude": "30.859206"
                        },
                        {
                            "area_id": 19109,
                            "city_id": 19102,
                            "province_id": 13,
                            "name": "江达县",
                            "whole_name": "江达县，昌都市，西藏自治区",
                            "simple_py": "JDX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0895",
                            "area_code": "540321",
                            "longitude": "98.218351",
                            "latitude": "31.499534"
                        },
                        {
                            "area_id": 19110,
                            "city_id": 19102,
                            "province_id": 13,
                            "name": "卡若区",
                            "whole_name": "卡若区，昌都市，西藏自治区",
                            "simple_py": "KRQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0895",
                            "area_code": "540302",
                            "longitude": "97.178255",
                            "latitude": "31.137035"
                        },
                        {
                            "area_id": 19112,
                            "city_id": 19102,
                            "province_id": 13,
                            "name": "类乌齐县",
                            "whole_name": "类乌齐县，昌都市，西藏自治区",
                            "simple_py": "LWQX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0895",
                            "area_code": "540323",
                            "longitude": "96.601259",
                            "latitude": "31.213048"
                        },
                        {
                            "area_id": 19114,
                            "city_id": 19102,
                            "province_id": 13,
                            "name": "洛隆县",
                            "whole_name": "洛隆县，昌都市，西藏自治区",
                            "simple_py": "LLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0895",
                            "area_code": "540329",
                            "longitude": "95.823418",
                            "latitude": "30.741947"
                        },
                        {
                            "area_id": 19118,
                            "city_id": 19102,
                            "province_id": 13,
                            "name": "芒康县",
                            "whole_name": "芒康县，昌都市，西藏自治区",
                            "simple_py": "MKX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0895",
                            "area_code": "540328",
                            "longitude": "98.596444",
                            "latitude": "29.686615"
                        },
                        {
                            "area_id": 19119,
                            "city_id": 19102,
                            "province_id": 13,
                            "name": "左贡县",
                            "whole_name": "左贡县，昌都市，西藏自治区",
                            "simple_py": "ZGX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0895",
                            "area_code": "540327",
                            "longitude": "97.840532",
                            "latitude": "29.671335"
                        }
                    ]
                },
                {
                    "city_id": 19103,
                    "province_id": 13,
                    "name": "拉萨市",
                    "whole_name": "拉萨市，西藏自治区",
                    "simple_py": "LSS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0891",
                    "area_code": "540100",
                    "longitude": "91.132212",
                    "latitude": "29.660361",
                    "children": [
                        {
                            "area_id": 19262,
                            "city_id": 19103,
                            "province_id": 13,
                            "name": "城关区",
                            "whole_name": "城关区，拉萨市，西藏自治区",
                            "simple_py": "CGQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0891",
                            "area_code": "540102",
                            "longitude": "91.132911",
                            "latitude": "29.659472"
                        },
                        {
                            "area_id": 19258,
                            "city_id": 19103,
                            "province_id": 13,
                            "name": "当雄县",
                            "whole_name": "当雄县，拉萨市，西藏自治区",
                            "simple_py": "DXX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0891",
                            "area_code": "540122",
                            "longitude": "91.103551",
                            "latitude": "30.474819"
                        },
                        {
                            "area_id": 19261,
                            "city_id": 19103,
                            "province_id": 13,
                            "name": "堆龙德庆区",
                            "whole_name": "堆龙德庆区，拉萨市，西藏自治区",
                            "simple_py": "DLDQQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0891",
                            "area_code": "540103",
                            "longitude": "91.002823",
                            "latitude": "29.647347"
                        },
                        {
                            "area_id": 19264,
                            "city_id": 19103,
                            "province_id": 13,
                            "name": "达孜区",
                            "whole_name": "达孜区，拉萨市，西藏自治区",
                            "simple_py": "DZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0891",
                            "area_code": "540104",
                            "longitude": "91.350976",
                            "latitude": "29.670314"
                        },
                        {
                            "area_id": 19260,
                            "city_id": 19103,
                            "province_id": 13,
                            "name": "林周县",
                            "whole_name": "林周县，拉萨市，西藏自治区",
                            "simple_py": "LZX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0891",
                            "area_code": "540121",
                            "longitude": "91.261842",
                            "latitude": "29.895754"
                        },
                        {
                            "area_id": 19259,
                            "city_id": 19103,
                            "province_id": 13,
                            "name": "墨竹工卡县",
                            "whole_name": "墨竹工卡县，拉萨市，西藏自治区",
                            "simple_py": "MZGKX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0891",
                            "area_code": "540127",
                            "longitude": "91.731158",
                            "latitude": "29.834657"
                        },
                        {
                            "area_id": 19263,
                            "city_id": 19103,
                            "province_id": 13,
                            "name": "尼木县",
                            "whole_name": "尼木县，拉萨市，西藏自治区",
                            "simple_py": "NMX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0891",
                            "area_code": "540123",
                            "longitude": "90.165545",
                            "latitude": "29.431346"
                        },
                        {
                            "area_id": 19265,
                            "city_id": 19103,
                            "province_id": 13,
                            "name": "曲水县",
                            "whole_name": "曲水县，拉萨市，西藏自治区",
                            "simple_py": "QSX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0891",
                            "area_code": "540124",
                            "longitude": "90.738051",
                            "latitude": "29.349895"
                        }
                    ]
                },
                {
                    "city_id": 19107,
                    "province_id": 13,
                    "name": "林芝市",
                    "whole_name": "林芝市，西藏自治区",
                    "simple_py": "LZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "L",
                    "city_code": "0894",
                    "area_code": "540400",
                    "longitude": "94.362348",
                    "latitude": "29.654693",
                    "children": [
                        {
                            "area_id": 19767,
                            "city_id": 19107,
                            "province_id": 13,
                            "name": "波密县",
                            "whole_name": "波密县，林芝市，西藏自治区",
                            "simple_py": "BMX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0894",
                            "area_code": "540424",
                            "longitude": "95.768151",
                            "latitude": "29.858771"
                        },
                        {
                            "area_id": 19769,
                            "city_id": 19107,
                            "province_id": 13,
                            "name": "巴宜区",
                            "whole_name": "巴宜区，林芝市，西藏自治区",
                            "simple_py": "BYQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0894",
                            "area_code": "540402",
                            "longitude": "94.360987",
                            "latitude": "29.653732"
                        },
                        {
                            "area_id": 19772,
                            "city_id": 19107,
                            "province_id": 13,
                            "name": "察隅县",
                            "whole_name": "察隅县，林芝市，西藏自治区",
                            "simple_py": "CYX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0894",
                            "area_code": "540425",
                            "longitude": "97.465002",
                            "latitude": "28.660244"
                        },
                        {
                            "area_id": 19768,
                            "city_id": 19107,
                            "province_id": 13,
                            "name": "工布江达县",
                            "whole_name": "工布江达县，林芝市，西藏自治区",
                            "simple_py": "GBJDX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0894",
                            "area_code": "540421",
                            "longitude": "93.246515",
                            "latitude": "29.88447"
                        },
                        {
                            "area_id": 19773,
                            "city_id": 19107,
                            "province_id": 13,
                            "name": "朗县",
                            "whole_name": "朗县，林芝市，西藏自治区",
                            "simple_py": "LX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0894",
                            "area_code": "540426",
                            "longitude": "93.073429",
                            "latitude": "29.0446"
                        },
                        {
                            "area_id": 19770,
                            "city_id": 19107,
                            "province_id": 13,
                            "name": "墨脱县",
                            "whole_name": "墨脱县，林芝市，西藏自治区",
                            "simple_py": "MTX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0894",
                            "area_code": "540423",
                            "longitude": "95.332245",
                            "latitude": "29.32573"
                        },
                        {
                            "area_id": 19771,
                            "city_id": 19107,
                            "province_id": 13,
                            "name": "米林县",
                            "whole_name": "米林县，林芝市，西藏自治区",
                            "simple_py": "MLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0894",
                            "area_code": "540422",
                            "longitude": "94.213679",
                            "latitude": "29.213811"
                        }
                    ]
                },
                {
                    "city_id": 19104,
                    "province_id": 13,
                    "name": "那曲市",
                    "whole_name": "那曲市，西藏自治区",
                    "simple_py": "NQS",
                    "per_pin_yin": "N",
                    "per_pin_yin2": "N",
                    "city_code": "0896",
                    "area_code": "540600",
                    "longitude": "92.060214",
                    "latitude": "31.476004",
                    "children": [
                        {
                            "area_id": 19333,
                            "city_id": 19104,
                            "province_id": 13,
                            "name": "安多县",
                            "whole_name": "安多县，那曲市，西藏自治区",
                            "simple_py": "ADX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0896",
                            "area_code": "540624",
                            "longitude": "91.681879",
                            "latitude": "32.260299"
                        },
                        {
                            "area_id": 19332,
                            "city_id": 19104,
                            "province_id": 13,
                            "name": "巴青县",
                            "whole_name": "巴青县，那曲市，西藏自治区",
                            "simple_py": "BQX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0896",
                            "area_code": "540628",
                            "longitude": "94.054049",
                            "latitude": "31.918691"
                        },
                        {
                            "area_id": 19334,
                            "city_id": 19104,
                            "province_id": 13,
                            "name": "班戈县",
                            "whole_name": "班戈县，那曲市，西藏自治区",
                            "simple_py": "BGX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0896",
                            "area_code": "540627",
                            "longitude": "90.011822",
                            "latitude": "31.394578"
                        },
                        {
                            "area_id": 19335,
                            "city_id": 19104,
                            "province_id": 13,
                            "name": "比如县",
                            "whole_name": "比如县，那曲市，西藏自治区",
                            "simple_py": "BRX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "B",
                            "city_code": "0896",
                            "area_code": "540622",
                            "longitude": "93.68044",
                            "latitude": "31.479917"
                        },
                        {
                            "area_id": 19339,
                            "city_id": 19104,
                            "province_id": 13,
                            "name": "嘉黎县",
                            "whole_name": "嘉黎县，那曲市，西藏自治区",
                            "simple_py": "JLX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0896",
                            "area_code": "540621",
                            "longitude": "93.232907",
                            "latitude": "30.640846"
                        },
                        {
                            "area_id": 19331,
                            "city_id": 19104,
                            "province_id": 13,
                            "name": "聂荣县",
                            "whole_name": "聂荣县，那曲市，西藏自治区",
                            "simple_py": "NRX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0896",
                            "area_code": "540623",
                            "longitude": "92.303659",
                            "latitude": "32.107855"
                        },
                        {
                            "area_id": 19340,
                            "city_id": 19104,
                            "province_id": 13,
                            "name": "尼玛县",
                            "whole_name": "尼玛县，那曲市，西藏自治区",
                            "simple_py": "NMX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0896",
                            "area_code": "540629",
                            "longitude": "87.236646",
                            "latitude": "31.784979"
                        },
                        {
                            "area_id": 19336,
                            "city_id": 19104,
                            "province_id": 13,
                            "name": "申扎县",
                            "whole_name": "申扎县，那曲市，西藏自治区",
                            "simple_py": "SZX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0896",
                            "area_code": "540625",
                            "longitude": "88.709777",
                            "latitude": "30.929056"
                        },
                        {
                            "area_id": 19337,
                            "city_id": 19104,
                            "province_id": 13,
                            "name": "索县",
                            "whole_name": "索县，那曲市，西藏自治区",
                            "simple_py": "SX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0896",
                            "area_code": "540626",
                            "longitude": "93.784964",
                            "latitude": "31.886173"
                        },
                        {
                            "area_id": 19338,
                            "city_id": 19104,
                            "province_id": 13,
                            "name": "色尼区",
                            "whole_name": "色尼区，那曲市，西藏自治区",
                            "simple_py": "SNQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0896",
                            "area_code": "540602",
                            "longitude": "92.061862",
                            "latitude": "31.475756"
                        },
                        {
                            "area_id": 19341,
                            "city_id": 19104,
                            "province_id": 13,
                            "name": "双湖县",
                            "whole_name": "双湖县，那曲市，西藏自治区",
                            "simple_py": "SHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0896",
                            "area_code": "540630",
                            "longitude": "88.838578",
                            "latitude": "33.18698"
                        }
                    ]
                },
                {
                    "city_id": 19105,
                    "province_id": 13,
                    "name": "日喀则市",
                    "whole_name": "日喀则市，西藏自治区",
                    "simple_py": "RKZS",
                    "per_pin_yin": "R",
                    "per_pin_yin2": "R",
                    "city_code": "0892",
                    "area_code": "540200",
                    "longitude": "88.885148",
                    "latitude": "29.267519",
                    "children": [
                        {
                            "area_id": 19453,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "昂仁县",
                            "whole_name": "昂仁县，日喀则市，西藏自治区",
                            "simple_py": "ARX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0892",
                            "area_code": "540226",
                            "longitude": "87.23578",
                            "latitude": "29.294758"
                        },
                        {
                            "area_id": 19462,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "白朗县",
                            "whole_name": "白朗县，日喀则市，西藏自治区",
                            "simple_py": "BLX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0892",
                            "area_code": "540228",
                            "longitude": "89.263618",
                            "latitude": "29.106627"
                        },
                        {
                            "area_id": 19463,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "定日县",
                            "whole_name": "定日县，日喀则市，西藏自治区",
                            "simple_py": "DRX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0892",
                            "area_code": "540223",
                            "longitude": "87.123887",
                            "latitude": "28.656667"
                        },
                        {
                            "area_id": 19468,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "定结县",
                            "whole_name": "定结县，日喀则市，西藏自治区",
                            "simple_py": "DJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0892",
                            "area_code": "540231",
                            "longitude": "87.767723",
                            "latitude": "28.36409"
                        },
                        {
                            "area_id": 19467,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "岗巴县",
                            "whole_name": "岗巴县，日喀则市，西藏自治区",
                            "simple_py": "GBX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0892",
                            "area_code": "540237",
                            "longitude": "88.518903",
                            "latitude": "28.274371"
                        },
                        {
                            "area_id": 19459,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "吉隆县",
                            "whole_name": "吉隆县，日喀则市，西藏自治区",
                            "simple_py": "JLX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0892",
                            "area_code": "540234",
                            "longitude": "85.298349",
                            "latitude": "28.852416"
                        },
                        {
                            "area_id": 19464,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "江孜县",
                            "whole_name": "江孜县，日喀则市，西藏自治区",
                            "simple_py": "JZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0892",
                            "area_code": "540222",
                            "longitude": "89.605044",
                            "latitude": "28.908845"
                        },
                        {
                            "area_id": 19466,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "康马县",
                            "whole_name": "康马县，日喀则市，西藏自治区",
                            "simple_py": "KMX",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0892",
                            "area_code": "540230",
                            "longitude": "89.683406",
                            "latitude": "28.554719"
                        },
                        {
                            "area_id": 19458,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "拉孜县",
                            "whole_name": "拉孜县，日喀则市，西藏自治区",
                            "simple_py": "LZX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0892",
                            "area_code": "540225",
                            "longitude": "87.63743",
                            "latitude": "29.085136"
                        },
                        {
                            "area_id": 19455,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "南木林县",
                            "whole_name": "南木林县，日喀则市，西藏自治区",
                            "simple_py": "NMLX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0892",
                            "area_code": "540221",
                            "longitude": "89.099434",
                            "latitude": "29.680459"
                        },
                        {
                            "area_id": 19465,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "聂拉木县",
                            "whole_name": "聂拉木县，日喀则市，西藏自治区",
                            "simple_py": "NLMX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "N",
                            "city_code": "0892",
                            "area_code": "540235",
                            "longitude": "85.981953",
                            "latitude": "28.15595"
                        },
                        {
                            "area_id": 19460,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "仁布县",
                            "whole_name": "仁布县，日喀则市，西藏自治区",
                            "simple_py": "RBX",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0892",
                            "area_code": "540229",
                            "longitude": "89.843207",
                            "latitude": "29.230299"
                        },
                        {
                            "area_id": 19456,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "萨嘎县",
                            "whole_name": "萨嘎县，日喀则市，西藏自治区",
                            "simple_py": "SGX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0892",
                            "area_code": "540236",
                            "longitude": "85.234622",
                            "latitude": "29.328194"
                        },
                        {
                            "area_id": 19457,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "桑珠孜区",
                            "whole_name": "桑珠孜区，日喀则市，西藏自治区",
                            "simple_py": "SZZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0892",
                            "area_code": "540202",
                            "longitude": "88.88667",
                            "latitude": "29.267003"
                        },
                        {
                            "area_id": 19461,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "萨迦县",
                            "whole_name": "萨迦县，日喀则市，西藏自治区",
                            "simple_py": "SJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0892",
                            "area_code": "540224",
                            "longitude": "88.023007",
                            "latitude": "28.901077"
                        },
                        {
                            "area_id": 19454,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "谢通门县",
                            "whole_name": "谢通门县，日喀则市，西藏自治区",
                            "simple_py": "XTMX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0892",
                            "area_code": "540227",
                            "longitude": "88.260517",
                            "latitude": "29.431597"
                        },
                        {
                            "area_id": 19469,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "亚东县",
                            "whole_name": "亚东县，日喀则市，西藏自治区",
                            "simple_py": "YDX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0892",
                            "area_code": "540233",
                            "longitude": "88.906806",
                            "latitude": "27.482772"
                        },
                        {
                            "area_id": 19452,
                            "city_id": 19105,
                            "province_id": 13,
                            "name": "仲巴县",
                            "whole_name": "仲巴县，日喀则市，西藏自治区",
                            "simple_py": "ZBX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0892",
                            "area_code": "540232",
                            "longitude": "84.032826",
                            "latitude": "29.768336"
                        }
                    ]
                },
                {
                    "city_id": 19106,
                    "province_id": 13,
                    "name": "山南市",
                    "whole_name": "山南市，西藏自治区",
                    "simple_py": "SNS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0893",
                    "area_code": "540500",
                    "longitude": "91.766529",
                    "latitude": "29.236023",
                    "children": [
                        {
                            "area_id": 19682,
                            "city_id": 19106,
                            "province_id": 13,
                            "name": "措美县",
                            "whole_name": "措美县，山南市，西藏自治区",
                            "simple_py": "CMX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0893",
                            "area_code": "540526",
                            "longitude": "91.432347",
                            "latitude": "28.437353"
                        },
                        {
                            "area_id": 19684,
                            "city_id": 19106,
                            "province_id": 13,
                            "name": "错那县",
                            "whole_name": "错那县，山南市，西藏自治区",
                            "simple_py": "CNX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "C",
                            "city_code": "0893",
                            "area_code": "540530",
                            "longitude": "91.960132",
                            "latitude": "27.991707"
                        },
                        {
                            "area_id": 19676,
                            "city_id": 19106,
                            "province_id": 13,
                            "name": "贡嘎县",
                            "whole_name": "贡嘎县，山南市，西藏自治区",
                            "simple_py": "GGX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0893",
                            "area_code": "540522",
                            "longitude": "90.985271",
                            "latitude": "29.289078"
                        },
                        {
                            "area_id": 19674,
                            "city_id": 19106,
                            "province_id": 13,
                            "name": "加查县",
                            "whole_name": "加查县，山南市，西藏自治区",
                            "simple_py": "JCX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0893",
                            "area_code": "540528",
                            "longitude": "92.591043",
                            "latitude": "29.140921"
                        },
                        {
                            "area_id": 19678,
                            "city_id": 19106,
                            "province_id": 13,
                            "name": "浪卡子县",
                            "whole_name": "浪卡子县，山南市，西藏自治区",
                            "simple_py": "LQZX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0893",
                            "area_code": "540531",
                            "longitude": "90.398747",
                            "latitude": "28.96836"
                        },
                        {
                            "area_id": 19679,
                            "city_id": 19106,
                            "province_id": 13,
                            "name": "隆子县",
                            "whole_name": "隆子县，山南市，西藏自治区",
                            "simple_py": "LZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0893",
                            "area_code": "540529",
                            "longitude": "92.463309",
                            "latitude": "28.408548"
                        },
                        {
                            "area_id": 19683,
                            "city_id": 19106,
                            "province_id": 13,
                            "name": "洛扎县",
                            "whole_name": "洛扎县，山南市，西藏自治区",
                            "simple_py": "LZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0893",
                            "area_code": "540527",
                            "longitude": "90.858243",
                            "latitude": "28.385765"
                        },
                        {
                            "area_id": 19675,
                            "city_id": 19106,
                            "province_id": 13,
                            "name": "乃东区",
                            "whole_name": "乃东区，山南市，西藏自治区",
                            "simple_py": "NDQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0893",
                            "area_code": "540502",
                            "longitude": "91.76525",
                            "latitude": "29.236106"
                        },
                        {
                            "area_id": 19680,
                            "city_id": 19106,
                            "province_id": 13,
                            "name": "琼结县",
                            "whole_name": "琼结县，山南市，西藏自治区",
                            "simple_py": "QJX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0893",
                            "area_code": "540524",
                            "longitude": "91.683753",
                            "latitude": "29.025242"
                        },
                        {
                            "area_id": 19681,
                            "city_id": 19106,
                            "province_id": 13,
                            "name": "曲松县",
                            "whole_name": "曲松县，山南市，西藏自治区",
                            "simple_py": "QSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0893",
                            "area_code": "540525",
                            "longitude": "92.201066",
                            "latitude": "29.063656"
                        },
                        {
                            "area_id": 19673,
                            "city_id": 19106,
                            "province_id": 13,
                            "name": "桑日县",
                            "whole_name": "桑日县，山南市，西藏自治区",
                            "simple_py": "SRX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0893",
                            "area_code": "540523",
                            "longitude": "92.015732",
                            "latitude": "29.259774"
                        },
                        {
                            "area_id": 19677,
                            "city_id": 19106,
                            "province_id": 13,
                            "name": "扎囊县",
                            "whole_name": "扎囊县，山南市，西藏自治区",
                            "simple_py": "ZNX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0893",
                            "area_code": "540521",
                            "longitude": "91.338",
                            "latitude": "29.246476"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 25,
            "name": "香港特别行政区",
            "whole_name": "香港特别行政区",
            "simple_py": "XGTBXZQ",
            "per_pin_yin": " ",
            "per_pin_yin2": "X",
            "city_code": "",
            "area_code": "810000",
            "longitude": "114.173355",
            "latitude": "22.320048",
            "children": [
                {
                    "city_id": 35021,
                    "province_id": 25,
                    "name": "北区",
                    "whole_name": "北区，香港特别行政区",
                    "simple_py": "BQ",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "",
                    "area_code": "810013",
                    "longitude": "114.147404",
                    "latitude": "22.496143",
                    "children": []
                },
                {
                    "city_id": 35014,
                    "province_id": 25,
                    "name": "东区",
                    "whole_name": "东区，香港特别行政区",
                    "simple_py": "DQ",
                    "per_pin_yin": "D",
                    "per_pin_yin2": "D",
                    "city_code": "",
                    "area_code": "810003",
                    "longitude": "114.225965",
                    "latitude": "22.279779",
                    "children": []
                },
                {
                    "city_id": 35016,
                    "province_id": 25,
                    "name": "大埔区",
                    "whole_name": "大埔区，香港特别行政区",
                    "simple_py": "DBQ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "D",
                    "city_code": "",
                    "area_code": "810014",
                    "longitude": "114.171713",
                    "latitude": "22.44573",
                    "children": []
                },
                {
                    "city_id": 35020,
                    "province_id": 25,
                    "name": "观塘区",
                    "whole_name": "观塘区，香港特别行政区",
                    "simple_py": "GTQ",
                    "per_pin_yin": "G",
                    "per_pin_yin2": "G",
                    "city_code": "",
                    "area_code": "810009",
                    "longitude": "114.214083",
                    "latitude": "22.320679",
                    "children": []
                },
                {
                    "city_id": 35013,
                    "province_id": 25,
                    "name": "黄大仙区",
                    "whole_name": "黄大仙区，香港特别行政区",
                    "simple_py": "HDXQ",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "",
                    "area_code": "810008",
                    "longitude": "114.203985",
                    "latitude": "22.336112",
                    "children": []
                },
                {
                    "city_id": 35017,
                    "province_id": 25,
                    "name": "九龙城区",
                    "whole_name": "九龙城区，香港特别行政区",
                    "simple_py": "JLCQ",
                    "per_pin_yin": "J",
                    "per_pin_yin2": "J",
                    "city_code": "",
                    "area_code": "810007",
                    "longitude": "114.193047",
                    "latitude": "22.312373",
                    "children": []
                },
                {
                    "city_id": 35024,
                    "province_id": 25,
                    "name": "葵青区",
                    "whole_name": "葵青区，香港特别行政区",
                    "simple_py": "KQQ",
                    "per_pin_yin": "K",
                    "per_pin_yin2": "K",
                    "city_code": "",
                    "area_code": "810017",
                    "longitude": "114.13918",
                    "latitude": "22.363908",
                    "children": []
                },
                {
                    "city_id": 35022,
                    "province_id": 25,
                    "name": "离岛区",
                    "whole_name": "离岛区，香港特别行政区",
                    "simple_py": "LDQ",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "",
                    "area_code": "810018",
                    "longitude": "113.946059",
                    "latitude": "22.286371",
                    "children": []
                },
                {
                    "city_id": 35019,
                    "province_id": 25,
                    "name": "南区",
                    "whole_name": "南区，香港特别行政区",
                    "simple_py": "NQ",
                    "per_pin_yin": "N",
                    "per_pin_yin2": "N",
                    "city_code": "",
                    "area_code": "810004",
                    "longitude": "114.160023",
                    "latitude": "22.245811",
                    "children": []
                },
                {
                    "city_id": 35023,
                    "province_id": 25,
                    "name": "荃湾区",
                    "whole_name": "荃湾区，香港特别行政区",
                    "simple_py": "QWQ",
                    "per_pin_yin": "Q",
                    "per_pin_yin2": "Q",
                    "city_code": "",
                    "area_code": "810010",
                    "longitude": "114.121234",
                    "latitude": "22.368458",
                    "children": []
                },
                {
                    "city_id": 35007,
                    "province_id": 25,
                    "name": "深水埗区",
                    "whole_name": "深水埗区，香港特别行政区",
                    "simple_py": "SSBQ",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "",
                    "area_code": "810006",
                    "longitude": "114.163349",
                    "latitude": "22.333775",
                    "children": []
                },
                {
                    "city_id": 35018,
                    "province_id": 25,
                    "name": "沙田区",
                    "whole_name": "沙田区，香港特别行政区",
                    "simple_py": "STQ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "S",
                    "city_code": "",
                    "area_code": "810016",
                    "longitude": "114.195126",
                    "latitude": "22.379715",
                    "children": []
                },
                {
                    "city_id": 35012,
                    "province_id": 25,
                    "name": "屯门区",
                    "whole_name": "屯门区，香港特别行政区",
                    "simple_py": "TMQ",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "",
                    "area_code": "810011",
                    "longitude": "113.976308",
                    "latitude": "22.393896",
                    "children": []
                },
                {
                    "city_id": 35011,
                    "province_id": 25,
                    "name": "湾仔区",
                    "whole_name": "湾仔区，香港特别行政区",
                    "simple_py": "WZQ",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "",
                    "area_code": "810002",
                    "longitude": "114.18299",
                    "latitude": "22.276345",
                    "children": []
                },
                {
                    "city_id": 35008,
                    "province_id": 25,
                    "name": "西贡区",
                    "whole_name": "西贡区，香港特别行政区",
                    "simple_py": "XGQ",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "",
                    "area_code": "810015",
                    "longitude": "114.264813",
                    "latitude": "22.314203",
                    "children": []
                },
                {
                    "city_id": 35009,
                    "province_id": 25,
                    "name": "元朗区",
                    "whole_name": "元朗区，香港特别行政区",
                    "simple_py": "YLQ",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "",
                    "area_code": "810012",
                    "longitude": "114.032528",
                    "latitude": "22.44132",
                    "children": []
                },
                {
                    "city_id": 35010,
                    "province_id": 25,
                    "name": "油尖旺区",
                    "whole_name": "油尖旺区，香港特别行政区",
                    "simple_py": "YJWQ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "Y",
                    "city_code": "",
                    "area_code": "810005",
                    "longitude": "114.173347",
                    "latitude": "22.311632",
                    "children": []
                },
                {
                    "city_id": 35015,
                    "province_id": 25,
                    "name": "中西区",
                    "whole_name": "中西区，香港特别行政区",
                    "simple_py": "ZXQ",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "",
                    "area_code": "810001",
                    "longitude": "114.154334",
                    "latitude": "22.281931",
                    "children": []
                }
            ]
        },
        {
            "province_id": 31,
            "name": "云南省",
            "whole_name": "云南省",
            "simple_py": "YNS",
            "per_pin_yin": "Y",
            "per_pin_yin2": "Y",
            "city_code": "",
            "area_code": "530000",
            "longitude": "102.712251",
            "latitude": "25.040609",
            "children": [
                {
                    "city_id": 42985,
                    "province_id": 31,
                    "name": "保山市",
                    "whole_name": "保山市，云南省",
                    "simple_py": "BSS",
                    "per_pin_yin": "B",
                    "per_pin_yin2": "B",
                    "city_code": "0875",
                    "area_code": "530500",
                    "longitude": "99.167133",
                    "latitude": "25.111802",
                    "children": [
                        {
                            "area_id": 43548,
                            "city_id": 42985,
                            "province_id": 31,
                            "name": "昌宁县",
                            "whole_name": "昌宁县，保山市，云南省",
                            "simple_py": "CNX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0875",
                            "area_code": "530524",
                            "longitude": "99.612344",
                            "latitude": "24.823662"
                        },
                        {
                            "area_id": 43546,
                            "city_id": 42985,
                            "province_id": 31,
                            "name": "隆阳区",
                            "whole_name": "隆阳区，保山市，云南省",
                            "simple_py": "LYQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0875",
                            "area_code": "530502",
                            "longitude": "99.165825",
                            "latitude": "25.112144"
                        },
                        {
                            "area_id": 43550,
                            "city_id": 42985,
                            "province_id": 31,
                            "name": "龙陵县",
                            "whole_name": "龙陵县，保山市，云南省",
                            "simple_py": "LLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0875",
                            "area_code": "530523",
                            "longitude": "98.693567",
                            "latitude": "24.591912"
                        },
                        {
                            "area_id": 43549,
                            "city_id": 42985,
                            "province_id": 31,
                            "name": "施甸县",
                            "whole_name": "施甸县，保山市，云南省",
                            "simple_py": "SDX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0875",
                            "area_code": "530521",
                            "longitude": "99.183758",
                            "latitude": "24.730847"
                        },
                        {
                            "area_id": 43547,
                            "city_id": 42985,
                            "province_id": 31,
                            "name": "腾冲市",
                            "whole_name": "腾冲市，保山市，云南省",
                            "simple_py": "TCS",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0875",
                            "area_code": "530581",
                            "longitude": "98.497292",
                            "latitude": "25.01757"
                        }
                    ]
                },
                {
                    "city_id": 42993,
                    "province_id": 31,
                    "name": "楚雄彝族自治州",
                    "whole_name": "楚雄彝族自治州，云南省",
                    "simple_py": "CXYZZZZ",
                    "per_pin_yin": "C",
                    "per_pin_yin2": "C",
                    "city_code": "0878",
                    "area_code": "532300",
                    "longitude": "101.546046",
                    "latitude": "25.041988",
                    "children": [
                        {
                            "area_id": 44281,
                            "city_id": 42993,
                            "province_id": 31,
                            "name": "楚雄市",
                            "whole_name": "楚雄市，楚雄彝族自治州，云南省",
                            "simple_py": "CXS",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0878",
                            "area_code": "532301",
                            "longitude": "101.546145",
                            "latitude": "25.040912"
                        },
                        {
                            "area_id": 44278,
                            "city_id": 42993,
                            "province_id": 31,
                            "name": "大姚县",
                            "whole_name": "大姚县，楚雄彝族自治州，云南省",
                            "simple_py": "DYX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0878",
                            "area_code": "532326",
                            "longitude": "101.323602",
                            "latitude": "25.722348"
                        },
                        {
                            "area_id": 44280,
                            "city_id": 42993,
                            "province_id": 31,
                            "name": "禄丰县",
                            "whole_name": "禄丰县，楚雄彝族自治州，云南省",
                            "simple_py": "LFX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0878",
                            "area_code": "532331",
                            "longitude": "102.075694",
                            "latitude": "25.14327"
                        },
                        {
                            "area_id": 44277,
                            "city_id": 42993,
                            "province_id": 31,
                            "name": "牟定县",
                            "whole_name": "牟定县，楚雄彝族自治州，云南省",
                            "simple_py": "MDX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0878",
                            "area_code": "532323",
                            "longitude": "101.543044",
                            "latitude": "25.312111"
                        },
                        {
                            "area_id": 44279,
                            "city_id": 42993,
                            "province_id": 31,
                            "name": "南华县",
                            "whole_name": "南华县，楚雄彝族自治州，云南省",
                            "simple_py": "NHX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0878",
                            "area_code": "532324",
                            "longitude": "101.274991",
                            "latitude": "25.192408"
                        },
                        {
                            "area_id": 44282,
                            "city_id": 42993,
                            "province_id": 31,
                            "name": "双柏县",
                            "whole_name": "双柏县，楚雄彝族自治州，云南省",
                            "simple_py": "SBX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0878",
                            "area_code": "532322",
                            "longitude": "101.63824",
                            "latitude": "24.685094"
                        },
                        {
                            "area_id": 44283,
                            "city_id": 42993,
                            "province_id": 31,
                            "name": "武定县",
                            "whole_name": "武定县，楚雄彝族自治州，云南省",
                            "simple_py": "WDX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0878",
                            "area_code": "532329",
                            "longitude": "102.406785",
                            "latitude": "25.5301"
                        },
                        {
                            "area_id": 44275,
                            "city_id": 42993,
                            "province_id": 31,
                            "name": "元谋县",
                            "whole_name": "元谋县，楚雄彝族自治州，云南省",
                            "simple_py": "YMX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0878",
                            "area_code": "532328",
                            "longitude": "101.870837",
                            "latitude": "25.703313"
                        },
                        {
                            "area_id": 44276,
                            "city_id": 42993,
                            "province_id": 31,
                            "name": "姚安县",
                            "whole_name": "姚安县，楚雄彝族自治州，云南省",
                            "simple_py": "YAX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0878",
                            "area_code": "532325",
                            "longitude": "101.238399",
                            "latitude": "25.505403"
                        },
                        {
                            "area_id": 44284,
                            "city_id": 42993,
                            "province_id": 31,
                            "name": "永仁县",
                            "whole_name": "永仁县，楚雄彝族自治州，云南省",
                            "simple_py": "YRX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0878",
                            "area_code": "532327",
                            "longitude": "101.671175",
                            "latitude": "26.056316"
                        }
                    ]
                },
                {
                    "city_id": 42987,
                    "province_id": 31,
                    "name": "大理白族自治州",
                    "whole_name": "大理白族自治州，云南省",
                    "simple_py": "DLBZZZZ",
                    "per_pin_yin": "D",
                    "per_pin_yin2": "D",
                    "city_code": "0872",
                    "area_code": "532900",
                    "longitude": "100.225668",
                    "latitude": "25.589449",
                    "children": [
                        {
                            "area_id": 43745,
                            "city_id": 42987,
                            "province_id": 31,
                            "name": "宾川县",
                            "whole_name": "宾川县，大理白族自治州，云南省",
                            "simple_py": "BCX",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0872",
                            "area_code": "532924",
                            "longitude": "100.578957",
                            "latitude": "25.825904"
                        },
                        {
                            "area_id": 43743,
                            "city_id": 42987,
                            "province_id": 31,
                            "name": "大理市",
                            "whole_name": "大理市，大理白族自治州，云南省",
                            "simple_py": "DLS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0872",
                            "area_code": "532901",
                            "longitude": "100.241369",
                            "latitude": "25.593067"
                        },
                        {
                            "area_id": 43744,
                            "city_id": 42987,
                            "province_id": 31,
                            "name": "洱源县",
                            "whole_name": "洱源县，大理白族自治州，云南省",
                            "simple_py": "EYX",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0872",
                            "area_code": "532930",
                            "longitude": "99.951708",
                            "latitude": "26.111184"
                        },
                        {
                            "area_id": 43742,
                            "city_id": 42987,
                            "province_id": 31,
                            "name": "鹤庆县",
                            "whole_name": "鹤庆县，大理白族自治州，云南省",
                            "simple_py": "HQX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0872",
                            "area_code": "532932",
                            "longitude": "100.173375",
                            "latitude": "26.55839"
                        },
                        {
                            "area_id": 43741,
                            "city_id": 42987,
                            "province_id": 31,
                            "name": "剑川县",
                            "whole_name": "剑川县，大理白族自治州，云南省",
                            "simple_py": "JCX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0872",
                            "area_code": "532931",
                            "longitude": "99.905887",
                            "latitude": "26.530066"
                        },
                        {
                            "area_id": 43751,
                            "city_id": 42987,
                            "province_id": 31,
                            "name": "弥渡县",
                            "whole_name": "弥渡县，大理白族自治州，云南省",
                            "simple_py": "MDX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0872",
                            "area_code": "532925",
                            "longitude": "100.490669",
                            "latitude": "25.342594"
                        },
                        {
                            "area_id": 43752,
                            "city_id": 42987,
                            "province_id": 31,
                            "name": "南涧彝族自治县",
                            "whole_name": "南涧彝族自治县，大理白族自治州，云南省",
                            "simple_py": "NJYZZZX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0872",
                            "area_code": "532926",
                            "longitude": "100.518683",
                            "latitude": "25.041279"
                        },
                        {
                            "area_id": 43749,
                            "city_id": 42987,
                            "province_id": 31,
                            "name": "巍山彝族回族自治县",
                            "whole_name": "巍山彝族回族自治县，大理白族自治州，云南省",
                            "simple_py": "WSYZHZZZX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0872",
                            "area_code": "532927",
                            "longitude": "100.30793",
                            "latitude": "25.230909"
                        },
                        {
                            "area_id": 43747,
                            "city_id": 42987,
                            "province_id": 31,
                            "name": "祥云县",
                            "whole_name": "祥云县，大理白族自治州，云南省",
                            "simple_py": "XYX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0872",
                            "area_code": "532923",
                            "longitude": "100.554025",
                            "latitude": "25.477072"
                        },
                        {
                            "area_id": 43746,
                            "city_id": 42987,
                            "province_id": 31,
                            "name": "云龙县",
                            "whole_name": "云龙县，大理白族自治州，云南省",
                            "simple_py": "YLX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0872",
                            "area_code": "532929",
                            "longitude": "99.369402",
                            "latitude": "25.884955"
                        },
                        {
                            "area_id": 43748,
                            "city_id": 42987,
                            "province_id": 31,
                            "name": "漾濞彝族自治县",
                            "whole_name": "漾濞彝族自治县，大理白族自治州，云南省",
                            "simple_py": "YBYZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0872",
                            "area_code": "532922",
                            "longitude": "99.95797",
                            "latitude": "25.669543"
                        },
                        {
                            "area_id": 43750,
                            "city_id": 42987,
                            "province_id": 31,
                            "name": "永平县",
                            "whole_name": "永平县，大理白族自治州，云南省",
                            "simple_py": "YPX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0872",
                            "area_code": "532928",
                            "longitude": "99.533536",
                            "latitude": "25.461281"
                        }
                    ]
                },
                {
                    "city_id": 42989,
                    "province_id": 31,
                    "name": "迪庆藏族自治州",
                    "whole_name": "迪庆藏族自治州，云南省",
                    "simple_py": "DQCZZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "D",
                    "city_code": "0887",
                    "area_code": "533400",
                    "longitude": "99.706463",
                    "latitude": "27.826853",
                    "children": [
                        {
                            "area_id": 43898,
                            "city_id": 42989,
                            "province_id": 31,
                            "name": "德钦县",
                            "whole_name": "德钦县，迪庆藏族自治州，云南省",
                            "simple_py": "DQX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0887",
                            "area_code": "533422",
                            "longitude": "98.91506",
                            "latitude": "28.483272"
                        },
                        {
                            "area_id": 43900,
                            "city_id": 42989,
                            "province_id": 31,
                            "name": "维西傈僳族自治县",
                            "whole_name": "维西傈僳族自治县，迪庆藏族自治州，云南省",
                            "simple_py": "WXLSZZZX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0887",
                            "area_code": "533423",
                            "longitude": "99.286355",
                            "latitude": "27.180948"
                        },
                        {
                            "area_id": 43899,
                            "city_id": 42989,
                            "province_id": 31,
                            "name": "香格里拉市",
                            "whole_name": "香格里拉市，迪庆藏族自治州，云南省",
                            "simple_py": "XGLLS",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0887",
                            "area_code": "533401",
                            "longitude": "99.708667",
                            "latitude": "27.825804"
                        }
                    ]
                },
                {
                    "city_id": 42994,
                    "province_id": 31,
                    "name": "德宏傣族景颇族自治州",
                    "whole_name": "德宏傣族景颇族自治州，云南省",
                    "simple_py": "DHDZJPZZZZ",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "D",
                    "city_code": "0692",
                    "area_code": "533100",
                    "longitude": "98.578363",
                    "latitude": "24.436694",
                    "children": [
                        {
                            "area_id": 44389,
                            "city_id": 42994,
                            "province_id": 31,
                            "name": "梁河县",
                            "whole_name": "梁河县，德宏傣族景颇族自治州，云南省",
                            "simple_py": "LHX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0692",
                            "area_code": "533122",
                            "longitude": "98.298196",
                            "latitude": "24.80742"
                        },
                        {
                            "area_id": 44391,
                            "city_id": 42994,
                            "province_id": 31,
                            "name": "陇川县",
                            "whole_name": "陇川县，德宏傣族景颇族自治州，云南省",
                            "simple_py": "LCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0692",
                            "area_code": "533124",
                            "longitude": "97.794441",
                            "latitude": "24.184065"
                        },
                        {
                            "area_id": 44390,
                            "city_id": 42994,
                            "province_id": 31,
                            "name": "芒市",
                            "whole_name": "芒市，德宏傣族景颇族自治州，云南省",
                            "simple_py": "MS",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0692",
                            "area_code": "533103",
                            "longitude": "98.577608",
                            "latitude": "24.436699"
                        },
                        {
                            "area_id": 44392,
                            "city_id": 42994,
                            "province_id": 31,
                            "name": "瑞丽市",
                            "whole_name": "瑞丽市，德宏傣族景颇族自治州，云南省",
                            "simple_py": "RLS",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0692",
                            "area_code": "533102",
                            "longitude": "97.855883",
                            "latitude": "24.010734"
                        },
                        {
                            "area_id": 44388,
                            "city_id": 42994,
                            "province_id": 31,
                            "name": "盈江县",
                            "whole_name": "盈江县，德宏傣族景颇族自治州，云南省",
                            "simple_py": "YJX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0692",
                            "area_code": "533123",
                            "longitude": "97.93393",
                            "latitude": "24.709541"
                        }
                    ]
                },
                {
                    "city_id": 42982,
                    "province_id": 31,
                    "name": "红河哈尼族彝族自治州",
                    "whole_name": "红河哈尼族彝族自治州，云南省",
                    "simple_py": "HHHNZYZZZZ",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0873",
                    "area_code": "532500",
                    "longitude": "103.384182",
                    "latitude": "23.366775",
                    "children": [
                        {
                            "area_id": 43289,
                            "city_id": 42982,
                            "province_id": 31,
                            "name": "个旧市",
                            "whole_name": "个旧市，红河哈尼族彝族自治州，云南省",
                            "simple_py": "GJS",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0873",
                            "area_code": "532501",
                            "longitude": "103.154752",
                            "latitude": "23.360383"
                        },
                        {
                            "area_id": 43291,
                            "city_id": 42982,
                            "province_id": 31,
                            "name": "红河县",
                            "whole_name": "红河县，红河哈尼族彝族自治州，云南省",
                            "simple_py": "HHX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0873",
                            "area_code": "532529",
                            "longitude": "102.42121",
                            "latitude": "23.369191"
                        },
                        {
                            "area_id": 43294,
                            "city_id": 42982,
                            "province_id": 31,
                            "name": "河口瑶族自治县",
                            "whole_name": "河口瑶族自治县，红河哈尼族彝族自治州，云南省",
                            "simple_py": "HKYZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0873",
                            "area_code": "532532",
                            "longitude": "103.961593",
                            "latitude": "22.507563"
                        },
                        {
                            "area_id": 43286,
                            "city_id": 42982,
                            "province_id": 31,
                            "name": "建水县",
                            "whole_name": "建水县，红河哈尼族彝族自治州，云南省",
                            "simple_py": "JSX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0873",
                            "area_code": "532524",
                            "longitude": "102.820493",
                            "latitude": "23.618387"
                        },
                        {
                            "area_id": 43296,
                            "city_id": 42982,
                            "province_id": 31,
                            "name": "金平苗族瑶族傣族自治县",
                            "whole_name": "金平苗族瑶族傣族自治县，红河哈尼族彝族自治州，云南省",
                            "simple_py": "JPMZYZDZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0873",
                            "area_code": "532530",
                            "longitude": "103.228359",
                            "latitude": "22.779982"
                        },
                        {
                            "area_id": 43287,
                            "city_id": 42982,
                            "province_id": 31,
                            "name": "开远市",
                            "whole_name": "开远市，红河哈尼族彝族自治州，云南省",
                            "simple_py": "KYS",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0873",
                            "area_code": "532502",
                            "longitude": "103.258679",
                            "latitude": "23.713832"
                        },
                        {
                            "area_id": 43285,
                            "city_id": 42982,
                            "province_id": 31,
                            "name": "泸西县",
                            "whole_name": "泸西县，红河哈尼族彝族自治州，云南省",
                            "simple_py": "LXX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0873",
                            "area_code": "532527",
                            "longitude": "103.759622",
                            "latitude": "24.532368"
                        },
                        {
                            "area_id": 43295,
                            "city_id": 42982,
                            "province_id": 31,
                            "name": "绿春县",
                            "whole_name": "绿春县，红河哈尼族彝族自治州，云南省",
                            "simple_py": "LCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0873",
                            "area_code": "532531",
                            "longitude": "102.39286",
                            "latitude": "22.99352"
                        },
                        {
                            "area_id": 43284,
                            "city_id": 42982,
                            "province_id": 31,
                            "name": "弥勒市",
                            "whole_name": "弥勒市，红河哈尼族彝族自治州，云南省",
                            "simple_py": "MLS",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0873",
                            "area_code": "532504",
                            "longitude": "103.436988",
                            "latitude": "24.40837"
                        },
                        {
                            "area_id": 43293,
                            "city_id": 42982,
                            "province_id": 31,
                            "name": "蒙自市",
                            "whole_name": "蒙自市，红河哈尼族彝族自治州，云南省",
                            "simple_py": "MZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0873",
                            "area_code": "532503",
                            "longitude": "103.385005",
                            "latitude": "23.366843"
                        },
                        {
                            "area_id": 43290,
                            "city_id": 42982,
                            "province_id": 31,
                            "name": "屏边苗族自治县",
                            "whole_name": "屏边苗族自治县，红河哈尼族彝族自治州，云南省",
                            "simple_py": "PBMZZZX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0873",
                            "area_code": "532523",
                            "longitude": "103.687229",
                            "latitude": "22.987013"
                        },
                        {
                            "area_id": 43288,
                            "city_id": 42982,
                            "province_id": 31,
                            "name": "石屏县",
                            "whole_name": "石屏县，红河哈尼族彝族自治州，云南省",
                            "simple_py": "SPX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0873",
                            "area_code": "532525",
                            "longitude": "102.484469",
                            "latitude": "23.712569"
                        },
                        {
                            "area_id": 43292,
                            "city_id": 42982,
                            "province_id": 31,
                            "name": "元阳县",
                            "whole_name": "元阳县，红河哈尼族彝族自治州，云南省",
                            "simple_py": "YYX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0873",
                            "area_code": "532528",
                            "longitude": "102.837056",
                            "latitude": "23.219773"
                        }
                    ]
                },
                {
                    "city_id": 42992,
                    "province_id": 31,
                    "name": "昆明市",
                    "whole_name": "昆明市，云南省",
                    "simple_py": "KMS",
                    "per_pin_yin": "K",
                    "per_pin_yin2": "K",
                    "city_code": "0871",
                    "area_code": "530100",
                    "longitude": "102.712251",
                    "latitude": "25.040609",
                    "children": [
                        {
                            "area_id": 44137,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "安宁市",
                            "whole_name": "安宁市，昆明市，云南省",
                            "simple_py": "ANS",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0871",
                            "area_code": "530181",
                            "longitude": "102.485544",
                            "latitude": "24.921785"
                        },
                        {
                            "area_id": 44133,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "呈贡区",
                            "whole_name": "呈贡区，昆明市，云南省",
                            "simple_py": "CGQ",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0871",
                            "area_code": "530114",
                            "longitude": "102.801382",
                            "latitude": "24.889275"
                        },
                        {
                            "area_id": 44127,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "东川区",
                            "whole_name": "东川区，昆明市，云南省",
                            "simple_py": "DCQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0871",
                            "area_code": "530113",
                            "longitude": "103.182",
                            "latitude": "26.08349"
                        },
                        {
                            "area_id": 44136,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "富民县",
                            "whole_name": "富民县，昆明市，云南省",
                            "simple_py": "FMX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0871",
                            "area_code": "530124",
                            "longitude": "102.497888",
                            "latitude": "25.219667"
                        },
                        {
                            "area_id": 44138,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "官渡区",
                            "whole_name": "官渡区，昆明市，云南省",
                            "simple_py": "GDQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0871",
                            "area_code": "530111",
                            "longitude": "102.723437",
                            "latitude": "25.021211"
                        },
                        {
                            "area_id": 44134,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "晋宁区",
                            "whole_name": "晋宁区，昆明市，云南省",
                            "simple_py": "JNQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0871",
                            "area_code": "530115",
                            "longitude": "102.594987",
                            "latitude": "24.666944"
                        },
                        {
                            "area_id": 44135,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "禄劝彝族苗族自治县",
                            "whole_name": "禄劝彝族苗族自治县，昆明市，云南省",
                            "simple_py": "LQYZMZZZX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0871",
                            "area_code": "530128",
                            "longitude": "102.46905",
                            "latitude": "25.556533"
                        },
                        {
                            "area_id": 44140,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "盘龙区",
                            "whole_name": "盘龙区，昆明市，云南省",
                            "simple_py": "PLQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0871",
                            "area_code": "530103",
                            "longitude": "102.729044",
                            "latitude": "25.070239"
                        },
                        {
                            "area_id": 44132,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "石林彝族自治县",
                            "whole_name": "石林彝族自治县，昆明市，云南省",
                            "simple_py": "SLYZZZX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0871",
                            "area_code": "530126",
                            "longitude": "103.271962",
                            "latitude": "24.754545"
                        },
                        {
                            "area_id": 44139,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "嵩明县",
                            "whole_name": "嵩明县，昆明市，云南省",
                            "simple_py": "SMX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0871",
                            "area_code": "530127",
                            "longitude": "103.038777",
                            "latitude": "25.335087"
                        },
                        {
                            "area_id": 44131,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "五华区",
                            "whole_name": "五华区，昆明市，云南省",
                            "simple_py": "WHQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0871",
                            "area_code": "530102",
                            "longitude": "102.704412",
                            "latitude": "25.042165"
                        },
                        {
                            "area_id": 44128,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "寻甸回族彝族自治县",
                            "whole_name": "寻甸回族彝族自治县，昆明市，云南省",
                            "simple_py": "XDHZYZZZX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0871",
                            "area_code": "530129",
                            "longitude": "103.257588",
                            "latitude": "25.559474"
                        },
                        {
                            "area_id": 44129,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "西山区",
                            "whole_name": "西山区，昆明市，云南省",
                            "simple_py": "XSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0871",
                            "area_code": "530112",
                            "longitude": "102.705904",
                            "latitude": "25.02436"
                        },
                        {
                            "area_id": 44130,
                            "city_id": 42992,
                            "province_id": 31,
                            "name": "宜良县",
                            "whole_name": "宜良县，昆明市，云南省",
                            "simple_py": "YLX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0871",
                            "area_code": "530125",
                            "longitude": "103.145989",
                            "latitude": "24.918215"
                        }
                    ]
                },
                {
                    "city_id": 42983,
                    "province_id": 31,
                    "name": "丽江市",
                    "whole_name": "丽江市，云南省",
                    "simple_py": "LJS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0888",
                    "area_code": "530700",
                    "longitude": "100.233026",
                    "latitude": "26.872108",
                    "children": [
                        {
                            "area_id": 43433,
                            "city_id": 42983,
                            "province_id": 31,
                            "name": "古城区",
                            "whole_name": "古城区，丽江市，云南省",
                            "simple_py": "GCQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0888",
                            "area_code": "530702",
                            "longitude": "100.234412",
                            "latitude": "26.872229"
                        },
                        {
                            "area_id": 43432,
                            "city_id": 42983,
                            "province_id": 31,
                            "name": "华坪县",
                            "whole_name": "华坪县，丽江市，云南省",
                            "simple_py": "HPX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0888",
                            "area_code": "530723",
                            "longitude": "101.267796",
                            "latitude": "26.628834"
                        },
                        {
                            "area_id": 43431,
                            "city_id": 42983,
                            "province_id": 31,
                            "name": "宁蒗彝族自治县",
                            "whole_name": "宁蒗彝族自治县，丽江市，云南省",
                            "simple_py": "NLYZZZX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0888",
                            "area_code": "530724",
                            "longitude": "100.852427",
                            "latitude": "27.281109"
                        },
                        {
                            "area_id": 43430,
                            "city_id": 42983,
                            "province_id": 31,
                            "name": "玉龙纳西族自治县",
                            "whole_name": "玉龙纳西族自治县，丽江市，云南省",
                            "simple_py": "YLNXZZZX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0888",
                            "area_code": "530721",
                            "longitude": "100.238312",
                            "latitude": "26.830593"
                        },
                        {
                            "area_id": 43434,
                            "city_id": 42983,
                            "province_id": 31,
                            "name": "永胜县",
                            "whole_name": "永胜县，丽江市，云南省",
                            "simple_py": "YSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0888",
                            "area_code": "530722",
                            "longitude": "100.750901",
                            "latitude": "26.685623"
                        }
                    ]
                },
                {
                    "city_id": 42995,
                    "province_id": 31,
                    "name": "临沧市",
                    "whole_name": "临沧市，云南省",
                    "simple_py": "LCS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "L",
                    "city_code": "0883",
                    "area_code": "530900",
                    "longitude": "100.08697",
                    "latitude": "23.886567",
                    "children": [
                        {
                            "area_id": 44451,
                            "city_id": 42995,
                            "province_id": 31,
                            "name": "沧源佤族自治县",
                            "whole_name": "沧源佤族自治县，临沧市，云南省",
                            "simple_py": "CYWZZZX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0883",
                            "area_code": "530927",
                            "longitude": "99.2474",
                            "latitude": "23.146887"
                        },
                        {
                            "area_id": 44444,
                            "city_id": 42995,
                            "province_id": 31,
                            "name": "凤庆县",
                            "whole_name": "凤庆县，临沧市，云南省",
                            "simple_py": "FQX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0883",
                            "area_code": "530921",
                            "longitude": "99.91871",
                            "latitude": "24.592738"
                        },
                        {
                            "area_id": 44449,
                            "city_id": 42995,
                            "province_id": 31,
                            "name": "耿马傣族佤族自治县",
                            "whole_name": "耿马傣族佤族自治县，临沧市，云南省",
                            "simple_py": "GMDZWZZZX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0883",
                            "area_code": "530926",
                            "longitude": "99.402495",
                            "latitude": "23.534579"
                        },
                        {
                            "area_id": 44447,
                            "city_id": 42995,
                            "province_id": 31,
                            "name": "临翔区",
                            "whole_name": "临翔区，临沧市，云南省",
                            "simple_py": "LXQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0883",
                            "area_code": "530902",
                            "longitude": "100.086486",
                            "latitude": "23.886562"
                        },
                        {
                            "area_id": 44450,
                            "city_id": 42995,
                            "province_id": 31,
                            "name": "双江拉祜族佤族布朗族傣族自治县",
                            "whole_name": "双江拉祜族佤族布朗族傣族自治县，临沧市，云南省",
                            "simple_py": "SJLHZWZBLZDZZZX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0883",
                            "area_code": "530925",
                            "longitude": "99.824419",
                            "latitude": "23.477476"
                        },
                        {
                            "area_id": 44445,
                            "city_id": 42995,
                            "province_id": 31,
                            "name": "云县",
                            "whole_name": "云县，临沧市，云南省",
                            "simple_py": "YX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0883",
                            "area_code": "530922",
                            "longitude": "100.125637",
                            "latitude": "24.439026"
                        },
                        {
                            "area_id": 44448,
                            "city_id": 42995,
                            "province_id": 31,
                            "name": "永德县",
                            "whole_name": "永德县，临沧市，云南省",
                            "simple_py": "YDX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0883",
                            "area_code": "530923",
                            "longitude": "99.253679",
                            "latitude": "24.028159"
                        },
                        {
                            "area_id": 44446,
                            "city_id": 42995,
                            "province_id": 31,
                            "name": "镇康县",
                            "whole_name": "镇康县，临沧市，云南省",
                            "simple_py": "ZKX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0883",
                            "area_code": "530924",
                            "longitude": "98.82743",
                            "latitude": "23.761415"
                        }
                    ]
                },
                {
                    "city_id": 42988,
                    "province_id": 31,
                    "name": "怒江傈僳族自治州",
                    "whole_name": "怒江傈僳族自治州，云南省",
                    "simple_py": "NJLSZZZZ",
                    "per_pin_yin": "N",
                    "per_pin_yin2": "N",
                    "city_code": "0886",
                    "area_code": "533300",
                    "longitude": "98.854304",
                    "latitude": "25.850949",
                    "children": [
                        {
                            "area_id": 43866,
                            "city_id": 42988,
                            "province_id": 31,
                            "name": "福贡县",
                            "whole_name": "福贡县，怒江傈僳族自治州，云南省",
                            "simple_py": "FGX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0886",
                            "area_code": "533323",
                            "longitude": "98.867413",
                            "latitude": "26.902738"
                        },
                        {
                            "area_id": 43865,
                            "city_id": 42988,
                            "province_id": 31,
                            "name": "贡山独龙族怒族自治县",
                            "whole_name": "贡山独龙族怒族自治县，怒江傈僳族自治州，云南省",
                            "simple_py": "GSDLZNZZZX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0886",
                            "area_code": "533324",
                            "longitude": "98.666141",
                            "latitude": "27.738054"
                        },
                        {
                            "area_id": 43867,
                            "city_id": 42988,
                            "province_id": 31,
                            "name": "兰坪白族普米族自治县",
                            "whole_name": "兰坪白族普米族自治县，怒江傈僳族自治州，云南省",
                            "simple_py": "LPBZPMZZZX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0886",
                            "area_code": "533325",
                            "longitude": "99.421378",
                            "latitude": "26.453839"
                        },
                        {
                            "area_id": 43868,
                            "city_id": 42988,
                            "province_id": 31,
                            "name": "泸水市",
                            "whole_name": "泸水市，怒江傈僳族自治州，云南省",
                            "simple_py": "LSS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0886",
                            "area_code": "533301",
                            "longitude": "98.854063",
                            "latitude": "25.851142"
                        }
                    ]
                },
                {
                    "city_id": 42991,
                    "province_id": 31,
                    "name": "普洱市",
                    "whole_name": "普洱市，云南省",
                    "simple_py": "PES",
                    "per_pin_yin": "P",
                    "per_pin_yin2": "P",
                    "city_code": "0879",
                    "area_code": "530800",
                    "longitude": "100.972344",
                    "latitude": "22.777321",
                    "children": [
                        {
                            "area_id": 44014,
                            "city_id": 42991,
                            "province_id": 31,
                            "name": "景东彝族自治县",
                            "whole_name": "景东彝族自治县，普洱市，云南省",
                            "simple_py": "JDYZZZX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0879",
                            "area_code": "530823",
                            "longitude": "100.840011",
                            "latitude": "24.448523"
                        },
                        {
                            "area_id": 44015,
                            "city_id": 42991,
                            "province_id": 31,
                            "name": "景谷傣族彝族自治县",
                            "whole_name": "景谷傣族彝族自治县，普洱市，云南省",
                            "simple_py": "JGDZYZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0879",
                            "area_code": "530824",
                            "longitude": "100.701425",
                            "latitude": "23.500278"
                        },
                        {
                            "area_id": 44022,
                            "city_id": 42991,
                            "province_id": 31,
                            "name": "江城哈尼族彝族自治县",
                            "whole_name": "江城哈尼族彝族自治县，普洱市，云南省",
                            "simple_py": "JCHNZYZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0879",
                            "area_code": "530826",
                            "longitude": "101.859144",
                            "latitude": "22.58336"
                        },
                        {
                            "area_id": 44019,
                            "city_id": 42991,
                            "province_id": 31,
                            "name": "澜沧拉祜族自治县",
                            "whole_name": "澜沧拉祜族自治县，普洱市，云南省",
                            "simple_py": "LCLHZZZX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0879",
                            "area_code": "530828",
                            "longitude": "99.931201",
                            "latitude": "22.553083"
                        },
                        {
                            "area_id": 44017,
                            "city_id": 42991,
                            "province_id": 31,
                            "name": "墨江哈尼族自治县",
                            "whole_name": "墨江哈尼族自治县，普洱市，云南省",
                            "simple_py": "MJHNZZZX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0879",
                            "area_code": "530822",
                            "longitude": "101.687606",
                            "latitude": "23.428165"
                        },
                        {
                            "area_id": 44023,
                            "city_id": 42991,
                            "province_id": 31,
                            "name": "孟连傣族拉祜族佤族自治县",
                            "whole_name": "孟连傣族拉祜族佤族自治县，普洱市，云南省",
                            "simple_py": "MLDZLHZWZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0879",
                            "area_code": "530827",
                            "longitude": "99.585406",
                            "latitude": "22.325924"
                        },
                        {
                            "area_id": 44018,
                            "city_id": 42991,
                            "province_id": 31,
                            "name": "宁洱哈尼族彝族自治县",
                            "whole_name": "宁洱哈尼族彝族自治县，普洱市，云南省",
                            "simple_py": "NEHNZYZZZX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0879",
                            "area_code": "530821",
                            "longitude": "101.04524",
                            "latitude": "23.062507"
                        },
                        {
                            "area_id": 44021,
                            "city_id": 42991,
                            "province_id": 31,
                            "name": "思茅区",
                            "whole_name": "思茅区，普洱市，云南省",
                            "simple_py": "SMQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0879",
                            "area_code": "530802",
                            "longitude": "100.973227",
                            "latitude": "22.776595"
                        },
                        {
                            "area_id": 44020,
                            "city_id": 42991,
                            "province_id": 31,
                            "name": "西盟佤族自治县",
                            "whole_name": "西盟佤族自治县，普洱市，云南省",
                            "simple_py": "XMWZZZX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0879",
                            "area_code": "530829",
                            "longitude": "99.594372",
                            "latitude": "22.644423"
                        },
                        {
                            "area_id": 44016,
                            "city_id": 42991,
                            "province_id": 31,
                            "name": "镇沅彝族哈尼族拉祜族自治县",
                            "whole_name": "镇沅彝族哈尼族拉祜族自治县，普洱市，云南省",
                            "simple_py": "ZYYZHNZLHZZZX",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0879",
                            "area_code": "530825",
                            "longitude": "101.108512",
                            "latitude": "24.005712"
                        }
                    ]
                },
                {
                    "city_id": 42981,
                    "province_id": 31,
                    "name": "曲靖市",
                    "whole_name": "曲靖市，云南省",
                    "simple_py": "QJS",
                    "per_pin_yin": "Q",
                    "per_pin_yin2": "Q",
                    "city_code": "0874",
                    "area_code": "530300",
                    "longitude": "103.797851",
                    "latitude": "25.501557",
                    "children": [
                        {
                            "area_id": 43158,
                            "city_id": 42981,
                            "province_id": 31,
                            "name": "富源县",
                            "whole_name": "富源县，曲靖市，云南省",
                            "simple_py": "FYX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0874",
                            "area_code": "530325",
                            "longitude": "104.25692",
                            "latitude": "25.67064"
                        },
                        {
                            "area_id": 43151,
                            "city_id": 42981,
                            "province_id": 31,
                            "name": "会泽县",
                            "whole_name": "会泽县，曲靖市，云南省",
                            "simple_py": "HZX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0874",
                            "area_code": "530326",
                            "longitude": "103.300041",
                            "latitude": "26.412861"
                        },
                        {
                            "area_id": 43155,
                            "city_id": 42981,
                            "province_id": 31,
                            "name": "罗平县",
                            "whole_name": "罗平县，曲靖市，云南省",
                            "simple_py": "LPX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0874",
                            "area_code": "530324",
                            "longitude": "104.309263",
                            "latitude": "24.885708"
                        },
                        {
                            "area_id": 43156,
                            "city_id": 42981,
                            "province_id": 31,
                            "name": "陆良县",
                            "whole_name": "陆良县，曲靖市，云南省",
                            "simple_py": "LLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0874",
                            "area_code": "530322",
                            "longitude": "103.655233",
                            "latitude": "25.022878"
                        },
                        {
                            "area_id": 43154,
                            "city_id": 42981,
                            "province_id": 31,
                            "name": "马龙县",
                            "whole_name": "马龙县，曲靖市，云南省",
                            "simple_py": "MLX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0874",
                            "area_code": "530321",
                            "longitude": "103.578755",
                            "latitude": "25.429451"
                        },
                        {
                            "area_id": 43153,
                            "city_id": 42981,
                            "province_id": 31,
                            "name": "麒麟区",
                            "whole_name": "麒麟区，曲靖市，云南省",
                            "simple_py": "QLQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0874",
                            "area_code": "530302",
                            "longitude": "103.798054",
                            "latitude": "25.501269"
                        },
                        {
                            "area_id": 43157,
                            "city_id": 42981,
                            "province_id": 31,
                            "name": "师宗县",
                            "whole_name": "师宗县，曲靖市，云南省",
                            "simple_py": "SZX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0874",
                            "area_code": "530323",
                            "longitude": "103.993808",
                            "latitude": "24.825681"
                        },
                        {
                            "area_id": 43159,
                            "city_id": 42981,
                            "province_id": 31,
                            "name": "宣威市",
                            "whole_name": "宣威市，曲靖市，云南省",
                            "simple_py": "XWS",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0874",
                            "area_code": "530381",
                            "longitude": "104.09554",
                            "latitude": "26.227777"
                        },
                        {
                            "area_id": 43152,
                            "city_id": 42981,
                            "province_id": 31,
                            "name": "沾益区",
                            "whole_name": "沾益区，曲靖市，云南省",
                            "simple_py": "ZYQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0874",
                            "area_code": "530303",
                            "longitude": "103.819262",
                            "latitude": "25.600878"
                        }
                    ]
                },
                {
                    "city_id": 42986,
                    "province_id": 31,
                    "name": "文山壮族苗族自治州",
                    "whole_name": "文山壮族苗族自治州，云南省",
                    "simple_py": "WSZZMZZZZ",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "0876",
                    "area_code": "532600",
                    "longitude": "104.24401",
                    "latitude": "23.36951",
                    "children": [
                        {
                            "area_id": 43633,
                            "city_id": 42986,
                            "province_id": 31,
                            "name": "富宁县",
                            "whole_name": "富宁县，文山壮族苗族自治州，云南省",
                            "simple_py": "FNX",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0876",
                            "area_code": "532628",
                            "longitude": "105.62856",
                            "latitude": "23.626494"
                        },
                        {
                            "area_id": 43627,
                            "city_id": 42986,
                            "province_id": 31,
                            "name": "广南县",
                            "whole_name": "广南县，文山壮族苗族自治州，云南省",
                            "simple_py": "GNX",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0876",
                            "area_code": "532627",
                            "longitude": "105.056684",
                            "latitude": "24.050272"
                        },
                        {
                            "area_id": 43631,
                            "city_id": 42986,
                            "province_id": 31,
                            "name": "马关县",
                            "whole_name": "马关县，文山壮族苗族自治州，云南省",
                            "simple_py": "MGX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0876",
                            "area_code": "532625",
                            "longitude": "104.398619",
                            "latitude": "23.011723"
                        },
                        {
                            "area_id": 43632,
                            "city_id": 42986,
                            "province_id": 31,
                            "name": "麻栗坡县",
                            "whole_name": "麻栗坡县，文山壮族苗族自治州，云南省",
                            "simple_py": "MLPX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0876",
                            "area_code": "532624",
                            "longitude": "104.701899",
                            "latitude": "23.124202"
                        },
                        {
                            "area_id": 43626,
                            "city_id": 42986,
                            "province_id": 31,
                            "name": "丘北县",
                            "whole_name": "丘北县，文山壮族苗族自治州，云南省",
                            "simple_py": "QBX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0876",
                            "area_code": "532626",
                            "longitude": "104.194366",
                            "latitude": "24.040982"
                        },
                        {
                            "area_id": 43628,
                            "city_id": 42986,
                            "province_id": 31,
                            "name": "文山市",
                            "whole_name": "文山市，文山壮族苗族自治州，云南省",
                            "simple_py": "WSS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0876",
                            "area_code": "532601",
                            "longitude": "104.244277",
                            "latitude": "23.369216"
                        },
                        {
                            "area_id": 43630,
                            "city_id": 42986,
                            "province_id": 31,
                            "name": "西畴县",
                            "whole_name": "西畴县，文山壮族苗族自治州，云南省",
                            "simple_py": "XCX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0876",
                            "area_code": "532623",
                            "longitude": "104.675711",
                            "latitude": "23.437439"
                        },
                        {
                            "area_id": 43629,
                            "city_id": 42986,
                            "province_id": 31,
                            "name": "砚山县",
                            "whole_name": "砚山县，文山壮族苗族自治州，云南省",
                            "simple_py": "YSX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0876",
                            "area_code": "532622",
                            "longitude": "104.343989",
                            "latitude": "23.612301"
                        }
                    ]
                },
                {
                    "city_id": 42984,
                    "province_id": 31,
                    "name": "西双版纳傣族自治州",
                    "whole_name": "西双版纳傣族自治州，云南省",
                    "simple_py": "XSBNDZZZZ",
                    "per_pin_yin": "X",
                    "per_pin_yin2": "X",
                    "city_code": "0691",
                    "area_code": "532800",
                    "longitude": "100.797941",
                    "latitude": "22.001724",
                    "children": [
                        {
                            "area_id": 43498,
                            "city_id": 42984,
                            "province_id": 31,
                            "name": "景洪市",
                            "whole_name": "景洪市，西双版纳傣族自治州，云南省",
                            "simple_py": "JHS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0691",
                            "area_code": "532801",
                            "longitude": "100.797947",
                            "latitude": "22.002087"
                        },
                        {
                            "area_id": 43499,
                            "city_id": 42984,
                            "province_id": 31,
                            "name": "勐腊县",
                            "whole_name": "勐腊县，西双版纳傣族自治州，云南省",
                            "simple_py": "MLX",
                            "per_pin_yin": "M",
                            "per_pin_yin2": "M",
                            "city_code": "0691",
                            "area_code": "532823",
                            "longitude": "101.567051",
                            "latitude": "21.479449"
                        },
                        {
                            "area_id": 43500,
                            "city_id": 42984,
                            "province_id": 31,
                            "name": "勐海县",
                            "whole_name": "勐海县，西双版纳傣族自治州，云南省",
                            "simple_py": "MHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "M",
                            "city_code": "0691",
                            "area_code": "532822",
                            "longitude": "100.448288",
                            "latitude": "21.955866"
                        }
                    ]
                },
                {
                    "city_id": 42990,
                    "province_id": 31,
                    "name": "玉溪市",
                    "whole_name": "玉溪市，云南省",
                    "simple_py": "YXS",
                    "per_pin_yin": "Y",
                    "per_pin_yin2": "Y",
                    "city_code": "0877",
                    "area_code": "530400",
                    "longitude": "102.543907",
                    "latitude": "24.350461",
                    "children": [
                        {
                            "area_id": 43930,
                            "city_id": 42990,
                            "province_id": 31,
                            "name": "澄江县",
                            "whole_name": "澄江县，玉溪市，云南省",
                            "simple_py": "CJX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0877",
                            "area_code": "530422",
                            "longitude": "102.916652",
                            "latitude": "24.669679"
                        },
                        {
                            "area_id": 43932,
                            "city_id": 42990,
                            "province_id": 31,
                            "name": "峨山彝族自治县",
                            "whole_name": "峨山彝族自治县，玉溪市，云南省",
                            "simple_py": "ESYZZZX",
                            "per_pin_yin": "E",
                            "per_pin_yin2": "E",
                            "city_code": "0877",
                            "area_code": "530426",
                            "longitude": "102.404358",
                            "latitude": "24.173256"
                        },
                        {
                            "area_id": 43933,
                            "city_id": 42990,
                            "province_id": 31,
                            "name": "华宁县",
                            "whole_name": "华宁县，玉溪市，云南省",
                            "simple_py": "HNX",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0877",
                            "area_code": "530424",
                            "longitude": "102.928982",
                            "latitude": "24.189807"
                        },
                        {
                            "area_id": 43934,
                            "city_id": 42990,
                            "province_id": 31,
                            "name": "红塔区",
                            "whole_name": "红塔区，玉溪市，云南省",
                            "simple_py": "HTQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0877",
                            "area_code": "530402",
                            "longitude": "102.543468",
                            "latitude": "24.350753"
                        },
                        {
                            "area_id": 43937,
                            "city_id": 42990,
                            "province_id": 31,
                            "name": "江川区",
                            "whole_name": "江川区，玉溪市，云南省",
                            "simple_py": "JCQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0877",
                            "area_code": "530403",
                            "longitude": "102.749839",
                            "latitude": "24.291006"
                        },
                        {
                            "area_id": 43938,
                            "city_id": 42990,
                            "province_id": 31,
                            "name": "通海县",
                            "whole_name": "通海县，玉溪市，云南省",
                            "simple_py": "THX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0877",
                            "area_code": "530423",
                            "longitude": "102.760039",
                            "latitude": "24.112205"
                        },
                        {
                            "area_id": 43935,
                            "city_id": 42990,
                            "province_id": 31,
                            "name": "新平彝族傣族自治县",
                            "whole_name": "新平彝族傣族自治县，玉溪市，云南省",
                            "simple_py": "XPYZDZZZX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0877",
                            "area_code": "530427",
                            "longitude": "101.990903",
                            "latitude": "24.0664"
                        },
                        {
                            "area_id": 43931,
                            "city_id": 42990,
                            "province_id": 31,
                            "name": "易门县",
                            "whole_name": "易门县，玉溪市，云南省",
                            "simple_py": "YMX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0877",
                            "area_code": "530425",
                            "longitude": "102.16211",
                            "latitude": "24.669598"
                        },
                        {
                            "area_id": 43936,
                            "city_id": 42990,
                            "province_id": 31,
                            "name": "元江哈尼族彝族傣族自治县",
                            "whole_name": "元江哈尼族彝族傣族自治县，玉溪市，云南省",
                            "simple_py": "YJHNZYZDZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0877",
                            "area_code": "530428",
                            "longitude": "101.999658",
                            "latitude": "23.597618"
                        }
                    ]
                },
                {
                    "city_id": 42980,
                    "province_id": 31,
                    "name": "昭通市",
                    "whole_name": "昭通市，云南省",
                    "simple_py": "ZTS",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "0870",
                    "area_code": "530600",
                    "longitude": "103.717216",
                    "latitude": "27.336999",
                    "children": [
                        {
                            "area_id": 42996,
                            "city_id": 42980,
                            "province_id": 31,
                            "name": "大关县",
                            "whole_name": "大关县，昭通市，云南省",
                            "simple_py": "DGX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0870",
                            "area_code": "530624",
                            "longitude": "103.891608",
                            "latitude": "27.747114"
                        },
                        {
                            "area_id": 43004,
                            "city_id": 42980,
                            "province_id": 31,
                            "name": "鲁甸县",
                            "whole_name": "鲁甸县，昭通市，云南省",
                            "simple_py": "LDX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0870",
                            "area_code": "530621",
                            "longitude": "103.549333",
                            "latitude": "27.191637"
                        },
                        {
                            "area_id": 43001,
                            "city_id": 42980,
                            "province_id": 31,
                            "name": "巧家县",
                            "whole_name": "巧家县，昭通市，云南省",
                            "simple_py": "QJX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0870",
                            "area_code": "530622",
                            "longitude": "102.929284",
                            "latitude": "26.9117"
                        },
                        {
                            "area_id": 42997,
                            "city_id": 42980,
                            "province_id": 31,
                            "name": "水富县",
                            "whole_name": "水富县，昭通市，云南省",
                            "simple_py": "SFX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0870",
                            "area_code": "530630",
                            "longitude": "104.415376",
                            "latitude": "28.629688"
                        },
                        {
                            "area_id": 42998,
                            "city_id": 42980,
                            "province_id": 31,
                            "name": "绥江县",
                            "whole_name": "绥江县，昭通市，云南省",
                            "simple_py": "SJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0870",
                            "area_code": "530626",
                            "longitude": "103.961095",
                            "latitude": "28.599953"
                        },
                        {
                            "area_id": 43000,
                            "city_id": 42980,
                            "province_id": 31,
                            "name": "威信县",
                            "whole_name": "威信县，昭通市，云南省",
                            "simple_py": "WXX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0870",
                            "area_code": "530629",
                            "longitude": "105.04869",
                            "latitude": "27.843381"
                        },
                        {
                            "area_id": 42999,
                            "city_id": 42980,
                            "province_id": 31,
                            "name": "永善县",
                            "whole_name": "永善县，昭通市，云南省",
                            "simple_py": "YSX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0870",
                            "area_code": "530625",
                            "longitude": "103.63732",
                            "latitude": "28.231526"
                        },
                        {
                            "area_id": 43005,
                            "city_id": 42980,
                            "province_id": 31,
                            "name": "彝良县",
                            "whole_name": "彝良县，昭通市，云南省",
                            "simple_py": "YLX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0870",
                            "area_code": "530628",
                            "longitude": "104.048492",
                            "latitude": "27.627425"
                        },
                        {
                            "area_id": 43006,
                            "city_id": 42980,
                            "province_id": 31,
                            "name": "盐津县",
                            "whole_name": "盐津县，昭通市，云南省",
                            "simple_py": "YJX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0870",
                            "area_code": "530623",
                            "longitude": "104.23506",
                            "latitude": "28.106923"
                        },
                        {
                            "area_id": 43002,
                            "city_id": 42980,
                            "province_id": 31,
                            "name": "昭阳区",
                            "whole_name": "昭阳区，昭通市，云南省",
                            "simple_py": "ZYQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0870",
                            "area_code": "530602",
                            "longitude": "103.717267",
                            "latitude": "27.336636"
                        },
                        {
                            "area_id": 43003,
                            "city_id": 42980,
                            "province_id": 31,
                            "name": "镇雄县",
                            "whole_name": "镇雄县，昭通市，云南省",
                            "simple_py": "ZXX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Z",
                            "city_code": "0870",
                            "area_code": "530627",
                            "longitude": "104.873055",
                            "latitude": "27.436267"
                        }
                    ]
                }
            ]
        },
        {
            "province_id": 23,
            "name": "浙江省",
            "whole_name": "浙江省",
            "simple_py": "ZJS",
            "per_pin_yin": "Z",
            "per_pin_yin2": "Z",
            "city_code": "",
            "area_code": "330000",
            "longitude": "120.153576",
            "latitude": "30.287459",
            "children": [
                {
                    "city_id": 31081,
                    "province_id": 23,
                    "name": "杭州市",
                    "whole_name": "杭州市，浙江省",
                    "simple_py": "HZS",
                    "per_pin_yin": "H",
                    "per_pin_yin2": "H",
                    "city_code": "0571",
                    "area_code": "330100",
                    "longitude": "120.153576",
                    "latitude": "30.287459",
                    "children": [
                        {
                            "area_id": 32123,
                            "city_id": 31081,
                            "province_id": 23,
                            "name": "滨江区",
                            "whole_name": "滨江区，杭州市，浙江省",
                            "simple_py": "BJQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0571",
                            "area_code": "330108",
                            "longitude": "120.21062",
                            "latitude": "30.206615"
                        },
                        {
                            "area_id": 32120,
                            "city_id": 31081,
                            "province_id": 23,
                            "name": "淳安县",
                            "whole_name": "淳安县，杭州市，浙江省",
                            "simple_py": "CAX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0571",
                            "area_code": "330127",
                            "longitude": "119.044276",
                            "latitude": "29.604177"
                        },
                        {
                            "area_id": 32115,
                            "city_id": 31081,
                            "province_id": 23,
                            "name": "富阳区",
                            "whole_name": "富阳区，杭州市，浙江省",
                            "simple_py": "FYQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0571",
                            "area_code": "330111",
                            "longitude": "119.949869",
                            "latitude": "30.049871"
                        },
                        {
                            "area_id": 32127,
                            "city_id": 31081,
                            "province_id": 23,
                            "name": "拱墅区",
                            "whole_name": "拱墅区，杭州市，浙江省",
                            "simple_py": "GSQ",
                            "per_pin_yin": "G",
                            "per_pin_yin2": "G",
                            "city_code": "0571",
                            "area_code": "330105",
                            "longitude": "120.150053",
                            "latitude": "30.314697"
                        },
                        {
                            "area_id": 32119,
                            "city_id": 31081,
                            "province_id": 23,
                            "name": "建德市",
                            "whole_name": "建德市，杭州市，浙江省",
                            "simple_py": "JDS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0571",
                            "area_code": "330182",
                            "longitude": "119.279089",
                            "latitude": "29.472284"
                        },
                        {
                            "area_id": 32124,
                            "city_id": 31081,
                            "province_id": 23,
                            "name": "江干区",
                            "whole_name": "江干区，杭州市，浙江省",
                            "simple_py": "JGQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0571",
                            "area_code": "330104",
                            "longitude": "120.202633",
                            "latitude": "30.266603"
                        },
                        {
                            "area_id": 32126,
                            "city_id": 31081,
                            "province_id": 23,
                            "name": "临安区",
                            "whole_name": "临安区，杭州市，浙江省",
                            "simple_py": "LAQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0571",
                            "area_code": "330112",
                            "longitude": "119.715101",
                            "latitude": "30.231153"
                        },
                        {
                            "area_id": 32118,
                            "city_id": 31081,
                            "province_id": 23,
                            "name": "上城区",
                            "whole_name": "上城区，杭州市，浙江省",
                            "simple_py": "SCQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0571",
                            "area_code": "330102",
                            "longitude": "120.171465",
                            "latitude": "30.250236"
                        },
                        {
                            "area_id": 32116,
                            "city_id": 31081,
                            "province_id": 23,
                            "name": "桐庐县",
                            "whole_name": "桐庐县，杭州市，浙江省",
                            "simple_py": "TLX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0571",
                            "area_code": "330122",
                            "longitude": "119.685045",
                            "latitude": "29.797437"
                        },
                        {
                            "area_id": 32117,
                            "city_id": 31081,
                            "province_id": 23,
                            "name": "西湖区",
                            "whole_name": "西湖区，杭州市，浙江省",
                            "simple_py": "XHQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0571",
                            "area_code": "330106",
                            "longitude": "120.147376",
                            "latitude": "30.272934"
                        },
                        {
                            "area_id": 32122,
                            "city_id": 31081,
                            "province_id": 23,
                            "name": "萧山区",
                            "whole_name": "萧山区，杭州市，浙江省",
                            "simple_py": "XSQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0571",
                            "area_code": "330109",
                            "longitude": "120.27069",
                            "latitude": "30.162932"
                        },
                        {
                            "area_id": 32125,
                            "city_id": 31081,
                            "province_id": 23,
                            "name": "下城区",
                            "whole_name": "下城区，杭州市，浙江省",
                            "simple_py": "XCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "X",
                            "city_code": "0571",
                            "area_code": "330103",
                            "longitude": "120.172763",
                            "latitude": "30.276271"
                        },
                        {
                            "area_id": 32121,
                            "city_id": 31081,
                            "province_id": 23,
                            "name": "余杭区",
                            "whole_name": "余杭区，杭州市，浙江省",
                            "simple_py": "YHQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0571",
                            "area_code": "330110",
                            "longitude": "120.301737",
                            "latitude": "30.421187"
                        }
                    ]
                },
                {
                    "city_id": 31083,
                    "province_id": 23,
                    "name": "湖州市",
                    "whole_name": "湖州市，浙江省",
                    "simple_py": "HZS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "H",
                    "city_code": "0572",
                    "area_code": "330500",
                    "longitude": "120.102398",
                    "latitude": "30.867198",
                    "children": [
                        {
                            "area_id": 32451,
                            "city_id": 31083,
                            "province_id": 23,
                            "name": "安吉县",
                            "whole_name": "安吉县，湖州市，浙江省",
                            "simple_py": "AJX",
                            "per_pin_yin": "A",
                            "per_pin_yin2": "A",
                            "city_code": "0572",
                            "area_code": "330523",
                            "longitude": "119.687891",
                            "latitude": "30.631974"
                        },
                        {
                            "area_id": 32449,
                            "city_id": 31083,
                            "province_id": 23,
                            "name": "长兴县",
                            "whole_name": "长兴县，湖州市，浙江省",
                            "simple_py": "CXX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0572",
                            "area_code": "330522",
                            "longitude": "119.910122",
                            "latitude": "31.00475"
                        },
                        {
                            "area_id": 32448,
                            "city_id": 31083,
                            "province_id": 23,
                            "name": "德清县",
                            "whole_name": "德清县，湖州市，浙江省",
                            "simple_py": "DQX",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0572",
                            "area_code": "330521",
                            "longitude": "119.967662",
                            "latitude": "30.534927"
                        },
                        {
                            "area_id": 32452,
                            "city_id": 31083,
                            "province_id": 23,
                            "name": "南浔区",
                            "whole_name": "南浔区，湖州市，浙江省",
                            "simple_py": "NXQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0572",
                            "area_code": "330503",
                            "longitude": "120.417195",
                            "latitude": "30.872742"
                        },
                        {
                            "area_id": 32450,
                            "city_id": 31083,
                            "province_id": 23,
                            "name": "吴兴区",
                            "whole_name": "吴兴区，湖州市，浙江省",
                            "simple_py": "WXQ",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0572",
                            "area_code": "330502",
                            "longitude": "120.101416",
                            "latitude": "30.867252"
                        }
                    ]
                },
                {
                    "city_id": 31075,
                    "province_id": 23,
                    "name": "嘉兴市",
                    "whole_name": "嘉兴市，浙江省",
                    "simple_py": "JXS",
                    "per_pin_yin": "J",
                    "per_pin_yin2": "J",
                    "city_code": "0573",
                    "area_code": "330400",
                    "longitude": "120.750865",
                    "latitude": "30.762653",
                    "children": [
                        {
                            "area_id": 31394,
                            "city_id": 31075,
                            "province_id": 23,
                            "name": "海宁市",
                            "whole_name": "海宁市，嘉兴市，浙江省",
                            "simple_py": "HNS",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0573",
                            "area_code": "330481",
                            "longitude": "120.688821",
                            "latitude": "30.525544"
                        },
                        {
                            "area_id": 31398,
                            "city_id": 31075,
                            "province_id": 23,
                            "name": "海盐县",
                            "whole_name": "海盐县，嘉兴市，浙江省",
                            "simple_py": "HYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "H",
                            "city_code": "0573",
                            "area_code": "330424",
                            "longitude": "120.942017",
                            "latitude": "30.522223"
                        },
                        {
                            "area_id": 31397,
                            "city_id": 31075,
                            "province_id": 23,
                            "name": "嘉善县",
                            "whole_name": "嘉善县，嘉兴市，浙江省",
                            "simple_py": "JSX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0573",
                            "area_code": "330421",
                            "longitude": "120.921871",
                            "latitude": "30.841352"
                        },
                        {
                            "area_id": 31396,
                            "city_id": 31075,
                            "province_id": 23,
                            "name": "南湖区",
                            "whole_name": "南湖区，嘉兴市，浙江省",
                            "simple_py": "NHQ",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0573",
                            "area_code": "330402",
                            "longitude": "120.749953",
                            "latitude": "30.764652"
                        },
                        {
                            "area_id": 31392,
                            "city_id": 31075,
                            "province_id": 23,
                            "name": "平湖市",
                            "whole_name": "平湖市，嘉兴市，浙江省",
                            "simple_py": "PHS",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0573",
                            "area_code": "330482",
                            "longitude": "121.014666",
                            "latitude": "30.698921"
                        },
                        {
                            "area_id": 31393,
                            "city_id": 31075,
                            "province_id": 23,
                            "name": "桐乡市",
                            "whole_name": "桐乡市，嘉兴市，浙江省",
                            "simple_py": "TXS",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0573",
                            "area_code": "330483",
                            "longitude": "120.551085",
                            "latitude": "30.629065"
                        },
                        {
                            "area_id": 31395,
                            "city_id": 31075,
                            "province_id": 23,
                            "name": "秀洲区",
                            "whole_name": "秀洲区，嘉兴市，浙江省",
                            "simple_py": "XZQ",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0573",
                            "area_code": "330411",
                            "longitude": "120.720431",
                            "latitude": "30.763323"
                        }
                    ]
                },
                {
                    "city_id": 31079,
                    "province_id": 23,
                    "name": "金华市",
                    "whole_name": "金华市，浙江省",
                    "simple_py": "JHS",
                    "per_pin_yin": " ",
                    "per_pin_yin2": "J",
                    "city_code": "0579",
                    "area_code": "330700",
                    "longitude": "119.649506",
                    "latitude": "29.089524",
                    "children": [
                        {
                            "area_id": 31780,
                            "city_id": 31079,
                            "province_id": 23,
                            "name": "东阳市",
                            "whole_name": "东阳市，金华市，浙江省",
                            "simple_py": "DYS",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0579",
                            "area_code": "330783",
                            "longitude": "120.23334",
                            "latitude": "29.262546"
                        },
                        {
                            "area_id": 31783,
                            "city_id": 31079,
                            "province_id": 23,
                            "name": "金东区",
                            "whole_name": "金东区，金华市，浙江省",
                            "simple_py": "JDQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0579",
                            "area_code": "330703",
                            "longitude": "119.681264",
                            "latitude": "29.095835"
                        },
                        {
                            "area_id": 31779,
                            "city_id": 31079,
                            "province_id": 23,
                            "name": "兰溪市",
                            "whole_name": "兰溪市，金华市，浙江省",
                            "simple_py": "LXS",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0579",
                            "area_code": "330781",
                            "longitude": "119.460521",
                            "latitude": "29.210065"
                        },
                        {
                            "area_id": 31776,
                            "city_id": 31079,
                            "province_id": 23,
                            "name": "浦江县",
                            "whole_name": "浦江县，金华市，浙江省",
                            "simple_py": "PJX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0579",
                            "area_code": "330726",
                            "longitude": "119.893363",
                            "latitude": "29.451254"
                        },
                        {
                            "area_id": 31782,
                            "city_id": 31079,
                            "province_id": 23,
                            "name": "磐安县",
                            "whole_name": "磐安县，金华市，浙江省",
                            "simple_py": "PAX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "P",
                            "city_code": "0579",
                            "area_code": "330727",
                            "longitude": "120.44513",
                            "latitude": "29.052627"
                        },
                        {
                            "area_id": 31778,
                            "city_id": 31079,
                            "province_id": 23,
                            "name": "武义县",
                            "whole_name": "武义县，金华市，浙江省",
                            "simple_py": "WYX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0579",
                            "area_code": "330723",
                            "longitude": "119.819159",
                            "latitude": "28.896563"
                        },
                        {
                            "area_id": 31781,
                            "city_id": 31079,
                            "province_id": 23,
                            "name": "婺城区",
                            "whole_name": "婺城区，金华市，浙江省",
                            "simple_py": "WCQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "W",
                            "city_code": "0579",
                            "area_code": "330702",
                            "longitude": "119.652579",
                            "latitude": "29.082607"
                        },
                        {
                            "area_id": 31777,
                            "city_id": 31079,
                            "province_id": 23,
                            "name": "永康市",
                            "whole_name": "永康市，金华市，浙江省",
                            "simple_py": "YKS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0579",
                            "area_code": "330784",
                            "longitude": "120.036328",
                            "latitude": "28.895293"
                        },
                        {
                            "area_id": 31784,
                            "city_id": 31079,
                            "province_id": 23,
                            "name": "义乌市",
                            "whole_name": "义乌市，金华市，浙江省",
                            "simple_py": "YWS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0579",
                            "area_code": "330782",
                            "longitude": "120.074911",
                            "latitude": "29.306863"
                        }
                    ]
                },
                {
                    "city_id": 31080,
                    "province_id": 23,
                    "name": "丽水市",
                    "whole_name": "丽水市，浙江省",
                    "simple_py": "LSS",
                    "per_pin_yin": "L",
                    "per_pin_yin2": "L",
                    "city_code": "0578",
                    "area_code": "331100",
                    "longitude": "119.921786",
                    "latitude": "28.451993",
                    "children": [
                        {
                            "area_id": 31937,
                            "city_id": 31080,
                            "province_id": 23,
                            "name": "缙云县",
                            "whole_name": "缙云县，丽水市，浙江省",
                            "simple_py": "JYX",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0578",
                            "area_code": "331122",
                            "longitude": "120.078965",
                            "latitude": "28.654208"
                        },
                        {
                            "area_id": 31938,
                            "city_id": 31080,
                            "province_id": 23,
                            "name": "景宁畲族自治县",
                            "whole_name": "景宁畲族自治县，丽水市，浙江省",
                            "simple_py": "JNSZZZX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "J",
                            "city_code": "0578",
                            "area_code": "331127",
                            "longitude": "119.634669",
                            "latitude": "27.977247"
                        },
                        {
                            "area_id": 31932,
                            "city_id": 31080,
                            "province_id": 23,
                            "name": "莲都区",
                            "whole_name": "莲都区，丽水市，浙江省",
                            "simple_py": "LDQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0578",
                            "area_code": "331102",
                            "longitude": "119.922293",
                            "latitude": "28.451103"
                        },
                        {
                            "area_id": 31934,
                            "city_id": 31080,
                            "province_id": 23,
                            "name": "龙泉市",
                            "whole_name": "龙泉市，丽水市，浙江省",
                            "simple_py": "LQS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0578",
                            "area_code": "331181",
                            "longitude": "119.132319",
                            "latitude": "28.069177"
                        },
                        {
                            "area_id": 31939,
                            "city_id": 31080,
                            "province_id": 23,
                            "name": "青田县",
                            "whole_name": "青田县，丽水市，浙江省",
                            "simple_py": "QTX",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0578",
                            "area_code": "331121",
                            "longitude": "120.291939",
                            "latitude": "28.135247"
                        },
                        {
                            "area_id": 31940,
                            "city_id": 31080,
                            "province_id": 23,
                            "name": "庆元县",
                            "whole_name": "庆元县，丽水市，浙江省",
                            "simple_py": "QYX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Q",
                            "city_code": "0578",
                            "area_code": "331126",
                            "longitude": "119.067233",
                            "latitude": "27.618231"
                        },
                        {
                            "area_id": 31933,
                            "city_id": 31080,
                            "province_id": 23,
                            "name": "松阳县",
                            "whole_name": "松阳县，丽水市，浙江省",
                            "simple_py": "SYX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0578",
                            "area_code": "331124",
                            "longitude": "119.485292",
                            "latitude": "28.449937"
                        },
                        {
                            "area_id": 31935,
                            "city_id": 31080,
                            "province_id": 23,
                            "name": "遂昌县",
                            "whole_name": "遂昌县，丽水市，浙江省",
                            "simple_py": "SCX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0578",
                            "area_code": "331123",
                            "longitude": "119.27589",
                            "latitude": "28.5924"
                        },
                        {
                            "area_id": 31936,
                            "city_id": 31080,
                            "province_id": 23,
                            "name": "云和县",
                            "whole_name": "云和县，丽水市，浙江省",
                            "simple_py": "YHX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0578",
                            "area_code": "331125",
                            "longitude": "119.569458",
                            "latitude": "28.111077"
                        }
                    ]
                },
                {
                    "city_id": 31073,
                    "province_id": 23,
                    "name": "宁波市",
                    "whole_name": "宁波市，浙江省",
                    "simple_py": "NBS",
                    "per_pin_yin": "N",
                    "per_pin_yin2": "N",
                    "city_code": "0574",
                    "area_code": "330200",
                    "longitude": "121.549792",
                    "latitude": "29.868388",
                    "children": [
                        {
                            "area_id": 31084,
                            "city_id": 31073,
                            "province_id": 23,
                            "name": "北仑区",
                            "whole_name": "北仑区，宁波市，浙江省",
                            "simple_py": "BLQ",
                            "per_pin_yin": "B",
                            "per_pin_yin2": "B",
                            "city_code": "0574",
                            "area_code": "330206",
                            "longitude": "121.831303",
                            "latitude": "29.90944"
                        },
                        {
                            "area_id": 31093,
                            "city_id": 31073,
                            "province_id": 23,
                            "name": "慈溪市",
                            "whole_name": "慈溪市，宁波市，浙江省",
                            "simple_py": "CXS",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0574",
                            "area_code": "330282",
                            "longitude": "121.248052",
                            "latitude": "30.177142"
                        },
                        {
                            "area_id": 31088,
                            "city_id": 31073,
                            "province_id": 23,
                            "name": "奉化区",
                            "whole_name": "奉化区，宁波市，浙江省",
                            "simple_py": "FHQ",
                            "per_pin_yin": "F",
                            "per_pin_yin2": "F",
                            "city_code": "0574",
                            "area_code": "330213",
                            "longitude": "121.41089",
                            "latitude": "29.662348"
                        },
                        {
                            "area_id": 31092,
                            "city_id": 31073,
                            "province_id": 23,
                            "name": "海曙区",
                            "whole_name": "海曙区，宁波市，浙江省",
                            "simple_py": "HSQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0574",
                            "area_code": "330203",
                            "longitude": "121.539698",
                            "latitude": "29.874452"
                        },
                        {
                            "area_id": 31087,
                            "city_id": 31073,
                            "province_id": 23,
                            "name": "江北区",
                            "whole_name": "江北区，宁波市，浙江省",
                            "simple_py": "JBQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0574",
                            "area_code": "330205",
                            "longitude": "121.559282",
                            "latitude": "29.888361"
                        },
                        {
                            "area_id": 31089,
                            "city_id": 31073,
                            "province_id": 23,
                            "name": "宁海县",
                            "whole_name": "宁海县，宁波市，浙江省",
                            "simple_py": "NHX",
                            "per_pin_yin": "N",
                            "per_pin_yin2": "N",
                            "city_code": "0574",
                            "area_code": "330226",
                            "longitude": "121.432606",
                            "latitude": "29.299836"
                        },
                        {
                            "area_id": 31085,
                            "city_id": 31073,
                            "province_id": 23,
                            "name": "象山县",
                            "whole_name": "象山县，宁波市，浙江省",
                            "simple_py": "XSX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0574",
                            "area_code": "330225",
                            "longitude": "121.877091",
                            "latitude": "29.470206"
                        },
                        {
                            "area_id": 31090,
                            "city_id": 31073,
                            "province_id": 23,
                            "name": "余姚市",
                            "whole_name": "余姚市，宁波市，浙江省",
                            "simple_py": "YYS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0574",
                            "area_code": "330281",
                            "longitude": "121.156294",
                            "latitude": "30.045404"
                        },
                        {
                            "area_id": 31091,
                            "city_id": 31073,
                            "province_id": 23,
                            "name": "鄞州区",
                            "whole_name": "鄞州区，宁波市，浙江省",
                            "simple_py": "YZQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "Y",
                            "city_code": "0574",
                            "area_code": "330212",
                            "longitude": "121.558436",
                            "latitude": "29.831662"
                        },
                        {
                            "area_id": 31086,
                            "city_id": 31073,
                            "province_id": 23,
                            "name": "镇海区",
                            "whole_name": "镇海区，宁波市，浙江省",
                            "simple_py": "ZHQ",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0574",
                            "area_code": "330211",
                            "longitude": "121.713162",
                            "latitude": "29.952107"
                        }
                    ]
                },
                {
                    "city_id": 31078,
                    "province_id": 23,
                    "name": "衢州市",
                    "whole_name": "衢州市，浙江省",
                    "simple_py": "QZS",
                    "per_pin_yin": "Q",
                    "per_pin_yin2": "Q",
                    "city_code": "0570",
                    "area_code": "330800",
                    "longitude": "118.87263",
                    "latitude": "28.941708",
                    "children": [
                        {
                            "area_id": 31668,
                            "city_id": 31078,
                            "province_id": 23,
                            "name": "常山县",
                            "whole_name": "常山县，衢州市，浙江省",
                            "simple_py": "CSX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0570",
                            "area_code": "330822",
                            "longitude": "118.521654",
                            "latitude": "28.900039"
                        },
                        {
                            "area_id": 31671,
                            "city_id": 31078,
                            "province_id": 23,
                            "name": "江山市",
                            "whole_name": "江山市，衢州市，浙江省",
                            "simple_py": "JSS",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0570",
                            "area_code": "330881",
                            "longitude": "118.627879",
                            "latitude": "28.734674"
                        },
                        {
                            "area_id": 31667,
                            "city_id": 31078,
                            "province_id": 23,
                            "name": "柯城区",
                            "whole_name": "柯城区，衢州市，浙江省",
                            "simple_py": "KCQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0570",
                            "area_code": "330802",
                            "longitude": "118.873041",
                            "latitude": "28.944539"
                        },
                        {
                            "area_id": 31669,
                            "city_id": 31078,
                            "province_id": 23,
                            "name": "开化县",
                            "whole_name": "开化县，衢州市，浙江省",
                            "simple_py": "KHX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "K",
                            "city_code": "0570",
                            "area_code": "330824",
                            "longitude": "118.414435",
                            "latitude": "29.136503"
                        },
                        {
                            "area_id": 31670,
                            "city_id": 31078,
                            "province_id": 23,
                            "name": "龙游县",
                            "whole_name": "龙游县，衢州市，浙江省",
                            "simple_py": "LYX",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0570",
                            "area_code": "330825",
                            "longitude": "119.172525",
                            "latitude": "29.031364"
                        },
                        {
                            "area_id": 31666,
                            "city_id": 31078,
                            "province_id": 23,
                            "name": "衢江区",
                            "whole_name": "衢江区，衢州市，浙江省",
                            "simple_py": "QJQ",
                            "per_pin_yin": "Q",
                            "per_pin_yin2": "Q",
                            "city_code": "0570",
                            "area_code": "330803",
                            "longitude": "118.957683",
                            "latitude": "28.973195"
                        }
                    ]
                },
                {
                    "city_id": 31082,
                    "province_id": 23,
                    "name": "绍兴市",
                    "whole_name": "绍兴市，浙江省",
                    "simple_py": "SXS",
                    "per_pin_yin": "S",
                    "per_pin_yin2": "S",
                    "city_code": "0575",
                    "area_code": "330600",
                    "longitude": "120.582112",
                    "latitude": "29.997117",
                    "children": [
                        {
                            "area_id": 32327,
                            "city_id": 31082,
                            "province_id": 23,
                            "name": "柯桥区",
                            "whole_name": "柯桥区，绍兴市，浙江省",
                            "simple_py": "KQQ",
                            "per_pin_yin": "K",
                            "per_pin_yin2": "K",
                            "city_code": "0575",
                            "area_code": "330603",
                            "longitude": "120.476075",
                            "latitude": "30.078038"
                        },
                        {
                            "area_id": 32323,
                            "city_id": 31082,
                            "province_id": 23,
                            "name": "上虞区",
                            "whole_name": "上虞区，绍兴市，浙江省",
                            "simple_py": "SYQ",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0575",
                            "area_code": "330604",
                            "longitude": "120.874185",
                            "latitude": "30.016769"
                        },
                        {
                            "area_id": 32324,
                            "city_id": 31082,
                            "province_id": 23,
                            "name": "嵊州市",
                            "whole_name": "嵊州市，绍兴市，浙江省",
                            "simple_py": "SZS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "S",
                            "city_code": "0575",
                            "area_code": "330683",
                            "longitude": "120.82888",
                            "latitude": "29.586606"
                        },
                        {
                            "area_id": 32325,
                            "city_id": 31082,
                            "province_id": 23,
                            "name": "新昌县",
                            "whole_name": "新昌县，绍兴市，浙江省",
                            "simple_py": "XCX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0575",
                            "area_code": "330624",
                            "longitude": "120.905665",
                            "latitude": "29.501205"
                        },
                        {
                            "area_id": 32326,
                            "city_id": 31082,
                            "province_id": 23,
                            "name": "越城区",
                            "whole_name": "越城区，绍兴市，浙江省",
                            "simple_py": "YCQ",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0575",
                            "area_code": "330602",
                            "longitude": "120.585315",
                            "latitude": "29.996993"
                        },
                        {
                            "area_id": 32328,
                            "city_id": 31082,
                            "province_id": 23,
                            "name": "诸暨市",
                            "whole_name": "诸暨市，绍兴市，浙江省",
                            "simple_py": "ZJS",
                            "per_pin_yin": "Z",
                            "per_pin_yin2": "Z",
                            "city_code": "0575",
                            "area_code": "330681",
                            "longitude": "120.244326",
                            "latitude": "29.713662"
                        }
                    ]
                },
                {
                    "city_id": 31074,
                    "province_id": 23,
                    "name": "台州市",
                    "whole_name": "台州市，浙江省",
                    "simple_py": "TZS",
                    "per_pin_yin": "T",
                    "per_pin_yin2": "T",
                    "city_code": "0576",
                    "area_code": "331000",
                    "longitude": "121.428599",
                    "latitude": "28.661378",
                    "children": [
                        {
                            "area_id": 31257,
                            "city_id": 31074,
                            "province_id": 23,
                            "name": "黄岩区",
                            "whole_name": "黄岩区，台州市，浙江省",
                            "simple_py": "HYQ",
                            "per_pin_yin": "H",
                            "per_pin_yin2": "H",
                            "city_code": "0576",
                            "area_code": "331003",
                            "longitude": "121.262138",
                            "latitude": "28.64488"
                        },
                        {
                            "area_id": 31252,
                            "city_id": 31074,
                            "province_id": 23,
                            "name": "椒江区",
                            "whole_name": "椒江区，台州市，浙江省",
                            "simple_py": "JJQ",
                            "per_pin_yin": "J",
                            "per_pin_yin2": "J",
                            "city_code": "0576",
                            "area_code": "331002",
                            "longitude": "121.431049",
                            "latitude": "28.67615"
                        },
                        {
                            "area_id": 31250,
                            "city_id": 31074,
                            "province_id": 23,
                            "name": "路桥区",
                            "whole_name": "路桥区，台州市，浙江省",
                            "simple_py": "LQQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0576",
                            "area_code": "331004",
                            "longitude": "121.37292",
                            "latitude": "28.581799"
                        },
                        {
                            "area_id": 31251,
                            "city_id": 31074,
                            "province_id": 23,
                            "name": "临海市",
                            "whole_name": "临海市，台州市，浙江省",
                            "simple_py": "LHS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0576",
                            "area_code": "331082",
                            "longitude": "121.131229",
                            "latitude": "28.845441"
                        },
                        {
                            "area_id": 31253,
                            "city_id": 31074,
                            "province_id": 23,
                            "name": "三门县",
                            "whole_name": "三门县，台州市，浙江省",
                            "simple_py": "SMX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0576",
                            "area_code": "331022",
                            "longitude": "121.376429",
                            "latitude": "29.118955"
                        },
                        {
                            "area_id": 31254,
                            "city_id": 31074,
                            "province_id": 23,
                            "name": "天台县",
                            "whole_name": "天台县，台州市，浙江省",
                            "simple_py": "TTX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0576",
                            "area_code": "331023",
                            "longitude": "121.031227",
                            "latitude": "29.141126"
                        },
                        {
                            "area_id": 31255,
                            "city_id": 31074,
                            "province_id": 23,
                            "name": "温岭市",
                            "whole_name": "温岭市，台州市，浙江省",
                            "simple_py": "WLS",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0576",
                            "area_code": "331081",
                            "longitude": "121.373611",
                            "latitude": "28.368781"
                        },
                        {
                            "area_id": 31258,
                            "city_id": 31074,
                            "province_id": 23,
                            "name": "仙居县",
                            "whole_name": "仙居县，台州市，浙江省",
                            "simple_py": "XJX",
                            "per_pin_yin": "X",
                            "per_pin_yin2": "X",
                            "city_code": "0576",
                            "area_code": "331024",
                            "longitude": "120.735074",
                            "latitude": "28.849213"
                        },
                        {
                            "area_id": 31256,
                            "city_id": 31074,
                            "province_id": 23,
                            "name": "玉环市",
                            "whole_name": "玉环市，台州市，浙江省",
                            "simple_py": "YHS",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0576",
                            "area_code": "331083",
                            "longitude": "121.232337",
                            "latitude": "28.12842"
                        }
                    ]
                },
                {
                    "city_id": 31077,
                    "province_id": 23,
                    "name": "温州市",
                    "whole_name": "温州市，浙江省",
                    "simple_py": "WZS",
                    "per_pin_yin": "W",
                    "per_pin_yin2": "W",
                    "city_code": "0577",
                    "area_code": "330300",
                    "longitude": "120.672111",
                    "latitude": "28.000575",
                    "children": [
                        {
                            "area_id": 31514,
                            "city_id": 31077,
                            "province_id": 23,
                            "name": "苍南县",
                            "whole_name": "苍南县，温州市，浙江省",
                            "simple_py": "CNX",
                            "per_pin_yin": "C",
                            "per_pin_yin2": "C",
                            "city_code": "0577",
                            "area_code": "330327",
                            "longitude": "120.406256",
                            "latitude": "27.507743"
                        },
                        {
                            "area_id": 31512,
                            "city_id": 31077,
                            "province_id": 23,
                            "name": "洞头区",
                            "whole_name": "洞头区，温州市，浙江省",
                            "simple_py": "DTQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0577",
                            "area_code": "330305",
                            "longitude": "121.156181",
                            "latitude": "27.836057"
                        },
                        {
                            "area_id": 31515,
                            "city_id": 31077,
                            "province_id": 23,
                            "name": "鹿城区",
                            "whole_name": "鹿城区，温州市，浙江省",
                            "simple_py": "LCQ",
                            "per_pin_yin": "L",
                            "per_pin_yin2": "L",
                            "city_code": "0577",
                            "area_code": "330302",
                            "longitude": "120.674231",
                            "latitude": "28.003352"
                        },
                        {
                            "area_id": 31519,
                            "city_id": 31077,
                            "province_id": 23,
                            "name": "乐清市",
                            "whole_name": "乐清市，温州市，浙江省",
                            "simple_py": "LQS",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0577",
                            "area_code": "330382",
                            "longitude": "120.967147",
                            "latitude": "28.116083"
                        },
                        {
                            "area_id": 31520,
                            "city_id": 31077,
                            "province_id": 23,
                            "name": "龙湾区",
                            "whole_name": "龙湾区，温州市，浙江省",
                            "simple_py": "LWQ",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "L",
                            "city_code": "0577",
                            "area_code": "330303",
                            "longitude": "120.763469",
                            "latitude": "27.970254"
                        },
                        {
                            "area_id": 31521,
                            "city_id": 31077,
                            "province_id": 23,
                            "name": "瓯海区",
                            "whole_name": "瓯海区，温州市，浙江省",
                            "simple_py": "OHQ",
                            "per_pin_yin": "O",
                            "per_pin_yin2": "O",
                            "city_code": "0577",
                            "area_code": "330304",
                            "longitude": "120.637145",
                            "latitude": "28.006444"
                        },
                        {
                            "area_id": 31511,
                            "city_id": 31077,
                            "province_id": 23,
                            "name": "平阳县",
                            "whole_name": "平阳县，温州市，浙江省",
                            "simple_py": "PYX",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0577",
                            "area_code": "330326",
                            "longitude": "120.564387",
                            "latitude": "27.6693"
                        },
                        {
                            "area_id": 31513,
                            "city_id": 31077,
                            "province_id": 23,
                            "name": "瑞安市",
                            "whole_name": "瑞安市，温州市，浙江省",
                            "simple_py": "RAS",
                            "per_pin_yin": "R",
                            "per_pin_yin2": "R",
                            "city_code": "0577",
                            "area_code": "330381",
                            "longitude": "120.646171",
                            "latitude": "27.779321"
                        },
                        {
                            "area_id": 31517,
                            "city_id": 31077,
                            "province_id": 23,
                            "name": "泰顺县",
                            "whole_name": "泰顺县，温州市，浙江省",
                            "simple_py": "TSX",
                            "per_pin_yin": "T",
                            "per_pin_yin2": "T",
                            "city_code": "0577",
                            "area_code": "330329",
                            "longitude": "119.71624",
                            "latitude": "27.557309"
                        },
                        {
                            "area_id": 31518,
                            "city_id": 31077,
                            "province_id": 23,
                            "name": "文成县",
                            "whole_name": "文成县，温州市，浙江省",
                            "simple_py": "WCX",
                            "per_pin_yin": "W",
                            "per_pin_yin2": "W",
                            "city_code": "0577",
                            "area_code": "330328",
                            "longitude": "120.09245",
                            "latitude": "27.789133"
                        },
                        {
                            "area_id": 31516,
                            "city_id": 31077,
                            "province_id": 23,
                            "name": "永嘉县",
                            "whole_name": "永嘉县，温州市，浙江省",
                            "simple_py": "YJX",
                            "per_pin_yin": "Y",
                            "per_pin_yin2": "Y",
                            "city_code": "0577",
                            "area_code": "330324",
                            "longitude": "120.690968",
                            "latitude": "28.153886"
                        }
                    ]
                },
                {
                    "city_id": 31076,
                    "province_id": 23,
                    "name": "舟山市",
                    "whole_name": "舟山市，浙江省",
                    "simple_py": "ZSS",
                    "per_pin_yin": "Z",
                    "per_pin_yin2": "Z",
                    "city_code": "0580",
                    "area_code": "330900",
                    "longitude": "122.106863",
                    "latitude": "30.016028",
                    "children": [
                        {
                            "area_id": 31472,
                            "city_id": 31076,
                            "province_id": 23,
                            "name": "定海区",
                            "whole_name": "定海区，舟山市，浙江省",
                            "simple_py": "DHQ",
                            "per_pin_yin": "D",
                            "per_pin_yin2": "D",
                            "city_code": "0580",
                            "area_code": "330902",
                            "longitude": "122.108496",
                            "latitude": "30.016423"
                        },
                        {
                            "area_id": 31474,
                            "city_id": 31076,
                            "province_id": 23,
                            "name": "岱山县",
                            "whole_name": "岱山县，舟山市，浙江省",
                            "simple_py": "DSX",
                            "per_pin_yin": " ",
                            "per_pin_yin2": "D",
                            "city_code": "0580",
                            "area_code": "330921",
                            "longitude": "122.201132",
                            "latitude": "30.242865"
                        },
                        {
                            "area_id": 31473,
                            "city_id": 31076,
                            "province_id": 23,
                            "name": "普陀区",
                            "whole_name": "普陀区，舟山市，浙江省",
                            "simple_py": "PTQ",
                            "per_pin_yin": "P",
                            "per_pin_yin2": "P",
                            "city_code": "0580",
                            "area_code": "330903",
                            "longitude": "122.301953",
                            "latitude": "29.945614"
                        },
                        {
                            "area_id": 31475,
                            "city_id": 31076,
                            "province_id": 23,
                            "name": "嵊泗县",
                            "whole_name": "嵊泗县，舟山市，浙江省",
                            "simple_py": "SSX",
                            "per_pin_yin": "S",
                            "per_pin_yin2": "S",
                            "city_code": "0580",
                            "area_code": "330922",
                            "longitude": "122.457809",
                            "latitude": "30.727166"
                        }
                    ]
                }
            ]
        }
    ]
}

//导出
export default cityData


// WEBPACK FOOTER //
// ./src/assets/js/city.js